/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/react-clustergrammer/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(17);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(13);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v1.11.0
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2014-01-23T21:02Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper window is present,
		// execute the factory and get jQuery
		// For environments that do not inherently posses a window with a document
		// (such as Node.js), expose a jQuery-making factory as module.exports
		// This accentuates the need for the creation of a real window
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Can't do this because several apps including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
// Support: Firefox 18+
//

var deletedIds = [];

var slice = deletedIds.slice;

var concat = deletedIds.concat;

var push = deletedIds.push;

var indexOf = deletedIds.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var trim = "".trim;

var support = {};



var
	version = "1.11.0",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {
		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Make sure we trim BOM and NBSP (here's looking at you, Safari 5.0 and IE)
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {
	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return a 'clean' array
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return just the object
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	// (You can seed the arguments with an array of args, but this is
	// only used internally.)
	each: function( callback, args ) {
		return jQuery.each( this, callback, args );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map(this, function( elem, i ) {
			return callback.call( elem, i, elem );
		}));
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor(null);
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: deletedIds.sort,
	splice: deletedIds.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var src, copyIsArray, copy, name, options, clone,
		target = arguments[0] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
		target = {};
	}

	// extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {
		// Only deal with non-null/undefined values
		if ( (options = arguments[ i ]) != null ) {
			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray(src) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject(src) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend({
	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	// See test/unit/core.js for details concerning isFunction.
	// Since version 1.3, DOM methods and functions like alert
	// aren't supported. They return false on IE (#2968).
	isFunction: function( obj ) {
		return jQuery.type(obj) === "function";
	},

	isArray: Array.isArray || function( obj ) {
		return jQuery.type(obj) === "array";
	},

	isWindow: function( obj ) {
		/* jshint eqeqeq: false */
		return obj != null && obj == obj.window;
	},

	isNumeric: function( obj ) {
		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		return obj - parseFloat( obj ) >= 0;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	isPlainObject: function( obj ) {
		var key;

		// Must be an Object.
		// Because of IE, we also have to check the presence of the constructor property.
		// Make sure that DOM nodes and window objects don't pass through, as well
		if ( !obj || jQuery.type(obj) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		try {
			// Not own constructor property must be Object
			if ( obj.constructor &&
				!hasOwn.call(obj, "constructor") &&
				!hasOwn.call(obj.constructor.prototype, "isPrototypeOf") ) {
				return false;
			}
		} catch ( e ) {
			// IE8,9 Will throw exceptions on certain host objects #9897
			return false;
		}

		// Support: IE<9
		// Handle iteration over inherited properties before own properties.
		if ( support.ownLast ) {
			for ( key in obj ) {
				return hasOwn.call( obj, key );
			}
		}

		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		for ( key in obj ) {}

		return key === undefined || hasOwn.call( obj, key );
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call(obj) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	// Workarounds based on findings by Jim Driscoll
	// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
	globalEval: function( data ) {
		if ( data && jQuery.trim( data ) ) {
			// We use execScript on Internet Explorer
			// We use an anonymous function so that context is window
			// rather than jQuery in Firefox
			( window.execScript || function( data ) {
				window[ "eval" ].call( window, data );
			} )( data );
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	// args is for internal usage only
	each: function( obj, callback, args ) {
		var value,
			i = 0,
			length = obj.length,
			isArray = isArraylike( obj );

		if ( args ) {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			}

		// A special, fast, case for the most common use of each
		} else {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			}
		}

		return obj;
	},

	// Use native String.trim function wherever possible
	trim: trim && !trim.call("\uFEFF\xA0") ?
		function( text ) {
			return text == null ?
				"" :
				trim.call( text );
		} :

		// Otherwise use our own trimming functionality
		function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArraylike( Object(arr) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		var len;

		if ( arr ) {
			if ( indexOf ) {
				return indexOf.call( arr, elem, i );
			}

			len = arr.length;
			i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;

			for ( ; i < len; i++ ) {
				// Skip accessing in sparse arrays
				if ( i in arr && arr[ i ] === elem ) {
					return i;
				}
			}
		}

		return -1;
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		while ( j < len ) {
			first[ i++ ] = second[ j++ ];
		}

		// Support: IE<9
		// Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
		if ( len !== len ) {
			while ( second[j] !== undefined ) {
				first[ i++ ] = second[ j++ ];
			}
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var value,
			i = 0,
			length = elems.length,
			isArray = isArraylike( elems ),
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArray ) {
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var args, proxy, tmp;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: function() {
		return +( new Date() );
	},

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
});

// Populate the class2type map
jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
});

function isArraylike( obj ) {
	var length = obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	if ( obj.nodeType === 1 && length ) {
		return true;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v1.10.16
 * http://sizzlejs.com/
 *
 * Copyright 2013 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2014-01-13
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	compile,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + -(new Date()),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	strundefined = typeof undefined,
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf if we can't use a native one
	indexOf = arr.indexOf || function( elem ) {
		var i = 0,
			len = this.length;
		for ( ; i < len; i++ ) {
			if ( this[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",
	// http://www.w3.org/TR/css3-syntax/#characters
	characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Loosely modeled on CSS identifier characters
	// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
	// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = characterEncoding.replace( "w", "w#" ),

	// Acceptable operators http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + characterEncoding + ")" + whitespace +
		"*(?:([*^$|!~]?=)" + whitespace + "*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|(" + identifier + ")|)|)" + whitespace + "*\\]",

	// Prefer arguments quoted,
	//   then not containing pseudos/brackets,
	//   then attribute selectors/non-parenthetical expressions,
	//   then anything else
	// These preferences are here to reduce the number of selectors
	//   needing tokenize in the PSEUDO preFilter
	pseudos = ":(" + characterEncoding + ")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|" + attributes.replace( 3, 8 ) + ")*)|.*)\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + characterEncoding + ")" ),
		"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
		"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var match, elem, m, nodeType,
		// QSA vars
		i, groups, old, nid, newContext, newSelector;

	if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
		setDocument( context );
	}

	context = context || document;
	results = results || [];

	if ( !selector || typeof selector !== "string" ) {
		return results;
	}

	if ( (nodeType = context.nodeType) !== 1 && nodeType !== 9 ) {
		return [];
	}

	if ( documentIsHTML && !seed ) {

		// Shortcuts
		if ( (match = rquickExpr.exec( selector )) ) {
			// Speed-up: Sizzle("#ID")
			if ( (m = match[1]) ) {
				if ( nodeType === 9 ) {
					elem = context.getElementById( m );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document (jQuery #6963)
					if ( elem && elem.parentNode ) {
						// Handle the case where IE, Opera, and Webkit return items
						// by name instead of ID
						if ( elem.id === m ) {
							results.push( elem );
							return results;
						}
					} else {
						return results;
					}
				} else {
					// Context is not a document
					if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
						contains( context, elem ) && elem.id === m ) {
						results.push( elem );
						return results;
					}
				}

			// Speed-up: Sizzle("TAG")
			} else if ( match[2] ) {
				push.apply( results, context.getElementsByTagName( selector ) );
				return results;

			// Speed-up: Sizzle(".CLASS")
			} else if ( (m = match[3]) && support.getElementsByClassName && context.getElementsByClassName ) {
				push.apply( results, context.getElementsByClassName( m ) );
				return results;
			}
		}

		// QSA path
		if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
			nid = old = expando;
			newContext = context;
			newSelector = nodeType === 9 && selector;

			// qSA works strangely on Element-rooted queries
			// We can work around this by specifying an extra ID on the root
			// and working up from there (Thanks to Andrew Dupont for the technique)
			// IE 8 doesn't work on object elements
			if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
				groups = tokenize( selector );

				if ( (old = context.getAttribute("id")) ) {
					nid = old.replace( rescape, "\\$&" );
				} else {
					context.setAttribute( "id", nid );
				}
				nid = "[id='" + nid + "'] ";

				i = groups.length;
				while ( i-- ) {
					groups[i] = nid + toSelector( groups[i] );
				}
				newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
				newSelector = groups.join(",");
			}

			if ( newSelector ) {
				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch(qsaError) {
				} finally {
					if ( !old ) {
						context.removeAttribute("id");
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = attrs.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== strundefined && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare,
		doc = node ? node.ownerDocument || node : preferredDoc,
		parent = doc.defaultView;

	// If no document and documentElement is available, return
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Set our document
	document = doc;
	docElem = doc.documentElement;

	// Support tests
	documentIsHTML = !isXML( doc );

	// Support: IE>8
	// If iframe document is assigned to "document" variable and if iframe has been reloaded,
	// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
	// IE6-8 do not support the defaultView property so parent will be undefined
	if ( parent && parent !== parent.top ) {
		// IE11 does not have attachEvent, so all must suffer
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", function() {
				setDocument();
			}, false );
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", function() {
				setDocument();
			});
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( doc.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Check if getElementsByClassName can be trusted
	support.getElementsByClassName = rnative.test( doc.getElementsByClassName ) && assert(function( div ) {
		div.innerHTML = "<div class='a'></div><div class='a i'></div>";

		// Support: Safari<4
		// Catch class over-caching
		div.firstChild.className = "i";
		// Support: Opera<10
		// Catch gEBCN failure to find non-leading classes
		return div.getElementsByClassName("i").length === 2;
	});

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== strundefined && documentIsHTML ) {
				var m = context.getElementById( id );
				// Check parentNode to catch when Blackberry 4.6 returns
				// nodes that are no longer in the document #6963
				return m && m.parentNode ? [m] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== strundefined && elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== strundefined ) {
				return context.getElementsByTagName( tag );
			}
		} :
		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== strundefined && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			div.innerHTML = "<select t=''><option selected=''></option></select>";

			// Support: IE8, Opera 10-12
			// Nothing should be selected when empty strings follow ^= or $= or *=
			if ( div.querySelectorAll("[t^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = doc.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully does not implement inclusive descendent
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === doc ? -1 :
				b === doc ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return doc;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch(e) {}
	}

	return Sizzle( expr, document, null, [elem] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[5] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] && match[4] !== undefined ) {
				match[2] = match[4];

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, outerCache, node, diff, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {
							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || (parent[ expando ] = {});
							cache = outerCache[ type ] || [];
							nodeIndex = cache[0] === dirruns && cache[1];
							diff = cache[0] === dirruns && cache[2];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						// Use previously-cached element index if available
						} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
							diff = cache[1];

						// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
						} else {
							// Use the same loop as above to seek `elem` from the start
							while ( (node = ++nodeIndex && node && node[ dir ] ||
								(diff = nodeIndex = 0) || start.pop()) ) {

								if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
									// Cache the index of each encountered element
									if ( useCache ) {
										(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
									}

									if ( node === elem ) {
										break;
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});
						if ( (oldCache = outerCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							outerCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf.call( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			return ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context !== document && context;
			}

			// Add elements passing elementMatchers directly to results
			// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// Apply set filters to unmatched elements
			matchedCount += i;
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, group /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !group ) {
			group = tokenize( selector );
		}
		i = group.length;
		while ( i-- ) {
			cached = matcherFromTokens( group[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	}
	return cached;
};

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		match = tokenize( selector );

	if ( !seed ) {
		// Try to minimize operations if there is only one group
		if ( match.length === 1 ) {

			// Take a shortcut and set the context if the root selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {

				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
				}
				selector = selector.slice( tokens.shift().value.length );
			}

			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];

				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {

						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}

						break;
					}
				}
			}
		}
	}

	// Compile and execute a filtering function
	// Provide `match` to avoid retokenization if we modified the selector above
	compile( selector, match )(
		seed,
		context,
		!documentIsHTML,
		results,
		rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome<14
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[":"] = jQuery.expr.pseudos;
jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		});

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		});

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( jQuery.inArray( elem, qualifier ) >= 0 ) !== not;
	});
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		}));
};

jQuery.fn.extend({
	find: function( selector ) {
		var i,
			ret = [],
			self = this,
			len = self.length;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter(function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			}) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow(this, selector || [], false) );
	},
	not: function( selector ) {
		return this.pushStack( winnow(this, selector || [], true) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
});


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// Use the correct document accordingly with window argument (sandbox)
	document = window.document,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector.charAt(0) === "<" && selector.charAt( selector.length - 1 ) === ">" && selector.length >= 3 ) {
				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && (match[1] || !context) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[1] ) {
					context = context instanceof jQuery ? context[0] : context;

					// scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[1],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {
							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[2] );

					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					if ( elem && elem.parentNode ) {
						// Handle the case where IE and Opera return items
						// by name instead of ID
						if ( elem.id !== match[2] ) {
							return rootjQuery.find( selector );
						}

						// Otherwise, we inject the element directly into the jQuery object
						this.length = 1;
						this[0] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || rootjQuery ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[0] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return typeof rootjQuery.ready !== "undefined" ?
				rootjQuery.ready( selector ) :
				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	// methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.extend({
	dir: function( elem, dir, until ) {
		var matched = [],
			cur = elem[ dir ];

		while ( cur && cur.nodeType !== 9 && (until === undefined || cur.nodeType !== 1 || !jQuery( cur ).is( until )) ) {
			if ( cur.nodeType === 1 ) {
				matched.push( cur );
			}
			cur = cur[dir];
		}
		return matched;
	},

	sibling: function( n, elem ) {
		var r = [];

		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				r.push( n );
			}
		}

		return r;
	}
});

jQuery.fn.extend({
	has: function( target ) {
		var i,
			targets = jQuery( target, this ),
			len = targets.length;

		return this.filter(function() {
			for ( i = 0; i < len; i++ ) {
				if ( jQuery.contains( this, targets[i] ) ) {
					return true;
				}
			}
		});
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
				// Always skip document fragments
				if ( cur.nodeType < 11 && (pos ?
					pos.index(cur) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector(cur, selectors)) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
	},

	// Determine the position of an element within
	// the matched set of elements
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[0] && this[0].parentNode ) ? this.first().prevAll().length : -1;
		}

		// index in selector
		if ( typeof elem === "string" ) {
			return jQuery.inArray( this[0], jQuery( elem ) );
		}

		// Locate the position of the desired element
		return jQuery.inArray(
			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[0] : elem, this );
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.unique(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter(selector)
		);
	}
});

function sibling( cur, dir ) {
	do {
		cur = cur[ dir ];
	} while ( cur && cur.nodeType !== 1 );

	return cur;
}

jQuery.each({
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return jQuery.dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return jQuery.dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return jQuery.dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return jQuery.sibling( elem.firstChild );
	},
	contents: function( elem ) {
		return jQuery.nodeName( elem, "iframe" ) ?
			elem.contentDocument || elem.contentWindow.document :
			jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var ret = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			ret = jQuery.filter( selector, ret );
		}

		if ( this.length > 1 ) {
			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				ret = jQuery.unique( ret );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				ret = ret.reverse();
			}
		}

		return this.pushStack( ret );
	};
});
var rnotwhite = (/\S+/g);



// String to Object options format cache
var optionsCache = {};

// Convert String-formatted options into Object-formatted ones and store in cache
function createOptions( options ) {
	var object = optionsCache[ options ] = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	});
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		( optionsCache[ options ] || createOptions( options ) ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,
		// Last fire value (for non-forgettable lists)
		memory,
		// Flag to know if list was already fired
		fired,
		// End of the loop when firing
		firingLength,
		// Index of currently firing callback (modified by remove if needed)
		firingIndex,
		// First callback to fire (used internally by add and fireWith)
		firingStart,
		// Actual callback list
		list = [],
		// Stack of fire calls for repeatable lists
		stack = !options.once && [],
		// Fire callbacks
		fire = function( data ) {
			memory = options.memory && data;
			fired = true;
			firingIndex = firingStart || 0;
			firingStart = 0;
			firingLength = list.length;
			firing = true;
			for ( ; list && firingIndex < firingLength; firingIndex++ ) {
				if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
					memory = false; // To prevent further calls using add
					break;
				}
			}
			firing = false;
			if ( list ) {
				if ( stack ) {
					if ( stack.length ) {
						fire( stack.shift() );
					}
				} else if ( memory ) {
					list = [];
				} else {
					self.disable();
				}
			}
		},
		// Actual Callbacks object
		self = {
			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {
					// First, we save the current length
					var start = list.length;
					(function add( args ) {
						jQuery.each( args, function( _, arg ) {
							var type = jQuery.type( arg );
							if ( type === "function" ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && type !== "string" ) {
								// Inspect recursively
								add( arg );
							}
						});
					})( arguments );
					// Do we need to add the callbacks to the
					// current firing batch?
					if ( firing ) {
						firingLength = list.length;
					// With memory, if we're not firing then
					// we should call right away
					} else if ( memory ) {
						firingStart = start;
						fire( memory );
					}
				}
				return this;
			},
			// Remove a callback from the list
			remove: function() {
				if ( list ) {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
							// Handle firing indexes
							if ( firing ) {
								if ( index <= firingLength ) {
									firingLength--;
								}
								if ( index <= firingIndex ) {
									firingIndex--;
								}
							}
						}
					});
				}
				return this;
			},
			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
			},
			// Remove all callbacks from the list
			empty: function() {
				list = [];
				firingLength = 0;
				return this;
			},
			// Have the list do nothing anymore
			disable: function() {
				list = stack = memory = undefined;
				return this;
			},
			// Is it disabled?
			disabled: function() {
				return !list;
			},
			// Lock the list in its current state
			lock: function() {
				stack = undefined;
				if ( !memory ) {
					self.disable();
				}
				return this;
			},
			// Is it locked?
			locked: function() {
				return !stack;
			},
			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( list && ( !fired || stack ) ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					if ( firing ) {
						stack.push( args );
					} else {
						fire( args );
					}
				}
				return this;
			},
			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},
			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend({

	Deferred: function( func ) {
		var tuples = [
				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks("memory") ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred(function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[1] ](function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.done( newDefer.resolve )
										.fail( newDefer.reject )
										.progress( newDefer.notify );
								} else {
									newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
								}
							});
						});
						fns = null;
					}).promise();
				},
				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[1] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(function() {
					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[0] ] = function() {
				deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[0] + "With" ] = list.fireWith;
		});

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );

					} else if ( !(--remaining) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject )
						.progress( updateFunc( i, progressContexts, progressValues ) );
				} else {
					--remaining;
				}
			}
		}

		// if we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
});


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {
	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend({
	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Make sure body exists, at least, in case IE gets a little overzealous (ticket #5443).
		if ( !document.body ) {
			return setTimeout( jQuery.ready );
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.trigger ) {
			jQuery( document ).trigger("ready").off("ready");
		}
	}
});

/**
 * Clean-up method for dom ready events
 */
function detach() {
	if ( document.addEventListener ) {
		document.removeEventListener( "DOMContentLoaded", completed, false );
		window.removeEventListener( "load", completed, false );

	} else {
		document.detachEvent( "onreadystatechange", completed );
		window.detachEvent( "onload", completed );
	}
}

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	// readyState === "complete" is good enough for us to call the dom ready in oldIE
	if ( document.addEventListener || event.type === "load" || document.readyState === "complete" ) {
		detach();
		jQuery.ready();
	}
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called after the browser event has already occurred.
		// we once tried to use readyState "interactive" here, but it caused issues like the one
		// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
		if ( document.readyState === "complete" ) {
			// Handle it asynchronously to allow scripts the opportunity to delay ready
			setTimeout( jQuery.ready );

		// Standards-based browsers support DOMContentLoaded
		} else if ( document.addEventListener ) {
			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed, false );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed, false );

		// If IE event model is used
		} else {
			// Ensure firing before onload, maybe late but safe also for iframes
			document.attachEvent( "onreadystatechange", completed );

			// A fallback to window.onload, that will always work
			window.attachEvent( "onload", completed );

			// If IE and not a frame
			// continually check to see if the document is ready
			var top = false;

			try {
				top = window.frameElement == null && document.documentElement;
			} catch(e) {}

			if ( top && top.doScroll ) {
				(function doScrollCheck() {
					if ( !jQuery.isReady ) {

						try {
							// Use the trick by Diego Perini
							// http://javascript.nwbox.com/IEContentLoaded/
							top.doScroll("left");
						} catch(e) {
							return setTimeout( doScrollCheck, 50 );
						}

						// detach all dom ready events
						detach();

						// and execute any waiting functions
						jQuery.ready();
					}
				})();
			}
		}
	}
	return readyList.promise( obj );
};


var strundefined = typeof undefined;



// Support: IE<9
// Iteration over object's inherited properties before its own
var i;
for ( i in jQuery( support ) ) {
	break;
}
support.ownLast = i !== "0";

// Note: most support tests are defined in their respective modules.
// false until the test is run
support.inlineBlockNeedsLayout = false;

jQuery(function() {
	// We need to execute this one support test ASAP because we need to know
	// if body.style.zoom needs to be set.

	var container, div,
		body = document.getElementsByTagName("body")[0];

	if ( !body ) {
		// Return for frameset docs that don't have a body
		return;
	}

	// Setup
	container = document.createElement( "div" );
	container.style.cssText = "border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px";

	div = document.createElement( "div" );
	body.appendChild( container ).appendChild( div );

	if ( typeof div.style.zoom !== strundefined ) {
		// Support: IE<8
		// Check if natively block-level elements act like inline-block
		// elements when setting their display to 'inline' and giving
		// them layout
		div.style.cssText = "border:0;margin:0;width:1px;padding:1px;display:inline;zoom:1";

		if ( (support.inlineBlockNeedsLayout = ( div.offsetWidth === 3 )) ) {
			// Prevent IE 6 from affecting layout for positioned elements #11048
			// Prevent IE from shrinking the body in IE 7 mode #12869
			// Support: IE<8
			body.style.zoom = 1;
		}
	}

	body.removeChild( container );

	// Null elements to avoid leaks in IE
	container = div = null;
});




(function() {
	var div = document.createElement( "div" );

	// Execute the test only if not already executed in another module.
	if (support.deleteExpando == null) {
		// Support: IE<9
		support.deleteExpando = true;
		try {
			delete div.test;
		} catch( e ) {
			support.deleteExpando = false;
		}
	}

	// Null elements to avoid leaks in IE.
	div = null;
})();


/**
 * Determines whether an object can have data
 */
jQuery.acceptData = function( elem ) {
	var noData = jQuery.noData[ (elem.nodeName + " ").toLowerCase() ],
		nodeType = +elem.nodeType || 1;

	// Do not set data on non-element DOM nodes because it will not be cleared (#8335).
	return nodeType !== 1 && nodeType !== 9 ?
		false :

		// Nodes accept data unless otherwise specified; rejection can be conditional
		!noData || noData !== true && elem.getAttribute("classid") === noData;
};


var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /([A-Z])/g;

function dataAttr( elem, key, data ) {
	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {

		var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();

		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :
					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch( e ) {}

			// Make sure we set the data so it isn't changed later
			jQuery.data( elem, key, data );

		} else {
			data = undefined;
		}
	}

	return data;
}

// checks a cache object for emptiness
function isEmptyDataObject( obj ) {
	var name;
	for ( name in obj ) {

		// if the public data object is empty, the private is still empty
		if ( name === "data" && jQuery.isEmptyObject( obj[name] ) ) {
			continue;
		}
		if ( name !== "toJSON" ) {
			return false;
		}
	}

	return true;
}

function internalData( elem, name, data, pvt /* Internal Use Only */ ) {
	if ( !jQuery.acceptData( elem ) ) {
		return;
	}

	var ret, thisCache,
		internalKey = jQuery.expando,

		// We have to handle DOM nodes and JS objects differently because IE6-7
		// can't GC object references properly across the DOM-JS boundary
		isNode = elem.nodeType,

		// Only DOM nodes need the global jQuery cache; JS object data is
		// attached directly to the object so GC can occur automatically
		cache = isNode ? jQuery.cache : elem,

		// Only defining an ID for JS objects if its cache already exists allows
		// the code to shortcut on the same path as a DOM node with no cache
		id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey;

	// Avoid doing any more work than we need to when trying to get data on an
	// object that has no data at all
	if ( (!id || !cache[id] || (!pvt && !cache[id].data)) && data === undefined && typeof name === "string" ) {
		return;
	}

	if ( !id ) {
		// Only DOM nodes need a new unique ID for each element since their data
		// ends up in the global cache
		if ( isNode ) {
			id = elem[ internalKey ] = deletedIds.pop() || jQuery.guid++;
		} else {
			id = internalKey;
		}
	}

	if ( !cache[ id ] ) {
		// Avoid exposing jQuery metadata on plain JS objects when the object
		// is serialized using JSON.stringify
		cache[ id ] = isNode ? {} : { toJSON: jQuery.noop };
	}

	// An object can be passed to jQuery.data instead of a key/value pair; this gets
	// shallow copied over onto the existing cache
	if ( typeof name === "object" || typeof name === "function" ) {
		if ( pvt ) {
			cache[ id ] = jQuery.extend( cache[ id ], name );
		} else {
			cache[ id ].data = jQuery.extend( cache[ id ].data, name );
		}
	}

	thisCache = cache[ id ];

	// jQuery data() is stored in a separate object inside the object's internal data
	// cache in order to avoid key collisions between internal data and user-defined
	// data.
	if ( !pvt ) {
		if ( !thisCache.data ) {
			thisCache.data = {};
		}

		thisCache = thisCache.data;
	}

	if ( data !== undefined ) {
		thisCache[ jQuery.camelCase( name ) ] = data;
	}

	// Check for both converted-to-camel and non-converted data property names
	// If a data property was specified
	if ( typeof name === "string" ) {

		// First Try to find as-is property data
		ret = thisCache[ name ];

		// Test for null|undefined property data
		if ( ret == null ) {

			// Try to find the camelCased property
			ret = thisCache[ jQuery.camelCase( name ) ];
		}
	} else {
		ret = thisCache;
	}

	return ret;
}

function internalRemoveData( elem, name, pvt ) {
	if ( !jQuery.acceptData( elem ) ) {
		return;
	}

	var thisCache, i,
		isNode = elem.nodeType,

		// See jQuery.data for more information
		cache = isNode ? jQuery.cache : elem,
		id = isNode ? elem[ jQuery.expando ] : jQuery.expando;

	// If there is already no cache entry for this object, there is no
	// purpose in continuing
	if ( !cache[ id ] ) {
		return;
	}

	if ( name ) {

		thisCache = pvt ? cache[ id ] : cache[ id ].data;

		if ( thisCache ) {

			// Support array or space separated string names for data keys
			if ( !jQuery.isArray( name ) ) {

				// try the string as a key before any manipulation
				if ( name in thisCache ) {
					name = [ name ];
				} else {

					// split the camel cased version by spaces unless a key with the spaces exists
					name = jQuery.camelCase( name );
					if ( name in thisCache ) {
						name = [ name ];
					} else {
						name = name.split(" ");
					}
				}
			} else {
				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = name.concat( jQuery.map( name, jQuery.camelCase ) );
			}

			i = name.length;
			while ( i-- ) {
				delete thisCache[ name[i] ];
			}

			// If there is no data left in the cache, we want to continue
			// and let the cache object itself get destroyed
			if ( pvt ? !isEmptyDataObject(thisCache) : !jQuery.isEmptyObject(thisCache) ) {
				return;
			}
		}
	}

	// See jQuery.data for more information
	if ( !pvt ) {
		delete cache[ id ].data;

		// Don't destroy the parent cache unless the internal data object
		// had been the only thing left in it
		if ( !isEmptyDataObject( cache[ id ] ) ) {
			return;
		}
	}

	// Destroy the cache
	if ( isNode ) {
		jQuery.cleanData( [ elem ], true );

	// Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
	/* jshint eqeqeq: false */
	} else if ( support.deleteExpando || cache != cache.window ) {
		/* jshint eqeqeq: true */
		delete cache[ id ];

	// When all else fails, null
	} else {
		cache[ id ] = null;
	}
}

jQuery.extend({
	cache: {},

	// The following elements (space-suffixed to avoid Object.prototype collisions)
	// throw uncatchable exceptions if you attempt to set expando properties
	noData: {
		"applet ": true,
		"embed ": true,
		// ...but Flash objects (which have this classid) *can* handle expandos
		"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
	},

	hasData: function( elem ) {
		elem = elem.nodeType ? jQuery.cache[ elem[jQuery.expando] ] : elem[ jQuery.expando ];
		return !!elem && !isEmptyDataObject( elem );
	},

	data: function( elem, name, data ) {
		return internalData( elem, name, data );
	},

	removeData: function( elem, name ) {
		return internalRemoveData( elem, name );
	},

	// For internal use only.
	_data: function( elem, name, data ) {
		return internalData( elem, name, data, true );
	},

	_removeData: function( elem, name ) {
		return internalRemoveData( elem, name, true );
	}
});

jQuery.fn.extend({
	data: function( key, value ) {
		var i, name, data,
			elem = this[0],
			attrs = elem && elem.attributes;

		// Special expections of .data basically thwart jQuery.access,
		// so implement the relevant behavior ourselves

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = jQuery.data( elem );

				if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {
						name = attrs[i].name;

						if ( name.indexOf("data-") === 0 ) {
							name = jQuery.camelCase( name.slice(5) );

							dataAttr( elem, name, data[ name ] );
						}
					}
					jQuery._data( elem, "parsedAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each(function() {
				jQuery.data( this, key );
			});
		}

		return arguments.length > 1 ?

			// Sets one value
			this.each(function() {
				jQuery.data( this, key, value );
			}) :

			// Gets one value
			// Try to fetch any internally stored data first
			elem ? dataAttr( elem, key, jQuery.data( elem, key ) ) : undefined;
	},

	removeData: function( key ) {
		return this.each(function() {
			jQuery.removeData( this, key );
		});
	}
});


jQuery.extend({
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = jQuery._data( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray(data) ) {
					queue = jQuery._data( elem, type, jQuery.makeArray(data) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// not intended for public consumption - generates a queueHooks object, or returns the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return jQuery._data( elem, key ) || jQuery._data( elem, key, {
			empty: jQuery.Callbacks("once memory").add(function() {
				jQuery._removeData( elem, type + "queue" );
				jQuery._removeData( elem, key );
			})
		});
	}
});

jQuery.fn.extend({
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[0], type );
		}

		return data === undefined ?
			this :
			this.each(function() {
				var queue = jQuery.queue( this, type, data );

				// ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[0] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			});
	},
	dequeue: function( type ) {
		return this.each(function() {
			jQuery.dequeue( this, type );
		});
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},
	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = jQuery._data( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
});
var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;

var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {
		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
	};



// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		length = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {
			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < length; i++ ) {
				fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			length ? fn( elems[0], key ) : emptyGet;
};
var rcheckableType = (/^(?:checkbox|radio)$/i);



(function() {
	var fragment = document.createDocumentFragment(),
		div = document.createElement("div"),
		input = document.createElement("input");

	// Setup
	div.setAttribute( "className", "t" );
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a>";

	// IE strips leading whitespace when .innerHTML is used
	support.leadingWhitespace = div.firstChild.nodeType === 3;

	// Make sure that tbody elements aren't automatically inserted
	// IE will insert them into empty tables
	support.tbody = !div.getElementsByTagName( "tbody" ).length;

	// Make sure that link elements get serialized correctly by innerHTML
	// This requires a wrapper element in IE
	support.htmlSerialize = !!div.getElementsByTagName( "link" ).length;

	// Makes sure cloning an html5 element does not cause problems
	// Where outerHTML is undefined, this still works
	support.html5Clone =
		document.createElement( "nav" ).cloneNode( true ).outerHTML !== "<:nav></:nav>";

	// Check if a disconnected checkbox will retain its checked
	// value of true after appended to the DOM (IE6/7)
	input.type = "checkbox";
	input.checked = true;
	fragment.appendChild( input );
	support.appendChecked = input.checked;

	// Make sure textarea (and checkbox) defaultValue is properly cloned
	// Support: IE6-IE11+
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// #11217 - WebKit loses check when the name is after the checked attribute
	fragment.appendChild( div );
	div.innerHTML = "<input type='radio' checked='checked' name='t'/>";

	// Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
	// old WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<9
	// Opera does not clone events (and typeof div.attachEvent === undefined).
	// IE9-10 clones events bound via attachEvent, but they don't trigger with .click()
	support.noCloneEvent = true;
	if ( div.attachEvent ) {
		div.attachEvent( "onclick", function() {
			support.noCloneEvent = false;
		});

		div.cloneNode( true ).click();
	}

	// Execute the test only if not already executed in another module.
	if (support.deleteExpando == null) {
		// Support: IE<9
		support.deleteExpando = true;
		try {
			delete div.test;
		} catch( e ) {
			support.deleteExpando = false;
		}
	}

	// Null elements to avoid leaks in IE.
	fragment = div = input = null;
})();


(function() {
	var i, eventName,
		div = document.createElement( "div" );

	// Support: IE<9 (lack submit/change bubble), Firefox 23+ (lack focusin event)
	for ( i in { submit: true, change: true, focusin: true }) {
		eventName = "on" + i;

		if ( !(support[ i + "Bubbles" ] = eventName in window) ) {
			// Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
			div.setAttribute( eventName, "t" );
			support[ i + "Bubbles" ] = div.attributes[ eventName ].expando === false;
		}
	}

	// Null elements to avoid leaks in IE.
	div = null;
})();


var rformElems = /^(?:input|select|textarea)$/i,
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|contextmenu)|click/,
	rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {
		var tmp, events, t, handleObjIn,
			special, eventHandle, handleObj,
			handlers, type, namespaces, origType,
			elemData = jQuery._data( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !(events = elemData.events) ) {
			events = elemData.events = {};
		}
		if ( !(eventHandle = elemData.handle) ) {
			eventHandle = elemData.handle = function( e ) {
				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== strundefined && (!e || jQuery.event.triggered !== e.type) ?
					jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
					undefined;
			};
			// Add elem as a property of the handle fn to prevent a memory leak with IE non-native events
			eventHandle.elem = elem;
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend({
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join(".")
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !(handlers = events[ type ]) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener/attachEvent if the special events handler returns false
				if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
					// Bind the global event handler to the element
					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle, false );

					} else if ( elem.attachEvent ) {
						elem.attachEvent( "on" + type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

		// Nullify elem to prevent memory leaks in IE
		elem = null;
	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {
		var j, handleObj, tmp,
			origCount, t, events,
			special, handlers, type,
			namespaces, origType,
			elemData = jQuery.hasData( elem ) && jQuery._data( elem );

		if ( !elemData || !(events = elemData.events) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			delete elemData.handle;

			// removeData also checks for emptiness and clears the expando if empty
			// so use it instead of delete
			jQuery._removeData( elem, "events" );
		}
	},

	trigger: function( event, data, elem, onlyHandlers ) {
		var handle, ontype, cur,
			bubbleType, special, tmp, i,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf(".") >= 0 ) {
			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split(".");
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf(":") < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join(".");
		event.namespace_re = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === (elem.ownerDocument || document) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] && jQuery._data( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
				jQuery.acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Can't use an .isFunction() check here because IE6/7 fails that test.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && elem[ type ] && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					try {
						elem[ type ]();
					} catch ( e ) {
						// IE<9 dies on focus/blur to hidden element (#1486,#12518)
						// only reproducible on winXP IE8 native, not IE9 in IE8 mode
					}
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, ret, handleObj, matched, j,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( jQuery._data( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[0] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or
				// 2) have namespace(s) a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
							.apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( (event.result = ret) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var sel, handleObj, matches, i,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		// Avoid non-left-click bubbling in Firefox (#3861)
		if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {

			/* jshint eqeqeq: false */
			for ( ; cur != this; cur = cur.parentNode || this ) {
				/* jshint eqeqeq: true */

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && (cur.disabled !== true || event.type !== "click") ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) >= 0 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push({ elem: cur, handlers: matches });
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
		}

		return handlerQueue;
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: IE<9
		// Fix target property (#1925)
		if ( !event.target ) {
			event.target = originalEvent.srcElement || document;
		}

		// Support: Chrome 23+, Safari?
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		// Support: IE<9
		// For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
		event.metaKey = !!event.metaKey;

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split(" "),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
		filter: function( event, original ) {
			var body, eventDoc, doc,
				button = original.button,
				fromElement = original.fromElement;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add relatedTarget, if necessary
			if ( !event.relatedTarget && fromElement ) {
				event.relatedTarget = fromElement === event.target ? original.toElement : fromElement;
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	special: {
		load: {
			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {
			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					try {
						this.focus();
						return false;
					} catch ( e ) {
						// Support: IE<9
						// If we error on focus to hidden element (#1486, #12518),
						// let .trigger() run the handlers
					}
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {
			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( jQuery.nodeName( this, "input" ) && this.type === "checkbox" && this.click ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Even when returnValue equals to undefined Firefox will still show alert
				if ( event.result !== undefined ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	},

	simulate: function( type, elem, event, bubble ) {
		// Piggyback on a donor event to simulate a different one.
		// Fake originalEvent to avoid donor's stopPropagation, but if the
		// simulated event prevents default then we do the same on the donor.
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true,
				originalEvent: {}
			}
		);
		if ( bubble ) {
			jQuery.event.trigger( e, null, elem );
		} else {
			jQuery.event.dispatch.call( elem, e );
		}
		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}
};

jQuery.removeEvent = document.removeEventListener ?
	function( elem, type, handle ) {
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle, false );
		}
	} :
	function( elem, type, handle ) {
		var name = "on" + type;

		if ( elem.detachEvent ) {

			// #8545, #7054, preventing memory leaks for custom events in IE6-8
			// detachEvent needed property on element, by name of that event, to properly expose it to GC
			if ( typeof elem[ name ] === strundefined ) {
				elem[ name ] = null;
			}

			elem.detachEvent( name, handle );
		}
	};

jQuery.Event = function( src, props ) {
	// Allow instantiation without the 'new' keyword
	if ( !(this instanceof jQuery.Event) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined && (
				// Support: IE < 9
				src.returnValue === false ||
				// Support: Android < 4.0
				src.getPreventDefault && src.getPreventDefault() ) ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;
		if ( !e ) {
			return;
		}

		// If preventDefault exists, run it on the original event
		if ( e.preventDefault ) {
			e.preventDefault();

		// Support: IE
		// Otherwise set the returnValue property of the original event to false
		} else {
			e.returnValue = false;
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;
		if ( !e ) {
			return;
		}
		// If stopPropagation exists, run it on the original event
		if ( e.stopPropagation ) {
			e.stopPropagation();
		}

		// Support: IE
		// Set the cancelBubble property of the original event to true
		e.cancelBubble = true;
	},
	stopImmediatePropagation: function() {
		this.isImmediatePropagationStopped = returnTrue;
		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
jQuery.each({
	mouseenter: "mouseover",
	mouseleave: "mouseout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mousenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
});

// IE submit delegation
if ( !support.submitBubbles ) {

	jQuery.event.special.submit = {
		setup: function() {
			// Only need this for delegated form submit events
			if ( jQuery.nodeName( this, "form" ) ) {
				return false;
			}

			// Lazy-add a submit handler when a descendant form may potentially be submitted
			jQuery.event.add( this, "click._submit keypress._submit", function( e ) {
				// Node name check avoids a VML-related crash in IE (#9807)
				var elem = e.target,
					form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ? elem.form : undefined;
				if ( form && !jQuery._data( form, "submitBubbles" ) ) {
					jQuery.event.add( form, "submit._submit", function( event ) {
						event._submit_bubble = true;
					});
					jQuery._data( form, "submitBubbles", true );
				}
			});
			// return undefined since we don't need an event listener
		},

		postDispatch: function( event ) {
			// If form was submitted by the user, bubble the event up the tree
			if ( event._submit_bubble ) {
				delete event._submit_bubble;
				if ( this.parentNode && !event.isTrigger ) {
					jQuery.event.simulate( "submit", this.parentNode, event, true );
				}
			}
		},

		teardown: function() {
			// Only need this for delegated form submit events
			if ( jQuery.nodeName( this, "form" ) ) {
				return false;
			}

			// Remove delegated handlers; cleanData eventually reaps submit handlers attached above
			jQuery.event.remove( this, "._submit" );
		}
	};
}

// IE change delegation and checkbox/radio fix
if ( !support.changeBubbles ) {

	jQuery.event.special.change = {

		setup: function() {

			if ( rformElems.test( this.nodeName ) ) {
				// IE doesn't fire change on a check/radio until blur; trigger it on click
				// after a propertychange. Eat the blur-change in special.change.handle.
				// This still fires onchange a second time for check/radio after blur.
				if ( this.type === "checkbox" || this.type === "radio" ) {
					jQuery.event.add( this, "propertychange._change", function( event ) {
						if ( event.originalEvent.propertyName === "checked" ) {
							this._just_changed = true;
						}
					});
					jQuery.event.add( this, "click._change", function( event ) {
						if ( this._just_changed && !event.isTrigger ) {
							this._just_changed = false;
						}
						// Allow triggered, simulated change events (#11500)
						jQuery.event.simulate( "change", this, event, true );
					});
				}
				return false;
			}
			// Delegated event; lazy-add a change handler on descendant inputs
			jQuery.event.add( this, "beforeactivate._change", function( e ) {
				var elem = e.target;

				if ( rformElems.test( elem.nodeName ) && !jQuery._data( elem, "changeBubbles" ) ) {
					jQuery.event.add( elem, "change._change", function( event ) {
						if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
							jQuery.event.simulate( "change", this.parentNode, event, true );
						}
					});
					jQuery._data( elem, "changeBubbles", true );
				}
			});
		},

		handle: function( event ) {
			var elem = event.target;

			// Swallow native change events from checkbox/radio, we already triggered them above
			if ( this !== elem || event.isSimulated || event.isTrigger || (elem.type !== "radio" && elem.type !== "checkbox") ) {
				return event.handleObj.handler.apply( this, arguments );
			}
		},

		teardown: function() {
			jQuery.event.remove( this, "._change" );

			return !rformElems.test( this.nodeName );
		}
	};
}

// Create "bubbling" focus and blur events
if ( !support.focusinBubbles ) {
	jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
			};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = jQuery._data( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				jQuery._data( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = jQuery._data( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					jQuery._removeData( doc, fix );
				} else {
					jQuery._data( doc, fix, attaches );
				}
			}
		};
	});
}

jQuery.fn.extend({

	on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
		var type, origFn;

		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				this.on( type, selector, data, types[ type ], one );
			}
			return this;
		}

		if ( data == null && fn == null ) {
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return this;
		}

		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return this.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		});
	},
	one: function( types, selector, data, fn ) {
		return this.on( types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {
			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {
			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {
			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each(function() {
			jQuery.event.remove( this, types, fn, selector );
		});
	},

	trigger: function( type, data ) {
		return this.each(function() {
			jQuery.event.trigger( type, data, this );
		});
	},
	triggerHandler: function( type, data ) {
		var elem = this[0];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
});


function createSafeFragment( document ) {
	var list = nodeNames.split( "|" ),
		safeFrag = document.createDocumentFragment();

	if ( safeFrag.createElement ) {
		while ( list.length ) {
			safeFrag.createElement(
				list.pop()
			);
		}
	}
	return safeFrag;
}

var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|" +
		"header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
	rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
	rnoshimcache = new RegExp("<(?:" + nodeNames + ")[\\s/>]", "i"),
	rleadingWhitespace = /^\s+/,
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
	rtagName = /<([\w:]+)/,
	rtbody = /<tbody/i,
	rhtml = /<|&#?\w+;/,
	rnoInnerhtml = /<(?:script|style|link)/i,
	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptType = /^$|\/(?:java|ecma)script/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,

	// We have to close these tags to support XHTML (#13200)
	wrapMap = {
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
		legend: [ 1, "<fieldset>", "</fieldset>" ],
		area: [ 1, "<map>", "</map>" ],
		param: [ 1, "<object>", "</object>" ],
		thead: [ 1, "<table>", "</table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

		// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
		// unless wrapped in a div with non-breaking characters in front of it.
		_default: support.htmlSerialize ? [ 0, "", "" ] : [ 1, "X<div>", "</div>"  ]
	},
	safeFragment = createSafeFragment( document ),
	fragmentDiv = safeFragment.appendChild( document.createElement("div") );

wrapMap.optgroup = wrapMap.option;
wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

function getAll( context, tag ) {
	var elems, elem,
		i = 0,
		found = typeof context.getElementsByTagName !== strundefined ? context.getElementsByTagName( tag || "*" ) :
			typeof context.querySelectorAll !== strundefined ? context.querySelectorAll( tag || "*" ) :
			undefined;

	if ( !found ) {
		for ( found = [], elems = context.childNodes || context; (elem = elems[i]) != null; i++ ) {
			if ( !tag || jQuery.nodeName( elem, tag ) ) {
				found.push( elem );
			} else {
				jQuery.merge( found, getAll( elem, tag ) );
			}
		}
	}

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], found ) :
		found;
}

// Used in buildFragment, fixes the defaultChecked property
function fixDefaultChecked( elem ) {
	if ( rcheckableType.test( elem.type ) ) {
		elem.defaultChecked = elem.checked;
	}
}

// Support: IE<8
// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName("tbody")[0] ||
			elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = (jQuery.find.attr( elem, "type" ) !== null) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );
	if ( match ) {
		elem.type = match[1];
	} else {
		elem.removeAttribute("type");
	}
	return elem;
}

// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var elem,
		i = 0;
	for ( ; (elem = elems[i]) != null; i++ ) {
		jQuery._data( elem, "globalEval", !refElements || jQuery._data( refElements[i], "globalEval" ) );
	}
}

function cloneCopyEvent( src, dest ) {

	if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
		return;
	}

	var type, i, l,
		oldData = jQuery._data( src ),
		curData = jQuery._data( dest, oldData ),
		events = oldData.events;

	if ( events ) {
		delete curData.handle;
		curData.events = {};

		for ( type in events ) {
			for ( i = 0, l = events[ type ].length; i < l; i++ ) {
				jQuery.event.add( dest, type, events[ type ][ i ] );
			}
		}
	}

	// make the cloned public data object a copy from the original
	if ( curData.data ) {
		curData.data = jQuery.extend( {}, curData.data );
	}
}

function fixCloneNodeIssues( src, dest ) {
	var nodeName, e, data;

	// We do not need to do anything for non-Elements
	if ( dest.nodeType !== 1 ) {
		return;
	}

	nodeName = dest.nodeName.toLowerCase();

	// IE6-8 copies events bound via attachEvent when using cloneNode.
	if ( !support.noCloneEvent && dest[ jQuery.expando ] ) {
		data = jQuery._data( dest );

		for ( e in data.events ) {
			jQuery.removeEvent( dest, e, data.handle );
		}

		// Event data gets referenced instead of copied if the expando gets copied too
		dest.removeAttribute( jQuery.expando );
	}

	// IE blanks contents when cloning scripts, and tries to evaluate newly-set text
	if ( nodeName === "script" && dest.text !== src.text ) {
		disableScript( dest ).text = src.text;
		restoreScript( dest );

	// IE6-10 improperly clones children of object elements using classid.
	// IE10 throws NoModificationAllowedError if parent is null, #12132.
	} else if ( nodeName === "object" ) {
		if ( dest.parentNode ) {
			dest.outerHTML = src.outerHTML;
		}

		// This path appears unavoidable for IE9. When cloning an object
		// element in IE9, the outerHTML strategy above is not sufficient.
		// If the src has innerHTML and the destination does not,
		// copy the src.innerHTML into the dest.innerHTML. #10324
		if ( support.html5Clone && ( src.innerHTML && !jQuery.trim(dest.innerHTML) ) ) {
			dest.innerHTML = src.innerHTML;
		}

	} else if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		// IE6-8 fails to persist the checked state of a cloned checkbox
		// or radio button. Worse, IE6-7 fail to give the cloned element
		// a checked appearance if the defaultChecked value isn't also set

		dest.defaultChecked = dest.checked = src.checked;

		// IE6-7 get confused and end up setting the value of a cloned
		// checkbox/radio button to an empty string instead of "on"
		if ( dest.value !== src.value ) {
			dest.value = src.value;
		}

	// IE6-8 fails to return the selected option to the default selected
	// state when cloning options
	} else if ( nodeName === "option" ) {
		dest.defaultSelected = dest.selected = src.defaultSelected;

	// IE6-8 fails to set the defaultValue to the correct value when
	// cloning other types of input fields
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

jQuery.extend({
	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var destElements, node, clone, i, srcElements,
			inPage = jQuery.contains( elem.ownerDocument, elem );

		if ( support.html5Clone || jQuery.isXMLDoc(elem) || !rnoshimcache.test( "<" + elem.nodeName + ">" ) ) {
			clone = elem.cloneNode( true );

		// IE<=8 does not properly clone detached, unknown element nodes
		} else {
			fragmentDiv.innerHTML = elem.outerHTML;
			fragmentDiv.removeChild( clone = fragmentDiv.firstChild );
		}

		if ( (!support.noCloneEvent || !support.noCloneChecked) &&
				(elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			// Fix all IE cloning issues
			for ( i = 0; (node = srcElements[i]) != null; ++i ) {
				// Ensure that the destination node is not null; Fixes #9587
				if ( destElements[i] ) {
					fixCloneNodeIssues( node, destElements[i] );
				}
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0; (node = srcElements[i]) != null; i++ ) {
					cloneCopyEvent( node, destElements[i] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		destElements = srcElements = node = null;

		// Return the cloned set
		return clone;
	},

	buildFragment: function( elems, context, scripts, selection ) {
		var j, elem, contains,
			tmp, tag, tbody, wrap,
			l = elems.length,

			// Ensure a safe fragment
			safe = createSafeFragment( context ),

			nodes = [],
			i = 0;

		for ( ; i < l; i++ ) {
			elem = elems[ i ];

			if ( elem || elem === 0 ) {

				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );

				// Convert html into DOM nodes
				} else {
					tmp = tmp || safe.appendChild( context.createElement("div") );

					// Deserialize a standard representation
					tag = (rtagName.exec( elem ) || [ "", "" ])[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;

					tmp.innerHTML = wrap[1] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[2];

					// Descend through wrappers to the right content
					j = wrap[0];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}

					// Manually add leading whitespace removed by IE
					if ( !support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
						nodes.push( context.createTextNode( rleadingWhitespace.exec( elem )[0] ) );
					}

					// Remove IE's autoinserted <tbody> from table fragments
					if ( !support.tbody ) {

						// String was a <table>, *may* have spurious <tbody>
						elem = tag === "table" && !rtbody.test( elem ) ?
							tmp.firstChild :

							// String was a bare <thead> or <tfoot>
							wrap[1] === "<table>" && !rtbody.test( elem ) ?
								tmp :
								0;

						j = elem && elem.childNodes.length;
						while ( j-- ) {
							if ( jQuery.nodeName( (tbody = elem.childNodes[j]), "tbody" ) && !tbody.childNodes.length ) {
								elem.removeChild( tbody );
							}
						}
					}

					jQuery.merge( nodes, tmp.childNodes );

					// Fix #12392 for WebKit and IE > 9
					tmp.textContent = "";

					// Fix #12392 for oldIE
					while ( tmp.firstChild ) {
						tmp.removeChild( tmp.firstChild );
					}

					// Remember the top-level container for proper cleanup
					tmp = safe.lastChild;
				}
			}
		}

		// Fix #11356: Clear elements from fragment
		if ( tmp ) {
			safe.removeChild( tmp );
		}

		// Reset defaultChecked for any radios and checkboxes
		// about to be appended to the DOM in IE 6/7 (#8060)
		if ( !support.appendChecked ) {
			jQuery.grep( getAll( nodes, "input" ), fixDefaultChecked );
		}

		i = 0;
		while ( (elem = nodes[ i++ ]) ) {

			// #4087 - If origin and destination elements are the same, and this is
			// that element, do not do anything
			if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
				continue;
			}

			contains = jQuery.contains( elem.ownerDocument, elem );

			// Append to fragment
			tmp = getAll( safe.appendChild( elem ), "script" );

			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}

			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( (elem = tmp[ j++ ]) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}

		tmp = null;

		return safe;
	},

	cleanData: function( elems, /* internal */ acceptData ) {
		var elem, type, id, data,
			i = 0,
			internalKey = jQuery.expando,
			cache = jQuery.cache,
			deleteExpando = support.deleteExpando,
			special = jQuery.event.special;

		for ( ; (elem = elems[i]) != null; i++ ) {
			if ( acceptData || jQuery.acceptData( elem ) ) {

				id = elem[ internalKey ];
				data = id && cache[ id ];

				if ( data ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Remove cache only if it was not already removed by jQuery.event.remove
					if ( cache[ id ] ) {

						delete cache[ id ];

						// IE does not allow us to delete expando properties from nodes,
						// nor does it have a removeAttribute function on Document nodes;
						// we must handle all of these cases
						if ( deleteExpando ) {
							delete elem[ internalKey ];

						} else if ( typeof elem.removeAttribute !== strundefined ) {
							elem.removeAttribute( internalKey );

						} else {
							elem[ internalKey ] = null;
						}

						deletedIds.push( id );
					}
				}
			}
		}
	}
});

jQuery.fn.extend({
	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().append( ( this[0] && this[0].ownerDocument || document ).createTextNode( value ) );
		}, null, value, arguments.length );
	},

	append: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		});
	},

	prepend: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		});
	},

	before: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		});
	},

	after: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		});
	},

	remove: function( selector, keepData /* Internal Use Only */ ) {
		var elem,
			elems = selector ? jQuery.filter( selector, this ) : this,
			i = 0;

		for ( ; (elem = elems[i]) != null; i++ ) {

			if ( !keepData && elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem ) );
			}

			if ( elem.parentNode ) {
				if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
					setGlobalEval( getAll( elem, "script" ) );
				}
				elem.parentNode.removeChild( elem );
			}
		}

		return this;
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; (elem = this[i]) != null; i++ ) {
			// Remove element nodes and prevent memory leaks
			if ( elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem, false ) );
			}

			// Remove any remaining nodes
			while ( elem.firstChild ) {
				elem.removeChild( elem.firstChild );
			}

			// If this is a select, ensure that it displays empty (#12336)
			// Support: IE<9
			if ( elem.options && jQuery.nodeName( elem, "select" ) ) {
				elem.options.length = 0;
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map(function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		});
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined ) {
				return elem.nodeType === 1 ?
					elem.innerHTML.replace( rinlinejQuery, "" ) :
					undefined;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				( support.htmlSerialize || !rnoshimcache.test( value )  ) &&
				( support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
				!wrapMap[ (rtagName.exec( value ) || [ "", "" ])[ 1 ].toLowerCase() ] ) {

				value = value.replace( rxhtmlTag, "<$1></$2>" );

				try {
					for (; i < l; i++ ) {
						// Remove element nodes and prevent memory leaks
						elem = this[i] || {};
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch(e) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var arg = arguments[ 0 ];

		// Make the changes, replacing each context element with the new content
		this.domManip( arguments, function( elem ) {
			arg = this.parentNode;

			jQuery.cleanData( getAll( this ) );

			if ( arg ) {
				arg.replaceChild( elem, this );
			}
		});

		// Force removal if there was no new content (e.g., from empty arguments)
		return arg && (arg.length || arg.nodeType) ? this : this.remove();
	},

	detach: function( selector ) {
		return this.remove( selector, true );
	},

	domManip: function( args, callback ) {

		// Flatten any nested arrays
		args = concat.apply( [], args );

		var first, node, hasScripts,
			scripts, doc, fragment,
			i = 0,
			l = this.length,
			set = this,
			iNoClone = l - 1,
			value = args[0],
			isFunction = jQuery.isFunction( value );

		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return this.each(function( index ) {
				var self = set.eq( index );
				if ( isFunction ) {
					args[0] = value.call( this, index, self.html() );
				}
				self.domManip( args, callback );
			});
		}

		if ( l ) {
			fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
			first = fragment.firstChild;

			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}

			if ( first ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;

				// Use the original fragment for the last item instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;

					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );

						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}

					callback.call( this[i], node, i );
				}

				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;

					// Reenable scripts
					jQuery.map( scripts, restoreScript );

					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!jQuery._data( node, "globalEval" ) && jQuery.contains( doc, node ) ) {

							if ( node.src ) {
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( ( node.text || node.textContent || node.innerHTML || "" ).replace( rcleanScript, "" ) );
							}
						}
					}
				}

				// Fix #11809: Avoid leaking memory
				fragment = first = null;
			}
		}

		return this;
	}
});

jQuery.each({
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			i = 0,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone(true);
			jQuery( insert[i] )[ original ]( elems );

			// Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
});


var iframe,
	elemdisplay = {};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */
// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		// getDefaultComputedStyle might be reliably used only on attached element
		display = window.getDefaultComputedStyle ?

			// Use of this method is a temporary fix (more like optmization) until something better comes along,
			// since it was removed from specification and supported only in FF
			window.getDefaultComputedStyle( elem[ 0 ] ).display : jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = ( iframe[ 0 ].contentWindow || iframe[ 0 ].contentDocument ).document;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}


(function() {
	var a, shrinkWrapBlocksVal,
		div = document.createElement( "div" ),
		divReset =
			"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;" +
			"display:block;padding:0;margin:0;border:0";

	// Setup
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	a = div.getElementsByTagName( "a" )[ 0 ];

	a.style.cssText = "float:left;opacity:.5";

	// Make sure that element opacity exists
	// (IE uses filter instead)
	// Use a regex to work around a WebKit issue. See #5145
	support.opacity = /^0.5/.test( a.style.opacity );

	// Verify style float existence
	// (IE uses styleFloat instead of cssFloat)
	support.cssFloat = !!a.style.cssFloat;

	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	// Null elements to avoid leaks in IE.
	a = div = null;

	support.shrinkWrapBlocks = function() {
		var body, container, div, containerStyles;

		if ( shrinkWrapBlocksVal == null ) {
			body = document.getElementsByTagName( "body" )[ 0 ];
			if ( !body ) {
				// Test fired too early or in an unsupported environment, exit.
				return;
			}

			containerStyles = "border:0;width:0;height:0;position:absolute;top:0;left:-9999px";
			container = document.createElement( "div" );
			div = document.createElement( "div" );

			body.appendChild( container ).appendChild( div );

			// Will be changed later if needed.
			shrinkWrapBlocksVal = false;

			if ( typeof div.style.zoom !== strundefined ) {
				// Support: IE6
				// Check if elements with layout shrink-wrap their children
				div.style.cssText = divReset + ";width:1px;padding:1px;zoom:1";
				div.innerHTML = "<div></div>";
				div.firstChild.style.width = "5px";
				shrinkWrapBlocksVal = div.offsetWidth !== 3;
			}

			body.removeChild( container );

			// Null elements to avoid leaks in IE.
			body = container = div = null;
		}

		return shrinkWrapBlocksVal;
	};

})();
var rmargin = (/^margin/);

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );



var getStyles, curCSS,
	rposition = /^(top|right|bottom|left)$/;

if ( window.getComputedStyle ) {
	getStyles = function( elem ) {
		return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
	};

	curCSS = function( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;

		computed = computed || getStyles( elem );

		// getPropertyValue is only needed for .css('filter') in IE9, see #12537
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;

		if ( computed ) {

			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}

			// A tribute to the "awesome hack by Dean Edwards"
			// Chrome < 17 and Safari 5.0 uses "computed value" instead of "used value" for margin-right
			// Safari 5.1.7 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
			// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
			if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {

				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;

				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;

				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}

		// Support: IE
		// IE returns zIndex value as an integer.
		return ret === undefined ?
			ret :
			ret + "";
	};
} else if ( document.documentElement.currentStyle ) {
	getStyles = function( elem ) {
		return elem.currentStyle;
	};

	curCSS = function( elem, name, computed ) {
		var left, rs, rsLeft, ret,
			style = elem.style;

		computed = computed || getStyles( elem );
		ret = computed ? computed[ name ] : undefined;

		// Avoid setting ret to empty string here
		// so we don't default to auto
		if ( ret == null && style && style[ name ] ) {
			ret = style[ name ];
		}

		// From the awesome hack by Dean Edwards
		// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291

		// If we're not dealing with a regular pixel number
		// but a number that has a weird ending, we need to convert it to pixels
		// but not position css attributes, as those are proportional to the parent element instead
		// and we can't measure the parent instead because it might trigger a "stacking dolls" problem
		if ( rnumnonpx.test( ret ) && !rposition.test( name ) ) {

			// Remember the original values
			left = style.left;
			rs = elem.runtimeStyle;
			rsLeft = rs && rs.left;

			// Put in the new values to get a computed value out
			if ( rsLeft ) {
				rs.left = elem.currentStyle.left;
			}
			style.left = name === "fontSize" ? "1em" : ret;
			ret = style.pixelLeft + "px";

			// Revert the changed values
			style.left = left;
			if ( rsLeft ) {
				rs.left = rsLeft;
			}
		}

		// Support: IE
		// IE returns zIndex value as an integer.
		return ret === undefined ?
			ret :
			ret + "" || "auto";
	};
}




function addGetHookIf( conditionFn, hookFn ) {
	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			var condition = conditionFn();

			if ( condition == null ) {
				// The test was not ready at this point; screw the hook this time
				// but check again when needed next time.
				return;
			}

			if ( condition ) {
				// Hook not needed (or it's not possible to use it due to missing dependency),
				// remove it.
				// Since there are no other hooks for marginRight, remove the whole object.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.

			return (this.get = hookFn).apply( this, arguments );
		}
	};
}


(function() {
	var a, reliableHiddenOffsetsVal, boxSizingVal, boxSizingReliableVal,
		pixelPositionVal, reliableMarginRightVal,
		div = document.createElement( "div" ),
		containerStyles = "border:0;width:0;height:0;position:absolute;top:0;left:-9999px",
		divReset =
			"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;" +
			"display:block;padding:0;margin:0;border:0";

	// Setup
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	a = div.getElementsByTagName( "a" )[ 0 ];

	a.style.cssText = "float:left;opacity:.5";

	// Make sure that element opacity exists
	// (IE uses filter instead)
	// Use a regex to work around a WebKit issue. See #5145
	support.opacity = /^0.5/.test( a.style.opacity );

	// Verify style float existence
	// (IE uses styleFloat instead of cssFloat)
	support.cssFloat = !!a.style.cssFloat;

	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	// Null elements to avoid leaks in IE.
	a = div = null;

	jQuery.extend(support, {
		reliableHiddenOffsets: function() {
			if ( reliableHiddenOffsetsVal != null ) {
				return reliableHiddenOffsetsVal;
			}

			var container, tds, isSupported,
				div = document.createElement( "div" ),
				body = document.getElementsByTagName( "body" )[ 0 ];

			if ( !body ) {
				// Return for frameset docs that don't have a body
				return;
			}

			// Setup
			div.setAttribute( "className", "t" );
			div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";

			container = document.createElement( "div" );
			container.style.cssText = containerStyles;

			body.appendChild( container ).appendChild( div );

			// Support: IE8
			// Check if table cells still have offsetWidth/Height when they are set
			// to display:none and there are still other visible table cells in a
			// table row; if so, offsetWidth/Height are not reliable for use when
			// determining if an element has been hidden directly using
			// display:none (it is still safe to use offsets if a parent element is
			// hidden; don safety goggles and see bug #4512 for more information).
			div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
			tds = div.getElementsByTagName( "td" );
			tds[ 0 ].style.cssText = "padding:0;margin:0;border:0;display:none";
			isSupported = ( tds[ 0 ].offsetHeight === 0 );

			tds[ 0 ].style.display = "";
			tds[ 1 ].style.display = "none";

			// Support: IE8
			// Check if empty table cells still have offsetWidth/Height
			reliableHiddenOffsetsVal = isSupported && ( tds[ 0 ].offsetHeight === 0 );

			body.removeChild( container );

			// Null elements to avoid leaks in IE.
			div = body = null;

			return reliableHiddenOffsetsVal;
		},

		boxSizing: function() {
			if ( boxSizingVal == null ) {
				computeStyleTests();
			}
			return boxSizingVal;
		},

		boxSizingReliable: function() {
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return boxSizingReliableVal;
		},

		pixelPosition: function() {
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return pixelPositionVal;
		},

		reliableMarginRight: function() {
			var body, container, div, marginDiv;

			// Use window.getComputedStyle because jsdom on node.js will break without it.
			if ( reliableMarginRightVal == null && window.getComputedStyle ) {
				body = document.getElementsByTagName( "body" )[ 0 ];
				if ( !body ) {
					// Test fired too early or in an unsupported environment, exit.
					return;
				}

				container = document.createElement( "div" );
				div = document.createElement( "div" );
				container.style.cssText = containerStyles;

				body.appendChild( container ).appendChild( div );

				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// Fails in WebKit before Feb 2011 nightlies
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				marginDiv = div.appendChild( document.createElement( "div" ) );
				marginDiv.style.cssText = div.style.cssText = divReset;
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";

				reliableMarginRightVal =
					!parseFloat( ( window.getComputedStyle( marginDiv, null ) || {} ).marginRight );

				body.removeChild( container );
			}

			return reliableMarginRightVal;
		}
	});

	function computeStyleTests() {
		var container, div,
			body = document.getElementsByTagName( "body" )[ 0 ];

		if ( !body ) {
			// Test fired too early or in an unsupported environment, exit.
			return;
		}

		container = document.createElement( "div" );
		div = document.createElement( "div" );
		container.style.cssText = containerStyles;

		body.appendChild( container ).appendChild( div );

		div.style.cssText =
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
				"position:absolute;display:block;padding:1px;border:1px;width:4px;" +
				"margin-top:1%;top:1%";

		// Workaround failing boxSizing test due to offsetWidth returning wrong value
		// with some non-1 values of body zoom, ticket #13543
		jQuery.swap( body, body.style.zoom != null ? { zoom: 1 } : {}, function() {
			boxSizingVal = div.offsetWidth === 4;
		});

		// Will be changed later if needed.
		boxSizingReliableVal = true;
		pixelPositionVal = false;
		reliableMarginRightVal = true;

		// Use window.getComputedStyle because jsdom on node.js will break without it.
		if ( window.getComputedStyle ) {
			pixelPositionVal = ( window.getComputedStyle( div, null ) || {} ).top !== "1%";
			boxSizingReliableVal =
				( window.getComputedStyle( div, null ) || { width: "4px" } ).width === "4px";
		}

		body.removeChild( container );

		// Null elements to avoid leaks in IE.
		div = body = null;
	}

})();


// A method for quickly swapping in/out CSS properties to get correct calculations.
jQuery.swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var
		ralpha = /alpha\([^)]*\)/i,
	ropacity = /opacity\s*=\s*([^)]*)/,

	// swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	// see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
	rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: 0,
		fontWeight: 400
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];


// return a css property mapped to a potentially vendor prefixed property
function vendorPropName( style, name ) {

	// shortcut for names that are not vendor prefixed
	if ( name in style ) {
		return name;
	}

	// check for vendor prefixed names
	var capName = name.charAt(0).toUpperCase() + name.slice(1),
		origName = name,
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in style ) {
			return name;
		}
	}

	return origName;
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = jQuery._data( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {
			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = jQuery._data( elem, "olddisplay", defaultDisplay(elem.nodeName) );
			}
		} else {

			if ( !values[ index ] ) {
				hidden = isHidden( elem );

				if ( display && display !== "none" || !hidden ) {
					jQuery._data( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
				}
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

function setPositiveNumber( elem, value, subtract ) {
	var matches = rnumsplit.exec( value );
	return matches ?
		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?
		// If we already have the right measurement, avoid augmentation
		4 :
		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {
		// both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {
			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// at this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {
			// at this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// at this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = support.boxSizing() && jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {
		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test(val) ) {
			return val;
		}

		// we need the check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox && ( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend({
	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {
					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"columnCount": true,
		"fillOpacity": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		// normalize float css property
		"float": support.cssFloat ? "cssFloat" : "styleFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {
		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );

		// gets hook for the prefixed version
		// followed by the unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// convert relative number strings (+= or -=) to relative numbers. #7345
			if ( type === "string" && (ret = rrelNum.exec( value )) ) {
				value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set. See: #7116
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add 'px' to the (except for certain CSS properties)
			if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
				value += "px";
			}

			// Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
			// but it would mean to define eight (for every problematic property) identical functions
			if ( !support.clearCloneStyle && value === "" && name.indexOf("background") === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {

				// Support: IE
				// Swallow errors from 'invalid' CSS values (#5509)
				try {
					// Support: Chrome, Safari
					// Setting style to blank string required to delete "style: x !important;"
					style[ name ] = "";
					style[ name ] = value;
				} catch(e) {}
			}

		} else {
			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var num, val, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );

		// gets hook for the prefixed version
		// followed by the unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		//convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Return, converting to number if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
		}
		return val;
	}
});

jQuery.each([ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {
				// certain elements can have dimension info if we invisibly show them
				// however, it must have a current display style that would benefit from this
				return elem.offsetWidth === 0 && rdisplayswap.test( jQuery.css( elem, "display" ) ) ?
					jQuery.swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, name, extra );
					}) :
					getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var styles = extra && getStyles( elem );
			return setPositiveNumber( elem, value, extra ?
				augmentWidthOrHeight(
					elem,
					name,
					extra,
					support.boxSizing() && jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				) : 0
			);
		}
	};
});

if ( !support.opacity ) {
	jQuery.cssHooks.opacity = {
		get: function( elem, computed ) {
			// IE uses filters for opacity
			return ropacity.test( (computed && elem.currentStyle ? elem.currentStyle.filter : elem.style.filter) || "" ) ?
				( 0.01 * parseFloat( RegExp.$1 ) ) + "" :
				computed ? "1" : "";
		},

		set: function( elem, value ) {
			var style = elem.style,
				currentStyle = elem.currentStyle,
				opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
				filter = currentStyle && currentStyle.filter || style.filter || "";

			// IE has trouble with opacity if it does not have layout
			// Force it by setting the zoom level
			style.zoom = 1;

			// if setting opacity to 1, and no other filters exist - attempt to remove filter attribute #6652
			// if value === "", then remove inline opacity #12685
			if ( ( value >= 1 || value === "" ) &&
					jQuery.trim( filter.replace( ralpha, "" ) ) === "" &&
					style.removeAttribute ) {

				// Setting style.filter to null, "" & " " still leave "filter:" in the cssText
				// if "filter:" is present at all, clearType is disabled, we want to avoid this
				// style.removeAttribute is IE Only, but so apparently is this code path...
				style.removeAttribute( "filter" );

				// if there is no filter style applied in a css rule or unset inline opacity, we are done
				if ( value === "" || currentStyle && !currentStyle.filter ) {
					return;
				}
			}

			// otherwise, set new filter values
			style.filter = ralpha.test( filter ) ?
				filter.replace( ralpha, opacity ) :
				filter + " " + opacity;
		}
	};
}

jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
			// Work around by temporarily setting element display to inline-block
			return jQuery.swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each({
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// assumes a single number if not a string
				parts = typeof value === "string" ? value.split(" ") : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
});

jQuery.fn.extend({
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each(function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		});
	}
});


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || "swing";
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			if ( tween.elem[ tween.prop ] != null &&
				(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
				return tween.elem[ tween.prop ];
			}

			// passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails
			// so, simple values such as "10px" are parsed to Float.
			// complex values such as "rotate(1rad)" are returned as is.
			result = jQuery.css( tween.elem, tween.prop, "" );
			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {
			// use step hook for back compat - use cssHook if its there - use .style if its
			// available and use plain properties where available
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9
// Panic based approach to setting things on disconnected nodes

Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	}
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
	rrun = /queueHooks$/,
	animationPrefilters = [ defaultPrefilter ],
	tweeners = {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value ),
				target = tween.cur(),
				parts = rfxnum.exec( value ),
				unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

				// Starting value computation is required for potential unit mismatches
				start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
					rfxnum.exec( jQuery.css( tween.elem, prop ) ),
				scale = 1,
				maxIterations = 20;

			if ( start && start[ 3 ] !== unit ) {
				// Trust units reported by jQuery.css
				unit = unit || start[ 3 ];

				// Make sure we update the tween properties later on
				parts = parts || [];

				// Iteratively approximate from a nonzero starting point
				start = +target || 1;

				do {
					// If previous iteration zeroed out, double until we get *something*
					// Use a string for doubling factor so we don't accidentally see scale as unchanged below
					scale = scale || ".5";

					// Adjust and apply
					start = start / scale;
					jQuery.style( tween.elem, prop, start + unit );

				// Update scale, tolerating zero or NaN from tween.cur()
				// And breaking the loop if scale is unchanged or perfect, or if we've just had enough
				} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
			}

			// Update tween properties
			if ( parts ) {
				start = tween.start = +start || +target || 0;
				tween.unit = unit;
				// If a +=/-= token was provided, we're doing a relative animation
				tween.end = parts[ 1 ] ?
					start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
					+parts[ 2 ];
			}

			return tween;
		} ]
	};

// Animations created synchronously will run synchronously
function createFxNow() {
	setTimeout(function() {
		fxNow = undefined;
	});
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		attrs = { height: type },
		i = 0;

	// if we include width, step value is 1 to do all cssExpand values,
	// if we don't include width, step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( (tween = collection[ index ].call( animation, prop, value )) ) {

			// we're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, dDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = jQuery._data( elem, "fxshow" );

	// handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always(function() {
			// doing this makes sure that the complete handler will be called
			// before this completes
			anim.always(function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			});
		});
	}

	// height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE does not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );
		dDisplay = defaultDisplay( elem.nodeName );
		if ( display === "none" ) {
			display = dDisplay;
		}
		if ( display === "inline" &&
				jQuery.css( elem, "float" ) === "none" ) {

			// inline-level elements accept inline-block;
			// block-level elements need to be inline with layout
			if ( !support.inlineBlockNeedsLayout || dDisplay === "inline" ) {
				style.display = "inline-block";
			} else {
				style.zoom = 1;
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		if ( !support.shrinkWrapBlocks() ) {
			anim.always(function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			});
		}
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = jQuery._data( elem, "fxshow", {} );
		}

		// store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done(function() {
				jQuery( elem ).hide();
			});
		}
		anim.done(function() {
			var prop;
			jQuery._removeData( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		});
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// not quite $.extend, this wont overwrite keys already present.
			// also - reusing 'index' from above because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = animationPrefilters.length,
		deferred = jQuery.Deferred().always( function() {
			// don't match elem in the :animated selector
			delete tick.elem;
		}),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
				// archaic crash bug won't allow us to use 1 - ( 0.5 || 0 ) (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ]);

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise({
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, { specialEasing: {} }, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,
					// if we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// resolve when we played the last frame
				// otherwise, reject
				if ( gotoEnd ) {
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		}),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		})
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {
	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.split(" ");
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			tweeners[ prop ] = tweeners[ prop ] || [];
			tweeners[ prop ].unshift( callback );
		}
	},

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			animationPrefilters.unshift( callback );
		} else {
			animationPrefilters.push( callback );
		}
	}
});

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
		opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend({
	fadeTo: function( speed, to, easing, callback ) {

		// show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// animate to the value specified
			.end().animate({ opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {
				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || jQuery._data( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each(function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = jQuery._data( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// start the next in the queue if the last step wasn't forced
			// timers currently will call their complete callbacks, which will dequeue
			// but only if they were gotoEnd
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		});
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each(function() {
			var index,
				data = jQuery._data( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// enable finishing flag on private data
			data.finish = true;

			// empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// turn off finishing flag
			delete data.finish;
		});
	}
});

jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
});

// Generate shortcuts for custom animations
jQuery.each({
	slideDown: genFx("show"),
	slideUp: genFx("hide"),
	slideToggle: genFx("toggle"),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
});

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		timers = jQuery.timers,
		i = 0;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];
		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;

jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	clearInterval( timerId );
	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,
	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = setTimeout( next, time );
		hooks.stop = function() {
			clearTimeout( timeout );
		};
	});
};


(function() {
	var a, input, select, opt,
		div = document.createElement("div" );

	// Setup
	div.setAttribute( "className", "t" );
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	a = div.getElementsByTagName("a")[ 0 ];

	// First batch of tests.
	select = document.createElement("select");
	opt = select.appendChild( document.createElement("option") );
	input = div.getElementsByTagName("input")[ 0 ];

	a.style.cssText = "top:1px";

	// Test setAttribute on camelCase class. If it works, we need attrFixes when doing get/setAttribute (ie6/7)
	support.getSetAttribute = div.className !== "t";

	// Get the style information from getAttribute
	// (IE uses .cssText instead)
	support.style = /top/.test( a.getAttribute("style") );

	// Make sure that URLs aren't manipulated
	// (IE normalizes it by default)
	support.hrefNormalized = a.getAttribute("href") === "/a";

	// Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
	support.checkOn = !!input.value;

	// Make sure that a selected-by-default option has a working selected property.
	// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
	support.optSelected = opt.selected;

	// Tests for enctype support on a form (#6743)
	support.enctype = !!document.createElement("form").enctype;

	// Make sure that the options inside disabled selects aren't marked as disabled
	// (WebKit marks them as disabled)
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE8 only
	// Check if we can trust getAttribute("value")
	input = document.createElement( "input" );
	input.setAttribute( "value", "" );
	support.input = input.getAttribute( "value" ) === "";

	// Check if an input maintains its value after becoming a radio
	input.value = "t";
	input.setAttribute( "type", "radio" );
	support.radioValue = input.value === "t";

	// Null elements to avoid leaks in IE.
	a = input = select = opt = div = null;
})();


var rreturn = /\r/g;

jQuery.fn.extend({
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[0];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?
					// handle most common string cases
					ret.replace(rreturn, "") :
					// handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each(function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";
			} else if ( typeof val === "number" ) {
				val += "";
			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				});
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		});
	}
});

jQuery.extend({
	valHooks: {
		option: {
			get: function( elem ) {
				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :
					jQuery.text( elem );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// oldIE doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&
							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null ) &&
							( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					if ( jQuery.inArray( jQuery.valHooks.option.get( option ), values ) >= 0 ) {

						// Support: IE6
						// When new option element is added to select box we need to
						// force reflow of newly added node in order to workaround delay
						// of initialization properties
						try {
							option.selected = optionSet = true;

						} catch ( _ ) {

							// Will be executed only in IE6
							option.scrollHeight;
						}

					} else {
						option.selected = false;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}

				return options;
			}
		}
	}
});

// Radios and checkboxes getter/setter
jQuery.each([ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			// Support: Webkit
			// "" is returned instead of "on" if a value isn't specified
			return elem.getAttribute("value") === null ? "on" : elem.value;
		};
	}
});




var nodeHook, boolHook,
	attrHandle = jQuery.expr.attrHandle,
	ruseDefault = /^(?:checked|selected)$/i,
	getSetAttribute = support.getSetAttribute,
	getSetInput = support.input;

jQuery.fn.extend({
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each(function() {
			jQuery.removeAttr( this, name );
		});
	}
});

jQuery.extend({
	attr: function( elem, name, value ) {
		var hooks, ret,
			nType = elem.nodeType;

		// don't get/set attributes on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === strundefined ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
		}

		if ( value !== undefined ) {

			if ( value === null ) {
				jQuery.removeAttr( elem, name );

			} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
				return ret;

			} else {
				elem.setAttribute( name, value + "" );
				return value;
			}

		} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
			return ret;

		} else {
			ret = jQuery.find.attr( elem, name );

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ?
				undefined :
				ret;
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( (name = attrNames[i++]) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {
					// Set corresponding property to false
					if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
						elem[ propName ] = false;
					// Support: IE<9
					// Also clear defaultChecked/defaultSelected (if appropriate)
					} else {
						elem[ jQuery.camelCase( "default-" + name ) ] =
							elem[ propName ] = false;
					}

				// See #9699 for explanation of this approach (setting first, then removal)
				} else {
					jQuery.attr( elem, name, "" );
				}

				elem.removeAttribute( getSetAttribute ? name : propName );
			}
		}
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" && jQuery.nodeName(elem, "input") ) {
					// Setting the type on a radio button after the value resets the value in IE6-9
					// Reset value to default in case type is set after value during creation
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	}
});

// Hook for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {
			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
			// IE<8 needs the *property* name
			elem.setAttribute( !getSetAttribute && jQuery.propFix[ name ] || name, name );

		// Use defaultChecked and defaultSelected for oldIE
		} else {
			elem[ jQuery.camelCase( "default-" + name ) ] = elem[ name ] = true;
		}

		return name;
	}
};

// Retrieve booleans specially
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {

	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = getSetInput && getSetAttribute || !ruseDefault.test( name ) ?
		function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		} :
		function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem[ jQuery.camelCase( "default-" + name ) ] ?
					name.toLowerCase() :
					null;
			}
		};
});

// fix oldIE attroperties
if ( !getSetInput || !getSetAttribute ) {
	jQuery.attrHooks.value = {
		set: function( elem, value, name ) {
			if ( jQuery.nodeName( elem, "input" ) ) {
				// Does not return so that setAttribute is also used
				elem.defaultValue = value;
			} else {
				// Use nodeHook if defined (#1954); otherwise setAttribute is fine
				return nodeHook && nodeHook.set( elem, value, name );
			}
		}
	};
}

// IE6/7 do not support getting/setting some attributes with get/setAttribute
if ( !getSetAttribute ) {

	// Use this for any attribute in IE6/7
	// This fixes almost every IE6/7 issue
	nodeHook = {
		set: function( elem, value, name ) {
			// Set the existing or create a new attribute node
			var ret = elem.getAttributeNode( name );
			if ( !ret ) {
				elem.setAttributeNode(
					(ret = elem.ownerDocument.createAttribute( name ))
				);
			}

			ret.value = value += "";

			// Break association with cloned elements by also using setAttribute (#9646)
			if ( name === "value" || value === elem.getAttribute( name ) ) {
				return value;
			}
		}
	};

	// Some attributes are constructed with empty-string values when not defined
	attrHandle.id = attrHandle.name = attrHandle.coords =
		function( elem, name, isXML ) {
			var ret;
			if ( !isXML ) {
				return (ret = elem.getAttributeNode( name )) && ret.value !== "" ?
					ret.value :
					null;
			}
		};

	// Fixing value retrieval on a button requires this module
	jQuery.valHooks.button = {
		get: function( elem, name ) {
			var ret = elem.getAttributeNode( name );
			if ( ret && ret.specified ) {
				return ret.value;
			}
		},
		set: nodeHook.set
	};

	// Set contenteditable to false on removals(#10429)
	// Setting to empty string throws an error as an invalid value
	jQuery.attrHooks.contenteditable = {
		set: function( elem, value, name ) {
			nodeHook.set( elem, value === "" ? false : value, name );
		}
	};

	// Set width and height to auto instead of 0 on empty string( Bug #8150 )
	// This is for removals
	jQuery.each([ "width", "height" ], function( i, name ) {
		jQuery.attrHooks[ name ] = {
			set: function( elem, value ) {
				if ( value === "" ) {
					elem.setAttribute( name, "auto" );
					return value;
				}
			}
		};
	});
}

if ( !support.style ) {
	jQuery.attrHooks.style = {
		get: function( elem ) {
			// Return undefined in the case of empty string
			// Note: IE uppercases css property names, but if we were to .toLowerCase()
			// .cssText, that would destroy case senstitivity in URL's, like in "background"
			return elem.style.cssText || undefined;
		},
		set: function( elem, value ) {
			return ( elem.style.cssText = value + "" );
		}
	};
}




var rfocusable = /^(?:input|select|textarea|button|object)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend({
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		name = jQuery.propFix[ name ] || name;
		return this.each(function() {
			// try/catch handles cases where IE balks (such as removing a property on window)
			try {
				this[ name ] = undefined;
				delete this[ name ];
			} catch( e ) {}
		});
	}
});

jQuery.extend({
	propFix: {
		"for": "htmlFor",
		"class": "className"
	},

	prop: function( elem, name, value ) {
		var ret, hooks, notxml,
			nType = elem.nodeType;

		// don't get/set properties on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		notxml = nType !== 1 || !jQuery.isXMLDoc( elem );

		if ( notxml ) {
			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
				ret :
				( elem[ name ] = value );

		} else {
			return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
				ret :
				elem[ name ];
		}
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {
				// elem.tabIndex doesn't always return the correct value when it hasn't been explicitly set
				// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				return tabindex ?
					parseInt( tabindex, 10 ) :
					rfocusable.test( elem.nodeName ) || rclickable.test( elem.nodeName ) && elem.href ?
						0 :
						-1;
			}
		}
	}
});

// Some attributes require a special call on IE
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !support.hrefNormalized ) {
	// href/src property should get the full normalized URL (#10299/#12915)
	jQuery.each([ "href", "src" ], function( i, name ) {
		jQuery.propHooks[ name ] = {
			get: function( elem ) {
				return elem.getAttribute( name, 4 );
			}
		};
	});
}

// Support: Safari, IE9+
// mis-reports the default selected property of an option
// Accessing the parent's selectedIndex property fixes it
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;

			if ( parent ) {
				parent.selectedIndex;

				// Make sure that it also works with optgroups, see #5701
				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
			return null;
		}
	};
}

jQuery.each([
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
});

// IE6/7 call enctype encoding
if ( !support.enctype ) {
	jQuery.propFix.enctype = "encoding";
}




var rclass = /[\t\r\n\f]/g;

jQuery.fn.extend({
	addClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			i = 0,
			len = this.length,
			proceed = typeof value === "string" && value;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).addClass( value.call( this, j, this.className ) );
			});
		}

		if ( proceed ) {
			// The disjunction here is for better compressibility (see removeClass)
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					" "
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			i = 0,
			len = this.length,
			proceed = arguments.length === 0 || typeof value === "string" && value;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).removeClass( value.call( this, j, this.className ) );
			});
		}
		if ( proceed ) {
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					""
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = value ? jQuery.trim( cur ) : "";
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( i ) {
				jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
			});
		}

		return this.each(function() {
			if ( type === "string" ) {
				// toggle individual class names
				var className,
					i = 0,
					self = jQuery( this ),
					classNames = value.match( rnotwhite ) || [];

				while ( (className = classNames[ i++ ]) ) {
					// check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( type === strundefined || type === "boolean" ) {
				if ( this.className ) {
					// store className if set
					jQuery._data( this, "__className__", this.className );
				}

				// If the element has a class name or if we're passed "false",
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				this.className = this.className || value === false ? "" : jQuery._data( this, "__className__" ) || "";
			}
		});
	},

	hasClass: function( selector ) {
		var className = " " + selector + " ",
			i = 0,
			l = this.length;
		for ( ; i < l; i++ ) {
			if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
				return true;
			}
		}

		return false;
	}
});




// Return jQuery for attributes-only inclusion


jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
});

jQuery.fn.extend({
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	},

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {
		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
	}
});


var nonce = jQuery.now();

var rquery = (/\?/);



var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;

jQuery.parseJSON = function( data ) {
	// Attempt to parse using the native JSON parser first
	if ( window.JSON && window.JSON.parse ) {
		// Support: Android 2.3
		// Workaround failure to string-cast null input
		return window.JSON.parse( data + "" );
	}

	var requireNonComma,
		depth = null,
		str = jQuery.trim( data + "" );

	// Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
	// after removing valid tokens
	return str && !jQuery.trim( str.replace( rvalidtokens, function( token, comma, open, close ) {

		// Force termination if we see a misplaced comma
		if ( requireNonComma && comma ) {
			depth = 0;
		}

		// Perform no more replacements after returning to outermost depth
		if ( depth === 0 ) {
			return token;
		}

		// Commas must not follow "[", "{", or ","
		requireNonComma = open || comma;

		// Determine new depth
		// array/object open ("[" or "{"): depth += true - false (increment)
		// array/object close ("]" or "}"): depth += false - true (decrement)
		// other cases ("," or primitive): depth += true - true (numeric cast)
		depth += !close - !open;

		// Remove this token
		return "";
	}) ) ?
		( Function( "return " + str ) )() :
		jQuery.error( "Invalid JSON: " + data );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, tmp;
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	try {
		if ( window.DOMParser ) { // Standard
			tmp = new DOMParser();
			xml = tmp.parseFromString( data, "text/xml" );
		} else { // IE
			xml = new ActiveXObject( "Microsoft.XMLDOM" );
			xml.async = "false";
			xml.loadXML( data );
		}
	} catch( e ) {
		xml = undefined;
	}
	if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	// Document location
	ajaxLocParts,
	ajaxLocation,

	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg, // IE leaves an \r character at EOL
	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,
	rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat("*");

// #8138, IE may throw an exception when accessing
// a field from window.location if document.domain has been set
try {
	ajaxLocation = location.href;
} catch( e ) {
	// Use the href attribute of an A element
	// since IE will modify it given document.location
	ajaxLocation = document.createElement( "a" );
	ajaxLocation.href = "";
	ajaxLocation = ajaxLocation.href;
}

// Segment location into parts
ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {
			// For each dataType in the dataTypeExpression
			while ( (dataType = dataTypes[i++]) ) {
				// Prepend if requested
				if ( dataType.charAt( 0 ) === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					(structure[ dataType ] = structure[ dataType ] || []).unshift( func );

				// Otherwise append
				} else {
					(structure[ dataType ] = structure[ dataType ] || []).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		});
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var deep, key,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {
	var firstDataType, ct, finalDataType, type,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {
		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}
		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},
		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {
								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s[ "throws" ] ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend({

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: ajaxLocation,
		type: "GET",
		isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /xml/,
			html: /html/,
			json: /json/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var // Cross-domain detection vars
			parts,
			// Loop variable
			i,
			// URL without anti-cache param
			cacheURL,
			// Response headers as string
			responseHeadersString,
			// timeout handle
			timeoutTimer,

			// To know if global events are to be dispatched
			fireGlobals,

			transport,
			// Response headers
			responseHeaders,
			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),
			// Callbacks context
			callbackContext = s.context || s,
			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,
			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks("once memory"),
			// Status-dependent callbacks
			statusCode = s.statusCode || {},
			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},
			// The jqXHR state
			state = 0,
			// Default abort message
			strAbort = "canceled",
			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( (match = rheaders.exec( responseHeadersString )) ) {
								responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {
								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {
							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" ).replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when we have a protocol:host:port mismatch
		if ( s.crossDomain == null ) {
			parts = rurl.exec( s.url.toLowerCase() );
			s.crossDomain = !!( parts &&
				( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
			);
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		fireGlobals = s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger("ajaxStart");
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
				s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
			// Abort if not done already and return
			return jqXHR.abort();
		}

		// aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}
			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = setTimeout(function() {
					jqXHR.abort("timeout");
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {
				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );
				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader("Last-Modified");
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader("etag");
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {
				// We extract error from statusText
				// then normalize statusText and status for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger("ajaxStop");
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
});

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {
		// shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		return jQuery.ajax({
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		});
	};
});

// Attach a bunch of functions for handling common AJAX events
jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
});


jQuery._evalUrl = function( url ) {
	return jQuery.ajax({
		url: url,
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	});
};


jQuery.fn.extend({
	wrapAll: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each(function(i) {
				jQuery(this).wrapAll( html.call(this, i) );
			});
		}

		if ( this[0] ) {
			// The elements to wrap the target around
			var wrap = jQuery( html, this[0].ownerDocument ).eq(0).clone(true);

			if ( this[0].parentNode ) {
				wrap.insertBefore( this[0] );
			}

			wrap.map(function() {
				var elem = this;

				while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
					elem = elem.firstChild;
				}

				return elem;
			}).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each(function(i) {
				jQuery(this).wrapInner( html.call(this, i) );
			});
		}

		return this.each(function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		});
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each(function(i) {
			jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
		});
	},

	unwrap: function() {
		return this.parent().each(function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		}).end();
	}
});


jQuery.expr.filters.hidden = function( elem ) {
	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	return elem.offsetWidth <= 0 && elem.offsetHeight <= 0 ||
		(!support.reliableHiddenOffsets() &&
			((elem.style && elem.style.display) || jQuery.css( elem, "display" )) === "none");
};

jQuery.expr.filters.visible = function( elem ) {
	return !jQuery.expr.filters.hidden( elem );
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {
		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {
				// Treat each array item as a scalar.
				add( prefix, v );

			} else {
				// Item is non-scalar (array or object), encode its numeric index.
				buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
			}
		});

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {
		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {
		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {
			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		});

	} else {
		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend({
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map(function() {
			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		})
		.filter(function() {
			var type = this.type;
			// Use .is(":disabled") so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		})
		.map(function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					}) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		}).get();
	}
});


// Create the request object
// (This is still attached to ajaxSettings for backward compatibility)
jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ?
	// Support: IE6+
	function() {

		// XHR cannot access local files, always use ActiveX for that case
		return !this.isLocal &&

			// Support: IE7-8
			// oldIE XHR does not support non-RFC2616 methods (#13240)
			// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
			// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
			// Although this check for six methods instead of eight
			// since IE also does not support "trace" and "connect"
			/^(get|post|head|put|delete|options)$/i.test( this.type ) &&

			createStandardXHR() || createActiveXHR();
	} :
	// For all other browsers, use the standard XMLHttpRequest object
	createStandardXHR;

var xhrId = 0,
	xhrCallbacks = {},
	xhrSupported = jQuery.ajaxSettings.xhr();

// Support: IE<10
// Open requests must be manually aborted on unload (#5280)
if ( window.ActiveXObject ) {
	jQuery( window ).on( "unload", function() {
		for ( var key in xhrCallbacks ) {
			xhrCallbacks[ key ]( undefined, true );
		}
	});
}

// Determine support properties
support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
xhrSupported = support.ajax = !!xhrSupported;

// Create transport if the browser can provide an xhr
if ( xhrSupported ) {

	jQuery.ajaxTransport(function( options ) {
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( !options.crossDomain || support.cors ) {

			var callback;

			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr(),
						id = ++xhrId;

					// Open the socket
					xhr.open( options.type, options.url, options.async, options.username, options.password );

					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}

					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}

					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers["X-Requested-With"] ) {
						headers["X-Requested-With"] = "XMLHttpRequest";
					}

					// Set headers
					for ( i in headers ) {
						// Support: IE<9
						// IE's ActiveXObject throws a 'Type Mismatch' exception when setting
						// request header to a null-value.
						//
						// To keep consistent with other XHR implementations, cast the value
						// to string and ignore `undefined`.
						if ( headers[ i ] !== undefined ) {
							xhr.setRequestHeader( i, headers[ i ] + "" );
						}
					}

					// Do send the request
					// This may raise an exception which is actually
					// handled in jQuery.ajax (so no try/catch here)
					xhr.send( ( options.hasContent && options.data ) || null );

					// Listener
					callback = function( _, isAbort ) {
						var status, statusText, responses;

						// Was never called and is aborted or complete
						if ( callback && ( isAbort || xhr.readyState === 4 ) ) {
							// Clean up
							delete xhrCallbacks[ id ];
							callback = undefined;
							xhr.onreadystatechange = jQuery.noop;

							// Abort manually if needed
							if ( isAbort ) {
								if ( xhr.readyState !== 4 ) {
									xhr.abort();
								}
							} else {
								responses = {};
								status = xhr.status;

								// Support: IE<10
								// Accessing binary-data responseText throws an exception
								// (#11426)
								if ( typeof xhr.responseText === "string" ) {
									responses.text = xhr.responseText;
								}

								// Firefox throws an exception when accessing
								// statusText for faulty cross-domain requests
								try {
									statusText = xhr.statusText;
								} catch( e ) {
									// We normalize with Webkit giving an empty statusText
									statusText = "";
								}

								// Filter status for non standard behaviors

								// If the request is local and we have data: assume a success
								// (success with no data won't get notified, that's the best we
								// can do given current implementations)
								if ( !status && options.isLocal && !options.crossDomain ) {
									status = responses.text ? 200 : 404;
								// IE - #1450: sometimes returns 1223 when it should be 204
								} else if ( status === 1223 ) {
									status = 204;
								}
							}
						}

						// Call complete if needed
						if ( responses ) {
							complete( status, statusText, responses, xhr.getAllResponseHeaders() );
						}
					};

					if ( !options.async ) {
						// if we're in sync mode we fire the callback
						callback();
					} else if ( xhr.readyState === 4 ) {
						// (IE6 & IE7) if it's in cache and has been
						// retrieved directly we need to fire the callback
						setTimeout( callback );
					} else {
						// Add to the list of active xhr callbacks
						xhr.onreadystatechange = xhrCallbacks[ id ] = callback;
					}
				},

				abort: function() {
					if ( callback ) {
						callback( undefined, true );
					}
				}
			};
		}
	});
}

// Functions to create xhrs
function createStandardXHR() {
	try {
		return new window.XMLHttpRequest();
	} catch( e ) {}
}

function createActiveXHR() {
	try {
		return new window.ActiveXObject( "Microsoft.XMLHTTP" );
	} catch( e ) {}
}




// Install script dataType
jQuery.ajaxSetup({
	accepts: {
		script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /(?:java|ecma)script/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
});

// Handle cache's special case and global
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
		s.global = false;
	}
});

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function(s) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {

		var script,
			head = document.head || jQuery("head")[0] || document.documentElement;

		return {

			send: function( _, callback ) {

				script = document.createElement("script");

				script.async = true;

				if ( s.scriptCharset ) {
					script.charset = s.scriptCharset;
				}

				script.src = s.url;

				// Attach handlers for all browsers
				script.onload = script.onreadystatechange = function( _, isAbort ) {

					if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {

						// Handle memory leak in IE
						script.onload = script.onreadystatechange = null;

						// Remove the script
						if ( script.parentNode ) {
							script.parentNode.removeChild( script );
						}

						// Dereference the script
						script = null;

						// Callback if not abort
						if ( !isAbort ) {
							callback( 200, "success" );
						}
					}
				};

				// Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
				// Use native DOM manipulation to avoid our domManip AJAX trickery
				head.insertBefore( script, head.firstChild );
			},

			abort: function() {
				if ( script ) {
					script.onload( undefined, true );
				}
			}
		};
	}
});




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup({
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
});

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters["script json"] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always(function() {
			// Restore preexisting value
			window[ callbackName ] = overwritten;

			// Save back as free
			if ( s[ callbackName ] ) {
				// make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		});

		// Delegate to script
		return "script";
	}
});




// data: string of html
// context (optional): If specified, the fragment will be created in this context, defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[1] ) ];
	}

	parsed = jQuery.buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, response, type,
		self = this,
		off = url.indexOf(" ");

	if ( off >= 0 ) {
		selector = url.slice( off, url.length );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax({
			url: url,

			// if "type" variable is undefined, then "GET" method will be used
			type: type,
			dataType: "html",
			data: params
		}).done(function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		}).complete( callback && function( jqXHR, status ) {
			self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
		});
	}

	return this;
};




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep(jQuery.timers, function( fn ) {
		return elem === fn.elem;
	}).length;
};





var docElem = window.document.documentElement;

/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ?
		elem :
		elem.nodeType === 9 ?
			elem.defaultView || elem.parentWindow :
			false;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			jQuery.inArray("auto", [ curCSSTop, curCSSLeft ] ) > -1;

		// need to be able to calculate position if either top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;
		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {
			options = options.call( elem, i, curOffset );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );
		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend({
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each(function( i ) {
					jQuery.offset.setOffset( this, options, i );
				});
		}

		var docElem, win,
			box = { top: 0, left: 0 },
			elem = this[ 0 ],
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		// If we don't have gBCR, just use 0,0 rather than error
		// BlackBerry 5, iOS 3 (original iPhone)
		if ( typeof elem.getBoundingClientRect !== strundefined ) {
			box = elem.getBoundingClientRect();
		}
		win = getWindow( doc );
		return {
			top: box.top  + ( win.pageYOffset || docElem.scrollTop )  - ( docElem.clientTop  || 0 ),
			left: box.left + ( win.pageXOffset || docElem.scrollLeft ) - ( docElem.clientLeft || 0 )
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			parentOffset = { top: 0, left: 0 },
			elem = this[ 0 ];

		// fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {
			// we assume that getBoundingClientRect is available when computed position is fixed
			offset = elem.getBoundingClientRect();
		} else {
			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top  += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		// note: when an element has margin: auto the offsetLeft and marginLeft
		// are the same in Safari causing offset.left to incorrectly be 0
		return {
			top:  offset.top  - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true)
		};
	},

	offsetParent: function() {
		return this.map(function() {
			var offsetParent = this.offsetParent || docElem;

			while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
				offsetParent = offsetParent.offsetParent;
			}
			return offsetParent || docElem;
		});
	}
});

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = /Y/.test( prop );

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? (prop in win) ? win[ prop ] :
					win.document.documentElement[ method ] :
					elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : jQuery( win ).scrollLeft(),
					top ? val : jQuery( win ).scrollTop()
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length, null );
	};
});

// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// getComputedStyle returns percent when specified for top/left/bottom/right
// rather than make the css module depend on the offset module, we just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );
				// if curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
});


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
		// margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {
					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height], whichever is greatest
					// unfortunately, this causes bug #3838 in IE6/8 only, but there is currently no good, small way to fix it.
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?
					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	});
});


// The number of elements contained in the matched element set
jQuery.fn.size = function() {
	return this.length;
};

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.
if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var
	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in
// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === strundefined ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;

}));


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(11);
module.exports = __webpack_require__(16);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(12).enable();
  window.Promise = __webpack_require__(14);
}

// fetch() polyfill for making API calls.
__webpack_require__(15);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(0);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(2);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(2);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(26);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],null),document.getElementById('root'));

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(0),n=__webpack_require__(4),p=__webpack_require__(5),q=__webpack_require__(6),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
function M(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a)}
function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++)}
function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b)}
var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b)},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(19);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var ba=__webpack_require__(4),ea=__webpack_require__(1),m=__webpack_require__(20),A=__webpack_require__(0),C=__webpack_require__(6),fa=__webpack_require__(21),ha=__webpack_require__(22),ja=__webpack_require__(23),ka=__webpack_require__(5);
function D(a){for(var b=arguments.length-1,c="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ea?void 0:D("227");
function ma(a,b,c,d,e,f,h,g,k){this._hasCaughtError=!1;this._caughtError=null;var v=Array.prototype.slice.call(arguments,3);try{b.apply(c,v)}catch(l){this._caughtError=l,this._hasCaughtError=!0}}
var E={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,h,g,k){ma.apply(E,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,g,k){E.invokeGuardedCallback.apply(this,arguments);if(E.hasCaughtError()){var v=E.clearCaughtError();E._hasRethrowError||(E._hasRethrowError=!0,E._rethrowError=v)}},rethrowCaughtError:function(){return na.apply(E,arguments)},hasCaughtError:function(){return E._hasCaughtError},clearCaughtError:function(){if(E._hasCaughtError){var a=
E._caughtError;E._caughtError=null;E._hasCaughtError=!1;return a}D("198")}};function na(){if(E._hasRethrowError){var a=E._rethrowError;E._rethrowError=null;E._hasRethrowError=!1;throw a;}}var oa=null,pa={};
function qa(){if(oa)for(var a in pa){var b=pa[a],c=oa.indexOf(a);-1<c?void 0:D("96",a);if(!ra[c]){b.extractEvents?void 0:D("97",a);ra[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;sa.hasOwnProperty(g)?D("99",g):void 0;sa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ta(k[e],h,g);e=!0}else f.registrationName?(ta(f.registrationName,h,g),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
function ta(a,b,c){ua[a]?D("100",a):void 0;ua[a]=b;va[a]=b.eventTypes[c].dependencies}var ra=[],sa={},ua={},va={};function wa(a){oa?D("101"):void 0;oa=Array.prototype.slice.call(a);qa()}function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];pa.hasOwnProperty(c)&&pa[c]===d||(pa[c]?D("102",c):void 0,pa[c]=d,b=!0)}b&&qa()}
var Ca=Object.freeze({plugins:ra,eventNameDispatchConfigs:sa,registrationNameModules:ua,registrationNameDependencies:va,possibleRegistrationNames:null,injectEventPluginOrder:wa,injectEventPluginsByName:xa}),Da=null,Ea=null,Fa=null;function Ga(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Fa(d);E.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Ha(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ia(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ja=null;
function Ka(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Ga(a,b,c[e],d[e]);else c&&Ga(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function La(a){return Ka(a,!0)}function Ma(a){return Ka(a,!1)}var Na={injectEventPluginOrder:wa,injectEventPluginsByName:xa};
function Oa(a,b){var c=a.stateNode;if(!c)return null;var d=Da(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
return c}function Pa(a,b){null!==a&&(Ja=Ha(Ja,a));a=Ja;Ja=null;a&&(b?Ia(a,La):Ia(a,Ma),Ja?D("95"):void 0,E.rethrowCaughtError())}function Qa(a,b,c,d){for(var e=null,f=0;f<ra.length;f++){var h=ra[f];h&&(h=h.extractEvents(a,b,c,d))&&(e=Ha(e,h))}Pa(e,!1)}var Ra=Object.freeze({injection:Na,getListener:Oa,runEventsInBatch:Pa,runExtractedEventsInBatch:Qa}),Sa=Math.random().toString(36).slice(2),F="__reactInternalInstance$"+Sa,Ta="__reactEventHandlers$"+Sa;
function Ua(a){if(a[F])return a[F];for(;!a[F];)if(a.parentNode)a=a.parentNode;else return null;a=a[F];return 5===a.tag||6===a.tag?a:null}function Va(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function Xa(a){return a[Ta]||null}var bb=Object.freeze({precacheFiberNode:function(a,b){b[F]=a},getClosestInstanceFromNode:Ua,getInstanceFromNode:function(a){a=a[F];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Va,getFiberCurrentPropsFromNode:Xa,updateFiberProps:function(a,b){a[Ta]=b}});
function L(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function cb(a,b,c){for(var d=[];a;)d.push(a),a=L(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function db(a,b,c){if(b=Oa(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a)}function eb(a){a&&a.dispatchConfig.phasedRegistrationNames&&cb(a._targetInst,db,a)}
function fb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?L(b):null;cb(b,db,a)}}function gb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Oa(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a))}function hb(a){a&&a.dispatchConfig.registrationName&&gb(a._targetInst,null,a)}function ib(a){Ia(a,eb)}
function jb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,h=0,g=e;g;g=L(g))h++;g=0;for(var k=f;k;k=L(k))g++;for(;0<h-g;)e=L(e),h--;for(;0<g-h;)f=L(f),g--;for(;h--;){if(e===f||e===f.alternate)break a;e=L(e);f=L(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){h=c.alternate;if(null!==h&&h===f)break;e.push(c);c=L(c)}for(c=[];d&&d!==f;){h=d.alternate;if(null!==h&&h===f)break;c.push(d);d=L(d)}for(d=0;d<e.length;d++)gb(e[d],"bubbled",a);for(a=c.length;0<a--;)gb(c[a],"captured",b)}
var kb=Object.freeze({accumulateTwoPhaseDispatches:ib,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ia(a,fb)},accumulateEnterLeaveDispatches:jb,accumulateDirectDispatches:function(a){Ia(a,hb)}}),lb=null;function mb(){!lb&&m.canUseDOM&&(lb="textContent"in document.documentElement?"textContent":"innerText");return lb}var M={_root:null,_startText:null,_fallbackText:null};
function nb(){if(M._fallbackText)return M._fallbackText;var a,b=M._startText,c=b.length,d,e=ob(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);M._fallbackText=e.slice(a,1<d?1-d:void 0);return M._fallbackText}function ob(){return"value"in M._root?M._root.value:M._root[mb()]}
var pb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),qb={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function N(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
A(N.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<pb.length;a++)this[pb[a]]=null}});N.Interface=qb;N.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;A(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=A({},d.Interface,a);c.extend=d.extend;rb(c);return c};rb(N);
function sb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function tb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function rb(a){a.eventPool=[];a.getPooled=sb;a.release=tb}var ub=N.extend({data:null}),vb=N.extend({data:null}),wb=[9,13,27,32],xb=m.canUseDOM&&"CompositionEvent"in window,yb=null;m.canUseDOM&&"documentMode"in document&&(yb=document.documentMode);
var zb=m.canUseDOM&&"TextEvent"in window&&!yb,Ab=m.canUseDOM&&(!xb||yb&&8<yb&&11>=yb),Bb=String.fromCharCode(32),Kb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Lb=!1;
function Mb(a,b){switch(a){case "topKeyUp":return-1!==wb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function Nb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Ob=!1;function Pb(a,b){switch(a){case "topCompositionEnd":return Nb(b);case "topKeyPress":if(32!==b.which)return null;Lb=!0;return Bb;case "topTextInput":return a=b.data,a===Bb&&Lb?null:a;default:return null}}
function Qb(a,b){if(Ob)return"topCompositionEnd"===a||!xb&&Mb(a,b)?(a=nb(),M._root=null,M._startText=null,M._fallbackText=null,Ob=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return Ab?null:b.data;default:return null}}
var Rb={eventTypes:Kb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(xb)b:{switch(a){case "topCompositionStart":e=Kb.compositionStart;break b;case "topCompositionEnd":e=Kb.compositionEnd;break b;case "topCompositionUpdate":e=Kb.compositionUpdate;break b}e=void 0}else Ob?Mb(a,c)&&(e=Kb.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(e=Kb.compositionStart);e?(Ab&&(Ob||e!==Kb.compositionStart?e===Kb.compositionEnd&&Ob&&(f=nb()):(M._root=d,M._startText=ob(),Ob=!0)),e=ub.getPooled(e,
b,c,d),f?e.data=f:(f=Nb(c),null!==f&&(e.data=f)),ib(e),f=e):f=null;(a=zb?Pb(a,c):Qb(a,c))?(b=vb.getPooled(Kb.beforeInput,b,c,d),b.data=a,ib(b)):b=null;return null===f?b:null===b?f:[f,b]}},Sb=null,Tb={injectFiberControlledHostComponent:function(a){Sb=a}},Ub=null,Vb=null;function Wb(a){if(a=Ea(a)){Sb&&"function"===typeof Sb.restoreControlledState?void 0:D("194");var b=Da(a.stateNode);Sb.restoreControlledState(a.stateNode,a.type,b)}}function Xb(a){Ub?Vb?Vb.push(a):Vb=[a]:Ub=a}
function Yb(){return null!==Ub||null!==Vb}function Zb(){if(Ub){var a=Ub,b=Vb;Vb=Ub=null;Wb(a);if(b)for(a=0;a<b.length;a++)Wb(b[a])}}var $b=Object.freeze({injection:Tb,enqueueStateRestore:Xb,needsStateRestore:Yb,restoreStateIfNeeded:Zb});function ac(a,b){return a(b)}function bc(a,b,c){return a(b,c)}function cc(){}var dc=!1;function ec(a,b){if(dc)return a(b);dc=!0;try{return ac(a,b)}finally{dc=!1,Yb()&&(cc(),Zb())}}
var fc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function gc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!fc[a.type]:"textarea"===b?!0:!1}function hc(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function ic(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function jc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function kc(a){var b=jc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),Object.defineProperty(a,b,{enumerable:c.enumerable}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function lc(a){a._valueTracker||(a._valueTracker=kc(a))}function mc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=jc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var nc=ea.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,O="function"===typeof Symbol&&Symbol["for"],oc=O?Symbol["for"]("react.element"):60103,pc=O?Symbol["for"]("react.call"):60104,qc=O?Symbol["for"]("react.return"):60105,rc=O?Symbol["for"]("react.portal"):60106,sc=O?Symbol["for"]("react.fragment"):60107,tc=O?Symbol["for"]("react.strict_mode"):60108,uc=O?Symbol["for"]("react.provider"):60109,vc=O?Symbol["for"]("react.context"):60110,wc=O?Symbol["for"]("react.async_mode"):60111,
xc=O?Symbol["for"]("react.forward_ref"):60112,yc="function"===typeof Symbol&&Symbol.iterator;function zc(a){if(null===a||"undefined"===typeof a)return null;a=yc&&a[yc]||a["@@iterator"];return"function"===typeof a?a:null}
function Ac(a){a=a.type;if("function"===typeof a)return a.displayName||a.name;if("string"===typeof a)return a;switch(a){case sc:return"ReactFragment";case rc:return"ReactPortal";case pc:return"ReactCall";case qc:return"ReactReturn"}if("object"===typeof a&&null!==a)switch(a.$$typeof){case xc:return a=a.render.displayName||a.render.name||"",""!==a?"ForwardRef("+a+")":"ForwardRef"}return null}
function Bc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=Ac(a);var f=null;c&&(f=Ac(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a["return"]}while(a);return b}
var Cc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Dc={},Ec={};function Fc(a){if(Ec.hasOwnProperty(a))return!0;if(Dc.hasOwnProperty(a))return!1;if(Cc.test(a))return Ec[a]=!0;Dc[a]=!0;return!1}
function Gc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Hc(a,b,c,d){if(null===b||"undefined"===typeof b||Gc(a,b,c,d))return!0;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function U(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var V={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){V[a]=new U(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];V[b]=new U(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){V[a]=new U(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){V[a]=new U(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){V[a]=new U(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){V[a]=new U(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){V[a]=new U(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){V[a]=new U(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){V[a]=new U(a,5,!1,a.toLowerCase(),null)});var Sc=/[\-:]([a-z])/g;function Tc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Sc,
Tc);V[b]=new U(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});V.tabIndex=new U("tabIndex",1,!1,"tabindex",null);
function Uc(a,b,c,d){var e=V.hasOwnProperty(b)?V[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Hc(b,c,e,d)&&(c=null),d||null===e?Fc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Vc(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Xc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Yc(a,b){b=b.checked;null!=b&&Uc(a,"checked",b,!1)}
function Zc(a,b){Yc(a,b);var c=Xc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?$c(a,b.type,c):b.hasOwnProperty("defaultValue")&&$c(a,b.type,Xc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function ad(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function $c(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Xc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var bd={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function cd(a,b,c){a=N.getPooled(bd.change,a,b,c);a.type="change";Xb(c);ib(a);return a}var dd=null,ed=null;function fd(a){Pa(a,!1)}
function gd(a){var b=Va(a);if(mc(b))return a}function hd(a,b){if("topChange"===a)return b}var id=!1;m.canUseDOM&&(id=ic("input")&&(!document.documentMode||9<document.documentMode));function jd(){dd&&(dd.detachEvent("onpropertychange",kd),ed=dd=null)}function kd(a){"value"===a.propertyName&&gd(ed)&&(a=cd(ed,a,hc(a)),ec(fd,a))}function ld(a,b,c){"topFocus"===a?(jd(),dd=b,ed=c,dd.attachEvent("onpropertychange",kd)):"topBlur"===a&&jd()}
function md(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return gd(ed)}function nd(a,b){if("topClick"===a)return gd(b)}function od(a,b){if("topInput"===a||"topChange"===a)return gd(b)}
var pd={eventTypes:bd,_isInputEventSupported:id,extractEvents:function(a,b,c,d){var e=b?Va(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=hd:gc(e)?id?f=od:(f=md,h=ld):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=nd);if(f&&(f=f(a,b)))return cd(f,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&$c(e,"number",e.value)}},qd=N.extend({view:null,
detail:null}),rd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function sd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=rd[a])?!!b[a]:!1}function td(){return sd}
var ud=qd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:td,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),vd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},wd={eventTypes:vd,extractEvents:function(a,
b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?Ua(b):null):a=null;if(a===b)return null;var f=null==a?e:Va(a);e=null==b?e:Va(b);var h=ud.getPooled(vd.mouseLeave,a,c,d);h.type="mouseleave";h.target=f;h.relatedTarget=e;c=ud.getPooled(vd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=
f;jb(h,c,a,b);return[h,c]}};function xd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function yd(a){return(a=a._reactInternalFiber)?2===xd(a):!1}function zd(a){2!==xd(a)?D("188"):void 0}
function Ad(a){var b=a.alternate;if(!b)return b=xd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var h=e.child;h;){if(h===c)return zd(e),a;if(h===d)return zd(e),b;h=h.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{h=!1;for(var g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}h?
void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function Bd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function Cd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var Dd=N.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Ed=N.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Fd=qd.extend({relatedTarget:null});
function Gd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Hd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Id={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Jd=qd.extend({key:function(a){if(a.key){var b=Hd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Gd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Id[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:td,charCode:function(a){return"keypress"===
a.type?Gd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Gd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Kd=ud.extend({dataTransfer:null}),Ld=qd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:td}),Md=N.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Nd=ud.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Od={},Pd={};function Qd(a,b){var c=a[0].toUpperCase()+a.slice(1),d="on"+c;c="top"+c;b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Od[a]=b;Pd[c]=b}
"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function(a){Qd(a,!0)});
"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function(a){Qd(a,!1)});
var Rd={eventTypes:Od,isInteractiveTopLevelEventType:function(a){a=Pd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Pd[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Gd(c))return null;case "topKeyDown":case "topKeyUp":a=Jd;break;case "topBlur":case "topFocus":a=Fd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=
ud;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=Kd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Ld;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Dd;break;case "topTransitionEnd":a=Md;break;case "topScroll":a=qd;break;case "topWheel":a=Nd;break;case "topCopy":case "topCut":case "topPaste":a=Ed;break;default:a=
N}b=a.getPooled(e,b,c,d);ib(b);return b}},Sd=Rd.isInteractiveTopLevelEventType,Td=[];function Ud(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Ua(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Qa(a.topLevelType,b,a.nativeEvent,hc(a.nativeEvent))}var Vd=!0;function Wd(a){Vd=!!a}
function W(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!1)}function Zd(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!0)}function Xd(a,b){bc(Yd,a,b)}
function Yd(a,b){if(Vd){var c=hc(b);c=Ua(c);null!==c&&"number"===typeof c.tag&&2!==xd(c)&&(c=null);if(Td.length){var d=Td.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{ec(Ud,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Td.length&&Td.push(a)}}}
var $d=Object.freeze({get _enabled(){return Vd},setEnabled:Wd,isEnabled:function(){return Vd},trapBubbledEvent:W,trapCapturedEvent:Zd,dispatchEvent:Yd});function ae(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var be={animationend:ae("Animation","AnimationEnd"),animationiteration:ae("Animation","AnimationIteration"),animationstart:ae("Animation","AnimationStart"),transitionend:ae("Transition","TransitionEnd")},ce={},de={};m.canUseDOM&&(de=document.createElement("div").style,"AnimationEvent"in window||(delete be.animationend.animation,delete be.animationiteration.animation,delete be.animationstart.animation),"TransitionEvent"in window||delete be.transitionend.transition);
function ee(a){if(ce[a])return ce[a];if(!be[a])return a;var b=be[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in de)return ce[a]=b[c];return a}
var fe={topAnimationEnd:ee("animationend"),topAnimationIteration:ee("animationiteration"),topAnimationStart:ee("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:ee("transitionend"),topWheel:"wheel"},ge={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",
topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},he={},ie=0,je="_reactListenersID"+(""+Math.random()).slice(2);function ke(a){Object.prototype.hasOwnProperty.call(a,je)||(a[je]=ie++,he[a[je]]={});return he[a[je]]}function le(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function me(a,b){var c=le(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=le(c)}}function ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var oe=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,pe={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},qe=null,re=null,se=null,te=!1;
function ue(a,b){if(te||null==qe||qe!==fa())return null;var c=qe;"selectionStart"in c&&ne(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return se&&ha(se,c)?null:(se=c,a=N.getPooled(pe.select,re,a,b),a.type="select",a.target=qe,ib(a),a)}
var ve={eventTypes:pe,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=ke(e);f=va.onSelect;for(var h=0;h<f.length;h++){var g=f[h];if(!e.hasOwnProperty(g)||!e[g]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Va(b):window;switch(a){case "topFocus":if(gc(e)||"true"===e.contentEditable)qe=e,re=b,se=null;break;case "topBlur":se=re=qe=null;break;case "topMouseDown":te=!0;break;case "topContextMenu":case "topMouseUp":return te=!1,ue(c,d);case "topSelectionChange":if(oe)break;
case "topKeyDown":case "topKeyUp":return ue(c,d)}return null}};Na.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Da=bb.getFiberCurrentPropsFromNode;Ea=bb.getInstanceFromNode;Fa=bb.getNodeFromInstance;Na.injectEventPluginsByName({SimpleEventPlugin:Rd,EnterLeaveEventPlugin:wd,ChangeEventPlugin:pd,SelectEventPlugin:ve,BeforeInputEventPlugin:Rb});
function xe(a,b,c,d){this.tag=a;this.key=c;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function ze(a,b,c){var d=a.alternate;null===d?(d=new xe(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Ae(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case sc:return Be(a.children,b,c,e);case wc:f=11;b|=3;break;case tc:f=11;b|=2;break;case pc:f=7;break;case qc:f=9;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case uc:f=13;break;case vc:f=12;break;case xc:f=14;break;default:if("number"===typeof d.tag)return b=d,b.pendingProps=a,b.expirationTime=c,
b;D("130",null==d?d:typeof d,"")}else D("130",null==d?d:typeof d,"")}b=new xe(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Be(a,b,c,d){a=new xe(10,a,d,b);a.expirationTime=c;return a}function Ce(a,b,c){a=new xe(6,a,null,b);a.expirationTime=c;return a}function De(a,b,c){b=new xe(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var Ee=null,Fe=null;
function Ge(a){return function(b){try{return a(b)}catch(c){}}}function He(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ee=Ge(function(a){return b.onCommitFiberRoot(c,a)});Fe=Ge(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ie(a){"function"===typeof Ee&&Ee(a)}function Je(a){"function"===typeof Fe&&Fe(a)}new Set;
function Ke(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1,capturedValues:null}}function Le(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}var Me=void 0,Ne=void 0;
function Oe(a){Me=Ne=null;var b=a.alternate,c=a.updateQueue;null===c&&(c=a.updateQueue=Ke(null));null!==b?(a=b.updateQueue,null===a&&(a=b.updateQueue=Ke(null))):a=null;Me=c;Ne=a!==c?a:null}function Pe(a,b){Oe(a);a=Me;var c=Ne;null===c?Le(a,b):null===a.last||null===c.last?(Le(a,b),Le(c,b)):(Le(a,b),c.last=b)}function Qe(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Re(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,capturedValues:c.capturedValues,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var h=!0,g=c.first,k=!1;null!==g;){var v=g.expirationTime;if(v>f){var l=c.expirationTime;if(0===l||l>v)c.expirationTime=v;k||(k=!0,c.baseState=a)}else{k||
(c.first=g.next,null===c.first&&(c.last=null));if(g.isReplace)a=Qe(g,d,a,e),h=!0;else if(v=Qe(g,d,a,e))a=h?A({},a,v):A(a,v),h=!1;g.isForced&&(c.hasForceUpdate=!0);null!==g.callback&&(v=c.callbackList,null===v&&(v=c.callbackList=[]),v.push(g));null!==g.capturedValue&&(v=c.capturedValues,null===v?c.capturedValues=[g.capturedValue]:v.push(g.capturedValue))}g=g.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||null!==c.capturedValues||(b.updateQueue=null);k||(c.baseState=a);
return a}function Se(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
function Te(a,b,c,d,e){function f(a,b,c,d,e,f){if(null===b||null!==a.updateQueue&&a.updateQueue.hasForceUpdate)return!0;var n=a.stateNode;a=a.type;return"function"===typeof n.shouldComponentUpdate?n.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ha(b,c)||!ha(d,e):!0}function h(a,b){b.updater=r;a.stateNode=b;b._reactInternalFiber=a}function g(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&
b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&r.enqueueReplaceState(b,b.state,null)}function k(a,b,c,d){a=a.type;if("function"===typeof a.getDerivedStateFromProps)return a.getDerivedStateFromProps.call(null,c,d)}var v=a.cacheContext,l=a.getMaskedContext,p=a.getUnmaskedContext,z=a.isContextConsumer,B=a.hasContextChanged,r={isMounted:yd,enqueueSetState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!1,isForced:!1,
capturedValue:null,next:null});b(a,f)},enqueueReplaceState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,capturedValue:null,next:null});b(a,f)},enqueueForceUpdate:function(a,d){a=a._reactInternalFiber;d=void 0===d?null:d;var e=c(a);Pe(a,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,capturedValue:null,next:null});b(a,e)}};return{adoptClassInstance:h,callGetDerivedStateFromProps:k,
constructClassInstance:function(a,b){var c=a.type,d=p(a),e=z(a),f=e?l(a,d):ka;c=new c(b,f);var n=null!==c.state&&void 0!==c.state?c.state:null;h(a,c);a.memoizedState=n;b=k(a,c,b,n);null!==b&&void 0!==b&&(a.memoizedState=A({},a.memoizedState,b));e&&v(a,d,f);return c},mountClassInstance:function(a,b){var c=a.type,d=a.alternate,e=a.stateNode,f=a.pendingProps,n=p(a);e.props=f;e.state=a.memoizedState;e.refs=ka;e.context=l(a,n);"function"===typeof c.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||
"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(c=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),c!==e.state&&r.enqueueReplaceState(e,e.state,null),c=a.updateQueue,null!==c&&(e.state=Re(d,a,c,e,f,b)));"function"===typeof e.componentDidMount&&(a.effectTag|=4)},resumeMountClassInstance:function(a,b){var c=a.type,n=a.stateNode;n.props=a.memoizedProps;n.state=
a.memoizedState;var h=a.memoizedProps,r=a.pendingProps,z=n.context,q=p(a);q=l(a,q);(c="function"===typeof c.getDerivedStateFromProps||"function"===typeof n.getSnapshotBeforeUpdate)||"function"!==typeof n.UNSAFE_componentWillReceiveProps&&"function"!==typeof n.componentWillReceiveProps||(h!==r||z!==q)&&g(a,n,r,q);z=a.memoizedState;b=null!==a.updateQueue?Re(null,a,a.updateQueue,n,r,b):z;var u=void 0;h!==r&&(u=k(a,n,r,b));if(null!==u&&void 0!==u){b=null===b||void 0===b?u:A({},b,u);var t=a.updateQueue;
null!==t&&(t.baseState=A({},t.baseState,u))}if(!(h!==r||z!==b||B()||null!==a.updateQueue&&a.updateQueue.hasForceUpdate))return"function"===typeof n.componentDidMount&&(a.effectTag|=4),!1;(h=f(a,h,r,z,b,q))?(c||"function"!==typeof n.UNSAFE_componentWillMount&&"function"!==typeof n.componentWillMount||("function"===typeof n.componentWillMount&&n.componentWillMount(),"function"===typeof n.UNSAFE_componentWillMount&&n.UNSAFE_componentWillMount()),"function"===typeof n.componentDidMount&&(a.effectTag|=
4)):("function"===typeof n.componentDidMount&&(a.effectTag|=4),d(a,r),e(a,b));n.props=r;n.state=b;n.context=q;return h},updateClassInstance:function(a,b,c){var n=b.type,x=b.stateNode;x.props=b.memoizedProps;x.state=b.memoizedState;var h=b.memoizedProps,r=b.pendingProps,q=x.context,u=p(b);u=l(b,u);(n="function"===typeof n.getDerivedStateFromProps||"function"===typeof x.getSnapshotBeforeUpdate)||"function"!==typeof x.UNSAFE_componentWillReceiveProps&&"function"!==typeof x.componentWillReceiveProps||
(h!==r||q!==u)&&g(b,x,r,u);q=b.memoizedState;c=null!==b.updateQueue?Re(a,b,b.updateQueue,x,r,c):q;var t=void 0;h!==r&&(t=k(b,x,r,c));if(null!==t&&void 0!==t){c=null===c||void 0===c?t:A({},c,t);var y=b.updateQueue;null!==y&&(y.baseState=A({},y.baseState,t))}if(!(h!==r||q!==c||B()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=2048),!1;(t=f(b,h,r,q,c,u))?(n||"function"!==typeof x.UNSAFE_componentWillUpdate&&"function"!==typeof x.componentWillUpdate||("function"===typeof x.componentWillUpdate&&x.componentWillUpdate(r,c,u),"function"===typeof x.UNSAFE_componentWillUpdate&&x.UNSAFE_componentWillUpdate(r,c,u)),"function"===typeof x.componentDidUpdate&&(b.effectTag|=4),"function"===typeof x.getSnapshotBeforeUpdate&&(b.effectTag|=2048)):("function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=2048),d(b,r),e(b,c));x.props=r;x.state=c;x.context=u;return t}}}var Ue=Array.isArray;
function Ve(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?D("110"):void 0,d=c.stateNode);d?void 0:D("147",a);var e=""+a;if(null!==b&&null!==b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ka?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?D("148"):void 0;c._owner?void 0:D("254",a)}return a}
function We(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Xe(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ze(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=Ce(c,a.mode,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ve(a,b,c),d["return"]=a,d;d=Ae(c,a.mode,d);d.ref=Ve(a,b,c);d["return"]=a;return d}function v(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
De(c,a.mode,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function l(a,b,c,d,f){if(null===b||10!==b.tag)return b=Be(c,a.mode,d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ce(""+b,a.mode,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case oc:return c=Ae(b,a.mode,c),c.ref=Ve(a,null,b),c["return"]=a,c;case rc:return b=De(b,a.mode,c),b["return"]=a,b}if(Ue(b)||zc(b))return b=Be(b,
a.mode,c,null),b["return"]=a,b;We(a,b)}return null}function z(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case oc:return c.key===e?c.type===sc?l(a,b,c.props.children,d,e):k(a,b,c,d):null;case rc:return c.key===e?v(a,b,c,d):null}if(Ue(c)||zc(c))return null!==e?null:l(a,b,c,d,null);We(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case oc:return a=a.get(null===d.key?c:d.key)||null,d.type===sc?l(b,a,d.props.children,e,d.key):k(b,a,d,e);case rc:return a=a.get(null===d.key?c:d.key)||null,v(b,a,d,e)}if(Ue(d)||zc(d))return a=a.get(c)||null,l(b,a,d,e,null);We(b,d)}return null}function r(e,l,g,h){for(var r=null,k=null,q=l,u=l=0,t=null;null!==q&&u<g.length;u++){q.index>u?(t=q,q=null):t=q.sibling;var n=z(e,q,g[u],h);if(null===n){null===q&&(q=t);break}a&&q&&null===
n.alternate&&b(e,q);l=f(n,l,u);null===k?r=n:k.sibling=n;k=n;q=t}if(u===g.length)return c(e,q),r;if(null===q){for(;u<g.length;u++)if(q=p(e,g[u],h))l=f(q,l,u),null===k?r=q:k.sibling=q,k=q;return r}for(q=d(e,q);u<g.length;u++)if(t=B(q,e,u,g[u],h)){if(a&&null!==t.alternate)q["delete"](null===t.key?u:t.key);l=f(t,l,u);null===k?r=t:k.sibling=t;k=t}a&&q.forEach(function(a){return b(e,a)});return r}function Q(e,l,g,h){var r=zc(g);"function"!==typeof r?D("150"):void 0;g=r.call(g);null==g?D("151"):void 0;for(var k=
r=null,q=l,u=l=0,t=null,n=g.next();null!==q&&!n.done;u++,n=g.next()){q.index>u?(t=q,q=null):t=q.sibling;var H=z(e,q,n.value,h);if(null===H){q||(q=t);break}a&&q&&null===H.alternate&&b(e,q);l=f(H,l,u);null===k?r=H:k.sibling=H;k=H;q=t}if(n.done)return c(e,q),r;if(null===q){for(;!n.done;u++,n=g.next())n=p(e,n.value,h),null!==n&&(l=f(n,l,u),null===k?r=n:k.sibling=n,k=n);return r}for(q=d(e,q);!n.done;u++,n=g.next())if(n=B(q,e,u,n.value,h),null!==n){if(a&&null!==n.alternate)q["delete"](null===n.key?u:n.key);
l=f(n,l,u);null===k?r=n:k.sibling=n;k=n}a&&q.forEach(function(a){return b(e,a)});return r}return function(a,d,f,l){"object"===typeof f&&null!==f&&f.type===sc&&null===f.key&&(f=f.props.children);var g="object"===typeof f&&null!==f;if(g)switch(f.$$typeof){case oc:a:{var k=f.key;for(g=d;null!==g;){if(g.key===k)if(10===g.tag?f.type===sc:g.type===f.type){c(a,g.sibling);d=e(g,f.type===sc?f.props.children:f.props,l);d.ref=Ve(a,g,f);d["return"]=a;a=d;break a}else{c(a,g);break}else b(a,g);g=g.sibling}f.type===
sc?(d=Be(f.props.children,a.mode,l,f.key),d["return"]=a,a=d):(l=Ae(f,a.mode,l),l.ref=Ve(a,d,f),l["return"]=a,a=l)}return h(a);case rc:a:{for(g=f.key;null!==d;){if(d.key===g)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],l);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=De(f,a.mode,l);d["return"]=a;a=d}return h(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&
6===d.tag?(c(a,d.sibling),d=e(d,f,l),d["return"]=a,a=d):(c(a,d),d=Ce(f,a.mode,l),d["return"]=a,a=d),h(a);if(Ue(f))return r(a,d,f,l);if(zc(f))return Q(a,d,f,l);g&&We(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:l=a.type,D("152",l.displayName||l.name||"Component")}return c(a,d)}}var Ye=Xe(!0),Ze=Xe(!1);
function $e(a,b,c,d,e,f,h){function g(a,b,c){k(a,b,c,b.expirationTime)}function k(a,b,c,d){b.child=null===a?Ze(b,null,c,d):Ye(b,a.child,c,d)}function v(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function l(a,b,c,d,e,f){v(a,b);if(!c&&!e)return d&&y(b,!1),r(a,b);c=b.stateNode;nc.current=b;var l=e?null:c.render();b.effectTag|=1;e&&(k(a,b,null,f),b.child=null);k(a,b,l,f);b.memoizedState=c.state;b.memoizedProps=c.props;d&&y(b,!0);return b.child}function p(a){var b=a.stateNode;
b.pendingContext?t(a,b.pendingContext,b.pendingContext!==b.context):b.context&&t(a,b.context,!1);Y(a,b.containerInfo)}function z(a,b,c,d){var e=a.child;for(null!==e&&(e["return"]=a);null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var l=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==l&&(0===l.expirationTime||l.expirationTime>d)&&(l.expirationTime=d);else if(null!==l&&(0===l.expirationTime||l.expirationTime>d))l.expirationTime=
d;else break;f=f["return"]}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=e.child}if(null!==f)f["return"]=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){f=e;break}f=f["return"]}e=f}}function B(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps;if(!q()&&f===e)return b.stateNode=0,G(b),r(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children)return b.stateNode=0,G(b),
r(a,b);l=0}else{var h=f.value;if(h===l&&(0!==h||1/h===1/l)||h!==h&&l!==l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,l):1073741823,l|=0,0===l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b)}else z(b,d,l,c)}b.stateNode=l;G(b);g(a,b,e.children);return b.child}function r(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ze(a,a.pendingProps,a.expirationTime);
b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ze(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}var Q=a.shouldSetTextContent,n=a.shouldDeprioritizeSubtree,x=b.pushHostContext,Y=b.pushHostContainer,G=d.pushProvider,R=c.getMaskedContext,S=c.getUnmaskedContext,q=c.hasContextChanged,u=c.pushContextProvider,t=c.pushTopLevelContextObject,y=c.invalidateContextProvider,H=e.enterHydrationState,Wa=e.resetHydrationState,Cb=e.tryToClaimNextHydratableInstance;
a=Te(c,f,h,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var Jc=a.adoptClassInstance,Kc=a.callGetDerivedStateFromProps,Lc=a.constructClassInstance,Db=a.mountClassInstance,Mc=a.resumeMountClassInstance,Eb=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:p(b);break;case 2:u(b);break;case 4:Y(b,b.stateNode.containerInfo);break;case 13:G(b)}return null}switch(b.tag){case 0:null!==a?D("155"):void 0;var d=b.type,
e=b.pendingProps,f=S(b);f=R(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,"function"===typeof f.getDerivedStateFromProps&&(e=Kc(b,d,e,b.memoizedState),null!==e&&void 0!==e&&(b.memoizedState=A({},b.memoizedState,e))),e=u(b),Jc(b,d),Db(b,c),a=l(a,b,!0,e,!1,c)):(b.tag=1,g(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,q()||
b.memoizedProps!==c?(d=S(b),d=R(b,d),e=e(c,d),b.effectTag|=1,g(a,b,e),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 2:e=u(b);null===a?null===b.stateNode?(Lc(b,b.pendingProps),Db(b,c),d=!0):d=Mc(b,c):d=Eb(a,b,c);f=!1;var h=b.updateQueue;null!==h&&null!==h.capturedValues&&(f=d=!0);return l(a,b,d,e,f,c);case 3:a:if(p(b),d=b.updateQueue,null!==d){f=b.memoizedState;e=Re(a,b,d,null,null,c);b.memoizedState=e;d=b.updateQueue;if(null!==d&&null!==d.capturedValues)d=null;else if(f===e){Wa();a=r(a,b);break a}else d=
e.element;f=b.stateNode;(null===a||null===a.child)&&f.hydrate&&H(b)?(b.effectTag|=2,b.child=Ze(b,null,d,c)):(Wa(),g(a,b,d));b.memoizedState=e;a=b.child}else Wa(),a=r(a,b);return a;case 5:a:{x(b);null===a&&Cb(b);e=b.type;h=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!q()&&h===d){if(h=b.mode&1&&n(e,d))b.expirationTime=1073741823;if(!h||1073741823!==c){a=r(a,b);break a}}h=d.children;Q(e,d)?h=null:f&&Q(e,f)&&(b.effectTag|=16);v(a,b);1073741823!==c&&b.mode&1&&n(e,d)?(b.expirationTime=
1073741823,b.memoizedProps=d,a=null):(g(a,b,h),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Cb(b),b.memoizedProps=b.pendingProps,null;case 8:b.tag=7;case 7:return e=b.pendingProps,q()||b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?Ze(b,b.stateNode,d,c):Ye(b,a.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:return Y(b,b.stateNode.containerInfo),e=b.pendingProps,q()||b.memoizedProps!==e?(null===a?b.child=Ye(b,null,e,c):g(a,b,e),b.memoizedProps=
e,a=b.child):a=r(a,b),a;case 14:return c=b.type.render,c=c(b.pendingProps,b.ref),g(a,b,c),b.memoizedProps=c,b.child;case 10:return c=b.pendingProps,q()||b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 11:return c=b.pendingProps.children,q()||null!==c&&b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 13:return B(a,b,c);case 12:a:{d=b.type;f=b.pendingProps;h=b.memoizedProps;e=d._currentValue;var t=d._changedBits;if(q()||0!==t||h!==f){b.memoizedProps=
f;var k=f.unstable_observedBits;if(void 0===k||null===k)k=1073741823;b.stateNode=k;if(0!==(t&k))z(b,d,t,c);else if(h===f){a=r(a,b);break a}c=f.children;c=c(e);g(a,b,c);a=b.child}else a=r(a,b)}return a;default:D("156")}}}}
function af(a,b,c,d,e){function f(a){a.effectTag|=4}var h=a.createInstance,g=a.createTextInstance,k=a.appendInitialChild,v=a.finalizeInitialChildren,l=a.prepareUpdate,p=a.persistence,z=b.getRootHostContainer,B=b.popHostContext,r=b.getHostContext,Q=b.popHostContainer,n=c.popContextProvider,x=c.popTopLevelContextObject,Y=d.popProvider,G=e.prepareToHydrateHostInstance,R=e.prepareToHydrateHostTextInstance,S=e.popHydrationState,q=void 0,u=void 0,t=void 0;a.mutation?(q=function(){},u=function(a,b,c){(b.updateQueue=
c)&&f(b)},t=function(a,b,c,d){c!==d&&f(b)}):p?D("235"):D("236");return{completeWork:function(a,b,c){var d=b.pendingProps;switch(b.tag){case 1:return null;case 2:return n(b),a=b.stateNode,d=b.updateQueue,null!==d&&null!==d.capturedValues&&(b.effectTag&=-65,"function"===typeof a.componentDidCatch?b.effectTag|=256:d.capturedValues=null),null;case 3:Q(b);x(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)S(b),b.effectTag&=-3;q(b);a=b.updateQueue;
null!==a&&null!==a.capturedValues&&(b.effectTag|=256);return null;case 5:B(b);c=z();var e=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,H=b.stateNode,y=r();H=l(H,e,p,d,c,y);u(a,b,H,e,p,d,c,y);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!d)return null===b.stateNode?D("166"):void 0,null;a=r();if(S(b))G(b,c,a)&&f(b);else{p=h(e,d,c,a,b);a:for(y=b.child;null!==y;){if(5===y.tag||6===y.tag)k(p,y.stateNode);else if(4!==y.tag&&null!==y.child){y.child["return"]=y;y=y.child;continue}if(y===b)break;
for(;null===y.sibling;){if(null===y["return"]||y["return"]===b)break a;y=y["return"]}y.sibling["return"]=y["return"];y=y.sibling}v(p,e,d,c,a)&&f(b);b.stateNode=p}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)t(a,b,a.memoizedProps,d);else{if("string"!==typeof d)return null===b.stateNode?D("166"):void 0,null;a=z();c=r();S(b)?R(b)&&f(b):b.stateNode=g(d,a,c,b)}return null;case 7:(d=b.memoizedProps)?void 0:D("165");b.tag=8;e=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==
p;){if(5===p.tag||6===p.tag||4===p.tag)D("247");else if(9===p.tag)e.push(p.pendingProps.value);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=d.handler;d=p(d.props,e);b.child=Ye(b,null!==a?a.child:null,d,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 14:return null;case 10:return null;case 11:return null;case 4:return Q(b),q(b),null;
case 13:return Y(b),null;case 12:return null;case 0:D("167");default:D("156")}}}}
function bf(a,b,c,d,e){var f=a.popHostContainer,h=a.popHostContext,g=b.popContextProvider,k=b.popTopLevelContextObject,v=c.popProvider;return{throwException:function(a,b,c){b.effectTag|=512;b.firstEffect=b.lastEffect=null;b={value:c,source:b,stack:Bc(b)};do{switch(a.tag){case 3:Oe(a);a.updateQueue.capturedValues=[b];a.effectTag|=1024;return;case 2:if(c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&!e(c)){Oe(a);c=a.updateQueue;var d=c.capturedValues;null===d?
c.capturedValues=[b]:d.push(b);a.effectTag|=1024;return}}a=a["return"]}while(null!==a)},unwindWork:function(a){switch(a.tag){case 2:g(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return f(a),k(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return h(a),null;case 4:return f(a),null;case 13:return v(a),null;default:return null}},unwindInterruptedWork:function(a){switch(a.tag){case 2:g(a);break;case 3:f(a);k(a);break;case 5:h(a);break;case 4:f(a);break;case 13:v(a)}}}}
function cf(a,b){var c=b.source;null===b.stack&&Bc(c);null!==c&&Ac(c);b=b.value;null!==a&&2===a.tag&&Ac(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}
function df(a,b,c,d,e){function f(a){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(t){b(a,t)}else c.current=null}function h(a){"function"===typeof Je&&Je(a);switch(a.tag){case 2:f(a);var c=a.stateNode;if("function"===typeof c.componentWillUnmount)try{c.props=a.memoizedProps,c.state=a.memoizedState,c.componentWillUnmount()}catch(t){b(a,t)}break;case 5:f(a);break;case 7:g(a.stateNode);break;case 4:p&&v(a)}}function g(a){for(var b=a;;)if(h(b),null===b.child||p&&4===b.tag){if(b===
a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function k(a){return 5===a.tag||3===a.tag||4===a.tag}function v(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c["return"]}c=!0}if(5===
b.tag||6===b.tag)g(b),e?S(d,b.stateNode):R(d,b.stateNode);else if(4===b.tag?d=b.stateNode.containerInfo:h(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var l=a.getPublicInstance,p=a.mutation;a=a.persistence;p||(a?D("235"):D("236"));var z=p.commitMount,B=p.commitUpdate,r=p.resetTextContent,Q=p.commitTextUpdate,n=p.appendChild,
x=p.appendChildToContainer,Y=p.insertBefore,G=p.insertInContainerBefore,R=p.removeChild,S=p.removeChildFromContainer;return{commitBeforeMutationLifeCycles:function(a,b){switch(b.tag){case 2:if(b.effectTag&2048&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;a.props=b.memoizedProps;a.state=b.memoizedState;b=a.getSnapshotBeforeUpdate(c,d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:break;default:D("163")}},commitResetTextContent:function(a){r(a.stateNode)},
commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(k(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(r(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||k(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==
c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):Y(b,e.stateNode,c):d?x(b,e.stateNode):n(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){v(a);
a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&B(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;Q(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b,c){switch(c.tag){case 2:a=
c.stateNode;if(c.effectTag&4)if(null===b)a.props=c.memoizedProps,a.state=c.memoizedState,a.componentDidMount();else{var d=b.memoizedProps;b=b.memoizedState;a.props=c.memoizedProps;a.state=c.memoizedState;a.componentDidUpdate(d,b,a.__reactInternalSnapshotBeforeUpdate)}c=c.updateQueue;null!==c&&Se(c,a);break;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=l(c.child.stateNode);break;case 2:a=c.child.stateNode}Se(b,a)}break;case 5:a=c.stateNode;null===b&&c.effectTag&
4&&z(a,c.type,c.memoizedProps,c);break;case 6:break;case 4:break;default:D("163")}},commitErrorLogging:function(a,b){switch(a.tag){case 2:var c=a.type;b=a.stateNode;var d=a.updateQueue;null===d||null===d.capturedValues?D("264"):void 0;var f=d.capturedValues;d.capturedValues=null;"function"!==typeof c.getDerivedStateFromCatch&&e(b);b.props=a.memoizedProps;b.state=a.memoizedState;for(c=0;c<f.length;c++){d=f[c];var l=d.value,g=d.stack;cf(a,d);b.componentDidCatch(l,{componentStack:null!==g?g:""})}break;
case 3:c=a.updateQueue;null===c||null===c.capturedValues?D("264"):void 0;f=c.capturedValues;c.capturedValues=null;for(c=0;c<f.length;c++)d=f[c],cf(a,d),b(d.value);break;default:D("265")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=l(c);break;default:a=c}"function"===typeof b?b(a):b.current=a}},commitDetachRef:function(a){a=a.ref;null!==a&&("function"===typeof a?a(null):a.current=null)}}}var ef={};
function ff(a,b){function c(a){a===ef?D("174"):void 0;return a}var d=a.getChildHostContext,e=a.getRootHostContext;a=b.createCursor;var f=b.push,h=b.pop,g=a(ef),k=a(ef),v=a(ef);return{getHostContext:function(){return c(g.current)},getRootHostContainer:function(){return c(v.current)},popHostContainer:function(a){h(g,a);h(k,a);h(v,a)},popHostContext:function(a){k.current===a&&(h(g,a),h(k,a))},pushHostContainer:function(a,b){f(v,b,a);f(k,a,a);f(g,ef,a);b=e(b);h(g,a);f(g,b,a)},pushHostContext:function(a){var b=
c(v.current),e=c(g.current);b=d(e,a.type,b);e!==b&&(f(k,a,a),f(g,b,a))}}}
function gf(a){function b(a,b){var c=new xe(5,null,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=h(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];p=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,h=a.canHydrateTextInstance,g=a.getNextHydratableSibling,k=a.getFirstHydratableChild,v=a.hydrateInstance,l=a.hydrateTextInstance,p=null,z=null,B=!1;return{enterHydrationState:function(a){z=
k(a.stateNode.containerInfo);p=a;return B=!0},resetHydrationState:function(){z=p=null;B=!1},tryToClaimNextHydratableInstance:function(a){if(B){var d=z;if(d){if(!c(a,d)){d=g(d);if(!d||!c(a,d)){a.effectTag|=2;B=!1;p=a;return}b(p,z)}p=a;z=k(d)}else a.effectTag|=2,B=!1,p=a}},prepareToHydrateHostInstance:function(a,b,c){b=v(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return l(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
p)return!1;if(!B)return d(a),B=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=z;c;)b(a,c),c=g(c);d(a);z=p?g(a.stateNode):null;return!0}}}
function hf(a){function b(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function c(a){return 2===a.tag&&null!=a.type.childContextTypes}function d(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",Ac(a)||"Unknown",e);return A({},b,c)}var e=a.createCursor,f=a.push,h=a.pop,g=e(ka),k=e(!1),v=ka;return{getUnmaskedContext:function(a){return c(a)?
v:g.current},cacheContext:b,getMaskedContext:function(a,c){var d=a.type.contextTypes;if(!d)return ka;var e=a.stateNode;if(e&&e.__reactInternalMemoizedUnmaskedChildContext===c)return e.__reactInternalMemoizedMaskedChildContext;var f={},g;for(g in d)f[g]=c[g];e&&b(a,c,f);return f},hasContextChanged:function(){return k.current},isContextConsumer:function(a){return 2===a.tag&&null!=a.type.contextTypes},isContextProvider:c,popContextProvider:function(a){c(a)&&(h(k,a),h(g,a))},popTopLevelContextObject:function(a){h(k,
a);h(g,a)},pushTopLevelContextObject:function(a,b,c){null!=g.cursor?D("168"):void 0;f(g,b,a);f(k,c,a)},processChildContext:d,pushContextProvider:function(a){if(!c(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ka;v=g.current;f(g,b,a);f(k,k.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var e=d(a,v);c.__reactInternalMemoizedMergedChildContext=e;h(k,a);h(g,a);f(g,e,a)}else h(k,a);f(k,b,a)},findCurrentUnmaskedContext:function(a){for(2!==
xd(a)||2!==a.tag?D("170"):void 0;3!==a.tag;){if(c(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:D("171")}return a.stateNode.context}}}
function jf(a){var b=a.createCursor,c=a.push,d=a.pop,e=b(null),f=b(null),h=b(0);return{pushProvider:function(a){var b=a.type._context;c(h,b._changedBits,a);c(f,b._currentValue,a);c(e,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode},popProvider:function(a){var b=h.current,c=f.current;d(e,a);d(f,a);d(h,a);a=a.type._context;a._currentValue=c;a._changedBits=b}}}
function kf(){var a=[],b=-1;return{createCursor:function(a){return{current:a}},isEmpty:function(){return-1===b},pop:function(c){0>b||(c.current=a[b],a[b]=null,b--)},push:function(c,d){b++;a[b]=c.current;c.current=d},checkThatStackIsEmpty:function(){},resetStackAfterFatalErrorInDev:function(){}}}
function lf(a){function b(){if(null!==I)for(var a=I["return"];null!==a;)Lc(a),a=a["return"];Ya=null;Z=0;I=null;Nc=!1}function c(a){return null!==ya&&ya.has(a)}function d(a){for(;;){var b=a.alternate,c=a["return"],d=a.sibling;if(0===(a.effectTag&512)){b=Cb(b,a,Z);var e=a;if(1073741823===Z||1073741823!==e.expirationTime){b:switch(e.tag){case 3:case 2:var f=e.updateQueue;f=null===f?0:f.expirationTime;break b;default:f=0}for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=
g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Nc=!0;break}}else{a=Kc(a);if(null!==a)return a.effectTag&=2559,a;null!==c&&(c.firstEffect=c.lastEffect=
null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}function e(a){var b=Wa(a.alternate,a,Z);null===b&&(b=d(a));nc.current=null;return b}function f(a,c,f){ca?D("243"):void 0;ca=!0;if(c!==Z||a!==Ya||null===I)b(),Ya=a,Z=c,I=ze(Ya.current,null,Z),a.pendingCommitExpirationTime=0;var g=!1;do{try{if(f)for(;null!==I&&!S();)I=e(I);else for(;null!==I;)I=e(I)}catch(Oc){if(null===I){g=!0;q(Oc);break}f=I;var h=f["return"];if(null===h){g=!0;q(Oc);break}Jc(h,f,Oc);I=d(f)}break}while(1);
ca=!1;if(g||null!==I)return null;if(Nc)return a.pendingCommitExpirationTime=c,a.current.alternate;D("262")}function h(a,b,c,d){a={value:c,source:a,stack:Bc(a)};Pe(b,{expirationTime:d,partialState:null,callback:null,isReplace:!1,isForced:!1,capturedValue:a,next:null});v(b,d)}function g(a,b){a:{ca&&!Za?D("263"):void 0;for(var d=a["return"];null!==d;){switch(d.tag){case 2:var e=d.stateNode;if("function"===typeof d.type.getDerivedStateFromCatch||"function"===typeof e.componentDidCatch&&!c(e)){h(a,d,b,
1);a=void 0;break a}break;case 3:h(a,d,b,1);a=void 0;break a}d=d["return"]}3===a.tag&&h(a,a,b,1);a=void 0}return a}function k(a){a=0!==ia?ia:ca?Za?1:Z:a.mode&1?za?10*(((l()+15)/10|0)+1):25*(((l()+500)/25|0)+1):1;za&&(0===da||a>da)&&(da=a);return a}function v(a,c){a:{for(;null!==a;){if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>c)&&(a.alternate.expirationTime=c);if(null===a["return"])if(3===a.tag){var d=
a.stateNode;!ca&&0!==Z&&c<Z&&b();ca&&!Za&&Ya===d||B(d,c);Fb>xg&&D("185")}else{c=void 0;break a}a=a["return"]}c=void 0}return c}function l(){ye=Ic()-Pc;return yg=(ye/10|0)+2}function p(a,b,c,d,e){var f=ia;ia=1;try{return a(b,c,d,e)}finally{ia=f}}function z(a){if(0!==Gb){if(a>Gb)return;mg(Qc)}var b=Ic()-Pc;Gb=a;Qc=lg(Q,{timeout:10*(a-2)-b})}function B(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===K?(la=K=a,a.nextScheduledRoot=a):(K=K.nextScheduledRoot=a,K.nextScheduledRoot=la);
else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}T||(J?Hb&&(aa=a,P=1,G(a,1,!1)):1===b?n():z(b))}function r(){var a=0,b=null;if(null!==K)for(var c=K,d=la;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===K?D("244"):void 0;if(d===d.nextScheduledRoot){la=K=d.nextScheduledRoot=null;break}else if(d===la)la=e=d.nextScheduledRoot,K.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===K){K=c;K.nextScheduledRoot=la;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=
d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===K)break;c=d;d=d.nextScheduledRoot}}c=aa;null!==c&&c===b&&1===a?Fb++:Fb=0;aa=b;P=a}function Q(a){x(0,!0,a)}function n(){x(1,!1,null)}function x(a,b,c){$a=c;r();if(b)for(;null!==aa&&0!==P&&(0===a||a>=P)&&(!Ib||l()>=P);)G(aa,P,!Ib),r();else for(;null!==aa&&0!==P&&(0===a||a>=P);)G(aa,P,!1),r();null!==$a&&(Gb=0,Qc=-1);0!==P&&z(P);$a=null;Ib=!1;Y()}function Y(){Fb=0;if(null!==Aa){var a=Aa;Aa=null;for(var b=
0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(wg){Ba||(Ba=!0,Jb=wg)}}}if(Ba)throw a=Jb,Jb=null,Ba=!1,a;}function G(a,b,c){T?D("245"):void 0;T=!0;c?(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!0),null!==c&&(S()?a.finishedWork=c:R(a,c,b)))):(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!1),null!==c&&R(a,c,b)));T=!1}function R(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Aa?Aa=[d]:Aa.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=
0;return}a.finishedWork=null;Za=ca=!0;c=b.stateNode;c.current===b?D("177"):void 0;d=c.pendingCommitExpirationTime;0===d?D("261"):void 0;c.pendingCommitExpirationTime=0;var e=l();nc.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var f=b.firstEffect}else f=b;else f=b.firstEffect;zg(c.containerInfo);for(w=f;null!==w;){var h=!1,k=void 0;try{for(;null!==w;)w.effectTag&2048&&Db(w.alternate,w),w=w.nextEffect}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==
w&&(w=w.nextEffect))}for(w=f;null!==w;){h=!1;k=void 0;try{for(;null!==w;){var p=w.effectTag;p&16&&Mc(w);if(p&128){var n=w.alternate;null!==n&&kg(n)}switch(p&14){case 2:Eb(w);w.effectTag&=-3;break;case 6:Eb(w);w.effectTag&=-3;we(w.alternate,w);break;case 4:we(w.alternate,w);break;case 8:gg(w)}w=w.nextEffect}}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==w&&(w=w.nextEffect))}Ag(c.containerInfo);c.current=b;for(w=f;null!==w;){p=!1;n=void 0;try{for(f=c,h=e,k=d;null!==w;){var r=w.effectTag;
r&36&&hg(f,w.alternate,w,h,k);r&256&&ig(w,q);r&128&&jg(w);var t=w.nextEffect;w.nextEffect=null;w=t}}catch(ab){p=!0,n=ab}p&&(null===w?D("178"):void 0,g(w,n),null!==w&&(w=w.nextEffect))}ca=Za=!1;"function"===typeof Ie&&Ie(b.stateNode);b=c.current.expirationTime;0===b&&(ya=null);a.remainingExpirationTime=b}function S(){return null===$a||$a.timeRemaining()>Bg?!1:Ib=!0}function q(a){null===aa?D("246"):void 0;aa.remainingExpirationTime=0;Ba||(Ba=!0,Jb=a)}var u=kf(),t=ff(a,u),y=hf(u);u=jf(u);var H=gf(a),
Wa=$e(a,t,y,u,H,v,k).beginWork,Cb=af(a,t,y,u,H).completeWork;t=bf(t,y,u,v,c);var Jc=t.throwException,Kc=t.unwindWork,Lc=t.unwindInterruptedWork;t=df(a,g,v,k,function(a){null===ya?ya=new Set([a]):ya.add(a)},l);var Db=t.commitBeforeMutationLifeCycles,Mc=t.commitResetTextContent,Eb=t.commitPlacement,gg=t.commitDeletion,we=t.commitWork,hg=t.commitLifeCycles,ig=t.commitErrorLogging,jg=t.commitAttachRef,kg=t.commitDetachRef,Ic=a.now,lg=a.scheduleDeferredCallback,mg=a.cancelDeferredCallback,zg=a.prepareForCommit,
Ag=a.resetAfterCommit,Pc=Ic(),yg=2,ye=Pc,Rc=0,ia=0,ca=!1,I=null,Ya=null,Z=0,w=null,Za=!1,Nc=!1,ya=null,la=null,K=null,Gb=0,Qc=-1,T=!1,aa=null,P=0,da=0,Ib=!1,Ba=!1,Jb=null,$a=null,J=!1,Hb=!1,za=!1,Aa=null,xg=1E3,Fb=0,Bg=1;return{recalculateCurrentTime:l,computeExpirationForFiber:k,scheduleWork:v,requestWork:B,flushRoot:function(a,b){T?D("253"):void 0;aa=a;P=b;G(a,b,!1);n();Y()},batchedUpdates:function(a,b){var c=J;J=!0;try{return a(b)}finally{(J=c)||T||n()}},unbatchedUpdates:function(a,b){if(J&&!Hb){Hb=
!0;try{return a(b)}finally{Hb=!1}}return a(b)},flushSync:function(a,b){T?D("187"):void 0;var c=J;J=!0;try{return p(a,b)}finally{J=c,n()}},flushControlled:function(a){var b=J;J=!0;try{p(a)}finally{(J=b)||T||x(1,!1,null)}},deferredUpdates:function(a){var b=ia;ia=25*(((l()+500)/25|0)+1);try{return a()}finally{ia=b}},syncUpdates:p,interactiveUpdates:function(a,b,c){if(za)return a(b,c);J||T||0===da||(x(da,!1,null),da=0);var d=za,e=J;J=za=!0;try{return a(b,c)}finally{za=d,(J=e)||T||n()}},flushInteractiveUpdates:function(){T||
0===da||(x(da,!1,null),da=0)},computeUniqueAsyncExpiration:function(){var a=25*(((l()+500)/25|0)+1);a<=Rc&&(a=Rc+1);return Rc=a},legacyContext:y}}
function mf(a){function b(a,b,c,d,e,h){d=b.current;if(c){c=c._reactInternalFiber;var l=g(c);c=k(c)?v(c,l):l}else c=ka;null===b.context?b.context=c:b.pendingContext=c;b=h;Pe(d,{expirationTime:e,partialState:{element:a},callback:void 0===b?null:b,isReplace:!1,isForced:!1,capturedValue:null,next:null});f(d,e);return e}var c=a.getPublicInstance;a=lf(a);var d=a.recalculateCurrentTime,e=a.computeExpirationForFiber,f=a.scheduleWork,h=a.legacyContext,g=h.findCurrentUnmaskedContext,k=h.isContextProvider,v=
h.processChildContext;return{createContainer:function(a,b,c){b=new xe(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,c,f,h){var g=c.current,k=d();g=e(g);return b(a,c,f,k,g,h)},updateContainerAtExpirationTime:function(a,c,e,f,g){var h=d();return b(a,c,e,h,f,g)},flushRoot:a.flushRoot,
requestWork:a.requestWork,computeUniqueAsyncExpiration:a.computeUniqueAsyncExpiration,batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,syncUpdates:a.syncUpdates,interactiveUpdates:a.interactiveUpdates,flushInteractiveUpdates:a.flushInteractiveUpdates,flushControlled:a.flushControlled,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},
findHostInstance:function(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?D("188"):D("268",Object.keys(a)));a=Bd(b);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=Cd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return He(A({},a,{findHostInstanceByFiber:function(a){a=Bd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}}}
var nf=Object.freeze({default:mf}),of=nf&&mf||nf,pf=of["default"]?of["default"]:of;function qf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:rc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var rf="object"===typeof performance&&"function"===typeof performance.now,sf=void 0;sf=rf?function(){return performance.now()}:function(){return Date.now()};var tf=void 0,uf=void 0;
if(m.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var vf=null,wf=!1,xf=-1,yf=!1,zf=0,Af=33,Bf=33,Cf=void 0;Cf=rf?{didTimeout:!1,timeRemaining:function(){var a=zf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=zf-Date.now();return 0<a?a:0}};var Df="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Df){wf=!1;a=sf();if(0>=zf-a)if(-1!==
xf&&xf<=a)Cf.didTimeout=!0;else{yf||(yf=!0,requestAnimationFrame(Ef));return}else Cf.didTimeout=!1;xf=-1;a=vf;vf=null;null!==a&&a(Cf)}},!1);var Ef=function(a){yf=!1;var b=a-zf+Bf;b<Bf&&Af<Bf?(8>b&&(b=8),Bf=b<Af?Af:b):Af=b;zf=a+Bf;wf||(wf=!0,window.postMessage(Df,"*"))};tf=function(a,b){vf=a;null!=b&&"number"===typeof b.timeout&&(xf=sf()+b.timeout);yf||(yf=!0,requestAnimationFrame(Ef));return 0};uf=function(){vf=null;wf=!1;xf=-1}}else tf=window.requestIdleCallback,uf=window.cancelIdleCallback;else tf=
function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})})},uf=function(a){clearTimeout(a)};function Ff(a){var b="";ea.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function Gf(a,b){a=A({children:void 0},b);if(b=Ff(b.children))a.children=b;return a}
function Hf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function If(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Jf(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Kf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Lf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Mf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Nf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Of(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Pf(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Of(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Qf=void 0,Rf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Nf.svg||"innerHTML"in a)a.innerHTML=b;else{Qf=Qf||document.createElement("div");Qf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Qf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Sf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Tf={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Uf=["Webkit","ms","Moz","O"];Object.keys(Tf).forEach(function(a){Uf.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Tf[b]=Tf[a]})});
function Vf(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Tf.hasOwnProperty(e)&&Tf[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Wf=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Xf(a,b,c){b&&(Wf[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
function Yf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Zf=C.thatReturns("");
function $f(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=ke(a);b=va[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?Zd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(Zd("topFocus","focus",a),Zd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(ic("cancel",!0)&&Zd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(ic("close",!0)&&Zd("topClose","close",a),c.topClose=!0):fe.hasOwnProperty(e)&&W(e,fe[e],a),c[e]=!0)}}
function ag(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Nf.html&&(d=Of(a));d===Nf.html?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function bg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function cg(a,b,c,d){var e=Yf(b,c);switch(b){case "iframe":case "object":W("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);f=c;break;case "source":W("topError","error",a);f=c;break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);f=c;break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);f=c;break;case "details":W("topToggle","toggle",a);f=c;break;case "input":Wc(a,c);f=Vc(a,c);W("topInvalid",
"invalid",a);$f(d,"onChange");break;case "option":f=Gf(a,c);break;case "select":If(a,c);f=A({},c,{value:void 0});W("topInvalid","invalid",a);$f(d,"onChange");break;case "textarea":Kf(a,c);f=Jf(a,c);W("topInvalid","invalid",a);$f(d,"onChange");break;default:f=c}Xf(b,f,Zf);var h=f,g;for(g in h)if(h.hasOwnProperty(g)){var k=h[g];"style"===g?Vf(a,k,Zf):"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,null!=k&&Rf(a,k)):"children"===g?"string"===typeof k?("textarea"!==b||""!==k)&&Sf(a,k):"number"===typeof k&&
Sf(a,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(ua.hasOwnProperty(g)?null!=k&&$f(d,g):null!=k&&Uc(a,g,k,e))}switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Hf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Hf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=C)}}
function dg(a,b,c,d,e){var f=null;switch(b){case "input":c=Vc(a,c);d=Vc(a,d);f=[];break;case "option":c=Gf(a,c);d=Gf(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=Jf(a,c);d=Jf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}Xf(b,d,Zf);b=a=void 0;var h=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var g=c[a];for(b in g)g.hasOwnProperty(b)&&(h||
(h={}),h[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ua.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];g=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==g&&(null!=k||null!=g))if("style"===a)if(g){for(b in g)!g.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(h||(h={}),h[b]="");for(b in k)k.hasOwnProperty(b)&&g[b]!==k[b]&&(h||(h={}),h[b]=k[b])}else h||(f||(f=[]),f.push(a,h)),
h=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,g=g?g.__html:void 0,null!=k&&g!==k&&(f=f||[]).push(a,""+k)):"children"===a?g===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ua.hasOwnProperty(a)?(null!=k&&$f(e,a),f||g===k||(f=[])):(f=f||[]).push(a,k))}h&&(f=f||[]).push("style",h);return f}
function eg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Yc(a,e);Yf(c,d);d=Yf(c,e);for(var f=0;f<b.length;f+=2){var h=b[f],g=b[f+1];"style"===h?Vf(a,g,Zf):"dangerouslySetInnerHTML"===h?Rf(a,g):"children"===h?Sf(a,g):Uc(a,h,g,d)}switch(c){case "input":Zc(a,e);break;case "textarea":Lf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Hf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Hf(a,!!e.multiple,e.defaultValue,!0):Hf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function fg(a,b,c,d,e){switch(b){case "iframe":case "object":W("topLoad","load",a);break;case "video":case "audio":for(var f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);break;case "source":W("topError","error",a);break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);break;case "details":W("topToggle","toggle",a);break;case "input":Wc(a,c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "select":If(a,
c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "textarea":Kf(a,c),W("topInvalid","invalid",a),$f(e,"onChange")}Xf(b,c,Zf);d=null;for(var h in c)c.hasOwnProperty(h)&&(f=c[h],"children"===h?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):ua.hasOwnProperty(h)&&null!=f&&$f(e,h));switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function ng(a,b){return a.nodeValue!==b}
var og=Object.freeze({createElement:ag,createTextNode:bg,setInitialProperties:cg,diffProperties:dg,updateProperties:eg,diffHydratedProperties:fg,diffHydratedText:ng,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Zc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Xa(d);e?void 0:D("90");mc(d);Zc(d,e)}}}break;case "textarea":Lf(a,c);break;case "select":b=c.value,null!=b&&Hf(a,!!c.multiple,b,!1)}}});Tb.injectFiberControlledHostComponent(og);var pg=null,qg=null;
function rg(a){this._expirationTime=X.computeUniqueAsyncExpiration();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}rg.prototype.render=function(a){this._defer?void 0:D("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new sg;X.updateContainerAtExpirationTime(a,b,null,c,d._onCommit);return d};
rg.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
rg.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:D("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?D("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;X.flushRoot(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};rg.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function sg(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}sg.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
sg.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?D("191",c):void 0;c()}}};function tg(a,b,c){this._internalRoot=X.createContainer(a,b,c)}tg.prototype.render=function(a,b){var c=this._internalRoot,d=new sg;b=void 0===b?null:b;null!==b&&d.then(b);X.updateContainer(a,c,null,d._onCommit);return d};
tg.prototype.unmount=function(a){var b=this._internalRoot,c=new sg;a=void 0===a?null:a;null!==a&&c.then(a);X.updateContainer(null,b,null,c._onCommit);return c};tg.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new sg;c=void 0===c?null:c;null!==c&&e.then(c);X.updateContainer(b,d,a,e._onCommit);return e};
tg.prototype.createBatch=function(){var a=new rg(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ug(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function vg(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
var X=pf({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Pf(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Pf(a,b)}return a},getChildHostContext:function(a,b){return Pf(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){pg=Vd;var a=fa();if(ne(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(B){b=null;break a}var f=0,h=-1,g=-1,k=0,v=0,l=a,p=null;b:for(;;){for(var z;;){l!==b||0!==d&&3!==l.nodeType||(h=f+d);l!==e||0!==c&&3!==l.nodeType||(g=f+c);3===l.nodeType&&(f+=l.nodeValue.length);if(null===(z=l.firstChild))break;p=l;l=z}for(;;){if(l===a)break b;p===b&&++k===d&&(h=f);p===e&&++v===c&&(g=f);if(null!==(z=l.nextSibling))break;l=p;p=l.parentNode}l=z}b=-1===h||-1===g?null:
{start:h,end:g}}else b=null}b=b||{start:0,end:0}}else b=null;qg={focusedElem:a,selectionRange:b};Wd(!1)},resetAfterCommit:function(){var a=qg,b=fa(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ja(document.documentElement,c)){if(ne(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[mb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=me(c,a);var f=me(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var h=document.createRange();h.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(h),b.extend(f.node,f.offset)):(h.setEnd(f.node,f.offset),b.addRange(h))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,
a.element.scrollTop=a.top}qg=null;Wd(pg);pg=null},createInstance:function(a,b,c,d,e){a=ag(a,b,c,d);a[F]=e;a[Ta]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){cg(a,b,c,d);return vg(b,c)},prepareUpdate:function(a,b,c,d,e){return dg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===
typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=bg(a,b);a[F]=d;return a},now:sf,mutation:{commitMount:function(a,b,c){vg(b,c)&&a.focus()},commitUpdate:function(a,b,c,d,e){a[Ta]=e;eg(a,b,c,d,e)},resetTextContent:function(a){Sf(a,"")},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},
insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=
a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[F]=f;a[Ta]=c;return fg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[F]=c;return ng(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},
didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:tf,cancelDeferredCallback:uf}),Cg=X;ac=Cg.batchedUpdates;bc=Cg.interactiveUpdates;cc=Cg.flushInteractiveUpdates;
function Dg(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new tg(a,!1,b)}
function Eg(a,b,c,d,e){ug(c)?void 0:D("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var h=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);h.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Dg(c,d);if("function"===typeof e){var g=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);g.call(a)}}X.unbatchedUpdates(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return X.getPublicRootInstance(f._internalRoot)}
function Fg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ug(b)?void 0:D("200");return qf(a,b,null,c)}
var Gg={createPortal:Fg,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:X.findHostInstance(a)},hydrate:function(a,b,c){return Eg(null,a,b,!0,c)},render:function(a,b,c){return Eg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Eg(a,b,c,!1,d)},unmountComponentAtNode:function(a){ug(a)?void 0:D("40");return a._reactRootContainer?(X.unbatchedUpdates(function(){Eg(null,null,a,!1,function(){a._reactRootContainer=
null})}),!0):!1},unstable_createPortal:function(){return Fg.apply(void 0,arguments)},unstable_batchedUpdates:X.batchedUpdates,unstable_deferredUpdates:X.deferredUpdates,flushSync:X.flushSync,unstable_flushControlled:X.flushControlled,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ra,EventPluginRegistry:Ca,EventPropagators:kb,ReactControlledComponent:$b,ReactDOMComponentTree:bb,ReactDOMEventListener:$d},unstable_createRoot:function(a,b){return new tg(a,!0,null!=b&&!0===b.hydrate)}};
X.injectIntoDevTools({findFiberByHostInstance:Ua,bundleType:0,version:"16.3.2",rendererPackageName:"react-dom"});var Hg=Object.freeze({default:Gg}),Ig=Hg&&Gg||Hg;module.exports=Ig["default"]?Ig["default"]:Ig;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(24);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(25);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_clustergrammer__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){var nRow=100;var nCol=100;var nGroupDepth=10;var nLink=10000;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_clustergrammer__["a" /* default */],{network_data:{row_nodes:Array(nRow).fill(0).map(function(_,i){return{name:'ROW-'+i,clust:i,group:Array(nGroupDepth).fill(0).map(function(_,d){return parseInt(i/Math.pow(2,d));})};}),col_nodes:Array(nCol).fill(0).map(function(_,i){return{name:'COL-'+i,clust:i,group:Array(nGroupDepth).fill(0).map(function(_,d){return parseInt(i/Math.pow(2,d));})};}),links:Array(nLink).fill(0).map(function(_){return{source:parseInt(Math.random()*nRow),target:parseInt(Math.random()*nCol),value:Math.random()*2-1};})},width:window.innerWidth,height:window.innerHeight});}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var d3=__webpack_require__(35);var _=__webpack_require__(36);var $=__webpack_require__(9);var jQuery=__webpack_require__(9);window.jQuery=jQuery;__webpack_require__(38);var Clustergrammer=/******/function(modules){// webpackBootstrap
/******/// The module cache
/******/var installedModules={};/******/// The require function
/******/function __webpack_require__(moduleId){/******/// Check if module is in cache
/******/if(installedModules[moduleId])/******/return installedModules[moduleId].exports;/******/// Create a new module (and put it into the cache)
/******/var module=installedModules[moduleId]={/******/exports:{},/******/id:moduleId,/******/loaded:false/******/};/******/// Execute the module function
/******/modules[moduleId].call(module.exports,module,module.exports,__webpack_require__);/******/// Flag the module as loaded
/******/module.loaded=true;/******/// Return the exports of the module
/******/return module.exports;/******/}/******/// expose the modules object (__webpack_modules__)
/******/__webpack_require__.m=modules;/******/// expose the module cache
/******/__webpack_require__.c=installedModules;/******/// __webpack_public_path__
/******/__webpack_require__.p="";/******/// Load entry module and return exports
/******/return __webpack_require__(0);/******/}(/************************************************************************//******/[/* 0 *//***/function(module,exports,__webpack_require__){var make_config=__webpack_require__(1);var make_params=__webpack_require__(10);var make_viz=__webpack_require__(87);var resize_viz=__webpack_require__(152);var play_demo=__webpack_require__(195);var ini_demo=__webpack_require__(235);var filter_viz_using_nodes=__webpack_require__(238);var filter_viz_using_names=__webpack_require__(239);var update_cats=__webpack_require__(240);var reset_cats=__webpack_require__(241);var two_translate_zoom=__webpack_require__(144);var update_view=__webpack_require__(243);var save_matrix=__webpack_require__(246);var brush_crop_matrix=__webpack_require__(250);var run_zoom=__webpack_require__(153);var d3_tip_custom=__webpack_require__(98);var all_reorder=__webpack_require__(143);var make_matrix_string=__webpack_require__(248);// moved d3.slider to src
d3.slider=__webpack_require__(252);/* eslint-disable */var awesomplete=__webpack_require__(254);// getting css from src
__webpack_require__(255);__webpack_require__(259);/* clustergrammer v1.19.5
	 * Nicolas Fernandez, Ma'ayan Lab, Icahn School of Medicine at Mount Sinai
	 * (c) 2017
	 */function Clustergrammer(args){/* Main program
	   * ----------------------------------------------------------------------- */// consume and validate user input
// build giant config object
// visualize based on config object
// handle user events
// consume and validate user arguments, produce configuration object
var config=make_config(args);var cgm={};// make visualization parameters using configuration object
cgm.params=make_params(config);cgm.config=config;// set up zoom
cgm.params.zoom_behavior=d3.behavior.zoom().scaleExtent([1,cgm.params.viz.square_zoom*cgm.params.viz.zoom_ratio.x]).on('zoom',function(){run_zoom(cgm);});cgm.params.zoom_behavior.translate([cgm.params.viz.clust.margin.left,cgm.params.viz.clust.margin.top]);if(cgm.params.use_sidebar){var make_sidebar=__webpack_require__(261);make_sidebar(cgm);}// make visualization using parameters
make_viz(cgm);function external_resize(){d3.select(cgm.params.viz.viz_svg).style('opacity',0.5);var wait_time=500;if(this.params.viz.run_trans===true){wait_time=2500;}setTimeout(resize_fun,wait_time,this);}function resize_fun(cgm){resize_viz(cgm);}function run_update_cats(cat_data){update_cats(this,cat_data);}function zoom_api(pan_dx,pan_dy,fin_zoom){two_translate_zoom(this,pan_dx,pan_dy,fin_zoom);}function expose_d3_tip_custom(){// this allows external modules to have access to d3_tip
return d3_tip_custom;}function api_reorder(inst_rc,inst_order){if(inst_order==='sum'){inst_order='rank';}if(inst_order==='var'){inst_order='rankvar';}all_reorder(this,inst_order,inst_rc);}function export_matrix_string(){return make_matrix_string(this.params);}function external_update_view(filter_type,inst_state){update_view(this,filter_type,inst_state);}// add more API endpoints
cgm.update_view=update_view;cgm.resize_viz=external_resize;cgm.play_demo=play_demo;cgm.ini_demo=ini_demo;cgm.filter_viz_using_nodes=filter_viz_using_nodes;cgm.filter_viz_using_names=filter_viz_using_names;cgm.update_cats=run_update_cats;cgm.reset_cats=reset_cats;cgm.zoom=zoom_api;cgm.save_matrix=save_matrix;cgm.brush_crop_matrix=brush_crop_matrix;cgm.d3_tip_custom=expose_d3_tip_custom;cgm.reorder=api_reorder;cgm.export_matrix_string=export_matrix_string;cgm.update_view=external_update_view;return cgm;}module.exports=Clustergrammer;/***/},/* 1 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);var transpose_network=__webpack_require__(4);var get_available_filters=__webpack_require__(5);var get_filter_default_state=__webpack_require__(6);var set_defaults=__webpack_require__(7);var check_sim_mat=__webpack_require__(8);var check_nodes_for_categories=__webpack_require__(9);var underscore=__webpack_require__(3);module.exports=function make_config(args){var defaults$$1=set_defaults();// Mixin defaults with user-defined arguments.
var config=utils.extend(defaults$$1,args);config.network_data=args.network_data;var super_string=': ';// replace undersores with space in row/col names
underscore.each(['row','col'],function(inst_rc){var inst_nodes=config.network_data[inst_rc+'_nodes'];var has_cats=check_nodes_for_categories(inst_nodes);inst_nodes.forEach(function(d,i){// add index to row_nodes and col_nodes
d[inst_rc+'_index']=i;if(has_cats){config.super_labels=true;config.super[inst_rc]=d.name.split(super_string)[0];d.name=d.name.split(super_string)[1];}d.name=String(d.name);d.name=d.name.replace(/_/g,' ');});});config.network_data.row_nodes_names=utils.pluck(config.network_data.row_nodes,'name');config.network_data.col_nodes_names=utils.pluck(config.network_data.col_nodes,'name');config.sim_mat=check_sim_mat(config);var filters=get_available_filters(config.network_data.views);var default_states={};underscore.each(underscore.keys(filters.possible_filters),function(inst_filter){var tmp_state=get_filter_default_state(filters.filter_data,inst_filter);default_states[inst_filter]=tmp_state;});// process view
if(_.has(config.network_data,'views')){config.network_data.views.forEach(function(inst_view){underscore.each(underscore.keys(filters.possible_filters),function(inst_filter){if(!_.has(inst_view,inst_filter)){inst_view[inst_filter]=default_states[inst_filter];}});var inst_nodes=inst_view.nodes;// proc row/col nodes names in views
underscore.each(['row','col'],function(inst_rc){var has_cats=check_nodes_for_categories(inst_nodes[inst_rc+'_nodes']);inst_nodes[inst_rc+'_nodes'].forEach(function(d,i){// add index to row_nodes and col_nodes
d[inst_rc+'_index']=i;if(has_cats){d.name=d.name.split(super_string)[1];}d.name=String(d.name);d.name=d.name.replace(/_/g,' ');});});});}var col_nodes=config.network_data.col_nodes;var row_nodes=config.network_data.row_nodes;// console.log( config.network_data.links[0] )
// console.log( config.network_data.links[1] )
// console.log( config.network_data.links[2] )
// console.log(_.has(config.network_data,'mat'));
///////////////////////////
// convert 'mat' to links
///////////////////////////
if(_.has(config.network_data,'mat')){var links=[];var mat=config.network_data.mat;var inst_link={};// console.log('found mat')
for(var i=0;i<mat.length;i++){for(var j=0;j<mat[0].length;j++){// console.log(mat[i][j])
inst_link={};inst_link.source=i;inst_link.target=j;inst_link.value=mat[i][j];links.push(inst_link);}}// save to network_data
config.network_data.links=links;}// add names and instantaneous positions to links
config.network_data.links.forEach(function(d){d.name=row_nodes[d.source].name+'_'+col_nodes[d.target].name;d.row_name=row_nodes[d.source].name;d.col_name=col_nodes[d.target].name;});// transpose network if necessary
if(config.transpose){config.network_data=transpose_network(config.network_data);var tmp_col_label=args.col_label;var tmp_row_label=args.row_label;args.row_label=tmp_col_label;args.col_label=tmp_row_label;}// super-row/col labels
if(!utils.is_undefined(args.row_label)&&!utils.is_undefined(args.col_label)){config.super_labels=true;config.super={};config.super.row=args.row_label;config.super.col=args.col_label;}// initialize cluster ordering - both rows and columns
config.inst_order={};if(!utils.is_undefined(args.order)&&utils.is_supported_order(args.order)){config.inst_order.row=args.order;config.inst_order.col=args.order;}else{config.inst_order.row='clust';config.inst_order.col='clust';}// set row or column order directly -- note that row/col are swapped
// !! need to swap row/col orderings
if(!utils.is_undefined(args.row_order)&&utils.is_supported_order(args.row_order)){// !! row and col orderings are swapped, need to fix
config.inst_order.col=args.row_order;}if(!utils.is_undefined(args.col_order)&&utils.is_supported_order(args.col_order)){// !! row and col orderings are swapped, need to fix
config.inst_order.row=args.col_order;}var row_has_group=utils.has(config.network_data.row_nodes[0],'group');var col_has_group=utils.has(config.network_data.col_nodes[0],'group');config.show_dendrogram=row_has_group||col_has_group;if(utils.has(config.network_data.links[0],'value_orig')){config.keep_orig=true;}else{config.keep_orig=false;}return config;};/***/},/* 2 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);/* Utility functions
	 * ----------------------------------------------------------------------- */module.exports={normal_name:function normal_name(d){var inst_name=d.name.replace(/_/g,' ').split('#')[0];return inst_name;},is_supported_order:function is_supported_order(order){return order==='ini'||order==='clust'||order==='rank_var'||order==='rank'||order==='class'||order=='alpha';},/* Returns whether or not an object has a certain property.
	   */has:function has(obj,key){return obj!=null&&hasOwnProperty.call(obj,key);},property:function property(key){return function(obj){return obj==null?void 0:obj[key];};},// Convenience version of a common use case of `map`: fetching a property.
pluck:function pluck(arr,key){var self=this;// Double check that we have lodash or underscore available
if(window._){// Underscore provides a pluck function. Use that.
if(typeof underscore.pluck==='function'){return underscore.pluck(arr,key);}else if(typeof underscore.map==='function'){// Lodash does not have a pluck function.
// Use underscore.map with the property function defined above.
return underscore.map(arr,self.property(key));}}else if(arr.map&&typeof arr.map==='function'){// If lodash or underscore not available, check to see if the native arr.map is available.
// If so, use it with the property function defined above.
return arr.map(self.property(key));}},/* Returns true if the object is undefined.
	   */is_undefined:function is_undefined(obj){return obj===void 0;},/* Mixes two objects in together, overwriting a target with a source.
	   */extend:function extend(target,source){target=target||{};for(var prop in source){if(_typeof(source[prop])==='object'){target[prop]=this.extend(target[prop],source[prop]);}else{target[prop]=source[prop];}}return target;}};/***/},/* 3 *//***/function(module,exports,__webpack_require__){var __WEBPACK_AMD_DEFINE_ARRAY__,__WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
(function(){// Baseline setup
// --------------
// Establish the root object, `window` in the browser, or `exports` on the server.
var root=this;// Save the previous value of the `_` variable.
var previousUnderscore=root._;// Save bytes in the minified (but not gzipped) version:
var ArrayProto=Array.prototype,ObjProto=Object.prototype,FuncProto=Function.prototype;// Create quick reference variables for speed access to core prototypes.
var push=ArrayProto.push,slice=ArrayProto.slice,toString=ObjProto.toString,hasOwnProperty=ObjProto.hasOwnProperty;// All **ECMAScript 5** native function implementations that we hope to use
// are declared here.
var nativeIsArray=Array.isArray,nativeKeys=Object.keys,nativeBind=FuncProto.bind,nativeCreate=Object.create;// Naked function reference for surrogate-prototype-swapping.
var Ctor=function Ctor(){};// Create a safe reference to the Underscore object for use below.
var _=function _(obj){if(obj instanceof _)return obj;if(!(this instanceof _))return new _(obj);this._wrapped=obj;};// Export the Underscore object for **Node.js**, with
// backwards-compatibility for the old `require()` API. If we're in
// the browser, add `_` as a global object.
{if(typeof module!=='undefined'&&module.exports){exports=module.exports=_;}exports._=_;}// Current version.
_.VERSION='1.8.3';// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
var optimizeCb=function optimizeCb(func,context,argCount){if(context===void 0)return func;switch(argCount==null?3:argCount){case 1:return function(value){return func.call(context,value);};case 2:return function(value,other){return func.call(context,value,other);};case 3:return function(value,index,collection){return func.call(context,value,index,collection);};case 4:return function(accumulator,value,index,collection){return func.call(context,accumulator,value,index,collection);};}return function(){return func.apply(context,arguments);};};// A mostly-internal function to generate callbacks that can be applied
// to each element in a collection, returning the desired result — either
// identity, an arbitrary callback, a property matcher, or a property accessor.
var cb=function cb(value,context,argCount){if(value==null)return _.identity;if(_.isFunction(value))return optimizeCb(value,context,argCount);if(_.isObject(value))return _.matcher(value);return _.property(value);};_.iteratee=function(value,context){return cb(value,context,Infinity);};// An internal function for creating assigner functions.
var createAssigner=function createAssigner(keysFunc,undefinedOnly){return function(obj){var length=arguments.length;if(length<2||obj==null)return obj;for(var index=1;index<length;index++){var source=arguments[index],keys=keysFunc(source),l=keys.length;for(var i=0;i<l;i++){var key=keys[i];if(!undefinedOnly||obj[key]===void 0)obj[key]=source[key];}}return obj;};};// An internal function for creating a new object that inherits from another.
var baseCreate=function baseCreate(prototype){if(!_.isObject(prototype))return{};if(nativeCreate)return nativeCreate(prototype);Ctor.prototype=prototype;var result=new Ctor();Ctor.prototype=null;return result;};var property=function property(key){return function(obj){return obj==null?void 0:obj[key];};};// Helper for collection methods to determine whether a collection
// should be iterated as an array or as an object
// Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
var MAX_ARRAY_INDEX=Math.pow(2,53)-1;var getLength=property('length');var isArrayLike=function isArrayLike(collection){var length=getLength(collection);return typeof length=='number'&&length>=0&&length<=MAX_ARRAY_INDEX;};// Collection Functions
// --------------------
// The cornerstone, an `each` implementation, aka `forEach`.
// Handles raw objects in addition to array-likes. Treats all
// sparse array-likes as if they were dense.
_.each=_.forEach=function(obj,iteratee,context){iteratee=optimizeCb(iteratee,context);var i,length;if(isArrayLike(obj)){for(i=0, length=obj.length;i<length;i++){iteratee(obj[i],i,obj);}}else{var keys=_.keys(obj);for(i=0, length=keys.length;i<length;i++){iteratee(obj[keys[i]],keys[i],obj);}}return obj;};// Return the results of applying the iteratee to each element.
_.map=_.collect=function(obj,iteratee,context){iteratee=cb(iteratee,context);var keys=!isArrayLike(obj)&&_.keys(obj),length=(keys||obj).length,results=Array(length);for(var index=0;index<length;index++){var currentKey=keys?keys[index]:index;results[index]=iteratee(obj[currentKey],currentKey,obj);}return results;};// Create a reducing function iterating left or right.
function createReduce(dir){// Optimized iterator function as using arguments.length
// in the main function will deoptimize the, see #1991.
function iterator(obj,iteratee,memo,keys,index,length){for(;index>=0&&index<length;index+=dir){var currentKey=keys?keys[index]:index;memo=iteratee(memo,obj[currentKey],currentKey,obj);}return memo;}return function(obj,iteratee,memo,context){iteratee=optimizeCb(iteratee,context,4);var keys=!isArrayLike(obj)&&_.keys(obj),length=(keys||obj).length,index=dir>0?0:length-1;// Determine the initial value if none is provided.
if(arguments.length<3){memo=obj[keys?keys[index]:index];index+=dir;}return iterator(obj,iteratee,memo,keys,index,length);};}// **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
_.reduce=_.foldl=_.inject=createReduce(1);// The right-associative version of reduce, also known as `foldr`.
_.reduceRight=_.foldr=createReduce(-1);// Return the first value which passes a truth test. Aliased as `detect`.
_.find=_.detect=function(obj,predicate,context){var key;if(isArrayLike(obj)){key=_.findIndex(obj,predicate,context);}else{key=_.findKey(obj,predicate,context);}if(key!==void 0&&key!==-1)return obj[key];};// Return all the elements that pass a truth test.
// Aliased as `select`.
_.filter=_.select=function(obj,predicate,context){var results=[];predicate=cb(predicate,context);_.each(obj,function(value,index,list){if(predicate(value,index,list))results.push(value);});return results;};// Return all the elements for which a truth test fails.
_.reject=function(obj,predicate,context){return _.filter(obj,_.negate(cb(predicate)),context);};// Determine whether all of the elements match a truth test.
// Aliased as `all`.
_.every=_.all=function(obj,predicate,context){predicate=cb(predicate,context);var keys=!isArrayLike(obj)&&_.keys(obj),length=(keys||obj).length;for(var index=0;index<length;index++){var currentKey=keys?keys[index]:index;if(!predicate(obj[currentKey],currentKey,obj))return false;}return true;};// Determine if at least one element in the object matches a truth test.
// Aliased as `any`.
_.some=_.any=function(obj,predicate,context){predicate=cb(predicate,context);var keys=!isArrayLike(obj)&&_.keys(obj),length=(keys||obj).length;for(var index=0;index<length;index++){var currentKey=keys?keys[index]:index;if(predicate(obj[currentKey],currentKey,obj))return true;}return false;};// Determine if the array or object contains a given item (using `===`).
// Aliased as `includes` and `include`.
_.contains=_.includes=_.include=function(obj,item,fromIndex,guard){if(!isArrayLike(obj))obj=_.values(obj);if(typeof fromIndex!='number'||guard)fromIndex=0;return _.indexOf(obj,item,fromIndex)>=0;};// Invoke a method (with arguments) on every item in a collection.
_.invoke=function(obj,method){var args=slice.call(arguments,2);var isFunc=_.isFunction(method);return _.map(obj,function(value){var func=isFunc?method:value[method];return func==null?func:func.apply(value,args);});};// Convenience version of a common use case of `map`: fetching a property.
_.pluck=function(obj,key){return _.map(obj,_.property(key));};// Convenience version of a common use case of `filter`: selecting only objects
// containing specific `key:value` pairs.
_.where=function(obj,attrs){return _.filter(obj,_.matcher(attrs));};// Convenience version of a common use case of `find`: getting the first object
// containing specific `key:value` pairs.
_.findWhere=function(obj,attrs){return _.find(obj,_.matcher(attrs));};// Return the maximum element (or element-based computation).
_.max=function(obj,iteratee,context){var result=-Infinity,lastComputed=-Infinity,value,computed;if(iteratee==null&&obj!=null){obj=isArrayLike(obj)?obj:_.values(obj);for(var i=0,length=obj.length;i<length;i++){value=obj[i];if(value>result){result=value;}}}else{iteratee=cb(iteratee,context);_.each(obj,function(value,index,list){computed=iteratee(value,index,list);if(computed>lastComputed||computed===-Infinity&&result===-Infinity){result=value;lastComputed=computed;}});}return result;};// Return the minimum element (or element-based computation).
_.min=function(obj,iteratee,context){var result=Infinity,lastComputed=Infinity,value,computed;if(iteratee==null&&obj!=null){obj=isArrayLike(obj)?obj:_.values(obj);for(var i=0,length=obj.length;i<length;i++){value=obj[i];if(value<result){result=value;}}}else{iteratee=cb(iteratee,context);_.each(obj,function(value,index,list){computed=iteratee(value,index,list);if(computed<lastComputed||computed===Infinity&&result===Infinity){result=value;lastComputed=computed;}});}return result;};// Shuffle a collection, using the modern version of the
// [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
_.shuffle=function(obj){var set$$1=isArrayLike(obj)?obj:_.values(obj);var length=set$$1.length;var shuffled=Array(length);for(var index=0,rand;index<length;index++){rand=_.random(0,index);if(rand!==index)shuffled[index]=shuffled[rand];shuffled[rand]=set$$1[index];}return shuffled;};// Sample **n** random values from a collection.
// If **n** is not specified, returns a single random element.
// The internal `guard` argument allows it to work with `map`.
_.sample=function(obj,n,guard){if(n==null||guard){if(!isArrayLike(obj))obj=_.values(obj);return obj[_.random(obj.length-1)];}return _.shuffle(obj).slice(0,Math.max(0,n));};// Sort the object's values by a criterion produced by an iteratee.
_.sortBy=function(obj,iteratee,context){iteratee=cb(iteratee,context);return _.pluck(_.map(obj,function(value,index,list){return{value:value,index:index,criteria:iteratee(value,index,list)};}).sort(function(left,right){var a=left.criteria;var b=right.criteria;if(a!==b){if(a>b||a===void 0)return 1;if(a<b||b===void 0)return-1;}return left.index-right.index;}),'value');};// An internal function used for aggregate "group by" operations.
var group=function group(behavior){return function(obj,iteratee,context){var result={};iteratee=cb(iteratee,context);_.each(obj,function(value,index){var key=iteratee(value,index,obj);behavior(result,value,key);});return result;};};// Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
_.groupBy=group(function(result,value,key){if(_.has(result,key))result[key].push(value);else result[key]=[value];});// Indexes the object's values by a criterion, similar to `groupBy`, but for
// when you know that your index values will be unique.
_.indexBy=group(function(result,value,key){result[key]=value;});// Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
_.countBy=group(function(result,value,key){if(_.has(result,key))result[key]++;else result[key]=1;});// Safely create a real, live array from anything iterable.
_.toArray=function(obj){if(!obj)return[];if(_.isArray(obj))return slice.call(obj);if(isArrayLike(obj))return _.map(obj,_.identity);return _.values(obj);};// Return the number of elements in an object.
_.size=function(obj){if(obj==null)return 0;return isArrayLike(obj)?obj.length:_.keys(obj).length;};// Split a collection into two arrays: one whose elements all satisfy the given
// predicate, and one whose elements all do not satisfy the predicate.
_.partition=function(obj,predicate,context){predicate=cb(predicate,context);var pass=[],fail=[];_.each(obj,function(value,key,obj){(predicate(value,key,obj)?pass:fail).push(value);});return[pass,fail];};// Array Functions
// ---------------
// Get the first element of an array. Passing **n** will return the first N
// values in the array. Aliased as `head` and `take`. The **guard** check
// allows it to work with `_.map`.
_.first=_.head=_.take=function(array,n,guard){if(array==null)return void 0;if(n==null||guard)return array[0];return _.initial(array,array.length-n);};// Returns everything but the last entry of the array. Especially useful on
// the arguments object. Passing **n** will return all the values in
// the array, excluding the last N.
_.initial=function(array,n,guard){return slice.call(array,0,Math.max(0,array.length-(n==null||guard?1:n)));};// Get the last element of an array. Passing **n** will return the last N
// values in the array.
_.last=function(array,n,guard){if(array==null)return void 0;if(n==null||guard)return array[array.length-1];return _.rest(array,Math.max(0,array.length-n));};// Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
// Especially useful on the arguments object. Passing an **n** will return
// the rest N values in the array.
_.rest=_.tail=_.drop=function(array,n,guard){return slice.call(array,n==null||guard?1:n);};// Trim out all falsy values from an array.
_.compact=function(array){return _.filter(array,_.identity);};// Internal implementation of a recursive `flatten` function.
var flatten=function flatten(input,shallow,strict,startIndex){var output=[],idx=0;for(var i=startIndex||0,length=getLength(input);i<length;i++){var value=input[i];if(isArrayLike(value)&&(_.isArray(value)||_.isArguments(value))){//flatten current level of array or arguments object
if(!shallow)value=flatten(value,shallow,strict);var j=0,len=value.length;output.length+=len;while(j<len){output[idx++]=value[j++];}}else if(!strict){output[idx++]=value;}}return output;};// Flatten out an array, either recursively (by default), or just one level.
_.flatten=function(array,shallow){return flatten(array,shallow,false);};// Return a version of the array that does not contain the specified value(s).
_.without=function(array){return _.difference(array,slice.call(arguments,1));};// Produce a duplicate-free version of the array. If the array has already
// been sorted, you have the option of using a faster algorithm.
// Aliased as `unique`.
_.uniq=_.unique=function(array,isSorted,iteratee,context){if(!_.isBoolean(isSorted)){context=iteratee;iteratee=isSorted;isSorted=false;}if(iteratee!=null)iteratee=cb(iteratee,context);var result=[];var seen=[];for(var i=0,length=getLength(array);i<length;i++){var value=array[i],computed=iteratee?iteratee(value,i,array):value;if(isSorted){if(!i||seen!==computed)result.push(value);seen=computed;}else if(iteratee){if(!_.contains(seen,computed)){seen.push(computed);result.push(value);}}else if(!_.contains(result,value)){result.push(value);}}return result;};// Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
_.union=function(){return _.uniq(flatten(arguments,true,true));};// Produce an array that contains every item shared between all the
// passed-in arrays.
_.intersection=function(array){var result=[];var argsLength=arguments.length;for(var i=0,length=getLength(array);i<length;i++){var item=array[i];if(_.contains(result,item))continue;for(var j=1;j<argsLength;j++){if(!_.contains(arguments[j],item))break;}if(j===argsLength)result.push(item);}return result;};// Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
_.difference=function(array){var rest=flatten(arguments,true,true,1);return _.filter(array,function(value){return!_.contains(rest,value);});};// Zip together multiple lists into a single array -- elements that share
// an index go together.
_.zip=function(){return _.unzip(arguments);};// Complement of _.zip. Unzip accepts an array of arrays and groups
// each array's elements on shared indices
_.unzip=function(array){var length=array&&_.max(array,getLength).length||0;var result=Array(length);for(var index=0;index<length;index++){result[index]=_.pluck(array,index);}return result;};// Converts lists into objects. Pass either a single array of `[key, value]`
// pairs, or two parallel arrays of the same length -- one of keys, and one of
// the corresponding values.
_.object=function(list,values){var result={};for(var i=0,length=getLength(list);i<length;i++){if(values){result[list[i]]=values[i];}else{result[list[i][0]]=list[i][1];}}return result;};// Generator function to create the findIndex and findLastIndex functions
function createPredicateIndexFinder(dir){return function(array,predicate,context){predicate=cb(predicate,context);var length=getLength(array);var index=dir>0?0:length-1;for(;index>=0&&index<length;index+=dir){if(predicate(array[index],index,array))return index;}return-1;};}// Returns the first index on an array-like that passes a predicate test
_.findIndex=createPredicateIndexFinder(1);_.findLastIndex=createPredicateIndexFinder(-1);// Use a comparator function to figure out the smallest index at which
// an object should be inserted so as to maintain order. Uses binary search.
_.sortedIndex=function(array,obj,iteratee,context){iteratee=cb(iteratee,context,1);var value=iteratee(obj);var low=0,high=getLength(array);while(low<high){var mid=Math.floor((low+high)/2);if(iteratee(array[mid])<value)low=mid+1;else high=mid;}return low;};// Generator function to create the indexOf and lastIndexOf functions
function createIndexFinder(dir,predicateFind,sortedIndex){return function(array,item,idx){var i=0,length=getLength(array);if(typeof idx=='number'){if(dir>0){i=idx>=0?idx:Math.max(idx+length,i);}else{length=idx>=0?Math.min(idx+1,length):idx+length+1;}}else if(sortedIndex&&idx&&length){idx=sortedIndex(array,item);return array[idx]===item?idx:-1;}if(item!==item){idx=predicateFind(slice.call(array,i,length),_.isNaN);return idx>=0?idx+i:-1;}for(idx=dir>0?i:length-1;idx>=0&&idx<length;idx+=dir){if(array[idx]===item)return idx;}return-1;};}// Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
_.indexOf=createIndexFinder(1,_.findIndex,_.sortedIndex);_.lastIndexOf=createIndexFinder(-1,_.findLastIndex);// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](http://docs.python.org/library/functions.html#range).
_.range=function(start,stop,step){if(stop==null){stop=start||0;start=0;}step=step||1;var length=Math.max(Math.ceil((stop-start)/step),0);var range=Array(length);for(var idx=0;idx<length;idx++, start+=step){range[idx]=start;}return range;};// Function (ahem) Functions
// ------------------
// Determines whether to execute a function as a constructor
// or a normal function with the provided arguments
var executeBound=function executeBound(sourceFunc,boundFunc,context,callingContext,args){if(!(callingContext instanceof boundFunc))return sourceFunc.apply(context,args);var self=baseCreate(sourceFunc.prototype);var result=sourceFunc.apply(self,args);if(_.isObject(result))return result;return self;};// Create a function bound to a given object (assigning `this`, and arguments,
// optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
// available.
_.bind=function(func,context){if(nativeBind&&func.bind===nativeBind)return nativeBind.apply(func,slice.call(arguments,1));if(!_.isFunction(func))throw new TypeError('Bind must be called on a function');var args=slice.call(arguments,2);var bound=function bound(){return executeBound(func,bound,context,this,args.concat(slice.call(arguments)));};return bound;};// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. _ acts
// as a placeholder, allowing any combination of arguments to be pre-filled.
_.partial=function(func){var boundArgs=slice.call(arguments,1);var bound=function bound(){var position=0,length=boundArgs.length;var args=Array(length);for(var i=0;i<length;i++){args[i]=boundArgs[i]===_?arguments[position++]:boundArgs[i];}while(position<arguments.length){args.push(arguments[position++]);}return executeBound(func,bound,this,this,args);};return bound;};// Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
_.bindAll=function(obj){var i,length=arguments.length,key;if(length<=1)throw new Error('bindAll must be passed function names');for(i=1;i<length;i++){key=arguments[i];obj[key]=_.bind(obj[key],obj);}return obj;};// Memoize an expensive function by storing its results.
_.memoize=function(func,hasher){var memoize=function memoize(key){var cache=memoize.cache;var address=''+(hasher?hasher.apply(this,arguments):key);if(!_.has(cache,address))cache[address]=func.apply(this,arguments);return cache[address];};memoize.cache={};return memoize;};// Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
_.delay=function(func,wait){var args=slice.call(arguments,2);return setTimeout(function(){return func.apply(null,args);},wait);};// Defers a function, scheduling it to run after the current call stack has
// cleared.
_.defer=_.partial(_.delay,_,1);// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
_.throttle=function(func,wait,options){var context,args,result;var timeout=null;var previous=0;if(!options)options={};var later=function later(){previous=options.leading===false?0:_.now();timeout=null;result=func.apply(context,args);if(!timeout)context=args=null;};return function(){var now=_.now();if(!previous&&options.leading===false)previous=now;var remaining=wait-(now-previous);context=this;args=arguments;if(remaining<=0||remaining>wait){if(timeout){clearTimeout(timeout);timeout=null;}previous=now;result=func.apply(context,args);if(!timeout)context=args=null;}else if(!timeout&&options.trailing!==false){timeout=setTimeout(later,remaining);}return result;};};// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
_.debounce=function(func,wait,immediate){var timeout,args,context,timestamp,result;var later=function later(){var last=_.now()-timestamp;if(last<wait&&last>=0){timeout=setTimeout(later,wait-last);}else{timeout=null;if(!immediate){result=func.apply(context,args);if(!timeout)context=args=null;}}};return function(){context=this;args=arguments;timestamp=_.now();var callNow=immediate&&!timeout;if(!timeout)timeout=setTimeout(later,wait);if(callNow){result=func.apply(context,args);context=args=null;}return result;};};// Returns the first function passed as an argument to the second,
// allowing you to adjust arguments, run code before and after, and
// conditionally execute the original function.
_.wrap=function(func,wrapper){return _.partial(wrapper,func);};// Returns a negated version of the passed-in predicate.
_.negate=function(predicate){return function(){return!predicate.apply(this,arguments);};};// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
_.compose=function(){var args=arguments;var start=args.length-1;return function(){var i=start;var result=args[start].apply(this,arguments);while(i--){result=args[i].call(this,result);}return result;};};// Returns a function that will only be executed on and after the Nth call.
_.after=function(times,func){return function(){if(--times<1){return func.apply(this,arguments);}};};// Returns a function that will only be executed up to (but not including) the Nth call.
_.before=function(times,func){var memo;return function(){if(--times>0){memo=func.apply(this,arguments);}if(times<=1)func=null;return memo;};};// Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
_.once=_.partial(_.before,2);// Object Functions
// ----------------
// Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
var hasEnumBug=!{toString:null}.propertyIsEnumerable('toString');var nonEnumerableProps=['valueOf','isPrototypeOf','toString','propertyIsEnumerable','hasOwnProperty','toLocaleString'];function collectNonEnumProps(obj,keys){var nonEnumIdx=nonEnumerableProps.length;var constructor=obj.constructor;var proto=_.isFunction(constructor)&&constructor.prototype||ObjProto;// Constructor is a special case.
var prop='constructor';if(_.has(obj,prop)&&!_.contains(keys,prop))keys.push(prop);while(nonEnumIdx--){prop=nonEnumerableProps[nonEnumIdx];if(prop in obj&&obj[prop]!==proto[prop]&&!_.contains(keys,prop)){keys.push(prop);}}}// Retrieve the names of an object's own properties.
// Delegates to **ECMAScript 5**'s native `Object.keys`
_.keys=function(obj){if(!_.isObject(obj))return[];if(nativeKeys)return nativeKeys(obj);var keys=[];for(var key in obj){if(_.has(obj,key))keys.push(key);}// Ahem, IE < 9.
if(hasEnumBug)collectNonEnumProps(obj,keys);return keys;};// Retrieve all the property names of an object.
_.allKeys=function(obj){if(!_.isObject(obj))return[];var keys=[];for(var key in obj){keys.push(key);}// Ahem, IE < 9.
if(hasEnumBug)collectNonEnumProps(obj,keys);return keys;};// Retrieve the values of an object's properties.
_.values=function(obj){var keys=_.keys(obj);var length=keys.length;var values=Array(length);for(var i=0;i<length;i++){values[i]=obj[keys[i]];}return values;};// Returns the results of applying the iteratee to each element of the object
// In contrast to _.map it returns an object
_.mapObject=function(obj,iteratee,context){iteratee=cb(iteratee,context);var keys=_.keys(obj),length=keys.length,results={},currentKey;for(var index=0;index<length;index++){currentKey=keys[index];results[currentKey]=iteratee(obj[currentKey],currentKey,obj);}return results;};// Convert an object into a list of `[key, value]` pairs.
_.pairs=function(obj){var keys=_.keys(obj);var length=keys.length;var pairs=Array(length);for(var i=0;i<length;i++){pairs[i]=[keys[i],obj[keys[i]]];}return pairs;};// Invert the keys and values of an object. The values must be serializable.
_.invert=function(obj){var result={};var keys=_.keys(obj);for(var i=0,length=keys.length;i<length;i++){result[obj[keys[i]]]=keys[i];}return result;};// Return a sorted list of the function names available on the object.
// Aliased as `methods`
_.functions=_.methods=function(obj){var names=[];for(var key in obj){if(_.isFunction(obj[key]))names.push(key);}return names.sort();};// Extend a given object with all the properties in passed-in object(s).
_.extend=createAssigner(_.allKeys);// Assigns a given object with all the own properties in the passed-in object(s)
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
_.extendOwn=_.assign=createAssigner(_.keys);// Returns the first key on an object that passes a predicate test
_.findKey=function(obj,predicate,context){predicate=cb(predicate,context);var keys=_.keys(obj),key;for(var i=0,length=keys.length;i<length;i++){key=keys[i];if(predicate(obj[key],key,obj))return key;}};// Return a copy of the object only containing the whitelisted properties.
_.pick=function(object,oiteratee,context){var result={},obj=object,iteratee,keys;if(obj==null)return result;if(_.isFunction(oiteratee)){keys=_.allKeys(obj);iteratee=optimizeCb(oiteratee,context);}else{keys=flatten(arguments,false,false,1);iteratee=function iteratee(value,key,obj){return key in obj;};obj=Object(obj);}for(var i=0,length=keys.length;i<length;i++){var key=keys[i];var value=obj[key];if(iteratee(value,key,obj))result[key]=value;}return result;};// Return a copy of the object without the blacklisted properties.
_.omit=function(obj,iteratee,context){if(_.isFunction(iteratee)){iteratee=_.negate(iteratee);}else{var keys=_.map(flatten(arguments,false,false,1),String);iteratee=function iteratee(value,key){return!_.contains(keys,key);};}return _.pick(obj,iteratee,context);};// Fill in a given object with default properties.
_.defaults=createAssigner(_.allKeys,true);// Creates an object that inherits from the given prototype object.
// If additional properties are provided then they will be added to the
// created object.
_.create=function(prototype,props){var result=baseCreate(prototype);if(props)_.extendOwn(result,props);return result;};// Create a (shallow-cloned) duplicate of an object.
_.clone=function(obj){if(!_.isObject(obj))return obj;return _.isArray(obj)?obj.slice():_.extend({},obj);};// Invokes interceptor with the obj, and then returns obj.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
_.tap=function(obj,interceptor){interceptor(obj);return obj;};// Returns whether an object has a given set of `key:value` pairs.
_.isMatch=function(object,attrs){var keys=_.keys(attrs),length=keys.length;if(object==null)return!length;var obj=Object(object);for(var i=0;i<length;i++){var key=keys[i];if(attrs[key]!==obj[key]||!(key in obj))return false;}return true;};// Internal recursive comparison function for `isEqual`.
var eq=function eq(a,b,aStack,bStack){// Identical objects are equal. `0 === -0`, but they aren't identical.
// See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
if(a===b)return a!==0||1/a===1/b;// A strict comparison is necessary because `null == undefined`.
if(a==null||b==null)return a===b;// Unwrap any wrapped objects.
if(a instanceof _)a=a._wrapped;if(b instanceof _)b=b._wrapped;// Compare `[[Class]]` names.
var className=toString.call(a);if(className!==toString.call(b))return false;switch(className){// Strings, numbers, regular expressions, dates, and booleans are compared by value.
case'[object RegExp]':// RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
case'[object String]':// Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
// equivalent to `new String("5")`.
return''+a===''+b;case'[object Number]':// `NaN`s are equivalent, but non-reflexive.
// Object(NaN) is equivalent to NaN
if(+a!==+a)return+b!==+b;// An `egal` comparison is performed for other numeric values.
return+a===0?1/+a===1/b:+a===+b;case'[object Date]':case'[object Boolean]':// Coerce dates and booleans to numeric primitive values. Dates are compared by their
// millisecond representations. Note that invalid dates with millisecond representations
// of `NaN` are not equivalent.
return+a===+b;}var areArrays=className==='[object Array]';if(!areArrays){if((typeof a==='undefined'?'undefined':_typeof(a))!='object'||(typeof b==='undefined'?'undefined':_typeof(b))!='object')return false;// Objects with different constructors are not equivalent, but `Object`s or `Array`s
// from different frames are.
var aCtor=a.constructor,bCtor=b.constructor;if(aCtor!==bCtor&&!(_.isFunction(aCtor)&&aCtor instanceof aCtor&&_.isFunction(bCtor)&&bCtor instanceof bCtor)&&'constructor'in a&&'constructor'in b){return false;}}// Assume equality for cyclic structures. The algorithm for detecting cyclic
// structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
// Initializing stack of traversed objects.
// It's done here since we only need them for objects and arrays comparison.
aStack=aStack||[];bStack=bStack||[];var length=aStack.length;while(length--){// Linear search. Performance is inversely proportional to the number of
// unique nested structures.
if(aStack[length]===a)return bStack[length]===b;}// Add the first object to the stack of traversed objects.
aStack.push(a);bStack.push(b);// Recursively compare objects and arrays.
if(areArrays){// Compare array lengths to determine if a deep comparison is necessary.
length=a.length;if(length!==b.length)return false;// Deep compare the contents, ignoring non-numeric properties.
while(length--){if(!eq(a[length],b[length],aStack,bStack))return false;}}else{// Deep compare objects.
var keys=_.keys(a),key;length=keys.length;// Ensure that both objects contain the same number of properties before comparing deep equality.
if(_.keys(b).length!==length)return false;while(length--){// Deep compare each member
key=keys[length];if(!(_.has(b,key)&&eq(a[key],b[key],aStack,bStack)))return false;}}// Remove the first object from the stack of traversed objects.
aStack.pop();bStack.pop();return true;};// Perform a deep comparison to check if two objects are equal.
_.isEqual=function(a,b){return eq(a,b);};// Is a given array, string, or object empty?
// An "empty" object has no enumerable own-properties.
_.isEmpty=function(obj){if(obj==null)return true;if(isArrayLike(obj)&&(_.isArray(obj)||_.isString(obj)||_.isArguments(obj)))return obj.length===0;return _.keys(obj).length===0;};// Is a given value a DOM element?
_.isElement=function(obj){return!!(obj&&obj.nodeType===1);};// Is a given value an array?
// Delegates to ECMA5's native Array.isArray
_.isArray=nativeIsArray||function(obj){return toString.call(obj)==='[object Array]';};// Is a given variable an object?
_.isObject=function(obj){var type=typeof obj==='undefined'?'undefined':_typeof(obj);return type==='function'||type==='object'&&!!obj;};// Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
_.each(['Arguments','Function','String','Number','Date','RegExp','Error'],function(name){_['is'+name]=function(obj){return toString.call(obj)==='[object '+name+']';};});// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
if(!_.isArguments(arguments)){_.isArguments=function(obj){return _.has(obj,'callee');};}// Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
// IE 11 (#1621), and in Safari 8 (#1929).
if(typeof /./!='function'&&(typeof Int8Array==='undefined'?'undefined':_typeof(Int8Array))!='object'){_.isFunction=function(obj){return typeof obj=='function'||false;};}// Is a given object a finite number?
_.isFinite=function(obj){return isFinite(obj)&&!isNaN(parseFloat(obj));};// Is the given value `NaN`? (NaN is the only number which does not equal itself).
_.isNaN=function(obj){return _.isNumber(obj)&&obj!==+obj;};// Is a given value a boolean?
_.isBoolean=function(obj){return obj===true||obj===false||toString.call(obj)==='[object Boolean]';};// Is a given value equal to null?
_.isNull=function(obj){return obj===null;};// Is a given variable undefined?
_.isUndefined=function(obj){return obj===void 0;};// Shortcut function for checking if an object has a given property directly
// on itself (in other words, not on a prototype).
_.has=function(obj,key){return obj!=null&&hasOwnProperty.call(obj,key);};// Utility Functions
// -----------------
// Run Underscore.js in *noConflict* mode, returning the `_` variable to its
// previous owner. Returns a reference to the Underscore object.
_.noConflict=function(){root._=previousUnderscore;return this;};// Keep the identity function around for default iteratees.
_.identity=function(value){return value;};// Predicate-generating functions. Often useful outside of Underscore.
_.constant=function(value){return function(){return value;};};_.noop=function(){};_.property=property;// Generates a function for a given object that returns a given property.
_.propertyOf=function(obj){return obj==null?function(){}:function(key){return obj[key];};};// Returns a predicate for checking whether an object has a given set of
// `key:value` pairs.
_.matcher=_.matches=function(attrs){attrs=_.extendOwn({},attrs);return function(obj){return _.isMatch(obj,attrs);};};// Run a function **n** times.
_.times=function(n,iteratee,context){var accum=Array(Math.max(0,n));iteratee=optimizeCb(iteratee,context,1);for(var i=0;i<n;i++){accum[i]=iteratee(i);}return accum;};// Return a random integer between min and max (inclusive).
_.random=function(min,max){if(max==null){max=min;min=0;}return min+Math.floor(Math.random()*(max-min+1));};// A (possibly faster) way to get the current timestamp as an integer.
_.now=Date.now||function(){return new Date().getTime();};// List of HTML entities for escaping.
var escapeMap={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#x27;','`':'&#x60;'};var unescapeMap=_.invert(escapeMap);// Functions for escaping and unescaping strings to/from HTML interpolation.
var createEscaper=function createEscaper(map){var escaper=function escaper(match){return map[match];};// Regexes for identifying a key that needs to be escaped
var source='(?:'+_.keys(map).join('|')+')';var testRegexp=RegExp(source);var replaceRegexp=RegExp(source,'g');return function(string){string=string==null?'':''+string;return testRegexp.test(string)?string.replace(replaceRegexp,escaper):string;};};_.escape=createEscaper(escapeMap);_.unescape=createEscaper(unescapeMap);// If the value of the named `property` is a function then invoke it with the
// `object` as context; otherwise, return it.
_.result=function(object,property,fallback){var value=object==null?void 0:object[property];if(value===void 0){value=fallback;}return _.isFunction(value)?value.call(object):value;};// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var idCounter=0;_.uniqueId=function(prefix){var id=++idCounter+'';return prefix?prefix+id:id;};// By default, Underscore uses ERB-style template delimiters, change the
// following template settings to use alternative delimiters.
_.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};// When customizing `templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var noMatch=/(.)^/;// Certain characters need to be escaped so that they can be put into a
// string literal.
var escapes={"'":"'",'\\':'\\','\r':'r','\n':'n','\u2028':'u2028','\u2029':'u2029'};var escaper=/\\|'|\r|\n|\u2028|\u2029/g;var escapeChar=function escapeChar(match){return'\\'+escapes[match];};// JavaScript micro-templating, similar to John Resig's implementation.
// Underscore templating handles arbitrary delimiters, preserves whitespace,
// and correctly escapes quotes within interpolated code.
// NB: `oldSettings` only exists for backwards compatibility.
_.template=function(text,settings,oldSettings){if(!settings&&oldSettings)settings=oldSettings;settings=_.defaults({},settings,_.templateSettings);// Combine delimiters into one regular expression via alternation.
var matcher=RegExp([(settings.escape||noMatch).source,(settings.interpolate||noMatch).source,(settings.evaluate||noMatch).source].join('|')+'|$','g');// Compile the template source, escaping string literals appropriately.
var index=0;var source="__p+='";text.replace(matcher,function(match,escape,interpolate,evaluate,offset){source+=text.slice(index,offset).replace(escaper,escapeChar);index=offset+match.length;if(escape){source+="'+\n((__t=("+escape+"))==null?'':_.escape(__t))+\n'";}else if(interpolate){source+="'+\n((__t=("+interpolate+"))==null?'':__t)+\n'";}else if(evaluate){source+="';\n"+evaluate+"\n__p+='";}// Adobe VMs need the match returned to produce the correct offest.
return match;});source+="';\n";// If a variable is not specified, place data values in local scope.
if(!settings.variable)source='with(obj||{}){\n'+source+'}\n';source="var __t,__p='',__j=Array.prototype.join,"+"print=function(){__p+=__j.call(arguments,'');};\n"+source+'return __p;\n';try{var render=new Function(settings.variable||'obj','_',source);}catch(e){e.source=source;throw e;}var template=function template(data){return render.call(this,data,_);};// Provide the compiled source as a convenience for precompilation.
var argument=settings.variable||'obj';template.source='function('+argument+'){\n'+source+'}';return template;};// Add a "chain" function. Start chaining a wrapped Underscore object.
_.chain=function(obj){var instance=_(obj);instance._chain=true;return instance;};// OOP
// ---------------
// If Underscore is called as a function, it returns a wrapped object that
// can be used OO-style. This wrapper holds altered versions of all the
// underscore functions. Wrapped objects may be chained.
// Helper function to continue chaining intermediate results.
var result=function result(instance,obj){return instance._chain?_(obj).chain():obj;};// Add your own custom functions to the Underscore object.
_.mixin=function(obj){_.each(_.functions(obj),function(name){var func=_[name]=obj[name];_.prototype[name]=function(){var args=[this._wrapped];push.apply(args,arguments);return result(this,func.apply(_,args));};});};// Add all of the Underscore functions to the wrapper object.
_.mixin(_);// Add all mutator Array functions to the wrapper.
_.each(['pop','push','reverse','shift','sort','splice','unshift'],function(name){var method=ArrayProto[name];_.prototype[name]=function(){var obj=this._wrapped;method.apply(obj,arguments);if((name==='shift'||name==='splice')&&obj.length===0)delete obj[0];return result(this,obj);};});// Add all accessor Array functions to the wrapper.
_.each(['concat','join','slice'],function(name){var method=ArrayProto[name];_.prototype[name]=function(){return result(this,method.apply(this._wrapped,arguments));};});// Extracts the result from a wrapped and chained object.
_.prototype.value=function(){return this._wrapped;};// Provide unwrapping proxy for some methods used in engine operations
// such as arithmetic and JSON stringification.
_.prototype.valueOf=_.prototype.toJSON=_.prototype.value;_.prototype.toString=function(){return''+this._wrapped;};// AMD registration happens at the end for compatibility with AMD loaders
// that may not enforce next-turn semantics on modules. Even though general
// practice for AMD registration is to be anonymous, underscore registers
// as a named module because, like jQuery, it is a base library that is
// popular enough to be bundled in a third party lib, but not be part of
// an AMD load request. Those cases could generate an error when an
// anonymous define() is called outside of a loader request.
{!(__WEBPACK_AMD_DEFINE_ARRAY__=[], __WEBPACK_AMD_DEFINE_RESULT__=function(){return _;}.apply(exports,__WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__!==undefined&&(module.exports=__WEBPACK_AMD_DEFINE_RESULT__));}}).call(this);/***/},/* 4 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);/* Transpose network.
	 */module.exports=function(net){var tnet={},inst_link,i;tnet.row_nodes=net.col_nodes;tnet.col_nodes=net.row_nodes;tnet.links=[];for(i=0;i<net.links.length;i++){inst_link={};inst_link.source=net.links[i].target;inst_link.target=net.links[i].source;inst_link.value=net.links[i].value;// Optional highlight.
if(utils.has(net.links[i],'highlight')){inst_link.highlight=net.links[i].highlight;}if(utils.has(net.links[i],'value_up')){inst_link.value_up=net.links[i].value_up;}if(utils.has(net.links[i],'value_dn')){inst_link.value_dn=net.links[i].value_dn;}if(utils.has(net.links[i],'info')){inst_link.info=net.links[i].info;}tnet.links.push(inst_link);}return tnet;};/***/},/* 5 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function get_available_filters(views){var possible_filters={};var filter_data={};underscore.each(views,function(inst_view){var inst_keys=underscore.keys(inst_view);underscore.each(inst_keys,function(inst_key){if(inst_key!='nodes'){if(!_.has(filter_data,inst_key)){filter_data[inst_key]=[];}filter_data[inst_key].push(inst_view[inst_key]);filter_data[inst_key]=underscore.uniq(filter_data[inst_key]);}});});var tmp_filters=underscore.keys(filter_data);underscore.each(tmp_filters,function(inst_filter){var options=filter_data[inst_filter];var num_options=options.length;var filter_type='categorical';underscore.each(options,function(inst_option){if(typeof inst_option==='number'){filter_type='numerical';}});if(num_options>1){possible_filters[inst_filter]=filter_type;}});var filters={};filters.possible_filters=possible_filters;filters.filter_data=filter_data;return filters;};/***/},/* 6 *//***/function(module,exports){module.exports=function get_filter_default_state(filter_data,filter_type){var default_state=filter_data[filter_type].sort(function(a,b){return b-a;})[0];default_state=String(default_state);return default_state;};/***/},/* 7 *//***/function(module,exports){module.exports=function set_defaults(){var defaults$$1={// Label options
row_label_scale:1,col_label_scale:1,super_labels:false,super:{},show_label_tooltips:true,show_tile_tooltips:true,// matrix options
transpose:false,tile_colors:['#FF0000','#1C86EE'],bar_colors:['#FF0000','#1C86EE'],// value-cat colors
// cat_value_colors: ['#2F4F4F', '#8A2BE2'],
cat_value_colors:['#2F4F4F','#9370DB'],outline_colors:['orange','black'],highlight_color:'#FFFF00',tile_title:false,// Default domain is set to 0: the domain will be set automatically
input_domain:0,opacity_scale:'linear',do_zoom:true,is_zoom:0,is_slider_drag:false,is_cropping:false,background_color:'#FFFFFF',super_border_color:'#F5F5F5',outer_margins:{top:0,bottom:0,left:0,right:0},ini_expand:false,grey_border_width:2,tile_click_hlight:false,super_label_scale:1,make_tile_tooltip:function make_tile_tooltip(d){return d.info;},// initialize view, e.g. initialize with row filtering
ini_view:null,// record of requested views
requested_view:null,use_sidebar:true,title:null,about:null,sidebar_width:160,sidebar_icons:true,row_search_placeholder:'Row',buffer_width:10,show_sim_mat:false,cat_colors:null,resize:true,clamp_opacity:0.85,expand_button:true,max_allow_fs:20,dendro_filter:{'row':false,'col':false},cat_filter:{'row':false,'col':false},crop_filter_nodes:{'row':false,'col':false},row_tip_callback:null,col_tip_callback:null,tile_tip_callback:null,matrix_update_callback:null,cat_update_callback:null,dendro_callback:null,dendro_click_callback:null,new_row_cats:null,make_modals:true,show_viz_border:false};return defaults$$1;};/***/},/* 8 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function check_sim_mat(config){var sim_mat=false;var num_rows=config.network_data.row_nodes_names.length;var num_cols=config.network_data.col_nodes_names.length;if(num_rows==num_cols){// the sort here was causing errors
var rows=config.network_data.row_nodes_names;var cols=config.network_data.col_nodes_names;sim_mat=true;underscore.each(rows,function(inst_row){var inst_index=rows.indexOf(inst_row);if(inst_row!==cols[inst_index]){sim_mat=false;}});}if(sim_mat){config.expand_button=false;}return sim_mat;};/***/},/* 9 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function check_nodes_for_categories(nodes){var super_string=': ';var has_cat=true;underscore.each(nodes,function(inst_node){var inst_name=String(inst_node.name);if(inst_name.indexOf(super_string)<0){has_cat=false;}});return has_cat;};/***/},/* 10 *//***/function(module,exports,__webpack_require__){var make_network_using_view=__webpack_require__(11);var ini_sidebar_params=__webpack_require__(63);var make_requested_view=__webpack_require__(64);var get_available_filters=__webpack_require__(5);var calc_viz_params=__webpack_require__(65);var ini_zoom_info=__webpack_require__(86);/*
	Params: calculates the size of all the visualization elements in the
	clustergram.
	 */module.exports=function make_params(input_config){var config=$.extend(true,{},input_config);var params=config;// keep a copy of inst_view
params.inst_nodes={};params.inst_nodes.row_nodes=params.network_data.row_nodes;params.inst_nodes.col_nodes=params.network_data.col_nodes;// when pre-loading the visualization using a view
if(params.ini_view!==null){var requested_view=params.ini_view;var filters=get_available_filters(params.network_data.views);params.viz={};params.viz.possible_filters=filters.possible_filters;params.viz.filter_data=filters.filter_data;requested_view=make_requested_view(params,requested_view);params.network_data=make_network_using_view(config,params,requested_view);// save ini_view as requested_view
params.requested_view=requested_view;}params=calc_viz_params(params);if(params.use_sidebar){params.sidebar=ini_sidebar_params(params);}params.zoom_info=ini_zoom_info();return params;};/***/},/* 11 *//***/function(module,exports,__webpack_require__){var filter_network_using_new_nodes=__webpack_require__(12);var get_subset_views=__webpack_require__(62);module.exports=function make_network_using_view(config,params,requested_view){var orig_views=config.network_data.views;var is_enr=false;if(_.has(orig_views[0],'enr_score_type')){is_enr=true;}var sub_views=get_subset_views(params,orig_views,requested_view);//////////////////////////////
// Enrichr specific rules
//////////////////////////////
if(is_enr&&sub_views.length==0){requested_view={'N_row_sum':'all','N_col_sum':'10'};sub_views=get_subset_views(params,orig_views,requested_view);}var inst_view=sub_views[0];var new_network_data;// get new_network_data or default back to old_network_data
if(typeof inst_view!=='undefined'){var new_nodes=inst_view.nodes;new_network_data=filter_network_using_new_nodes(config,new_nodes);}else{new_network_data=config.network_data;}return new_network_data;};/***/},/* 12 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);var core=__webpack_require__(13);var underscore=__webpack_require__(3);var math=core.create();math.import(__webpack_require__(24));math.import(__webpack_require__(61));module.exports=function filter_network_using_new_nodes(config,new_nodes){var links=config.network_data.links;// // make new mat from links
// var new_mat = config.network_data.mat;
// get new names of rows and cols
var row_names=utils.pluck(new_nodes.row_nodes,'name');var col_names=utils.pluck(new_nodes.col_nodes,'name');var new_mat=math.matrix(math.zeros([new_nodes.row_nodes.length,new_nodes.col_nodes.length]));new_mat=new_mat.toArray();var new_links=underscore.filter(links,function(inst_link){var inst_row=inst_link.name.split('_')[0];var inst_col=inst_link.name.split('_')[1];var row_index=underscore.indexOf(row_names,inst_row);var col_index=underscore.indexOf(col_names,inst_col);// only keep links that have not been filtered out
if(row_index>-1&col_index>-1){// redefine source and target
inst_link.source=row_index;inst_link.target=col_index;new_mat[row_index][col_index]=inst_link.value;return inst_link;}});// set up new_network_data
var new_network_data={};// rows
new_network_data.row_nodes=new_nodes.row_nodes;new_network_data.row_nodes_names=row_names;// cols
new_network_data.col_nodes=new_nodes.col_nodes;new_network_data.col_nodes_names=col_names;// save all links
new_network_data.links=new_links;new_network_data.all_links=links;// mat
new_network_data.mat=new_mat;// add back all views
new_network_data.views=config.network_data.views;// add cat_colors if necessary
if(_.has(config.network_data,'cat_colors')){new_network_data.cat_colors=config.network_data.cat_colors;}return new_network_data;};/***/},/* 13 *//***/function(module,exports,__webpack_require__){module.exports=__webpack_require__(14);/***/},/* 14 *//***/function(module,exports,__webpack_require__){var isFactory=__webpack_require__(15).isFactory;var typedFactory=__webpack_require__(16);var emitter=__webpack_require__(19);var importFactory=__webpack_require__(21);var configFactory=__webpack_require__(23);/**
	 * Math.js core. Creates a new, empty math.js instance
	 * @param {Object} [options] Available options:
	 *                            {number} epsilon
	 *                              Minimum relative difference between two
	 *                              compared values, used by all comparison functions.
	 *                            {string} matrix
	 *                              A string 'Matrix' (default) or 'Array'.
	 *                            {string} number
	 *                              A string 'number' (default), 'BigNumber', or 'Fraction'
	 *                            {number} precision
	 *                              The number of significant digits for BigNumbers.
	 *                              Not applicable for Numbers.
	 *                            {boolean} predictable
	 *                              Predictable output type of functions. When true,
	 *                              output type depends only on the input types. When
	 *                              false (default), output type can vary depending
	 *                              on input values. For example `math.sqrt(-4)`
	 *                              returns `complex('2i')` when predictable is false, and
	 *                              returns `NaN` when true.
	 *                            {string} randomSeed
	 *                              Random seed for seeded pseudo random number generator.
	 *                              Set to null to randomly seed.
	 * @returns {Object} Returns a bare-bone math.js instance containing
	 *                   functions:
	 *                   - `import` to add new functions
	 *                   - `config` to change configuration
	 *                   - `on`, `off`, `once`, `emit` for events
	 */exports.create=function create(options){// simple test for ES5 support
if(typeof Object.create!=='function'){throw new Error('ES5 not supported by this JavaScript engine. '+'Please load the es5-shim and es5-sham library for compatibility.');}// cached factories and instances
var factories=[];var instances=[];// create a namespace for the mathjs instance, and attach emitter functions
var math=emitter.mixin({});math.type={};math.expression={transform:{},mathWithTransform:{}};// create a new typed instance
math.typed=typedFactory.create(math.type);// create configuration options. These are private
var _config={// minimum relative difference between two compared values,
// used by all comparison functions
epsilon:1e-12,// type of default matrix output. Choose 'matrix' (default) or 'array'
matrix:'Matrix',// type of default number output. Choose 'number' (default) 'BigNumber', or 'Fraction
number:'number',// number of significant digits in BigNumbers
precision:64,// predictable output type of functions. When true, output type depends only
// on the input types. When false (default), output type can vary depending
// on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
// predictable is false, and returns `NaN` when true.
predictable:false,// random seed for seeded pseudo random number generation
// null = randomly seed
randomSeed:null};/**
	   * Load a function or data type from a factory.
	   * If the function or data type already exists, the existing instance is
	   * returned.
	   * @param {{type: string, name: string, factory: Function}} factory
	   * @returns {*}
	   */function load(factory){if(!isFactory(factory)){throw new Error('Factory object with properties `type`, `name`, and `factory` expected');}var index=factories.indexOf(factory);var instance;if(index===-1){// doesn't yet exist
if(factory.math===true){// pass with math namespace
instance=factory.factory(math.type,_config,load,math.typed,math);}else{instance=factory.factory(math.type,_config,load,math.typed);}// append to the cache
factories.push(factory);instances.push(instance);}else{// already existing function, return the cached instance
instance=instances[index];}return instance;}// load the import and config functions
math['import']=load(importFactory);math['config']=load(configFactory);math.expression.mathWithTransform['config']=math['config'];// apply options
if(options){math.config(options);}return math;};/***/},/* 15 *//***/function(module,exports){exports.clone=function clone(x){var type=typeof x==='undefined'?'undefined':_typeof(x);// immutable primitive types
if(type==='number'||type==='string'||type==='boolean'||x===null||x===undefined){return x;}// use clone function of the object when available
if(typeof x.clone==='function'){return x.clone();}// array
if(Array.isArray(x)){return x.map(function(value){return clone(value);});}if(x instanceof Number)return new Number(x.valueOf());if(x instanceof String)return new String(x.valueOf());if(x instanceof Boolean)return new Boolean(x.valueOf());if(x instanceof Date)return new Date(x.valueOf());if(x&&x.isBigNumber===true)return x;// bignumbers are immutable
if(x instanceof RegExp)throw new TypeError('Cannot clone '+x);// TODO: clone a RegExp
// object
return exports.map(x,clone);};/**
	 * Apply map to all properties of an object
	 * @param {Object} object
	 * @param {function} callback
	 * @return {Object} Returns a copy of the object with mapped properties
	 */exports.map=function(object,callback){var clone={};for(var key in object){if(exports.hasOwnProperty(object,key)){clone[key]=callback(object[key]);}}return clone;};/**
	 * Extend object a with the properties of object b
	 * @param {Object} a
	 * @param {Object} b
	 * @return {Object} a
	 */exports.extend=function(a,b){for(var prop in b){if(exports.hasOwnProperty(b,prop)){a[prop]=b[prop];}}return a;};/**
	 * Deep extend an object a with the properties of object b
	 * @param {Object} a
	 * @param {Object} b
	 * @returns {Object}
	 */exports.deepExtend=function deepExtend(a,b){// TODO: add support for Arrays to deepExtend
if(Array.isArray(b)){throw new TypeError('Arrays are not supported by deepExtend');}for(var prop in b){if(exports.hasOwnProperty(b,prop)){if(b[prop]&&b[prop].constructor===Object){if(a[prop]===undefined){a[prop]={};}if(a[prop].constructor===Object){deepExtend(a[prop],b[prop]);}else{a[prop]=b[prop];}}else if(Array.isArray(b[prop])){throw new TypeError('Arrays are not supported by deepExtend');}else{a[prop]=b[prop];}}}return a;};/**
	 * Deep test equality of all fields in two pairs of arrays or objects.
	 * @param {Array | Object} a
	 * @param {Array | Object} b
	 * @returns {boolean}
	 */exports.deepEqual=function deepEqual(a,b){var prop,i,len;if(Array.isArray(a)){if(!Array.isArray(b)){return false;}if(a.length!=b.length){return false;}for(i=0, len=a.length;i<len;i++){if(!exports.deepEqual(a[i],b[i])){return false;}}return true;}else if(a instanceof Object){if(Array.isArray(b)||!(b instanceof Object)){return false;}for(prop in a){//noinspection JSUnfilteredForInLoop
if(!exports.deepEqual(a[prop],b[prop])){return false;}}for(prop in b){//noinspection JSUnfilteredForInLoop
if(!exports.deepEqual(a[prop],b[prop])){return false;}}return true;}else{return(typeof a==='undefined'?'undefined':_typeof(a))===(typeof b==='undefined'?'undefined':_typeof(b))&&a==b;}};/**
	 * Test whether the current JavaScript engine supports Object.defineProperty
	 * @returns {boolean} returns true if supported
	 */exports.canDefineProperty=function(){// test needed for broken IE8 implementation
try{if(Object.defineProperty){Object.defineProperty({},'x',{get:function get$$1(){}});return true;}}catch(e){}return false;};/**
	 * Attach a lazy loading property to a constant.
	 * The given function `fn` is called once when the property is first requested.
	 * On older browsers (<IE8), the function will fall back to direct evaluation
	 * of the properties value.
	 * @param {Object} object   Object where to add the property
	 * @param {string} prop     Property name
	 * @param {Function} fn     Function returning the property value. Called
	 *                          without arguments.
	 */exports.lazy=function(object,prop,fn){if(exports.canDefineProperty()){var _uninitialized=true;var _value;Object.defineProperty(object,prop,{get:function get$$1(){if(_uninitialized){_value=fn();_uninitialized=false;}return _value;},set:function set$$1(value){_value=value;_uninitialized=false;},configurable:true,enumerable:true});}else{// fall back to immediate evaluation
object[prop]=fn();}};/**
	 * Traverse a path into an object.
	 * When a namespace is missing, it will be created
	 * @param {Object} object
	 * @param {string} path   A dot separated string like 'name.space'
	 * @return {Object} Returns the object at the end of the path
	 */exports.traverse=function(object,path){var obj=object;if(path){var names=path.split('.');for(var i=0;i<names.length;i++){var name=names[i];if(!(name in obj)){obj[name]={};}obj=obj[name];}}return obj;};/**
	 * A safe hasOwnProperty
	 * @param {Object} object
	 * @param {string} property
	 */exports.hasOwnProperty=function(object,property){return object&&Object.hasOwnProperty.call(object,property);};/**
	 * Test whether an object is a factory. a factory has fields:
	 *
	 * - factory: function (type: Object, config: Object, load: function, typed: function [, math: Object])   (required)
	 * - name: string (optional)
	 * - path: string    A dot separated path (optional)
	 * - math: boolean   If true (false by default), the math namespace is passed
	 *                   as fifth argument of the factory function
	 *
	 * @param {*} object
	 * @returns {boolean}
	 */exports.isFactory=function(object){return object&&typeof object.factory==='function';};/***/},/* 16 *//***/function(module,exports,__webpack_require__){var typedFunction=__webpack_require__(17);var digits=__webpack_require__(18).digits;// returns a new instance of typed-function
var _createTyped=function createTyped(){// initially, return the original instance of typed-function
// consecutively, return a new instance from typed.create.
_createTyped=typedFunction.create;return typedFunction;};/**
	 * Factory function for creating a new typed instance
	 * @param {Object} type   Object with data types like Complex and BigNumber
	 * @returns {Function}
	 */exports.create=function create(type){// TODO: typed-function must be able to silently ignore signatures with unknown data types
// get a new instance of typed-function
var typed=_createTyped();// define all types. The order of the types determines in which order function
// arguments are type-checked (so for performance it's important to put the
// most used types first).
typed.types=[{name:'number',test:function test(x){return typeof x==='number';}},{name:'Complex',test:function test(x){return x&&x.isComplex;}},{name:'BigNumber',test:function test(x){return x&&x.isBigNumber;}},{name:'Fraction',test:function test(x){return x&&x.isFraction;}},{name:'Unit',test:function test(x){return x&&x.isUnit;}},{name:'string',test:function test(x){return typeof x==='string';}},{name:'Array',test:Array.isArray},{name:'Matrix',test:function test(x){return x&&x.isMatrix;}},{name:'DenseMatrix',test:function test(x){return x&&x.isDenseMatrix;}},{name:'SparseMatrix',test:function test(x){return x&&x.isSparseMatrix;}},{name:'Range',test:function test(x){return x&&x.isRange;}},{name:'Index',test:function test(x){return x&&x.isIndex;}},{name:'boolean',test:function test(x){return typeof x==='boolean';}},{name:'ResultSet',test:function test(x){return x&&x.isResultSet;}},{name:'Help',test:function test(x){return x&&x.isHelp;}},{name:'function',test:function test(x){return typeof x==='function';}},{name:'Date',test:function test(x){return x instanceof Date;}},{name:'RegExp',test:function test(x){return x instanceof RegExp;}},{name:'Object',test:function test(x){return(typeof x==='undefined'?'undefined':_typeof(x))==='object';}},{name:'null',test:function test(x){return x===null;}},{name:'undefined',test:function test(x){return x===undefined;}},{name:'OperatorNode',test:function test(x){return x&&x.isOperatorNode;}},{name:'ConstantNode',test:function test(x){return x&&x.isConstantNode;}},{name:'SymbolNode',test:function test(x){return x&&x.isSymbolNode;}},{name:'ParenthesisNode',test:function test(x){return x&&x.isParenthesisNode;}},{name:'FunctionNode',test:function test(x){return x&&x.isFunctionNode;}},{name:'FunctionAssignmentNode',test:function test(x){return x&&x.isFunctionAssignmentNode;}},{name:'ArrayNode',test:function test(x){return x&&x.isArrayNode;}},{name:'AssignmentNode',test:function test(x){return x&&x.isAssignmentNode;}},{name:'BlockNode',test:function test(x){return x&&x.isBlockNode;}},{name:'ConditionalNode',test:function test(x){return x&&x.isConditionalNode;}},{name:'IndexNode',test:function test(x){return x&&x.isIndexNode;}},{name:'RangeNode',test:function test(x){return x&&x.isRangeNode;}},{name:'UpdateNode',test:function test(x){return x&&x.isUpdateNode;}},{name:'Node',test:function test(x){return x&&x.isNode;}}];// TODO: add conversion from BigNumber to number?
typed.conversions=[{from:'number',to:'BigNumber',convert:function convert(x){// note: conversion from number to BigNumber can fail if x has >15 digits
if(digits(x)>15){throw new TypeError('Cannot implicitly convert a number with >15 significant digits to BigNumber '+'(value: '+x+'). '+'Use function bignumber(x) to convert to BigNumber.');}return new type.BigNumber(x);}},{from:'number',to:'Complex',convert:function convert(x){return new type.Complex(x,0);}},{from:'number',to:'string',convert:function convert(x){return x+'';}},{from:'BigNumber',to:'Complex',convert:function convert(x){return new type.Complex(x.toNumber(),0);}},{from:'Fraction',to:'BigNumber',convert:function convert(x){throw new TypeError('Cannot implicitly convert a Fraction to BigNumber or vice versa. '+'Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.');}},{from:'Fraction',to:'Complex',convert:function convert(x){return new type.Complex(x.valueOf(),0);}},{from:'number',to:'Fraction',convert:function convert(x){var f=new type.Fraction(x);if(f.valueOf()!==x){throw new TypeError('Cannot implicitly convert a number to a Fraction when there will be a loss of precision '+'(value: '+x+'). '+'Use function fraction(x) to convert to Fraction.');}return new type.Fraction(x);}},{// FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
//  from: 'Fraction',
//  to: 'number',
//  convert: function (x) {
//    return x.valueOf();
//  }
//}, {
from:'string',to:'number',convert:function convert(x){var n=Number(x);if(isNaN(n)){throw new Error('Cannot convert "'+x+'" to a number');}return n;}},{from:'string',to:'BigNumber',convert:function convert(x){try{return new type.BigNumber(x);}catch(err){throw new Error('Cannot convert "'+x+'" to BigNumber');}}},{from:'string',to:'Fraction',convert:function convert(x){try{return new type.Fraction(x);}catch(err){throw new Error('Cannot convert "'+x+'" to Fraction');}}},{from:'string',to:'Complex',convert:function convert(x){try{return new type.Complex(x);}catch(err){throw new Error('Cannot convert "'+x+'" to Complex');}}},{from:'boolean',to:'number',convert:function convert(x){return+x;}},{from:'boolean',to:'BigNumber',convert:function convert(x){return new type.BigNumber(+x);}},{from:'boolean',to:'Fraction',convert:function convert(x){return new type.Fraction(+x);}},{from:'boolean',to:'string',convert:function convert(x){return+x;}},{from:'null',to:'number',convert:function convert(){return 0;}},{from:'null',to:'string',convert:function convert(){return'null';}},{from:'null',to:'BigNumber',convert:function convert(){return new type.BigNumber(0);}},{from:'null',to:'Fraction',convert:function convert(){return new type.Fraction(0);}},{from:'Array',to:'Matrix',convert:function convert(array){// TODO: how to decide on the right type of matrix to create?
return new type.DenseMatrix(array);}},{from:'Matrix',to:'Array',convert:function convert(matrix){return matrix.valueOf();}}];return typed;};/***/},/* 17 *//***/function(module,exports,__webpack_require__){var __WEBPACK_AMD_DEFINE_FACTORY__,__WEBPACK_AMD_DEFINE_ARRAY__,__WEBPACK_AMD_DEFINE_RESULT__;/**
	 * typed-function
	 *
	 * Type checking for JavaScript functions
	 *
	 * https://github.com/josdejong/typed-function
	 */(function(root,factory){{// AMD. Register as an anonymous module.
!(__WEBPACK_AMD_DEFINE_ARRAY__=[], __WEBPACK_AMD_DEFINE_FACTORY__=factory, __WEBPACK_AMD_DEFINE_RESULT__=typeof __WEBPACK_AMD_DEFINE_FACTORY__==='function'?__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports,__WEBPACK_AMD_DEFINE_ARRAY__):__WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__!==undefined&&(module.exports=__WEBPACK_AMD_DEFINE_RESULT__));}})(this,function(){// factory function to create a new instance of typed-function
// TODO: allow passing configuration, types, tests via the factory function
function create(){/**
	     * Get a type test function for a specific data type
	     * @param {string} name                   Name of a data type like 'number' or 'string'
	     * @returns {Function(obj: *) : boolean}  Returns a type testing function.
	     *                                        Throws an error for an unknown type.
	     */function getTypeTest(name){var test;for(var i=0;i<typed.types.length;i++){var entry=typed.types[i];if(entry.name===name){test=entry.test;break;}}if(!test){var hint;for(i=0;i<typed.types.length;i++){entry=typed.types[i];if(entry.name.toLowerCase()==name.toLowerCase()){hint=entry.name;break;}}throw new Error('Unknown type "'+name+'"'+(hint?'. Did you mean "'+hint+'"?':''));}return test;}/**
	     * Retrieve the function name from a set of functions, and check
	     * whether the name of all functions match (if given)
	     * @param {Array.<function>} fns
	     */function getName(fns){var name='';for(var i=0;i<fns.length;i++){var fn=fns[i];// merge function name when this is a typed function
if(fn.signatures&&fn.name!=''){if(name==''){name=fn.name;}else if(name!=fn.name){var err=new Error('Function names do not match (expected: '+name+', actual: '+fn.name+')');err.data={actual:fn.name,expected:name};throw err;}}}return name;}/**
	     * Create an ArgumentsError. Creates messages like:
	     *
	     *   Unexpected type of argument (expected: ..., actual: ..., index: ...)
	     *   Too few arguments (expected: ..., index: ...)
	     *   Too many arguments (expected: ..., actual: ...)
	     *
	     * @param {String} fn         Function name
	     * @param {number} argCount   Number of arguments
	     * @param {Number} index      Current argument index
	     * @param {*} actual          Current argument
	     * @param {string} [expected] An optional, comma separated string with
	     *                            expected types on given index
	     * @extends Error
	     */function createError(fn,argCount,index,actual,expected){var actualType=getTypeOf(actual);var _expected=expected?expected.split(','):null;var _fn=fn||'unnamed';var anyType=_expected&&contains(_expected,'any');var message;var data={fn:fn,index:index,actual:actual,expected:_expected};if(_expected){if(argCount>index&&!anyType){// unexpected type
message='Unexpected type of argument in function '+_fn+' (expected: '+_expected.join(' or ')+', actual: '+actualType+', index: '+index+')';}else{// too few arguments
message='Too few arguments in function '+_fn+' (expected: '+_expected.join(' or ')+', index: '+index+')';}}else{// too many arguments
message='Too many arguments in function '+_fn+' (expected: '+index+', actual: '+argCount+')';}var err=new TypeError(message);err.data=data;return err;}/**
	     * Collection with function references (local shortcuts to functions)
	     * @constructor
	     * @param {string} [name='refs']  Optional name for the refs, used to generate
	     *                                JavaScript code
	     */function Refs(name){this.name=name||'refs';this.categories={};}/**
	     * Add a function reference.
	     * @param {Function} fn
	     * @param {string} [category='fn']    A function category, like 'fn' or 'signature'
	     * @returns {string} Returns the function name, for example 'fn0' or 'signature2'
	     */Refs.prototype.add=function(fn,category){var cat=category||'fn';if(!this.categories[cat])this.categories[cat]=[];var index=this.categories[cat].indexOf(fn);if(index==-1){index=this.categories[cat].length;this.categories[cat].push(fn);}return cat+index;};/**
	     * Create code lines for all function references
	     * @returns {string} Returns the code containing all function references
	     */Refs.prototype.toCode=function(){var code=[];var path=this.name+'.categories';var categories=this.categories;for(var cat in categories){if(categories.hasOwnProperty(cat)){var category=categories[cat];for(var i=0;i<category.length;i++){code.push('var '+cat+i+' = '+path+'[\''+cat+'\']['+i+'];');}}}return code.join('\n');};/**
	     * A function parameter
	     * @param {string | string[] | Param} types    A parameter type like 'string',
	     *                                             'number | boolean'
	     * @param {boolean} [varArgs=false]            Variable arguments if true
	     * @constructor
	     */function Param(types,varArgs){// parse the types, can be a string with types separated by pipe characters |
if(typeof types==='string'){// parse variable arguments operator (ellipses '...number')
var _types=types.trim();var _varArgs=_types.substr(0,3)==='...';if(_varArgs){_types=_types.substr(3);}if(_types===''){this.types=['any'];}else{this.types=_types.split('|');for(var i=0;i<this.types.length;i++){this.types[i]=this.types[i].trim();}}}else if(Array.isArray(types)){this.types=types;}else if(types instanceof Param){return types.clone();}else{throw new Error('String or Array expected');}// can hold a type to which to convert when handling this parameter
this.conversions=[];// TODO: implement better API for conversions, be able to add conversions via constructor (support a new type Object?)
// variable arguments
this.varArgs=_varArgs||varArgs||false;// check for any type arguments
this.anyType=this.types.indexOf('any')!==-1;}/**
	     * Order Params
	     * any type ('any') will be ordered last, and object as second last (as other
	     * types may be an object as well, like Array).
	     *
	     * @param {Param} a
	     * @param {Param} b
	     * @returns {number} Returns 1 if a > b, -1 if a < b, and else 0.
	     */Param.compare=function(a,b){// TODO: simplify parameter comparison, it's a mess
if(a.anyType)return 1;if(b.anyType)return-1;if(contains(a.types,'Object'))return 1;if(contains(b.types,'Object'))return-1;if(a.hasConversions()){if(b.hasConversions()){var i,ac,bc;for(i=0;i<a.conversions.length;i++){if(a.conversions[i]!==undefined){ac=a.conversions[i];break;}}for(i=0;i<b.conversions.length;i++){if(b.conversions[i]!==undefined){bc=b.conversions[i];break;}}return typed.conversions.indexOf(ac)-typed.conversions.indexOf(bc);}else{return 1;}}else{if(b.hasConversions()){return-1;}else{// both params have no conversions
var ai,bi;for(i=0;i<typed.types.length;i++){if(typed.types[i].name===a.types[0]){ai=i;break;}}for(i=0;i<typed.types.length;i++){if(typed.types[i].name===b.types[0]){bi=i;break;}}return ai-bi;}}};/**
	     * Test whether this parameters types overlap an other parameters types.
	     * Will not match ['any'] with ['number']
	     * @param {Param} other
	     * @return {boolean} Returns true when there are overlapping types
	     */Param.prototype.overlapping=function(other){for(var i=0;i<this.types.length;i++){if(contains(other.types,this.types[i])){return true;}}return false;};/**
	     * Test whether this parameters types matches an other parameters types.
	     * When any of the two parameters contains `any`, true is returned
	     * @param {Param} other
	     * @return {boolean} Returns true when there are matching types
	     */Param.prototype.matches=function(other){return this.anyType||other.anyType||this.overlapping(other);};/**
	     * Create a clone of this param
	     * @returns {Param} Returns a cloned version of this param
	     */Param.prototype.clone=function(){var param=new Param(this.types.slice(),this.varArgs);param.conversions=this.conversions.slice();return param;};/**
	     * Test whether this parameter contains conversions
	     * @returns {boolean} Returns true if the parameter contains one or
	     *                    multiple conversions.
	     */Param.prototype.hasConversions=function(){return this.conversions.length>0;};/**
	     * Tests whether this parameters contains any of the provided types
	     * @param {Object} types  A Map with types, like {'number': true}
	     * @returns {boolean}     Returns true when the parameter contains any
	     *                        of the provided types
	     */Param.prototype.contains=function(types){for(var i=0;i<this.types.length;i++){if(types[this.types[i]]){return true;}}return false;};/**
	     * Return a string representation of this params types, like 'string' or
	     * 'number | boolean' or '...number'
	     * @param {boolean} [toConversion]   If true, the returned types string
	     *                                   contains the types where the parameter
	     *                                   will convert to. If false (default)
	     *                                   the "from" types are returned
	     * @returns {string}
	     */Param.prototype.toString=function(toConversion){var types=[];var keys={};for(var i=0;i<this.types.length;i++){var conversion=this.conversions[i];var type=toConversion&&conversion?conversion.to:this.types[i];if(!(type in keys)){keys[type]=true;types.push(type);}}return(this.varArgs?'...':'')+types.join('|');};/**
	     * A function signature
	     * @param {string | string[] | Param[]} params
	     *                         Array with the type(s) of each parameter,
	     *                         or a comma separated string with types
	     * @param {Function} fn    The actual function
	     * @constructor
	     */function Signature(params,fn){var _params;if(typeof params==='string'){_params=params!==''?params.split(','):[];}else if(Array.isArray(params)){_params=params;}else{throw new Error('string or Array expected');}this.params=new Array(_params.length);this.anyType=false;this.varArgs=false;for(var i=0;i<_params.length;i++){var param=new Param(_params[i]);this.params[i]=param;if(param.anyType){this.anyType=true;}if(i===_params.length-1){// the last argument
this.varArgs=param.varArgs;}else{// non-last argument
if(param.varArgs){throw new SyntaxError('Unexpected variable arguments operator "..."');}}}this.fn=fn;}/**
	     * Create a clone of this signature
	     * @returns {Signature} Returns a cloned version of this signature
	     */Signature.prototype.clone=function(){return new Signature(this.params.slice(),this.fn);};/**
	     * Expand a signature: split params with union types in separate signatures
	     * For example split a Signature "string | number" into two signatures.
	     * @return {Signature[]} Returns an array with signatures (at least one)
	     */Signature.prototype.expand=function(){var signatures=[];function recurse(signature,path){if(path.length<signature.params.length){var i,newParam,conversion;var param=signature.params[path.length];if(param.varArgs){// a variable argument. do not split the types in the parameter
newParam=param.clone();// add conversions to the parameter
// recurse for all conversions
for(i=0;i<typed.conversions.length;i++){conversion=typed.conversions[i];if(!contains(param.types,conversion.from)&&contains(param.types,conversion.to)){var j=newParam.types.length;newParam.types[j]=conversion.from;newParam.conversions[j]=conversion;}}recurse(signature,path.concat(newParam));}else{// split each type in the parameter
for(i=0;i<param.types.length;i++){recurse(signature,path.concat(new Param(param.types[i])));}// recurse for all conversions
for(i=0;i<typed.conversions.length;i++){conversion=typed.conversions[i];if(!contains(param.types,conversion.from)&&contains(param.types,conversion.to)){newParam=new Param(conversion.from);newParam.conversions[0]=conversion;recurse(signature,path.concat(newParam));}}}}else{signatures.push(new Signature(path,signature.fn));}}recurse(this,[]);return signatures;};/**
	     * Compare two signatures.
	     *
	     * When two params are equal and contain conversions, they will be sorted
	     * by lowest index of the first conversions.
	     *
	     * @param {Signature} a
	     * @param {Signature} b
	     * @returns {number} Returns 1 if a > b, -1 if a < b, and else 0.
	     */Signature.compare=function(a,b){if(a.params.length>b.params.length)return 1;if(a.params.length<b.params.length)return-1;// count the number of conversions
var i;var len=a.params.length;// a and b have equal amount of params
var ac=0;var bc=0;for(i=0;i<len;i++){if(a.params[i].hasConversions())ac++;if(b.params[i].hasConversions())bc++;}if(ac>bc)return 1;if(ac<bc)return-1;// compare the order per parameter
for(i=0;i<a.params.length;i++){var cmp=Param.compare(a.params[i],b.params[i]);if(cmp!==0){return cmp;}}return 0;};/**
	     * Test whether any of the signatures parameters has conversions
	     * @return {boolean} Returns true when any of the parameters contains
	     *                   conversions.
	     */Signature.prototype.hasConversions=function(){for(var i=0;i<this.params.length;i++){if(this.params[i].hasConversions()){return true;}}return false;};/**
	     * Test whether this signature should be ignored.
	     * Checks whether any of the parameters contains a type listed in
	     * typed.ignore
	     * @return {boolean} Returns true when the signature should be ignored
	     */Signature.prototype.ignore=function(){// create a map with ignored types
var types={};for(var i=0;i<typed.ignore.length;i++){types[typed.ignore[i]]=true;}// test whether any of the parameters contains this type
for(i=0;i<this.params.length;i++){if(this.params[i].contains(types)){return true;}}return false;};/**
	     * Test whether the path of this signature matches a given path.
	     * @param {Param[]} params
	     */Signature.prototype.paramsStartWith=function(params){if(params.length===0){return true;}var aLast=last(this.params);var bLast=last(params);for(var i=0;i<params.length;i++){var a=this.params[i]||(aLast.varArgs?aLast:null);var b=params[i]||(bLast.varArgs?bLast:null);if(!a||!b||!a.matches(b)){return false;}}return true;};/**
	     * Generate the code to invoke this signature
	     * @param {Refs} refs
	     * @param {string} prefix
	     * @returns {string} Returns code
	     */Signature.prototype.toCode=function(refs,prefix){var code=[];var args=new Array(this.params.length);for(var i=0;i<this.params.length;i++){var param=this.params[i];var conversion=param.conversions[0];if(param.varArgs){args[i]='varArgs';}else if(conversion){args[i]=refs.add(conversion.convert,'convert')+'(arg'+i+')';}else{args[i]='arg'+i;}}var ref=this.fn?refs.add(this.fn,'signature'):undefined;if(ref){return prefix+'return '+ref+'('+args.join(', ')+'); // signature: '+this.params.join(', ');}return code.join('\n');};/**
	     * Return a string representation of the signature
	     * @returns {string}
	     */Signature.prototype.toString=function(){return this.params.join(', ');};/**
	     * A group of signatures with the same parameter on given index
	     * @param {Param[]} path
	     * @param {Signature} [signature]
	     * @param {Node[]} childs
	     * @param {boolean} [fallThrough=false]
	     * @constructor
	     */function Node(path,signature,childs,fallThrough){this.path=path||[];this.param=path[path.length-1]||null;this.signature=signature||null;this.childs=childs||[];this.fallThrough=fallThrough||false;}/**
	     * Generate code for this group of signatures
	     * @param {Refs} refs
	     * @param {string} prefix
	     * @returns {string} Returns the code as string
	     */Node.prototype.toCode=function(refs,prefix){// TODO: split this function in multiple functions, it's too large
var code=[];if(this.param){var index=this.path.length-1;var conversion=this.param.conversions[0];var comment='// type: '+(conversion?conversion.from+' (convert to '+conversion.to+')':this.param);// non-root node (path is non-empty)
if(this.param.varArgs){if(this.param.anyType){// variable arguments with any type
code.push(prefix+'if (arguments.length > '+index+') {');code.push(prefix+'  var varArgs = [];');code.push(prefix+'  for (var i = '+index+'; i < arguments.length; i++) {');code.push(prefix+'    varArgs.push(arguments[i]);');code.push(prefix+'  }');code.push(this.signature.toCode(refs,prefix+'  '));code.push(prefix+'}');}else{// variable arguments with a fixed type
var getTests=function(types,arg){var tests=[];for(var i=0;i<types.length;i++){tests[i]=refs.add(getTypeTest(types[i]),'test')+'('+arg+')';}return tests.join(' || ');}.bind(this);var allTypes=this.param.types;var exactTypes=[];for(var i=0;i<allTypes.length;i++){if(this.param.conversions[i]===undefined){exactTypes.push(allTypes[i]);}}code.push(prefix+'if ('+getTests(allTypes,'arg'+index)+') { '+comment);code.push(prefix+'  var varArgs = [arg'+index+'];');code.push(prefix+'  for (var i = '+(index+1)+'; i < arguments.length; i++) {');code.push(prefix+'    if ('+getTests(exactTypes,'arguments[i]')+') {');code.push(prefix+'      varArgs.push(arguments[i]);');for(var i=0;i<allTypes.length;i++){var conversion_i=this.param.conversions[i];if(conversion_i){var test=refs.add(getTypeTest(allTypes[i]),'test');var convert=refs.add(conversion_i.convert,'convert');code.push(prefix+'    }');code.push(prefix+'    else if ('+test+'(arguments[i])) {');code.push(prefix+'      varArgs.push('+convert+'(arguments[i]));');}}code.push(prefix+'    } else {');code.push(prefix+'      throw createError(name, arguments.length, i, arguments[i], \''+exactTypes.join(',')+'\');');code.push(prefix+'    }');code.push(prefix+'  }');code.push(this.signature.toCode(refs,prefix+'  '));code.push(prefix+'}');}}else{if(this.param.anyType){// any type
code.push(prefix+'// type: any');code.push(this._innerCode(refs,prefix));}else{// regular type
var type=this.param.types[0];var test=type!=='any'?refs.add(getTypeTest(type),'test'):null;code.push(prefix+'if ('+test+'(arg'+index+')) { '+comment);code.push(this._innerCode(refs,prefix+'  '));code.push(prefix+'}');}}}else{// root node (path is empty)
code.push(this._innerCode(refs,prefix));}return code.join('\n');};/**
	     * Generate inner code for this group of signatures.
	     * This is a helper function of Node.prototype.toCode
	     * @param {Refs} refs
	     * @param {string} prefix
	     * @returns {string} Returns the inner code as string
	     * @private
	     */Node.prototype._innerCode=function(refs,prefix){var code=[];var i;if(this.signature){code.push(prefix+'if (arguments.length === '+this.path.length+') {');code.push(this.signature.toCode(refs,prefix+'  '));code.push(prefix+'}');}for(i=0;i<this.childs.length;i++){code.push(this.childs[i].toCode(refs,prefix));}// TODO: shouldn't the this.param.anyType check be redundant
if(!this.fallThrough||this.param&&this.param.anyType){var exceptions=this._exceptions(refs,prefix);if(exceptions){code.push(exceptions);}}return code.join('\n');};/**
	     * Generate code to throw exceptions
	     * @param {Refs} refs
	     * @param {string} prefix
	     * @returns {string} Returns the inner code as string
	     * @private
	     */Node.prototype._exceptions=function(refs,prefix){var index=this.path.length;if(this.childs.length===0){// TODO: can this condition be simplified? (we have a fall-through here)
return[prefix+'if (arguments.length > '+index+') {',prefix+'  throw createError(name, arguments.length, '+index+', arguments['+index+']);',prefix+'}'].join('\n');}else{var keys={};var types=[];for(var i=0;i<this.childs.length;i++){var node=this.childs[i];if(node.param){for(var j=0;j<node.param.types.length;j++){var type=node.param.types[j];if(!(type in keys)&&!node.param.conversions[j]){keys[type]=true;types.push(type);}}}}return prefix+'throw createError(name, arguments.length, '+index+', arguments['+index+'], \''+types.join(',')+'\');';}};/**
	     * Split all raw signatures into an array with expanded Signatures
	     * @param {Object.<string, Function>} rawSignatures
	     * @return {Signature[]} Returns an array with expanded signatures
	     */function parseSignatures(rawSignatures){// FIXME: need to have deterministic ordering of signatures, do not create via object
var signature;var keys={};var signatures=[];var i;for(var types in rawSignatures){if(rawSignatures.hasOwnProperty(types)){var fn=rawSignatures[types];signature=new Signature(types,fn);if(signature.ignore()){continue;}var expanded=signature.expand();for(i=0;i<expanded.length;i++){var signature_i=expanded[i];var key=signature_i.toString();var existing=keys[key];if(!existing){keys[key]=signature_i;}else{var cmp=Signature.compare(signature_i,existing);if(cmp<0){// override if sorted first
keys[key]=signature_i;}else if(cmp===0){throw new Error('Signature "'+key+'" is defined twice');}// else: just ignore
}}}}// convert from map to array
for(key in keys){if(keys.hasOwnProperty(key)){signatures.push(keys[key]);}}// order the signatures
signatures.sort(function(a,b){return Signature.compare(a,b);});// filter redundant conversions from signatures with varArgs
// TODO: simplify this loop or move it to a separate function
for(i=0;i<signatures.length;i++){signature=signatures[i];if(signature.varArgs){var index=signature.params.length-1;var param=signature.params[index];var t=0;while(t<param.types.length){if(param.conversions[t]){var type=param.types[t];for(var j=0;j<signatures.length;j++){var other=signatures[j];var p=other.params[index];if(other!==signature&&p&&contains(p.types,type)&&!p.conversions[index]){// this (conversion) type already exists, remove it
param.types.splice(t,1);param.conversions.splice(t,1);t--;break;}}}t++;}}}return signatures;}/**
	     * Filter all any type signatures
	     * @param {Signature[]} signatures
	     * @return {Signature[]} Returns only any type signatures
	     */function filterAnyTypeSignatures(signatures){var filtered=[];for(var i=0;i<signatures.length;i++){if(signatures[i].anyType){filtered.push(signatures[i]);}}return filtered;}/**
	     * create a map with normalized signatures as key and the function as value
	     * @param {Signature[]} signatures   An array with split signatures
	     * @return {Object.<string, Function>} Returns a map with normalized
	     *                                     signatures as key, and the function
	     *                                     as value.
	     */function mapSignatures(signatures){var normalized={};for(var i=0;i<signatures.length;i++){var signature=signatures[i];if(signature.fn&&!signature.hasConversions()){var params=signature.params.join(',');normalized[params]=signature.fn;}}return normalized;}/**
	     * Parse signatures recursively in a node tree.
	     * @param {Signature[]} signatures  Array with expanded signatures
	     * @param {Param[]} path            Traversed path of parameter types
	     * @param {Signature[]} anys
	     * @return {Node}                   Returns a node tree
	     */function parseTree(signatures,path,anys){var i,signature;var index=path.length;var nodeSignature;var filtered=[];for(i=0;i<signatures.length;i++){signature=signatures[i];// filter the first signature with the correct number of params
if(signature.params.length===index&&!nodeSignature){nodeSignature=signature;}if(signature.params[index]!=undefined){filtered.push(signature);}}// sort the filtered signatures by param
filtered.sort(function(a,b){return Param.compare(a.params[index],b.params[index]);});// recurse over the signatures
var entries=[];for(i=0;i<filtered.length;i++){signature=filtered[i];// group signatures with the same param at current index
var param=signature.params[index];// TODO: replace the next filter loop
var existing=entries.filter(function(entry){return entry.param.overlapping(param);})[0];//var existing;
//for (var j = 0; j < entries.length; j++) {
//  if (entries[j].param.overlapping(param)) {
//    existing = entries[j];
//    break;
//  }
//}
if(existing){if(existing.param.varArgs){throw new Error('Conflicting types "'+existing.param+'" and "'+param+'"');}existing.signatures.push(signature);}else{entries.push({param:param,signatures:[signature]});}}// find all any type signature that can still match our current path
var matchingAnys=[];for(i=0;i<anys.length;i++){if(anys[i].paramsStartWith(path)){matchingAnys.push(anys[i]);}}// see if there are any type signatures that don't match any of the
// signatures that we have in our tree, i.e. we have alternative
// matching signature(s) outside of our current tree and we should
// fall through to them instead of throwing an exception
var fallThrough=false;for(i=0;i<matchingAnys.length;i++){if(!contains(signatures,matchingAnys[i])){fallThrough=true;break;}}// parse the childs
var childs=new Array(entries.length);for(i=0;i<entries.length;i++){var entry=entries[i];childs[i]=parseTree(entry.signatures,path.concat(entry.param),matchingAnys);}return new Node(path,nodeSignature,childs,fallThrough);}/**
	     * Generate an array like ['arg0', 'arg1', 'arg2']
	     * @param {number} count Number of arguments to generate
	     * @returns {Array} Returns an array with argument names
	     */function getArgs(count){// create an array with all argument names
var args=[];for(var i=0;i<count;i++){args[i]='arg'+i;}return args;}/**
	     * Compose a function from sub-functions each handling a single type signature.
	     * Signatures:
	     *   typed(signature: string, fn: function)
	     *   typed(name: string, signature: string, fn: function)
	     *   typed(signatures: Object.<string, function>)
	     *   typed(name: string, signatures: Object.<string, function>)
	     *
	     * @param {string | null} name
	     * @param {Object.<string, Function>} signatures
	     * @return {Function} Returns the typed function
	     * @private
	     */function _typed(name,signatures){var refs=new Refs();// parse signatures, expand them
var _signatures=parseSignatures(signatures);if(_signatures.length==0){throw new Error('No signatures provided');}// filter all any type signatures
var anys=filterAnyTypeSignatures(_signatures);// parse signatures into a node tree
var node=parseTree(_signatures,[],anys);//var util = require('util');
//console.log('ROOT');
//console.log(util.inspect(node, { depth: null }));
// generate code for the typed function
var code=[];var _name=name||'';var _args=getArgs(maxParams(_signatures));code.push('function '+_name+'('+_args.join(', ')+') {');code.push('  "use strict";');code.push('  var name = \''+_name+'\';');code.push(node.toCode(refs,'  ',false));code.push('}');// generate body for the factory function
var body=[refs.toCode(),'return '+code.join('\n')].join('\n');// evaluate the JavaScript code and attach function references
var factory=new Function(refs.name,'createError',body);var fn=factory(refs,createError);//console.log('FN\n' + fn.toString()); // TODO: cleanup
// attach the signatures with sub-functions to the constructed function
fn.signatures=mapSignatures(_signatures);return fn;}/**
	     * Calculate the maximum number of parameters in givens signatures
	     * @param {Signature[]} signatures
	     * @returns {number} The maximum number of parameters
	     */function maxParams(signatures){var max=0;for(var i=0;i<signatures.length;i++){var len=signatures[i].params.length;if(len>max){max=len;}}return max;}/**
	     * Get the type of a value
	     * @param {*} x
	     * @returns {string} Returns a string with the type of value
	     */function getTypeOf(x){var obj;for(var i=0;i<typed.types.length;i++){var entry=typed.types[i];if(entry.name==='Object'){// Array and Date are also Object, so test for Object afterwards
obj=entry;}else{if(entry.test(x))return entry.name;}}// at last, test whether an object
if(obj&&obj.test(x))return obj.name;return'unknown';}/**
	     * Test whether an array contains some item
	     * @param {Array} array
	     * @param {*} item
	     * @return {boolean} Returns true if array contains item, false if not.
	     */function contains(array,item){return array.indexOf(item)!==-1;}/**
	     * Returns the last item in the array
	     * @param {Array} array
	     * @return {*} item
	     */function last(array){return array[array.length-1];}// data type tests
var types=[{name:'number',test:function test(x){return typeof x==='number';}},{name:'string',test:function test(x){return typeof x==='string';}},{name:'boolean',test:function test(x){return typeof x==='boolean';}},{name:'Function',test:function test(x){return typeof x==='function';}},{name:'Array',test:Array.isArray},{name:'Date',test:function test(x){return x instanceof Date;}},{name:'RegExp',test:function test(x){return x instanceof RegExp;}},{name:'Object',test:function test(x){return(typeof x==='undefined'?'undefined':_typeof(x))==='object';}},{name:'null',test:function test(x){return x===null;}},{name:'undefined',test:function test(x){return x===undefined;}}];// configuration
var config={};// type conversions. Order is important
var conversions=[];// types to be ignored
var ignore=[];// temporary object for holding types and conversions, for constructing
// the `typed` function itself
// TODO: find a more elegant solution for this
var typed={config:config,types:types,conversions:conversions,ignore:ignore};/**
	     * Construct the typed function itself with various signatures
	     *
	     * Signatures:
	     *
	     *   typed(signatures: Object.<string, function>)
	     *   typed(name: string, signatures: Object.<string, function>)
	     */typed=_typed('typed',{'Object':function Object(signatures){var fns=[];for(var signature in signatures){if(signatures.hasOwnProperty(signature)){fns.push(signatures[signature]);}}var name=getName(fns);return _typed(name,signatures);},'string, Object':_typed,// TODO: add a signature 'Array.<function>'
'...Function':function Function(fns){var err;var name=getName(fns);var signatures={};for(var i=0;i<fns.length;i++){var fn=fns[i];// test whether this is a typed-function
if(!(_typeof(fn.signatures)==='object')){err=new TypeError('Function is no typed-function (index: '+i+')');err.data={index:i};throw err;}// merge the signatures
for(var signature in fn.signatures){if(fn.signatures.hasOwnProperty(signature)){if(signatures.hasOwnProperty(signature)){if(fn.signatures[signature]!==signatures[signature]){err=new Error('Signature "'+signature+'" is defined twice');err.data={signature:signature};throw err;}// else: both signatures point to the same function, that's fine
}else{signatures[signature]=fn.signatures[signature];}}}}return _typed(name,signatures);}});/**
	     * Find a specific signature from a (composed) typed function, for
	     * example:
	     *
	     *   typed.find(fn, ['number', 'string'])
	     *   typed.find(fn, 'number, string')
	     *
	     * Function find only only works for exact matches.
	     *
	     * @param {Function} fn                   A typed-function
	     * @param {string | string[]} signature   Signature to be found, can be
	     *                                        an array or a comma separated string.
	     * @return {Function}                     Returns the matching signature, or
	     *                                        throws an errror when no signature
	     *                                        is found.
	     */function find(fn,signature){if(!fn.signatures){throw new TypeError('Function is no typed-function');}// normalize input
var arr;if(typeof signature==='string'){arr=signature.split(',');for(var i=0;i<arr.length;i++){arr[i]=arr[i].trim();}}else if(Array.isArray(signature)){arr=signature;}else{throw new TypeError('String array or a comma separated string expected');}var str=arr.join(',');// find an exact match
var match=fn.signatures[str];if(match){return match;}// TODO: extend find to match non-exact signatures
throw new TypeError('Signature not found (signature: '+(fn.name||'unnamed')+'('+arr.join(', ')+'))');}/**
	     * Convert a given value to another data type.
	     * @param {*} value
	     * @param {string} type
	     */function convert(value,type){var from=getTypeOf(value);// check conversion is needed
if(type===from){return value;}for(var i=0;i<typed.conversions.length;i++){var conversion=typed.conversions[i];if(conversion.from===from&&conversion.to===type){return conversion.convert(value);}}throw new Error('Cannot convert from '+from+' to '+type);}// attach types and conversions to the final `typed` function
typed.config=config;typed.types=types;typed.conversions=conversions;typed.ignore=ignore;typed.create=create;typed.find=find;typed.convert=convert;// add a type
typed.addType=function(type){if(!type||typeof type.name!=='string'||typeof type.test!=='function'){throw new TypeError('Object with properties {name: string, test: function} expected');}typed.types.push(type);};// add a conversion
typed.addConversion=function(conversion){if(!conversion||typeof conversion.from!=='string'||typeof conversion.to!=='string'||typeof conversion.convert!=='function'){throw new TypeError('Object with properties {from: string, to: string, convert: function} expected');}typed.conversions.push(conversion);};return typed;}return create();});/***/},/* 18 *//***/function(module,exports){exports.isNumber=function(value){return typeof value==='number';};/**
	 * Check if a number is integer
	 * @param {number | boolean} value
	 * @return {boolean} isInteger
	 */exports.isInteger=function(value){return isFinite(value)?value==Math.round(value):false;// Note: we use ==, not ===, as we can have Booleans as well
};/**
	 * Calculate the sign of a number
	 * @param {number} x
	 * @returns {*}
	 */exports.sign=Math.sign||function(x){if(x>0){return 1;}else if(x<0){return-1;}else{return 0;}};/**
	 * Convert a number to a formatted string representation.
	 *
	 * Syntax:
	 *
	 *    format(value)
	 *    format(value, options)
	 *    format(value, precision)
	 *    format(value, fn)
	 *
	 * Where:
	 *
	 *    {number} value   The value to be formatted
	 *    {Object} options An object with formatting options. Available options:
	 *                     {string} notation
	 *                         Number notation. Choose from:
	 *                         'fixed'          Always use regular number notation.
	 *                                          For example '123.40' and '14000000'
	 *                         'exponential'    Always use exponential notation.
	 *                                          For example '1.234e+2' and '1.4e+7'
	 *                         'engineering'    Always use engineering notation.
	 *                                          For example '123.4e+0' and '14.0e+6'
	 *                         'auto' (default) Regular number notation for numbers
	 *                                          having an absolute value between
	 *                                          `lower` and `upper` bounds, and uses
	 *                                          exponential notation elsewhere.
	 *                                          Lower bound is included, upper bound
	 *                                          is excluded.
	 *                                          For example '123.4' and '1.4e7'.
	 *                     {number} precision   A number between 0 and 16 to round
	 *                                          the digits of the number.
	 *                                          In case of notations 'exponential' and
	 *                                          'auto', `precision` defines the total
	 *                                          number of significant digits returned
	 *                                          and is undefined by default.
	 *                                          In case of notation 'fixed',
	 *                                          `precision` defines the number of
	 *                                          significant digits after the decimal
	 *                                          point, and is 0 by default.
	 *                     {Object} exponential An object containing two parameters,
	 *                                          {number} lower and {number} upper,
	 *                                          used by notation 'auto' to determine
	 *                                          when to return exponential notation.
	 *                                          Default values are `lower=1e-3` and
	 *                                          `upper=1e5`.
	 *                                          Only applicable for notation `auto`.
	 *    {Function} fn    A custom formatting function. Can be used to override the
	 *                     built-in notations. Function `fn` is called with `value` as
	 *                     parameter and must return a string. Is useful for example to
	 *                     format all values inside a matrix in a particular way.
	 *
	 * Examples:
	 *
	 *    format(6.4);                                        // '6.4'
	 *    format(1240000);                                    // '1.24e6'
	 *    format(1/3);                                        // '0.3333333333333333'
	 *    format(1/3, 3);                                     // '0.333'
	 *    format(21385, 2);                                   // '21000'
	 *    format(12.071, {notation: 'fixed'});                // '12'
	 *    format(2.3,    {notation: 'fixed', precision: 2});  // '2.30'
	 *    format(52.8,   {notation: 'exponential'});          // '5.28e+1'
	 *    format(12345678, {notation: 'engineering'});        // '12.345678e+6'
	 *
	 * @param {number} value
	 * @param {Object | Function | number} [options]
	 * @return {string} str The formatted value
	 */exports.format=function(value,options){if(typeof options==='function'){// handle format(value, fn)
return options(value);}// handle special cases
if(value===Infinity){return'Infinity';}else if(value===-Infinity){return'-Infinity';}else if(isNaN(value)){return'NaN';}// default values for options
var notation='auto';var precision=undefined;if(options){// determine notation from options
if(options.notation){notation=options.notation;}// determine precision from options
if(exports.isNumber(options)){precision=options;}else if(options.precision){precision=options.precision;}}// handle the various notations
switch(notation){case'fixed':return exports.toFixed(value,precision);case'exponential':return exports.toExponential(value,precision);case'engineering':return exports.toEngineering(value,precision);case'auto':return exports.toPrecision(value,precision,options&&options.exponential)// remove trailing zeros after the decimal point
.replace(/((\.\d*?)(0+))($|e)/,function(){var digits=arguments[2];var e=arguments[4];return digits!=='.'?digits+e:e;});default:throw new Error('Unknown notation "'+notation+'". '+'Choose "auto", "exponential", or "fixed".');}};/**
	 * Split a number into sign, coefficients, and exponent
	 * @param {number | string} value
	 * @return {SplitValue}
	 *              Returns an object containing sign, coefficients, and exponent
	 */exports.splitNumber=function(value){// parse the input value
var match=String(value).toLowerCase().match(/^0*?(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);if(!match){throw new SyntaxError('Invalid number '+value);}var sign=match[1];var digits=match[2];var exponent=parseFloat(match[4]||'0');var dot=digits.indexOf('.');exponent+=dot!==-1?dot-1:digits.length-1;var coefficients=digits.replace('.','')// remove the dot (must be removed before removing leading zeros)
.replace(/^0*/,function(zeros){// remove leading zeros, add their count to the exponent
exponent-=zeros.length;return'';}).replace(/0*$/,'')// remove trailing zeros
.split('').map(function(d){return parseInt(d);});if(coefficients.length===0){coefficients.push(0);exponent++;}return{sign:sign,coefficients:coefficients,exponent:exponent};};/**
	 * Format a number in engineering notation. Like '1.23e+6', '2.3e+0', '3.500e-3'
	 * @param {number | string} value
	 * @param {number} [precision=0]        Optional number of decimals after the
	 *                                      decimal point. Zero by default.
	 */exports.toEngineering=function(value,precision){if(isNaN(value)||!isFinite(value)){return String(value);}var rounded=exports.roundDigits(exports.splitNumber(value),precision);var e=rounded.exponent;var c=rounded.coefficients;// find nearest lower multiple of 3 for exponent
var newExp=e%3===0?e:e<0?e-3-e%3:e-e%3;// concatenate coefficients with necessary zeros
var significandsDiff=e>=0?e:Math.abs(newExp);// add zeros if necessary (for ex: 1e+8)
if(c.length-1<significandsDiff)c=c.concat(zeros(significandsDiff-(c.length-1)));// find difference in exponents
var expDiff=Math.abs(e-newExp);var decimalIdx=1;// push decimal index over by expDiff times
while(--expDiff>=0){decimalIdx++;}// if all coefficient values are zero after the decimal point, don't add a decimal value.
// otherwise concat with the rest of the coefficients
var decimals=c.slice(decimalIdx).join('');var decimalVal=decimals.match(/[1-9]/)?'.'+decimals:'';var str=c.slice(0,decimalIdx).join('')+decimalVal+'e'+(e>=0?'+':'')+newExp.toString();return rounded.sign+str;};/**
	 * Format a number with fixed notation.
	 * @param {number | string} value
	 * @param {number} [precision=0]        Optional number of decimals after the
	 *                                      decimal point. Zero by default.
	 */exports.toFixed=function(value,precision){if(isNaN(value)||!isFinite(value)){return String(value);}var splitValue=exports.splitNumber(value);var rounded=exports.roundDigits(splitValue,splitValue.exponent+1+(precision||0));var c=rounded.coefficients;var p=rounded.exponent+1;// exponent may have changed
// append zeros if needed
var pp=p+(precision||0);if(c.length<pp){c=c.concat(zeros(pp-c.length));}// prepend zeros if needed
if(p<0){c=zeros(-p+1).concat(c);p=1;}// insert a dot if needed
if(precision){c.splice(p,0,p===0?'0.':'.');}return rounded.sign+c.join('');};/**
	 * Format a number in exponential notation. Like '1.23e+5', '2.3e+0', '3.500e-3'
	 * @param {number | string} value
	 * @param {number} [precision]  Number of digits in formatted output.
	 *                              If not provided, the maximum available digits
	 *                              is used.
	 */exports.toExponential=function(value,precision){if(isNaN(value)||!isFinite(value)){return String(value);}// round if needed, else create a clone
var split=exports.splitNumber(value);var rounded=precision?exports.roundDigits(split,precision):split;var c=rounded.coefficients;var e=rounded.exponent;// append zeros if needed
if(c.length<precision){c=c.concat(zeros(precision-c.length));}// format as `C.CCCe+EEE` or `C.CCCe-EEE`
var first=c.shift();return rounded.sign+first+(c.length>0?'.'+c.join(''):'')+'e'+(e>=0?'+':'')+e;};/**
	 * Format a number with a certain precision
	 * @param {number | string} value
	 * @param {number} [precision=undefined] Optional number of digits.
	 * @param {{lower: number | undefined, upper: number | undefined}} [options]
	 *                                       By default:
	 *                                         lower = 1e-3 (excl)
	 *                                         upper = 1e+5 (incl)
	 * @return {string}
	 */exports.toPrecision=function(value,precision,options){if(isNaN(value)||!isFinite(value)){return String(value);}// determine lower and upper bound for exponential notation.
var lower=options&&options.lower!==undefined?options.lower:1e-3;var upper=options&&options.upper!==undefined?options.upper:1e+5;var split=exports.splitNumber(value);var abs=Math.abs(Math.pow(10,split.exponent));if(abs<lower||abs>=upper){// exponential notation
return exports.toExponential(value,precision);}else{var rounded=precision?exports.roundDigits(split,precision):split;var c=rounded.coefficients;var e=rounded.exponent;// append trailing zeros
if(c.length<precision){c=c.concat(zeros(precision-c.length));}// append trailing zeros
// TODO: simplify the next statement
c=c.concat(zeros(e-c.length+1+(c.length<precision?precision-c.length:0)));// prepend zeros
c=zeros(-e).concat(c);var dot=e>0?e:0;if(dot<c.length-1){c.splice(dot+1,0,'.');}return rounded.sign+c.join('');}};/**
	 * Round the number of digits of a number *
	 * @param {SplitValue} split       A value split with .splitNumber(value)
	 * @param {number} precision  A positive integer
	 * @return {SplitValue}
	 *              Returns an object containing sign, coefficients, and exponent
	 *              with rounded digits
	 */exports.roundDigits=function(split,precision){// create a clone
var rounded={sign:split.sign,coefficients:split.coefficients,exponent:split.exponent};var c=rounded.coefficients;// prepend zeros if needed
while(precision<=0){c.unshift(0);rounded.exponent++;precision++;}if(c.length>precision){var removed=c.splice(precision,c.length-precision);if(removed[0]>=5){var i=precision-1;c[i]++;while(c[i]===10){c.pop();if(i===0){c.unshift(0);rounded.exponent++;i++;}i--;c[i]++;}}}return rounded;};/**
	 * Create an array filled with zeros.
	 * @param {number} length
	 * @return {Array}
	 */function zeros(length){var arr=[];for(var i=0;i<length;i++){arr.push(0);}return arr;}/**
	 * Count the number of significant digits of a number.
	 *
	 * For example:
	 *   2.34 returns 3
	 *   0.0034 returns 2
	 *   120.5e+30 returns 4
	 *
	 * @param {number} value
	 * @return {number} digits   Number of significant digits
	 */exports.digits=function(value){return value.toExponential().replace(/e.*$/,'')// remove exponential notation
.replace(/^0\.?0*|\./,'')// remove decimal point and leading zeros
.length;};/**
	 * Minimum number added to one that makes the result different than one
	 */exports.DBL_EPSILON=Number.EPSILON||2.2204460492503130808472633361816E-16;/**
	 * Compares two floating point numbers.
	 * @param {number} x          First value to compare
	 * @param {number} y          Second value to compare
	 * @param {number} [epsilon]  The maximum relative difference between x and y
	 *                            If epsilon is undefined or null, the function will
	 *                            test whether x and y are exactly equal.
	 * @return {boolean} whether the two numbers are nearly equal
	*/exports.nearlyEqual=function(x,y,epsilon){// if epsilon is null or undefined, test whether x and y are exactly equal
if(epsilon==null){return x==y;}// use "==" operator, handles infinities
if(x==y){return true;}// NaN
if(isNaN(x)||isNaN(y)){return false;}// at this point x and y should be finite
if(isFinite(x)&&isFinite(y)){// check numbers are very close, needed when comparing numbers near zero
var diff=Math.abs(x-y);if(diff<exports.DBL_EPSILON){return true;}else{// use relative error
return diff<=Math.max(Math.abs(x),Math.abs(y))*epsilon;}}// Infinite and Number or negative Infinite and positive Infinite cases
return false;};/***/},/* 19 *//***/function(module,exports,__webpack_require__){var Emitter=__webpack_require__(20);/**
	 * Extend given object with emitter functions `on`, `off`, `once`, `emit`
	 * @param {Object} obj
	 * @return {Object} obj
	 */exports.mixin=function(obj){// create event emitter
var emitter=new Emitter();// bind methods to obj (we don't want to expose the emitter.e Array...)
obj.on=emitter.on.bind(emitter);obj.off=emitter.off.bind(emitter);obj.once=emitter.once.bind(emitter);obj.emit=emitter.emit.bind(emitter);return obj;};/***/},/* 20 *//***/function(module,exports){function E(){// Keep this empty so it's easier to inherit from
// (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}E.prototype={on:function on(name,callback,ctx){var e=this.e||(this.e={});(e[name]||(e[name]=[])).push({fn:callback,ctx:ctx});return this;},once:function once(name,callback,ctx){var self=this;function listener(){self.off(name,listener);callback.apply(ctx,arguments);}listener._=callback;return this.on(name,listener,ctx);},emit:function emit(name){var data=[].slice.call(arguments,1);var evtArr=((this.e||(this.e={}))[name]||[]).slice();var i=0;var len=evtArr.length;for(i;i<len;i++){evtArr[i].fn.apply(evtArr[i].ctx,data);}return this;},off:function off(name,callback){var e=this.e||(this.e={});var evts=e[name];var liveEvents=[];if(evts&&callback){for(var i=0,len=evts.length;i<len;i++){if(evts[i].fn!==callback&&evts[i].fn._!==callback)liveEvents.push(evts[i]);}}// Remove event from queue to prevent memory leak
// Suggested by https://github.com/lazd
// Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
liveEvents.length?e[name]=liveEvents:delete e[name];return this;}};module.exports=E;/***/},/* 21 *//***/function(module,exports,__webpack_require__){var lazy=__webpack_require__(15).lazy;var isFactory=__webpack_require__(15).isFactory;var traverse=__webpack_require__(15).traverse;var ArgumentsError=__webpack_require__(22);function factory(type,config,load,typed,math){/**
	   * Import functions from an object or a module
	   *
	   * Syntax:
	   *
	   *    math.import(object)
	   *    math.import(object, options)
	   *
	   * Where:
	   *
	   * - `object: Object`
	   *   An object with functions to be imported.
	   * - `options: Object` An object with import options. Available options:
	   *   - `override: boolean`
	   *     If true, existing functions will be overwritten. False by default.
	   *   - `silent: boolean`
	   *     If true, the function will not throw errors on duplicates or invalid
	   *     types. False by default.
	   *   - `wrap: boolean`
	   *     If true, the functions will be wrapped in a wrapper function
	   *     which converts data types like Matrix to primitive data types like Array.
	   *     The wrapper is needed when extending math.js with libraries which do not
	   *     support these data type. False by default.
	   *
	   * Examples:
	   *
	   *    // define new functions and variables
	   *    math.import({
	   *      myvalue: 42,
	   *      hello: function (name) {
	   *        return 'hello, ' + name + '!';
	   *      }
	   *    });
	   *
	   *    // use the imported function and variable
	   *    math.myvalue * 2;               // 84
	   *    math.hello('user');             // 'hello, user!'
	   *
	   *    // import the npm module 'numbers'
	   *    // (must be installed first with `npm install numbers`)
	   *    math.import(require('numbers'), {wrap: true});
	   *
	   *    math.fibonacci(7); // returns 13
	   *
	   * @param {Object | Array} object   Object with functions to be imported.
	   * @param {Object} [options]        Import options.
	   */function math_import(object,options){var num=arguments.length;if(num!==1&&num!==2){throw new ArgumentsError('import',num,1,2);}if(!options){options={};}if(isFactory(object)){_importFactory(object,options);}// TODO: allow a typed-function with name too
else if(Array.isArray(object)){object.forEach(function(entry){math_import(entry,options);});}else if((typeof object==='undefined'?'undefined':_typeof(object))==='object'){// a map with functions
for(var name in object){if(object.hasOwnProperty(name)){var value=object[name];if(isSupportedType(value)){_import(name,value,options);}else if(isFactory(object)){_importFactory(object,options);}else{math_import(value,options);}}}}else{if(!options.silent){throw new TypeError('Factory, Object, or Array expected');}}}/**
	   * Add a property to the math namespace and create a chain proxy for it.
	   * @param {string} name
	   * @param {*} value
	   * @param {Object} options  See import for a description of the options
	   * @private
	   */function _import(name,value,options){// TODO: refactor this function, it's to complicated and contains duplicate code
if(options.wrap&&typeof value==='function'){// create a wrapper around the function
value=_wrap(value);}if(isTypedFunction(math[name])&&isTypedFunction(value)){if(options.override){// give the typed function the right name
value=typed(name,value.signatures);}else{// merge the existing and typed function
value=typed(math[name],value);}math[name]=value;_importTransform(name,value);math.emit('import',name,function resolver(){return value;});return;}if(math[name]===undefined||options.override){math[name]=value;_importTransform(name,value);math.emit('import',name,function resolver(){return value;});return;}if(!options.silent){throw new Error('Cannot import "'+name+'": already exists');}}function _importTransform(name,value){if(value&&typeof value.transform==='function'){math.expression.transform[name]=value.transform;if(allowedInExpressions(name)){math.expression.mathWithTransform[name]=value.transform;}}else{// remove existing transform
delete math.expression.transform[name];if(allowedInExpressions(name)){math.expression.mathWithTransform[name]=value;}}}/**
	   * Create a wrapper a round an function which converts the arguments
	   * to their primitive values (like convert a Matrix to Array)
	   * @param {Function} fn
	   * @return {Function} Returns the wrapped function
	   * @private
	   */function _wrap(fn){var wrapper=function wrapper(){var args=[];for(var i=0,len=arguments.length;i<len;i++){var arg=arguments[i];args[i]=arg&&arg.valueOf();}return fn.apply(math,args);};if(fn.transform){wrapper.transform=fn.transform;}return wrapper;}/**
	   * Import an instance of a factory into math.js
	   * @param {{factory: Function, name: string, path: string, math: boolean}} factory
	   * @param {Object} options  See import for a description of the options
	   * @private
	   */function _importFactory(factory,options){if(typeof factory.name==='string'){var name=factory.name;var existingTransform=name in math.expression.transform;var namespace=factory.path?traverse(math,factory.path):math;var existing=namespace.hasOwnProperty(name)?namespace[name]:undefined;var resolver=function resolver(){var instance=load(factory);if(instance&&typeof instance.transform==='function'){throw new Error('Transforms cannot be attached to factory functions. '+'Please create a separate function for it with exports.path="expression.transform"');}if(isTypedFunction(existing)&&isTypedFunction(instance)){if(options.override){// replace the existing typed function (nothing to do)
}else{// merge the existing and new typed function
instance=typed(existing,instance);}return instance;}if(existing===undefined||options.override){return instance;}if(!options.silent){throw new Error('Cannot import "'+name+'": already exists');}};if(factory.lazy!==false){lazy(namespace,name,resolver);if(!existingTransform){if(factory.path==='expression.transform'||factoryAllowedInExpressions(factory)){lazy(math.expression.mathWithTransform,name,resolver);}}}else{namespace[name]=resolver();if(!existingTransform){if(factory.path==='expression.transform'||factoryAllowedInExpressions(factory)){math.expression.mathWithTransform[name]=resolver();}}}math.emit('import',name,resolver,factory.path);}else{// unnamed factory.
// no lazy loading
load(factory);}}/**
	   * Check whether given object is a type which can be imported
	   * @param {Function | number | string | boolean | null | Unit | Complex} object
	   * @return {boolean}
	   * @private
	   */function isSupportedType(object){return typeof object==='function'||typeof object==='number'||typeof object==='string'||typeof object==='boolean'||object===null||object&&object.isUnit===true||object&&object.isComplex===true||object&&object.isBigNumber===true||object&&object.isFraction===true||object&&object.isMatrix===true||object&&Array.isArray(object)===true;}/**
	   * Test whether a given thing is a typed-function
	   * @param {*} fn
	   * @return {boolean} Returns true when `fn` is a typed-function
	   */function isTypedFunction(fn){return typeof fn==='function'&&_typeof(fn.signatures)==='object';}function allowedInExpressions(name){return!unsafe.hasOwnProperty(name);}function factoryAllowedInExpressions(factory){return factory.path===undefined&&!unsafe.hasOwnProperty(factory.name);}// namespaces and functions not available in the parser for safety reasons
var unsafe={'expression':true,'type':true,'docs':true,'error':true,'json':true,'chain':true// chain method not supported. Note that there is a unit chain too.
};return math_import;}exports.math=true;// request access to the math namespace as 5th argument of the factory function
exports.name='import';exports.factory=factory;exports.lazy=true;/***/},/* 22 *//***/function(module,exports){function ArgumentsError(fn,count,min,max){if(!(this instanceof ArgumentsError)){throw new SyntaxError('Constructor must be called with the new operator');}this.fn=fn;this.count=count;this.min=min;this.max=max;this.message='Wrong number of arguments in function '+fn+' ('+count+' provided, '+min+(max!=undefined?'-'+max:'')+' expected)';this.stack=new Error().stack;}ArgumentsError.prototype=new Error();ArgumentsError.prototype.constructor=Error;ArgumentsError.prototype.name='ArgumentsError';ArgumentsError.prototype.isArgumentsError=true;module.exports=ArgumentsError;/***/},/* 23 *//***/function(module,exports,__webpack_require__){var object=__webpack_require__(15);function factory(type,config,load,typed,math){var MATRIX=['Matrix','Array'];// valid values for option matrix
var NUMBER=['number','BigNumber','Fraction'];// valid values for option number
/**
	   * Set configuration options for math.js, and get current options.
	   * Will emit a 'config' event, with arguments (curr, prev, changes).
	   *
	   * Syntax:
	   *
	   *     math.config(config: Object): Object
	   *
	   * Examples:
	   *
	   *     math.config().number;                // outputs 'number'
	   *     math.eval('0.4');                    // outputs number 0.4
	   *     math.config({number: 'Fraction'});
	   *     math.eval('0.4');                    // outputs Fraction 2/5
	   *
	   * @param {Object} [options] Available options:
	   *                            {number} epsilon
	   *                              Minimum relative difference between two
	   *                              compared values, used by all comparison functions.
	   *                            {string} matrix
	   *                              A string 'Matrix' (default) or 'Array'.
	   *                            {string} number
	   *                              A string 'number' (default), 'BigNumber', or 'Fraction'
	   *                            {number} precision
	   *                              The number of significant digits for BigNumbers.
	   *                              Not applicable for Numbers.
	   *                            {string} parenthesis
	   *                              How to display parentheses in LaTeX and string
	   *                              output.
	   *                            {string} randomSeed
	   *                              Random seed for seeded pseudo random number generator.
	   *                              Set to null to randomly seed.
	   * @return {Object} Returns the current configuration
	   */function _config(options){if(options){var prev=object.map(config,object.clone);// validate some of the options
validateOption(options,'matrix',MATRIX);validateOption(options,'number',NUMBER);// merge options
object.deepExtend(config,options);var curr=object.map(config,object.clone);var changes=object.map(options,object.clone);// emit 'config' event
math.emit('config',curr,prev,changes);return curr;}else{return object.map(config,object.clone);}}// attach the valid options to the function so they can be extended
_config.MATRIX=MATRIX;_config.NUMBER=NUMBER;return _config;}/**
	 * Test whether an Array contains a specific item.
	 * @param {Array.<string>} array
	 * @param {string} item
	 * @return {boolean}
	 */function contains(array,item){return array.indexOf(item)!==-1;}/**
	 * Find a string in an array. Case insensitive search
	 * @param {Array.<string>} array
	 * @param {string} item
	 * @return {number} Returns the index when found. Returns -1 when not found
	 */function findIndex(array,item){return array.map(function(i){return i.toLowerCase();}).indexOf(item.toLowerCase());}/**
	 * Validate an option
	 * @param {Object} options         Object with options
	 * @param {string} name            Name of the option to validate
	 * @param {Array.<string>} values  Array with valid values for this option
	 */function validateOption(options,name,values){if(options[name]!==undefined&&!contains(values,options[name])){var index=findIndex(values,options[name]);if(index!==-1){// right value, wrong casing
// TODO: lower case values are deprecated since v3, remove this warning some day.
console.warn('Warning: Wrong casing for configuration option "'+name+'", should be "'+values[index]+'" instead of "'+options[name]+'".');options[name]=values[index];// change the option to the right casing
}else{// unknown value
console.warn('Warning: Unknown value "'+options[name]+'" for configuration option "'+name+'". Available options: '+values.map(JSON.stringify).join(', ')+'.');}}}exports.name='config';exports.math=true;// request the math namespace as fifth argument
exports.factory=factory;/***/},/* 24 *//***/function(module,exports,__webpack_require__){module.exports=[// types
__webpack_require__(25),__webpack_require__(35),__webpack_require__(37),__webpack_require__(40),__webpack_require__(50),__webpack_require__(56),__webpack_require__(57),__webpack_require__(58),// construction functions
__webpack_require__(59),__webpack_require__(42),__webpack_require__(60)];/***/},/* 25 *//***/function(module,exports,__webpack_require__){var util=__webpack_require__(26);var string=util.string;var isString=string.isString;function factory(type,config,load,typed){/**
	   * @constructor Matrix
	   *
	   * A Matrix is a wrapper around an Array. A matrix can hold a multi dimensional
	   * array. A matrix can be constructed as:
	   *     var matrix = math.matrix(data)
	   *
	   * Matrix contains the functions to resize, get and set values, get the size,
	   * clone the matrix and to convert the matrix to a vector, array, or scalar.
	   * Furthermore, one can iterate over the matrix using map and forEach.
	   * The internal Array of the Matrix can be accessed using the function valueOf.
	   *
	   * Example usage:
	   *     var matrix = math.matrix([[1, 2], [3, 4]]);
	   *     matix.size();              // [2, 2]
	   *     matrix.resize([3, 2], 5);
	   *     matrix.valueOf();          // [[1, 2], [3, 4], [5, 5]]
	   *     matrix.subset([1,2])       // 3 (indexes are zero-based)
	   *
	   */function Matrix(){if(!(this instanceof Matrix)){throw new SyntaxError('Constructor must be called with the new operator');}}/**
	   * Attach type information
	   */Matrix.prototype.type='Matrix';Matrix.prototype.isMatrix=true;/**
	   * Get the Matrix storage constructor for the given format.
	   *
	   * @param {string} format       The Matrix storage format.
	   *
	   * @return {Function}           The Matrix storage constructor.
	   */Matrix.storage=function(format){// check storage format is a string
if(!isString(format)){throw new TypeError('format must be a string value');}// get storage format constructor
var constructor=Matrix._storage[format];if(!constructor){throw new SyntaxError('Unsupported matrix storage format: '+format);}// return storage constructor
return constructor;};// a map with all constructors for all storage types
Matrix._storage={};/**
	   * Get the storage format used by the matrix.
	   *
	   * Usage:
	   *     var format = matrix.storage()                   // retrieve storage format
	   *
	   * @return {string}           The storage format.
	   */Matrix.prototype.storage=function(){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke storage on a Matrix interface');};/**
	   * Get the datatype of the data stored in the matrix.
	   *
	   * Usage:
	   *     var format = matrix.datatype()                   // retrieve matrix datatype
	   *
	   * @return {string}           The datatype.
	   */Matrix.prototype.datatype=function(){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke datatype on a Matrix interface');};/**
	   * Create a new Matrix With the type of the current matrix instance
	   * @param {Array | Object} data
	   * @param {string} [datatype]
	   */Matrix.prototype.create=function(data,datatype){throw new Error('Cannot invoke create on a Matrix interface');};/**
	   * Get a subset of the matrix, or replace a subset of the matrix.
	   *
	   * Usage:
	   *     var subset = matrix.subset(index)               // retrieve subset
	   *     var value = matrix.subset(index, replacement)   // replace subset
	   *
	   * @param {Index} index
	   * @param {Array | Matrix | *} [replacement]
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be filled with zeros.
	   */Matrix.prototype.subset=function(index,replacement,defaultValue){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke subset on a Matrix interface');};/**
	   * Get a single element from the matrix.
	   * @param {number[]} index   Zero-based index
	   * @return {*} value
	   */Matrix.prototype.get=function(index){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke get on a Matrix interface');};/**
	   * Replace a single element in the matrix.
	   * @param {number[]} index   Zero-based index
	   * @param {*} value
	   * @param {*} [defaultValue]        Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be left undefined.
	   * @return {Matrix} self
	   */Matrix.prototype.set=function(index,value,defaultValue){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke set on a Matrix interface');};/**
	   * Resize the matrix to the given size. Returns a copy of the matrix when
	   * `copy=true`, otherwise return the matrix itself (resize in place).
	   *
	   * @param {number[]} size           The new size the matrix should have.
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
	   *                                  If not provided, the matrix elements will
	   *                                  be filled with zeros.
	   * @param {boolean} [copy]          Return a resized copy of the matrix
	   *
	   * @return {Matrix}                 The resized matrix
	   */Matrix.prototype.resize=function(size,defaultValue){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke resize on a Matrix interface');};/**
	   * Reshape the matrix to the given size. Returns a copy of the matrix when
	   * `copy=true`, otherwise return the matrix itself (reshape in place).
	   *
	   * @param {number[]} size           The new size the matrix should have.
	   * @param {boolean} [copy]          Return a reshaped copy of the matrix
	   *
	   * @return {Matrix}                 The reshaped matrix
	   */Matrix.prototype.reshape=function(size,defaultValue){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke reshape on a Matrix interface');};/**
	   * Create a clone of the matrix
	   * @return {Matrix} clone
	   */Matrix.prototype.clone=function(){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke clone on a Matrix interface');};/**
	   * Retrieve the size of the matrix.
	   * @returns {number[]} size
	   */Matrix.prototype.size=function(){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke size on a Matrix interface');};/**
	   * Create a new matrix with the results of the callback function executed on
	   * each entry of the matrix.
	   * @param {Function} callback   The callback function is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix being traversed.
	   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
	   *
	   * @return {Matrix} matrix
	   */Matrix.prototype.map=function(callback,skipZeros){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke map on a Matrix interface');};/**
	   * Execute a callback function on each entry of the matrix.
	   * @param {Function} callback   The callback function is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix being traversed.
	   */Matrix.prototype.forEach=function(callback){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke forEach on a Matrix interface');};/**
	   * Create an Array with a copy of the data of the Matrix
	   * @returns {Array} array
	   */Matrix.prototype.toArray=function(){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke toArray on a Matrix interface');};/**
	   * Get the primitive value of the Matrix: a multidimensional array
	   * @returns {Array} array
	   */Matrix.prototype.valueOf=function(){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke valueOf on a Matrix interface');};/**
	   * Get a string representation of the matrix, with optional formatting options.
	   * @param {Object | number | Function} [options]  Formatting options. See
	   *                                                lib/utils/number:format for a
	   *                                                description of the available
	   *                                                options.
	   * @returns {string} str
	   */Matrix.prototype.format=function(options){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke format on a Matrix interface');};/**
	   * Get a string representation of the matrix
	   * @returns {string} str
	   */Matrix.prototype.toString=function(){// must be implemented by each of the Matrix implementations
throw new Error('Cannot invoke toString on a Matrix interface');};// exports
return Matrix;}exports.name='Matrix';exports.path='type';exports.factory=factory;/***/},/* 26 *//***/function(module,exports,__webpack_require__){exports.array=__webpack_require__(27);exports['boolean']=__webpack_require__(33);exports['function']=__webpack_require__(34);exports.number=__webpack_require__(18);exports.object=__webpack_require__(15);exports.string=__webpack_require__(28);exports.types=__webpack_require__(30);exports.emitter=__webpack_require__(19);/***/},/* 27 *//***/function(module,exports,__webpack_require__){var number=__webpack_require__(18);var string=__webpack_require__(28);var object=__webpack_require__(15);var types=__webpack_require__(30);var DimensionError=__webpack_require__(31);var IndexError=__webpack_require__(32);/**
	 * Calculate the size of a multi dimensional array.
	 * This function checks the size of the first entry, it does not validate
	 * whether all dimensions match. (use function `validate` for that)
	 * @param {Array} x
	 * @Return {Number[]} size
	 */exports.size=function(x){var s=[];while(Array.isArray(x)){s.push(x.length);x=x[0];}return s;};/**
	 * Recursively validate whether each element in a multi dimensional array
	 * has a size corresponding to the provided size array.
	 * @param {Array} array    Array to be validated
	 * @param {number[]} size  Array with the size of each dimension
	 * @param {number} dim   Current dimension
	 * @throws DimensionError
	 * @private
	 */function _validate(array,size,dim){var i;var len=array.length;if(len!=size[dim]){throw new DimensionError(len,size[dim]);}if(dim<size.length-1){// recursively validate each child array
var dimNext=dim+1;for(i=0;i<len;i++){var child=array[i];if(!Array.isArray(child)){throw new DimensionError(size.length-1,size.length,'<');}_validate(array[i],size,dimNext);}}else{// last dimension. none of the childs may be an array
for(i=0;i<len;i++){if(Array.isArray(array[i])){throw new DimensionError(size.length+1,size.length,'>');}}}}/**
	 * Validate whether each element in a multi dimensional array has
	 * a size corresponding to the provided size array.
	 * @param {Array} array    Array to be validated
	 * @param {number[]} size  Array with the size of each dimension
	 * @throws DimensionError
	 */exports.validate=function(array,size){var isScalar=size.length==0;if(isScalar){// scalar
if(Array.isArray(array)){throw new DimensionError(array.length,0);}}else{// array
_validate(array,size,0);}};/**
	 * Test whether index is an integer number with index >= 0 and index < length
	 * when length is provided
	 * @param {number} index    Zero-based index
	 * @param {number} [length] Length of the array
	 */exports.validateIndex=function(index,length){if(!number.isNumber(index)||!number.isInteger(index)){throw new TypeError('Index must be an integer (value: '+index+')');}if(index<0||typeof length==='number'&&index>=length){throw new IndexError(index,length);}};// a constant used to specify an undefined defaultValue
exports.UNINITIALIZED={};/**
	 * Resize a multi dimensional array. The resized array is returned.
	 * @param {Array} array         Array to be resized
	 * @param {Array.<number>} size Array with the size of each dimension
	 * @param {*} [defaultValue=0]  Value to be filled in in new entries,
	 *                              zero by default. To leave new entries undefined,
	 *                              specify array.UNINITIALIZED as defaultValue
	 * @return {Array} array         The resized array
	 */exports.resize=function(array,size,defaultValue){// TODO: add support for scalars, having size=[] ?
// check the type of the arguments
if(!Array.isArray(array)||!Array.isArray(size)){throw new TypeError('Array expected');}if(size.length===0){throw new Error('Resizing to scalar is not supported');}// check whether size contains positive integers
size.forEach(function(value){if(!number.isNumber(value)||!number.isInteger(value)||value<0){throw new TypeError('Invalid size, must contain positive integers '+'(size: '+string.format(size)+')');}});// recursively resize the array
var _defaultValue=defaultValue!==undefined?defaultValue:0;_resize(array,size,0,_defaultValue);return array;};/**
	 * Recursively resize a multi dimensional array
	 * @param {Array} array         Array to be resized
	 * @param {number[]} size       Array with the size of each dimension
	 * @param {number} dim          Current dimension
	 * @param {*} [defaultValue]    Value to be filled in in new entries,
	 *                              undefined by default.
	 * @private
	 */function _resize(array,size,dim,defaultValue){var i;var elem;var oldLen=array.length;var newLen=size[dim];var minLen=Math.min(oldLen,newLen);// apply new length
array.length=newLen;if(dim<size.length-1){// non-last dimension
var dimNext=dim+1;// resize existing child arrays
for(i=0;i<minLen;i++){// resize child array
elem=array[i];if(!Array.isArray(elem)){elem=[elem];// add a dimension
array[i]=elem;}_resize(elem,size,dimNext,defaultValue);}// create new child arrays
for(i=minLen;i<newLen;i++){// get child array
elem=[];array[i]=elem;// resize new child array
_resize(elem,size,dimNext,defaultValue);}}else{// last dimension
// remove dimensions of existing values
for(i=0;i<minLen;i++){while(Array.isArray(array[i])){array[i]=array[i][0];}}if(defaultValue!==exports.UNINITIALIZED){// fill new elements with the default value
for(i=minLen;i<newLen;i++){array[i]=defaultValue;}}}}/**
	 * Re-shape a multi dimensional array to fit the specified dimensions
	 * @param {Array} array           Array to be reshaped
	 * @param {Array.<number>} sizes  List of sizes for each dimension
	 * @returns {Array}               Array whose data has been formatted to fit the
	 *                                specified dimensions
	 *
	 * @throws {DimensionError}       If the product of the new dimension sizes does
	 *                                not equal that of the old ones
	 */exports.reshape=function(array,sizes){var flatArray=exports.flatten(array);var newArray;var product=function product(arr){return arr.reduce(function(prev,curr){return prev*curr;});};if(!Array.isArray(array)||!Array.isArray(sizes)){throw new TypeError('Array expected');}if(sizes.length===0){throw new DimensionError(0,product(exports.size(array)),'!=');}try{newArray=_reshape(flatArray,sizes);}catch(e){if(e instanceof DimensionError){throw new DimensionError(product(sizes),product(exports.size(array)),'!=');}throw e;}if(flatArray.length>0){throw new DimensionError(product(sizes),product(exports.size(array)),'!=');}return newArray;};/**
	 * Recursively re-shape a multi dimensional array to fit the specified dimensions
	 * @param {Array} array           Array to be reshaped
	 * @param {Array.<number>} sizes  List of sizes for each dimension
	 * @returns {Array}               Array whose data has been formatted to fit the
	 *                                specified dimensions
	 *
	 * @throws {DimensionError}       If the product of the new dimension sizes does
	 *                                not equal that of the old ones
	 */function _reshape(array,sizes){var accumulator=[];var i;if(sizes.length===0){if(array.length===0){throw new DimensionError(null,null,'!=');}return array.shift();}for(i=0;i<sizes[0];i+=1){accumulator.push(_reshape(array,sizes.slice(1)));}return accumulator;}/**
	 * Squeeze a multi dimensional array
	 * @param {Array} array
	 * @param {Array} [size]
	 * @returns {Array} returns the array itself
	 */exports.squeeze=function(array,size){var s=size||exports.size(array);// squeeze outer dimensions
while(Array.isArray(array)&&array.length===1){array=array[0];s.shift();}// find the first dimension to be squeezed
var dims=s.length;while(s[dims-1]===1){dims--;}// squeeze inner dimensions
if(dims<s.length){array=_squeeze(array,dims,0);s.length=dims;}return array;};/**
	 * Recursively squeeze a multi dimensional array
	 * @param {Array} array
	 * @param {number} dims Required number of dimensions
	 * @param {number} dim  Current dimension
	 * @returns {Array | *} Returns the squeezed array
	 * @private
	 */function _squeeze(array,dims,dim){var i,ii;if(dim<dims){var next=dim+1;for(i=0, ii=array.length;i<ii;i++){array[i]=_squeeze(array[i],dims,next);}}else{while(Array.isArray(array)){array=array[0];}}return array;}/**
	 * Unsqueeze a multi dimensional array: add dimensions when missing
	 *
	 * Paramter `size` will be mutated to match the new, unqueezed matrix size.
	 *
	 * @param {Array} array
	 * @param {number} dims     Desired number of dimensions of the array
	 * @param {number} [outer]  Number of outer dimensions to be added
	 * @param {Array} [size]    Current size of array.
	 * @returns {Array} returns the array itself
	 * @private
	 */exports.unsqueeze=function(array,dims,outer,size){var s=size||exports.size(array);// unsqueeze outer dimensions
if(outer){for(var i=0;i<outer;i++){array=[array];s.unshift(1);}}// unsqueeze inner dimensions
array=_unsqueeze(array,dims,0);while(s.length<dims){s.push(1);}return array;};/**
	 * Recursively unsqueeze a multi dimensional array
	 * @param {Array} array
	 * @param {number} dims Required number of dimensions
	 * @param {number} dim  Current dimension
	 * @returns {Array | *} Returns the squeezed array
	 * @private
	 */function _unsqueeze(array,dims,dim){var i,ii;if(Array.isArray(array)){var next=dim+1;for(i=0, ii=array.length;i<ii;i++){array[i]=_unsqueeze(array[i],dims,next);}}else{for(var d=dim;d<dims;d++){array=[array];}}return array;}/**
	 * Flatten a multi dimensional array, put all elements in a one dimensional
	 * array
	 * @param {Array} array   A multi dimensional array
	 * @return {Array}        The flattened array (1 dimensional)
	 */exports.flatten=function(array){if(!Array.isArray(array)){//if not an array, return as is
return array;}var flat=[];array.forEach(function callback(value){if(Array.isArray(value)){value.forEach(callback);//traverse through sub-arrays recursively
}else{flat.push(value);}});return flat;};/**
	 * A safe map
	 * @param {Array} array
	 * @param {function} callback
	 */exports.map=function(array,callback){return Array.prototype.map.call(array,callback);};/**
	 * A safe forEach
	 * @param {Array} array
	 * @param {function} callback
	 */exports.forEach=function(array,callback){Array.prototype.forEach.call(array,callback);};/**
	 * A safe filter
	 * @param {Array} array
	 * @param {function} callback
	 */exports.filter=function(array,callback){if(exports.size(array).length!==1){throw new Error('Only one dimensional matrices supported');}return Array.prototype.filter.call(array,callback);};/**
	 * Filter values in a callback given a regular expression
	 * @param {Array} array
	 * @param {RegExp} regexp
	 * @return {Array} Returns the filtered array
	 * @private
	 */exports.filterRegExp=function(array,regexp){if(exports.size(array).length!==1){throw new Error('Only one dimensional matrices supported');}return Array.prototype.filter.call(array,function(entry){return regexp.test(entry);});};/**
	 * A safe join
	 * @param {Array} array
	 * @param {string} separator
	 */exports.join=function(array,separator){return Array.prototype.join.call(array,separator);};/**
	 * Assign a numeric identifier to every element of a sorted array
	 * @param {Array}	a  An array
	 * @return {Array}	An array of objects containing the original value and its identifier
	 */exports.identify=function(a){if(!Array.isArray(a)){throw new TypeError('Array input expected');}if(a.length===0){return a;}var b=[];var count=0;b[0]={value:a[0],identifier:0};for(var i=1;i<a.length;i++){if(a[i]===a[i-1]){count++;}else{count=0;}b.push({value:a[i],identifier:count});}return b;};/**
	 * Remove the numeric identifier from the elements
	 * @param	a  An array
	 * @return	An array of values without identifiers
	 */exports.generalize=function(a){if(!Array.isArray(a)){throw new TypeError('Array input expected');}if(a.length===0){return a;}var b=[];for(var i=0;i<a.length;i++){b.push(a[i].value);}return b;};/**
	 * Test whether an object is an array
	 * @param {*} value
	 * @return {boolean} isArray
	 */exports.isArray=Array.isArray;/***/},/* 28 *//***/function(module,exports,__webpack_require__){var formatNumber=__webpack_require__(18).format;var formatBigNumber=__webpack_require__(29).format;/**
	 * Test whether value is a string
	 * @param {*} value
	 * @return {boolean} isString
	 */exports.isString=function(value){return typeof value==='string';};/**
	 * Check if a text ends with a certain string.
	 * @param {string} text
	 * @param {string} search
	 */exports.endsWith=function(text,search){var start=text.length-search.length;var end=text.length;return text.substring(start,end)===search;};/**
	 * Format a value of any type into a string.
	 *
	 * Usage:
	 *     math.format(value)
	 *     math.format(value, precision)
	 *
	 * When value is a function:
	 *
	 * - When the function has a property `syntax`, it returns this
	 *   syntax description.
	 * - In other cases, a string `'function'` is returned.
	 *
	 * When `value` is an Object:
	 *
	 * - When the object contains a property `format` being a function, this
	 *   function is invoked as `value.format(options)` and the result is returned.
	 * - When the object has its own `toString` method, this method is invoked
	 *   and the result is returned.
	 * - In other cases the function will loop over all object properties and
	 *   return JSON object notation like '{"a": 2, "b": 3}'.
	 *
	 * Example usage:
	 *     math.format(2/7);                // '0.2857142857142857'
	 *     math.format(math.pi, 3);         // '3.14'
	 *     math.format(new Complex(2, 3));  // '2 + 3i'
	 *     math.format('hello');            // '"hello"'
	 *
	 * @param {*} value             Value to be stringified
	 * @param {Object | number | Function} [options]  Formatting options. See
	 *                                                lib/utils/number:format for a
	 *                                                description of the available
	 *                                                options.
	 * @return {string} str
	 */exports.format=function(value,options){if(typeof value==='number'){return formatNumber(value,options);}if(value&&value.isBigNumber===true){return formatBigNumber(value,options);}if(value&&value.isFraction===true){if(!options||options.fraction!=='decimal'){// output as ratio, like '1/3'
return value.s*value.n+'/'+value.d;}else{// output as decimal, like '0.(3)'
return value.toString();}}if(Array.isArray(value)){return formatArray(value,options);}if(exports.isString(value)){return'"'+value+'"';}if(typeof value==='function'){return value.syntax?String(value.syntax):'function';}if(value&&(typeof value==='undefined'?'undefined':_typeof(value))==='object'){if(typeof value.format==='function'){return value.format(options);}else if(value&&value.toString()!=={}.toString()){// this object has a non-native toString method, use that one
return value.toString();}else{var entries=[];for(var key in value){if(value.hasOwnProperty(key)){entries.push('"'+key+'": '+exports.format(value[key],options));}}return'{'+entries.join(', ')+'}';}}return String(value);};/**
	 * Stringify a value into a string enclosed in double quotes.
	 * Unescaped double quotes and backslashes inside the value are escaped.
	 * @param {*} value
	 * @return {string}
	 */exports.stringify=function(value){var text=String(value);var escaped='';var i=0;while(i<text.length){var c=text.charAt(i);if(c==='\\'){escaped+=c;i++;c=text.charAt(i);if(c===''||'"\\/bfnrtu'.indexOf(c)===-1){escaped+='\\';// no valid escape character -> escape it
}escaped+=c;}else if(c==='"'){escaped+='\\"';}else{escaped+=c;}i++;}return'"'+escaped+'"';};/**
	 * Escape special HTML characters
	 * @param {*} value
	 * @return {string}
	 */exports.escape=function(value){var text=String(value);text=text.replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/'/g,'&#39;').replace(/</g,'&lt;').replace(/>/g,'&gt;');return text;};/**
	 * Recursively format an n-dimensional matrix
	 * Example output: "[[1, 2], [3, 4]]"
	 * @param {Array} array
	 * @param {Object | number | Function} [options]  Formatting options. See
	 *                                                lib/utils/number:format for a
	 *                                                description of the available
	 *                                                options.
	 * @returns {string} str
	 */function formatArray(array,options){if(Array.isArray(array)){var str='[';var len=array.length;for(var i=0;i<len;i++){if(i!=0){str+=', ';}str+=formatArray(array[i],options);}str+=']';return str;}else{return exports.format(array,options);}}/***/},/* 29 *//***/function(module,exports){/**
	 * Convert a BigNumber to a formatted string representation.
	 *
	 * Syntax:
	 *
	 *    format(value)
	 *    format(value, options)
	 *    format(value, precision)
	 *    format(value, fn)
	 *
	 * Where:
	 *
	 *    {number} value   The value to be formatted
	 *    {Object} options An object with formatting options. Available options:
	 *                     {string} notation
	 *                         Number notation. Choose from:
	 *                         'fixed'          Always use regular number notation.
	 *                                          For example '123.40' and '14000000'
	 *                         'exponential'    Always use exponential notation.
	 *                                          For example '1.234e+2' and '1.4e+7'
	 *                         'auto' (default) Regular number notation for numbers
	 *                                          having an absolute value between
	 *                                          `lower` and `upper` bounds, and uses
	 *                                          exponential notation elsewhere.
	 *                                          Lower bound is included, upper bound
	 *                                          is excluded.
	 *                                          For example '123.4' and '1.4e7'.
	 *                     {number} precision   A number between 0 and 16 to round
	 *                                          the digits of the number.
	 *                                          In case of notations 'exponential' and
	 *                                          'auto', `precision` defines the total
	 *                                          number of significant digits returned
	 *                                          and is undefined by default.
	 *                                          In case of notation 'fixed',
	 *                                          `precision` defines the number of
	 *                                          significant digits after the decimal
	 *                                          point, and is 0 by default.
	 *                     {Object} exponential An object containing two parameters,
	 *                                          {number} lower and {number} upper,
	 *                                          used by notation 'auto' to determine
	 *                                          when to return exponential notation.
	 *                                          Default values are `lower=1e-3` and
	 *                                          `upper=1e5`.
	 *                                          Only applicable for notation `auto`.
	 *    {Function} fn    A custom formatting function. Can be used to override the
	 *                     built-in notations. Function `fn` is called with `value` as
	 *                     parameter and must return a string. Is useful for example to
	 *                     format all values inside a matrix in a particular way.
	 *
	 * Examples:
	 *
	 *    format(6.4);                                        // '6.4'
	 *    format(1240000);                                    // '1.24e6'
	 *    format(1/3);                                        // '0.3333333333333333'
	 *    format(1/3, 3);                                     // '0.333'
	 *    format(21385, 2);                                   // '21000'
	 *    format(12.071, {notation: 'fixed'});                // '12'
	 *    format(2.3,    {notation: 'fixed', precision: 2});  // '2.30'
	 *    format(52.8,   {notation: 'exponential'});          // '5.28e+1'
	 *
	 * @param {BigNumber} value
	 * @param {Object | Function | number} [options]
	 * @return {string} str The formatted value
	 */exports.format=function(value,options){if(typeof options==='function'){// handle format(value, fn)
return options(value);}// handle special cases
if(!value.isFinite()){return value.isNaN()?'NaN':value.gt(0)?'Infinity':'-Infinity';}// default values for options
var notation='auto';var precision=undefined;if(options!==undefined){// determine notation from options
if(options.notation){notation=options.notation;}// determine precision from options
if(typeof options==='number'){precision=options;}else if(options.precision){precision=options.precision;}}// handle the various notations
switch(notation){case'fixed':return exports.toFixed(value,precision);case'exponential':return exports.toExponential(value,precision);case'auto':// determine lower and upper bound for exponential notation.
// TODO: implement support for upper and lower to be BigNumbers themselves
var lower=1e-3;var upper=1e5;if(options&&options.exponential){if(options.exponential.lower!==undefined){lower=options.exponential.lower;}if(options.exponential.upper!==undefined){upper=options.exponential.upper;}}// adjust the configuration of the BigNumber constructor (yeah, this is quite tricky...)
var oldConfig={toExpNeg:value.constructor.toExpNeg,toExpPos:value.constructor.toExpPos};value.constructor.config({toExpNeg:Math.round(Math.log(lower)/Math.LN10),toExpPos:Math.round(Math.log(upper)/Math.LN10)});// handle special case zero
if(value.isZero())return'0';// determine whether or not to output exponential notation
var str;var abs=value.abs();if(abs.gte(lower)&&abs.lt(upper)){// normal number notation
str=value.toSignificantDigits(precision).toFixed();}else{// exponential notation
str=exports.toExponential(value,precision);}// remove trailing zeros after the decimal point
return str.replace(/((\.\d*?)(0+))($|e)/,function(){var digits=arguments[2];var e=arguments[4];return digits!=='.'?digits+e:e;});default:throw new Error('Unknown notation "'+notation+'". '+'Choose "auto", "exponential", or "fixed".');}};/**
	 * Format a number in exponential notation. Like '1.23e+5', '2.3e+0', '3.500e-3'
	 * @param {BigNumber} value
	 * @param {number} [precision]  Number of digits in formatted output.
	 *                              If not provided, the maximum available digits
	 *                              is used.
	 * @returns {string} str
	 */exports.toExponential=function(value,precision){if(precision!==undefined){return value.toExponential(precision-1);// Note the offset of one
}else{return value.toExponential();}};/**
	 * Format a number with fixed notation.
	 * @param {BigNumber} value
	 * @param {number} [precision=0]        Optional number of decimals after the
	 *                                      decimal point. Zero by default.
	 */exports.toFixed=function(value,precision){return value.toFixed(precision||0);// Note: the (precision || 0) is needed as the toFixed of BigNumber has an
// undefined default precision instead of 0.
};/***/},/* 30 *//***/function(module,exports){exports.type=function(x){var type=typeof x==='undefined'?'undefined':_typeof(x);if(type==='object'){if(x===null)return'null';if(Array.isArray(x))return'Array';if(x instanceof Date)return'Date';if(x instanceof RegExp)return'RegExp';if(x instanceof Boolean)return'boolean';if(x instanceof Number)return'number';if(x instanceof String)return'string';return'Object';}if(type==='function')return'Function';return type;};/***/},/* 31 *//***/function(module,exports){function DimensionError(actual,expected,relation){if(!(this instanceof DimensionError)){throw new SyntaxError('Constructor must be called with the new operator');}this.actual=actual;this.expected=expected;this.relation=relation;this.message='Dimension mismatch ('+(Array.isArray(actual)?'['+actual.join(', ')+']':actual)+' '+(this.relation||'!=')+' '+(Array.isArray(expected)?'['+expected.join(', ')+']':expected)+')';this.stack=new Error().stack;}DimensionError.prototype=new RangeError();DimensionError.prototype.constructor=RangeError;DimensionError.prototype.name='DimensionError';DimensionError.prototype.isDimensionError=true;module.exports=DimensionError;/***/},/* 32 *//***/function(module,exports){function IndexError(index,min,max){if(!(this instanceof IndexError)){throw new SyntaxError('Constructor must be called with the new operator');}this.index=index;if(arguments.length<3){this.min=0;this.max=min;}else{this.min=min;this.max=max;}if(this.min!==undefined&&this.index<this.min){this.message='Index out of range ('+this.index+' < '+this.min+')';}else if(this.max!==undefined&&this.index>=this.max){this.message='Index out of range ('+this.index+' > '+(this.max-1)+')';}else{this.message='Index out of range ('+this.index+')';}this.stack=new Error().stack;}IndexError.prototype=new RangeError();IndexError.prototype.constructor=RangeError;IndexError.prototype.name='IndexError';IndexError.prototype.isIndexError=true;module.exports=IndexError;/***/},/* 33 *//***/function(module,exports){exports.isBoolean=function(value){return typeof value=='boolean';};/***/},/* 34 *//***/function(module,exports){// function utils
/*
	 * Memoize a given function by caching the computed result.
	 * The cache of a memoized function can be cleared by deleting the `cache`
	 * property of the function.
	 *
	 * @param {function} fn                     The function to be memoized.
	 *                                          Must be a pure function.
	 * @param {function(args: Array)} [hasher]  A custom hash builder.
	 *                                          Is JSON.stringify by default.
	 * @return {function}                       Returns the memoized function
	 */exports.memoize=function(fn,hasher){return function memoize(){if(_typeof(memoize.cache)!=='object'){memoize.cache={};}var args=[];for(var i=0;i<arguments.length;i++){args[i]=arguments[i];}var hash=hasher?hasher(args):JSON.stringify(args);if(!(hash in memoize.cache)){return memoize.cache[hash]=fn.apply(fn,args);}return memoize.cache[hash];};};/**
	 * Find the maximum number of arguments expected by a typed function.
	 * @param {function} fn   A typed function
	 * @return {number} Returns the maximum number of expected arguments.
	 *                  Returns -1 when no signatures where found on the function.
	 */exports.maxArgumentCount=function(fn){return Object.keys(fn.signatures||{}).reduce(function(args,signature){var count=(signature.match(/,/g)||[]).length+1;return Math.max(args,count);},-1);};/**
	 * Call a typed function with the
	 * @param {function} fn   A function or typed function
	 * @return {number} Returns the maximum number of expected arguments.
	 *                  Returns -1 when no signatures where found on the function.
	 */exports.callWithRightArgumentCount=function(fn,args,argCount){return Object.keys(fn.signatures||{}).reduce(function(args,signature){var count=(signature.match(/,/g)||[]).length+1;return Math.max(args,count);},-1);};/***/},/* 35 *//***/function(module,exports,__webpack_require__){var util=__webpack_require__(26);var DimensionError=__webpack_require__(31);var getSafeProperty=__webpack_require__(36).getSafeProperty;var setSafeProperty=__webpack_require__(36).setSafeProperty;var string=util.string;var array=util.array;var object=util.object;var number=util.number;var isArray=Array.isArray;var isNumber=number.isNumber;var isInteger=number.isInteger;var isString=string.isString;var validateIndex=array.validateIndex;function factory(type,config,load,typed){var Matrix=load(__webpack_require__(25));// force loading Matrix (do not use via type.Matrix)
/**
	   * Dense Matrix implementation. A regular, dense matrix, supporting multi-dimensional matrices. This is the default matrix type.
	   * @class DenseMatrix
	   */function DenseMatrix(data,datatype){if(!(this instanceof DenseMatrix))throw new SyntaxError('Constructor must be called with the new operator');if(datatype&&!isString(datatype))throw new Error('Invalid datatype: '+datatype);if(data&&data.isMatrix===true){// check data is a DenseMatrix
if(data.type==='DenseMatrix'){// clone data & size
this._data=object.clone(data._data);this._size=object.clone(data._size);this._datatype=datatype||data._datatype;}else{// build data from existing matrix
this._data=data.toArray();this._size=data.size();this._datatype=datatype||data._datatype;}}else if(data&&isArray(data.data)&&isArray(data.size)){// initialize fields from JSON representation
this._data=data.data;this._size=data.size;this._datatype=datatype||data.datatype;}else if(isArray(data)){// replace nested Matrices with Arrays
this._data=preprocess(data);// get the dimensions of the array
this._size=array.size(this._data);// verify the dimensions of the array, TODO: compute size while processing array
array.validate(this._data,this._size);// data type unknown
this._datatype=datatype;}else if(data){// unsupported type
throw new TypeError('Unsupported type of data ('+util.types.type(data)+')');}else{// nothing provided
this._data=[];this._size=[0];this._datatype=datatype;}}DenseMatrix.prototype=new Matrix();/**
	   * Attach type information
	   */DenseMatrix.prototype.type='DenseMatrix';DenseMatrix.prototype.isDenseMatrix=true;/**
	   * Get the storage format used by the matrix.
	   *
	   * Usage:
	   *     var format = matrix.storage()                   // retrieve storage format
	   *
	   * @memberof DenseMatrix
	   * @return {string}           The storage format.
	   */DenseMatrix.prototype.storage=function(){return'dense';};/**
	   * Get the datatype of the data stored in the matrix.
	   *
	   * Usage:
	   *     var format = matrix.datatype()                   // retrieve matrix datatype
	   *
	   * @memberof DenseMatrix
	   * @return {string}           The datatype.
	   */DenseMatrix.prototype.datatype=function(){return this._datatype;};/**
	   * Create a new DenseMatrix
	   * @memberof DenseMatrix
	   * @param {Array} data
	   * @param {string} [datatype]
	   */DenseMatrix.prototype.create=function(data,datatype){return new DenseMatrix(data,datatype);};/**
	   * Get a subset of the matrix, or replace a subset of the matrix.
	   *
	   * Usage:
	   *     var subset = matrix.subset(index)               // retrieve subset
	   *     var value = matrix.subset(index, replacement)   // replace subset
	   *
	   * @memberof DenseMatrix
	   * @param {Index} index
	   * @param {Array | DenseMatrix | *} [replacement]
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be filled with zeros.
	   */DenseMatrix.prototype.subset=function(index,replacement,defaultValue){switch(arguments.length){case 1:return _get(this,index);// intentional fall through
case 2:case 3:return _set(this,index,replacement,defaultValue);default:throw new SyntaxError('Wrong number of arguments');}};/**
	   * Get a single element from the matrix.
	   * @memberof DenseMatrix
	   * @param {number[]} index   Zero-based index
	   * @return {*} value
	   */DenseMatrix.prototype.get=function(index){if(!isArray(index))throw new TypeError('Array expected');if(index.length!=this._size.length)throw new DimensionError(index.length,this._size.length);// check index
for(var x=0;x<index.length;x++){validateIndex(index[x],this._size[x]);}var data=this._data;for(var i=0,ii=index.length;i<ii;i++){var index_i=index[i];validateIndex(index_i,data.length);data=data[index_i];}return data;};/**
	   * Replace a single element in the matrix.
	   * @memberof DenseMatrix
	   * @param {number[]} index   Zero-based index
	   * @param {*} value
	   * @param {*} [defaultValue]        Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be left undefined.
	   * @return {DenseMatrix} self
	   */DenseMatrix.prototype.set=function(index,value,defaultValue){if(!isArray(index))throw new TypeError('Array expected');if(index.length<this._size.length)throw new DimensionError(index.length,this._size.length,'<');var i,ii,index_i;// enlarge matrix when needed
var size=index.map(function(i){return i+1;});_fit(this,size,defaultValue);// traverse over the dimensions
var data=this._data;for(i=0, ii=index.length-1;i<ii;i++){index_i=index[i];validateIndex(index_i,data.length);data=data[index_i];}// set new value
index_i=index[index.length-1];validateIndex(index_i,data.length);data[index_i]=value;return this;};/**
	   * Get a submatrix of this matrix
	   * @memberof DenseMatrix
	   * @param {DenseMatrix} matrix
	   * @param {Index} index   Zero-based index
	   * @private
	   */function _get(matrix,index){if(!index||index.isIndex!==true){throw new TypeError('Invalid index');}var isScalar=index.isScalar();if(isScalar){// return a scalar
return matrix.get(index.min());}else{// validate dimensions
var size=index.size();if(size.length!=matrix._size.length){throw new DimensionError(size.length,matrix._size.length);}// validate if any of the ranges in the index is out of range
var min=index.min();var max=index.max();for(var i=0,ii=matrix._size.length;i<ii;i++){validateIndex(min[i],matrix._size[i]);validateIndex(max[i],matrix._size[i]);}// retrieve submatrix
// TODO: more efficient when creating an empty matrix and setting _data and _size manually
return new DenseMatrix(_getSubmatrix(matrix._data,index,size.length,0),matrix._datatype);}}/**
	   * Recursively get a submatrix of a multi dimensional matrix.
	   * Index is not checked for correct number or length of dimensions.
	   * @memberof DenseMatrix
	   * @param {Array} data
	   * @param {Index} index
	   * @param {number} dims   Total number of dimensions
	   * @param {number} dim    Current dimension
	   * @return {Array} submatrix
	   * @private
	   */function _getSubmatrix(data,index,dims,dim){var last=dim===dims-1;var range=index.dimension(dim);if(last){return range.map(function(i){validateIndex(i,data.length);return data[i];}).valueOf();}else{return range.map(function(i){validateIndex(i,data.length);var child=data[i];return _getSubmatrix(child,index,dims,dim+1);}).valueOf();}}/**
	   * Replace a submatrix in this matrix
	   * Indexes are zero-based.
	   * @memberof DenseMatrix
	   * @param {DenseMatrix} matrix
	   * @param {Index} index
	   * @param {DenseMatrix | Array | *} submatrix
	   * @param {*} defaultValue          Default value, filled in on new entries when
	   *                                  the matrix is resized.
	   * @return {DenseMatrix} matrix
	   * @private
	   */function _set(matrix,index,submatrix,defaultValue){if(!index||index.isIndex!==true){throw new TypeError('Invalid index');}// get index size and check whether the index contains a single value
var iSize=index.size(),isScalar=index.isScalar();// calculate the size of the submatrix, and convert it into an Array if needed
var sSize;if(submatrix&&submatrix.isMatrix===true){sSize=submatrix.size();submatrix=submatrix.valueOf();}else{sSize=array.size(submatrix);}if(isScalar){// set a scalar
// check whether submatrix is a scalar
if(sSize.length!==0){throw new TypeError('Scalar expected');}matrix.set(index.min(),submatrix,defaultValue);}else{// set a submatrix
// validate dimensions
if(iSize.length<matrix._size.length){throw new DimensionError(iSize.length,matrix._size.length,'<');}if(sSize.length<iSize.length){// calculate number of missing outer dimensions
var i=0;var outer=0;while(iSize[i]===1&&sSize[i]===1){i++;}while(iSize[i]===1){outer++;i++;}// unsqueeze both outer and inner dimensions
submatrix=array.unsqueeze(submatrix,iSize.length,outer,sSize);}// check whether the size of the submatrix matches the index size
if(!object.deepEqual(iSize,sSize)){throw new DimensionError(iSize,sSize,'>');}// enlarge matrix when needed
var size=index.max().map(function(i){return i+1;});_fit(matrix,size,defaultValue);// insert the sub matrix
var dims=iSize.length,dim=0;_setSubmatrix(matrix._data,index,submatrix,dims,dim);}return matrix;}/**
	   * Replace a submatrix of a multi dimensional matrix.
	   * @memberof DenseMatrix
	   * @param {Array} data
	   * @param {Index} index
	   * @param {Array} submatrix
	   * @param {number} dims   Total number of dimensions
	   * @param {number} dim
	   * @private
	   */function _setSubmatrix(data,index,submatrix,dims,dim){var last=dim===dims-1,range=index.dimension(dim);if(last){range.forEach(function(dataIndex,subIndex){validateIndex(dataIndex);data[dataIndex]=submatrix[subIndex[0]];});}else{range.forEach(function(dataIndex,subIndex){validateIndex(dataIndex);_setSubmatrix(data[dataIndex],index,submatrix[subIndex[0]],dims,dim+1);});}}/**
	   * Resize the matrix to the given size. Returns a copy of the matrix when
	   * `copy=true`, otherwise return the matrix itself (resize in place).
	   *
	   * @memberof DenseMatrix
	   * @param {number[]} size           The new size the matrix should have.
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
	   *                                  If not provided, the matrix elements will
	   *                                  be filled with zeros.
	   * @param {boolean} [copy]          Return a resized copy of the matrix
	   *
	   * @return {Matrix}                 The resized matrix
	   */DenseMatrix.prototype.resize=function(size,defaultValue,copy){// validate arguments
if(!isArray(size))throw new TypeError('Array expected');// matrix to resize
var m=copy?this.clone():this;// resize matrix
return _resize(m,size,defaultValue);};var _resize=function _resize(matrix,size,defaultValue){// check size
if(size.length===0){// first value in matrix
var v=matrix._data;// go deep
while(isArray(v)){v=v[0];}return v;}// resize matrix
matrix._size=size.slice(0);// copy the array
matrix._data=array.resize(matrix._data,matrix._size,defaultValue);// return matrix
return matrix;};/**
	   * Reshape the matrix to the given size. Returns a copy of the matrix when
	   * `copy=true`, otherwise return the matrix itself (reshape in place).
	   *
	   * NOTE: This might be better suited to copy by default, instead of modifying
	   *       in place. For now, it operates in place to remain consistent with
	   *       resize().
	   *
	   * @memberof DenseMatrix
	   * @param {number[]} size           The new size the matrix should have.
	   * @param {boolean} [copy]          Return a reshaped copy of the matrix
	   *
	   * @return {Matrix}                 The reshaped matrix
	   */DenseMatrix.prototype.reshape=function(size,copy){var m=copy?this.clone():this;m._data=array.reshape(m._data,size);m._size=size.slice(0);return m;};/**
	   * Enlarge the matrix when it is smaller than given size.
	   * If the matrix is larger or equal sized, nothing is done.
	   * @memberof DenseMatrix
	   * @param {DenseMatrix} matrix           The matrix to be resized
	   * @param {number[]} size
	   * @param {*} defaultValue          Default value, filled in on new entries.
	   * @private
	   */function _fit(matrix,size,defaultValue){var newSize=matrix._size.slice(0),// copy the array
changed=false;// add dimensions when needed
while(newSize.length<size.length){newSize.push(0);changed=true;}// enlarge size when needed
for(var i=0,ii=size.length;i<ii;i++){if(size[i]>newSize[i]){newSize[i]=size[i];changed=true;}}if(changed){// resize only when size is changed
_resize(matrix,newSize,defaultValue);}}/**
	   * Create a clone of the matrix
	   * @memberof DenseMatrix
	   * @return {DenseMatrix} clone
	   */DenseMatrix.prototype.clone=function(){var m=new DenseMatrix({data:object.clone(this._data),size:object.clone(this._size),datatype:this._datatype});return m;};/**
	   * Retrieve the size of the matrix.
	   * @memberof DenseMatrix
	   * @returns {number[]} size
	   */DenseMatrix.prototype.size=function(){return this._size.slice(0);// return a clone of _size
};/**
	   * Create a new matrix with the results of the callback function executed on
	   * each entry of the matrix.
	   * @memberof DenseMatrix
	   * @param {Function} callback   The callback function is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix being traversed.
	   *
	   * @return {DenseMatrix} matrix
	   */DenseMatrix.prototype.map=function(callback){// matrix instance
var me=this;var recurse=function recurse(value,index){if(isArray(value)){return value.map(function(child,i){return recurse(child,index.concat(i));});}else{return callback(value,index,me);}};// return dense format
return new DenseMatrix({data:recurse(this._data,[]),size:object.clone(this._size),datatype:this._datatype});};/**
	   * Execute a callback function on each entry of the matrix.
	   * @memberof DenseMatrix
	   * @param {Function} callback   The callback function is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix being traversed.
	   */DenseMatrix.prototype.forEach=function(callback){// matrix instance
var me=this;var recurse=function recurse(value,index){if(isArray(value)){value.forEach(function(child,i){recurse(child,index.concat(i));});}else{callback(value,index,me);}};recurse(this._data,[]);};/**
	   * Create an Array with a copy of the data of the DenseMatrix
	   * @memberof DenseMatrix
	   * @returns {Array} array
	   */DenseMatrix.prototype.toArray=function(){return object.clone(this._data);};/**
	   * Get the primitive value of the DenseMatrix: a multidimensional array
	   * @memberof DenseMatrix
	   * @returns {Array} array
	   */DenseMatrix.prototype.valueOf=function(){return this._data;};/**
	   * Get a string representation of the matrix, with optional formatting options.
	   * @memberof DenseMatrix
	   * @param {Object | number | Function} [options]  Formatting options. See
	   *                                                lib/utils/number:format for a
	   *                                                description of the available
	   *                                                options.
	   * @returns {string} str
	   */DenseMatrix.prototype.format=function(options){return string.format(this._data,options);};/**
	   * Get a string representation of the matrix
	   * @memberof DenseMatrix
	   * @returns {string} str
	   */DenseMatrix.prototype.toString=function(){return string.format(this._data);};/**
	   * Get a JSON representation of the matrix
	   * @memberof DenseMatrix
	   * @returns {Object}
	   */DenseMatrix.prototype.toJSON=function(){return{mathjs:'DenseMatrix',data:this._data,size:this._size,datatype:this._datatype};};/**
	   * Get the kth Matrix diagonal.
	   *
	   * @memberof DenseMatrix
	   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
	   *
	   * @returns {Array}                      The array vector with the diagonal values.
	   */DenseMatrix.prototype.diagonal=function(k){// validate k if any
if(k){// convert BigNumber to a number
if(k.isBigNumber===true)k=k.toNumber();// is must be an integer
if(!isNumber(k)||!isInteger(k)){throw new TypeError('The parameter k must be an integer number');}}else{// default value
k=0;}var kSuper=k>0?k:0;var kSub=k<0?-k:0;// rows & columns
var rows=this._size[0];var columns=this._size[1];// number diagonal values
var n=Math.min(rows-kSub,columns-kSuper);// x is a matrix get diagonal from matrix
var data=[];// loop rows
for(var i=0;i<n;i++){data[i]=this._data[i+kSub][i+kSuper];}// create DenseMatrix
return new DenseMatrix({data:data,size:[n],datatype:this._datatype});};/**
	   * Create a diagonal matrix.
	   *
	   * @memberof DenseMatrix
	   * @param {Array} size                   The matrix size.
	   * @param {number | Array} value          The values for the diagonal.
	   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will be filled in.
	   * @param {number} [defaultValue]        The default value for non-diagonal
	   *
	   * @returns {DenseMatrix}
	   */DenseMatrix.diagonal=function(size,value,k,defaultValue,datatype){if(!isArray(size))throw new TypeError('Array expected, size parameter');if(size.length!==2)throw new Error('Only two dimensions matrix are supported');// map size & validate
size=size.map(function(s){// check it is a big number
if(s&&s.isBigNumber===true){// convert it
s=s.toNumber();}// validate arguments
if(!isNumber(s)||!isInteger(s)||s<1){throw new Error('Size values must be positive integers');}return s;});// validate k if any
if(k){// convert BigNumber to a number
if(k&&k.isBigNumber===true)k=k.toNumber();// is must be an integer
if(!isNumber(k)||!isInteger(k)){throw new TypeError('The parameter k must be an integer number');}}else{// default value
k=0;}if(defaultValue&&isString(datatype)){// convert defaultValue to the same datatype
defaultValue=typed.convert(defaultValue,datatype);}var kSuper=k>0?k:0;var kSub=k<0?-k:0;// rows and columns
var rows=size[0];var columns=size[1];// number of non-zero items
var n=Math.min(rows-kSub,columns-kSuper);// value extraction function
var _value;// check value
if(isArray(value)){// validate array
if(value.length!==n){// number of values in array must be n
throw new Error('Invalid value array length');}// define function
_value=function _value(i){// return value @ i
return value[i];};}else if(value&&value.isMatrix===true){// matrix size
var ms=value.size();// validate matrix
if(ms.length!==1||ms[0]!==n){// number of values in array must be n
throw new Error('Invalid matrix length');}// define function
_value=function _value(i){// return value @ i
return value.get([i]);};}else{// define function
_value=function _value(){// return value
return value;};}// discover default value if needed
if(!defaultValue){// check first value in array
defaultValue=_value(0)&&_value(0).isBigNumber===true?new type.BigNumber(0):0;}// empty array
var data=[];// check we need to resize array
if(size.length>0){// resize array
data=array.resize(data,size,defaultValue);// fill diagonal
for(var d=0;d<n;d++){data[d+kSub][d+kSuper]=_value(d);}}// create DenseMatrix
return new DenseMatrix({data:data,size:[rows,columns]});};/**
	   * Generate a matrix from a JSON object
	   * @memberof DenseMatrix
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "DenseMatrix", data: [], size: []}`,
	   *                       where mathjs is optional
	   * @returns {DenseMatrix}
	   */DenseMatrix.fromJSON=function(json){return new DenseMatrix(json);};/**
	   * Swap rows i and j in Matrix.
	   *
	   * @memberof DenseMatrix
	   * @param {number} i       Matrix row index 1
	   * @param {number} j       Matrix row index 2
	   *
	   * @return {Matrix}        The matrix reference
	   */DenseMatrix.prototype.swapRows=function(i,j){// check index
if(!isNumber(i)||!isInteger(i)||!isNumber(j)||!isInteger(j)){throw new Error('Row index must be positive integers');}// check dimensions
if(this._size.length!==2){throw new Error('Only two dimensional matrix is supported');}// validate index
validateIndex(i,this._size[0]);validateIndex(j,this._size[0]);// swap rows
DenseMatrix._swapRows(i,j,this._data);// return current instance
return this;};/**
	   * Swap rows i and j in Dense Matrix data structure.
	   *
	   * @param {number} i       Matrix row index 1
	   * @param {number} j       Matrix row index 2
	   */DenseMatrix._swapRows=function(i,j,data){// swap values i <-> j
var vi=data[i];data[i]=data[j];data[j]=vi;};/**
	   * Preprocess data, which can be an Array or DenseMatrix with nested Arrays and
	   * Matrices. Replaces all nested Matrices with Arrays
	   * @memberof DenseMatrix
	   * @param {Array} data
	   * @return {Array} data
	   */function preprocess(data){for(var i=0,ii=data.length;i<ii;i++){var elem=data[i];if(isArray(elem)){data[i]=preprocess(elem);}else if(elem&&elem.isMatrix===true){data[i]=preprocess(elem.valueOf());}}return data;}// register this type in the base class Matrix
type.Matrix._storage.dense=DenseMatrix;type.Matrix._storage['default']=DenseMatrix;// exports
return DenseMatrix;}exports.name='DenseMatrix';exports.path='type';exports.factory=factory;exports.lazy=false;// no lazy loading, as we alter type.Matrix._storage
/***/},/* 36 *//***/function(module,exports,__webpack_require__){var hasOwnProperty=__webpack_require__(15).hasOwnProperty;/**
	 * Get a property of a plain object
	 * Throws an error in case the object is not a plain object or the
	 * property is not defined on the object itself
	 * @param {Object} object
	 * @param {string} prop
	 * @return {*} Returns the property value when safe
	 */function getSafeProperty(object,prop){// only allow getting safe properties of a plain object
if(isPlainObject(object)&&isSafeProperty(object,prop)){return object[prop];}if(typeof object[prop]==='function'&&isSafeMethod(object,prop)){throw new Error('Cannot access method "'+prop+'" as a property');}throw new Error('No access to property "'+prop+'"');}/**
	 * Set a property on a plain object.
	 * Throws an error in case the object is not a plain object or the
	 * property would override an inherited property like .constructor or .toString
	 * @param {Object} object
	 * @param {string} prop
	 * @param {*} value
	 * @return {*} Returns the value
	 */// TODO: merge this function into access.js?
function setSafeProperty(object,prop,value){// only allow setting safe properties of a plain object
if(isPlainObject(object)&&isSafeProperty(object,prop)){return object[prop]=value;}throw new Error('No access to property "'+prop+'"');}/**
	 * Test whether a property is safe to use for an object.
	 * For example .toString and .constructor are not safe
	 * @param {string} prop
	 * @return {boolean} Returns true when safe
	 */function isSafeProperty(object,prop){if(!object||(typeof object==='undefined'?'undefined':_typeof(object))!=='object'){return false;}// SAFE: whitelisted
// e.g length
if(hasOwnProperty(safeNativeProperties,prop)){return true;}// UNSAFE: inherited from Object prototype
// e.g constructor
if(prop in Object.prototype){// 'in' is used instead of hasOwnProperty for nodejs v0.10
// which is inconsistent on root prototypes. It is safe
// here because Object.prototype is a root object
return false;}// UNSAFE: inherited from Function prototype
// e.g call, apply
if(prop in Function.prototype){// 'in' is used instead of hasOwnProperty for nodejs v0.10
// which is inconsistent on root prototypes. It is safe
// here because Function.prototype is a root object
return false;}return true;}/**
	 * Validate whether a method is safe.
	 * Throws an error when that's not the case.
	 * @param {Object} object
	 * @param {string} method
	 */// TODO: merge this function into assign.js?
function validateSafeMethod(object,method){if(!isSafeMethod(object,method)){throw new Error('No access to method "'+method+'"');}}/**
	 * Check whether a method is safe.
	 * Throws an error when that's not the case (for example for `constructor`).
	 * @param {Object} object
	 * @param {string} method
	 * @return {boolean} Returns true when safe, false otherwise
	 */function isSafeMethod(object,method){if(!object||typeof object[method]!=='function'){return false;}// UNSAFE: ghosted
// e.g overridden toString
// Note that IE10 doesn't support __proto__ and we can't do this check there.
if(hasOwnProperty(object,method)&&object.__proto__&&method in object.__proto__){return false;}// SAFE: whitelisted
// e.g toString
if(hasOwnProperty(safeNativeMethods,method)){return true;}// UNSAFE: inherited from Object prototype
// e.g constructor
if(method in Object.prototype){// 'in' is used instead of hasOwnProperty for nodejs v0.10
// which is inconsistent on root prototypes. It is safe
// here because Object.prototype is a root object
return false;}// UNSAFE: inherited from Function prototype
// e.g call, apply
if(method in Function.prototype){// 'in' is used instead of hasOwnProperty for nodejs v0.10
// which is inconsistent on root prototypes. It is safe
// here because Function.prototype is a root object
return false;}return true;}function isPlainObject(object){return(typeof object==='undefined'?'undefined':_typeof(object))==='object'&&object&&object.constructor===Object;}var safeNativeProperties={length:true};var safeNativeMethods={toString:true,valueOf:true,toLocaleString:true};exports.getSafeProperty=getSafeProperty;exports.setSafeProperty=setSafeProperty;exports.isSafeProperty=isSafeProperty;exports.validateSafeMethod=validateSafeMethod;exports.isSafeMethod=isSafeMethod;exports.isPlainObject=isPlainObject;/***/},/* 37 *//***/function(module,exports,__webpack_require__){var util=__webpack_require__(26);var DimensionError=__webpack_require__(31);var array=util.array;var object=util.object;var string=util.string;var number=util.number;var isArray=Array.isArray;var isNumber=number.isNumber;var isInteger=number.isInteger;var isString=string.isString;var validateIndex=array.validateIndex;function factory(type,config,load,typed){var Matrix=load(__webpack_require__(25));// force loading Matrix (do not use via type.Matrix)
var equalScalar=load(__webpack_require__(38));/**
	   * Sparse Matrix implementation. This type implements a Compressed Column Storage format
	   * for sparse matrices.
	   * @class SparseMatrix
	   */function SparseMatrix(data,datatype){if(!(this instanceof SparseMatrix))throw new SyntaxError('Constructor must be called with the new operator');if(datatype&&!isString(datatype))throw new Error('Invalid datatype: '+datatype);if(data&&data.isMatrix===true){// create from matrix
_createFromMatrix(this,data,datatype);}else if(data&&isArray(data.index)&&isArray(data.ptr)&&isArray(data.size)){// initialize fields
this._values=data.values;this._index=data.index;this._ptr=data.ptr;this._size=data.size;this._datatype=datatype||data.datatype;}else if(isArray(data)){// create from array
_createFromArray(this,data,datatype);}else if(data){// unsupported type
throw new TypeError('Unsupported type of data ('+util.types.type(data)+')');}else{// nothing provided
this._values=[];this._index=[];this._ptr=[0];this._size=[0,0];this._datatype=datatype;}}var _createFromMatrix=function _createFromMatrix(matrix,source,datatype){// check matrix type
if(source.type==='SparseMatrix'){// clone arrays
matrix._values=source._values?object.clone(source._values):undefined;matrix._index=object.clone(source._index);matrix._ptr=object.clone(source._ptr);matrix._size=object.clone(source._size);matrix._datatype=datatype||source._datatype;}else{// build from matrix data
_createFromArray(matrix,source.valueOf(),datatype||source._datatype);}};var _createFromArray=function _createFromArray(matrix,data,datatype){// initialize fields
matrix._values=[];matrix._index=[];matrix._ptr=[];matrix._datatype=datatype;// discover rows & columns, do not use math.size() to avoid looping array twice
var rows=data.length;var columns=0;// equal signature to use
var eq=equalScalar;// zero value
var zero=0;if(isString(datatype)){// find signature that matches (datatype, datatype)
eq=typed.find(equalScalar,[datatype,datatype])||equalScalar;// convert 0 to the same datatype
zero=typed.convert(0,datatype);}// check we have rows (empty array)
if(rows>0){// column index
var j=0;do{// store pointer to values index
matrix._ptr.push(matrix._index.length);// loop rows
for(var i=0;i<rows;i++){// current row
var row=data[i];// check row is an array
if(isArray(row)){// update columns if needed (only on first column)
if(j===0&&columns<row.length)columns=row.length;// check row has column
if(j<row.length){// value
var v=row[j];// check value != 0
if(!eq(v,zero)){// store value
matrix._values.push(v);// index
matrix._index.push(i);}}}else{// update columns if needed (only on first column)
if(j===0&&columns<1)columns=1;// check value != 0 (row is a scalar)
if(!eq(row,zero)){// store value
matrix._values.push(row);// index
matrix._index.push(i);}}}// increment index
j++;}while(j<columns);}// store number of values in ptr
matrix._ptr.push(matrix._index.length);// size
matrix._size=[rows,columns];};SparseMatrix.prototype=new Matrix();/**
	   * Attach type information
	   */SparseMatrix.prototype.type='SparseMatrix';SparseMatrix.prototype.isSparseMatrix=true;/**
	   * Get the storage format used by the matrix.
	   *
	   * Usage:
	   *     var format = matrix.storage()                   // retrieve storage format
	   *
	   * @memberof SparseMatrix
	   * @return {string}           The storage format.
	   */SparseMatrix.prototype.storage=function(){return'sparse';};/**
	   * Get the datatype of the data stored in the matrix.
	   *
	   * Usage:
	   *     var format = matrix.datatype()                   // retrieve matrix datatype
	   *
	   * @memberof SparseMatrix
	   * @return {string}           The datatype.
	   */SparseMatrix.prototype.datatype=function(){return this._datatype;};/**
	   * Create a new SparseMatrix
	   * @memberof SparseMatrix
	   * @param {Array} data
	   * @param {string} [datatype]
	   */SparseMatrix.prototype.create=function(data,datatype){return new SparseMatrix(data,datatype);};/**
	   * Get the matrix density.
	   *
	   * Usage:
	   *     var density = matrix.density()                   // retrieve matrix density
	   *
	   * @memberof SparseMatrix
	   * @return {number}           The matrix density.
	   */SparseMatrix.prototype.density=function(){// rows & columns
var rows=this._size[0];var columns=this._size[1];// calculate density
return rows!==0&&columns!==0?this._index.length/(rows*columns):0;};/**
	   * Get a subset of the matrix, or replace a subset of the matrix.
	   *
	   * Usage:
	   *     var subset = matrix.subset(index)               // retrieve subset
	   *     var value = matrix.subset(index, replacement)   // replace subset
	   *
	   * @memberof SparseMatrix
	   * @param {Index} index
	   * @param {Array | Maytrix | *} [replacement]
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be filled with zeros.
	   */SparseMatrix.prototype.subset=function(index,replacement,defaultValue){// check it is a pattern matrix
if(!this._values)throw new Error('Cannot invoke subset on a Pattern only matrix');// check arguments
switch(arguments.length){case 1:return _getsubset(this,index);// intentional fall through
case 2:case 3:return _setsubset(this,index,replacement,defaultValue);default:throw new SyntaxError('Wrong number of arguments');}};var _getsubset=function _getsubset(matrix,idx){// check idx
if(!idx||idx.isIndex!==true){throw new TypeError('Invalid index');}var isScalar=idx.isScalar();if(isScalar){// return a scalar
return matrix.get(idx.min());}// validate dimensions
var size=idx.size();if(size.length!=matrix._size.length){throw new DimensionError(size.length,matrix._size.length);}// vars
var i,ii,k,kk;// validate if any of the ranges in the index is out of range
var min=idx.min();var max=idx.max();for(i=0, ii=matrix._size.length;i<ii;i++){validateIndex(min[i],matrix._size[i]);validateIndex(max[i],matrix._size[i]);}// matrix arrays
var mvalues=matrix._values;var mindex=matrix._index;var mptr=matrix._ptr;// rows & columns dimensions for result matrix
var rows=idx.dimension(0);var columns=idx.dimension(1);// workspace & permutation vector
var w=[];var pv=[];// loop rows in resulting matrix
rows.forEach(function(i,r){// update permutation vector
pv[i]=r[0];// mark i in workspace
w[i]=true;});// result matrix arrays
var values=mvalues?[]:undefined;var index=[];var ptr=[];// loop columns in result matrix
columns.forEach(function(j){// update ptr
ptr.push(index.length);// loop values in column j
for(k=mptr[j], kk=mptr[j+1];k<kk;k++){// row
i=mindex[k];// check row is in result matrix
if(w[i]===true){// push index
index.push(pv[i]);// check we need to process values
if(values)values.push(mvalues[k]);}}});// update ptr
ptr.push(index.length);// return matrix
return new SparseMatrix({values:values,index:index,ptr:ptr,size:size,datatype:matrix._datatype});};var _setsubset=function _setsubset(matrix,index,submatrix,defaultValue){// check index
if(!index||index.isIndex!==true){throw new TypeError('Invalid index');}// get index size and check whether the index contains a single value
var iSize=index.size(),isScalar=index.isScalar();// calculate the size of the submatrix, and convert it into an Array if needed
var sSize;if(submatrix&&submatrix.isMatrix===true){// submatrix size
sSize=submatrix.size();// use array representation
submatrix=submatrix.toArray();}else{// get submatrix size (array, scalar)
sSize=array.size(submatrix);}// check index is a scalar
if(isScalar){// verify submatrix is a scalar
if(sSize.length!==0){throw new TypeError('Scalar expected');}// set value
matrix.set(index.min(),submatrix,defaultValue);}else{// validate dimensions, index size must be one or two dimensions
if(iSize.length!==1&&iSize.length!==2){throw new DimensionError(iSize.length,matrix._size.length,'<');}// check submatrix and index have the same dimensions
if(sSize.length<iSize.length){// calculate number of missing outer dimensions
var i=0;var outer=0;while(iSize[i]===1&&sSize[i]===1){i++;}while(iSize[i]===1){outer++;i++;}// unsqueeze both outer and inner dimensions
submatrix=array.unsqueeze(submatrix,iSize.length,outer,sSize);}// check whether the size of the submatrix matches the index size
if(!object.deepEqual(iSize,sSize)){throw new DimensionError(iSize,sSize,'>');}// offsets
var x0=index.min()[0];var y0=index.min()[1];// submatrix rows and columns
var m=sSize[0];var n=sSize[1];// loop submatrix
for(var x=0;x<m;x++){// loop columns
for(var y=0;y<n;y++){// value at i, j
var v=submatrix[x][y];// invoke set (zero value will remove entry from matrix)
matrix.set([x+x0,y+y0],v,defaultValue);}}}return matrix;};/**
	   * Get a single element from the matrix.
	   * @memberof SparseMatrix
	   * @param {number[]} index   Zero-based index
	   * @return {*} value
	   */SparseMatrix.prototype.get=function(index){if(!isArray(index))throw new TypeError('Array expected');if(index.length!=this._size.length)throw new DimensionError(index.length,this._size.length);// check it is a pattern matrix
if(!this._values)throw new Error('Cannot invoke get on a Pattern only matrix');// row and column
var i=index[0];var j=index[1];// check i, j are valid
validateIndex(i,this._size[0]);validateIndex(j,this._size[1]);// find value index
var k=_getValueIndex(i,this._ptr[j],this._ptr[j+1],this._index);// check k is prior to next column k and it is in the correct row
if(k<this._ptr[j+1]&&this._index[k]===i)return this._values[k];return 0;};/**
	   * Replace a single element in the matrix.
	   * @memberof SparseMatrix
	   * @param {number[]} index   Zero-based index
	   * @param {*} value
	   * @param {*} [defaultValue]        Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be set to zero.
	   * @return {SparseMatrix} self
	   */SparseMatrix.prototype.set=function(index,v,defaultValue){if(!isArray(index))throw new TypeError('Array expected');if(index.length!=this._size.length)throw new DimensionError(index.length,this._size.length);// check it is a pattern matrix
if(!this._values)throw new Error('Cannot invoke set on a Pattern only matrix');// row and column
var i=index[0];var j=index[1];// rows & columns
var rows=this._size[0];var columns=this._size[1];// equal signature to use
var eq=equalScalar;// zero value
var zero=0;if(isString(this._datatype)){// find signature that matches (datatype, datatype)
eq=typed.find(equalScalar,[this._datatype,this._datatype])||equalScalar;// convert 0 to the same datatype
zero=typed.convert(0,this._datatype);}// check we need to resize matrix
if(i>rows-1||j>columns-1){// resize matrix
_resize(this,Math.max(i+1,rows),Math.max(j+1,columns),defaultValue);// update rows & columns
rows=this._size[0];columns=this._size[1];}// check i, j are valid
validateIndex(i,rows);validateIndex(j,columns);// find value index
var k=_getValueIndex(i,this._ptr[j],this._ptr[j+1],this._index);// check k is prior to next column k and it is in the correct row
if(k<this._ptr[j+1]&&this._index[k]===i){// check value != 0
if(!eq(v,zero)){// update value
this._values[k]=v;}else{// remove value from matrix
_remove(k,j,this._values,this._index,this._ptr);}}else{// insert value @ (i, j)
_insert(k,i,j,v,this._values,this._index,this._ptr);}return this;};var _getValueIndex=function _getValueIndex(i,top,bottom,index){// check row is on the bottom side
if(bottom-top===0)return bottom;// loop rows [top, bottom[
for(var r=top;r<bottom;r++){// check we found value index
if(index[r]===i)return r;}// we did not find row
return top;};var _remove=function _remove(k,j,values,index,ptr){// remove value @ k
values.splice(k,1);index.splice(k,1);// update pointers
for(var x=j+1;x<ptr.length;x++){ptr[x]--;}};var _insert=function _insert(k,i,j,v,values,index,ptr){// insert value
values.splice(k,0,v);// update row for k
index.splice(k,0,i);// update column pointers
for(var x=j+1;x<ptr.length;x++){ptr[x]++;}};/**
	   * Resize the matrix to the given size. Returns a copy of the matrix when
	   * `copy=true`, otherwise return the matrix itself (resize in place).
	   *
	   * @memberof SparseMatrix
	   * @param {number[]} size           The new size the matrix should have.
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
	   *                                  If not provided, the matrix elements will
	   *                                  be filled with zeros.
	   * @param {boolean} [copy]          Return a resized copy of the matrix
	   *
	   * @return {Matrix}                 The resized matrix
	   */SparseMatrix.prototype.resize=function(size,defaultValue,copy){// validate arguments
if(!isArray(size))throw new TypeError('Array expected');if(size.length!==2)throw new Error('Only two dimensions matrix are supported');// check sizes
size.forEach(function(value){if(!number.isNumber(value)||!number.isInteger(value)||value<0){throw new TypeError('Invalid size, must contain positive integers '+'(size: '+string.format(size)+')');}});// matrix to resize
var m=copy?this.clone():this;// resize matrix
return _resize(m,size[0],size[1],defaultValue);};var _resize=function _resize(matrix,rows,columns,defaultValue){// value to insert at the time of growing matrix
var value=defaultValue||0;// equal signature to use
var eq=equalScalar;// zero value
var zero=0;if(isString(matrix._datatype)){// find signature that matches (datatype, datatype)
eq=typed.find(equalScalar,[matrix._datatype,matrix._datatype])||equalScalar;// convert 0 to the same datatype
zero=typed.convert(0,matrix._datatype);// convert value to the same datatype
value=typed.convert(value,matrix._datatype);}// should we insert the value?
var ins=!eq(value,zero);// old columns and rows
var r=matrix._size[0];var c=matrix._size[1];var i,j,k;// check we need to increase columns
if(columns>c){// loop new columns
for(j=c;j<columns;j++){// update matrix._ptr for current column
matrix._ptr[j]=matrix._values.length;// check we need to insert matrix._values
if(ins){// loop rows
for(i=0;i<r;i++){// add new matrix._values
matrix._values.push(value);// update matrix._index
matrix._index.push(i);}}}// store number of matrix._values in matrix._ptr
matrix._ptr[columns]=matrix._values.length;}else if(columns<c){// truncate matrix._ptr
matrix._ptr.splice(columns+1,c-columns);// truncate matrix._values and matrix._index
matrix._values.splice(matrix._ptr[columns],matrix._values.length);matrix._index.splice(matrix._ptr[columns],matrix._index.length);}// update columns
c=columns;// check we need to increase rows
if(rows>r){// check we have to insert values
if(ins){// inserts
var n=0;// loop columns
for(j=0;j<c;j++){// update matrix._ptr for current column
matrix._ptr[j]=matrix._ptr[j]+n;// where to insert matrix._values
k=matrix._ptr[j+1]+n;// pointer
var p=0;// loop new rows, initialize pointer
for(i=r;i<rows;i++, p++){// add value
matrix._values.splice(k+p,0,value);// update matrix._index
matrix._index.splice(k+p,0,i);// increment inserts
n++;}}// store number of matrix._values in matrix._ptr
matrix._ptr[c]=matrix._values.length;}}else if(rows<r){// deletes
var d=0;// loop columns
for(j=0;j<c;j++){// update matrix._ptr for current column
matrix._ptr[j]=matrix._ptr[j]-d;// where matrix._values start for next column
var k0=matrix._ptr[j];var k1=matrix._ptr[j+1]-d;// loop matrix._index
for(k=k0;k<k1;k++){// row
i=matrix._index[k];// check we need to delete value and matrix._index
if(i>rows-1){// remove value
matrix._values.splice(k,1);// remove item from matrix._index
matrix._index.splice(k,1);// increase deletes
d++;}}}// update matrix._ptr for current column
matrix._ptr[j]=matrix._values.length;}// update matrix._size
matrix._size[0]=rows;matrix._size[1]=columns;// return matrix
return matrix;};/**
	   * Reshape the matrix to the given size. Returns a copy of the matrix when
	   * `copy=true`, otherwise return the matrix itself (reshape in place).
	   *
	   * NOTE: This might be better suited to copy by default, instead of modifying
	   *       in place. For now, it operates in place to remain consistent with
	   *       resize().
	   *
	   * @memberof SparseMatrix
	   * @param {number[]} size           The new size the matrix should have.
	   * @param {boolean} [copy]          Return a reshaped copy of the matrix
	   *
	   * @return {Matrix}                 The reshaped matrix
	   */SparseMatrix.prototype.reshape=function(size,copy){// validate arguments
if(!isArray(size))throw new TypeError('Array expected');if(size.length!==2)throw new Error('Sparse matrices can only be reshaped in two dimensions');// check sizes
size.forEach(function(value){if(!number.isNumber(value)||!number.isInteger(value)||value<0){throw new TypeError('Invalid size, must contain positive integers '+'(size: '+string.format(size)+')');}});// m * n must not change
if(this._size[0]*this._size[1]!==size[0]*size[1]){throw new Error('Reshaping sparse matrix will result in the wrong number of elements');}// matrix to reshape
var m=copy?this.clone():this;// return unchanged if the same shape
if(this._size[0]===size[0]&&this._size[1]===size[1]){return m;}// Convert to COO format (generate a column index)
var colIndex=[];for(var i=0;i<m._ptr.length;i++){for(var j=0;j<m._ptr[i+1]-m._ptr[i];j++){colIndex.push(i);}}// Clone the values array
var values=m._values.slice();// Clone the row index array
var rowIndex=m._index.slice();// Transform the (row, column) indices
for(var i=0;i<m._index.length;i++){var r1=rowIndex[i];var c1=colIndex[i];var flat=r1*m._size[1]+c1;colIndex[i]=flat%size[1];rowIndex[i]=Math.floor(flat/size[1]);}// Now reshaping is supposed to preserve the row-major order, BUT these sparse matrices are stored
// in column-major order, so we have to reorder the value array now. One option is to use a multisort,
// sorting several arrays based on some other array.
// OR, we could easily just:
// 1. Remove all values from the matrix
m._values.length=0;m._index.length=0;m._ptr.length=size[1]+1;m._size=size.slice();for(var i=0;i<m._ptr.length;i++){m._ptr[i]=0;}// 2. Re-insert all elements in the proper order (simplified code from SparseMatrix.prototype.set)
// This step is probably the most time-consuming
for(var h=0;h<values.length;h++){var i=rowIndex[h];var j=colIndex[h];var v=values[h];var k=_getValueIndex(i,m._ptr[j],m._ptr[j+1],m._index);_insert(k,i,j,v,m._values,m._index,m._ptr);}// The value indices are inserted out of order, but apparently that's... still OK?
return m;};/**
	   * Create a clone of the matrix
	   * @memberof SparseMatrix
	   * @return {SparseMatrix} clone
	   */SparseMatrix.prototype.clone=function(){var m=new SparseMatrix({values:this._values?object.clone(this._values):undefined,index:object.clone(this._index),ptr:object.clone(this._ptr),size:object.clone(this._size),datatype:this._datatype});return m;};/**
	   * Retrieve the size of the matrix.
	   * @memberof SparseMatrix
	   * @returns {number[]} size
	   */SparseMatrix.prototype.size=function(){return this._size.slice(0);// copy the Array
};/**
	   * Create a new matrix with the results of the callback function executed on
	   * each entry of the matrix.
	   * @memberof SparseMatrix
	   * @param {Function} callback   The callback function is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix being traversed.
	   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
	   *
	   * @return {SparseMatrix} matrix
	   */SparseMatrix.prototype.map=function(callback,skipZeros){// check it is a pattern matrix
if(!this._values)throw new Error('Cannot invoke map on a Pattern only matrix');// matrix instance
var me=this;// rows and columns
var rows=this._size[0];var columns=this._size[1];// invoke callback
var invoke=function invoke(v,i,j){// invoke callback
return callback(v,[i,j],me);};// invoke _map
return _map(this,0,rows-1,0,columns-1,invoke,skipZeros);};/**
	   * Create a new matrix with the results of the callback function executed on the interval
	   * [minRow..maxRow, minColumn..maxColumn].
	   */var _map=function _map(matrix,minRow,maxRow,minColumn,maxColumn,callback,skipZeros){// result arrays
var values=[];var index=[];var ptr=[];// equal signature to use
var eq=equalScalar;// zero value
var zero=0;if(isString(matrix._datatype)){// find signature that matches (datatype, datatype)
eq=typed.find(equalScalar,[matrix._datatype,matrix._datatype])||equalScalar;// convert 0 to the same datatype
zero=typed.convert(0,matrix._datatype);}// invoke callback
var invoke=function invoke(v,x,y){// invoke callback
v=callback(v,x,y);// check value != 0
if(!eq(v,zero)){// store value
values.push(v);// index
index.push(x);}};// loop columns
for(var j=minColumn;j<=maxColumn;j++){// store pointer to values index
ptr.push(values.length);// k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
var k0=matrix._ptr[j];var k1=matrix._ptr[j+1];// row pointer
var p=minRow;// loop k within [k0, k1[
for(var k=k0;k<k1;k++){// row index
var i=matrix._index[k];// check i is in range
if(i>=minRow&&i<=maxRow){// zero values
if(!skipZeros){for(var x=p;x<i;x++){invoke(0,x-minRow,j-minColumn);}}// value @ k
invoke(matrix._values[k],i-minRow,j-minColumn);}// update pointer
p=i+1;}// zero values
if(!skipZeros){for(var y=p;y<=maxRow;y++){invoke(0,y-minRow,j-minColumn);}}}// store number of values in ptr
ptr.push(values.length);// return sparse matrix
return new SparseMatrix({values:values,index:index,ptr:ptr,size:[maxRow-minRow+1,maxColumn-minColumn+1]});};/**
	   * Execute a callback function on each entry of the matrix.
	   * @memberof SparseMatrix
	   * @param {Function} callback   The callback function is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix being traversed.
	   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
	   */SparseMatrix.prototype.forEach=function(callback,skipZeros){// check it is a pattern matrix
if(!this._values)throw new Error('Cannot invoke forEach on a Pattern only matrix');// matrix instance
var me=this;// rows and columns
var rows=this._size[0];var columns=this._size[1];// loop columns
for(var j=0;j<columns;j++){// k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
var k0=this._ptr[j];var k1=this._ptr[j+1];// column pointer
var p=0;// loop k within [k0, k1[
for(var k=k0;k<k1;k++){// row index
var i=this._index[k];// check we need to process zeros
if(!skipZeros){// zero values
for(var x=p;x<i;x++){callback(0,[x,j],me);}}// value @ k
callback(this._values[k],[i,j],me);// update pointer
p=i+1;}// check we need to process zeros
if(!skipZeros){// zero values
for(var y=p;y<rows;y++){callback(0,[y,j],me);}}}};/**
	   * Create an Array with a copy of the data of the SparseMatrix
	   * @memberof SparseMatrix
	   * @returns {Array} array
	   */SparseMatrix.prototype.toArray=function(){return _toArray(this._values,this._index,this._ptr,this._size,true);};/**
	   * Get the primitive value of the SparseMatrix: a two dimensions array
	   * @memberof SparseMatrix
	   * @returns {Array} array
	   */SparseMatrix.prototype.valueOf=function(){return _toArray(this._values,this._index,this._ptr,this._size,false);};var _toArray=function _toArray(values,index,ptr,size,copy){// rows and columns
var rows=size[0];var columns=size[1];// result
var a=[];// vars
var i,j;// initialize array
for(i=0;i<rows;i++){a[i]=[];for(j=0;j<columns;j++){a[i][j]=0;}}// loop columns
for(j=0;j<columns;j++){// k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
var k0=ptr[j];var k1=ptr[j+1];// loop k within [k0, k1[
for(var k=k0;k<k1;k++){// row index
i=index[k];// set value (use one for pattern matrix)
a[i][j]=values?copy?object.clone(values[k]):values[k]:1;}}return a;};/**
	   * Get a string representation of the matrix, with optional formatting options.
	   * @memberof SparseMatrix
	   * @param {Object | number | Function} [options]  Formatting options. See
	   *                                                lib/utils/number:format for a
	   *                                                description of the available
	   *                                                options.
	   * @returns {string} str
	   */SparseMatrix.prototype.format=function(options){// rows and columns
var rows=this._size[0];var columns=this._size[1];// density
var density=this.density();// rows & columns
var str='Sparse Matrix ['+string.format(rows,options)+' x '+string.format(columns,options)+'] density: '+string.format(density,options)+'\n';// loop columns
for(var j=0;j<columns;j++){// k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
var k0=this._ptr[j];var k1=this._ptr[j+1];// loop k within [k0, k1[
for(var k=k0;k<k1;k++){// row index
var i=this._index[k];// append value
str+='\n    ('+string.format(i,options)+', '+string.format(j,options)+') ==> '+(this._values?string.format(this._values[k],options):'X');}}return str;};/**
	   * Get a string representation of the matrix
	   * @memberof SparseMatrix
	   * @returns {string} str
	   */SparseMatrix.prototype.toString=function(){return string.format(this.toArray());};/**
	   * Get a JSON representation of the matrix
	   * @memberof SparseMatrix
	   * @returns {Object}
	   */SparseMatrix.prototype.toJSON=function(){return{mathjs:'SparseMatrix',values:this._values,index:this._index,ptr:this._ptr,size:this._size,datatype:this._datatype};};/**
	   * Get the kth Matrix diagonal.
	   *
	   * @memberof SparseMatrix
	   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
	   *
	   * @returns {Matrix}                     The matrix vector with the diagonal values.
	   */SparseMatrix.prototype.diagonal=function(k){// validate k if any
if(k){// convert BigNumber to a number
if(k.isBigNumber===true)k=k.toNumber();// is must be an integer
if(!isNumber(k)||!isInteger(k)){throw new TypeError('The parameter k must be an integer number');}}else{// default value
k=0;}var kSuper=k>0?k:0;var kSub=k<0?-k:0;// rows & columns
var rows=this._size[0];var columns=this._size[1];// number diagonal values
var n=Math.min(rows-kSub,columns-kSuper);// diagonal arrays
var values=[];var index=[];var ptr=[];// initial ptr value
ptr[0]=0;// loop columns
for(var j=kSuper;j<columns&&values.length<n;j++){// k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
var k0=this._ptr[j];var k1=this._ptr[j+1];// loop x within [k0, k1[
for(var x=k0;x<k1;x++){// row index
var i=this._index[x];// check row
if(i===j-kSuper+kSub){// value on this column
values.push(this._values[x]);// store row
index[values.length-1]=i-kSub;// exit loop
break;}}}// close ptr
ptr.push(values.length);// return matrix
return new SparseMatrix({values:values,index:index,ptr:ptr,size:[n,1]});};/**
	   * Generate a matrix from a JSON object
	   * @memberof SparseMatrix
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "SparseMatrix", "values": [], "index": [], "ptr": [], "size": []}`,
	   *                       where mathjs is optional
	   * @returns {SparseMatrix}
	   */SparseMatrix.fromJSON=function(json){return new SparseMatrix(json);};/**
	   * Create a diagonal matrix.
	   *
	   * @memberof SparseMatrix
	   * @param {Array} size                       The matrix size.
	   * @param {number | Array | Matrix } value   The values for the diagonal.
	   * @param {number | BigNumber} [k=0]         The kth diagonal where the vector will be filled in.
	   * @param {string} [datatype]                The Matrix datatype, values must be of this datatype.
	   *
	   * @returns {SparseMatrix}
	   */SparseMatrix.diagonal=function(size,value,k,defaultValue,datatype){if(!isArray(size))throw new TypeError('Array expected, size parameter');if(size.length!==2)throw new Error('Only two dimensions matrix are supported');// map size & validate
size=size.map(function(s){// check it is a big number
if(s&&s.isBigNumber===true){// convert it
s=s.toNumber();}// validate arguments
if(!isNumber(s)||!isInteger(s)||s<1){throw new Error('Size values must be positive integers');}return s;});// validate k if any
if(k){// convert BigNumber to a number
if(k.isBigNumber===true)k=k.toNumber();// is must be an integer
if(!isNumber(k)||!isInteger(k)){throw new TypeError('The parameter k must be an integer number');}}else{// default value
k=0;}// equal signature to use
var eq=equalScalar;// zero value
var zero=0;if(isString(datatype)){// find signature that matches (datatype, datatype)
eq=typed.find(equalScalar,[datatype,datatype])||equalScalar;// convert 0 to the same datatype
zero=typed.convert(0,datatype);}var kSuper=k>0?k:0;var kSub=k<0?-k:0;// rows and columns
var rows=size[0];var columns=size[1];// number of non-zero items
var n=Math.min(rows-kSub,columns-kSuper);// value extraction function
var _value;// check value
if(isArray(value)){// validate array
if(value.length!==n){// number of values in array must be n
throw new Error('Invalid value array length');}// define function
_value=function _value(i){// return value @ i
return value[i];};}else if(value&&value.isMatrix===true){// matrix size
var ms=value.size();// validate matrix
if(ms.length!==1||ms[0]!==n){// number of values in array must be n
throw new Error('Invalid matrix length');}// define function
_value=function _value(i){// return value @ i
return value.get([i]);};}else{// define function
_value=function _value(){// return value
return value;};}// create arrays
var values=[];var index=[];var ptr=[];// loop items
for(var j=0;j<columns;j++){// number of rows with value
ptr.push(values.length);// diagonal index
var i=j-kSuper;// check we need to set diagonal value
if(i>=0&&i<n){// get value @ i
var v=_value(i);// check for zero
if(!eq(v,zero)){// column
index.push(i+kSub);// add value
values.push(v);}}}// last value should be number of values
ptr.push(values.length);// create SparseMatrix
return new SparseMatrix({values:values,index:index,ptr:ptr,size:[rows,columns]});};/**
	   * Swap rows i and j in Matrix.
	   *
	   * @memberof SparseMatrix
	   * @param {number} i       Matrix row index 1
	   * @param {number} j       Matrix row index 2
	   *
	   * @return {Matrix}        The matrix reference
	   */SparseMatrix.prototype.swapRows=function(i,j){// check index
if(!isNumber(i)||!isInteger(i)||!isNumber(j)||!isInteger(j)){throw new Error('Row index must be positive integers');}// check dimensions
if(this._size.length!==2){throw new Error('Only two dimensional matrix is supported');}// validate index
validateIndex(i,this._size[0]);validateIndex(j,this._size[0]);// swap rows
SparseMatrix._swapRows(i,j,this._size[1],this._values,this._index,this._ptr);// return current instance
return this;};/**
	   * Loop rows with data in column j.
	   *
	   * @param {number} j            Column
	   * @param {Array} values        Matrix values
	   * @param {Array} index         Matrix row indeces
	   * @param {Array} ptr           Matrix column pointers
	   * @param {Function} callback   Callback function invoked for every row in column j
	   */SparseMatrix._forEachRow=function(j,values,index,ptr,callback){// indeces for column j
var k0=ptr[j];var k1=ptr[j+1];// loop
for(var k=k0;k<k1;k++){// invoke callback
callback(index[k],values[k]);}};/**
	   * Swap rows x and y in Sparse Matrix data structures.
	   *
	   * @param {number} x         Matrix row index 1
	   * @param {number} y         Matrix row index 2
	   * @param {number} columns   Number of columns in matrix
	   * @param {Array} values     Matrix values
	   * @param {Array} index      Matrix row indeces
	   * @param {Array} ptr        Matrix column pointers
	   */SparseMatrix._swapRows=function(x,y,columns,values,index,ptr){// loop columns
for(var j=0;j<columns;j++){// k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
var k0=ptr[j];var k1=ptr[j+1];// find value index @ x
var kx=_getValueIndex(x,k0,k1,index);// find value index @ x
var ky=_getValueIndex(y,k0,k1,index);// check both rows exist in matrix
if(kx<k1&&ky<k1&&index[kx]===x&&index[ky]===y){// swap values (check for pattern matrix)
if(values){var v=values[kx];values[kx]=values[ky];values[ky]=v;}// next column
continue;}// check x row exist & no y row
if(kx<k1&&index[kx]===x&&(ky>=k1||index[ky]!==y)){// value @ x (check for pattern matrix)
var vx=values?values[kx]:undefined;// insert value @ y
index.splice(ky,0,y);if(values)values.splice(ky,0,vx);// remove value @ x (adjust array index if needed)
index.splice(ky<=kx?kx+1:kx,1);if(values)values.splice(ky<=kx?kx+1:kx,1);// next column
continue;}// check y row exist & no x row
if(ky<k1&&index[ky]===y&&(kx>=k1||index[kx]!==x)){// value @ y (check for pattern matrix)
var vy=values?values[ky]:undefined;// insert value @ x
index.splice(kx,0,x);if(values)values.splice(kx,0,vy);// remove value @ y (adjust array index if needed)
index.splice(kx<=ky?ky+1:ky,1);if(values)values.splice(kx<=ky?ky+1:ky,1);}}};// register this type in the base class Matrix
type.Matrix._storage.sparse=SparseMatrix;return SparseMatrix;}exports.name='SparseMatrix';exports.path='type';exports.factory=factory;exports.lazy=false;// no lazy loading, as we alter type.Matrix._storage
/***/},/* 38 *//***/function(module,exports,__webpack_require__){var nearlyEqual=__webpack_require__(18).nearlyEqual;var bigNearlyEqual=__webpack_require__(39);function factory(type,config,load,typed){/**
	   * Test whether two values are equal.
	   *
	   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit} x   First value to compare
	   * @param  {number | BigNumber | Fraction | boolean | Complex} y          Second value to compare
	   * @return {boolean}                                                  Returns true when the compared values are equal, else returns false
	   * @private
	   */var equalScalar=typed('equalScalar',{'boolean, boolean':function booleanBoolean(x,y){return x===y;},'number, number':function numberNumber(x,y){return x===y||nearlyEqual(x,y,config.epsilon);},'BigNumber, BigNumber':function BigNumberBigNumber(x,y){return x.eq(y)||bigNearlyEqual(x,y,config.epsilon);},'Fraction, Fraction':function FractionFraction(x,y){return x.equals(y);},'Complex, Complex':function ComplexComplex(x,y){return x.equals(y);},'Unit, Unit':function UnitUnit(x,y){if(!x.equalBase(y)){throw new Error('Cannot compare units with different base');}return equalScalar(x.value,y.value);},'string, string':function stringString(x,y){return x===y;}});return equalScalar;}exports.factory=factory;/***/},/* 39 *//***/function(module,exports){module.exports=function nearlyEqual(x,y,epsilon){// if epsilon is null or undefined, test whether x and y are exactly equal
if(epsilon==null){return x.eq(y);}// use "==" operator, handles infinities
if(x.eq(y)){return true;}// NaN
if(x.isNaN()||y.isNaN()){return false;}// at this point x and y should be finite
if(x.isFinite()&&y.isFinite()){// check numbers are very close, needed when comparing numbers near zero
var diff=x.minus(y).abs();if(diff.isZero()){return true;}else{// use relative error
var max=x.constructor.max(x.abs(),y.abs());return diff.lte(max.times(epsilon));}}// Infinite and Number or negative Infinite and positive Infinite cases
return false;};/***/},/* 40 *//***/function(module,exports,__webpack_require__){function factory(type,config,load){var add=load(__webpack_require__(41));var equalScalar=load(__webpack_require__(38));/**
	   * An ordered Sparse Accumulator is a representation for a sparse vector that includes a dense array
	   * of the vector elements and an ordered list of non-zero elements.
	   */function Spa(){if(!(this instanceof Spa))throw new SyntaxError('Constructor must be called with the new operator');// allocate vector, TODO use typed arrays
this._values=[];this._heap=new type.FibonacciHeap();}/**
	   * Attach type information
	   */Spa.prototype.type='Spa';Spa.prototype.isSpa=true;/**
	   * Set the value for index i.
	   *
	   * @param {number} i                       The index
	   * @param {number | BigNumber | Complex}   The value at index i
	   */Spa.prototype.set=function(i,v){// check we have a value @ i
if(!this._values[i]){// insert in heap
var node=this._heap.insert(i,v);// set the value @ i
this._values[i]=node;}else{// update the value @ i
this._values[i].value=v;}};Spa.prototype.get=function(i){var node=this._values[i];if(node)return node.value;return 0;};Spa.prototype.accumulate=function(i,v){// node @ i
var node=this._values[i];if(!node){// insert in heap
node=this._heap.insert(i,v);// initialize value
this._values[i]=node;}else{// accumulate value
node.value=add(node.value,v);}};Spa.prototype.forEach=function(from,to,callback){// references
var heap=this._heap;var values=this._values;// nodes
var nodes=[];// node with minimum key, save it
var node=heap.extractMinimum();if(node)nodes.push(node);// extract nodes from heap (ordered)
while(node&&node.key<=to){// check it is in range
if(node.key>=from){// check value is not zero
if(!equalScalar(node.value,0)){// invoke callback
callback(node.key,node.value,this);}}// extract next node, save it
node=heap.extractMinimum();if(node)nodes.push(node);}// reinsert all nodes in heap
for(var i=0;i<nodes.length;i++){// current node
var n=nodes[i];// insert node in heap
node=heap.insert(n.key,n.value);// update values
values[node.key]=node;}};Spa.prototype.swap=function(i,j){// node @ i and j
var nodei=this._values[i];var nodej=this._values[j];// check we need to insert indeces
if(!nodei&&nodej){// insert in heap
nodei=this._heap.insert(i,nodej.value);// remove from heap
this._heap.remove(nodej);// set values
this._values[i]=nodei;this._values[j]=undefined;}else if(nodei&&!nodej){// insert in heap
nodej=this._heap.insert(j,nodei.value);// remove from heap
this._heap.remove(nodei);// set values
this._values[j]=nodej;this._values[i]=undefined;}else if(nodei&&nodej){// swap values
var v=nodei.value;nodei.value=nodej.value;nodej.value=v;}};return Spa;}exports.name='Spa';exports.path='type';exports.factory=factory;/***/},/* 41 *//***/function(module,exports,__webpack_require__){var extend=__webpack_require__(15).extend;function factory(type,config,load,typed){var matrix=load(__webpack_require__(42));var addScalar=load(__webpack_require__(43));var latex=__webpack_require__(44);var algorithm01=load(__webpack_require__(45));var algorithm04=load(__webpack_require__(46));var algorithm10=load(__webpack_require__(47));var algorithm13=load(__webpack_require__(48));var algorithm14=load(__webpack_require__(49));/**
	   * Add two or more values, `x + y`.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.add(x, y)
	   *    math.add(x, y, z, ...)
	   *
	   * Examples:
	   *
	   *    math.add(2, 3);               // returns number 5
	   *    math.add(2, 3, 4);            // returns number 9
	   *
	   *    var a = math.complex(2, 3);
	   *    var b = math.complex(-4, 1);
	   *    math.add(a, b);               // returns Complex -2 + 4i
	   *
	   *    math.add([1, 2, 3], 4);       // returns Array [5, 6, 7]
	   *
	   *    var c = math.unit('5 cm');
	   *    var d = math.unit('2.1 mm');
	   *    math.add(c, d);               // returns Unit 52.1 mm
	   *
	   *    math.add("2.3", "4");         // returns number 6.3
	   *
	   * See also:
	   *
	   *    subtract, sum
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to add
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to add
	   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Sum of `x` and `y`
	   */var add=typed('add',extend({// we extend the signatures of addScalar with signatures dealing with matrices
'Matrix, Matrix':function MatrixMatrix(x,y){// result
var c;// process matrix storage
switch(x.storage()){case'sparse':switch(y.storage()){case'sparse':// sparse + sparse
c=algorithm04(x,y,addScalar);break;default:// sparse + dense
c=algorithm01(y,x,addScalar,true);break;}break;default:switch(y.storage()){case'sparse':// dense + sparse
c=algorithm01(x,y,addScalar,false);break;default:// dense + dense
c=algorithm13(x,y,addScalar);break;}break;}return c;},'Array, Array':function ArrayArray(x,y){// use matrix implementation
return add(matrix(x),matrix(y)).valueOf();},'Array, Matrix':function ArrayMatrix(x,y){// use matrix implementation
return add(matrix(x),y);},'Matrix, Array':function MatrixArray(x,y){// use matrix implementation
return add(x,matrix(y));},'Matrix, any':function MatrixAny(x,y){// result
var c;// check storage format
switch(x.storage()){case'sparse':c=algorithm10(x,y,addScalar,false);break;default:c=algorithm14(x,y,addScalar,false);break;}return c;},'any, Matrix':function anyMatrix(x,y){// result
var c;// check storage format
switch(y.storage()){case'sparse':c=algorithm10(y,x,addScalar,true);break;default:c=algorithm14(y,x,addScalar,true);break;}return c;},'Array, any':function ArrayAny(x,y){// use matrix implementation
return algorithm14(matrix(x),y,addScalar,false).valueOf();},'any, Array':function anyArray(x,y){// use matrix implementation
return algorithm14(matrix(y),x,addScalar,true).valueOf();},'any, any':addScalar,'any, any, ...any':function anyAnyAny(x,y,rest){var result=add(x,y);for(var i=0;i<rest.length;i++){result=add(result,rest[i]);}return result;}},addScalar.signatures));add.toTex={2:'\\left(${args[0]}'+latex.operators['add']+'${args[1]}\\right)'};return add;}exports.name='add';exports.factory=factory;/***/},/* 42 *//***/function(module,exports){function factory(type,config,load,typed){/**
	   * Create a Matrix. The function creates a new `math.type.Matrix` object from
	   * an `Array`. A Matrix has utility functions to manipulate the data in the
	   * matrix, like getting the size and getting or setting values in the matrix.
	   * Supported storage formats are 'dense' and 'sparse'.
	   *
	   * Syntax:
	   *
	   *    math.matrix()                         // creates an empty matrix using default storage format (dense).
	   *    math.matrix(data)                     // creates a matrix with initial data using default storage format (dense).
	   *    math.matrix('dense')                  // creates an empty matrix using the given storage format.
	   *    math.matrix(data, 'dense')            // creates a matrix with initial data using the given storage format.
	   *    math.matrix(data, 'sparse')           // creates a sparse matrix with initial data.
	   *    math.matrix(data, 'sparse', 'number') // creates a sparse matrix with initial data, number data type.
	   *
	   * Examples:
	   *
	   *    var m = math.matrix([[1, 2], [3, 4]]);
	   *    m.size();                        // Array [2, 2]
	   *    m.resize([3, 2], 5);
	   *    m.valueOf();                     // Array [[1, 2], [3, 4], [5, 5]]
	   *    m.get([1, 0])                    // number 3
	   *
	   * See also:
	   *
	   *    bignumber, boolean, complex, index, number, string, unit, sparse
	   *
	   * @param {Array | Matrix} [data]    A multi dimensional array
	   * @param {string} [format]          The Matrix storage format
	   *
	   * @return {Matrix} The created matrix
	   */var matrix=typed('matrix',{'':function _(){return _create([]);},'string':function string(format){return _create([],format);},'string, string':function stringString(format,datatype){return _create([],format,datatype);},'Array':function Array(data){return _create(data);},'Matrix':function Matrix(data){return _create(data,data.storage());},'Array | Matrix, string':_create,'Array | Matrix, string, string':_create});matrix.toTex={0:'\\begin{bmatrix}\\end{bmatrix}',1:'\\left(${args[0]}\\right)',2:'\\left(${args[0]}\\right)'};return matrix;/**
	   * Create a new Matrix with given storage format
	   * @param {Array} data
	   * @param {string} [format]
	   * @param {string} [datatype]
	   * @returns {Matrix} Returns a new Matrix
	   * @private
	   */function _create(data,format,datatype){// get storage format constructor
var M=type.Matrix.storage(format||'default');// create instance
return new M(data,datatype);}}exports.name='matrix';exports.factory=factory;/***/},/* 43 *//***/function(module,exports){function factory(type,config,load,typed){/**
	   * Add two scalar values, `x + y`.
	   * This function is meant for internal use: it is used by the public function
	   * `add`
	   *
	   * This function does not support collections (Array or Matrix), and does
	   * not validate the number of of inputs.
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to add
	   * @param  {number | BigNumber | Fraction | Complex} y          Second value to add
	   * @return {number | BigNumber | Fraction | Complex | Unit}                      Sum of `x` and `y`
	   * @private
	   */var add=typed('add',{'number, number':function numberNumber(x,y){return x+y;},'Complex, Complex':function ComplexComplex(x,y){return x.add(y);},'BigNumber, BigNumber':function BigNumberBigNumber(x,y){return x.plus(y);},'Fraction, Fraction':function FractionFraction(x,y){return x.add(y);},'Unit, Unit':function UnitUnit(x,y){if(x.value==null)throw new Error('Parameter x contains a unit with undefined value');if(y.value==null)throw new Error('Parameter y contains a unit with undefined value');if(!x.equalBase(y))throw new Error('Units do not match');var res=x.clone();res.value=add(res.value,y.value);res.fixPrefix=false;return res;}});return add;}exports.factory=factory;/***/},/* 44 *//***/function(module,exports){exports.symbols={// GREEK LETTERS
Alpha:'A',alpha:'\\alpha',Beta:'B',beta:'\\beta',Gamma:'\\Gamma',gamma:'\\gamma',Delta:'\\Delta',delta:'\\delta',Epsilon:'E',epsilon:'\\epsilon',varepsilon:'\\varepsilon',Zeta:'Z',zeta:'\\zeta',Eta:'H',eta:'\\eta',Theta:'\\Theta',theta:'\\theta',vartheta:'\\vartheta',Iota:'I',iota:'\\iota',Kappa:'K',kappa:'\\kappa',varkappa:'\\varkappa',Lambda:'\\Lambda',lambda:'\\lambda',Mu:'M',mu:'\\mu',Nu:'N',nu:'\\nu',Xi:'\\Xi',xi:'\\xi',Omicron:'O',omicron:'o',Pi:'\\Pi',pi:'\\pi',varpi:'\\varpi',Rho:'P',rho:'\\rho',varrho:'\\varrho',Sigma:'\\Sigma',sigma:'\\sigma',varsigma:'\\varsigma',Tau:'T',tau:'\\tau',Upsilon:'\\Upsilon',upsilon:'\\upsilon',Phi:'\\Phi',phi:'\\phi',varphi:'\\varphi',Chi:'X',chi:'\\chi',Psi:'\\Psi',psi:'\\psi',Omega:'\\Omega',omega:'\\omega',//logic
'true':'\\mathrm{True}','false':'\\mathrm{False}',//other
i:'i',//TODO use \i ??
inf:'\\infty',Inf:'\\infty',infinity:'\\infty',Infinity:'\\infty',oo:'\\infty',lim:'\\lim','undefined':'\\mathbf{?}'};exports.operators={'transpose':'^\\top','factorial':'!','pow':'^','dotPow':'.^\\wedge',//TODO find ideal solution
'unaryPlus':'+','unaryMinus':'-','bitNot':'~',//TODO find ideal solution
'not':'\\neg','multiply':'\\cdot','divide':'\\frac',//TODO how to handle that properly?
'dotMultiply':'.\\cdot',//TODO find ideal solution
'dotDivide':'.:',//TODO find ideal solution
'mod':'\\mod','add':'+','subtract':'-','to':'\\rightarrow','leftShift':'<<','rightArithShift':'>>','rightLogShift':'>>>','equal':'=','unequal':'\\neq','smaller':'<','larger':'>','smallerEq':'\\leq','largerEq':'\\geq','bitAnd':'\\&','bitXor':'\\underline{|}','bitOr':'|','and':'\\wedge','xor':'\\veebar','or':'\\vee'};exports.defaultTemplate='\\mathrm{${name}}\\left(${args}\\right)';var units={deg:'^\\circ'};//@param {string} name
//@param {boolean} isUnit
exports.toSymbol=function(name,isUnit){isUnit=typeof isUnit==='undefined'?false:isUnit;if(isUnit){if(units.hasOwnProperty(name)){return units[name];}return'\\mathrm{'+name+'}';}if(exports.symbols.hasOwnProperty(name)){return exports.symbols[name];}else if(name.indexOf('_')!==-1){//symbol with index (eg. alpha_1)
var index=name.indexOf('_');return exports.toSymbol(name.substring(0,index))+'_{'+exports.toSymbol(name.substring(index+1))+'}';}return name;};/***/},/* 45 *//***/function(module,exports,__webpack_require__){var DimensionError=__webpack_require__(31);function factory(type,config,load,typed){var DenseMatrix=type.DenseMatrix;/**
	   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
	   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
	   *
	   *
	   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
	   * C(i,j) = ┤
	   *          └  Dij          ; otherwise
	   *
	   *
	   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
	   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
	   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
	   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
	   *
	   * @return {Matrix}                    DenseMatrix (C)
	   *
	   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
	   */var algorithm01=function algorithm01(denseMatrix,sparseMatrix,callback,inverse){// dense matrix arrays
var adata=denseMatrix._data;var asize=denseMatrix._size;var adt=denseMatrix._datatype;// sparse matrix arrays
var bvalues=sparseMatrix._values;var bindex=sparseMatrix._index;var bptr=sparseMatrix._ptr;var bsize=sparseMatrix._size;var bdt=sparseMatrix._datatype;// validate dimensions
if(asize.length!==bsize.length)throw new DimensionError(asize.length,bsize.length);// check rows & columns
if(asize[0]!==bsize[0]||asize[1]!==bsize[1])throw new RangeError('Dimension mismatch. Matrix A ('+asize+') must match Matrix B ('+bsize+')');// sparse matrix cannot be a Pattern matrix
if(!bvalues)throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');// rows & columns
var rows=asize[0];var columns=asize[1];// process data types
var dt=typeof adt==='string'&&adt===bdt?adt:undefined;// callback function
var cf=dt?typed.find(callback,[dt,dt]):callback;// vars
var i,j;// result (DenseMatrix)
var cdata=[];// initialize c
for(i=0;i<rows;i++){cdata[i]=[];}// workspace
var x=[];// marks indicating we have a value in x for a given column
var w=[];// loop columns in b
for(j=0;j<columns;j++){// column mark
var mark=j+1;// values in column j
for(var k0=bptr[j],k1=bptr[j+1],k=k0;k<k1;k++){// row
i=bindex[k];// update workspace
x[i]=inverse?cf(bvalues[k],adata[i][j]):cf(adata[i][j],bvalues[k]);// mark i as updated
w[i]=mark;}// loop rows
for(i=0;i<rows;i++){// check row is in workspace
if(w[i]===mark){// c[i][j] was already calculated
cdata[i][j]=x[i];}else{// item does not exist in S
cdata[i][j]=adata[i][j];}}}// return dense matrix
return new DenseMatrix({data:cdata,size:[rows,columns],datatype:dt});};return algorithm01;}exports.name='algorithm01';exports.factory=factory;/***/},/* 46 *//***/function(module,exports,__webpack_require__){var DimensionError=__webpack_require__(31);function factory(type,config,load,typed){var equalScalar=load(__webpack_require__(38));var SparseMatrix=type.SparseMatrix;/**
	   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
	   * Callback function invoked MAX(NNZA, NNZB) times
	   *
	   *
	   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
	   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
	   *          └  B(i,j)       ; B(i,j) !== 0
	   *
	   *
	   * @param {Matrix}   a                 The SparseMatrix instance (A)
	   * @param {Matrix}   b                 The SparseMatrix instance (B)
	   * @param {Function} callback          The f(Aij,Bij) operation to invoke
	   *
	   * @return {Matrix}                    SparseMatrix (C)
	   *
	   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
	   */var algorithm04=function algorithm04(a,b,callback){// sparse matrix arrays
var avalues=a._values;var aindex=a._index;var aptr=a._ptr;var asize=a._size;var adt=a._datatype;// sparse matrix arrays
var bvalues=b._values;var bindex=b._index;var bptr=b._ptr;var bsize=b._size;var bdt=b._datatype;// validate dimensions
if(asize.length!==bsize.length)throw new DimensionError(asize.length,bsize.length);// check rows & columns
if(asize[0]!==bsize[0]||asize[1]!==bsize[1])throw new RangeError('Dimension mismatch. Matrix A ('+asize+') must match Matrix B ('+bsize+')');// rows & columns
var rows=asize[0];var columns=asize[1];// datatype
var dt;// equal signature to use
var eq=equalScalar;// zero value
var zero=0;// callback signature to use
var cf=callback;// process data types
if(typeof adt==='string'&&adt===bdt){// datatype
dt=adt;// find signature that matches (dt, dt)
eq=typed.find(equalScalar,[dt,dt]);// convert 0 to the same datatype
zero=typed.convert(0,dt);// callback
cf=typed.find(callback,[dt,dt]);}// result arrays
var cvalues=avalues&&bvalues?[]:undefined;var cindex=[];var cptr=[];// matrix
var c=new SparseMatrix({values:cvalues,index:cindex,ptr:cptr,size:[rows,columns],datatype:dt});// workspace
var xa=avalues&&bvalues?[]:undefined;var xb=avalues&&bvalues?[]:undefined;// marks indicating we have a value in x for a given column
var wa=[];var wb=[];// vars
var i,j,k,k0,k1;// loop columns
for(j=0;j<columns;j++){// update cptr
cptr[j]=cindex.length;// columns mark
var mark=j+1;// loop A(:,j)
for(k0=aptr[j], k1=aptr[j+1], k=k0;k<k1;k++){// row
i=aindex[k];// update c
cindex.push(i);// update workspace
wa[i]=mark;// check we need to process values
if(xa)xa[i]=avalues[k];}// loop B(:,j)
for(k0=bptr[j], k1=bptr[j+1], k=k0;k<k1;k++){// row
i=bindex[k];// check row exists in A
if(wa[i]===mark){// update record in xa @ i
if(xa){// invoke callback
var v=cf(xa[i],bvalues[k]);// check for zero
if(!eq(v,zero)){// update workspace
xa[i]=v;}else{// remove mark (index will be removed later)
wa[i]=null;}}}else{// update c
cindex.push(i);// update workspace
wb[i]=mark;// check we need to process values
if(xb)xb[i]=bvalues[k];}}// check we need to process values (non pattern matrix)
if(xa&&xb){// initialize first index in j
k=cptr[j];// loop index in j
while(k<cindex.length){// row
i=cindex[k];// check workspace has value @ i
if(wa[i]===mark){// push value (Aij != 0 || (Aij != 0 && Bij != 0))
cvalues[k]=xa[i];// increment pointer
k++;}else if(wb[i]===mark){// push value (bij != 0)
cvalues[k]=xb[i];// increment pointer
k++;}else{// remove index @ k
cindex.splice(k,1);}}}}// update cptr
cptr[columns]=cindex.length;// return sparse matrix
return c;};return algorithm04;}exports.name='algorithm04';exports.factory=factory;/***/},/* 47 *//***/function(module,exports){function factory(type,config,load,typed){var DenseMatrix=type.DenseMatrix;/**
	   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
	   * Callback function invoked NZ times (number of nonzero items in S).
	   *
	   *
	   *          ┌  f(Sij, b)  ; S(i,j) !== 0
	   * C(i,j) = ┤
	   *          └  b          ; otherwise
	   *
	   *
	   * @param {Matrix}   s                 The SparseMatrix instance (S)
	   * @param {Scalar}   b                 The Scalar value
	   * @param {Function} callback          The f(Aij,b) operation to invoke
	   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
	   *
	   * @return {Matrix}                    DenseMatrix (C)
	   *
	   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
	   */var algorithm10=function algorithm10(s,b,callback,inverse){// sparse matrix arrays
var avalues=s._values;var aindex=s._index;var aptr=s._ptr;var asize=s._size;var adt=s._datatype;// sparse matrix cannot be a Pattern matrix
if(!avalues)throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');// rows & columns
var rows=asize[0];var columns=asize[1];// datatype
var dt;// callback signature to use
var cf=callback;// process data types
if(typeof adt==='string'){// datatype
dt=adt;// convert b to the same datatype
b=typed.convert(b,dt);// callback
cf=typed.find(callback,[dt,dt]);}// result arrays
var cdata=[];// matrix
var c=new DenseMatrix({data:cdata,size:[rows,columns],datatype:dt});// workspaces
var x=[];// marks indicating we have a value in x for a given column
var w=[];// loop columns
for(var j=0;j<columns;j++){// columns mark
var mark=j+1;// values in j
for(var k0=aptr[j],k1=aptr[j+1],k=k0;k<k1;k++){// row
var r=aindex[k];// update workspace
x[r]=avalues[k];w[r]=mark;}// loop rows
for(var i=0;i<rows;i++){// initialize C on first column
if(j===0){// create row array
cdata[i]=[];}// check sparse matrix has a value @ i,j
if(w[i]===mark){// invoke callback, update C
cdata[i][j]=inverse?cf(b,x[i]):cf(x[i],b);}else{// dense matrix value @ i, j
cdata[i][j]=b;}}}// return sparse matrix
return c;};return algorithm10;}exports.name='algorithm10';exports.factory=factory;/***/},/* 48 *//***/function(module,exports,__webpack_require__){var util=__webpack_require__(26);var DimensionError=__webpack_require__(31);var string=util.string,isString=string.isString;function factory(type,config,load,typed){var DenseMatrix=type.DenseMatrix;/**
	   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, Bij..z).
	   * Callback function invoked MxN times.
	   *
	   * C(i,j,...z) = f(Aij..z, Bij..z)
	   *
	   * @param {Matrix}   a                 The DenseMatrix instance (A)
	   * @param {Matrix}   b                 The DenseMatrix instance (B)
	   * @param {Function} callback          The f(Aij..z,Bij..z) operation to invoke
	   *
	   * @return {Matrix}                    DenseMatrix (C)
	   *
	   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97658658
	   */var algorithm13=function algorithm13(a,b,callback){// a arrays
var adata=a._data;var asize=a._size;var adt=a._datatype;// b arrays
var bdata=b._data;var bsize=b._size;var bdt=b._datatype;// c arrays
var csize=[];// validate dimensions
if(asize.length!==bsize.length)throw new DimensionError(asize.length,bsize.length);// validate each one of the dimension sizes
for(var s=0;s<asize.length;s++){// must match
if(asize[s]!==bsize[s])throw new RangeError('Dimension mismatch. Matrix A ('+asize+') must match Matrix B ('+bsize+')');// update dimension in c
csize[s]=asize[s];}// datatype
var dt;// callback signature to use
var cf=callback;// process data types
if(typeof adt==='string'&&adt===bdt){// datatype
dt=adt;// convert b to the same datatype
b=typed.convert(b,dt);// callback
cf=typed.find(callback,[dt,dt]);}// populate cdata, iterate through dimensions
var cdata=csize.length>0?_iterate(cf,0,csize,csize[0],adata,bdata):[];// c matrix
return new DenseMatrix({data:cdata,size:csize,datatype:dt});};// recursive function
var _iterate=function _iterate(f,level,s,n,av,bv){// initialize array for this level
var cv=[];// check we reach the last level
if(level===s.length-1){// loop arrays in last level
for(var i=0;i<n;i++){// invoke callback and store value
cv[i]=f(av[i],bv[i]);}}else{// iterate current level
for(var j=0;j<n;j++){// iterate next level
cv[j]=_iterate(f,level+1,s,s[level+1],av[j],bv[j]);}}return cv;};return algorithm13;}exports.name='algorithm13';exports.factory=factory;/***/},/* 49 *//***/function(module,exports,__webpack_require__){var clone=__webpack_require__(15).clone;function factory(type,config,load,typed){var DenseMatrix=type.DenseMatrix;/**
	   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, b).
	   * Callback function invoked MxN times.
	   *
	   * C(i,j,...z) = f(Aij..z, b)
	   *
	   * @param {Matrix}   a                 The DenseMatrix instance (A)
	   * @param {Scalar}   b                 The Scalar value
	   * @param {Function} callback          The f(Aij..z,b) operation to invoke
	   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Aij..z)
	   *
	   * @return {Matrix}                    DenseMatrix (C)
	   *
	   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97659042
	   */var algorithm14=function algorithm14(a,b,callback,inverse){// a arrays
var adata=a._data;var asize=a._size;var adt=a._datatype;// datatype
var dt;// callback signature to use
var cf=callback;// process data types
if(typeof adt==='string'){// datatype
dt=adt;// convert b to the same datatype
b=typed.convert(b,dt);// callback
cf=typed.find(callback,[dt,dt]);}// populate cdata, iterate through dimensions
var cdata=asize.length>0?_iterate(cf,0,asize,asize[0],adata,b,inverse):[];// c matrix
return new DenseMatrix({data:cdata,size:clone(asize),datatype:dt});};// recursive function
var _iterate=function _iterate(f,level,s,n,av,bv,inverse){// initialize array for this level
var cv=[];// check we reach the last level
if(level===s.length-1){// loop arrays in last level
for(var i=0;i<n;i++){// invoke callback and store value
cv[i]=inverse?f(bv,av[i]):f(av[i],bv);}}else{// iterate current level
for(var j=0;j<n;j++){// iterate next level
cv[j]=_iterate(f,level+1,s,s[level+1],av[j],bv,inverse);}}return cv;};return algorithm14;}exports.name='algorithm14';exports.factory=factory;/***/},/* 50 *//***/function(module,exports,__webpack_require__){function factory(type,config,load,typed){var smaller=load(__webpack_require__(51));var larger=load(__webpack_require__(55));var oneOverLogPhi=1.0/Math.log((1.0+Math.sqrt(5.0))/2.0);/**
	   * Fibonacci Heap implementation, used interally for Matrix math.
	   * @class FibonacciHeap
	   * @constructor FibonacciHeap
	   */function FibonacciHeap(){if(!(this instanceof FibonacciHeap))throw new SyntaxError('Constructor must be called with the new operator');// initialize fields
this._minimum=null;this._size=0;}/**
	   * Attach type information
	   */FibonacciHeap.prototype.type='FibonacciHeap';FibonacciHeap.prototype.isFibonacciHeap=true;/**
	   * Inserts a new data element into the heap. No heap consolidation is
	   * performed at this time, the new node is simply inserted into the root
	   * list of this heap. Running time: O(1) actual.
	   * @memberof FibonacciHeap
	   */FibonacciHeap.prototype.insert=function(key,value){// create node
var node={key:key,value:value,degree:0};// check we have a node in the minimum
if(this._minimum){// minimum node
var minimum=this._minimum;// update left & right of node
node.left=minimum;node.right=minimum.right;minimum.right=node;node.right.left=node;// update minimum node in heap if needed
if(smaller(key,minimum.key)){// node has a smaller key, use it as minimum
this._minimum=node;}}else{// set left & right
node.left=node;node.right=node;// this is the first node
this._minimum=node;}// increment number of nodes in heap
this._size++;// return node
return node;};/**
	   * Returns the number of nodes in heap. Running time: O(1) actual.
	   * @memberof FibonacciHeap
	   */FibonacciHeap.prototype.size=function(){return this._size;};/**
	   * Removes all elements from this heap.
	   * @memberof FibonacciHeap
	   */FibonacciHeap.prototype.clear=function(){this._minimum=null;this._size=0;};/**
	   * Returns true if the heap is empty, otherwise false.
	   * @memberof FibonacciHeap
	   */FibonacciHeap.prototype.isEmpty=function(){return!!this._minimum;};/**
	   * Extracts the node with minimum key from heap. Amortized running
	   * time: O(log n).
	   * @memberof FibonacciHeap
	   */FibonacciHeap.prototype.extractMinimum=function(){// node to remove
var node=this._minimum;// check we have a minimum
if(node===null)return node;// current minimum
var minimum=this._minimum;// get number of children
var numberOfChildren=node.degree;// pointer to the first child
var x=node.child;// for each child of node do...
while(numberOfChildren>0){// store node in right side
var tempRight=x.right;// remove x from child list
x.left.right=x.right;x.right.left=x.left;// add x to root list of heap
x.left=minimum;x.right=minimum.right;minimum.right=x;x.right.left=x;// set Parent[x] to null
x.parent=null;x=tempRight;numberOfChildren--;}// remove node from root list of heap
node.left.right=node.right;node.right.left=node.left;// update minimum
if(node==node.right){// empty
minimum=null;}else{// update minimum
minimum=node.right;// we need to update the pointer to the root with minimum key
minimum=_findMinimumNode(minimum,this._size);}// decrement size of heap
this._size--;// update minimum
this._minimum=minimum;// return node
return node;};/**
	   * Removes a node from the heap given the reference to the node. The trees
	   * in the heap will be consolidated, if necessary. This operation may fail
	   * to remove the correct element if there are nodes with key value -Infinity.
	   * Running time: O(log n) amortized.
	   * @memberof FibonacciHeap
	   */FibonacciHeap.prototype.remove=function(node){// decrease key value
this._minimum=_decreaseKey(this._minimum,node,-1);// remove the smallest
this.extractMinimum();};/**
	   * Decreases the key value for a heap node, given the new value to take on.
	   * The structure of the heap may be changed and will not be consolidated.
	   * Running time: O(1) amortized.
	   * @memberof FibonacciHeap
	   */var _decreaseKey=function _decreaseKey(minimum,node,key){// set node key
node.key=key;// get parent node
var parent=node.parent;if(parent&&smaller(node.key,parent.key)){// remove node from parent
_cut(minimum,node,parent);// remove all nodes from parent to the root parent
_cascadingCut(minimum,parent);}// update minimum node if needed
if(smaller(node.key,minimum.key))minimum=node;// return minimum
return minimum;};/**
	   * The reverse of the link operation: removes node from the child list of parent.
	   * This method assumes that min is non-null. Running time: O(1).
	   * @memberof FibonacciHeap
	   */var _cut=function _cut(minimum,node,parent){// remove node from parent children and decrement Degree[parent]
node.left.right=node.right;node.right.left=node.left;parent.degree--;// reset y.child if necessary
if(parent.child==node)parent.child=node.right;// remove child if degree is 0
if(parent.degree===0)parent.child=null;// add node to root list of heap
node.left=minimum;node.right=minimum.right;minimum.right=node;node.right.left=node;// set parent[node] to null
node.parent=null;// set mark[node] to false
node.mark=false;};/**
	   * Performs a cascading cut operation. This cuts node from its parent and then
	   * does the same for its parent, and so on up the tree.
	   * Running time: O(log n); O(1) excluding the recursion.
	   * @memberof FibonacciHeap
	   */var _cascadingCut=function _cascadingCut(minimum,node){// store parent node
var parent=node.parent;// if there's a parent...
if(!parent)return;// if node is unmarked, set it marked
if(!node.mark){node.mark=true;}else{// it's marked, cut it from parent
_cut(minimum,node,parent);// cut its parent as well
_cascadingCut(parent);}};/**
	   * Make the first node a child of the second one. Running time: O(1) actual.
	   * @memberof FibonacciHeap
	   */var _linkNodes=function _linkNodes(node,parent){// remove node from root list of heap
node.left.right=node.right;node.right.left=node.left;// make node a Child of parent
node.parent=parent;if(!parent.child){parent.child=node;node.right=node;node.left=node;}else{node.left=parent.child;node.right=parent.child.right;parent.child.right=node;node.right.left=node;}// increase degree[parent]
parent.degree++;// set mark[node] false
node.mark=false;};var _findMinimumNode=function _findMinimumNode(minimum,size){// to find trees of the same degree efficiently we use an array of length O(log n) in which we keep a pointer to one root of each degree
var arraySize=Math.floor(Math.log(size)*oneOverLogPhi)+1;// create list with initial capacity
var array=new Array(arraySize);// find the number of root nodes.
var numRoots=0;var x=minimum;if(x){numRoots++;x=x.right;while(x!==minimum){numRoots++;x=x.right;}}// vars
var y;// For each node in root list do...
while(numRoots>0){// access this node's degree..
var d=x.degree;// get next node
var next=x.right;// check if there is a node already in array with the same degree
while(true){// get node with the same degree is any
y=array[d];if(!y)break;// make one node with the same degree a child of the other, do this based on the key value.
if(larger(x.key,y.key)){var temp=y;y=x;x=temp;}// make y a child of x
_linkNodes(y,x);// we have handled this degree, go to next one.
array[d]=null;d++;}// save this node for later when we might encounter another of the same degree.
array[d]=x;// move forward through list.
x=next;numRoots--;}// Set min to null (effectively losing the root list) and reconstruct the root list from the array entries in array[].
minimum=null;// loop nodes in array
for(var i=0;i<arraySize;i++){// get current node
y=array[i];if(!y)continue;// check if we have a linked list
if(minimum){// First remove node from root list.
y.left.right=y.right;y.right.left=y.left;// now add to root list, again.
y.left=minimum;y.right=minimum.right;minimum.right=y;y.right.left=y;// check if this is a new min.
if(smaller(y.key,minimum.key))minimum=y;}else minimum=y;}return minimum;};return FibonacciHeap;}exports.name='FibonacciHeap';exports.path='type';exports.factory=factory;/***/},/* 51 *//***/function(module,exports,__webpack_require__){var nearlyEqual=__webpack_require__(18).nearlyEqual;var bigNearlyEqual=__webpack_require__(39);function factory(type,config,load,typed){var matrix=load(__webpack_require__(42));var algorithm03=load(__webpack_require__(52));var algorithm07=load(__webpack_require__(53));var algorithm12=load(__webpack_require__(54));var algorithm13=load(__webpack_require__(48));var algorithm14=load(__webpack_require__(49));var latex=__webpack_require__(44);/**
	   * Test whether value x is smaller than y.
	   *
	   * The function returns true when x is smaller than y and the relative
	   * difference between x and y is smaller than the configured epsilon. The
	   * function cannot be used to compare values smaller than approximately 2.22e-16.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.smaller(x, y)
	   *
	   * Examples:
	   *
	   *    math.smaller(2, 3);            // returns true
	   *    math.smaller(5, 2 * 2);        // returns false
	   *
	   *    var a = math.unit('5 cm');
	   *    var b = math.unit('2 inch');
	   *    math.smaller(a, b);            // returns true
	   *
	   * See also:
	   *
	   *    equal, unequal, smallerEq, smaller, smallerEq, compare
	   *
	   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
	   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
	   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
	   */var smaller=typed('smaller',{'boolean, boolean':function booleanBoolean(x,y){return x<y;},'number, number':function numberNumber(x,y){return x<y&&!nearlyEqual(x,y,config.epsilon);},'BigNumber, BigNumber':function BigNumberBigNumber(x,y){return x.lt(y)&&!bigNearlyEqual(x,y,config.epsilon);},'Fraction, Fraction':function FractionFraction(x,y){return x.compare(y)===-1;},'Complex, Complex':function ComplexComplex(x,y){throw new TypeError('No ordering relation is defined for complex numbers');},'Unit, Unit':function UnitUnit(x,y){if(!x.equalBase(y)){throw new Error('Cannot compare units with different base');}return smaller(x.value,y.value);},'string, string':function stringString(x,y){return x<y;},'Matrix, Matrix':function MatrixMatrix(x,y){// result
var c;// process matrix storage
switch(x.storage()){case'sparse':switch(y.storage()){case'sparse':// sparse + sparse
c=algorithm07(x,y,smaller);break;default:// sparse + dense
c=algorithm03(y,x,smaller,true);break;}break;default:switch(y.storage()){case'sparse':// dense + sparse
c=algorithm03(x,y,smaller,false);break;default:// dense + dense
c=algorithm13(x,y,smaller);break;}break;}return c;},'Array, Array':function ArrayArray(x,y){// use matrix implementation
return smaller(matrix(x),matrix(y)).valueOf();},'Array, Matrix':function ArrayMatrix(x,y){// use matrix implementation
return smaller(matrix(x),y);},'Matrix, Array':function MatrixArray(x,y){// use matrix implementation
return smaller(x,matrix(y));},'Matrix, any':function MatrixAny(x,y){// result
var c;// check storage format
switch(x.storage()){case'sparse':c=algorithm12(x,y,smaller,false);break;default:c=algorithm14(x,y,smaller,false);break;}return c;},'any, Matrix':function anyMatrix(x,y){// result
var c;// check storage format
switch(y.storage()){case'sparse':c=algorithm12(y,x,smaller,true);break;default:c=algorithm14(y,x,smaller,true);break;}return c;},'Array, any':function ArrayAny(x,y){// use matrix implementation
return algorithm14(matrix(x),y,smaller,false).valueOf();},'any, Array':function anyArray(x,y){// use matrix implementation
return algorithm14(matrix(y),x,smaller,true).valueOf();}});smaller.toTex={2:'\\left(${args[0]}'+latex.operators['smaller']+'${args[1]}\\right)'};return smaller;}exports.name='smaller';exports.factory=factory;/***/},/* 52 *//***/function(module,exports,__webpack_require__){var DimensionError=__webpack_require__(31);function factory(type,config,load,typed){var DenseMatrix=type.DenseMatrix;/**
	   * Iterates over SparseMatrix items and invokes the callback function f(Dij, Sij).
	   * Callback function invoked M*N times.
	   *
	   *
	   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
	   * C(i,j) = ┤
	   *          └  f(Dij, 0)    ; otherwise
	   *
	   *
	   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
	   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (C)
	   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
	   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
	   *
	   * @return {Matrix}                    DenseMatrix (C)
	   *
	   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
	   */var algorithm03=function algorithm03(denseMatrix,sparseMatrix,callback,inverse){// dense matrix arrays
var adata=denseMatrix._data;var asize=denseMatrix._size;var adt=denseMatrix._datatype;// sparse matrix arrays
var bvalues=sparseMatrix._values;var bindex=sparseMatrix._index;var bptr=sparseMatrix._ptr;var bsize=sparseMatrix._size;var bdt=sparseMatrix._datatype;// validate dimensions
if(asize.length!==bsize.length)throw new DimensionError(asize.length,bsize.length);// check rows & columns
if(asize[0]!==bsize[0]||asize[1]!==bsize[1])throw new RangeError('Dimension mismatch. Matrix A ('+asize+') must match Matrix B ('+bsize+')');// sparse matrix cannot be a Pattern matrix
if(!bvalues)throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');// rows & columns
var rows=asize[0];var columns=asize[1];// datatype
var dt;// zero value
var zero=0;// callback signature to use
var cf=callback;// process data types
if(typeof adt==='string'&&adt===bdt){// datatype
dt=adt;// convert 0 to the same datatype
zero=typed.convert(0,dt);// callback
cf=typed.find(callback,[dt,dt]);}// result (DenseMatrix)
var cdata=[];// initialize dense matrix
for(var z=0;z<rows;z++){// initialize row
cdata[z]=[];}// workspace
var x=[];// marks indicating we have a value in x for a given column
var w=[];// loop columns in b
for(var j=0;j<columns;j++){// column mark
var mark=j+1;// values in column j
for(var k0=bptr[j],k1=bptr[j+1],k=k0;k<k1;k++){// row
var i=bindex[k];// update workspace
x[i]=inverse?cf(bvalues[k],adata[i][j]):cf(adata[i][j],bvalues[k]);w[i]=mark;}// process workspace
for(var y=0;y<rows;y++){// check we have a calculated value for current row
if(w[y]===mark){// use calculated value
cdata[y][j]=x[y];}else{// calculate value
cdata[y][j]=inverse?cf(zero,adata[y][j]):cf(adata[y][j],zero);}}}// return dense matrix
return new DenseMatrix({data:cdata,size:[rows,columns],datatype:dt});};return algorithm03;}exports.name='algorithm03';exports.factory=factory;/***/},/* 53 *//***/function(module,exports,__webpack_require__){var DimensionError=__webpack_require__(31);function factory(type,config,load,typed){var DenseMatrix=type.DenseMatrix;/**
	   * Iterates over SparseMatrix A and SparseMatrix B items (zero and nonzero) and invokes the callback function f(Aij, Bij).
	   * Callback function invoked MxN times.
	   *
	   * C(i,j) = f(Aij, Bij)
	   *
	   * @param {Matrix}   a                 The SparseMatrix instance (A)
	   * @param {Matrix}   b                 The SparseMatrix instance (B)
	   * @param {Function} callback          The f(Aij,Bij) operation to invoke
	   *
	   * @return {Matrix}                    DenseMatrix (C)
	   *
	   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
	   */var algorithm07=function algorithm07(a,b,callback){// sparse matrix arrays
var asize=a._size;var adt=a._datatype;// sparse matrix arrays
var bsize=b._size;var bdt=b._datatype;// validate dimensions
if(asize.length!==bsize.length)throw new DimensionError(asize.length,bsize.length);// check rows & columns
if(asize[0]!==bsize[0]||asize[1]!==bsize[1])throw new RangeError('Dimension mismatch. Matrix A ('+asize+') must match Matrix B ('+bsize+')');// rows & columns
var rows=asize[0];var columns=asize[1];// datatype
var dt;// zero value
var zero=0;// callback signature to use
var cf=callback;// process data types
if(typeof adt==='string'&&adt===bdt){// datatype
dt=adt;// convert 0 to the same datatype
zero=typed.convert(0,dt);// callback
cf=typed.find(callback,[dt,dt]);}// vars
var i,j;// result arrays
var cdata=[];// initialize c
for(i=0;i<rows;i++){cdata[i]=[];}// matrix
var c=new DenseMatrix({data:cdata,size:[rows,columns],datatype:dt});// workspaces
var xa=[];var xb=[];// marks indicating we have a value in x for a given column
var wa=[];var wb=[];// loop columns
for(j=0;j<columns;j++){// columns mark
var mark=j+1;// scatter the values of A(:,j) into workspace
_scatter(a,j,wa,xa,mark);// scatter the values of B(:,j) into workspace
_scatter(b,j,wb,xb,mark);// loop rows
for(i=0;i<rows;i++){// matrix values @ i,j
var va=wa[i]===mark?xa[i]:zero;var vb=wb[i]===mark?xb[i]:zero;// invoke callback
cdata[i][j]=cf(va,vb);}}// return sparse matrix
return c;};var _scatter=function _scatter(m,j,w,x,mark){// a arrays
var values=m._values;var index=m._index;var ptr=m._ptr;// loop values in column j
for(var k=ptr[j],k1=ptr[j+1];k<k1;k++){// row
var i=index[k];// update workspace
w[i]=mark;x[i]=values[k];}};return algorithm07;}exports.name='algorithm07';exports.factory=factory;/***/},/* 54 *//***/function(module,exports){function factory(type,config,load,typed){var DenseMatrix=type.DenseMatrix;/**
	   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
	   * Callback function invoked MxN times.
	   *
	   *
	   *          ┌  f(Sij, b)  ; S(i,j) !== 0
	   * C(i,j) = ┤
	   *          └  f(0, b)    ; otherwise
	   *
	   *
	   * @param {Matrix}   s                 The SparseMatrix instance (S)
	   * @param {Scalar}   b                 The Scalar value
	   * @param {Function} callback          The f(Aij,b) operation to invoke
	   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
	   *
	   * @return {Matrix}                    DenseMatrix (C)
	   *
	   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
	   */var algorithm12=function algorithm12(s,b,callback,inverse){// sparse matrix arrays
var avalues=s._values;var aindex=s._index;var aptr=s._ptr;var asize=s._size;var adt=s._datatype;// sparse matrix cannot be a Pattern matrix
if(!avalues)throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');// rows & columns
var rows=asize[0];var columns=asize[1];// datatype
var dt;// callback signature to use
var cf=callback;// process data types
if(typeof adt==='string'){// datatype
dt=adt;// convert b to the same datatype
b=typed.convert(b,dt);// callback
cf=typed.find(callback,[dt,dt]);}// result arrays
var cdata=[];// matrix
var c=new DenseMatrix({data:cdata,size:[rows,columns],datatype:dt});// workspaces
var x=[];// marks indicating we have a value in x for a given column
var w=[];// loop columns
for(var j=0;j<columns;j++){// columns mark
var mark=j+1;// values in j
for(var k0=aptr[j],k1=aptr[j+1],k=k0;k<k1;k++){// row
var r=aindex[k];// update workspace
x[r]=avalues[k];w[r]=mark;}// loop rows
for(var i=0;i<rows;i++){// initialize C on first column
if(j===0){// create row array
cdata[i]=[];}// check sparse matrix has a value @ i,j
if(w[i]===mark){// invoke callback, update C
cdata[i][j]=inverse?cf(b,x[i]):cf(x[i],b);}else{// dense matrix value @ i, j
cdata[i][j]=inverse?cf(b,0):cf(0,b);}}}// return sparse matrix
return c;};return algorithm12;}exports.name='algorithm12';exports.factory=factory;/***/},/* 55 *//***/function(module,exports,__webpack_require__){var nearlyEqual=__webpack_require__(18).nearlyEqual;var bigNearlyEqual=__webpack_require__(39);function factory(type,config,load,typed){var matrix=load(__webpack_require__(42));var algorithm03=load(__webpack_require__(52));var algorithm07=load(__webpack_require__(53));var algorithm12=load(__webpack_require__(54));var algorithm13=load(__webpack_require__(48));var algorithm14=load(__webpack_require__(49));var latex=__webpack_require__(44);/**
	   * Test whether value x is larger than y.
	   *
	   * The function returns true when x is larger than y and the relative
	   * difference between x and y is larger than the configured epsilon. The
	   * function cannot be used to compare values smaller than approximately 2.22e-16.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.larger(x, y)
	   *
	   * Examples:
	   *
	   *    math.larger(2, 3);             // returns false
	   *    math.larger(5, 2 + 2);         // returns true
	   *
	   *    var a = math.unit('5 cm');
	   *    var b = math.unit('2 inch');
	   *    math.larger(a, b);             // returns false
	   *
	   * See also:
	   *
	   *    equal, unequal, smaller, smallerEq, largerEq, compare
	   *
	   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
	   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
	   * @return {boolean | Array | Matrix} Returns true when the x is larger than y, else returns false
	   */var larger=typed('larger',{'boolean, boolean':function booleanBoolean(x,y){return x>y;},'number, number':function numberNumber(x,y){return x>y&&!nearlyEqual(x,y,config.epsilon);},'BigNumber, BigNumber':function BigNumberBigNumber(x,y){return x.gt(y)&&!bigNearlyEqual(x,y,config.epsilon);},'Fraction, Fraction':function FractionFraction(x,y){return x.compare(y)===1;},'Complex, Complex':function ComplexComplex(){throw new TypeError('No ordering relation is defined for complex numbers');},'Unit, Unit':function UnitUnit(x,y){if(!x.equalBase(y)){throw new Error('Cannot compare units with different base');}return larger(x.value,y.value);},'string, string':function stringString(x,y){return x>y;},'Matrix, Matrix':function MatrixMatrix(x,y){// result
var c;// process matrix storage
switch(x.storage()){case'sparse':switch(y.storage()){case'sparse':// sparse + sparse
c=algorithm07(x,y,larger);break;default:// sparse + dense
c=algorithm03(y,x,larger,true);break;}break;default:switch(y.storage()){case'sparse':// dense + sparse
c=algorithm03(x,y,larger,false);break;default:// dense + dense
c=algorithm13(x,y,larger);break;}break;}return c;},'Array, Array':function ArrayArray(x,y){// use matrix implementation
return larger(matrix(x),matrix(y)).valueOf();},'Array, Matrix':function ArrayMatrix(x,y){// use matrix implementation
return larger(matrix(x),y);},'Matrix, Array':function MatrixArray(x,y){// use matrix implementation
return larger(x,matrix(y));},'Matrix, any':function MatrixAny(x,y){// result
var c;// check storage format
switch(x.storage()){case'sparse':c=algorithm12(x,y,larger,false);break;default:c=algorithm14(x,y,larger,false);break;}return c;},'any, Matrix':function anyMatrix(x,y){// result
var c;// check storage format
switch(y.storage()){case'sparse':c=algorithm12(y,x,larger,true);break;default:c=algorithm14(y,x,larger,true);break;}return c;},'Array, any':function ArrayAny(x,y){// use matrix implementation
return algorithm14(matrix(x),y,larger,false).valueOf();},'any, Array':function anyArray(x,y){// use matrix implementation
return algorithm14(matrix(y),x,larger,true).valueOf();}});larger.toTex={2:'\\left(${args[0]}'+latex.operators['larger']+'${args[1]}\\right)'};return larger;}exports.name='larger';exports.factory=factory;/***/},/* 56 *//***/function(module,exports,__webpack_require__){var util=__webpack_require__(26);var string=util.string;var object=util.object;var isArray=Array.isArray;var isString=string.isString;function factory(type,config,load){var DenseMatrix=load(__webpack_require__(35));var smaller=load(__webpack_require__(51));function ImmutableDenseMatrix(data,datatype){if(!(this instanceof ImmutableDenseMatrix))throw new SyntaxError('Constructor must be called with the new operator');if(datatype&&!isString(datatype))throw new Error('Invalid datatype: '+datatype);if(data&&data.isMatrix===true||isArray(data)){// use DenseMatrix implementation
var matrix=new DenseMatrix(data,datatype);// internal structures
this._data=matrix._data;this._size=matrix._size;this._datatype=matrix._datatype;this._min=null;this._max=null;}else if(data&&isArray(data.data)&&isArray(data.size)){// initialize fields from JSON representation
this._data=data.data;this._size=data.size;this._datatype=data.datatype;this._min=typeof data.min!=='undefined'?data.min:null;this._max=typeof data.max!=='undefined'?data.max:null;}else if(data){// unsupported type
throw new TypeError('Unsupported type of data ('+util.types.type(data)+')');}else{// nothing provided
this._data=[];this._size=[0];this._datatype=datatype;this._min=null;this._max=null;}}ImmutableDenseMatrix.prototype=new DenseMatrix();/**
	   * Attach type information
	   */ImmutableDenseMatrix.prototype.type='ImmutableDenseMatrix';ImmutableDenseMatrix.prototype.isImmutableDenseMatrix=true;/**
	   * Get a subset of the matrix, or replace a subset of the matrix.
	   *
	   * Usage:
	   *     var subset = matrix.subset(index)               // retrieve subset
	   *     var value = matrix.subset(index, replacement)   // replace subset
	   *
	   * @param {Index} index
	   * @param {Array | ImmutableDenseMatrix | *} [replacement]
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be filled with zeros.
	   */ImmutableDenseMatrix.prototype.subset=function(index){switch(arguments.length){case 1:// use base implementation
var m=DenseMatrix.prototype.subset.call(this,index);// check result is a matrix
if(m.isMatrix){// return immutable matrix
return new ImmutableDenseMatrix({data:m._data,size:m._size,datatype:m._datatype});}return m;// intentional fall through
case 2:case 3:throw new Error('Cannot invoke set subset on an Immutable Matrix instance');default:throw new SyntaxError('Wrong number of arguments');}};/**
	   * Replace a single element in the matrix.
	   * @param {Number[]} index   Zero-based index
	   * @param {*} value
	   * @param {*} [defaultValue]        Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be left undefined.
	   * @return {ImmutableDenseMatrix} self
	   */ImmutableDenseMatrix.prototype.set=function(){throw new Error('Cannot invoke set on an Immutable Matrix instance');};/**
	   * Resize the matrix to the given size. Returns a copy of the matrix when
	   * `copy=true`, otherwise return the matrix itself (resize in place).
	   *
	   * @param {Number[]} size           The new size the matrix should have.
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
	   *                                  If not provided, the matrix elements will
	   *                                  be filled with zeros.
	   * @param {boolean} [copy]          Return a resized copy of the matrix
	   *
	   * @return {Matrix}                 The resized matrix
	   */ImmutableDenseMatrix.prototype.resize=function(){throw new Error('Cannot invoke resize on an Immutable Matrix instance');};/**
	   * Disallows reshaping in favor of immutability.
	   *
	   * @throws {Error} Operation not allowed
	   */ImmutableDenseMatrix.prototype.reshape=function(){throw new Error('Cannot invoke reshape on an Immutable Matrix instance');};/**
	   * Create a clone of the matrix
	   * @return {ImmutableDenseMatrix} clone
	   */ImmutableDenseMatrix.prototype.clone=function(){var m=new ImmutableDenseMatrix({data:object.clone(this._data),size:object.clone(this._size),datatype:this._datatype});return m;};/**
	   * Get a JSON representation of the matrix
	   * @returns {Object}
	   */ImmutableDenseMatrix.prototype.toJSON=function(){return{mathjs:'ImmutableDenseMatrix',data:this._data,size:this._size,datatype:this._datatype};};/**
	   * Generate a matrix from a JSON object
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "ImmutableDenseMatrix", data: [], size: []}`,
	   *                       where mathjs is optional
	   * @returns {ImmutableDenseMatrix}
	   */ImmutableDenseMatrix.fromJSON=function(json){return new ImmutableDenseMatrix(json);};/**
	   * Swap rows i and j in Matrix.
	   *
	   * @param {Number} i       Matrix row index 1
	   * @param {Number} j       Matrix row index 2
	   *
	   * @return {Matrix}        The matrix reference
	   */ImmutableDenseMatrix.prototype.swapRows=function(){throw new Error('Cannot invoke swapRows on an Immutable Matrix instance');};/**
	   * Calculate the minimum value in the set
	   * @return {Number | undefined} min
	   */ImmutableDenseMatrix.prototype.min=function(){// check min has been calculated before
if(this._min===null){// minimum
var m=null;// compute min
this.forEach(function(v){if(m===null||smaller(v,m))m=v;});this._min=m!==null?m:undefined;}return this._min;};/**
	   * Calculate the maximum value in the set
	   * @return {Number | undefined} max
	   */ImmutableDenseMatrix.prototype.max=function(){// check max has been calculated before
if(this._max===null){// maximum
var m=null;// compute max
this.forEach(function(v){if(m===null||smaller(m,v))m=v;});this._max=m!==null?m:undefined;}return this._max;};// exports
return ImmutableDenseMatrix;}exports.name='ImmutableDenseMatrix';exports.path='type';exports.factory=factory;/***/},/* 57 *//***/function(module,exports,__webpack_require__){var clone=__webpack_require__(15).clone;var isInteger=__webpack_require__(18).isInteger;function factory(type){/**
	   * Create an index. An Index can store ranges and sets for multiple dimensions.
	   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
	   *
	   * Usage:
	   *     var index = new Index(range1, range2, matrix1, array1, ...);
	   *
	   * Where each parameter can be any of:
	   *     A number
	   *     A string (containing a name of an object property)
	   *     An instance of Range
	   *     An Array with the Set values
	   *     A Matrix with the Set values
	   *
	   * The parameters start, end, and step must be integer numbers.
	   *
	   * @class Index
	   * @Constructor Index
	   * @param {...*} ranges
	   */function Index(ranges){if(!(this instanceof Index)){throw new SyntaxError('Constructor must be called with the new operator');}this._dimensions=[];this._isScalar=true;for(var i=0,ii=arguments.length;i<ii;i++){var arg=arguments[i];if(arg&&arg.isRange===true){this._dimensions.push(arg);this._isScalar=false;}else if(arg&&(Array.isArray(arg)||arg.isMatrix===true)){// create matrix
var m=_createImmutableMatrix(arg.valueOf());this._dimensions.push(m);// size
var size=m.size();// scalar
if(size.length!==1||size[0]!==1){this._isScalar=false;}}else if(typeof arg==='number'){this._dimensions.push(_createImmutableMatrix([arg]));}else if(typeof arg==='string'){// object property (arguments.count should be 1)
this._dimensions.push(arg);}// TODO: implement support for wildcard '*'
else{throw new TypeError('Dimension must be an Array, Matrix, number, string, or Range');}}}/**
	   * Attach type information
	   */Index.prototype.type='Index';Index.prototype.isIndex=true;function _createImmutableMatrix(arg){// loop array elements
for(var i=0,l=arg.length;i<l;i++){if(typeof arg[i]!=='number'||!isInteger(arg[i])){throw new TypeError('Index parameters must be positive integer numbers');}}// create matrix
return new type.ImmutableDenseMatrix(arg);}/**
	   * Create a clone of the index
	   * @memberof Index
	   * @return {Index} clone
	   */Index.prototype.clone=function(){var index=new Index();index._dimensions=clone(this._dimensions);index._isScalar=this._isScalar;return index;};/**
	   * Create an index from an array with ranges/numbers
	   * @memberof Index
	   * @param {Array.<Array | number>} ranges
	   * @return {Index} index
	   * @private
	   */Index.create=function(ranges){var index=new Index();Index.apply(index,ranges);return index;};/**
	   * Retrieve the size of the index, the number of elements for each dimension.
	   * @memberof Index
	   * @returns {number[]} size
	   */Index.prototype.size=function(){var size=[];for(var i=0,ii=this._dimensions.length;i<ii;i++){var d=this._dimensions[i];size[i]=typeof d==='string'?1:d.size()[0];}return size;};/**
	   * Get the maximum value for each of the indexes ranges.
	   * @memberof Index
	   * @returns {number[]} max
	   */Index.prototype.max=function(){var values=[];for(var i=0,ii=this._dimensions.length;i<ii;i++){var range=this._dimensions[i];values[i]=typeof range==='string'?range:range.max();}return values;};/**
	   * Get the minimum value for each of the indexes ranges.
	   * @memberof Index
	   * @returns {number[]} min
	   */Index.prototype.min=function(){var values=[];for(var i=0,ii=this._dimensions.length;i<ii;i++){var range=this._dimensions[i];values[i]=typeof range==='string'?range:range.min();}return values;};/**
	   * Loop over each of the ranges of the index
	   * @memberof Index
	   * @param {Function} callback   Called for each range with a Range as first
	   *                              argument, the dimension as second, and the
	   *                              index object as third.
	   */Index.prototype.forEach=function(callback){for(var i=0,ii=this._dimensions.length;i<ii;i++){callback(this._dimensions[i],i,this);}};/**
	   * Retrieve the dimension for the given index
	   * @memberof Index
	   * @param {Number} dim                  Number of the dimension
	   * @returns {Range | null} range
	   */Index.prototype.dimension=function(dim){return this._dimensions[dim]||null;};/**
	   * Test whether this index contains an object property
	   * @returns {boolean} Returns true if the index is an object property
	   */Index.prototype.isObjectProperty=function(){return this._dimensions.length===1&&typeof this._dimensions[0]==='string';};/**
	   * Returns the object property name when the Index holds a single object property,
	   * else returns null
	   * @returns {string | null}
	   */Index.prototype.getObjectProperty=function(){return this.isObjectProperty()?this._dimensions[0]:null;};/**
	   * Test whether this index contains only a single value.
	   *
	   * This is the case when the index is created with only scalar values as ranges,
	   * not for ranges resolving into a single value.
	   * @memberof Index
	   * @return {boolean} isScalar
	   */Index.prototype.isScalar=function(){return this._isScalar;};/**
	   * Expand the Index into an array.
	   * For example new Index([0,3], [2,7]) returns [[0,1,2], [2,3,4,5,6]]
	   * @memberof Index
	   * @returns {Array} array
	   */Index.prototype.toArray=function(){var array=[];for(var i=0,ii=this._dimensions.length;i<ii;i++){var dimension=this._dimensions[i];array.push(typeof dimension==='string'?dimension:dimension.toArray());}return array;};/**
	   * Get the primitive value of the Index, a two dimensional array.
	   * Equivalent to Index.toArray().
	   * @memberof Index
	   * @returns {Array} array
	   */Index.prototype.valueOf=Index.prototype.toArray;/**
	   * Get the string representation of the index, for example '[2:6]' or '[0:2:10, 4:7, [1,2,3]]'
	   * @memberof Index
	   * @returns {String} str
	   */Index.prototype.toString=function(){var strings=[];for(var i=0,ii=this._dimensions.length;i<ii;i++){var dimension=this._dimensions[i];if(typeof dimension==='string'){strings.push(JSON.stringify(dimension));}else{strings.push(dimension.toString());}}return'['+strings.join(', ')+']';};/**
	   * Get a JSON representation of the Index
	   * @memberof Index
	   * @returns {Object} Returns a JSON object structured as:
	   *                   `{"mathjs": "Index", "ranges": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
	   */Index.prototype.toJSON=function(){return{mathjs:'Index',dimensions:this._dimensions};};/**
	   * Instantiate an Index from a JSON object
	   * @memberof Index
	   * @param {Object} json A JSON object structured as:
	   *                     `{"mathjs": "Index", "dimensions": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
	   * @return {Index}
	   */Index.fromJSON=function(json){return Index.create(json.dimensions);};return Index;}exports.name='Index';exports.path='type';exports.factory=factory;/***/},/* 58 *//***/function(module,exports,__webpack_require__){var number=__webpack_require__(18);function factory(type,config,load,typed){/**
	   * Create a range. A range has a start, step, and end, and contains functions
	   * to iterate over the range.
	   *
	   * A range can be constructed as:
	   *     var range = new Range(start, end);
	   *     var range = new Range(start, end, step);
	   *
	   * To get the result of the range:
	   *     range.forEach(function (x) {
	   *         console.log(x);
	   *     });
	   *     range.map(function (x) {
	   *         return math.sin(x);
	   *     });
	   *     range.toArray();
	   *
	   * Example usage:
	   *     var c = new Range(2, 6);         // 2:1:5
	   *     c.toArray();                     // [2, 3, 4, 5]
	   *     var d = new Range(2, -3, -1);    // 2:-1:-2
	   *     d.toArray();                     // [2, 1, 0, -1, -2]
	   *
	   * @class Range
	   * @constructor Range
	   * @param {number} start  included lower bound
	   * @param {number} end    excluded upper bound
	   * @param {number} [step] step size, default value is 1
	   */function Range(start,end,step){if(!(this instanceof Range)){throw new SyntaxError('Constructor must be called with the new operator');}if(start!=null){if(start.isBigNumber===true)start=start.toNumber();else if(typeof start!=='number')throw new TypeError('Parameter start must be a number');}if(end!=null){if(end.isBigNumber===true)end=end.toNumber();else if(typeof end!=='number')throw new TypeError('Parameter end must be a number');}if(step!=null){if(step.isBigNumber===true)step=step.toNumber();else if(typeof step!=='number')throw new TypeError('Parameter step must be a number');}this.start=start!=null?parseFloat(start):0;this.end=end!=null?parseFloat(end):0;this.step=step!=null?parseFloat(step):1;}/**
	   * Attach type information
	   */Range.prototype.type='Range';Range.prototype.isRange=true;/**
	   * Parse a string into a range,
	   * The string contains the start, optional step, and end, separated by a colon.
	   * If the string does not contain a valid range, null is returned.
	   * For example str='0:2:11'.
	   * @memberof Range
	   * @param {string} str
	   * @return {Range | null} range
	   */Range.parse=function(str){if(typeof str!=='string'){return null;}var args=str.split(':');var nums=args.map(function(arg){return parseFloat(arg);});var invalid=nums.some(function(num){return isNaN(num);});if(invalid){return null;}switch(nums.length){case 2:return new Range(nums[0],nums[1]);case 3:return new Range(nums[0],nums[2],nums[1]);default:return null;}};/**
	   * Create a clone of the range
	   * @return {Range} clone
	   */Range.prototype.clone=function(){return new Range(this.start,this.end,this.step);};/**
	   * Retrieve the size of the range.
	   * Returns an array containing one number, the number of elements in the range.
	   * @memberof Range
	   * @returns {number[]} size
	   */Range.prototype.size=function(){var len=0,start=this.start,step=this.step,end=this.end,diff=end-start;if(number.sign(step)==number.sign(diff)){len=Math.ceil(diff/step);}else if(diff==0){len=0;}if(isNaN(len)){len=0;}return[len];};/**
	   * Calculate the minimum value in the range
	   * @memberof Range
	   * @return {number | undefined} min
	   */Range.prototype.min=function(){var size=this.size()[0];if(size>0){if(this.step>0){// positive step
return this.start;}else{// negative step
return this.start+(size-1)*this.step;}}else{return undefined;}};/**
	   * Calculate the maximum value in the range
	   * @memberof Range
	   * @return {number | undefined} max
	   */Range.prototype.max=function(){var size=this.size()[0];if(size>0){if(this.step>0){// positive step
return this.start+(size-1)*this.step;}else{// negative step
return this.start;}}else{return undefined;}};/**
	   * Execute a callback function for each value in the range.
	   * @memberof Range
	   * @param {function} callback   The callback method is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Range being traversed.
	   */Range.prototype.forEach=function(callback){var x=this.start;var step=this.step;var end=this.end;var i=0;if(step>0){while(x<end){callback(x,[i],this);x+=step;i++;}}else if(step<0){while(x>end){callback(x,[i],this);x+=step;i++;}}};/**
	   * Execute a callback function for each value in the Range, and return the
	   * results as an array
	   * @memberof Range
	   * @param {function} callback   The callback method is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix being traversed.
	   * @returns {Array} array
	   */Range.prototype.map=function(callback){var array=[];this.forEach(function(value,index,obj){array[index[0]]=callback(value,index,obj);});return array;};/**
	   * Create an Array with a copy of the Ranges data
	   * @memberof Range
	   * @returns {Array} array
	   */Range.prototype.toArray=function(){var array=[];this.forEach(function(value,index){array[index[0]]=value;});return array;};/**
	   * Get the primitive value of the Range, a one dimensional array
	   * @memberof Range
	   * @returns {Array} array
	   */Range.prototype.valueOf=function(){// TODO: implement a caching mechanism for range.valueOf()
return this.toArray();};/**
	   * Get a string representation of the range, with optional formatting options.
	   * Output is formatted as 'start:step:end', for example '2:6' or '0:0.2:11'
	   * @memberof Range
	   * @param {Object | number | function} [options]  Formatting options. See
	   *                                                lib/utils/number:format for a
	   *                                                description of the available
	   *                                                options.
	   * @returns {string} str
	   */Range.prototype.format=function(options){var str=number.format(this.start,options);if(this.step!=1){str+=':'+number.format(this.step,options);}str+=':'+number.format(this.end,options);return str;};/**
	   * Get a string representation of the range.
	   * @memberof Range
	   * @returns {string}
	   */Range.prototype.toString=function(){return this.format();};/**
	   * Get a JSON representation of the range
	   * @memberof Range
	   * @returns {Object} Returns a JSON object structured as:
	   *                   `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
	   */Range.prototype.toJSON=function(){return{mathjs:'Range',start:this.start,end:this.end,step:this.step};};/**
	   * Instantiate a Range from a JSON object
	   * @memberof Range
	   * @param {Object} json A JSON object structured as:
	   *                      `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
	   * @return {Range}
	   */Range.fromJSON=function(json){return new Range(json.start,json.end,json.step);};return Range;}exports.name='Range';exports.path='type';exports.factory=factory;/***/},/* 59 *//***/function(module,exports){function factory(type,config,load,typed){/**
	   * Create an index. An Index can store ranges having start, step, and end
	   * for multiple dimensions.
	   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
	   *
	   * Syntax:
	   *
	   *     math.index(range1, range2, ...)
	   *
	   * Where each range can be any of:
	   *
	   * - A number
	   * - A string for getting/setting an object property
	   * - An instance of `Range`
	   * - A one-dimensional Array or a Matrix with numbers
	   *
	   * Indexes must be zero-based, integer numbers.
	   *
	   * Examples:
	   *
	   *    var math = math.js
	   *
	   *    var b = [1, 2, 3, 4, 5];
	   *    math.subset(b, math.index([1, 2, 3]));     // returns [2, 3, 4]
	   *
	   *    var a = math.matrix([[1, 2], [3, 4]]);
	   *    a.subset(math.index(0, 1));             // returns 2
	   *
	   * See also:
	   *
	   *    bignumber, boolean, complex, matrix, number, string, unit
	   *
	   * @param {...*} ranges   Zero or more ranges or numbers.
	   * @return {Index}        Returns the created index
	   */return typed('index',{'...number | string | BigNumber | Range | Array | Matrix':function numberStringBigNumberRangeArrayMatrix(args){var ranges=args.map(function(arg){if(arg&&arg.isBigNumber===true){return arg.toNumber();// convert BigNumber to Number
}else if(arg&&(Array.isArray(arg)||arg.isMatrix===true)){return arg.map(function(elem){// convert BigNumber to Number
return elem&&elem.isBigNumber===true?elem.toNumber():elem;});}else{return arg;}});var res=new type.Index();type.Index.apply(res,ranges);return res;}});}exports.name='index';exports.factory=factory;/***/},/* 60 *//***/function(module,exports){function factory(type,config,load,typed){var SparseMatrix=type.SparseMatrix;/**
	   * Create a Sparse Matrix. The function creates a new `math.type.Matrix` object from
	   * an `Array`. A Matrix has utility functions to manipulate the data in the
	   * matrix, like getting the size and getting or setting values in the matrix.
	   *
	   * Syntax:
	   *
	   *    math.sparse()               // creates an empty sparse matrix.
	   *    math.sparse(data)           // creates a sparse matrix with initial data.
	   *    math.sparse(data, 'number') // creates a sparse matrix with initial data, number datatype.
	   *
	   * Examples:
	   *
	   *    var m = math.sparse([[1, 2], [3, 4]]);
	   *    m.size();                        // Array [2, 2]
	   *    m.resize([3, 2], 5);
	   *    m.valueOf();                     // Array [[1, 2], [3, 4], [5, 5]]
	   *    m.get([1, 0])                    // number 3
	   *
	   * See also:
	   *
	   *    bignumber, boolean, complex, index, number, string, unit, matrix
	   *
	   * @param {Array | Matrix} [data]    A two dimensional array
	   *
	   * @return {Matrix} The created matrix
	   */var sparse=typed('sparse',{'':function _(){return new SparseMatrix([]);},'string':function string(datatype){return new SparseMatrix([],datatype);},'Array | Matrix':function ArrayMatrix(data){return new SparseMatrix(data);},'Array | Matrix, string':function ArrayMatrixString(data,datatype){return new SparseMatrix(data,datatype);}});sparse.toTex={0:'\\begin{bsparse}\\end{bsparse}',1:'\\left(${args[0]}\\right)'};return sparse;}exports.name='sparse';exports.factory=factory;/***/},/* 61 *//***/function(module,exports,__webpack_require__){var isInteger=__webpack_require__(18).isInteger;var resize=__webpack_require__(27).resize;function factory(type,config,load,typed){var matrix=load(__webpack_require__(42));/**
	   * Create a matrix filled with zeros. The created matrix can have one or
	   * multiple dimensions.
	   *
	   * Syntax:
	   *
	   *    math.zeros(m)
	   *    math.zeros(m, format)
	   *    math.zeros(m, n)
	   *    math.zeros(m, n, format)
	   *    math.zeros([m, n])
	   *    math.zeros([m, n], format)
	   *
	   * Examples:
	   *
	   *    math.zeros(3);                  // returns [0, 0, 0]
	   *    math.zeros(3, 2);               // returns [[0, 0], [0, 0], [0, 0]]
	   *    math.zeros(3, 'dense');         // returns [0, 0, 0]
	   *
	   *    var A = [[1, 2, 3], [4, 5, 6]];
	   *    math.zeros(math.size(A));       // returns [[0, 0, 0], [0, 0, 0]]
	   *
	   * See also:
	   *
	   *    ones, eye, size, range
	   *
	   * @param {...number | Array} size    The size of each dimension of the matrix
	   * @param {string} [format]           The Matrix storage format
	   *
	   * @return {Array | Matrix}           A matrix filled with zeros
	   */var zeros=typed('zeros',{'':function _(){return config.matrix==='Array'?_zeros([]):_zeros([],'default');},// math.zeros(m, n, p, ..., format)
// TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
'...number | BigNumber | string':function numberBigNumberString(size){var last=size[size.length-1];if(typeof last==='string'){var format=size.pop();return _zeros(size,format);}else if(config.matrix==='Array'){return _zeros(size);}else{return _zeros(size,'default');}},'Array':_zeros,'Matrix':function Matrix(size){var format=size.storage();return _zeros(size.valueOf(),format);},'Array | Matrix, string':function ArrayMatrixString(size,format){return _zeros(size.valueOf(),format);}});zeros.toTex=undefined;// use default template
return zeros;/**
	   * Create an Array or Matrix with zeros
	   * @param {Array} size
	   * @param {string} [format='default']
	   * @return {Array | Matrix}
	   * @private
	   */function _zeros(size,format){var hasBigNumbers=_normalize(size);var defaultValue=hasBigNumbers?new type.BigNumber(0):0;_validate(size);if(format){// return a matrix
var m=matrix(format);if(size.length>0){return m.resize(size,defaultValue);}return m;}else{// return an Array
var arr=[];if(size.length>0){return resize(arr,size,defaultValue);}return arr;}}// replace BigNumbers with numbers, returns true if size contained BigNumbers
function _normalize(size){var hasBigNumbers=false;size.forEach(function(value,index,arr){if(value&&value.isBigNumber===true){hasBigNumbers=true;arr[index]=value.toNumber();}});return hasBigNumbers;}// validate arguments
function _validate(size){size.forEach(function(value){if(typeof value!=='number'||!isInteger(value)||value<0){throw new Error('Parameters in function zeros must be positive integers');}});}}// TODO: zeros contains almost the same code as ones. Reuse this?
exports.name='zeros';exports.factory=factory;/***/},/* 62 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);var get_filter_default_state=__webpack_require__(6);var underscore=__webpack_require__(3);module.exports=function get_subset_views(params,views,requested_view){var inst_value;var found_filter;var request_filters=underscore.keys(requested_view);// find a view that matches all of the requested view/filter-attributes
underscore.each(request_filters,function(inst_filter){inst_value=requested_view[inst_filter];// if the value is a number, then convert it to an integer
if(/[^a-z_]/i.test(inst_value)){inst_value=parseInt(inst_value,10);}// only run filtering if any of the views has the filter
found_filter=false;underscore.each(views,function(tmp_view){if(utils.has(tmp_view,inst_filter)){found_filter=true;}});if(found_filter){views=underscore.filter(views,function(d){return d[inst_filter]==inst_value;});}});// remove duplicate complete default states
var export_views=[];var found_default=false;var check_default;var inst_default_state;// check if each view is a default state: all filters are at default
// there can only be one of these
underscore.each(views,function(inst_view){check_default=true;// check each filter in a view to see if it is in the default state
underscore.each(underscore.keys(params.viz.possible_filters),function(inst_filter){inst_default_state=get_filter_default_state(params.viz.filter_data,inst_filter);if(inst_view[inst_filter]!=inst_default_state){check_default=false;}});// found defaule view, only append if you have not already found a default
if(check_default){if(found_default===false){found_default=true;export_views.push(inst_view);}}else{export_views.push(inst_view);}});// if (export_views.length > 1){
//   console.log('found more than one view in get_subset_views')
//   console.log(requested_view)
//   console.log(export_views)
// } else {
//   console.log('found single view in get_subset_views')
//   console.log(requested_view)
//   console.log(export_views[0])
//   console.log('\n')
// }
return export_views;};/***/},/* 63 *//***/function(module,exports){module.exports=function ini_sidebar_params(params){var sidebar={};sidebar.wrapper={};// sidebar.wrapper.width = 170;
sidebar.row_search={};sidebar.row_search.box={};sidebar.row_search.box.height=34;sidebar.row_search.box.width=95;sidebar.row_search.placeholder=params.row_search_placeholder;sidebar.row_search.margin_left=7;sidebar.slider={};sidebar.slider.width=params.sidebar_width-30;sidebar.slider.margin_left=15;sidebar.key_cat={};sidebar.key_cat.width=params.sidebar_width-15;sidebar.key_cat.margin_left=5;sidebar.key_cat.max_height=100;sidebar.title=params.title;sidebar.title_margin_left=7;sidebar.about=params.about;sidebar.width=params.sidebar_width;sidebar.buttons={};sidebar.buttons.width=params.sidebar_width-15;sidebar.text={};sidebar.icons=params.sidebar_icons;sidebar.icon_margin_left=-5;return sidebar;};/***/},/* 64 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function make_view_request(params,requested_view){// this will add all necessary information to a view request
// it will grab necessary view information from the sliders
// only one component will be changed at a time
var changed_component=underscore.keys(requested_view)[0];// add additional filter information from othe possible filters
underscore.each(underscore.keys(params.viz.possible_filters),function(inst_filter){if(inst_filter!=changed_component){if(!d3.select(params.root+' .slider_'+inst_filter).empty()){var inst_state=d3.select(params.root+' .slider_'+inst_filter).attr('current_state');requested_view[inst_filter]=inst_state;}}});return requested_view;};/***/},/* 65 *//***/function(module,exports,__webpack_require__){var ini_label_params=__webpack_require__(66);var set_viz_wrapper_size=__webpack_require__(67);var get_svg_dim=__webpack_require__(69);var calc_label_params=__webpack_require__(70);var calc_clust_width=__webpack_require__(71);var calc_clust_height=__webpack_require__(72);var calc_val_max=__webpack_require__(73);var calc_matrix_params=__webpack_require__(74);var set_zoom_params=__webpack_require__(79);var calc_default_fs=__webpack_require__(81);var utils=__webpack_require__(2);var get_available_filters=__webpack_require__(5);var make_cat_params=__webpack_require__(82);module.exports=function calc_viz_params(params){var predefined_cat_colors=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;params.labels=ini_label_params(params);params.viz=ini_viz_params(params,predefined_cat_colors);set_viz_wrapper_size(params);params=get_svg_dim(params);params.viz=calc_label_params(params.viz);params.viz=calc_clust_width(params.viz);params.viz=calc_clust_height(params.viz);if(params.sim_mat){if(params.viz.clust.dim.width<=params.viz.clust.dim.height){params.viz.clust.dim.height=params.viz.clust.dim.width;}else{params.viz.clust.dim.width=params.viz.clust.dim.height;}}params=calc_val_max(params);params=calc_matrix_params(params);params=set_zoom_params(params);params=calc_default_fs(params);function ini_viz_params(params){var predefined_cat_colors=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var viz={};viz.root=params.root;viz.root_tips=params.root.replace('#','.')+'_'+'d3-tip';viz.viz_wrapper=params.root+' .viz_wrapper';viz.do_zoom=params.do_zoom;viz.background_color=params.background_color;viz.super_border_color=params.super_border_color;viz.outer_margins=params.outer_margins;viz.is_expand=params.ini_expand;viz.grey_border_width=params.grey_border_width;viz.show_dendrogram=params.show_dendrogram;viz.tile_click_hlight=params.tile_click_hlight;viz.inst_order=params.inst_order;viz.expand_button=params.expand_button;viz.sim_mat=params.sim_mat;viz.dendro_filter=params.dendro_filter;viz.cat_filter=params.cat_filter;viz.cat_value_colors=params.cat_value_colors;viz.cat_bar_width=180;viz.cat_bar_height=20;viz.tree_menu_width=400;viz.tree_menu_height=237;viz.tree_menu_x_offset=20;viz.filter_menu_width=500;viz.filter_menu_height=237;viz.filter_menu_x_offset=20;viz.update_button_width=100;viz.viz_svg=viz.viz_wrapper+' .viz_svg';viz.zoom_element=viz.viz_wrapper+' .viz_svg';viz.uni_duration=1000;// extra space below the clustergram (was 5)
// will increase this to accomidate dendro slider
viz.bottom_space=10;viz.run_trans=false;viz.duration=1000;viz.resize=params.resize;if(utils.has(params,'size')){viz.fixed_size=params.size;}else{viz.fixed_size=false;}// width is 1 over this value
viz.border_fraction=65;viz.uni_margin=5;viz.super_labels={};viz.super_labels.margin={};viz.super_labels.dim={};viz.super_labels.margin.left=viz.grey_border_width;viz.super_labels.margin.top=viz.grey_border_width;viz.super_labels.dim.width=0;if(params.labels.super_labels){viz.super_labels.dim.width=15*params.labels.super_label_scale;}viz.triangle_opacity=0.6;viz.norm_labels={};viz.norm_labels.width={};viz.dendro_room={};if(viz.show_dendrogram){viz.dendro_room.symbol_width=10;}else{viz.dendro_room.symbol_width=0;}viz.cat_colors=params.cat_colors;// console.log('ini_viz_params -> make_cat_params')
// console.log('predefined_cat_colors outside function ' + String(predefined_cat_colors))
viz=make_cat_params(params,viz,predefined_cat_colors);// // always make group level dict
// params.group_level = {};
if(_.has(params,'group_level')==false){if(viz.show_dendrogram){params.group_level={};}// preventing error when un-clustered, above statement
// preserves dendro state while updating
if(_.has(params,'group_level')==false){params.group_level={};}params.group_level.row=5;params.group_level.col=5;}viz.dendro_opacity=0.35;viz.spillover_col_slant=viz.norm_labels.width.col;var filters=get_available_filters(params.network_data.views);viz.possible_filters=filters.possible_filters;viz.filter_data=filters.filter_data;viz.viz_nodes={};// nodes that should be visible based on visible area
viz.viz_nodes.row=params.network_data.row_nodes_names;viz.viz_nodes.col=params.network_data.col_nodes_names;// nodes that are currently visible
viz.viz_nodes.curr_row=params.network_data.row_nodes_names;viz.viz_nodes.curr_col=params.network_data.col_nodes_names;// correct panning in x direction
viz.x_offset=0;return viz;}return params;};/***/},/* 66 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function ini_label_params(params){var labels={};labels.super_label_scale=params.super_label_scale;labels.super_labels=params.super_labels;labels.super_label_fs=13.8;if(labels.super_labels){labels.super={};labels.super.row=params.super.row;labels.super.col=params.super.col;}labels.show_label_tooltips=params.show_label_tooltips;labels.row_max_char=underscore.max(params.network_data.row_nodes,function(inst){return inst.name.length;}).name.length;labels.col_max_char=underscore.max(params.network_data.col_nodes,function(inst){return inst.name.length;}).name.length;labels.max_allow_fs=params.max_allow_fs;return labels;};/***/},/* 67 *//***/function(module,exports,__webpack_require__){var calc_viz_dimensions=__webpack_require__(68);module.exports=function set_viz_wrapper_size(params){// Create wrapper around SVG visualization
if(d3.select(params.root+' .viz_wrapper').empty()){d3.select(params.root).append('div').classed('sidebar_wrapper',true);d3.select(params.root).append('div').classed('viz_wrapper',true);}var cont_dim=calc_viz_dimensions(params);d3.select(params.root+' .sidebar_wrapper').style('float','left').style('width',params.sidebar_width+'px').style('height',cont_dim.height+'px').style('overflow','hidden');d3.select(params.viz.viz_wrapper).style('float','left').style('width',cont_dim.width+'px').style('height',cont_dim.height+'px');};/***/},/* 68 *//***/function(module,exports){module.exports=function calc_viz_dimensions(params){var cont_dim={};var extra_space=params.buffer_width;// var screen_width = window.innerWidth;
// var screen_height = window.innerHeight;
// // resize container, then resize visualization within container
// d3.select(params.root)
//   .style('width', screen_width+'px')
//   .style('height', screen_height+'px');
var container_width=d3.select(params.root).style('width').replace('px','');var container_height=d3.select(params.root).style('height').replace('px','');// get outer_margins
var outer_margins;if(params.viz.is_expand===false){outer_margins=params.viz.outer_margins;cont_dim.width=container_width-params.sidebar_width-extra_space;}else{outer_margins=params.viz.outer_margins;cont_dim.width=container_width-extra_space;}cont_dim.top=outer_margins.top;cont_dim.left=outer_margins.left;if(params.viz.resize){cont_dim.height=container_height;}else{if(params.viz.is_expand){cont_dim.width=params.viz.fixed_size.width;}else{cont_dim.width=params.viz.fixed_size.width-params.sidebar_width;}cont_dim.height=params.viz.fixed_size.height;}return cont_dim;};/***/},/* 69 *//***/function(module,exports){module.exports=function get_svg_dim(params){params.viz.svg_dim={};params.viz.svg_dim.width=Number(d3.select(params.viz.viz_wrapper).style('width').replace('px',''));params.viz.svg_dim.height=Number(d3.select(params.viz.viz_wrapper).style('height').replace('px',''));return params;};/***/},/* 70 *//***/function(module,exports){module.exports=function calc_label_params(viz){viz.norm_labels.margin={};viz.norm_labels.margin.left=viz.super_labels.margin.left+viz.super_labels.dim.width;viz.norm_labels.margin.top=viz.super_labels.margin.top+viz.super_labels.dim.width;viz.label_background={};viz.label_background.row=viz.norm_labels.width.row+viz.cat_room.row+viz.uni_margin;viz.label_background.col=viz.norm_labels.width.col+viz.cat_room.col+viz.uni_margin;return viz;};/***/},/* 71 *//***/function(module,exports){module.exports=function calc_clust_width(viz){viz.clust={};viz.clust.margin={};// margin on left/top of the clustergram/matrix
// 1) norm_label margin and width
// 2) cat_room and uni_margin
viz.clust.margin.left=viz.norm_labels.margin.left+viz.norm_labels.width.row+viz.cat_room.row+viz.uni_margin;viz.clust.margin.top=viz.norm_labels.margin.top+viz.norm_labels.width.col+viz.cat_room.col+viz.uni_margin;// the clustergram/matrix width is the svg width minus:
// the margin of the clustergram on the left
// the room for the spillover on the right
// ** the dendro will fit in the spillover room on the right
var ini_clust_width=viz.svg_dim.width-viz.clust.margin.left-viz.spillover_col_slant;// make tmp scale to calc height of triangle col labels
var tmp_x_scale=d3.scale.ordinal().rangeBands([0,ini_clust_width]).domain(_.range(viz.num_col_nodes));var triangle_height=tmp_x_scale.rangeBand()/2;// prevent the visualization from being unnecessarily wide
if(triangle_height>viz.norm_labels.width.col){var reduce_width=viz.norm_labels.width.col/triangle_height;ini_clust_width=ini_clust_width*reduce_width;}viz.clust.dim={};viz.clust.dim.width=ini_clust_width;return viz;};/***/},/* 72 *//***/function(module,exports){module.exports=function calc_clust_height(viz){// the clustergram/matrix height is the svg width minus:
// the margin of the clustergram on the top
// the dendrogram
// the bottom_space
var ini_clust_height=viz.svg_dim.height-viz.clust.margin.top-viz.dendro_room.col-viz.bottom_space;viz.clust.dim.height=ini_clust_height;return viz;};/***/},/* 73 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function calc_val_max(params){var val_max=Math.abs(underscore.max(params.network_data.col_nodes,function(d){return Math.abs(d.value);}).value);params.labels.bar_scale_col=d3.scale.linear().domain([0,val_max]).range([0,0.75*params.viz.norm_labels.width.col]);val_max=Math.abs(underscore.max(params.network_data.row_nodes,function(d){return Math.abs(d.value);}).value);params.labels.bar_scale_row=d3.scale.linear().domain([0,val_max]).range([0,params.viz.norm_labels.width.row]);return params;};/***/},/* 74 *//***/function(module,exports,__webpack_require__){var ini_matrix_params=__webpack_require__(75);var calc_downsampled_levels=__webpack_require__(77);var underscore=__webpack_require__(3);module.exports=function calc_matrix_params(params){params.matrix=ini_matrix_params(params);// X and Y scales: set domains and ranges
//////////////////////////////////////////////
params.viz.x_scale=d3.scale.ordinal().rangeBands([0,params.viz.clust.dim.width]);params.viz.y_scale=d3.scale.ordinal().rangeBands([0,params.viz.clust.dim.height]);var inst_order;underscore.each(['row','col'],function(inst_rc){inst_order=params.viz.inst_order[inst_rc];if(inst_order==='custom'){inst_order='clust';}if(inst_rc==='row'){params.viz.x_scale.domain(params.matrix.orders[inst_order+'_'+inst_rc]);}else{params.viz.y_scale.domain(params.matrix.orders[inst_order+'_'+inst_rc]);}});// border width
params.viz.border_width={};params.viz.border_width.x=params.viz.x_scale.rangeBand()/params.viz.border_fraction;params.viz.border_width.y=params.viz.y_scale.rangeBand()/params.viz.border_fraction;// rect width needs matrix and zoom parameters
params.viz.rect_width=params.viz.x_scale.rangeBand()-params.viz.border_width.x;// moved calculateion to calc_matrix_params
params.viz.rect_height=params.viz.y_scale.rangeBand()-params.viz.border_width.y;calc_downsampled_levels(params);return params;};/***/},/* 75 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);var initialize_matrix=__webpack_require__(76);var underscore=__webpack_require__(3);module.exports=function ini_matrix_params(params){var matrix={};var network_data=params.network_data;matrix.tile_colors=params.tile_colors;matrix.bar_colors=params.bar_colors;matrix.outline_colors=params.outline_colors;matrix.hlight_color=params.highlight_color;matrix.tile_title=params.tile_title;matrix.show_tile_tooltips=params.show_tile_tooltips;matrix.make_tile_tooltip=params.make_tile_tooltip;matrix.distance_metric='cosine';matrix.linkage_type='average';matrix.filter_state='no-filter';matrix.normalization_state='no-normalization';// initialized clicked tile and rows
matrix.click_hlight_x=-666;matrix.click_hlight_y=-666;matrix.click_hlight_row=-666;matrix.click_hlight_col=-666;// definition of a large matrix (num links) determines if transition is run
matrix.def_large_matrix=2e4;matrix.opacity_function=params.opacity_scale;matrix.orders={};underscore.each(['row','col'],function(inst_rc){// row ordering is based on col info and vice versa
var other_rc;if(inst_rc==='row'){other_rc='col';}else{other_rc='row';}// the nodes are defined using other_rc
var inst_nodes=network_data[other_rc+'_nodes'];var num_nodes=inst_nodes.length;var nodes_names=utils.pluck(inst_nodes,'name');var tmp=nodes_names.sort();var alpha_index=underscore.map(tmp,function(d){return network_data[other_rc+'_nodes_names'].indexOf(d);});matrix.orders['alpha_'+inst_rc]=alpha_index;var possible_orders=['clust','rank'];if(_.has(inst_nodes[0],'rankvar')){possible_orders.push('rankvar');}if(params.viz.all_cats[other_rc].length>0){underscore.each(params.viz.all_cats[other_rc],function(inst_cat){// the index of the category has replaced - with _
inst_cat=inst_cat.replace('-','_');possible_orders.push(inst_cat+'_index');});}underscore.each(possible_orders,function(inst_order){var tmp_order_index=d3.range(num_nodes).sort(function(a,b){return inst_nodes[b][inst_order]-inst_nodes[a][inst_order];});matrix.orders[inst_order+'_'+inst_rc]=tmp_order_index;});});if(utils.has(network_data,'all_links')){matrix.max_link=underscore.max(network_data.all_links,function(d){return Math.abs(d.value);}).value;}else{matrix.max_link=underscore.max(network_data.links,function(d){return Math.abs(d.value);}).value;}matrix.abs_max_val=Math.abs(matrix.max_link)*params.clamp_opacity;if(params.input_domain===0){if(matrix.opacity_function==='linear'){matrix.opacity_scale=d3.scale.linear().domain([0,matrix.abs_max_val]).clamp(true).range([0.0,1.0]);}else if(matrix.opacity_function==='log'){matrix.opacity_scale=d3.scale.log().domain([0.001,matrix.abs_max_val]).clamp(true).range([0.0,1.0]);}}else{if(matrix.opacity_function==='linear'){matrix.opacity_scale=d3.scale.linear().domain([0,params.input_domain]).clamp(true).range([0.0,1.0]);}else if(matrix.opacity_function==='log'){matrix.opacity_scale=d3.scale.log().domain([0.001,params.input_domain]).clamp(true).range([0.0,1.0]);}}var has_val_up=utils.has(network_data.links[0],'value_up');var has_val_dn=utils.has(network_data.links[0],'value_dn');if(has_val_up||has_val_dn){matrix.tile_type='updn';}else{matrix.tile_type='simple';}if(utils.has(network_data.links[0],'highlight')){matrix.highlight=1;}else{matrix.highlight=0;}matrix.matrix=initialize_matrix(network_data);matrix.wait_tooltip=0;return matrix;};/***/},/* 76 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);module.exports=function(network_data){var matrix=[];var ini_object;var keep_orig;if(utils.has(network_data.links[0],'value_orig')){keep_orig=true;}else{keep_orig=false;}network_data.row_nodes.forEach(function(tmp,row_index){matrix[row_index]={};matrix[row_index].name=network_data.row_nodes[row_index].name;matrix[row_index].row_index=row_index;matrix[row_index].row_data=d3.range(network_data.col_nodes.length).map(function(col_index){if(utils.has(network_data.links[0],'value_up')||utils.has(network_data.links[0],'value_dn')){ini_object={pos_x:col_index,pos_y:row_index,value:0,value_up:0,value_dn:0,highlight:0};}else{ini_object={pos_x:col_index,pos_y:row_index,value:0,highlight:0};}if(keep_orig){ini_object.value_orig=0;}return ini_object;});});network_data.links.forEach(function(link){// transfer additional link information is necessary
matrix[link.source].row_data[link.target].value=link.value;matrix[link.source].row_data[link.target].row_name=link.row_name;matrix[link.source].row_data[link.target].col_name=link.col_name;if(utils.has(link,'value_up')||utils.has(link,'value_dn')){matrix[link.source].row_data[link.target].value_up=link.value_up;matrix[link.source].row_data[link.target].value_dn=link.value_dn;}if(keep_orig){matrix[link.source].row_data[link.target].value_orig=link.value_orig;}if(link.highlight){matrix[link.source].row_data[link.target].highlight=link.highlight;}if(link.info){matrix[link.source].row_data[link.target].info=link.info;}});return matrix;};/***/},/* 77 *//***/function(module,exports,__webpack_require__){var calc_downsampled_matrix=__webpack_require__(78);module.exports=function calc_downsampled_levels(params){// console.log('---- before ---------')
// console.log(params.matrix.matrix[0].row_data[0].value)
// height of downsampled rectangles
var ds_height=3;var min_rect_height=2;var total_zoom=ds_height/params.viz.rect_height;// amount of zooming that is tolerated for the downsampled rows
var inst_zt=2;params.viz.ds_zt=inst_zt;var num_levels=Math.floor(Math.log(total_zoom)/Math.log(inst_zt));if(params.viz.rect_height<min_rect_height&&num_levels>0){// increase ds opacity, as more rows are compressed into a single downsampled
// row, increase the opacity of the downsampled row. Max increase will be 2x
// when 100 or more rows are compressed
var max_opacity_scale=2;params.viz.ds_opacity_scale=d3.scale.linear().domain([1,100]).range([1,max_opacity_scale]).clamp(true);var ds;params.viz.ds_num_levels=num_levels;// array of downsampled parameters
params.viz.ds=[];// array of downsampled matrices at varying levels
params.matrix.ds_matrix=[];var inst_order=params.viz.inst_order.row;// cloning
var mat=$.extend(true,{},params.matrix.matrix);// calculate parameters for different levels
for(var i=0;i<num_levels;i++){// instantaneous ds_level (-1 means no downsampling)
params.viz.ds_level=0;ds={};ds.height=ds_height;ds.num_levels=num_levels;var inst_zoom_tolerance=Math.pow(inst_zt,i);ds.zt=inst_zoom_tolerance;// the number of downsampled rows is given by the height of the clustergram
// divided by the adjusted height of the downsampled rect.
// the adjusted height is the height divided by the zooming tolerance of
// the downsampled layer
// number of downsampled rows
ds.num_rows=Math.round(params.viz.clust.dim.height/(ds.height/inst_zoom_tolerance));// x_scale
/////////////////////////
ds.x_scale=d3.scale.ordinal().rangeBands([0,params.viz.clust.dim.width]);ds.x_scale.domain(params.matrix.orders[inst_order+'_row']);// y_scale
/////////////////////////
ds.y_scale=d3.scale.ordinal().rangeBands([0,params.viz.clust.dim.height]);ds.y_scale.domain(d3.range(ds.num_rows+1));ds.rect_height=ds.y_scale.rangeBand()-params.viz.border_width.y;params.viz.ds.push(ds);var matrix=calc_downsampled_matrix(params,mat,i);params.matrix.ds_matrix.push(matrix);}// reset row viz_nodes since downsampling
params.viz.viz_nodes.row=d3.range(params.matrix.ds_matrix[0].length).map(String);}else{// set ds to null if no downsampling is done
params.viz.ds=null;// instantaneous ds_level (-1 means no downsampling)
params.viz.ds_level=-1;params.viz.ds_num_levels=0;}// console.log('---- after ---------')
// console.log(params.matrix.matrix[0].row_data[0].value)
};/***/},/* 78 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function calc_downsampled_matrix(params,mat,ds_level){var inst_num_rows=params.viz.ds[ds_level].num_rows;var num_compressed_rows=params.network_data.row_nodes.length/inst_num_rows;// increase ds opacity, as more rows are compressed into a single downsampled
// row, increase the opacity of the downsampled row.
var opacity_factor=params.viz.ds_opacity_scale(num_compressed_rows);var mod_val=params.viz.clust.dim.height/inst_num_rows;var ds_mat=[];var inst_obj;var len_ds_array=inst_num_rows+1;var i;var x;// initialize array of objects
for(i=0;i<len_ds_array;i++){inst_obj={};inst_obj.row_index=i;inst_obj.name=String(i);inst_obj.all_names=[];ds_mat.push(inst_obj);}underscore.each(mat,function(inst_row){// row ordering information is contained in y_scale
var inst_y=params.viz.y_scale(inst_row.row_index);var ds_index=Math.round(inst_y/mod_val);var inst_row_data=inst_row.row_data;// gather names
ds_mat[ds_index].all_names.push(inst_row.name);// gather row_data
if(_.has(ds_mat[ds_index],'row_data')){for(x=0;x<inst_row_data.length;x++){ds_mat[ds_index].row_data[x].value=ds_mat[ds_index].row_data[x].value+inst_row_data[x].value;}}else{var new_data=[];for(x=0;x<inst_row_data.length;x++){new_data[x]=inst_row_data[x];}ds_mat[ds_index].row_data=new_data;}});// average the values
underscore.each(ds_mat,function(tmp_ds){var tmp_row_data=tmp_ds.row_data;var num_names=tmp_ds.all_names.length;underscore.each(tmp_row_data,function(tmp_obj){tmp_obj.value=tmp_obj.value/num_names*opacity_factor;});});// all names were found
var all_names=[];underscore.each(ds_mat,function(inst_row){all_names=all_names.concat(inst_row.all_names);});return ds_mat;};/***/},/* 79 *//***/function(module,exports,__webpack_require__){var calc_zoom_switching=__webpack_require__(80);module.exports=function set_zoom_params(params){params.viz.zoom_scale_font={};params.viz.zoom_scale_font.row=1;params.viz.zoom_scale_font.col=1;var max_zoom_limit=0.75;var half_col_height=params.viz.x_scale.rangeBand()/2;params.viz.square_zoom=params.viz.norm_labels.width.col/half_col_height*max_zoom_limit;params.viz=calc_zoom_switching(params.viz);return params;};/***/},/* 80 *//***/function(module,exports){module.exports=function calc_zoom_switching(viz){var width_by_col=viz.clust.dim.width/viz.num_col_nodes;var height_by_row=viz.clust.dim.height/viz.num_row_nodes;viz.zoom_ratio={};viz.zoom_ratio.x=width_by_col/height_by_row;viz.zoom_ratio.y=1;if(viz.zoom_ratio.x<1){viz.zoom_ratio.y=1/viz.zoom_ratio.x;viz.zoom_ratio.x=1;}return viz;};/***/},/* 81 *//***/function(module,exports){module.exports=function calc_default_fs(params){params.labels.default_fs_row=params.viz.y_scale.rangeBand()*1.01;params.labels.default_fs_col=params.viz.x_scale.rangeBand()*0.87;if(params.labels.default_fs_row>params.labels.max_allow_fs){params.labels.default_fs_row=params.labels.max_allow_fs;}if(params.labels.default_fs_col>params.labels.max_allow_fs){params.labels.default_fs_col=params.labels.max_allow_fs;}return params;};/***/},/* 82 *//***/function(module,exports,__webpack_require__){var calc_cat_params=__webpack_require__(83);var utils=__webpack_require__(2);var colors=__webpack_require__(84);var check_if_value_cats=__webpack_require__(85);var underscore=__webpack_require__(3);module.exports=function make_cat_params(params,viz){var predefined_cat_colors=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var super_string=': ';var tmp_super;var inst_info;var inst_color;viz.show_categories={};viz.all_cats={};viz.cat_names={};viz.cat_info={};// this will hold the information for calculating the opacity of the value
// function
var ini_val_opacity={};ini_val_opacity.row=null;ini_val_opacity.col=null;viz.cat_colors={};viz.cat_colors.value_opacity=ini_val_opacity;var num_colors=0;underscore.each(['row','col'],function(inst_rc){viz.show_categories[inst_rc]=false;viz.all_cats[inst_rc]=[];var tmp_keys=underscore.keys(params.network_data[inst_rc+'_nodes'][0]);tmp_keys=tmp_keys.sort();underscore.each(tmp_keys,function(d){if(d.indexOf('cat-')>=0){viz.show_categories[inst_rc]=true;viz.all_cats[inst_rc].push(d);}});viz.cat_info[inst_rc]=null;if(viz.show_categories[inst_rc]){viz.cat_colors[inst_rc]={};viz.cat_info[inst_rc]={};viz.cat_names[inst_rc]={};underscore.each(viz.all_cats[inst_rc],function(cat_title){var inst_node=params.network_data[inst_rc+'_nodes'][0];// look for title of category in category name
if(typeof inst_node[cat_title]==='string'){if(inst_node[cat_title].indexOf(super_string)>0){tmp_super=inst_node[cat_title].split(super_string)[0];viz.cat_names[inst_rc][cat_title]=tmp_super;}else{viz.cat_names[inst_rc][cat_title]=cat_title;}}else{viz.cat_names[inst_rc][cat_title]=cat_title;}var cat_instances_titles=utils.pluck(params.network_data[inst_rc+'_nodes'],cat_title);var cat_instances=[];underscore.each(cat_instances_titles,function(inst_cat){var new_cat;if(inst_cat.indexOf(': ')>0){new_cat=inst_cat.split(': ')[1];}else{new_cat=inst_cat;}cat_instances.push(new_cat);});var cat_states=underscore.uniq(cat_instances_titles).sort();// check whether all the categories are of value type
inst_info=check_if_value_cats(cat_states);// add histogram to inst_info
if(inst_info.type==='cat_strings'){// remove titles from categories in hist
var cat_hist=underscore.countBy(cat_instances);inst_info.cat_hist=cat_hist;}else{inst_info.cat_hist=null;}// pass info_info object
viz.cat_info[inst_rc][cat_title]=inst_info;viz.cat_colors[inst_rc][cat_title]={};underscore.each(cat_states,function(cat_tmp,inst_index){inst_color=colors.get_random_color(inst_index+num_colors);viz.cat_colors[inst_rc][cat_title][cat_tmp]=inst_color;// hack to get 'Not' categories to not be dark colored
// also doing this for false
if(typeof cat_tmp==='string'){if(cat_tmp.indexOf('Not ')>=0||cat_tmp.indexOf(': false')>0){viz.cat_colors[inst_rc][cat_title][cat_tmp]='#eee';}}num_colors=num_colors+1;});});}if(_.has(params.network_data,'cat_colors')&&predefined_cat_colors===true){viz.cat_colors[inst_rc]=params.network_data.cat_colors[inst_rc];}if(params.sim_mat){// sending row color info to columns since row color info can be updated
viz.cat_colors.col=viz.cat_colors.row;}});viz.cat_colors=viz.cat_colors;viz.cat_colors.opacity=0.6;viz.cat_colors.active_opacity=0.9;viz=calc_cat_params(params,viz);return viz;};/***/},/* 83 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function calc_cat_params(params,viz){var separtion_room;// increase the width of the label container based on the label length
var label_scale=d3.scale.linear().domain([5,15]).range([85,120]).clamp('true');viz.cat_room={};viz.cat_room.symbol_width=12;viz.cat_room.separation=3;underscore.each(['row','col'],function(inst_rc){viz.norm_labels.width[inst_rc]=label_scale(params.labels[inst_rc+'_max_char'])*params[inst_rc+'_label_scale'];viz['num_'+inst_rc+'_nodes']=params.network_data[inst_rc+'_nodes'].length;// if (_.has(config, 'group_level')){
//   config.group_level[inst_rc] = 5;
// }
if(inst_rc==='row'){viz.dendro_room[inst_rc]=viz.dendro_room.symbol_width;}else{viz.dendro_room[inst_rc]=viz.dendro_room.symbol_width+3*viz.uni_margin;}var num_cats=viz.all_cats[inst_rc].length;if(viz.show_categories[inst_rc]){separtion_room=(num_cats-1)*viz.cat_room.separation;var adjusted_cats;if(inst_rc==='row'){adjusted_cats=num_cats+1;}else{adjusted_cats=num_cats;}viz.cat_room[inst_rc]=adjusted_cats*viz.cat_room.symbol_width+separtion_room;}else{// no categories
if(inst_rc=='row'){viz.cat_room[inst_rc]=viz.cat_room.symbol_width;}else{viz.cat_room[inst_rc]=0;}}});return viz;};/***/},/* 84 *//***/function(module,exports){// colors from http://graphicdesign.stackexchange.com/revisions/3815/8
var all_colors;all_colors=["#393b79","#aec7e8","#ff7f0e","#ffbb78","#98df8a","#bcbd22","#404040","#ff9896","#c5b0d5","#8c564b","#1f77b4","#5254a3","#FFDB58","#c49c94","#e377c2","#7f7f7f","#2ca02c","#9467bd","#dbdb8d","#17becf","#637939","#6b6ecf","#9c9ede","#d62728","#8ca252","#8c6d31","#bd9e39","#e7cb94","#843c39","#ad494a","#d6616b","#7b4173","#a55194","#ce6dbd","#de9ed6"];// too light colors
// "#e7969c",
// "#c7c7c7",
// "#f7b6d2",
// "#cedb9c",
// "#9edae5",
function get_default_color(){return'#EEE';}function get_random_color(i){return all_colors[i%get_num_colors()];}function get_num_colors(){return all_colors.length;}module.exports={get_default_color:get_default_color,get_random_color:get_random_color,get_num_colors:get_num_colors};/***/},/* 85 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function check_if_value_cats(cat_states){var tmp_cat=cat_states[0];var has_title=false;var might_have_values=false;var cat_types='cat_strings';var max_abs_val=NaN;var all_values=[];var cat_scale=null;var super_string=': ';if(typeof tmp_cat==='string'){if(tmp_cat.indexOf(super_string)>-1){has_title=true;tmp_cat=tmp_cat.split(super_string)[1];}}if(isNaN(tmp_cat)==false){might_have_values=true;}// check each value for number
if(might_have_values){// the default state is that all are now values, check each one
cat_types='cat_values';underscore.each(cat_states,function(inst_cat){if(has_title){inst_cat=inst_cat.split(super_string)[1];}// checking whether inst_cat is 'not a number'
if(isNaN(inst_cat)===true){cat_types='cat_strings';}else{inst_cat=parseFloat(inst_cat);all_values.push(inst_cat);}});}if(cat_types==='cat_values'){// get absolute value
var max_value=underscore.max(all_values,function(d){return Math.abs(d);});max_abs_val=Math.abs(max_value);cat_scale=d3.scale.linear().domain([0,max_abs_val]).range([0,1]);}var inst_info={};inst_info.type=cat_types;inst_info.max_abs_val=max_abs_val;inst_info.cat_scale=cat_scale;return inst_info;};/***/},/* 86 *//***/function(module,exports){module.exports=function ini_zoom_info(){var zoom_info={};zoom_info.zoom_x=1;zoom_info.zoom_y=1;zoom_info.trans_x=0;zoom_info.trans_y=0;return zoom_info;};/***/},/* 87 *//***/function(module,exports,__webpack_require__){var generate_matrix=__webpack_require__(88);var make_row_label_container=__webpack_require__(99);var make_col_label_container=__webpack_require__(131);var generate_super_labels=__webpack_require__(139);var spillover=__webpack_require__(140);var initialize_resizing=__webpack_require__(151);var ini_doubleclick=__webpack_require__(161);var make_col_cat=__webpack_require__(183);var make_row_cat=__webpack_require__(188);var trim_text=__webpack_require__(146);var make_row_dendro=__webpack_require__(189);var make_col_dendro=__webpack_require__(190);var build_dendro_sliders=__webpack_require__(191);// var build_tree_icon = require('./menus/build_tree_icon');
// var build_filter_icon = require('./menus/build_filter_icon');
var make_row_dendro_spillover=__webpack_require__(194);var underscore=__webpack_require__(3);module.exports=function make_viz(cgm){var params=cgm.params;d3.select(params.viz.viz_wrapper+' svg').remove();var svg_group=d3.select(params.viz.viz_wrapper).append('svg').attr('class','viz_svg').attr('id','svg_'+params.root.replace('#','')).attr('width',params.viz.svg_dim.width).attr('height',params.viz.svg_dim.height).attr('is_zoom',0).attr('stopped_zoom',1);svg_group.append('rect').attr('class','super_background').style('width',params.viz.svg_dim.width).style('height',params.viz.svg_dim.height).style('fill','white');generate_matrix(params,svg_group);make_row_label_container(cgm);if(params.viz.show_dendrogram){make_row_dendro(cgm);make_col_dendro(cgm);make_row_dendro_spillover(cgm);}make_col_label_container(cgm);// initial trim text
if(params.viz.ds_level===-1){underscore.each(['row','col'],function(inst_rc){var inst_fs=Number(d3.select('.'+inst_rc+'_label_group').select('text').style('font-size').replace('px',''));var min_trim_fs=8;if(inst_fs>min_trim_fs){d3.selectAll(params.root+' .'+inst_rc+'_label_group').each(function(){trim_text(params,this,inst_rc);});}});}// make category colorbars
make_row_cat(cgm);if(params.viz.show_categories.col){make_col_cat(cgm);}spillover(cgm);if(params.labels.super_labels){generate_super_labels(params);}// // disable recluster and filter icons
// //////////////////
// // sliders should go above super labels
// build_tree_icon(cgm);
// build_filter_icon(cgm);
build_dendro_sliders(cgm);function border_colors(){var inst_color=params.viz.super_border_color;if(params.viz.is_expand||params.show_viz_border==false){inst_color='white';}return inst_color;}// left border
d3.select(params.viz.viz_svg).append('rect').classed('left_border',true).classed('borders',true).attr('fill',border_colors).attr('width',params.viz.grey_border_width).attr('height',params.viz.svg_dim.height).attr('transform','translate(0,0)');// right border
d3.select(params.viz.viz_svg).append('rect').classed('right_border',true).classed('borders',true).attr('fill',border_colors).attr('width',params.viz.grey_border_width).attr('height',params.viz.svg_dim.height).attr('transform',function(){var inst_offset=params.viz.svg_dim.width-params.viz.grey_border_width;return'translate('+inst_offset+',0)';});// top border
d3.select(params.viz.viz_svg).append('rect').classed('top_border',true).classed('borders',true).attr('fill',border_colors).attr('width',params.viz.svg_dim.width).attr('height',params.viz.grey_border_width).attr('transform',function(){var inst_offset=0;return'translate('+inst_offset+',0)';});// bottom border
d3.select(params.viz.viz_svg).append('rect').classed('bottom_border',true).classed('borders',true).attr('fill',border_colors).attr('width',params.viz.svg_dim.width).attr('height',params.viz.grey_border_width).attr('transform',function(){var inst_offset=params.viz.svg_dim.height-params.viz.grey_border_width;return'translate(0,'+inst_offset+')';});initialize_resizing(cgm);ini_doubleclick(cgm);if(params.viz.do_zoom){d3.select(params.viz.zoom_element).call(params.zoom_behavior);}d3.select(params.viz.zoom_element).on('dblclick.zoom',null);};/***/},/* 88 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);var draw_gridlines=__webpack_require__(89);var add_click_hlight=__webpack_require__(90);var make_matrix_rows=__webpack_require__(91);module.exports=function(params,svg_elem){var network_data=params.network_data;var matrix=[];var clust_container;var clust_group;// append a group that will hold clust_group and position it once
clust_container=svg_elem.append('g').attr('class','clust_container').attr('transform','translate('+params.viz.clust.margin.left+','+params.viz.clust.margin.top+')');clust_group=clust_container.append('g').attr('class','clust_group');// clustergram background rect
clust_group.append('rect').classed('background',true).classed('grey_background',true).style('fill','#eee').style('opacity',0.25).attr('width',params.viz.clust.dim.width).attr('height',params.viz.clust.dim.height);// pass in params and the rows (row_nodes) that need to be made
// in this case all row nodes
// make_matrix_rows(params, params.matrix.matrix, params.network_data.row_nodes_names);
// initialize at ds_level 0
if(params.viz.ds===null){// do not use downsampled matrix
make_matrix_rows(params,params.matrix.matrix,'all',params.viz.ds_level);}else{// use downsampled matrix
make_matrix_rows(params,params.matrix.ds_matrix[0],'all',params.viz.ds_level);}// add callback function to tile group - if one is supplied by the user
if(typeof params.click_tile==='function'){d3.selectAll(params.root+' .tile').on('click',function(d){// export row/col name and value from tile
var tile_info={};tile_info.row=params.network_data.row_nodes[d.pos_y].name;tile_info.col=params.network_data.col_nodes[d.pos_x].name;tile_info.value=d.value;if(utils.has(d,'value_up')){tile_info.value_up=d.value_up;}if(utils.has(d,'value_dn')){tile_info.value_dn=d.value_dn;}if(utils.has(d,'info')){tile_info.info=d.info;}// run the user supplied callback function
params.click_tile(tile_info);add_click_hlight(params,this);});}else{// highlight clicked tile
if(params.tile_click_hlight){d3.selectAll(params.root+' .tile').on('click',function(){add_click_hlight(params,this);});}}// draw grid lines after drawing tiles
var delays={};var duration=0;delays.enter=0;draw_gridlines(params,delays,duration);// Matrix API
return{get_clust_group:function get_clust_group(){return clust_group;},get_matrix:function get_matrix(){return matrix;},get_nodes:function get_nodes(type){if(type==='row'){return network_data.row_nodes;}return network_data.col_nodes;}};};/***/},/* 89 *//***/function(module,exports){// var grid_lines_viz = require('./grid_lines_viz');
// var toggle_grid_lines = require('./toggle_grid_lines');
/* eslint-disable */module.exports=function draw_gridlines(params,delays,duration){// var row_nodes = params.network_data.row_nodes;
// var col_nodes = params.network_data.col_nodes;
// // Fade in new gridlines
// ///////////////////////////
// // append horizontal line groups
// var horz_lines = d3.select(params.root+' .clust_group')
//   .selectAll('.horz_lines')
//   .data(row_nodes, function(d){return d.name;})
//   .enter()
//   .append('g')
//   .attr('class','horz_lines');
// // append vertical line groups
// var vert_lines = d3.select(params.root+' .clust_group')
//   .selectAll('.vert_lines')
//   .data(col_nodes)
//   .enter()
//   .append('g')
//   .attr('class', 'vert_lines');
// grid_lines_viz(params, duration);
// horz_lines
//   .select('line')
//   .attr('opacity',0)
//   .attr('stroke','white')
//   .attr('opacity', 1);
// vert_lines
//   .select('line')
//   .style('stroke', 'white')
//   .attr('opacity',0)
//   .transition().delay(delays.enter).duration(2*duration)
//   .attr('opacity', 1);
// toggle_grid_lines(params);
};/***/},/* 90 *//***/function(module,exports){module.exports=function(params,clicked_rect){// get x position of rectangle
d3.select(clicked_rect).each(function(d){var pos_x=d.pos_x;var pos_y=d.pos_y;d3.selectAll(params.root+' .click_hlight').remove();if(pos_x!=params.matrix.click_hlight_x||pos_y!=params.matrix.click_hlight_y){// save pos_x to params.viz.click_hlight_x
params.matrix.click_hlight_x=pos_x;params.matrix.click_hlight_y=pos_y;// draw the highlighting rectangle as four rectangles
// so that the width and height can be controlled
// separately
var rel_width_hlight=6;var opacity_hlight=0.85;var hlight_width=rel_width_hlight*params.viz.border_width.x;var hlight_height=rel_width_hlight*params.viz.border_width.y;// top highlight
d3.select(clicked_rect.parentNode).append('rect').classed('click_hlight',true).classed('top_hlight',true).attr('width',params.viz.x_scale.rangeBand()).attr('height',hlight_height).attr('fill',params.matrix.hlight_color).attr('transform',function(){return'translate('+params.viz.x_scale(pos_x)+',0)';}).attr('opacity',opacity_hlight);// left highlight
d3.select(clicked_rect.parentNode).append('rect').classed('click_hlight',true).classed('left_hlight',true).attr('width',hlight_width).attr('height',params.viz.y_scale.rangeBand()-hlight_height*0.99).attr('fill',params.matrix.hlight_color).attr('transform',function(){return'translate('+params.viz.x_scale(pos_x)+','+hlight_height*0.99+')';}).attr('opacity',opacity_hlight);// right highlight
d3.select(clicked_rect.parentNode).append('rect').classed('click_hlight',true).classed('right_hlight',true).attr('width',hlight_width).attr('height',params.viz.y_scale.rangeBand()-hlight_height*0.99).attr('fill',params.matrix.hlight_color).attr('transform',function(){var tmp_translate=params.viz.x_scale(pos_x)+params.viz.x_scale.rangeBand()-hlight_width;return'translate('+tmp_translate+','+hlight_height*0.99+')';}).attr('opacity',opacity_hlight);// bottom highlight
d3.select(clicked_rect.parentNode).append('rect').classed('click_hlight',true).classed('bottom_hlight',true).attr('width',function(){return params.viz.x_scale.rangeBand()-1.98*hlight_width;}).attr('height',hlight_height).attr('fill',params.matrix.hlight_color).attr('transform',function(){var tmp_translate_x=params.viz.x_scale(pos_x)+hlight_width*0.99;var tmp_translate_y=params.viz.y_scale.rangeBand()-hlight_height;return'translate('+tmp_translate_x+','+tmp_translate_y+')';}).attr('opacity',opacity_hlight);}else{params.matrix.click_hlight_x=-666;params.matrix.click_hlight_y=-666;}});};/***/},/* 91 *//***/function(module,exports,__webpack_require__){var make_simple_rows=__webpack_require__(92);var d3_tip_custom=__webpack_require__(98);var underscore=__webpack_require__(3);// current matrix can change with downsampling
module.exports=function make_matrix_rows(params,current_matrix){var row_names=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'all';var ds_level=arguments.length>3&&arguments[3]!==undefined?arguments[3]:-1;// defaults
var y_scale=params.viz.y_scale;var make_tip=true;var row_class='row';if(ds_level>=0){y_scale=params.viz.ds[ds_level].y_scale;// do not show tip when rows are downsampled
make_tip=false;row_class='ds'+String(ds_level)+'_row';}if(make_tip){// do not remove tile_tip here
/////////////////////////////////
// make rows in the matrix - add key names to rows in matrix
/////////////////////////////////////////////////////////////
// d3-tooltip - for tiles
var tip=d3_tip_custom().attr('class',function(){var root_tip_selector=params.viz.root_tips.replace('.','');var class_string=root_tip_selector+' d3-tip '+root_tip_selector+'_tile_tip';return class_string;}).style('display','none').direction('nw').offset([0,0]).html(function(d){var inst_value=String(d.value.toFixed(3));var tooltip_string;if(params.keep_orig){var orig_value=String(d.value_orig.toFixed(3));tooltip_string='<p>'+d.row_name+' and '+d.col_name+'</p>'+'<p> normalized value: '+inst_value+'</p>'+'<div> original value: '+orig_value+'</div>';}else{tooltip_string='<p>'+d.row_name+' and '+d.col_name+'</p>'+'<div> value: '+inst_value+'</div>';}return tooltip_string;});}else{tip=null;}// gather a subset of row data from the matrix or use all rows
var matrix_subset=[];if(row_names==='all'){matrix_subset=current_matrix;}else{underscore.each(current_matrix,function(inst_row){if(underscore.contains(row_names,inst_row.name)){matrix_subset.push(inst_row);}});}d3.select(params.root+' .clust_group').selectAll('.row').data(matrix_subset,function(d){return d.name;}).enter().append('g').classed(row_class,true).attr('transform',function(d){return'translate(0,'+y_scale(d.row_index)+')';}).each(function(d){make_simple_rows(params,d,tip,this,ds_level);});if(params.viz.ds_level===-1&&tip!=null){d3.selectAll(params.root+' .row').call(tip);}};/***/},/* 92 *//***/function(module,exports,__webpack_require__){/* eslint-disable */var draw_up_tile=__webpack_require__(93);var draw_dn_tile=__webpack_require__(94);var mouseover_tile=__webpack_require__(95);var mouseout_tile=__webpack_require__(96);var fine_position_tile=__webpack_require__(97);var underscore=__webpack_require__(3);module.exports=function make_simple_rows(params,inst_data,tip,row_selection){var ds_level=arguments.length>4&&arguments[4]!==undefined?arguments[4]:-1;var inp_row_data=inst_data.row_data;var make_tip=true;var rect_height=params.viz.rect_height;if(ds_level>=0){// make_tip = false;
rect_height=params.viz.ds[ds_level].rect_height;}var keep_orig;if(_.has(params.network_data.links[0],'value_orig')){keep_orig=true;}else{keep_orig=false;}var row_values;if(keep_orig===false){// value: remove zero values to make visualization faster
row_values=underscore.filter(inp_row_data,function(num){return num.value!==0;});}else{row_values=inp_row_data;}// generate tiles in the current row
var tile=d3.select(row_selection).selectAll('rect').data(row_values,function(d){return d.col_name;}).enter().append('rect').attr('class','tile row_tile').attr('width',params.viz.rect_width).attr('height',rect_height).style('fill',function(d){// switch the color based on up/dn value
var inst_fill;if(d.value_orig==='NaN'){inst_fill='#000000';}else{inst_fill=d.value>0?params.matrix.tile_colors[0]:params.matrix.tile_colors[1];}return inst_fill;}).style('fill-opacity',function(d){// calculate output opacity using the opacity scale
var inst_opacity;if(d.value_orig==='NaN'){// console.log('found NaN while making tiles');
inst_opacity=0.175;}else{inst_opacity=params.matrix.opacity_scale(Math.abs(d.value));}return inst_opacity;}).attr('transform',function(d){return fine_position_tile(params,d);});if(make_tip){tile.on('mouseover',function(){for(var inst_len=arguments.length,args=Array(inst_len),inst_key=0;inst_key<inst_len;inst_key++){args[inst_key]=arguments[inst_key];}mouseover_tile(params,this,tip,args);}).on('mouseout',function(){mouseout_tile(params,this,tip);});}// // tile circles
// /////////////////////////////
// var tile = d3.select(row_selection)
//   .selectAll('circle')
//   .data(row_values, function(d){ return d.col_name; })
//   .enter()
//   .append('circle')
//   .attr('cx', params.viz.rect_height/2)
//   .attr('cy', params.viz.rect_height/2)
//   .attr('r', params.viz.rect_height/3)
//   .attr('class', 'tile_circle')
//   // .attr('width', params.viz.rect_width/2)
//   // .attr('height', params.viz.rect_height/2)
//   // // switch the color based on up/dn value
//   // .style('fill', function(d) {
//   //   // return d.value > 0 ? params.matrix.tile_colors[0] : params.matrix.tile_colors[1];
//   //   return 'black';
//   // })
//   .on('mouseover', function(...args) {
//       mouseover_tile(params, this, tip, args);
//   })
//   .on('mouseout', function() {
//     mouseout_tile(params, this, tip);
//   })
//   .style('fill-opacity', function(d) {
//     // calculate output opacity using the opacity scale
//     var output_opacity = params.matrix.opacity_scale(Math.abs(d.value));
//     if (output_opacity < 0.3){
//       output_opacity = 0;
//     } else if (output_opacity < 0.6){
//       output_opacity = 0.35;
//     } else {
//       output_opacity = 1;
//     }
//     return output_opacity;
//     // return 0.1;
//   })
//   .attr('transform', function(d) {
//     return fine_position_tile(params, d);
//   });
if(params.matrix.tile_type=='updn'){// value split
var row_split_data=underscore.filter(inp_row_data,function(num){return num.value_up!=0||num.value_dn!=0;});// tile_up
d3.select(row_selection).selectAll('.tile_up').data(row_split_data,function(d){return d.col_name;}).enter().append('path').attr('class','tile_up').attr('d',function(){return draw_up_tile(params);}).attr('transform',function(d){fine_position_tile(params,d);}).style('fill',function(){return params.matrix.tile_colors[0];}).style('fill-opacity',function(d){var inst_opacity=0;if(Math.abs(d.value_dn)>0){inst_opacity=params.matrix.opacity_scale(Math.abs(d.value_up));}return inst_opacity;}).on('mouseover',function(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}mouseover_tile(params,this,tip,args);}).on('mouseout',function(){mouseout_tile(params,this,tip);});// tile_dn
d3.select(row_selection).selectAll('.tile_dn').data(row_split_data,function(d){return d.col_name;}).enter().append('path').attr('class','tile_dn').attr('d',function(){return draw_dn_tile(params);}).attr('transform',function(d){fine_position_tile(params,d);}).style('fill',function(){return params.matrix.tile_colors[1];}).style('fill-opacity',function(d){var inst_opacity=0;if(Math.abs(d.value_up)>0){inst_opacity=params.matrix.opacity_scale(Math.abs(d.value_dn));}return inst_opacity;}).on('mouseover',function(){for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}mouseover_tile(params,this,tip,args);}).on('mouseout',function(){mouseout_tile(params,this,tip);});// remove rect when tile is split
tile.each(function(d){if(Math.abs(d.value_up)>0&&Math.abs(d.value_dn)>0){d3.select(this).remove();}});}// append title to group
if(params.matrix.tile_title){tile.append('title').text(function(d){var inst_string='value: '+d.value;return inst_string;});}};/***/},/* 93 *//***/function(module,exports){module.exports=function draw_up_tile(params){var start_x=0;var final_x=params.viz.x_scale.rangeBand()-params.viz.border_width.x;var start_y=0;var final_y=params.viz.y_scale.rangeBand()-params.viz.border_width.y;var output_string='M'+start_x+','+start_y+' L'+start_x+', '+final_y+' L'+final_x+',0 Z';return output_string;};/***/},/* 94 *//***/function(module,exports){module.exports=function draw_dn_tile(params){var start_x=0;var final_x=params.viz.x_scale.rangeBand()-params.viz.border_width.x;var start_y=params.viz.y_scale.rangeBand()-params.viz.border_width.y;var final_y=params.viz.y_scale.rangeBand()-params.viz.border_width.y;var output_string='M'+start_x+', '+start_y+'   L'+final_x+', '+final_y+' L'+final_x+',0 Z';return output_string;};/***/},/* 95 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function mouseover_tile(params,inst_selection,tip,inst_arguments){var inst_data=inst_arguments[0];var args=[].slice.call(inst_arguments);var timeout;var delay=1000;d3.select(inst_selection).classed('hovering',true);underscore.each(['row','col'],function(inst_rc){d3.selectAll(params.root+' .'+inst_rc+'_label_group text').style('font-weight',function(d){var font_weight;var inst_found=inst_data[inst_rc+'_name'].replace(/_/g,' ')===d.name;if(inst_found){font_weight='bold';}else{font_weight='normal';}return font_weight;});});args.push(inst_selection);clearTimeout(timeout);timeout=setTimeout(check_if_hovering,delay,inst_selection);function check_if_hovering(){if(d3.select(inst_selection).classed('hovering')){var inst_zoom=Number(d3.select(params.root+' .viz_svg').attr('is_zoom'));if(inst_zoom===0){if(params.matrix.show_tile_tooltips&&tip!==null){d3.selectAll(params.viz.root_tips+'_tile_tip').style('display','block');tip.show.apply(inst_selection,args);if(params.tile_tip_callback!=null){var tile_info=args[0];params.tile_tip_callback(tile_info);}}}}}};/***/},/* 96 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function mouseout_tile(params,inst_selection,tip){d3.select(inst_selection).classed('hovering',false);d3.selectAll(params.viz.root_tips+'_tile_tip').style('display','none');underscore.each(['row','col'],function(inst_rc){d3.selectAll(params.root+' .'+inst_rc+'_label_group text').style('font-weight','normal');});if(tip!=null){tip.hide();}};/***/},/* 97 *//***/function(module,exports){module.exports=function fine_position_tile(params,d){var offset_x;// prevent rows not in x_scale domain from causing errors
if(d.pos_x in params.viz.x_scale.domain()){offset_x=params.viz.x_scale(d.pos_x);}else{offset_x=0;}var x_pos=offset_x+0.5*params.viz.border_width.x;var y_pos=0.5*params.viz.border_width.y;return'translate('+x_pos+','+y_pos+')';};/***/},/* 98 *//***/function(module,exports){module.exports=function d3_tip_custom(){/* eslint-disable */// Copyright (c) 2013 Justin Palmer
//
// Tooltips for d3.js SVG visualizations
// Public - contructs a new tooltip
//
// Returns a tip
// ******************
// Nick Fernandez modified version 4-19-2016
// improved multiple svg, scrolling+zooming support
// made syntax fixes
//////////////////////////////////////////////
var direction=d3_tip_direction,offset=d3_tip_offset,html=d3_tip_html,node=initNode(),svg=null,point=null,target=null;function tip(vis){svg=getSVGNode(vis);point=svg.createSVGPoint();document.body.appendChild(node);}// Public - show the tooltip on the screen
//
// Returns a tip
tip.show=function(){var args=Array.prototype.slice.call(arguments);if(args[args.length-1]instanceof SVGElement){target=args.pop();}var content=html.apply(this,args);var poffset=offset.apply(this,args);var dir=direction.apply(this,args);var nodel=d3.select(node);var i=0;var coords;// add z-index to make sure tooltips appear on top
nodel.html(content).style({opacity:1,'pointer-events':'all'}).style('z-index',99);while(i--){nodel.classed(directions[i],false);}coords=direction_callbacks.get(dir).apply(this);nodel.classed(dir,true).style({top:coords.top+poffset[0]+'px',left:coords.left+poffset[1]+'px'});// quick fix for fading tile tooltips
if(isFunction(this)===false){var inst_class=d3.select(this).attr('class');if(inst_class.indexOf('tile')>=0){setTimeout(fade_tips,5000,this);}}return tip;};// Public - hide the tooltip
//
// Returns a tip
tip.hide=function(){// // hide all d3-tip tooltips
// d3.selectAll('.d3-tip')
//   .style('display', 'none');
var nodel=d3.select(node);nodel.style({opacity:0,'pointer-events':'none'});return tip;};// Public: Proxy attr calls to the d3 tip container.  Sets or gets attribute value.
//
// n - name of the attribute
// v - value of the attribute
//
// Returns tip or attribute value
tip.attr=function(n){if(arguments.length<2&&typeof n==='string'){return d3.select(node).attr(n);}else{var args=Array.prototype.slice.call(arguments);d3.selection.prototype.attr.apply(d3.select(node),args);}return tip;};// Public: Proxy style calls to the d3 tip container.  Sets or gets a style value.
//
// n - name of the property
// v - value of the property
//
// Returns tip or style property value
tip.style=function(n){if(arguments.length<2&&typeof n==='string'){return d3.select(node).style(n);}else{var args=Array.prototype.slice.call(arguments);d3.selection.prototype.style.apply(d3.select(node),args);}return tip;};// Public: Set or get the direction of the tooltip
//
// v - One of n(north), s(south), e(east), or w(west), nw(northwest),
//     sw(southwest), ne(northeast) or se(southeast)
//
// Returns tip or direction
tip.direction=function(v){if(!arguments.length){return direction;}direction=v==null?v:d3.functor(v);return tip;};// Public: Sets or gets the offset of the tip
//
// v - Array of [x, y] offset
//
// Returns offset or
tip.offset=function(v){if(!arguments.length){return offset;}offset=v==null?v:d3.functor(v);return tip;};// Public: sets or gets the html value of the tooltip
//
// v - String value of the tip
//
// Returns html value or tip
tip.html=function(v){if(!arguments.length){return html;}html=v==null?v:d3.functor(v);return tip;};function d3_tip_direction(){return'n';}function d3_tip_offset(){return[0,0];}function d3_tip_html(){return' ';}var direction_callbacks=d3.map({n:direction_n,s:direction_s,e:direction_e,w:direction_w,nw:direction_nw,ne:direction_ne,sw:direction_sw,se:direction_se,south_custom:direction_south_custom}),directions=direction_callbacks.keys();function direction_south_custom(){var bbox=getScreenBBox();return{top:bbox.s.y,left:bbox.s.x};}function direction_n(){var bbox=getScreenBBox();return{top:bbox.n.y-node.offsetHeight,left:bbox.n.x-node.offsetWidth/2};}function direction_s(){var bbox=getScreenBBox();return{top:bbox.s.y,left:bbox.s.x-node.offsetWidth/2};}function direction_e(){var bbox=getScreenBBox();return{top:bbox.e.y-node.offsetHeight/2,left:bbox.e.x};}function direction_w(){var bbox=getScreenBBox();return{top:bbox.w.y-node.offsetHeight/2,left:bbox.w.x-node.offsetWidth};}function direction_nw(){var bbox=getScreenBBox();return{top:bbox.nw.y-node.offsetHeight,left:bbox.nw.x-node.offsetWidth};}function direction_ne(){var bbox=getScreenBBox();return{top:bbox.ne.y-node.offsetHeight,left:bbox.ne.x};}function direction_sw(){var bbox=getScreenBBox();return{top:bbox.sw.y,left:bbox.sw.x-node.offsetWidth};}function direction_se(){var bbox=getScreenBBox();return{top:bbox.se.y,left:bbox.e.x};}function initNode(){var node=d3.select(document.createElement('div'));node.style({position:'absolute',opacity:0,pointerEvents:'none',boxSizing:'border-box'});return node.node();}function getSVGNode(el){el=el.node();if(el.tagName.toLowerCase()=='svg'){return el;}return el.ownerSVGElement;}// Private - gets the screen coordinates of a shape
//
// Given a shape on the screen, will return an SVGPoint for the directions
// n(north), s(south), e(east), w(west), ne(northeast), se(southeast), nw(northwest),
// sw(southwest).
//
//    +-+-+
//    |   |
//    +   +
//    |   |
//    +-+-+
//
// Returns an Object {n, s, e, w, nw, sw, ne, se}
function getScreenBBox(){var targetel=target||d3.event.target;var bbox={};var matrix=targetel.getScreenCTM();var tbbox=targetel.getBBox();var width=tbbox.width;var height=tbbox.height;var x=tbbox.x;var y=tbbox.y;var scrollTop=document.documentElement.scrollTop||document.body.scrollTop;var scrollLeft=document.documentElement.scrollLeft||document.body.scrollLeft;// Nick - prevents bugs with scrolling and zooming on the same object
matrix.a=1;matrix.d=1;// changing order of adding scrolling,
// original ordering was causing problems with pre-translated or rotated
// elements.
matrix.e=matrix.e+scrollLeft;matrix.f=matrix.f+scrollTop;point.x=x;//+ scrollLeft
point.y=y;//+ scrollTop
bbox.nw=point.matrixTransform(matrix);point.x=point.x+width;bbox.ne=point.matrixTransform(matrix);point.y=point.y+height;bbox.se=point.matrixTransform(matrix);point.x=point.x-width;bbox.sw=point.matrixTransform(matrix);point.y=point.y-height/2;bbox.w=point.matrixTransform(matrix);point.x=point.x+width;bbox.e=point.matrixTransform(matrix);point.x=point.x-width/2;point.y=point.y-height/2;bbox.n=point.matrixTransform(matrix);point.y=point.y+height;bbox.s=point.matrixTransform(matrix);return bbox;}// only fade tips if you are still hovering on the current tip
function fade_tips(inst_selection){var is_hovering=d3.select(inst_selection).classed('hovering');if(is_hovering){d3.selectAll('.d3-tip').transition().duration(250).style('opacity',0).style('display','none');}}function isFunction(functionToCheck){var getType={};return functionToCheck&&getType.toString.call(functionToCheck)==='[object Function]';}return tip;};/***/},/* 99 *//***/function(module,exports,__webpack_require__){var make_row_labels=__webpack_require__(100);module.exports=function make_row_label_container(cgm,text_delay){var params=cgm.params;var row_container;// row container holds all row text and row visualizations (triangles rects)
////////////////////////////////////////////////////////////////////////////
if(d3.select(params.viz.viz_svg+' .row_container').empty()){row_container=d3.select(params.viz.viz_svg).append('g').classed('row_container',true).attr('transform','translate('+params.viz.norm_labels.margin.left+','+params.viz.clust.margin.top+')');}else{row_container=d3.select(params.viz.viz_svg).select('.row_container').attr('transform','translate('+params.viz.norm_labels.margin.left+','+params.viz.clust.margin.top+')');}if(d3.select(params.root+' .row_white_background').empty()){row_container.append('rect').classed('row_white_background',true).classed('white_bars',true).attr('fill',params.viz.background_color).attr('width',params.viz.label_background.row).attr('height',30*params.viz.clust.dim.height+'px');}// add container to hold text row labels if not already there
if(d3.select(params.root+' .row_label_container').empty()){row_container.append('g').classed('row_label_container',true).attr('transform','translate('+params.viz.norm_labels.width.row+',0)').append('g').classed('row_label_zoom_container',true);}else{row_container.select(params.root+' .row_label_container').attr('transform','translate('+params.viz.norm_labels.width.row+',0)');}// make row labels in the container
///////////////////////////////////////
if(params.viz.ds_level===-1){make_row_labels(cgm,'all',text_delay);}};/***/},/* 100 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);var add_row_click_hlight=__webpack_require__(101);var row_reorder=__webpack_require__(102);var make_row_tooltips=__webpack_require__(130);var underscore=__webpack_require__(3);module.exports=function make_row_labels(cgm){var row_names=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'all';var text_delay=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;// console.log('make_row_labels')
// console.log(row_names)
var params=cgm.params;var row_nodes=[];if(row_names==='all'){row_nodes=params.network_data.row_nodes;}else{underscore.each(params.network_data.row_nodes,function(inst_row){// if (_.contains(row_names, inst_row.name)){
if(underscore.contains(row_names,inst_row.name)){row_nodes.push(inst_row);}});}// make row labels in row_label_zoom_container, bind row_nodes data
var row_labels=d3.select(params.root+' .row_label_zoom_container').selectAll('g').data(row_nodes,function(d){return d.name;}).enter().append('g').classed('row_label_group',true);var row_nodes_names=params.network_data.row_nodes_names;row_labels.attr('transform',function(d){// var inst_index = d.row_index;
var inst_index=underscore.indexOf(row_nodes_names,d.name);return'translate(0,'+params.viz.y_scale(inst_index)+')';});row_labels.on('dblclick',function(d){var data_attr='__data__';var row_name=this[data_attr].name;// if (params.sim_mat){
//   row_reorder(cgm, this, row_name);
//   d3.selectAll(params.root+' .col_label_text')
//     .filter(function(d){
//       return d.name == row_name;}
//       )[0][0];
//   // this is causing buggyness may reenable
//   // col_reorder -> two_translate_zoom -> show_visible_area -> make_row_labels -> col_reorder
//   // col_reorder(cgm, col_selection, row_name);
// } else {
//   row_reorder(cgm, this, row_name);
// }
row_reorder(cgm,this,row_name);if(params.tile_click_hlight){add_row_click_hlight(this,d.ini);}});make_row_tooltips(params);// append rectangle behind text
row_labels.insert('rect').style('opacity',0);// append row label text
row_labels.append('text').attr('y',params.viz.rect_height*0.5+params.labels.default_fs_row*0.35).attr('text-anchor','end').style('font-size',params.labels.default_fs_row+'px').text(function(d){return utils.normal_name(d);}).attr('pointer-events','none').style('opacity',0).style('cursor','default').transition().delay(text_delay).duration(text_delay).style('opacity',1);// change the size of the highlighting rects
row_labels.each(function(){var bbox=d3.select(this).select('text')[0][0].getBBox();d3.select(this).select('rect').attr('x',bbox.x).attr('y',0).attr('width',bbox.width).attr('height',params.viz.y_scale.rangeBand()).style('fill',function(){var inst_hl='yellow';return inst_hl;}).style('opacity',function(d){var inst_opacity=0;// highlight target genes
if(d.target===1){inst_opacity=1;}return inst_opacity;});});// almost-deprecated row value bars
///////////////////////////////
if(utils.has(params.network_data.row_nodes[0],'value')){row_labels.append('rect').classed('row_bars',true).attr('width',function(d){var inst_value=0;inst_value=params.labels.bar_scale_row(Math.abs(d.value));return inst_value;}).attr('x',function(d){var inst_value=0;inst_value=-params.labels.bar_scale_row(Math.abs(d.value));return inst_value;}).attr('height',params.viz.y_scale.rangeBand()).attr('fill',function(d){return d.value>0?params.matrix.bar_colors[0]:params.matrix.bar_colors[1];}).attr('opacity',0.4);}};/***/},/* 101 *//***/function(module,exports){module.exports=function(params,clicked_row,id_clicked_row){if(id_clicked_row!=params.click_hlight_row){var rel_width_hlight=6;var opacity_hlight=0.85;var hlight_height=rel_width_hlight*params.viz.border_width.x;d3.selectAll(params.root+' .click_hlight').remove();// // highlight selected row
// d3.selectAll(params.root+' .row_label_group')
//   .select('rect')
// d3.select(this)
//   .select('rect')
//   .style('opacity', 1);
d3.select(clicked_row).append('rect').classed('click_hlight',true).classed('row_top_hlight',true).attr('width',params.viz.svg_dim.width).attr('height',hlight_height).attr('fill',params.matrix.hlight_color).attr('opacity',opacity_hlight);d3.select(clicked_row).append('rect').classed('click_hlight',true).classed('row_bottom_hlight',true).attr('width',params.viz.svg_dim.width).attr('height',hlight_height).attr('fill',params.matrix.hlight_color).attr('opacity',opacity_hlight).attr('transform',function(){var tmp_translate_y=params.viz.y_scale.rangeBand()-hlight_height;return'translate(0,'+tmp_translate_y+')';});}else{d3.selectAll(params.root+' .click_hlight').remove();params.click_hlight_row=-666;}};/***/},/* 102 *//***/function(module,exports,__webpack_require__){var reposition_tile_highlight=__webpack_require__(103);var toggle_dendro_view=__webpack_require__(104);var ini_zoom_info=__webpack_require__(86);var get_previous_zoom=__webpack_require__(129);var calc_downsampled_levels=__webpack_require__(77);var underscore=__webpack_require__(3);module.exports=function row_reorder(cgm,row_selection,inst_row){var params=cgm.params;var prev_zoom=get_previous_zoom(params);if(prev_zoom.zoom_y===1&&prev_zoom.zoom_x===1){params.viz.inst_order.row='custom';toggle_dendro_view(cgm,'col');d3.selectAll(params.root+' .toggle_col_order .btn').classed('active',false);params.viz.run_trans=true;var mat=$.extend(true,{},params.matrix.matrix);var row_nodes=params.network_data.row_nodes;var col_nodes=params.network_data.col_nodes;// find the index of the row
var tmp_arr=[];row_nodes.forEach(function(node){tmp_arr.push(node.name);});// find index
inst_row=underscore.indexOf(tmp_arr,inst_row);// gather the values of the input genes
tmp_arr=[];col_nodes.forEach(function(node,index){tmp_arr.push(mat[inst_row].row_data[index].value);});// sort the rows
var tmp_sort=d3.range(tmp_arr.length).sort(function(a,b){return tmp_arr[b]-tmp_arr[a];});// resort cols (cols are reorderd by double clicking a row)
params.viz.x_scale.domain(tmp_sort);// save to custom col order
params.matrix.orders.custom_row=tmp_sort;// reorder matrix
////////////////////
var t;if(params.network_data.links.length>params.matrix.def_large_matrix){t=d3.select(params.root+' .viz_svg');}else{t=d3.select(params.root+' .viz_svg').transition().duration(2500);}var col_nodes_names=params.network_data.col_nodes_names;// Move Col Labels
t.select('.col_zoom_container').selectAll('.col_label_text').attr('transform',function(d){var inst_index=underscore.indexOf(col_nodes_names,d.name);return'translate('+params.viz.x_scale(inst_index)+')rotate(-90)';});// reorder col_class groups
t.selectAll('.col_cat_group').attr('transform',function(d){var inst_index=underscore.indexOf(col_nodes_names,d.name);return'translate('+params.viz.x_scale(inst_index)+',0)';});// reorder tiles in matrix (do not change row order)
if(params.viz.ds_level===-1){t.selectAll('.tile').attr('transform',function(d){return'translate('+params.viz.x_scale(d.pos_x)+',0)';});t.selectAll('.tile_up').attr('transform',function(d){return'translate('+params.viz.x_scale(d.pos_x)+',0)';});t.selectAll('.tile_dn').attr('transform',function(d){return'translate('+params.viz.x_scale(d.pos_x)+',0)';});}// highlight selected row
///////////////////////////////
// unhilight and unbold all columns (already unbolded earlier)
d3.selectAll(params.root+' .row_label_group').select('rect').style('opacity',0);// highlight column name
d3.select(row_selection).select('rect').style('opacity',1);reposition_tile_highlight(params);// redefine x and y positions
params.network_data.links.forEach(function(d){d.x=params.viz.x_scale(d.target);d.y=params.viz.y_scale(d.source);});params.zoom_info=ini_zoom_info();setTimeout(function(){params.viz.run_trans=false;},2500);// calculate downsmapling if necessary
if(params.viz.ds_num_levels>0&&params.viz.ds_level>=0){calc_downsampled_levels(params);// var zooming_stopped = true;
// var zooming_out = true;
// var make_all_rows = true;
// // show_visible_area is also run with two_translate_zoom, but at that point
// // the parameters were not updated and two_translate_zoom if only run
// // if needed to reset zoom
// show_visible_area(cgm, zooming_stopped, zooming_out, make_all_rows);
}}};/***/},/* 103 *//***/function(module,exports){module.exports=function(params){// resize click hlight
var rel_width_hlight=6;// var opacity_hlight = 0.85;
var hlight_width=rel_width_hlight*params.viz.border_width.x;var hlight_height=rel_width_hlight*params.viz.border_width.y;// reposition tile highlight
////////////////////////////////
// top highlight
d3.select(params.root+' .top_hlight').attr('width',params.viz.x_scale.rangeBand()).attr('height',hlight_height).transition().duration(2500).attr('transform',function(){return'translate('+params.viz.x_scale(params.matrix.click_hlight_x)+',0)';});// left highlight
d3.select(params.root+' .left_hlight').attr('width',hlight_width).attr('height',params.viz.y_scale.rangeBand()-hlight_height*0.99).transition().duration(2500).attr('transform',function(){return'translate('+params.viz.x_scale(params.matrix.click_hlight_x)+','+hlight_height*0.99+')';});// right highlight
d3.select(params.root+' .right_hlight').attr('width',hlight_width).attr('height',params.viz.y_scale.rangeBand()-hlight_height*0.99).transition().duration(2500).attr('transform',function(){var tmp_translate=params.viz.x_scale(params.matrix.click_hlight_x)+params.viz.x_scale.rangeBand()-hlight_width;return'translate('+tmp_translate+','+hlight_height*0.99+')';});// bottom highlight
d3.select(params.root+' .bottom_hlight').attr('width',function(){return params.viz.x_scale.rangeBand()-1.98*hlight_width;}).attr('height',hlight_height).transition().duration(2500).attr('transform',function(){var tmp_translate_x=params.viz.x_scale(params.matrix.click_hlight_x)+hlight_width*0.99;var tmp_translate_y=params.viz.y_scale.rangeBand()-hlight_height;return'translate('+tmp_translate_x+','+tmp_translate_y+')';});};/***/},/* 104 *//***/function(module,exports,__webpack_require__){var make_dendro_triangles=__webpack_require__(105);module.exports=function toggle_dendro_view(cgm,inst_rc){var wait_time=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1500;var params=cgm.params;// row and col are reversed
if(inst_rc==='row'){if(params.viz.inst_order.col==='clust'){// the last true tells the viz that I'm chaning group size and not to
// delay the change in dendro
setTimeout(make_dendro_triangles,wait_time,cgm,'row',true);}}if(inst_rc==='col'){if(params.viz.inst_order.row==='clust'){setTimeout(make_dendro_triangles,wait_time,cgm,'col',true);}}if(params.viz.inst_order.row!='clust'&&params.viz.dendro_filter.col===false){d3.selectAll(params.root+' .col_dendro_group').style('opacity',0).on('mouseover',null).on('mouseout',null);d3.select(params.root+' .col_slider_group').style('opacity',0);// toggle crop buttons
d3.selectAll(params.root+' .col_dendro_crop_buttons').style('opacity',0).on('mouseover',null).on('mouseout',null);}if(params.viz.inst_order.col!='clust'&&params.viz.dendro_filter.row===false){d3.selectAll(params.root+' .row_dendro_group').style('opacity',0).on('mouseover',null).on('mouseout',null).on('click',null);d3.select(params.root+' .row_slider_group').style('opacity',0);// toggle crop buttons
d3.selectAll(params.root+' .row_dendro_crop_buttons').style('opacity',0).on('mouseover',null).on('mouseout',null);}};/***/},/* 105 *//***/function(module,exports,__webpack_require__){var calc_row_dendro_triangles=__webpack_require__(106);var calc_col_dendro_triangles=__webpack_require__(107);var dendro_group_highlight=__webpack_require__(108);var d3_tip_custom=__webpack_require__(98);var make_dendro_crop_buttons=__webpack_require__(110);var make_cat_breakdown_graph=__webpack_require__(113);module.exports=function make_dendro_triangles(cgm,inst_rc){var is_change_group=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var params=cgm.params;// in case sim_mat
if(inst_rc==='both'){inst_rc='row';}var other_rc;if(inst_rc==='row'){other_rc='col';}else{other_rc='row';}// orders are switched!
if(params.viz.inst_order[other_rc]==='clust'){d3.select(params.root+' .'+inst_rc+'_slider_group').style('opacity',1);}var dendro_info;if(params.viz.show_dendrogram){if(inst_rc==='row'){dendro_info=calc_row_dendro_triangles(params);}else{dendro_info=calc_col_dendro_triangles(params);}if(d3.select(cgm.params.root+' .'+inst_rc+'_dendro_crop_buttons').empty()===false){make_dendro_crop_buttons(cgm,inst_rc);}}// constant dendrogram opacity
var inst_dendro_opacity=params.viz.dendro_opacity;function still_hovering(inst_selection,inst_data,i){if(d3.select(inst_selection).classed('hovering')){// define where graph should be built
var inst_selector=params.viz.root_tips+'_'+inst_rc+'_dendro_tip';// prevent mouseover from making multiple graphs
if(d3.select(inst_selector+' .cat_graph').empty()){if(params.viz.cat_info[inst_rc]!==null){make_cat_breakdown_graph(params,inst_rc,inst_data,dendro_info[i],inst_selector,true);}}d3.selectAll(params.viz.root_tips+'_'+inst_rc+'_dendro_tip').style('opacity',1);}}var wait_before_tooltip=500;// remove any old dendro tooltips from this visualization
d3.selectAll(cgm.params.viz.root_tips+'_'+inst_rc+'_dendro_tip').remove();// run transition rules
var run_transition;if(d3.selectAll(params.root+' .'+inst_rc+'_dendro_group').empty()){run_transition=false;}else{run_transition=true;d3.selectAll(params.root+' .'+inst_rc+'_dendro_group').remove();// d3.selectAll(params.root+' .dendro_tip').remove();
}// d3-tooltip
var tmp_y_offset=0;var tmp_x_offset=-5;var dendro_tip=d3_tip_custom().attr('class',function(){// add root element to class
var root_tip_selector=params.viz.root_tips.replace('.','');var class_string=root_tip_selector+' d3-tip '+root_tip_selector+'_'+inst_rc+'_dendro_tip';return class_string;}).direction('nw').offset([tmp_y_offset,tmp_x_offset]).style('display','none').style('opacity',0);dendro_tip.html(function(){var full_string='<div class="cluster_info_container"></div>Click for cluster information <br>'+'and additional options.';return full_string;});if(is_change_group){run_transition=false;}var dendro_traps=d3.select(params.root+' .'+inst_rc+'_dendro_container').selectAll('path').data(dendro_info,function(d){return d.name;}).enter().append('path').style('opacity',0).attr('class',inst_rc+'_dendro_group').style('fill','black');// draw triangles (shown as trapezoids)
//////////////////////////////////////////
var start_x;var start_y;var mid_x;var mid_y;var final_x;var final_y;// row triangles
dendro_traps.attr('d',function(d){if(inst_rc==='row'){// row triangles
start_x=0;start_y=d.pos_top;mid_x=30;mid_y=d.pos_mid;final_x=0;final_y=d.pos_bot;}else{// column triangles
start_x=d.pos_top;start_y=0;mid_x=d.pos_mid;mid_y=30;final_x=d.pos_bot;final_y=0;}var output_string='M'+start_x+','+start_y+' L'+mid_x+', '+mid_y+' L'+final_x+','+final_y+' Z';return output_string;});dendro_traps.on('mouseover',function(d,i){// if (params.sim_mat){
//   inst_rc = 'both';
// }
// run instantly on mouseover
d3.select(this).classed('hovering',true);if(cgm.params.dendro_callback!=null){cgm.params.dendro_callback(this);}// display tip
// this is needed for it to show in the right place and the opacity
// will be toggled to delay the tooltip for the user
d3.select(params.viz.root_tips+'_'+inst_rc+'_dendro_tip').style('display','block');dendro_group_highlight(params,this,d,inst_rc);// show the tip (make sure it is displaying before it is shown)
dendro_tip.show(d);// set opacity to zero
d3.select(params.viz.root_tips+'_'+inst_rc+'_dendro_tip').style('opacity',0);// check if still hovering
setTimeout(still_hovering,wait_before_tooltip,this,d,i);}).on('mouseout',function(){if(params.viz.inst_order[other_rc]==='clust'){d3.select(this).style('opacity',inst_dendro_opacity);}d3.selectAll(params.root+' .dendro_shadow').remove();d3.select(this).classed('hovering',false);dendro_tip.hide(this);}).on('click',function(d,i){$(params.root+' .dendro_info').modal('toggle');var group_string=d.all_names.join(', ');d3.select(params.root+' .dendro_info input').attr('value',group_string);var inst_selector=params.root+' .dendro_info';// remove old graphs (modals are not within params.root)
d3.selectAll('.dendro_info .cluster_info_container .cat_graph').remove();if(params.viz.cat_info[inst_rc]!==null){make_cat_breakdown_graph(params,inst_rc,d,dendro_info[i],inst_selector);}if(cgm.params.dendro_click_callback!=null){cgm.params.dendro_click_callback(this);}}).call(dendro_tip);var triangle_opacity;if(params.viz.inst_order[other_rc]==='clust'){triangle_opacity=inst_dendro_opacity;}else{triangle_opacity=0;}if(run_transition){d3.select(params.root+' .'+inst_rc+'_dendro_container').selectAll('path').transition().delay(1000).duration(1000).style('opacity',triangle_opacity);}else{d3.select(params.root+' .'+inst_rc+'_dendro_container').selectAll('path').style('opacity',triangle_opacity);}};/***/},/* 106 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function calc_row_dendro_triangles(params){var triangle_info={};var inst_level=params.group_level.row;var row_nodes=params.network_data.row_nodes;var row_nodes_names=params.network_data.row_nodes_names;underscore.each(row_nodes,function(d){// console.log('row_node '+d.name)
var tmp_group=d.group[inst_level];var inst_index=underscore.indexOf(row_nodes_names,d.name);var inst_top=params.viz.y_scale(inst_index);var inst_bot=inst_top+params.viz.y_scale.rangeBand();if(underscore.has(triangle_info,tmp_group)===false){triangle_info[tmp_group]={};triangle_info[tmp_group].name_top=d.name;triangle_info[tmp_group].name_bot=d.name;triangle_info[tmp_group].pos_top=inst_top;triangle_info[tmp_group].pos_bot=inst_bot;triangle_info[tmp_group].pos_mid=(inst_top+inst_bot)/2;triangle_info[tmp_group].name=tmp_group;triangle_info[tmp_group].all_names=[];triangle_info[tmp_group].inst_rc='row';}triangle_info[tmp_group].all_names.push(d.name);if(inst_top<triangle_info[tmp_group].pos_top){triangle_info[tmp_group].name_top=d.name;triangle_info[tmp_group].pos_top=inst_top;triangle_info[tmp_group].pos_mid=(inst_top+triangle_info[tmp_group].pos_bot)/2;}if(inst_bot>triangle_info[tmp_group].pos_bot){triangle_info[tmp_group].name_bot=d.name;triangle_info[tmp_group].pos_bot=inst_bot;triangle_info[tmp_group].pos_mid=(triangle_info[tmp_group].pos_top+inst_bot)/2;}});var group_info=[];underscore.each(triangle_info,function(d){group_info.push(d);});return group_info;};/***/},/* 107 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function calc_col_dendro_triangles(params){var triangle_info={};var inst_level=params.group_level.col;var col_nodes=params.network_data.col_nodes;var col_nodes_names=params.network_data.col_nodes_names;underscore.each(col_nodes,function(d){var tmp_group=d.group[inst_level];var inst_index=underscore.indexOf(col_nodes_names,d.name);var inst_top=params.viz.x_scale(inst_index);var inst_bot=inst_top+params.viz.x_scale.rangeBand();if(underscore.has(triangle_info,tmp_group)===false){triangle_info[tmp_group]={};triangle_info[tmp_group].name_top=d.name;triangle_info[tmp_group].name_bot=d.name;triangle_info[tmp_group].pos_top=inst_top;triangle_info[tmp_group].pos_bot=inst_bot;triangle_info[tmp_group].pos_mid=(inst_top+inst_bot)/2;triangle_info[tmp_group].name=tmp_group;triangle_info[tmp_group].all_names=[];triangle_info[tmp_group].inst_rc='col';}triangle_info[tmp_group].all_names.push(d.name);if(inst_top<triangle_info[tmp_group].pos_top){triangle_info[tmp_group].name_top=d.name;triangle_info[tmp_group].pos_top=inst_top;triangle_info[tmp_group].pos_mid=(inst_top+triangle_info[tmp_group].pos_bot)/2;}if(inst_bot>triangle_info[tmp_group].pos_bot){triangle_info[tmp_group].name_bot=d.name;triangle_info[tmp_group].pos_bot=inst_bot;triangle_info[tmp_group].pos_mid=(triangle_info[tmp_group].pos_top+inst_bot)/2;}});var group_info=[];underscore.each(triangle_info,function(d){group_info.push(d);});return group_info;};/***/},/* 108 *//***/function(module,exports,__webpack_require__){var dendro_shade_bars=__webpack_require__(109);module.exports=function dendro_group_highlight(params,inst_selection,inst_data,inst_rc){// only make shadows if there is more than one crop button
if(d3.selectAll(params.root+' .'+inst_rc+'_dendro_crop_buttons')[0].length>1){setTimeout(still_hovering,500);}else{d3.selectAll(params.root+' .dendro_shadow').remove();}function still_hovering(){// check that user is still hovering over dendrogram group
if(d3.select(inst_selection).classed('hovering')){// check that user is not using dendrogram slider
if(params.is_slider_drag===false){d3.select(inst_selection).style('opacity',0.7);if(d3.select(params.viz.viz_svg).classed('running_update')===false){make_shadow_bars();}}}}function make_shadow_bars(){if(inst_rc==='row'){// row and col labling are reversed
if(params.viz.inst_order.col==='clust'){dendro_shade_bars(params,inst_selection,inst_rc,inst_data);}}else if(inst_rc==='col'){// row and col labeling are reversed
if(params.viz.inst_order.row==='clust'){dendro_shade_bars(params,inst_selection,inst_rc,inst_data);}}else if(inst_rc==='both'){if(params.viz.inst_order.col==='clust'){dendro_shade_bars(params,inst_selection,'row',inst_data);}if(params.viz.inst_order.row==='clust'){dendro_shade_bars(params,inst_selection,'col',inst_data);}}}};/***/},/* 109 *//***/function(module,exports){module.exports=function dendro_shade_bars(params,inst_selection,inst_rc,inst_data){var inst_opacity=0.2;var bot_height;d3.selectAll(params.root+' .dendro_shadow').remove();if(inst_rc=='row'){// top shade
d3.select(params.root+' .clust_group').append('rect').attr('width',params.viz.clust.dim.width+'px').attr('height',inst_data.pos_top+'px').attr('fill','black').classed('dendro_shadow',true).attr('opacity',inst_opacity);bot_height=params.viz.clust.dim.height-inst_data.pos_bot;// bottom shade
d3.select(params.root+' .clust_group').append('rect').attr('width',params.viz.clust.dim.width+'px').attr('height',bot_height+'px').attr('transform','translate(0,'+inst_data.pos_bot+')').attr('fill','black').classed('dendro_shadow',true).attr('opacity',inst_opacity);}else if(inst_rc==='col'){// top shade
d3.select(params.root+' .clust_group').append('rect').attr('width',inst_data.pos_top+'px').attr('height',params.viz.clust.dim.height+'px').attr('fill','black').classed('dendro_shadow',true).attr('opacity',inst_opacity);// bottom shade
bot_height=params.viz.clust.dim.width-inst_data.pos_bot;d3.select(params.root+' .clust_group').append('rect').attr('width',bot_height+'px').attr('height',params.viz.clust.dim.height+'px').attr('transform','translate('+inst_data.pos_bot+',0)').attr('fill','black').classed('dendro_shadow',true).attr('opacity',inst_opacity);}};/***/},/* 110 *//***/function(module,exports,__webpack_require__){var calc_row_dendro_triangles=__webpack_require__(106);var calc_col_dendro_triangles=__webpack_require__(107);var d3_tip_custom=__webpack_require__(98);var dendro_group_highlight=__webpack_require__(108);var run_dendro_filter=__webpack_require__(111);var zoom_crop_triangles=__webpack_require__(112);module.exports=function make_dendro_crop_buttons(cgm,inst_rc){var params=cgm.params;var button_opacity=params.viz.dendro_opacity*0.60;// information needed to make dendro
var dendro_info;var other_rc;if(inst_rc==='row'){dendro_info=calc_row_dendro_triangles(params);other_rc='col';}else{dendro_info=calc_col_dendro_triangles(params);other_rc='row';}// d3-tooltip
var tmp_y_offset=5;var tmp_x_offset=-5;var dendro_crop_tip=d3_tip_custom().attr('class',function(){var root_tip_selector=params.viz.root_tips.replace('.','');var class_string=root_tip_selector+' d3-tip '+root_tip_selector+'_'+inst_rc+'_dendro_crop_tip';return class_string;}).direction('nw').style('display','none').offset([tmp_y_offset,tmp_x_offset]);var wait_before_tooltip=500;d3.selectAll(params.viz.root_tips+'_'+inst_rc+'_dendro_crop_tip').remove();d3.selectAll(params.root+' .'+inst_rc+'_dendro_crop_buttons').remove();var icons;// position triangles
var start_x;var start_y;var mid_x;var mid_y;var final_x;var final_y;// need to improve to account for zooming
var min_tri_height=45;var scale_down_tri=0.25;var tri_height;var tri_width;var tri_dim;// make crop buttons or undo buttons
var button_class=inst_rc+'_dendro_crop_buttons';if(d3.select(cgm.params.root+' .'+inst_rc+'_dendro_icons_group').classed('ran_filter')===false){// Crop Triangle
//////////////////////////////
icons=d3.select(params.root+' .'+inst_rc+'_dendro_icons_group').selectAll('path').data(dendro_info,function(d){return d.name;}).enter().append('path').classed(button_class,true).attr('d',function(d){// redefine
tri_height=10;tri_width=10;var tmp_height=d.pos_bot-d.pos_top;// Row Dendrogram Crop Triangle
if(inst_rc==='row'){if(tmp_height<min_tri_height){tri_height=tmp_height*scale_down_tri;}// pointing left
start_x=tri_width;start_y=-tri_height;mid_x=0;mid_y=0;final_x=tri_width;final_y=tri_height;tri_dim=tri_height;// Column Dendrogram Crop Triangle
}else{if(tmp_height<min_tri_height){tri_width=tmp_height*scale_down_tri;}// pointing upward
start_x=-tri_width;start_y=tri_height;mid_x=0;mid_y=0;final_x=tri_width;final_y=tri_height;tri_dim=tri_width;}// save triangle height
// d3.select(this)[0][0].__data__.tri_dim = tri_dim;
var data_key='__data__';d3.select(this)[0][0][data_key].tri_dim=tri_dim;var output_string='M'+start_x+','+start_y+' L'+mid_x+', '+mid_y+' L'+final_x+','+final_y+' Z';return output_string;});dendro_crop_tip.html(function(){var full_string='Click to crop cluster';return full_string;});}else{// Undo Triangle
//////////////////////////////
icons=d3.select(params.root+' .'+inst_rc+'_dendro_icons_group').selectAll('path').data(dendro_info,function(d){return d.name;}).enter().append('path').classed(button_class,true).attr('d',function(d){// redefine
tri_height=10;tri_width=12;var tmp_height=d.pos_bot-d.pos_top;if(inst_rc==='row'){if(tmp_height<min_tri_height){tri_height=tmp_height*scale_down_tri;}// pointing right
start_x=0;start_y=-tri_height;mid_x=tri_width;mid_y=0;final_x=0;final_y=tri_height;}else{if(tmp_height<min_tri_height){tri_width=tmp_height*scale_down_tri;}// pointing downward
start_x=-tri_width;start_y=0;mid_x=0;mid_y=tri_height;final_x=tri_width;final_y=0;}// save triangle height
var data_key='__data__';d3.select(this)[0][0][data_key].tri_dim=10;var output_string='M'+start_x+','+start_y+' L'+mid_x+', '+mid_y+' L'+final_x+','+final_y+' Z';return output_string;});dendro_crop_tip.html(function(){var full_string='Click to undo crop';return full_string;});}icons.style('cursor','pointer').style('opacity',function(){var inst_opacity;// if (d3.select(this).classed('hide_crop')){
//   inst_opacity = 0;
// } else {
//   inst_opacity = button_opacity;
// }
inst_opacity=button_opacity;return inst_opacity;}).attr('transform',function(d){var inst_translate;var inst_x;var inst_y;if(inst_rc==='row'){inst_x=params.viz.uni_margin;inst_y=d.pos_mid;}else{inst_x=d.pos_mid;inst_y=params.viz.uni_margin;}inst_translate='translate('+inst_x+','+inst_y+')';return inst_translate;}).on('mouseover',function(d){d3.select(this).classed('hovering',true);dendro_crop_tip.show(d);dendro_group_highlight(params,this,d,inst_rc);// display with zero opacity
d3.selectAll(params.viz.root_tips+'_'+inst_rc+'_dendro_crop_tip').style('opacity',0).style('display','block');// check if still hovering
setTimeout(still_hovering,wait_before_tooltip,this);}).on('mouseout',function(){d3.select(this).classed('hovering',false);d3.selectAll(params.root+' .dendro_shadow').remove();d3.select(this).style('opacity',button_opacity);dendro_crop_tip.hide(this);}).on('click',function(d){// give user visual cue
d3.select(this).style('opacity',0.9).transition().duration(1000).style('opacity',0);// remove dendro shadows when clicked
d3.selectAll(params.root+' .dendro_shadow').remove();/* filter using dendrogram */if(cgm.params.dendro_filter.row===false&&cgm.params.dendro_filter.col===false&&cgm.params.cat_filter.row===false&&cgm.params.cat_filter.col===false){// Run Filtering
///////////////////
// use class as 'global' variable
d3.select(cgm.params.root+' .'+inst_rc+'_dendro_icons_group').attr('transform','translate(0,0), scale(1,1)').classed('ran_filter',true);d3.select(cgm.params.root+' .'+other_rc+'_dendro_icons_group').attr('transform','translate(0,0), scale(1,1)');// do not display dendrogram slider if filtering has been run
d3.select(cgm.params.root+' .'+inst_rc+'_slider_group').style('display','none');// do not display other crop buttons since they are inactive
d3.select(cgm.params.root+' .'+other_rc+'_dendro_icons_container').style('display','none');// do not display brush-crop button if performing dendro crop
d3.select(cgm.params.root+' .crop_button').style('opacity',0.2);}else{// Undo Filtering
///////////////////
// use class as 'global' variable
d3.select(cgm.params.root+' .'+inst_rc+'_dendro_icons_group').attr('transform','translate(0,0), scale(1,1)').classed('ran_filter',false);d3.select(cgm.params.root+' .'+other_rc+'_dendro_icons_group').attr('transform','translate(0,0), scale(1,1)');if(params.viz.inst_order[other_rc]==='clust'){// display slider when cropping has not been done
d3.select(cgm.params.root+' .'+inst_rc+'_slider_group').style('display','block');}// display other crop buttons when cropping has not been done
d3.select(cgm.params.root+' .'+other_rc+'_dendro_icons_container').style('display','block');// display brush-crop button if not performing dendro crop
d3.select(cgm.params.root+' .crop_button').style('opacity',1);}run_dendro_filter(cgm,d,inst_rc);}).call(dendro_crop_tip);// ordering has been reversed
if(params.viz.inst_order[other_rc]!='clust'){// do not display if not in cluster order
d3.select(params.root+' .'+inst_rc+'_dendro_icons_group').selectAll('path').style('display','none');}function still_hovering(inst_selection){if(d3.select(inst_selection).classed('hovering')){// increase opacity
d3.selectAll(params.viz.root_tips+'_'+inst_rc+'_dendro_crop_tip').style('opacity',1).style('display','block');}}zoom_crop_triangles(params,params.zoom_info,inst_rc);};/***/},/* 111 *//***/function(module,exports){module.exports=function run_dendro_filter(cgm,d,inst_rc){var names={};if(cgm.params.dendro_filter.row===false&&cgm.params.dendro_filter.col===false&&cgm.params.cat_filter.row===false&&cgm.params.cat_filter.col===false){d3.select(cgm.params.root+' .'+inst_rc+'_slider_group').style('opacity',0.35).style('pointer-events','none');names[inst_rc]=d.all_names;var tmp_names=cgm.params.network_data[inst_rc+'_nodes_names'];// keep a backup of the inst_view
var inst_row_nodes=cgm.params.network_data.row_nodes;var inst_col_nodes=cgm.params.network_data.col_nodes;cgm.filter_viz_using_names(names);// overwrite with backup of original nodes
cgm.params.inst_nodes.row_nodes=inst_row_nodes;cgm.params.inst_nodes.col_nodes=inst_col_nodes;d3.selectAll(cgm.params.root+' .dendro_shadow').transition().duration(1000).style('opacity',0).remove();// keep the names of all the nodes
cgm.params.dendro_filter[inst_rc]=tmp_names;/* reset filter */}else{names[inst_rc]=cgm.params.dendro_filter[inst_rc];cgm.filter_viz_using_names(names);cgm.params.dendro_filter[inst_rc]=false;}};/***/},/* 112 *//***/function(module,exports){module.exports=function zoom_crop_triangles(params,zoom_info,inst_rc){if(inst_rc==='row'){// transform icons (undo zoom on triangles)
d3.select(params.root+' .row_dendro_icons_group').selectAll('path').attr('transform',function(d){var inst_x=params.viz.uni_margin;var inst_y=d.pos_mid;var curr_zoom=zoom_info.zoom_y;var tri_dim=d3.select(this).data()[0].tri_dim;var inst_zoom=constrain_zoom(curr_zoom,tri_dim);return'translate('+inst_x+','+inst_y+') '+'scale(1, '+1/inst_zoom+')';});}else{// transform icons (undo zoom on triangles)
d3.select(params.root+' .col_dendro_icons_group').selectAll('path').attr('transform',function(d){var inst_x=d.pos_mid;var inst_y=params.viz.uni_margin;var curr_zoom=zoom_info.zoom_x;var tri_dim=d3.select(this).data()[0].tri_dim;var inst_zoom=constrain_zoom(curr_zoom,tri_dim);return'translate('+inst_x+','+inst_y+') '+'scale('+1/inst_zoom+', 1)';});}function constrain_zoom(curr_zoom,tri_height){var inst_zoom;var default_tri_height=10;if(tri_height*curr_zoom<default_tri_height){inst_zoom=1;}else{var max_zoom=default_tri_height/tri_height;inst_zoom=curr_zoom/max_zoom;}return inst_zoom;}};/***/},/* 113 *//***/function(module,exports,__webpack_require__){var calc_cat_cluster_breakdown=__webpack_require__(114);var underscore=__webpack_require__(3);var cat_breakdown_bars=__webpack_require__(127);var cat_breakdown_values=__webpack_require__(128);module.exports=function make_cat_breakdown_graph(params,inst_rc,inst_data,dendro_info,selector){var tooltip=arguments.length>5&&arguments[5]!==undefined?arguments[5]:false;/*
	  This function is used to make the category breakdown graphs for tooltips on
	  dendrogram mousover and on dendrogram click modal popup.
	  */// in case sim_mat
if(inst_rc==='both'){inst_rc='row';}var cat_breakdown=calc_cat_cluster_breakdown(params,inst_data,inst_rc);if(cat_breakdown.length>0){// put cluster information in dendro_tip
///////////////////////////////////////////
var cluster_info_container=d3.select(selector+' .cluster_info_container');// loop through cat_breakdown data
var width=370;var title_height=27;var shift_tooltip_left=177;var bar_offset=23;// these are the indexes where the number-of-nodes and the number of downsampled
// nodes are stored
var num_nodes_index=4;var num_nodes_ds_index=5;var offset_ds_count=150;var is_downsampled=false;if(cat_breakdown[0].bar_data[0][num_nodes_ds_index]!=null){width=width+100;shift_tooltip_left=shift_tooltip_left+offset_ds_count-47;is_downsampled=true;}// the index that will be used to generate the bars (will be different if
// downsampled)
var cluster_total=dendro_info.all_names.length;var bars_index=num_nodes_index;if(is_downsampled){bars_index=num_nodes_ds_index;// calculate the total number of nodes in downsampled case
var inst_bar_data=cat_breakdown[0].bar_data;cluster_total=0;underscore.each(inst_bar_data,function(tmp_data){cluster_total=cluster_total+tmp_data[num_nodes_ds_index];});}// limit on the number of category types shown
var max_cats=3;// limit the number of bars shown
var max_bars=25;// calculate height needed for svg based on cat_breakdown data
var svg_height=20;underscore.each(cat_breakdown.slice(0,max_cats),function(tmp_break){var num_bars=tmp_break.bar_data.length;if(num_bars>max_bars){num_bars=max_bars;}svg_height=svg_height+title_height*(num_bars+1);});// Cluster Information Title (for tooltip only not modal)
if(tooltip){cluster_info_container.append('text').text('Cluster Information');}var main_dendro_svg=cluster_info_container.append('div').style('margin-top','5px').classed('cat_graph',true).append('svg').style('height',svg_height+'px').style('width',width+'px');cluster_info_container.style('margin-bottom','5px');// make background
main_dendro_svg.append('rect').classed('cat_background',true).attr('height',svg_height+'px').attr('width',width+'px').attr('fill','white').attr('opacity',1);// limit the category-types
cat_breakdown=cat_breakdown.slice(0,max_cats);// shift the position of the numbers based on the size of the number
// offset the count column based on how large the counts are
var digit_offset_scale=d3.scale.linear().domain([0,100000]).range([20,30]);// the total amout to shift down the next category
var shift_down=title_height;underscore.each(cat_breakdown,function(cat_data){var max_bar_value=cat_data.bar_data[0][bars_index];var count_offset=digit_offset_scale(max_bar_value);var cat_graph_group=main_dendro_svg.append('g').classed('cat_graph_group',true).attr('transform','translate(10, '+shift_down+')');var cat_bar_container=cat_graph_group.append('g').classed('cat_bar_container',true).attr('transform','translate(0, 10)');// make bar groups (hold bar and text)
var cat_bar_groups=cat_bar_container.selectAll('g').data(cat_data.bar_data).enter().append('g').attr('transform',function(d,i){var inst_y=i*bar_offset;return'translate(0,'+inst_y+')';});cat_breakdown_bars(params,cat_data,cat_graph_group,title_height,bars_index,max_bars,cat_bar_groups);cat_breakdown_values(params,cat_graph_group,cat_bar_groups,num_nodes_index,is_downsampled,count_offset,bars_index,cluster_total);// shift down based on number of bars
shift_down=shift_down+title_height*(cat_data.bar_data.length+1);});// reposition tooltip
/////////////////////////////////////////////////
if(tooltip){var dendro_tip=d3.select(selector);var old_top=dendro_tip.style('top').split('.px')[0];var old_left=dendro_tip.style('left').split('.px')[0];var shift_top=0;var shift_left=0;// shifting
if(inst_rc==='row'){// rows
//////////////
shift_top=0;shift_left=shift_tooltip_left;// // prevent graph from being too high
// if (dendro_info.pos_top < svg_height){
//   // do not shift position of category breakdown graph
//   // shift_top = -(svg_height + (dendro_info.pos_mid - dendro_info.pos_top)/2) ;
// }
}else{// columns
//////////////
shift_top=svg_height+32;shift_left=30;}dendro_tip.style('top',function(){var new_top=String(parseInt(old_top,10)-shift_top)+'px';return new_top;}).style('left',function(){var new_left=String(parseInt(old_left,10)-shift_left)+'px';return new_left;});}}};/***/},/* 114 *//***/function(module,exports,__webpack_require__){var binom_test=__webpack_require__(115);var underscore=__webpack_require__(3);module.exports=function calc_cat_cluster_breakdown(params,inst_data,inst_rc){// Category-breakdown of dendrogram-clusters
/////////////////////////////////////////////
/*
	  1. get information for nodes in cluster
	  2. find category-types that are string-type
	  3. count instances of each category name for each category-type
	  */// in case sim_mat
if(inst_rc==='both'){inst_rc='row';}// 1: get information for nodes in cluster
///////////////////////////////////////////
// names of nodes in cluster
var clust_names=inst_data.all_names;// array of nodes in the cluster
var clust_nodes=[];var all_nodes=params.network_data[inst_rc+'_nodes'];var num_in_clust_index=null;var is_downsampled=false;var inst_name;underscore.each(all_nodes,function(inst_node){inst_name=inst_node.name;if(clust_names.indexOf(inst_name)>=0){clust_nodes.push(inst_node);}});// 2: find category-types that are string-type
///////////////////////////////////////////////
var cat_breakdown=[];if(params.viz.cat_info[inst_rc]!==null){var inst_cat_info=params.viz.cat_info[inst_rc];// tmp list of all categories
var tmp_types_index=underscore.keys(inst_cat_info);// this will hold the indexes of string-type categories
var cat_types_index=[];// get category names (only include string-type categories)
var cat_types_names=[];var type_name;var inst_index;var cat_index;for(var i=0;i<tmp_types_index.length;i++){cat_index='cat-'+String(i);if(params.viz.cat_info[inst_rc][cat_index].type==='cat_strings'){type_name=params.viz.cat_names[inst_rc][cat_index];cat_types_names.push(type_name);cat_types_index.push(cat_index);}else{// save number in clust category index if found
if(params.viz.cat_names[inst_rc][cat_index]==='number in clust'){num_in_clust_index=cat_index;is_downsampled=true;}}}var tmp_run_count={};var inst_breakdown={};var bar_data;var radix_param=10;// sort by actual counts (rather than cluster counts)
var sorting_index=4;if(is_downsampled){sorting_index=5;}var no_title_given;if(type_name===cat_index){no_title_given=true;}else{no_title_given=false;}if(cat_types_names.length>0){// 3: count instances of each category name for each category-type
var cat_name;var num_in_clust=clust_names.length;// use the cat_hist to get the number of instances of this category in
// all rows/cols
// params
underscore.each(cat_types_index,function(cat_index){inst_index=cat_index.split('-')[1];type_name=cat_types_names[inst_index];if(no_title_given){if(cat_index.indexOf('-')>=0){var tmp_num=parseInt(cat_index.split('-')[1],radix_param)+1;type_name='Category '+String(tmp_num);}else{// backup behavior
type_name='Category';}}tmp_run_count[type_name]={};// loop through the nodes and keep a running count of categories
underscore.each(clust_nodes,function(tmp_node){cat_name=tmp_node[cat_index];if(cat_name.indexOf(': ')>=0){cat_name=cat_name.split(': ')[1];}if(cat_name in tmp_run_count[type_name]){tmp_run_count[type_name][cat_name].num_nodes=tmp_run_count[type_name][cat_name].num_nodes+1;if(num_in_clust_index!=null){tmp_run_count[type_name][cat_name].num_nodes_ds=tmp_run_count[type_name][cat_name].num_nodes_ds+parseInt(tmp_node[num_in_clust_index].split(': ')[1],radix_param);}}else{tmp_run_count[type_name][cat_name]={};tmp_run_count[type_name][cat_name].num_nodes=1;if(num_in_clust_index!=null){tmp_run_count[type_name][cat_name].num_nodes_ds=parseInt(tmp_node[num_in_clust_index].split(': ')[1],radix_param);}}});inst_breakdown={};inst_breakdown.type_name=type_name;inst_breakdown.num_in_clust=num_in_clust;// sort cat info in cat_breakdown
bar_data=[];var bar_color;var cat_title_and_name;var inst_run_count=tmp_run_count[type_name];for(var inst_cat in inst_run_count){var tot_num_cat=params.viz.cat_info[inst_rc][cat_index].cat_hist[inst_cat];var total_nodes=params.network_data[inst_rc+'_nodes'].length;var expect_prob=tot_num_cat/total_nodes;// if no cat-title given
if(no_title_given){cat_title_and_name=inst_cat;}else{cat_title_and_name=type_name+': '+inst_cat;}// num_nodes: number of cat-nodes drawn in cluster
var num_nodes=inst_run_count[inst_cat].num_nodes;var actual_k=num_nodes;var pval=binom_test(actual_k,num_in_clust,expect_prob);// working on tracking the 'real' number of nodes, which is only different
// if downsampling has been done
if(_.has(inst_run_count[inst_cat],'num_nodes_ds')){var num_nodes_ds=inst_run_count[inst_cat].num_nodes_ds;}else{num_nodes_ds=null;}bar_color=params.viz.cat_colors[inst_rc][cat_index][cat_title_and_name];bar_data.push([cat_index,cat_title_and_name,inst_run_count[inst_cat],bar_color,num_nodes,num_nodes_ds,pval]);}bar_data.sort(function(a,b){return b[sorting_index]-a[sorting_index];});inst_breakdown.bar_data=bar_data;cat_breakdown.push(inst_breakdown);});}}return cat_breakdown;};/***/},/* 115 *//***/function(module,exports,__webpack_require__){// Load the math.js core
// Create a new, empty math.js instance
// It will only contain methods `import` and `config`
// math.import(require('mathjs/lib/type/fraction'));
var p_dict=__webpack_require__(116);var core=__webpack_require__(13);var math=core.create();math.import(__webpack_require__(117));module.exports=function binom_test(actual_k,n,p){var fact=math.factorial;var pval;function binom_dist(k,n,p){var bin_coeff=fact(n)/(fact(k)*fact(n-k));p=bin_coeff*(Math.pow(p,k)*Math.pow(1-p,n-k));return p;}function my_binom_test_2(actual_k,n,p){var cp=0;var k;var dp;for(var inst_k=actual_k;inst_k<n+1;inst_k++){k=inst_k;dp=binom_dist(k,n,p);cp=cp+dp;}return cp;}// look up p-value from z-score using table
function binom_prop_table(actual_k,n,p){// expected average number of successes
var mu=n*p;// standard deviation
var sigma=Math.sqrt(n*p*(1-p));// how many standard deviations is the actual_k away
// from the expected value
var z=(actual_k-mu)/sigma;var z_vals=p_dict.z;var p_vals=p_dict.p;var found_index=-1;var found=false;for(var index=0;index<z_vals.length;index++){var inst_z=z_vals[index];// increasing inst_z until z is less than inst_z
if(z<inst_z&&found===false){found_index=index;found=true;}}// give it the smallest p-val if the z-score was larger than
// any in the table
if(found_index===-1){found_index=z_vals.length-1;}pval=p_vals[found_index];return pval;}// calculate pval
pval=my_binom_test_2(actual_k,n,p);if(isNaN(pval)){pval=binom_prop_table(actual_k,n,p);}return pval;};/***/},/* 116 *//***/function(module,exports){module.exports={"p":[0.5,0.48006119416162751,0.46017216272297101,0.4403823076297575,0.42074029056089696,0.4012936743170763,0.38208857781104733,0.3631693488243809,0.34457825838967582,0.32635522028791997,0.30853753872598688,0.29115968678834636,0.27425311775007355,0.25784611080586473,0.24196365222307303,0.22662735237686821,0.21185539858339669,0.19766254312269238,0.18406012534675947,0.17105612630848183,0.15865525393145707,0.14685905637589591,0.13566606094638267,0.12507193563715024,0.11506967022170828,0.10564977366685535,0.096800484585610358,0.088507991437401956,0.080756659233771066,0.073529259609648304,0.066807201268858071,0.060570758002059008,0.054799291699557974,0.049471468033648075,0.044565462758543006,0.040059156863817086,0.035930319112925789,0.032156774795613713,0.028716559816001783,0.025588059521638611,0.022750131948179195,0.020182215405704383,0.017864420562816542,0.015777607391090499,0.013903447513498595,0.012224472655044696,0.010724110021675795,0.0093867055348385662,0.0081975359245961138,0.0071428107352714152,0.0062096653257761323,0.0053861459540666843,0.0046611880237187467,0.0040245885427583027,0.0034669738030406647,0.0029797632350545551,0.002555130330427929,0.0021859614549132405,0.0018658133003840339,0.0015888696473648667,0.0013498980316300933,0.0011442068310226977,0.00096760321321835631,0.00081635231282856037,0.00068713793791584708,0.00057702504239076592,0.00048342414238377663,0.0004040578018640207,0.00033692926567687988,0.00028029327681617744,0.00023262907903552502,0.00019261557563563279,0.00015910859015753364,0.00013112015442048433,0.00010779973347738823,8.8417285200803773e-05,7.2348043925119787e-05,5.9058912418922374e-05,4.8096344017602614e-05,3.9075596597787456e-05,3.1671241833119863e-05,2.5608816474041489e-05,2.0657506912546683e-05,1.6623763729652213e-05,1.334574901590631e-05,1.0688525774934402e-05,8.5399054709917942e-06,6.8068765993340312e-06,5.4125439077038407e-06,4.293514469971858e-06,3.3976731247300535e-06,2.6822957796388472e-06,2.1124547025028419e-06,1.6596751443714555e-06,1.3008074539172771e-06,1.0170832425687032e-06,7.9332815197558919e-07,6.1730737200919249e-07,4.7918327659031855e-07,3.7106740796333271e-07,2.8665157187919333e-07,2.2090503226954194e-07,1.6982674071475937e-07,1.3024322953320117e-07,9.9644263169334701e-08,7.6049605164887e-08,5.7901340399645569e-08,4.3977115940058689e-08,3.3320448485428448e-08,2.518491005446105e-08,1.8989562465887681e-08,1.4283479893922661e-08,1.0717590258310852e-08,8.0223918506634739e-09,5.9903714010635304e-09,4.4621724539016108e-09,3.3157459783261365e-09,2.4578650618080152e-09,1.8175078630994235e-09,1.3407124440918662e-09,9.8658764503769458e-10,7.2422917051376055e-10,5.303423262948808e-10,3.8741473466756636e-10,2.8231580370432682e-10,2.0522634252189396e-10,1.4882282217622966e-10,1.0765746385121517e-10,7.7688475817097756e-11,5.592507575942645e-11,4.0160005838590881e-11,2.8768541736043109e-11,2.055788909399508e-11,1.4654650977302715e-11,1.0420976987965154e-11,7.3922577780177942e-12,5.2309575441445253e-12,3.6924994272355614e-12,2.600126965638173e-12,1.8264310619769611e-12,1.279812543885835e-12,8.9458895587698439e-13,6.23784446333152e-13,4.3388950271780343e-13,3.0106279811174218e-13,2.0838581586720548e-13,1.4388386381575764e-13,9.9103427495475088e-14,6.8092248906200155e-14,4.6670115887190274e-14,3.1908916729108844e-14,2.1762912097085575e-14,1.4806537490047908e-14,1.0048965656526223e-14,6.8033115407739012e-15,4.5946274357785623e-15,3.095358771958668e-15,2.0801863521393674e-15,1.394517146659261e-15,9.3255757716812045e-16,6.2209605742717405e-16,4.1397018162731219e-16,2.7479593923982212e-16,1.8196213635266084e-16,1.2019351542735647e-16,7.9197263146424757e-17,5.2055697448902465e-17,3.4131483264581459e-17,2.232393197288031e-17,1.456514112590909e-17,9.4795348222032499e-18,6.1544255908503949e-18,3.985804962848151e-18,2.5749715380118873e-18,1.6594208699647519e-18,1.0667637375474856e-18,6.840807685935497e-19,4.3759647993090167e-19,2.7923343749396233e-19,1.7774117841455144e-19,1.1285884059538324e-19,7.1484170112696837e-20,4.516591491435403e-20,2.8466774084602088e-20,1.7897488120140146e-20,1.1224633591327901e-20,7.0222842404415411e-21,4.3823862990664603e-21,2.7281535713460872e-21,1.6941535024881097e-21,1.0494515075362604e-21,6.4848144530772079e-22,3.9972212057261192e-22,2.4577864834723153e-22,1.5074931688101589e-22,9.2234135249393526e-23,5.6292823113765143e-23,3.4271987941135974e-23,2.0813752194932085e-23,1.2609160670206559e-23],"z":[0.0,0.050000000000000003,0.10000000000000001,0.15000000000000002,0.20000000000000001,0.25,0.30000000000000004,0.35000000000000003,0.40000000000000002,0.45000000000000001,0.5,0.55000000000000004,0.60000000000000009,0.65000000000000002,0.70000000000000007,0.75,0.80000000000000004,0.85000000000000009,0.90000000000000002,0.95000000000000007,1.0,1.05,1.1000000000000001,1.1500000000000001,1.2000000000000002,1.25,1.3,1.3500000000000001,1.4000000000000001,1.4500000000000002,1.5,1.55,1.6000000000000001,1.6500000000000001,1.7000000000000002,1.75,1.8,1.8500000000000001,1.9000000000000001,1.9500000000000002,2.0,2.0500000000000003,2.1000000000000001,2.1499999999999999,2.2000000000000002,2.25,2.3000000000000003,2.3500000000000001,2.4000000000000004,2.4500000000000002,2.5,2.5500000000000003,2.6000000000000001,2.6500000000000004,2.7000000000000002,2.75,2.8000000000000003,2.8500000000000001,2.9000000000000004,2.9500000000000002,3.0,3.0500000000000003,3.1000000000000001,3.1500000000000004,3.2000000000000002,3.25,3.3000000000000003,3.3500000000000001,3.4000000000000004,3.4500000000000002,3.5,3.5500000000000003,3.6000000000000001,3.6500000000000004,3.7000000000000002,3.75,3.8000000000000003,3.8500000000000001,3.9000000000000004,3.9500000000000002,4.0,4.0499999999999998,4.1000000000000005,4.1500000000000004,4.2000000000000002,4.25,4.2999999999999998,4.3500000000000005,4.4000000000000004,4.4500000000000002,4.5,4.5499999999999998,4.6000000000000005,4.6500000000000004,4.7000000000000002,4.75,4.8000000000000007,4.8500000000000005,4.9000000000000004,4.9500000000000002,5.0,5.0500000000000007,5.1000000000000005,5.1500000000000004,5.2000000000000002,5.25,5.3000000000000007,5.3500000000000005,5.4000000000000004,5.4500000000000002,5.5,5.5500000000000007,5.6000000000000005,5.6500000000000004,5.7000000000000002,5.75,5.8000000000000007,5.8500000000000005,5.9000000000000004,5.9500000000000002,6.0,6.0500000000000007,6.1000000000000005,6.1500000000000004,6.2000000000000002,6.25,6.3000000000000007,6.3500000000000005,6.4000000000000004,6.4500000000000002,6.5,6.5500000000000007,6.6000000000000005,6.6500000000000004,6.7000000000000002,6.75,6.8000000000000007,6.8500000000000005,6.9000000000000004,6.9500000000000002,7.0,7.0500000000000007,7.1000000000000005,7.1500000000000004,7.2000000000000002,7.25,7.3000000000000007,7.3500000000000005,7.4000000000000004,7.4500000000000002,7.5,7.5500000000000007,7.6000000000000005,7.6500000000000004,7.7000000000000002,7.75,7.8000000000000007,7.8500000000000005,7.9000000000000004,7.9500000000000002,8.0,8.0500000000000007,8.0999999999999996,8.1500000000000004,8.2000000000000011,8.25,8.3000000000000007,8.3499999999999996,8.4000000000000004,8.4500000000000011,8.5,8.5500000000000007,8.5999999999999996,8.6500000000000004,8.7000000000000011,8.75,8.8000000000000007,8.8499999999999996,8.9000000000000004,8.9500000000000011,9.0,9.0500000000000007,9.0999999999999996,9.1500000000000004,9.2000000000000011,9.25,9.3000000000000007,9.3499999999999996,9.4000000000000004,9.4500000000000011,9.5,9.5500000000000007,9.6000000000000014,9.6500000000000004,9.7000000000000011,9.75,9.8000000000000007,9.8500000000000014,9.9000000000000004,9.9500000000000011]};/***/},/* 117 *//***/function(module,exports,__webpack_require__){var deepMap=__webpack_require__(118);function factory(type,config,load,typed){var gamma=load(__webpack_require__(119));var latex=__webpack_require__(44);/**
	   * Compute the factorial of a value
	   *
	   * Factorial only supports an integer value as argument.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.factorial(n)
	   *
	   * Examples:
	   *
	   *    math.factorial(5);    // returns 120
	   *    math.factorial(3);    // returns 6
	   *
	   * See also:
	   *
	   *    combinations, gamma, permutations
	   *
	   * @param {number | BigNumber | Array | Matrix} n   An integer number
	   * @return {number | BigNumber | Array | Matrix}    The factorial of `n`
	   */var factorial=typed('factorial',{'number':function number(n){if(n<0){throw new Error('Value must be non-negative');}return gamma(n+1);},'BigNumber':function BigNumber(n){if(n.isNegative()){throw new Error('Value must be non-negative');}return gamma(n.plus(1));},'Array | Matrix':function ArrayMatrix(n){return deepMap(n,factorial);}});factorial.toTex={1:'\\left(${args[0]}\\right)'+latex.operators['factorial']};return factorial;}exports.name='factorial';exports.factory=factory;/***/},/* 118 *//***/function(module,exports){module.exports=function deepMap(array,callback,skipZeros){if(array&&typeof array.map==='function'){// TODO: replace array.map with a for loop to improve performance
return array.map(function(x){return deepMap(x,callback,skipZeros);});}else{return callback(array);}};/***/},/* 119 *//***/function(module,exports,__webpack_require__){var deepMap=__webpack_require__(118);var isInteger=__webpack_require__(18).isInteger;function factory(type,config,load,typed){var multiply=load(__webpack_require__(120));var pow=load(__webpack_require__(123));/**
	   * Compute the gamma function of a value using Lanczos approximation for
	   * small values, and an extended Stirling approximation for large values.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.gamma(n)
	   *
	   * Examples:
	   *
	   *    math.gamma(5);       // returns 24
	   *    math.gamma(-0.5);    // returns -3.5449077018110335
	   *    math.gamma(math.i);  // returns -0.15494982830180973 - 0.49801566811835596i
	   *
	   * See also:
	   *
	   *    combinations, factorial, permutations
	   *
	   * @param {number | Array | Matrix} n   A real or complex number
	   * @return {number | Array | Matrix}    The gamma of `n`
	   */var gamma=typed('gamma',{'number':function number(n){var t,x;if(isInteger(n)){if(n<=0){return isFinite(n)?Infinity:NaN;}if(n>171){return Infinity;// Will overflow
}var value=n-2;var res=n-1;while(value>1){res*=value;value--;}if(res==0){res=1;// 0! is per definition 1
}return res;}if(n<0.5){return Math.PI/(Math.sin(Math.PI*n)*gamma(1-n));}if(n>=171.35){return Infinity;// will overflow
}if(n>85.0){// Extended Stirling Approx
var twoN=n*n;var threeN=twoN*n;var fourN=threeN*n;var fiveN=fourN*n;return Math.sqrt(2*Math.PI/n)*Math.pow(n/Math.E,n)*(1+1/(12*n)+1/(288*twoN)-139/(51840*threeN)-571/(2488320*fourN)+163879/(209018880*fiveN)+5246819/(75246796800*fiveN*n));}--n;x=p[0];for(var i=1;i<p.length;++i){x+=p[i]/(n+i);}t=n+g+0.5;return Math.sqrt(2*Math.PI)*Math.pow(t,n+0.5)*Math.exp(-t)*x;},'Complex':function Complex(n){var t,x;if(n.im==0){return gamma(n.re);}n=new type.Complex(n.re-1,n.im);x=new type.Complex(p[0],0);for(var i=1;i<p.length;++i){var real=n.re+i;// x += p[i]/(n+i)
var den=real*real+n.im*n.im;if(den!=0){x.re+=p[i]*real/den;x.im+=-(p[i]*n.im)/den;}else{x.re=p[i]<0?-Infinity:Infinity;}}t=new type.Complex(n.re+g+0.5,n.im);var twoPiSqrt=Math.sqrt(2*Math.PI);n.re+=0.5;var result=pow(t,n);if(result.im==0){// sqrt(2*PI)*result
result.re*=twoPiSqrt;}else if(result.re==0){result.im*=twoPiSqrt;}else{result.re*=twoPiSqrt;result.im*=twoPiSqrt;}var r=Math.exp(-t.re);// exp(-t)
t.re=r*Math.cos(-t.im);t.im=r*Math.sin(-t.im);return multiply(multiply(result,t),x);},'BigNumber':function BigNumber(n){if(n.isInteger()){return n.isNegative()||n.isZero()?new type.BigNumber(Infinity):bigFactorial(n.minus(1));}if(!n.isFinite()){return new type.BigNumber(n.isNegative()?NaN:Infinity);}throw new Error('Integer BigNumber expected');},'Array | Matrix':function ArrayMatrix(n){return deepMap(n,gamma);}});/**
	   * Calculate factorial for a BigNumber
	   * @param {BigNumber} n
	   * @returns {BigNumber} Returns the factorial of n
	   */function bigFactorial(n){if(n.isZero()){return new type.BigNumber(1);// 0! is per definition 1
}var precision=config.precision+(Math.log(n.toNumber())|0);var Big=type.BigNumber.clone({precision:precision});var res=new Big(n);var value=n.toNumber()-1;// number
while(value>1){res=res.times(value);value--;}return new type.BigNumber(res.toPrecision(type.BigNumber.precision));}gamma.toTex={1:'\\Gamma\\left(${args[0]}\\right)'};return gamma;}// TODO: comment on the variables g and p
var g=4.7421875;var p=[0.99999999999999709182,57.156235665862923517,-59.597960355475491248,14.136097974741747174,-0.49191381609762019978,0.33994649984811888699e-4,0.46523628927048575665e-4,-0.98374475304879564677e-4,0.15808870322491248884e-3,-0.21026444172410488319e-3,0.21743961811521264320e-3,-0.16431810653676389022e-3,0.84418223983852743293e-4,-0.26190838401581408670e-4,0.36899182659531622704e-5];exports.name='gamma';exports.factory=factory;/***/},/* 120 *//***/function(module,exports,__webpack_require__){var extend=__webpack_require__(15).extend;var array=__webpack_require__(27);function factory(type,config,load,typed){var latex=__webpack_require__(44);var matrix=load(__webpack_require__(42));var addScalar=load(__webpack_require__(43));var multiplyScalar=load(__webpack_require__(121));var equalScalar=load(__webpack_require__(38));var algorithm11=load(__webpack_require__(122));var algorithm14=load(__webpack_require__(49));var DenseMatrix=type.DenseMatrix;var SparseMatrix=type.SparseMatrix;/**
	   * Multiply two or more values, `x * y`.
	   * For matrices, the matrix product is calculated.
	   *
	   * Syntax:
	   *
	   *    math.multiply(x, y)
	   *    math.multiply(x, y, z, ...)
	   *
	   * Examples:
	   *
	   *    math.multiply(4, 5.2);        // returns number 20.8
	   *    math.multiply(2, 3, 4);       // returns number 24
	   *
	   *    var a = math.complex(2, 3);
	   *    var b = math.complex(4, 1);
	   *    math.multiply(a, b);          // returns Complex 5 + 14i
	   *
	   *    var c = [[1, 2], [4, 3]];
	   *    var d = [[1, 2, 3], [3, -4, 7]];
	   *    math.multiply(c, d);          // returns Array [[7, -6, 17], [13, -4, 33]]
	   *
	   *    var e = math.unit('2.1 km');
	   *    math.multiply(3, e);          // returns Unit 6.3 km
	   *
	   * See also:
	   *
	   *    divide, prod, cross, dot
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to multiply
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to multiply
	   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Multiplication of `x` and `y`
	   */var multiply=typed('multiply',extend({// we extend the signatures of multiplyScalar with signatures dealing with matrices
'Array, Array':function ArrayArray(x,y){// check dimensions
_validateMatrixDimensions(array.size(x),array.size(y));// use dense matrix implementation
var m=multiply(matrix(x),matrix(y));// return array or scalar
return m&&m.isMatrix===true?m.valueOf():m;},'Matrix, Matrix':function MatrixMatrix(x,y){// dimensions
var xsize=x.size();var ysize=y.size();// check dimensions
_validateMatrixDimensions(xsize,ysize);// process dimensions
if(xsize.length===1){// process y dimensions
if(ysize.length===1){// Vector * Vector
return _multiplyVectorVector(x,y,xsize[0]);}// Vector * Matrix
return _multiplyVectorMatrix(x,y);}// process y dimensions
if(ysize.length===1){// Matrix * Vector
return _multiplyMatrixVector(x,y);}// Matrix * Matrix
return _multiplyMatrixMatrix(x,y);},'Matrix, Array':function MatrixArray(x,y){// use Matrix * Matrix implementation
return multiply(x,matrix(y));},'Array, Matrix':function ArrayMatrix(x,y){// use Matrix * Matrix implementation
return multiply(matrix(x,y.storage()),y);},'Matrix, any':function MatrixAny(x,y){// result
var c;// process storage format
switch(x.storage()){case'sparse':c=algorithm11(x,y,multiplyScalar,false);break;case'dense':c=algorithm14(x,y,multiplyScalar,false);break;}return c;},'any, Matrix':function anyMatrix(x,y){// result
var c;// check storage format
switch(y.storage()){case'sparse':c=algorithm11(y,x,multiplyScalar,true);break;case'dense':c=algorithm14(y,x,multiplyScalar,true);break;}return c;},'Array, any':function ArrayAny(x,y){// use matrix implementation
return algorithm14(matrix(x),y,multiplyScalar,false).valueOf();},'any, Array':function anyArray(x,y){// use matrix implementation
return algorithm14(matrix(y),x,multiplyScalar,true).valueOf();},'any, any':multiplyScalar,'any, any, ...any':function anyAnyAny(x,y,rest){var result=multiply(x,y);for(var i=0;i<rest.length;i++){result=multiply(result,rest[i]);}return result;}},multiplyScalar.signatures));var _validateMatrixDimensions=function _validateMatrixDimensions(size1,size2){// check left operand dimensions
switch(size1.length){case 1:// check size2
switch(size2.length){case 1:// Vector x Vector
if(size1[0]!==size2[0]){// throw error
throw new RangeError('Dimension mismatch in multiplication. Vectors must have the same length');}break;case 2:// Vector x Matrix
if(size1[0]!==size2[0]){// throw error
throw new RangeError('Dimension mismatch in multiplication. Vector length ('+size1[0]+') must match Matrix rows ('+size2[0]+')');}break;default:throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix B has '+size2.length+' dimensions)');}break;case 2:// check size2
switch(size2.length){case 1:// Matrix x Vector
if(size1[1]!==size2[0]){// throw error
throw new RangeError('Dimension mismatch in multiplication. Matrix columns ('+size1[1]+') must match Vector length ('+size2[0]+')');}break;case 2:// Matrix x Matrix
if(size1[1]!==size2[0]){// throw error
throw new RangeError('Dimension mismatch in multiplication. Matrix A columns ('+size1[1]+') must match Matrix B rows ('+size2[0]+')');}break;default:throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix B has '+size2.length+' dimensions)');}break;default:throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix A has '+size1.length+' dimensions)');}};/**
	   * C = A * B
	   *
	   * @param {Matrix} a            Dense Vector   (N)
	   * @param {Matrix} b            Dense Vector   (N)
	   *
	   * @return {number}             Scalar value
	   */var _multiplyVectorVector=function _multiplyVectorVector(a,b,n){// check empty vector
if(n===0)throw new Error('Cannot multiply two empty vectors');// a dense
var adata=a._data;var adt=a._datatype;// b dense
var bdata=b._data;var bdt=b._datatype;// datatype
var dt;// addScalar signature to use
var af=addScalar;// multiplyScalar signature to use
var mf=multiplyScalar;// process data types
if(adt&&bdt&&adt===bdt&&typeof adt==='string'){// datatype
dt=adt;// find signatures that matches (dt, dt)
af=typed.find(addScalar,[dt,dt]);mf=typed.find(multiplyScalar,[dt,dt]);}// result (do not initialize it with zero)
var c=mf(adata[0],bdata[0]);// loop data
for(var i=1;i<n;i++){// multiply and accumulate
c=af(c,mf(adata[i],bdata[i]));}return c;};/**
	   * C = A * B
	   *
	   * @param {Matrix} a            Dense Vector   (M)
	   * @param {Matrix} b            Matrix         (MxN)
	   *
	   * @return {Matrix}             Dense Vector   (N)
	   */var _multiplyVectorMatrix=function _multiplyVectorMatrix(a,b){// process storage
switch(b.storage()){case'dense':return _multiplyVectorDenseMatrix(a,b);}throw new Error('Not implemented');};/**
	   * C = A * B
	   *
	   * @param {Matrix} a            Dense Vector   (M)
	   * @param {Matrix} b            Dense Matrix   (MxN)
	   *
	   * @return {Matrix}             Dense Vector   (N)
	   */var _multiplyVectorDenseMatrix=function _multiplyVectorDenseMatrix(a,b){// a dense
var adata=a._data;var asize=a._size;var adt=a._datatype;// b dense
var bdata=b._data;var bsize=b._size;var bdt=b._datatype;// rows & columns
var alength=asize[0];var bcolumns=bsize[1];// datatype
var dt;// addScalar signature to use
var af=addScalar;// multiplyScalar signature to use
var mf=multiplyScalar;// process data types
if(adt&&bdt&&adt===bdt&&typeof adt==='string'){// datatype
dt=adt;// find signatures that matches (dt, dt)
af=typed.find(addScalar,[dt,dt]);mf=typed.find(multiplyScalar,[dt,dt]);}// result
var c=[];// loop matrix columns
for(var j=0;j<bcolumns;j++){// sum (do not initialize it with zero)
var sum=mf(adata[0],bdata[0][j]);// loop vector
for(var i=1;i<alength;i++){// multiply & accumulate
sum=af(sum,mf(adata[i],bdata[i][j]));}c[j]=sum;}// return matrix
return new DenseMatrix({data:c,size:[bcolumns],datatype:dt});};/**
	   * C = A * B
	   *
	   * @param {Matrix} a            Matrix         (MxN)
	   * @param {Matrix} b            Dense Vector   (N)
	   *
	   * @return {Matrix}             Dense Vector   (M)
	   */var _multiplyMatrixVector=function _multiplyMatrixVector(a,b){// process storage
switch(a.storage()){case'dense':return _multiplyDenseMatrixVector(a,b);case'sparse':return _multiplySparseMatrixVector(a,b);}};/**
	   * C = A * B
	   *
	   * @param {Matrix} a            Matrix         (MxN)
	   * @param {Matrix} b            Matrix         (NxC)
	   *
	   * @return {Matrix}             Matrix         (MxC)
	   */var _multiplyMatrixMatrix=function _multiplyMatrixMatrix(a,b){// process storage
switch(a.storage()){case'dense':// process storage
switch(b.storage()){case'dense':return _multiplyDenseMatrixDenseMatrix(a,b);case'sparse':return _multiplyDenseMatrixSparseMatrix(a,b);}break;case'sparse':// process storage
switch(b.storage()){case'dense':return _multiplySparseMatrixDenseMatrix(a,b);case'sparse':return _multiplySparseMatrixSparseMatrix(a,b);}break;}};/**
	   * C = A * B
	   *
	   * @param {Matrix} a            DenseMatrix  (MxN)
	   * @param {Matrix} b            Dense Vector (N)
	   *
	   * @return {Matrix}             Dense Vector (M)
	   */var _multiplyDenseMatrixVector=function _multiplyDenseMatrixVector(a,b){// a dense
var adata=a._data;var asize=a._size;var adt=a._datatype;// b dense
var bdata=b._data;var bdt=b._datatype;// rows & columns
var arows=asize[0];var acolumns=asize[1];// datatype
var dt;// addScalar signature to use
var af=addScalar;// multiplyScalar signature to use
var mf=multiplyScalar;// process data types
if(adt&&bdt&&adt===bdt&&typeof adt==='string'){// datatype
dt=adt;// find signatures that matches (dt, dt)
af=typed.find(addScalar,[dt,dt]);mf=typed.find(multiplyScalar,[dt,dt]);}// result
var c=[];// loop matrix a rows
for(var i=0;i<arows;i++){// current row
var row=adata[i];// sum (do not initialize it with zero)
var sum=mf(row[0],bdata[0]);// loop matrix a columns
for(var j=1;j<acolumns;j++){// multiply & accumulate
sum=af(sum,mf(row[j],bdata[j]));}c[i]=sum;}// return matrix
return new DenseMatrix({data:c,size:[arows],datatype:dt});};/**
	   * C = A * B
	   *
	   * @param {Matrix} a            DenseMatrix    (MxN)
	   * @param {Matrix} b            DenseMatrix    (NxC)
	   *
	   * @return {Matrix}             DenseMatrix    (MxC)
	   */var _multiplyDenseMatrixDenseMatrix=function _multiplyDenseMatrixDenseMatrix(a,b){// a dense
var adata=a._data;var asize=a._size;var adt=a._datatype;// b dense
var bdata=b._data;var bsize=b._size;var bdt=b._datatype;// rows & columns
var arows=asize[0];var acolumns=asize[1];var bcolumns=bsize[1];// datatype
var dt;// addScalar signature to use
var af=addScalar;// multiplyScalar signature to use
var mf=multiplyScalar;// process data types
if(adt&&bdt&&adt===bdt&&typeof adt==='string'){// datatype
dt=adt;// find signatures that matches (dt, dt)
af=typed.find(addScalar,[dt,dt]);mf=typed.find(multiplyScalar,[dt,dt]);}// result
var c=[];// loop matrix a rows
for(var i=0;i<arows;i++){// current row
var row=adata[i];// initialize row array
c[i]=[];// loop matrix b columns
for(var j=0;j<bcolumns;j++){// sum (avoid initializing sum to zero)
var sum=mf(row[0],bdata[0][j]);// loop matrix a columns
for(var x=1;x<acolumns;x++){// multiply & accumulate
sum=af(sum,mf(row[x],bdata[x][j]));}c[i][j]=sum;}}// return matrix
return new DenseMatrix({data:c,size:[arows,bcolumns],datatype:dt});};/**
	   * C = A * B
	   *
	   * @param {Matrix} a            DenseMatrix    (MxN)
	   * @param {Matrix} b            SparseMatrix   (NxC)
	   *
	   * @return {Matrix}             SparseMatrix   (MxC)
	   */var _multiplyDenseMatrixSparseMatrix=function _multiplyDenseMatrixSparseMatrix(a,b){// a dense
var adata=a._data;var asize=a._size;var adt=a._datatype;// b sparse
var bvalues=b._values;var bindex=b._index;var bptr=b._ptr;var bsize=b._size;var bdt=b._datatype;// validate b matrix
if(!bvalues)throw new Error('Cannot multiply Dense Matrix times Pattern only Matrix');// rows & columns
var arows=asize[0];var bcolumns=bsize[1];// datatype
var dt;// addScalar signature to use
var af=addScalar;// multiplyScalar signature to use
var mf=multiplyScalar;// equalScalar signature to use
var eq=equalScalar;// zero value
var zero=0;// process data types
if(adt&&bdt&&adt===bdt&&typeof adt==='string'){// datatype
dt=adt;// find signatures that matches (dt, dt)
af=typed.find(addScalar,[dt,dt]);mf=typed.find(multiplyScalar,[dt,dt]);eq=typed.find(equalScalar,[dt,dt]);// convert 0 to the same datatype
zero=typed.convert(0,dt);}// result
var cvalues=[];var cindex=[];var cptr=[];// c matrix
var c=new SparseMatrix({values:cvalues,index:cindex,ptr:cptr,size:[arows,bcolumns],datatype:dt});// loop b columns
for(var jb=0;jb<bcolumns;jb++){// update ptr
cptr[jb]=cindex.length;// indeces in column jb
var kb0=bptr[jb];var kb1=bptr[jb+1];// do not process column jb if no data exists
if(kb1>kb0){// last row mark processed
var last=0;// loop a rows
for(var i=0;i<arows;i++){// column mark
var mark=i+1;// C[i, jb]
var cij;// values in b column j
for(var kb=kb0;kb<kb1;kb++){// row
var ib=bindex[kb];// check value has been initialized
if(last!==mark){// first value in column jb
cij=mf(adata[i][ib],bvalues[kb]);// update mark
last=mark;}else{// accumulate value
cij=af(cij,mf(adata[i][ib],bvalues[kb]));}}// check column has been processed and value != 0
if(last===mark&&!eq(cij,zero)){// push row & value
cindex.push(i);cvalues.push(cij);}}}}// update ptr
cptr[bcolumns]=cindex.length;// return sparse matrix
return c;};/**
	   * C = A * B
	   *
	   * @param {Matrix} a            SparseMatrix    (MxN)
	   * @param {Matrix} b            Dense Vector (N)
	   *
	   * @return {Matrix}             SparseMatrix    (M, 1)
	   */var _multiplySparseMatrixVector=function _multiplySparseMatrixVector(a,b){// a sparse
var avalues=a._values;var aindex=a._index;var aptr=a._ptr;var adt=a._datatype;// validate a matrix
if(!avalues)throw new Error('Cannot multiply Pattern only Matrix times Dense Matrix');// b dense
var bdata=b._data;var bdt=b._datatype;// rows & columns
var arows=a._size[0];var brows=b._size[0];// result
var cvalues=[];var cindex=[];var cptr=[];// datatype
var dt;// addScalar signature to use
var af=addScalar;// multiplyScalar signature to use
var mf=multiplyScalar;// equalScalar signature to use
var eq=equalScalar;// zero value
var zero=0;// process data types
if(adt&&bdt&&adt===bdt&&typeof adt==='string'){// datatype
dt=adt;// find signatures that matches (dt, dt)
af=typed.find(addScalar,[dt,dt]);mf=typed.find(multiplyScalar,[dt,dt]);eq=typed.find(equalScalar,[dt,dt]);// convert 0 to the same datatype
zero=typed.convert(0,dt);}// workspace
var x=[];// vector with marks indicating a value x[i] exists in a given column
var w=[];// update ptr
cptr[0]=0;// rows in b
for(var ib=0;ib<brows;ib++){// b[ib]
var vbi=bdata[ib];// check b[ib] != 0, avoid loops
if(!eq(vbi,zero)){// A values & index in ib column
for(var ka0=aptr[ib],ka1=aptr[ib+1],ka=ka0;ka<ka1;ka++){// a row
var ia=aindex[ka];// check value exists in current j
if(!w[ia]){// ia is new entry in j
w[ia]=true;// add i to pattern of C
cindex.push(ia);// x(ia) = A
x[ia]=mf(vbi,avalues[ka]);}else{// i exists in C already
x[ia]=af(x[ia],mf(vbi,avalues[ka]));}}}}// copy values from x to column jb of c
for(var p1=cindex.length,p=0;p<p1;p++){// row
var ic=cindex[p];// copy value
cvalues[p]=x[ic];}// update ptr
cptr[1]=cindex.length;// return sparse matrix
return new SparseMatrix({values:cvalues,index:cindex,ptr:cptr,size:[arows,1],datatype:dt});};/**
	   * C = A * B
	   *
	   * @param {Matrix} a            SparseMatrix      (MxN)
	   * @param {Matrix} b            DenseMatrix       (NxC)
	   *
	   * @return {Matrix}             SparseMatrix      (MxC)
	   */var _multiplySparseMatrixDenseMatrix=function _multiplySparseMatrixDenseMatrix(a,b){// a sparse
var avalues=a._values;var aindex=a._index;var aptr=a._ptr;var adt=a._datatype;// validate a matrix
if(!avalues)throw new Error('Cannot multiply Pattern only Matrix times Dense Matrix');// b dense
var bdata=b._data;var bdt=b._datatype;// rows & columns
var arows=a._size[0];var brows=b._size[0];var bcolumns=b._size[1];// datatype
var dt;// addScalar signature to use
var af=addScalar;// multiplyScalar signature to use
var mf=multiplyScalar;// equalScalar signature to use
var eq=equalScalar;// zero value
var zero=0;// process data types
if(adt&&bdt&&adt===bdt&&typeof adt==='string'){// datatype
dt=adt;// find signatures that matches (dt, dt)
af=typed.find(addScalar,[dt,dt]);mf=typed.find(multiplyScalar,[dt,dt]);eq=typed.find(equalScalar,[dt,dt]);// convert 0 to the same datatype
zero=typed.convert(0,dt);}// result
var cvalues=[];var cindex=[];var cptr=[];// c matrix
var c=new SparseMatrix({values:cvalues,index:cindex,ptr:cptr,size:[arows,bcolumns],datatype:dt});// workspace
var x=[];// vector with marks indicating a value x[i] exists in a given column
var w=[];// loop b columns
for(var jb=0;jb<bcolumns;jb++){// update ptr
cptr[jb]=cindex.length;// mark in workspace for current column
var mark=jb+1;// rows in jb
for(var ib=0;ib<brows;ib++){// b[ib, jb]
var vbij=bdata[ib][jb];// check b[ib, jb] != 0, avoid loops
if(!eq(vbij,zero)){// A values & index in ib column
for(var ka0=aptr[ib],ka1=aptr[ib+1],ka=ka0;ka<ka1;ka++){// a row
var ia=aindex[ka];// check value exists in current j
if(w[ia]!==mark){// ia is new entry in j
w[ia]=mark;// add i to pattern of C
cindex.push(ia);// x(ia) = A
x[ia]=mf(vbij,avalues[ka]);}else{// i exists in C already
x[ia]=af(x[ia],mf(vbij,avalues[ka]));}}}}// copy values from x to column jb of c
for(var p0=cptr[jb],p1=cindex.length,p=p0;p<p1;p++){// row
var ic=cindex[p];// copy value
cvalues[p]=x[ic];}}// update ptr
cptr[bcolumns]=cindex.length;// return sparse matrix
return c;};/**
	   * C = A * B
	   *
	   * @param {Matrix} a            SparseMatrix      (MxN)
	   * @param {Matrix} b            SparseMatrix      (NxC)
	   *
	   * @return {Matrix}             SparseMatrix      (MxC)
	   */var _multiplySparseMatrixSparseMatrix=function _multiplySparseMatrixSparseMatrix(a,b){// a sparse
var avalues=a._values;var aindex=a._index;var aptr=a._ptr;var adt=a._datatype;// b sparse
var bvalues=b._values;var bindex=b._index;var bptr=b._ptr;var bdt=b._datatype;// rows & columns
var arows=a._size[0];var bcolumns=b._size[1];// flag indicating both matrices (a & b) contain data
var values=avalues&&bvalues;// datatype
var dt;// addScalar signature to use
var af=addScalar;// multiplyScalar signature to use
var mf=multiplyScalar;// process data types
if(adt&&bdt&&adt===bdt&&typeof adt==='string'){// datatype
dt=adt;// find signatures that matches (dt, dt)
af=typed.find(addScalar,[dt,dt]);mf=typed.find(multiplyScalar,[dt,dt]);}// result
var cvalues=values?[]:undefined;var cindex=[];var cptr=[];// c matrix
var c=new SparseMatrix({values:cvalues,index:cindex,ptr:cptr,size:[arows,bcolumns],datatype:dt});// workspace
var x=values?[]:undefined;// vector with marks indicating a value x[i] exists in a given column
var w=[];// variables
var ka,ka0,ka1,kb,kb0,kb1,ia,ib;// loop b columns
for(var jb=0;jb<bcolumns;jb++){// update ptr
cptr[jb]=cindex.length;// mark in workspace for current column
var mark=jb+1;// B values & index in j
for(kb0=bptr[jb], kb1=bptr[jb+1], kb=kb0;kb<kb1;kb++){// b row
ib=bindex[kb];// check we need to process values
if(values){// loop values in a[:,ib]
for(ka0=aptr[ib], ka1=aptr[ib+1], ka=ka0;ka<ka1;ka++){// row
ia=aindex[ka];// check value exists in current j
if(w[ia]!==mark){// ia is new entry in j
w[ia]=mark;// add i to pattern of C
cindex.push(ia);// x(ia) = A
x[ia]=mf(bvalues[kb],avalues[ka]);}else{// i exists in C already
x[ia]=af(x[ia],mf(bvalues[kb],avalues[ka]));}}}else{// loop values in a[:,ib]
for(ka0=aptr[ib], ka1=aptr[ib+1], ka=ka0;ka<ka1;ka++){// row
ia=aindex[ka];// check value exists in current j
if(w[ia]!==mark){// ia is new entry in j
w[ia]=mark;// add i to pattern of C
cindex.push(ia);}}}}// check we need to process matrix values (pattern matrix)
if(values){// copy values from x to column jb of c
for(var p0=cptr[jb],p1=cindex.length,p=p0;p<p1;p++){// row
var ic=cindex[p];// copy value
cvalues[p]=x[ic];}}}// update ptr
cptr[bcolumns]=cindex.length;// return sparse matrix
return c;};multiply.toTex={2:'\\left(${args[0]}'+latex.operators['multiply']+'${args[1]}\\right)'};return multiply;}exports.name='multiply';exports.factory=factory;/***/},/* 121 *//***/function(module,exports){function factory(type,config,load,typed){/**
	   * Multiply two scalar values, `x * y`.
	   * This function is meant for internal use: it is used by the public function
	   * `multiply`
	   *
	   * This function does not support collections (Array or Matrix), and does
	   * not validate the number of of inputs.
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to multiply
	   * @param  {number | BigNumber | Fraction | Complex} y          Second value to multiply
	   * @return {number | BigNumber | Fraction | Complex | Unit}                      Multiplication of `x` and `y`
	   * @private
	   */var multiplyScalar=typed('multiplyScalar',{'number, number':function numberNumber(x,y){return x*y;},'Complex, Complex':function ComplexComplex(x,y){return x.mul(y);},'BigNumber, BigNumber':function BigNumberBigNumber(x,y){return x.times(y);},'Fraction, Fraction':function FractionFraction(x,y){return x.mul(y);},'number | Fraction | BigNumber | Complex, Unit':function numberFractionBigNumberComplexUnit(x,y){var res=y.clone();res.value=res.value===null?res._normalize(x):multiplyScalar(res.value,x);return res;},'Unit, number | Fraction | BigNumber | Complex':function UnitNumberFractionBigNumberComplex(x,y){var res=x.clone();res.value=res.value===null?res._normalize(y):multiplyScalar(res.value,y);return res;},'Unit, Unit':function UnitUnit(x,y){return x.multiply(y);}});return multiplyScalar;}exports.factory=factory;/***/},/* 122 *//***/function(module,exports,__webpack_require__){function factory(type,config,load,typed){var equalScalar=load(__webpack_require__(38));var SparseMatrix=type.SparseMatrix;/**
	   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
	   * Callback function invoked NZ times (number of nonzero items in S).
	   *
	   *
	   *          ┌  f(Sij, b)  ; S(i,j) !== 0
	   * C(i,j) = ┤
	   *          └  0          ; otherwise
	   *
	   *
	   * @param {Matrix}   s                 The SparseMatrix instance (S)
	   * @param {Scalar}   b                 The Scalar value
	   * @param {Function} callback          The f(Aij,b) operation to invoke
	   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
	   *
	   * @return {Matrix}                    SparseMatrix (C)
	   *
	   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
	   */var algorithm11=function algorithm11(s,b,callback,inverse){// sparse matrix arrays
var avalues=s._values;var aindex=s._index;var aptr=s._ptr;var asize=s._size;var adt=s._datatype;// sparse matrix cannot be a Pattern matrix
if(!avalues)throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');// rows & columns
var rows=asize[0];var columns=asize[1];// datatype
var dt;// equal signature to use
var eq=equalScalar;// zero value
var zero=0;// callback signature to use
var cf=callback;// process data types
if(typeof adt==='string'){// datatype
dt=adt;// find signature that matches (dt, dt)
eq=typed.find(equalScalar,[dt,dt]);// convert 0 to the same datatype
zero=typed.convert(0,dt);// convert b to the same datatype
b=typed.convert(b,dt);// callback
cf=typed.find(callback,[dt,dt]);}// result arrays
var cvalues=[];var cindex=[];var cptr=[];// matrix
var c=new SparseMatrix({values:cvalues,index:cindex,ptr:cptr,size:[rows,columns],datatype:dt});// loop columns
for(var j=0;j<columns;j++){// initialize ptr
cptr[j]=cindex.length;// values in j
for(var k0=aptr[j],k1=aptr[j+1],k=k0;k<k1;k++){// row
var i=aindex[k];// invoke callback
var v=inverse?cf(b,avalues[k]):cf(avalues[k],b);// check value is zero
if(!eq(v,zero)){// push index & value
cindex.push(i);cvalues.push(v);}}}// update ptr
cptr[columns]=cindex.length;// return sparse matrix
return c;};return algorithm11;}exports.name='algorithm11';exports.factory=factory;/***/},/* 123 *//***/function(module,exports,__webpack_require__){var isInteger=__webpack_require__(18).isInteger;var size=__webpack_require__(27).size;function factory(type,config,load,typed){var latex=__webpack_require__(44);var eye=load(__webpack_require__(124));var multiply=load(__webpack_require__(120));var matrix=load(__webpack_require__(42));var fraction=load(__webpack_require__(125));var number=load(__webpack_require__(126));/**
	   * Calculates the power of x to y, `x ^ y`.
	   * Matrix exponentiation is supported for square matrices `x`, and positive
	   * integer exponents `y`.
	   *
	   * For cubic roots of negative numbers, the function returns the principal
	   * root by default. In order to let the function return the real root,
	   * math.js can be configured with `math.config({predictable: true})`.
	   * To retrieve all cubic roots of a value, use `math.cbrt(x, true)`.
	   *
	   * Syntax:
	   *
	   *    math.pow(x, y)
	   *
	   * Examples:
	   *
	   *    math.pow(2, 3);               // returns number 8
	   *
	   *    var a = math.complex(2, 3);
	   *    math.pow(a, 2)                // returns Complex -5 + 12i
	   *
	   *    var b = [[1, 2], [4, 3]];
	   *    math.pow(b, 2);               // returns Array [[9, 8], [16, 17]]
	   *
	   * See also:
	   *
	   *    multiply, sqrt, cbrt, nthRoot
	   *
	   * @param  {number | BigNumber | Complex | Array | Matrix} x  The base
	   * @param  {number | BigNumber | Complex} y                   The exponent
	   * @return {number | BigNumber | Complex | Array | Matrix} The value of `x` to the power `y`
	   */var pow=typed('pow',{'number, number':_pow,'Complex, Complex':function ComplexComplex(x,y){return x.pow(y);},'BigNumber, BigNumber':function BigNumberBigNumber(x,y){if(y.isInteger()||x>=0||config.predictable){return x.pow(y);}else{return new type.Complex(x.toNumber(),0).pow(y.toNumber(),0);}},'Fraction, Fraction':function FractionFraction(x,y){if(y.d!==1){if(config.predictable){throw new Error('Function pow does not support non-integer exponents for fractions.');}else{return _pow(x.valueOf(),y.valueOf());}}else{return x.pow(y);}},'Array, number':_powArray,'Array, BigNumber':function ArrayBigNumber(x,y){return _powArray(x,y.toNumber());},'Matrix, number':_powMatrix,'Matrix, BigNumber':function MatrixBigNumber(x,y){return _powMatrix(x,y.toNumber());},'Unit, number':function UnitNumber(x,y){return x.pow(y);}});/**
	   * Calculates the power of x to y, x^y, for two numbers.
	   * @param {number} x
	   * @param {number} y
	   * @return {number | Complex} res
	   * @private
	   */function _pow(x,y){// Alternatively could define a 'realmode' config option or something, but
// 'predictable' will work for now
if(config.predictable&&!isInteger(y)&&x<0){// Check to see if y can be represented as a fraction
try{var yFrac=fraction(y);var yNum=number(yFrac);if(y===yNum||Math.abs((y-yNum)/y)<1e-14){if(yFrac.d%2===1){return(yFrac.n%2===0?1:-1)*Math.pow(-x,y);}}}catch(ex){}// fraction() throws an error if y is Infinity, etc.
// Unable to express y as a fraction, so continue on
}// x^Infinity === 0 if -1 < x < 1
// A real number 0 is returned instead of complex(0)
if(x*x<1&&y===Infinity||x*x>1&&y===-Infinity){return 0;}// **for predictable mode** x^Infinity === NaN if x < -1
// N.B. this behavour is different from `Math.pow` which gives
// (-2)^Infinity === Infinity
if(config.predictable&&(x<-1&&y===Infinity||x>-1&&x<0&&y===-Infinity)){return NaN;}if(isInteger(y)||x>=0||config.predictable){return Math.pow(x,y);}else{return new type.Complex(x,0).pow(y,0);}}/**
	   * Calculate the power of a 2d array
	   * @param {Array} x     must be a 2 dimensional, square matrix
	   * @param {number} y    a positive, integer value
	   * @returns {Array}
	   * @private
	   */function _powArray(x,y){if(!isInteger(y)||y<0){throw new TypeError('For A^b, b must be a positive integer (value is '+y+')');}// verify that A is a 2 dimensional square matrix
var s=size(x);if(s.length!=2){throw new Error('For A^b, A must be 2 dimensional (A has '+s.length+' dimensions)');}if(s[0]!=s[1]){throw new Error('For A^b, A must be square (size is '+s[0]+'x'+s[1]+')');}var res=eye(s[0]).valueOf();var px=x;while(y>=1){if((y&1)==1){res=multiply(px,res);}y>>=1;px=multiply(px,px);}return res;}/**
	   * Calculate the power of a 2d matrix
	   * @param {Matrix} x     must be a 2 dimensional, square matrix
	   * @param {number} y    a positive, integer value
	   * @returns {Matrix}
	   * @private
	   */function _powMatrix(x,y){return matrix(_powArray(x.valueOf(),y));}pow.toTex={2:'\\left(${args[0]}\\right)'+latex.operators['pow']+'{${args[1]}}'};return pow;}exports.name='pow';exports.factory=factory;/***/},/* 124 *//***/function(module,exports,__webpack_require__){var array=__webpack_require__(27);var isInteger=__webpack_require__(18).isInteger;function factory(type,config,load,typed){var matrix=load(__webpack_require__(42));/**
	   * Create a 2-dimensional identity matrix with size m x n or n x n.
	   * The matrix has ones on the diagonal and zeros elsewhere.
	   *
	   * Syntax:
	   *
	   *    math.eye(n)
	   *    math.eye(n, format)
	   *    math.eye(m, n)
	   *    math.eye(m, n, format)
	   *    math.eye([m, n])
	   *    math.eye([m, n], format)
	   *
	   * Examples:
	   *
	   *    math.eye(3);                    // returns [[1, 0, 0], [0, 1, 0], [0, 0, 1]]
	   *    math.eye(3, 2);                 // returns [[1, 0], [0, 1], [0, 0]]
	   *
	   *    var A = [[1, 2, 3], [4, 5, 6]];
	   *    math.eye(math.size(A));         // returns [[1, 0, 0], [0, 1, 0]]
	   *
	   * See also:
	   *
	   *    diag, ones, zeros, size, range
	   *
	   * @param {...number | Matrix | Array} size   The size for the matrix
	   * @param {string} [format]                   The Matrix storage format
	   *
	   * @return {Matrix | Array | number} A matrix with ones on the diagonal.
	   */var eye=typed('eye',{'':function _(){return config.matrix==='Matrix'?matrix([]):[];},'string':function string(format){return matrix(format);},'number | BigNumber':function numberBigNumber(rows){return _eye(rows,rows,config.matrix==='Matrix'?'default':undefined);},'number | BigNumber, string':function numberBigNumberString(rows,format){return _eye(rows,rows,format);},'number | BigNumber, number | BigNumber':function numberBigNumberNumberBigNumber(rows,cols){return _eye(rows,cols,config.matrix==='Matrix'?'default':undefined);},'number | BigNumber, number | BigNumber, string':function numberBigNumberNumberBigNumberString(rows,cols,format){return _eye(rows,cols,format);},'Array':function Array(size){return _eyeVector(size);},'Array, string':function ArrayString(size,format){return _eyeVector(size,format);},'Matrix':function Matrix(size){return _eyeVector(size.valueOf(),size.storage());},'Matrix, string':function MatrixString(size,format){return _eyeVector(size.valueOf(),format);}});eye.toTex=undefined;// use default template
return eye;function _eyeVector(size,format){switch(size.length){case 0:return format?matrix(format):[];case 1:return _eye(size[0],size[0],format);case 2:return _eye(size[0],size[1],format);default:throw new Error('Vector containing two values expected');}}/**
	   * Create an identity matrix
	   * @param {number | BigNumber} rows
	   * @param {number | BigNumber} cols
	   * @param {string} [format]
	   * @returns {Matrix}
	   * @private
	   */function _eye(rows,cols,format){// BigNumber constructor with the right precision
var Big=rows&&rows.isBigNumber===true?type.BigNumber:cols&&cols.isBigNumber===true?type.BigNumber:null;if(rows&&rows.isBigNumber===true)rows=rows.toNumber();if(cols&&cols.isBigNumber===true)cols=cols.toNumber();if(!isInteger(rows)||rows<1){throw new Error('Parameters in function eye must be positive integers');}if(!isInteger(cols)||cols<1){throw new Error('Parameters in function eye must be positive integers');}var one=Big?new type.BigNumber(1):1;var defaultValue=Big?new Big(0):0;var size=[rows,cols];// check we need to return a matrix
if(format){// get matrix storage constructor
var F=type.Matrix.storage(format);// create diagonal matrix (use optimized implementation for storage format)
return F.diagonal(size,one,0,defaultValue);}// create and resize array
var res=array.resize([],size,defaultValue);// fill in ones on the diagonal
var minimum=rows<cols?rows:cols;// fill diagonal
for(var d=0;d<minimum;d++){res[d][d]=one;}return res;}}exports.name='eye';exports.factory=factory;/***/},/* 125 *//***/function(module,exports,__webpack_require__){var deepMap=__webpack_require__(118);function factory(type,config,load,typed){/**
	   * Create a fraction convert a value to a fraction.
	   *
	   * Syntax:
	   *     math.fraction(numerator, denominator)
	   *     math.fraction({n: numerator, d: denominator})
	   *     math.fraction(matrix: Array | Matrix)         Turn all matrix entries
	   *                                                   into fractions
	   *
	   * Examples:
	   *
	   *     math.fraction(1, 3);
	   *     math.fraction('2/3');
	   *     math.fraction({n: 2, d: 3});
	   *     math.fraction([0.2, 0.25, 1.25]);
	   *
	   * See also:
	   *
	   *    bignumber, number, string, unit
	   *
	   * @param {number | string | Fraction | BigNumber | Array | Matrix} [args]
	   *            Arguments specifying the numerator and denominator of
	   *            the fraction
	   * @return {Fraction | Array | Matrix} Returns a fraction
	   */var fraction=typed('fraction',{'number':function number(x){if(!isFinite(x)||isNaN(x)){throw new Error(x+' cannot be represented as a fraction');}return new type.Fraction(x);},'string':function string(x){return new type.Fraction(x);},'number, number':function numberNumber(numerator,denominator){return new type.Fraction(numerator,denominator);},'BigNumber':function BigNumber(x){return new type.Fraction(x.toString());},'Fraction':function Fraction(x){return x;// fractions are immutable
},'Object':function Object(x){return new type.Fraction(x);},'Array | Matrix':function ArrayMatrix(x){return deepMap(x,fraction);}});return fraction;}exports.name='fraction';exports.factory=factory;/***/},/* 126 *//***/function(module,exports,__webpack_require__){var deepMap=__webpack_require__(118);function factory(type,config,load,typed){/**
	   * Create a number or convert a string, boolean, or unit to a number.
	   * When value is a matrix, all elements will be converted to number.
	   *
	   * Syntax:
	   *
	   *    math.number(value)
	   *    math.number(unit, valuelessUnit)
	   *
	   * Examples:
	   *
	   *    math.number(2);                         // returns number 2
	   *    math.number('7.2');                     // returns number 7.2
	   *    math.number(true);                      // returns number 1
	   *    math.number([true, false, true, true]); // returns [1, 0, 1, 1]
	   *    math.number(math.unit('52cm'), 'm');    // returns 0.52
	   *
	   * See also:
	   *
	   *    bignumber, boolean, complex, index, matrix, string, unit
	   *
	   * @param {string | number | BigNumber | Fraction | boolean | Array | Matrix | Unit | null} [value]  Value to be converted
	   * @param {Unit | string} [valuelessUnit] A valueless unit, used to convert a unit to a number
	   * @return {number | Array | Matrix} The created number
	   */var number=typed('number',{'':function _(){return 0;},'number':function number(x){return x;},'string':function string(x){var num=Number(x);if(isNaN(num)){throw new SyntaxError('String "'+x+'" is no valid number');}return num;},'BigNumber':function BigNumber(x){return x.toNumber();},'Fraction':function Fraction(x){return x.valueOf();},'Unit':function Unit(x){throw new Error('Second argument with valueless unit expected');},'Unit, string | Unit':function UnitStringUnit(unit,valuelessUnit){return unit.toNumber(valuelessUnit);},'Array | Matrix':function ArrayMatrix(x){return deepMap(x,number);}});number.toTex={0:'0',1:'\\left(${args[0]}\\right)',2:'\\left(\\left(${args[0]}\\right)${args[1]}\\right)'};return number;}exports.name='number';exports.factory=factory;/***/},/* 127 *//***/function(module,exports){module.exports=function cat_breakdown_bars(params,cat_data,cat_graph_group,title_height,bars_index,max_bars,cat_bar_groups){var paragraph_string='<p>';var super_string=': ';var bar_width=params.viz.cat_bar_width;var bar_height=params.viz.cat_bar_height;var max_string_length=25;var max_bar_value=cat_data.bar_data[0][bars_index];// only keep the top max_bars categories
cat_data.bar_data=cat_data.bar_data.slice(0,max_bars);var inst_title=cat_data.type_name;// ensure that title is not too long
if(inst_title.length>=max_string_length){inst_title=inst_title.slice(0,max_string_length)+'..';}// make title
cat_graph_group.append('text').classed('cat_graph_title',true).text(inst_title).style('font-family','"Helvetica Neue", Helvetica, Arial, sans-serif').style('font-weight',800);var line_y=4;cat_graph_group.append('line').attr('x1',0).attr('x2',bar_width).attr('y1',line_y).attr('y2',line_y).attr('stroke','blue').attr('stroke-width',1).attr('opacity',1.0);// bar length is max when all nodes in cluster are of
// a single cat
var bar_scale=d3.scale.linear().domain([0,max_bar_value]).range([0,bar_width]);// make bars
cat_bar_groups.append('rect').attr('height',bar_height+'px').attr('width',function(d){var inst_width=bar_scale(d[bars_index]);return inst_width+'px';}).attr('fill',function(d){// cat color is stored in the third element
return d[3];}).attr('opacity',params.viz.cat_colors.opacity).attr('stroke','grey').attr('stroke-width','0.5px');// make bar labels
cat_bar_groups.append('text').classed('bar_labels',true).text(function(d){var inst_text=d[1];if(inst_text.indexOf(super_string)>0){inst_text=inst_text.split(super_string)[1];}if(inst_text.indexOf(paragraph_string)>0){// required for Enrichr category names (needs improvements)
inst_text=inst_text.split(paragraph_string)[0];}// ensure that bar name is not too long
if(inst_text.length>=max_string_length){inst_text=inst_text.slice(0,max_string_length)+'..';}return inst_text;}).attr('transform',function(){return'translate(5, '+0.75*bar_height+')';}).attr('font-family','"Helvetica Neue", Helvetica, Arial, sans-serif').attr('font-weight',400).attr('text-anchor','right');};/***/},/* 128 *//***/function(module,exports){module.exports=function cat_breakdown_values(params,cat_graph_group,cat_bar_groups,num_nodes_index,is_downsampled,count_offset,bars_index,cluster_total){var bar_width=params.viz.cat_bar_width;var bar_height=params.viz.cat_bar_height;var offset_ds_count=150;var binom_pval_index=6;// Count Title
cat_graph_group.append('text').text('Count').attr('transform',function(){var inst_x=bar_width+count_offset;var inst_translate='translate('+inst_x+', 0)';return inst_translate;});// Percentage Title
cat_graph_group.append('text').text('Pct').attr('transform',function(){var inst_x=bar_width+count_offset+60;var inst_translate='translate('+inst_x+', 0)';return inst_translate;});// Percentage Title
cat_graph_group.append('text').text('P-val').attr('transform',function(){var inst_x=bar_width+count_offset+115;var inst_translate='translate('+inst_x+', 0)';return inst_translate;});// Count Downsampled Title
if(is_downsampled){cat_graph_group.append('text').text('Clusters').attr('transform',function(){var inst_x=bar_width+offset_ds_count;var inst_translate='translate('+inst_x+', 0)';return inst_translate;});}// Counts
/////////////////////////////
var shift_count_num=35;cat_bar_groups.append('text').classed('count_labels',true).text(function(d){var inst_count=d[bars_index];inst_count=inst_count.toLocaleString();return String(inst_count);}).attr('transform',function(){var inst_x=bar_width+count_offset+shift_count_num;var inst_y=0.75*bar_height;return'translate('+inst_x+', '+inst_y+')';}).attr('font-family','"Helvetica Neue", Helvetica, Arial, sans-serif').attr('font-weight',400).attr('text-anchor','end');// Percentage
//////////////////////
cat_bar_groups.append('text').classed('count_labels',true).text(function(d){// calculate the percentage relative to the current cluster
var inst_count=d[bars_index]/cluster_total*100;inst_count=Math.round(inst_count*10)/10;inst_count=inst_count.toLocaleString();return String(inst_count);}).attr('transform',function(){var inst_x=bar_width+count_offset+shift_count_num+47;var inst_y=0.75*bar_height;return'translate('+inst_x+', '+inst_y+')';}).attr('font-family','"Helvetica Neue", Helvetica, Arial, sans-serif').attr('font-weight',400).attr('text-anchor','end');// Binomial Test Pvals
cat_bar_groups.append('text').classed('count_labels',true).text(function(d){// calculate the percentage relative to the current cluster
var inst_count=d[binom_pval_index];if(inst_count<0.001){inst_count=parseFloat(inst_count.toPrecision(3));inst_count=inst_count.toExponential();}else{inst_count=parseFloat(inst_count.toPrecision(2));}// inst_count = inst_count.toLocaleString();
return inst_count;}).attr('transform',function(){var inst_x=bar_width+count_offset+shift_count_num+112;var inst_y=0.75*bar_height;return'translate('+inst_x+', '+inst_y+')';}).attr('font-family','"Helvetica Neue", Helvetica, Arial, sans-serif').attr('font-weight',400).attr('text-anchor','end');if(is_downsampled){cat_bar_groups.append('text').classed('count_labels',true).text(function(d){return String(d[num_nodes_index].toLocaleString());}).attr('transform',function(){// downsampled cluster numbers are smaller and need less flexible offsetting
var inst_x=bar_width+shift_count_num+offset_ds_count+20;var inst_y=0.75*bar_height;return'translate('+inst_x+', '+inst_y+')';}).attr('font-family','"Helvetica Neue", Helvetica, Arial, sans-serif').attr('font-weight',400).attr('text-anchor','end');}};/***/},/* 129 *//***/function(module,exports){module.exports=function get_previous_zoom(params){var prev_zoom={};var inst_trans=d3.select(params.root+' .clust_group').attr('transform');if(inst_trans!=null){// prevent from crashing if no scaling was done
if(inst_trans.indexOf('scale')>0){prev_zoom.zoom_x=parseFloat(inst_trans.split('scale')[1].replace('(','').replace(')','').split(',')[0]);prev_zoom.zoom_y=parseFloat(inst_trans.split('scale')[1].replace('(','').replace(')','').split(',')[1]);}else{prev_zoom.zoom_x=1;prev_zoom.zoom_y=1;}}else{prev_zoom.zoom_x=1;prev_zoom.zoom_y=1;}return prev_zoom;};/***/},/* 130 *//***/function(module,exports,__webpack_require__){var d3_tip_custom=__webpack_require__(98);module.exports=function make_row_tooltips(params){if(params.labels.show_label_tooltips){// remove old tooltips
d3.selectAll(params.viz.root_tips+'_row_tip').remove();var root_tip_selector=params.viz.root_tips.replace('.','');// d3-tooltip
var row_tip=d3_tip_custom().attr('class',function(){var class_string=root_tip_selector+' d3-tip '+root_tip_selector+'_row_tip';return class_string;}).direction('e').offset([0,10]).style('display','none').html(function(d){var inst_name=d.name.replace(/_/g,' ').split('#')[0];return"<span>"+inst_name+"</span>";});d3.select(params.viz.viz_wrapper).select(params.root+' .row_container').call(row_tip);d3.select(params.root+' .row_label_zoom_container').selectAll('g').on('mouseover',function(d){d3.select(params.viz.root_tips+'_row_tip').classed(d.name,true);d3.selectAll(params.viz.root_tips+'_row_tip').style('display','block');d3.select(this).select('text').classed('active',true);row_tip.show(d);if(params.row_tip_callback!=null){params.row_tip_callback(params.viz.root_tips,d);}}).on('mouseout',function mouseout(d){d3.selectAll(params.viz.root_tips+'_row_tip').style('display','none').classed(d.name,false);d3.select(this).select('text').classed('active',false);row_tip.hide(d);});}else{d3.select(params.root+' .row_label_zoom_container').selectAll('g').on('mouseover',function(){d3.select(this).select('text').classed('active',true);}).on('mouseout',function mouseout(){d3.select(this).select('text').classed('active',false);});}};/***/},/* 131 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);var add_col_click_hlight=__webpack_require__(132);var col_reorder=__webpack_require__(133);var row_reorder=__webpack_require__(102);var make_col_tooltips=__webpack_require__(137);var col_viz_aid_triangle=__webpack_require__(138);module.exports=function make_col_label_container(cgm){var text_delay=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var params=cgm.params;var col_container;var col_nodes=params.network_data.col_nodes;// offset click group column label
var x_offset_click=params.viz.x_scale.rangeBand()/2+params.viz.border_width.x;// reduce width of rotated rects
// make container to pre-position zoomable elements
if(d3.select(params.root+' .col_container').empty()){col_container=d3.select(params.viz.viz_svg).append('g').attr('class','col_container').attr('transform','translate('+params.viz.clust.margin.left+','+params.viz.norm_labels.margin.top+')');// white background rect for col labels
col_container.append('rect').attr('fill',params.viz.background_color)//!! prog_colors
.attr('width',30*params.viz.clust.dim.width+'px').attr('height',params.viz.label_background.col).attr('class','white_bars');// col labels
col_container.append('g').attr('class','col_label_outer_container')// position the outer col label group
.attr('transform','translate(0,'+params.viz.norm_labels.width.col+')').append('g').attr('class','col_zoom_container');}else{col_container=d3.select(params.root+' .col_container').attr('transform','translate('+params.viz.clust.margin.left+','+params.viz.norm_labels.margin.top+')');// white background rect for col labels
col_container.select('.white_bars').attr('fill',params.viz.background_color)//!! prog_colors
.attr('width',30*params.viz.clust.dim.width+'px').attr('height',params.viz.label_background.col);// col labels
col_container.select(params.root+' .col_label_outer_container');}// add main column label group
var col_label_obj=d3.select(params.root+' .col_zoom_container').selectAll('.col_label_text').data(col_nodes,function(d){return d.name;}).enter().append('g').attr('class','col_label_text').attr('transform',function(d){var inst_index=d.col_index;return'translate('+params.viz.x_scale(inst_index)+', 0) rotate(-90)';});// append group for individual column label
var col_label_group=col_label_obj// append new group for rect and label (not white lines)
.append('g').attr('class','col_label_group')// rotate column labels
.attr('transform','translate('+params.viz.x_scale.rangeBand()/2+','+x_offset_click+') rotate(45)').on('mouseover',function(){d3.select(this).select('text').classed('active',true);}).on('mouseout',function(){d3.select(this).select('text').classed('active',false);});// append column value bars
if(utils.has(params.network_data.col_nodes[0],'value')){col_label_group.append('rect').attr('class','col_bars').attr('width',function(d){var inst_value=0;if(d.value>0){inst_value=params.labels.bar_scale_col(d.value);}return inst_value;})// rotate labels - reduce width if rotating
.attr('height',params.viz.x_scale.rangeBand()*0.66).style('fill',function(d){return d.value>0?params.matrix.bar_colors[0]:params.matrix.bar_colors[1];}).attr('opacity',0.6);}// add column label
col_label_group.append('text').attr('x',0)// manually tuned
.attr('y',params.viz.x_scale.rangeBand()*0.64).attr('dx',params.viz.border_width.x).attr('text-anchor','start').attr('full_name',function(d){return d.name;})// original font size
.style('font-size',params.labels.default_fs_col+'px').style('cursor','default').text(function(d){return utils.normal_name(d);})// .attr('pointer-events','none')
.style('opacity',0).transition().delay(text_delay).duration(text_delay).style('opacity',1);make_col_tooltips(params);// add triangle under rotated labels
col_label_group.append('path').style('stroke-width',0).attr('d',function(){return col_viz_aid_triangle(params);}).attr('fill','#eee').style('opacity',0).transition().delay(text_delay).duration(text_delay).style('opacity',params.viz.triangle_opacity);// add col callback function
d3.selectAll(params.root+' .col_label_text').on('click',function(d){if(typeof params.click_label=='function'){params.click_label(d.name,'col');add_col_click_hlight(params,this,d.ini);}else{if(params.tile_click_hlight){add_col_click_hlight(params,this,d.ini);}}}).on('dblclick',function(d){var data_attr='__data__';var col_name=this[data_attr].name;if(params.sim_mat){col_reorder(cgm,this,col_name);var row_selection=d3.selectAll(params.root+' .row_label_group').filter(function(d){return d.name==col_name;})[0][0];row_reorder(cgm,row_selection,col_name);}else{col_reorder(cgm,this,col_name);}if(params.tile_click_hlight){add_col_click_hlight(params,this,d.ini);}});};/***/},/* 132 *//***/function(module,exports){module.exports=function(params,clicked_col,id_clicked_col){if(id_clicked_col!=params.click_hlight_col){params.click_hlight_col=id_clicked_col;var rel_width_hlight=6;var opacity_hlight=0.85;var hlight_width=rel_width_hlight*params.viz.border_width.x;d3.selectAll(params.root+' .click_hlight').remove();// // highlight selected column
// ///////////////////////////////
// // unhilight and unbold all columns (already unbolded earlier)
// d3.selectAll('.col_label_text')
//   .select('rect')
//   .style('opacity', 0);
// // highlight column name
// d3.select(clicked_col)
//   .select('rect')
//   .style('opacity', 1);
d3.select(clicked_col).append('rect').classed('click_hlight',true).classed('col_top_hlight',true).attr('width',params.viz.clust.dim.height).attr('height',hlight_width).attr('fill',params.matrix.hlight_color).attr('opacity',opacity_hlight).attr('transform',function(){var tmp_translate_y=0;var tmp_translate_x=-(params.viz.clust.dim.height+params.viz.cat_room.col+params.viz.uni_margin);return'translate('+tmp_translate_x+','+tmp_translate_y+')';});d3.select(clicked_col).append('rect').classed('click_hlight',true).classed('col_bottom_hlight',true).attr('width',params.viz.clust.dim.height).attr('height',hlight_width).attr('fill',params.matrix.hlight_color).attr('opacity',opacity_hlight).attr('transform',function(){// reverse x and y since rotated
var tmp_translate_y=params.viz.x_scale.rangeBand()-hlight_width;var tmp_translate_x=-(params.viz.clust.dim.height+params.viz.cat_room.col+params.viz.uni_margin);return'translate('+tmp_translate_x+','+tmp_translate_y+')';});}else{d3.selectAll(params.root+' .click_hlight').remove();params.click_hlight_col=-666;}};/***/},/* 133 *//***/function(module,exports,__webpack_require__){// var utils = require('../Utils_clust');
var reposition_tile_highlight=__webpack_require__(103);var toggle_dendro_view=__webpack_require__(104);var show_visible_area=__webpack_require__(134);var ini_zoom_info=__webpack_require__(86);var get_previous_zoom=__webpack_require__(129);var calc_downsampled_levels=__webpack_require__(77);var underscore=__webpack_require__(3);module.exports=function col_reorder(cgm,col_selection,inst_term){var params=cgm.params;var prev_zoom=get_previous_zoom(params);if(prev_zoom.zoom_y===1&&prev_zoom.zoom_x===1){params.viz.inst_order.col='custom';toggle_dendro_view(cgm,'col');d3.selectAll(params.root+' .toggle_row_order .btn').classed('active',false);params.viz.run_trans=true;var mat=$.extend(true,{},params.matrix.matrix);var row_nodes=params.network_data.row_nodes;var col_nodes=params.network_data.col_nodes;// find the column number of col_selection term from col_nodes
// gather column node names
var tmp_arr=[];col_nodes.forEach(function(node){tmp_arr.push(node.name);});// find index
var inst_col=underscore.indexOf(tmp_arr,inst_term);// gather the values of the input genes
tmp_arr=[];row_nodes.forEach(function(node,index){tmp_arr.push(mat[index].row_data[inst_col].value);});// sort the cols
var tmp_sort=d3.range(tmp_arr.length).sort(function(a,b){return tmp_arr[b]-tmp_arr[a];});// resort rows (rows are reorderd by double clicking a col)
params.viz.y_scale.domain(tmp_sort);// save to custom row order
params.matrix.orders.custom_col=tmp_sort;var t;var row_nodes_names=params.network_data.row_nodes_names;// reorder
if(params.network_data.links.length>params.matrix.def_large_matrix){t=d3.select(params.root+' .viz_svg');}else{t=d3.select(params.root+' .viz_svg').transition().duration(2500);}// reorder row_label_triangle groups
t.selectAll('.row_cat_group').attr('transform',function(d){var inst_index=underscore.indexOf(row_nodes_names,d.name);return'translate(0,'+params.viz.y_scale(inst_index)+')';});// Move Row Labels
t.select('.row_label_zoom_container').selectAll('.row_label_group').attr('transform',function(d){var inst_index=underscore.indexOf(row_nodes_names,d.name);return'translate(0,'+params.viz.y_scale(inst_index)+')';});// only update matri if not downsampled
if(params.viz.ds_level===-1){// reorder matrix rows
t.selectAll('.row').attr('transform',function(d){var inst_index=underscore.indexOf(row_nodes_names,d.name);return'translate(0,'+params.viz.y_scale(inst_index)+')';});}// highlight selected column
///////////////////////////////
// unhilight and unbold all columns (already unbolded earlier)
d3.selectAll(params.root+' .col_label_text').select('.highlight_rect').style('opacity',0);// highlight column name
d3.select(col_selection).select('.highlight_rect').style('opacity',1);// redefine x and y positions
params.network_data.links.forEach(function(d){d.x=params.viz.x_scale(d.target);d.y=params.viz.y_scale(d.source);});reposition_tile_highlight(params);params.zoom_info=ini_zoom_info();setTimeout(function(){params.viz.run_trans=false;},2500);// calculate downsmapling if necessary
if(params.viz.ds_num_levels>0&&params.viz.ds_level>=0){calc_downsampled_levels(params);var zooming_stopped=true;var zooming_out=true;var make_all_rows=true;// show_visible_area is also run with two_translate_zoom, but at that point
// the parameters were not updated and two_translate_zoom if only run
// if needed to reset zoom
show_visible_area(cgm,zooming_stopped,zooming_out,make_all_rows);}}};/***/},/* 134 *//***/function(module,exports,__webpack_require__){var find_viz_rows=__webpack_require__(135);var make_matrix_rows=__webpack_require__(91);var make_row_labels=__webpack_require__(100);var make_row_visual_aid_triangles=__webpack_require__(136);var underscore=__webpack_require__(3);module.exports=function show_visible_area(cgm){var zooming_stopped=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var zooming_out=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var make_all_rows=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;// console.log('show_visible_area stopped: ' + String(zooming_stopped));
var params=cgm.params;var zoom_info=params.zoom_info;// update ds_level if necessary
//////////////////////////////////////////////
var check_ds_level=params.viz.ds_level;var old_ds_level=params.viz.ds_level;// toggle the downsampling level (if necessary)
if(params.viz.ds===null){check_ds_level=-1;}else{check_ds_level=Math.floor(Math.log(zoom_info.zoom_y)/Math.log(params.viz.ds_zt));if(check_ds_level>params.viz.ds_num_levels-1){check_ds_level=-1;}}// check if override_ds is necessary
//////////////////////////////////////////////
// force update of view if moving to more coarse view
var override_ds=false;if(old_ds_level==-1){// transitioning to more coarse downsampling view (from real data)
if(check_ds_level>=0){override_ds=true;}}else{// transitioning to more coarse downsampling view
if(check_ds_level<old_ds_level){override_ds=true;}}// update level if zooming has stopped or if transitioning to more coarse view
var new_ds_level;if(zooming_stopped===true||override_ds===true){// update new_ds_level if necessary (if decreasing detail, zooming out)
new_ds_level=check_ds_level;// set zooming_stopped to true in case of override_ds
zooming_stopped=true;params.viz.ds_level=new_ds_level;}else{// keep the old level (zooming is still occuring and not zooming out)
new_ds_level=old_ds_level;}var viz_area={};var buffer_size=5;// get translation vector absolute values
viz_area.min_x=Math.abs(zoom_info.trans_x)/zoom_info.zoom_x-(buffer_size+1)*params.viz.rect_width;viz_area.min_y=Math.abs(zoom_info.trans_y)/zoom_info.zoom_y-(buffer_size+1)*params.viz.rect_height;viz_area.max_x=Math.abs(zoom_info.trans_x)/zoom_info.zoom_x+params.viz.clust.dim.width/zoom_info.zoom_x+buffer_size*params.viz.rect_width;viz_area.max_y=Math.abs(zoom_info.trans_y)/zoom_info.zoom_y+params.viz.clust.dim.height/zoom_info.zoom_y+buffer_size*params.viz.rect_height;// generate lists of visible rows/cols
find_viz_rows(params,viz_area);var missing_rows;if(make_all_rows===false){missing_rows=underscore.difference(params.viz.viz_nodes.row,params.viz.viz_nodes.curr_row);}else{// make all rows (reordering)
missing_rows='all';// remove downsampled rows
d3.selectAll(params.root+' .ds'+String(new_ds_level)+'_row').remove();}if(params.viz.ds!=null){var ds_row_class='.ds'+String(params.viz.ds_level)+'_row';d3.selectAll(ds_row_class).style('display','block');}// if downsampling
if(new_ds_level>=0){// remove old rows
d3.selectAll(params.root+' .row').remove();// remove tile tooltips and row tooltips
d3.selectAll(params.viz.root_tips+'_tile_tip').remove();d3.selectAll(params.viz.root_tips+'_row_tip').remove();}// default state for downsampling
var inst_matrix;if(new_ds_level<0){// set matrix to default matrix
inst_matrix=params.matrix.matrix;// make row visual-aid triangles
make_row_visual_aid_triangles(params);}else{// set matrix to downsampled matrix
inst_matrix=params.matrix.ds_matrix[new_ds_level];d3.selectAll(params.root+' .row_cat_group path').remove();}// also remove row visual aid triangles if zooming out
if(zooming_out===true){d3.selectAll(params.root+' .row_cat_group path').remove();}// remove rows and labels that are not visible and change ds_level
/* run when zooming has stopped */if(zooming_stopped===true){// remove not visible matrix rows
if(new_ds_level>=0){// remove downsampled rows
d3.selectAll(params.root+' .ds'+String(new_ds_level)+'_row').each(function(d){if(underscore.contains(params.viz.viz_nodes.row,d.name)===false){d3.select(this).remove();}});}else{// remove real data rows
d3.selectAll(params.root+' .row').each(function(d){if(underscore.contains(params.viz.viz_nodes.row,d.name)===false){d3.select(this).remove();}});}// remove not visible row labels
d3.selectAll(params.root+' .row_label_group').each(function(d){if(underscore.contains(params.viz.viz_nodes.row,d.name)===false){d3.select(this).remove();}});// level change
if(new_ds_level!=old_ds_level){// console.log('old: ' + String(old_ds_level) + ' new: '+ String(new_ds_level));
// all visible rows are missing at new downsampling level
missing_rows=params.viz.viz_nodes.row;// remove old level rows
d3.selectAll(params.root+' .ds'+String(old_ds_level)+'_row').remove();}}// console.log('missing_rows: ' + String(missing_rows))
// console.log(missing_rows)
// only make new matrix_rows if there are missing rows
if(missing_rows.length>=1||missing_rows==='all'){make_matrix_rows(params,inst_matrix,missing_rows,new_ds_level);}// only make new row_labels if there are missing row_labels, downsampled, and
// not zooming out or zooming has stopped
if(new_ds_level===-1){if(zooming_out===false||zooming_stopped){// check if labels need to be made
///////////////////////////////////
// get the names visible row_labels
var visible_row_labels=[];d3.selectAll(params.root+' .row_label_group').each(function(d){visible_row_labels.push(d.name);});// find missing labels
var missing_row_labels=underscore.difference(params.viz.viz_nodes.row,visible_row_labels);// make labels
//////////////////////////////////
// only make row labels if there are any missing
var addback_thresh=1;if(missing_row_labels.length>addback_thresh){make_row_labels(cgm,missing_row_labels);}}}};/***/},/* 135 *//***/function(module,exports){module.exports=function find_viz_rows(params,viz_area){var should_be_rows=[];var curr_rows=[];// find rows that should be visible
var y_trans;// default y_scale (no downsampling)
var y_scale=params.viz.y_scale;var ds_level=params.viz.ds_level;var row_names=params.network_data.row_nodes_names;var row_class='.row';// if downsampling redefine variables
if(ds_level>=0){y_scale=params.viz.ds[ds_level].y_scale;row_names=d3.range(params.matrix.ds_matrix[ds_level].length).map(String);row_class='.ds'+String(ds_level)+'_row';}// find rows that should be visible
for(var i=0;i<row_names.length;i++){y_trans=y_scale(i);if(y_trans<viz_area.max_y&&y_trans>viz_area.min_y){should_be_rows.push(row_names[i]);}}// find currently visible rows
d3.selectAll(params.root+' '+row_class).each(function(d){curr_rows.push(d.name);});// nodes that should be visible
params.viz.viz_nodes.row=should_be_rows;// nodes that are visible
params.viz.viz_nodes.curr_row=curr_rows;};/***/},/* 136 *//***/function(module,exports){module.exports=function make_row_visual_aid_triangles(params){if(d3.select(params.root+' .row_cat_group path').empty()===true){d3.selectAll(params.root+' .row_cat_group').append('path').attr('d',function(){var origin_x=params.viz.cat_room.symbol_width-1;var origin_y=0;var mid_x=1;var mid_y=params.viz.y_scale.rangeBand()/2;var final_x=params.viz.cat_room.symbol_width-1;var final_y=params.viz.y_scale.rangeBand();var output_string='M '+origin_x+','+origin_y+' L '+mid_x+','+mid_y+' L '+final_x+','+final_y+' Z';return output_string;}).attr('fill','#eee').style('opacity',params.viz.triangle_opacity);}};/***/},/* 137 *//***/function(module,exports,__webpack_require__){var d3_tip_custom=__webpack_require__(98);module.exports=function make_col_tooltips(params){if(params.labels.show_label_tooltips){// remove old col tooltips
d3.selectAll(params.viz.root_tips+'_col_tip').remove();// d3-tooltip
var col_tip=d3_tip_custom().attr('class',function(){var root_tip_selector=params.viz.root_tips.replace('.','');var class_string=root_tip_selector+' d3-tip '+root_tip_selector+'_col_tip';return class_string;}).direction('w').offset([20,0]).style('display','none').html(function(d){var inst_name=d.name.replace(/_/g,' ').split('#')[0];return"<span>"+inst_name+"</span>";});d3.select(params.viz.viz_wrapper).select('svg').select(params.root+' .col_zoom_container').selectAll('.col_label_group').select('text').call(col_tip);d3.select(params.root+' .col_zoom_container').selectAll('.col_label_group').on('mouseover',function(d){d3.selectAll(params.viz.root_tips+'_col_tip').style('display','block');col_tip.show(d);if(params.col_tip_callback!=null){params.col_tip_callback(d);}}).on('mouseout',function(){col_tip.hide(this);d3.selectAll(params.viz.root_tips+'_col_tip').style('display','none');});}};/***/},/* 138 *//***/function(module,exports){module.exports=function col_viz_aid_triangle(params){// x and y are flipped since its rotated
var reduce_rect_width=params.viz.x_scale.rangeBand()*0.36;var origin_y=-params.viz.border_width.x;var start_x=0;var final_x=params.viz.x_scale.rangeBand()-reduce_rect_width;var start_y=-(params.viz.x_scale.rangeBand()-reduce_rect_width+params.viz.border_width.x);var final_y=-params.viz.border_width.x;var output_string='M '+origin_y+',0 L '+start_y+','+start_x+' L '+final_y+','+final_x+' Z';return output_string;};/***/},/* 139 *//***/function(module,exports){module.exports=function(params){d3.select(params.viz.viz_svg).append('rect').attr('fill',params.viz.background_color).attr('height',params.viz.super_labels.dim.width+'px').attr('width','3000px').classed('super_col_bkg',true).classed('white_bars',true).attr('transform','translate('+params.viz.clust.margin.left+','+params.viz.super_labels.margin.top+')');d3.select(params.viz.viz_svg).append('text').attr('class','super_col').text(params.labels.super.col).attr('text-anchor','center').attr('transform',function(){var inst_text_width=d3.select(this)[0][0].getBBox().width;var inst_x=params.viz.clust.dim.width/2+params.viz.norm_labels.width.row-inst_text_width/2;var inst_y=params.viz.super_labels.dim.width;return'translate('+inst_x+','+inst_y+')';}).style('font-size',function(){var inst_font_size=params.labels.super_label_fs*params.labels.super_label_scale;return inst_font_size+'px';}).style('font-weight',300);d3.select(params.viz.viz_svg).append('rect').attr('fill',params.viz.background_color).attr('width',params.viz.super_labels.dim.width+'px').attr('height','3000px').classed('super_row_bkg',true).classed('white_bars',true).attr('transform','translate('+params.viz.super_labels.margin.left+',0)');// append super title row group - used to separate translation from rotation
d3.select(params.viz.viz_svg).append('g').classed('super_row',true).attr('transform',function(){// position in the middle of the clustergram
var inst_x=params.viz.super_labels.dim.width;var inst_y=params.viz.clust.dim.height/2+params.viz.norm_labels.width.col;return'translate('+inst_x+','+inst_y+')';});// super row label (rotate the already translated title )
d3.select(params.root+' .super_row').append('text').text(params.labels.super.row).attr('text-anchor','center').attr('transform',function(){var inst_text_width=d3.select(this)[0][0].getBBox().width;var inst_x_offset=inst_text_width/2+params.viz.norm_labels.width.col;var inst_offset='translate(0,'+inst_x_offset+'), rotate(-90)';return inst_offset;}).style('font-size',function(){var inst_font_size=params.labels.super_label_fs*params.labels.super_label_scale;return inst_font_size+'px';}).style('font-weight',300);};/***/},/* 140 *//***/function(module,exports,__webpack_require__){var get_cat_title=__webpack_require__(141);var ini_cat_reorder=__webpack_require__(142);var make_row_cat_super_labels=__webpack_require__(150);var make_dendro_crop_buttons=__webpack_require__(110);module.exports=function Spillover(cgm){var params=cgm.params;var viz=params.viz;// hide spillover from slanted column labels on right side
d3.select(viz.root+' .col_container').append('path').style('stroke-width','0').attr('d','M 0,0 L 1000,-1000, L 1000,0 Z').attr('fill',viz.background_color)//!! prog_colors
.attr('class','right_slant_triangle').attr('transform','translate('+viz.clust.dim.width+','+viz.norm_labels.width.col+')');// hide spillover from slanted column labels on left side
d3.select(viz.root+' .col_container').append('path').style('stroke-width','0').attr('d','M 0,0 L 500,-500, L 0,-500 Z').attr('fill',viz.background_color).attr('class','left_slant_triangle')// shift left by 1 px to prevent cutting off labels
.attr('transform','translate(-1,'+viz.norm_labels.width.col+')');var rect_height=viz.clust.margin.top+viz.uni_margin/5;// white rect to cover excess labels
d3.select(viz.viz_svg).append('rect').attr('fill',viz.background_color)//!! prog_colors
.attr('width',viz.clust.margin.left).attr('height',rect_height).attr('class','top_left_white');var inst_height=viz.cat_room.col+1.5*viz.uni_margin;// white rect to cover excess labels
d3.select(viz.viz_svg).append('rect').attr('fill',viz.background_color).attr('width',2*viz.clust.dim.width).attr('height',inst_height).attr('class','top_right_white').attr('transform',function(){var tmp_left=viz.clust.margin.left+viz.clust.dim.width;var tmp_top=viz.norm_labels.width.col+viz.norm_labels.margin.top-viz.uni_margin;return'translate('+tmp_left+', '+tmp_top+')';});x_offset=viz.clust.margin.left+viz.clust.dim.width+viz.uni_margin;y_offset=viz.norm_labels.margin.top+viz.norm_labels.width.col+2.5*viz.uni_margin;var cat_text_size=1.15*viz.cat_room.symbol_width;var cat_super_opacity=0.65;var extra_y_room=1.25;// col category super labels
if(viz.show_categories.col){d3.select(viz.viz_svg).selectAll().data(viz.all_cats.col).enter().append('text').classed('col_cat_super',true).style('font-size',cat_text_size+'px').style('opacity',cat_super_opacity).style('cursor','default').attr('transform',function(d){var inst_cat=parseInt(d.split('-')[1],10);var inst_y=y_offset+extra_y_room*viz.cat_room.symbol_width*inst_cat;return'translate('+x_offset+','+inst_y+')';}).text(function(d){return get_cat_title(viz,d,'col');});}// row category super labels
make_row_cat_super_labels(cgm);// white border bottom - prevent clustergram from hitting border
if(viz.show_dendrogram){// quick fix to make room for crop buttons
y_offset=viz.clust.margin.top+viz.clust.dim.height+viz.dendro_room.col-2*viz.uni_margin;}else{y_offset=viz.clust.margin.top+viz.clust.dim.height;}var b_spill_container=d3.select(viz.viz_svg).append('g').classed('bottom_spillover_container',true).attr('transform',function(){// shift up enough to show the entire border width
return'translate(0,'+y_offset+')';});b_spill_container.append('rect').attr('class','bottom_spillover').attr('fill',viz.background_color)//!! prog_colors
.attr('width',viz.svg_dim.width).attr('height',2*viz.svg_dim.height);x_offset=viz.clust.margin.left;y_offset=0;b_spill_container.append('g').classed('col_dendro_icons_container',true).attr('transform','translate('+x_offset+','+y_offset+')').append('g').classed('col_dendro_icons_group',true);if(params.viz.show_dendrogram){make_dendro_crop_buttons(cgm,'col');}var x_offset=viz.clust.margin.left+viz.clust.dim.width;var y_offset=viz.clust.margin.top+viz.clust.dim.height;var tmp_width=viz.cat_room.col+viz.clust.dim.width;var tmp_height=viz.cat_room.row+10*viz.uni_margin;d3.select(viz.viz_svg).append('rect').attr('fill',viz.background_color).attr('width',tmp_width).attr('height',tmp_height).attr('transform',function(){return'translate('+x_offset+','+y_offset+')';}).classed('white_bars',true).classed('dendro_corner_spillover',true);// hide spillover left top of col dendrogram
x_offset=0;y_offset=viz.clust.margin.top+viz.clust.dim.height;tmp_width=viz.clust.margin.left;tmp_height=viz.clust.dim.height*10;d3.select(viz.viz_svg).append('rect').attr('fill',viz.background_color).attr('width',tmp_width).attr('height',tmp_height).attr('transform',function(){return'translate('+x_offset+','+y_offset+')';}).classed('white_bars',true).classed('dendro_col_spillover',true);ini_cat_reorder(cgm);};/***/},/* 141 *//***/function(module,exports){module.exports=function get_cat_title(viz,inst_cat,inst_rc){var cat_title;// make default title if none is given
if(viz.cat_names[inst_rc][inst_cat]===inst_cat){var inst_num=parseInt(inst_cat.split('-')[1],10)+1;// generate placeholder title
cat_title='Category '+inst_num;}else{// make real title
cat_title=viz.cat_names[inst_rc][inst_cat];}return cat_title;};/***/},/* 142 *//***/function(module,exports,__webpack_require__){var all_reorder=__webpack_require__(143);var underscore=__webpack_require__(3);module.exports=function ini_cat_reorder(cgm){/* eslint-disable */var params=cgm.params;underscore.each(['row','col'],function(inst_rc){if(params.viz.show_categories[inst_rc]){d3.selectAll(params.root+' .'+inst_rc+'_cat_super').on('dblclick',function(){if(params.sim_mat){inst_rc='both';}d3.selectAll(params.root+' .toggle_'+inst_rc+'_order .btn').classed('active',false);var order_id=this.__data__.replace('-','_')+'_index';if(params.viz.sim_mat){all_reorder(cgm,order_id,'row');all_reorder(cgm,order_id,'col');}else{all_reorder(cgm,order_id,inst_rc);}});}});};/***/},/* 143 *//***/function(module,exports,__webpack_require__){var toggle_dendro_view=__webpack_require__(104);var show_visible_area=__webpack_require__(134);var ini_zoom_info=__webpack_require__(86);var calc_downsampled_levels=__webpack_require__(77);var two_translate_zoom=__webpack_require__(144);var get_previous_zoom=__webpack_require__(129);var underscore=__webpack_require__(3);module.exports=function(cgm,inst_order,inst_rc){var params=cgm.params;var prev_zoom=get_previous_zoom(params);var delay_reorder=0;if(prev_zoom.zoom_y!=1||prev_zoom.zoom_x!=1){// reset zoom before reordering
two_translate_zoom(cgm,0,0,1);delay_reorder=1200;}// row/col names are swapped, will improve later
var other_rc;if(inst_rc==='row'){other_rc='col';}else if(inst_rc==='col'){other_rc='row';}params.viz.run_trans=true;// save order state
if(other_rc==='row'){params.viz.inst_order.row=inst_order;}else if(other_rc==='col'){params.viz.inst_order.col=inst_order;}if(params.viz.show_dendrogram){toggle_dendro_view(cgm,inst_rc);}if(other_rc==='row'){params.viz.x_scale.domain(params.matrix.orders[params.viz.inst_order.row+'_row']);}else if(other_rc=='col'){params.viz.y_scale.domain(params.matrix.orders[params.viz.inst_order.col+'_col']);}// only animate transition if there are a small number of tiles
var t;if(d3.selectAll(params.root+' .tile')[0].length<params.matrix.def_large_matrix){t=d3.select(params.root+' .viz_svg').transition().duration(2500).delay(delay_reorder);}else{t=d3.select(params.root+' .viz_svg');}var row_nodes_names=params.network_data.row_nodes_names;var col_nodes_names=params.network_data.col_nodes_names;// only update matrix if not downsampled (otherwise rows are updated)
if(params.viz.ds_level===-1){t.selectAll('.row').attr('transform',function(d){var inst_index=underscore.indexOf(row_nodes_names,d.name);return'translate(0,'+params.viz.y_scale(inst_index)+')';}).selectAll('.tile').attr('transform',function(d){return'translate('+params.viz.x_scale(d.pos_x)+' , 0)';});t.selectAll('.tile_up').attr('transform',function(d){return'translate('+params.viz.x_scale(d.pos_x)+' , 0)';});t.selectAll('.tile_dn').attr('transform',function(d){return'translate('+params.viz.x_scale(d.pos_x)+' , 0)';});}// Move Row Labels
t.select('.row_label_zoom_container').selectAll('.row_label_group').attr('transform',function(d){var inst_index=underscore.indexOf(row_nodes_names,d.name);return'translate(0,'+params.viz.y_scale(inst_index)+')';});// Move Col Labels
t.select('.col_zoom_container').selectAll('.col_label_text').attr('transform',function(d){var inst_index=underscore.indexOf(col_nodes_names,d.name);return'translate('+params.viz.x_scale(inst_index)+') rotate(-90)';});// reorder row categories
t.selectAll('.row_cat_group').attr('transform',function(d){var inst_index=underscore.indexOf(row_nodes_names,d.name);return'translate(0,'+params.viz.y_scale(inst_index)+')';});// reorder col_class groups
t.selectAll('.col_cat_group').attr('transform',function(d){var inst_index=underscore.indexOf(col_nodes_names,d.name);return'translate('+params.viz.x_scale(inst_index)+',0)';});// redefine x and y positions
params.network_data.links.forEach(function(d){d.x=params.viz.x_scale(d.target);d.y=params.viz.y_scale(d.source);});params.zoom_info=ini_zoom_info();// calculate downsmapling if necessary
if(params.viz.ds_num_levels>0&&params.viz.ds_level>=0){calc_downsampled_levels(params);var zooming_stopped=true;var zooming_out=true;var make_all_rows=true;// show_visible_area is also run with two_translate_zoom, but at that point
// the parameters were not updated and two_translate_zoom if only run
// if needed to reset zoom
show_visible_area(cgm,zooming_stopped,zooming_out,make_all_rows);}setTimeout(function(){params.viz.run_trans=false;},2500);};/***/},/* 144 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);var label_constrain_and_trim=__webpack_require__(145);var show_visible_area=__webpack_require__(134);var ini_zoom_info=__webpack_require__(86);var toggle_grid_lines=__webpack_require__(149);var underscore=__webpack_require__(3);module.exports=function two_translate_zoom(cgm,pan_dx,pan_dy,fin_zoom){// console.log('pan_dy: ' + String(pan_dy))
var params=cgm.params;d3.selectAll(params.viz.root_tips).style('display','none');params.zoom_info=ini_zoom_info();show_visible_area(cgm);// do not allow while transitioning, e.g. reordering
if(!params.viz.run_trans){// define the commonly used variable half_height
var half_height=params.viz.clust.dim.height/2;// y pan room, the pan room has to be less than half_height since
// zooming in on a gene that is near the top of the clustergram also causes
// panning out of the visible region
var y_pan_room=half_height/fin_zoom;// prevent visualization from panning down too much
// when zooming into genes near the top of the clustergram
if(pan_dy>=half_height-y_pan_room){// console.log(' prevent visualization from panning down too much')
// explanation of panning rules
/////////////////////////////////
/*
	        prevent the clustergram from panning down too much
	        if the amount of panning is equal to the half_height then it needs to be reduced
	        effectively, the the visualization needs to be moved up (negative) by some factor
	        of the half-width-of-the-visualization.
	         If there was no zooming involved, then the
	        visualization would be centered first, then panned to center the top term
	        this would require a
	        correction to re-center it. However, because of the zooming the offset is
	        reduced by the zoom factor (this is because the panning is occurring on something
	        that will be zoomed into - this is why the pan_dy value is not scaled in the two
	        translate transformations, but it has to be scaled afterwards to set the translate
	        vector)
	        pan_dy = half_height - (half_height)/fin_zoom
	         if pan_dy is greater than the pan room, then panning has to be restricted
	        start by shifting back up (negative) by half_height/fin_zoom then shift back down
	        by the difference between half_height and pan_dy (so that the top of the clustergram is
	        visible)
	      */var shift_top_viz=half_height-pan_dy;var shift_up_viz=-half_height/fin_zoom+shift_top_viz;// reduce pan_dy so that the visualization does not get panned to far down
pan_dy=pan_dy+shift_up_viz;}// prevent visualization from panning up too much
// when zooming into genes at the bottom of the clustergram
if(pan_dy<-(half_height-y_pan_room)){shift_top_viz=half_height+pan_dy;shift_up_viz=half_height/fin_zoom-shift_top_viz;//- move_up_one_row;
// reduce pan_dy so that the visualization does not get panned to far down
pan_dy=pan_dy+shift_up_viz;}// will improve this !!
var zoom_y=fin_zoom;var zoom_x=1;// search duration - the duration of zooming and panning
var search_duration=700;// center_y
var center_y=-(zoom_y-1)*half_height;// transform clust group
////////////////////////////
d3.select(params.root+' .clust_group').transition().duration(search_duration)// first apply the margin transformation
// then zoom, then apply the final transformation
.attr('transform','translate('+[0,0+center_y]+')'+' scale('+zoom_x+','+zoom_y+')'+'translate('+[pan_dx,pan_dy]+')');// transform row labels
d3.select(params.root+' .row_label_zoom_container').transition().duration(search_duration).attr('transform','translate('+[0,center_y]+')'+' scale('+zoom_y+','+zoom_y+')'+'translate('+[0,pan_dy]+')');// transform row_cat_container
// use the offset saved in params, only zoom in the y direction
d3.select(params.root+' .row_cat_container').transition().duration(search_duration).attr('transform','translate('+[0,center_y]+')'+' scale('+1+','+zoom_y+')'+'translate('+[0,pan_dy]+')');d3.select(params.root+' .row_dendro_container').transition().duration(search_duration).attr('transform','translate('+[0,center_y]+')'+' scale('+zoom_x+','+zoom_y+')'+'translate('+[params.viz.uni_margin/2,pan_dy]+')');// toggle crop buttons
var inst_button_opacity;underscore.each(['row','col'],function(inst_rc){inst_button_opacity=d3.select(params.root+' .'+inst_rc+'_dendro_crop_buttons').style('opacity');d3.selectAll(params.root+' .'+inst_rc+'_dendro_crop_buttons').style('opacity',0);setTimeout(show_crop_buttons,700,inst_rc,inst_button_opacity);});// transform col labels
d3.select(params.root+' .col_zoom_container').transition().duration(search_duration).attr('transform',' scale('+zoom_x+','+zoom_x+')'+'translate('+[pan_dx,0]+')');// transform col_class
d3.select(params.root+' .col_cat_container').transition().duration(search_duration).attr('transform',' scale('+zoom_x+','+1+')'+'translate('+[pan_dx,0]+')');d3.select(params.root+' .col_dendro_container').transition().duration(search_duration).attr('transform',' scale('+zoom_x+','+1+')'+'translate('+[pan_dx,params.viz.uni_margin/2]+')');// set y translate: center_y is positive, positive moves the visualization down
// the translate vector has the initial margin, the first y centering, and pan_dy
// times the scaling zoom_y
var net_y_offset=params.viz.clust.margin.top+center_y+pan_dy*zoom_y;var net_x_offset=params.viz.clust.margin.left+pan_dx;// reset the zoom and translate
params.zoom_behavior.scale(zoom_y).translate([net_x_offset,net_y_offset]);label_constrain_and_trim(params);// re-size of the highlighting rects
/////////////////////////////////////////
if(d3.select(params.root+' .row_label_zoom_container text').empty()===false){d3.select(params.root+' .row_label_zoom_container').each(function(){// get the bounding box of the row label text
var bbox=d3.select(this).select('text')[0][0].getBBox();// use the bounding box to set the size of the rect
d3.select(this).select('rect').attr('x',bbox.x*0.5).attr('y',0).attr('width',bbox.width*0.5).attr('height',params.viz.y_scale.rangeBand()).style('fill','yellow');});}// reset crop button zooming
d3.select(params.root+' .row_dendro_icons_group').attr('transform','translate('+[0,0+center_y]+')'+' scale('+zoom_x+','+zoom_y+')'+'translate('+[pan_dx,pan_dy]+')');d3.select(params.root+' .row_dendro_icons_group').selectAll('path').attr('transform',function(d){var inst_x=params.viz.uni_margin;var inst_y=d.pos_mid;return'translate('+inst_x+','+inst_y+') '+'scale(1, '+1/zoom_y+')';});// console.log('zooming x and y')
// console.log(zoom_x)
// console.log(zoom_y)
// need to improve behavior
d3.select(params.root+' .col_dendro_icons_group').attr('transform',function(){var inst_trans=// 'translate(' + [0, 0 + center_y] + ')' +
' scale('+zoom_x+','+zoom_y+')';// + 'translate(' + [pan_dx, pan_dy ] + ')';
return inst_trans;});d3.select(params.root+' .col_dendro_icons_group').selectAll('path').attr('transform',function(d){var inst_x=d.pos_mid;var inst_y=params.viz.uni_margin;// return 'translate('+ inst_x +',' + inst_y + ') ' + 'scale('+1/zoom_x+',1)';
return'translate('+inst_x+','+inst_y+') '+'scale(1,1)';});// column value bars
///////////////////////
// reduce the height of the column value bars based on the zoom applied
// recalculate the height and divide by the zooming scale
// col_label_obj.select('rect')
if(utils.has(params.network_data.col_nodes[0],'value')){d3.selectAll(params.root+' .col_bars').attr('width',function(d){var inst_value=0;if(d.value>0){inst_value=params.labels.bar_scale_col(d.value)/zoom_x;}return inst_value;});}if(utils.has(params.network_data.row_nodes[0],'value')){d3.selectAll(params.root+' .row_bars').transition().duration(search_duration).attr('width',function(d){var inst_value=0;inst_value=params.labels.bar_scale_row(Math.abs(d.value))/zoom_y;return inst_value;}).attr('x',function(d){var inst_value=0;inst_value=-params.labels.bar_scale_row(Math.abs(d.value))/zoom_y;return inst_value;});}toggle_grid_lines(params);}function show_crop_buttons(inst_rc,inst_button_opacity){d3.selectAll(params.root+' .'+inst_rc+'_dendro_crop_buttons').transition().duration(search_duration).style('opacity',inst_button_opacity);}};/***/},/* 145 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);var trim_text=__webpack_require__(146);var constrain_font_size=__webpack_require__(147);module.exports=function label_constrain_and_trim(params){// console.log('label_constrain_and_trim');
// reset text in rows and columns
d3.selectAll(params.root+' .row_label_group').select('text').text(function(d){return utils.normal_name(d);});d3.selectAll(params.root+' .col_label_text').select('text').text(function(d){return utils.normal_name(d);});constrain_font_size(params);d3.selectAll(params.root+' .row_label_group').each(function(){trim_text(params,this,'row');});d3.selectAll(params.root+' .col_label_group').each(function(){trim_text(params,this,'col');});};/***/},/* 146 *//***/function(module,exports){module.exports=function(params,inst_selection,inst_rc){if(d3.select(inst_selection).style('display')!='none'){// trim text that is longer than the container
var inst_zoom;var inst_width;var trimmed_text;var current_num_char;var inst_text;var original_text;var keep_num_char;var i;var max_width=params.viz.norm_labels.width[inst_rc];if(inst_rc==='row'){if(params.viz.zoom_ratio.y){inst_zoom=params.zoom_behavior.scale()/params.viz.zoom_ratio.y;}else{inst_zoom=params.zoom_behavior.scale();}// num_trims = params.labels.row_max_char;
}else{if(params.viz.zoom_ratio.x>1){inst_zoom=params.zoom_behavior.scale()/params.viz.zoom_ratio.x;}else{inst_zoom=params.zoom_behavior.scale();}// num_trims = params.labels.col_max_char;
}var num_trims;d3.select(inst_selection).select('text').each(function(d){num_trims=d.name.length;});var tmp_width=d3.select(inst_selection).select('text').node().getBBox().width;inst_width=calc_width(tmp_width,inst_zoom);if(inst_width>max_width){for(i=1;i<num_trims;i++){if(inst_width>max_width){d3.select(inst_selection).select('text').text(trim);tmp_width=d3.select(inst_selection).select('text').node().getBBox().width;inst_width=calc_width(tmp_width,inst_zoom);}}}else if(inst_width<max_width*0.75){for(i=1;i<num_trims;i++){if(inst_width<max_width*0.75){d3.select(inst_selection).select('text').text(add_back);tmp_width=d3.select(inst_selection).select('text').node().getBBox().width;inst_width=calc_width(tmp_width,inst_zoom);}}}}function trim(){inst_text=d3.select(this).text();current_num_char=inst_text.length;keep_num_char=current_num_char-3;trimmed_text=inst_text.substring(0,keep_num_char)+'..';return trimmed_text;}function add_back(d){inst_text=d3.select(this).text();if(inst_text.slice(-2)==='..'){current_num_char=inst_text.length-2;}else{current_num_char=inst_text.length;}original_text=d.name;keep_num_char=current_num_char+2;trimmed_text=original_text.substring(0,keep_num_char)+'..';// if '..' was added to original text
if(trimmed_text.length>original_text.length){trimmed_text=original_text;}return trimmed_text;}function calc_width(tmp_width,inst_zoom){if(inst_zoom<1){inst_width=tmp_width;}else{inst_width=tmp_width*inst_zoom;}return inst_width;}};/***/},/* 147 *//***/function(module,exports,__webpack_require__){var calc_real_font_size=__webpack_require__(148);module.exports=function constrain_font_size(params){var tmp_font_size=params.labels.default_fs_row;var inst_zoom;var min_font_size=3;var real_font_size=calc_real_font_size(params);// rows
////////////////////////////////////
if(real_font_size.row>min_font_size){if(real_font_size.row>params.labels.max_allow_fs){if(params.viz.zoom_ratio.y){inst_zoom=params.zoom_behavior.scale()/params.viz.zoom_ratio.y;}else{inst_zoom=params.zoom_behavior.scale();}if(inst_zoom<1){inst_zoom=1;}tmp_font_size=params.labels.max_allow_fs/inst_zoom;d3.selectAll(params.root+' .row_label_group').select('text').style('font-size',tmp_font_size+'px').attr('y',params.viz.rect_height*0.5+tmp_font_size*0.35);}else{d3.selectAll(params.root+' .row_label_group').select('text').style('font-size',params.labels.default_fs_row+'px').attr('y',params.viz.rect_height*0.5+params.labels.default_fs_row*0.35);}}// columns
//////////////////////////////////////
if(real_font_size.col>min_font_size){if(real_font_size.col>params.labels.max_allow_fs){if(params.viz.zoom_ratio.x>1){inst_zoom=params.zoom_behavior.scale()/params.viz.zoom_ratio.x;}else{inst_zoom=params.zoom_behavior.scale();}if(inst_zoom<1){inst_zoom=1;}tmp_font_size=params.labels.max_allow_fs/inst_zoom;if(tmp_font_size>0.7*params.viz.rect_width){tmp_font_size=0.7*params.viz.rect_width;}d3.selectAll(params.root+' .col_label_text').select('text').style('font-size',tmp_font_size+'px');}else{d3.selectAll(params.root+' .col_label_text').select('text').style('font-size',params.labels.default_fs_col+'px');}}};/***/},/* 148 *//***/function(module,exports){module.exports=function calc_real_font_size(params){var real_font_size={};// zoom_switch behavior has to change with zoom_ratio.y
if(params.viz.zoom_ratio.x>1){real_font_size.row=params.labels.default_fs_row*params.zoom_behavior.scale();real_font_size.col=params.labels.default_fs_col*params.zoom_behavior.scale();}else{real_font_size.row=params.labels.default_fs_row*params.zoom_behavior.scale()/params.viz.zoom_ratio.y;real_font_size.col=params.labels.default_fs_col*params.zoom_behavior.scale();}return real_font_size;};/***/},/* 149 *//***/function(module,exports){module.exports=function toggle_grid_lines(params){if(params.zoom_info.zoom_x*params.viz.border_width.x>1){d3.selectAll(params.root+' .vert_lines').select('line').style('display','block').style('opacity',0).transition().style('opacity',1);}else{d3.selectAll(params.root+' .vert_lines').select('line').style('display','none');}if(params.zoom_info.zoom_y*params.viz.border_width.y>1){d3.selectAll(params.root+' .horz_lines').select('line').style('display','block').style('opacity',0).transition().style('opacity',1);}else{d3.selectAll(params.root+' .horz_lines').select('line').style('display','none');}};/***/},/* 150 *//***/function(module,exports,__webpack_require__){var get_cat_title=__webpack_require__(141);var d3_tip_custom=__webpack_require__(98);module.exports=function make_row_cat_super_labels(cgm){var params=cgm.params;var viz=params.viz;var extra_x_room=2.75;if(d3.select(params.root+' .row_cat_label_container').empty()){d3.select(cgm.params.viz.viz_svg).append('g').classed('row_cat_label_container',true);// append background section for optional value-bars (e.g. enrichment pvals)
d3.select(cgm.params.viz.viz_svg+' .row_cat_label_container').append('g').classed('row_cat_label_bar_container',true);}var x_offset=viz.clust.margin.left+viz.clust.dim.width+viz.uni_margin;var y_offset=viz.norm_labels.margin.top+viz.norm_labels.width.col+2.5*viz.uni_margin;var cat_text_size=1.15*viz.cat_room.symbol_width;var cat_super_opacity=0.65;var extra_y_room=1.25;d3.select(params.root+' .row_cat_label_container').attr('transform',function(){x_offset=viz.norm_labels.margin.left+viz.norm_labels.width.row+viz.cat_room.symbol_width+extra_x_room*viz.uni_margin;y_offset=viz.clust.margin.top-viz.uni_margin;return'translate('+x_offset+','+y_offset+') rotate(-90)';});// clear old categories
d3.selectAll(params.root+' .row_cat_label_container text').remove();d3.selectAll(params.root+' .row_cat_selection_bar').remove();// d3.selectAll(params.root+' .row_cat_label_bar_container rect').remove();
// remove any old row_cat_super tooltips from this visualization
d3.selectAll(cgm.params.viz.root_tips+'_row_cat_super').remove();// d3-tooltip
var tmp_y_offset=50;// viz.clust.margin.top - viz.uni_margin;
var tmp_x_offset=-75;var cat_tip=d3_tip_custom().attr('class',function(){var root_tip_selector=params.viz.root_tips.replace('.','');var class_string=root_tip_selector+' d3-tip '+root_tip_selector+'_row_cat_super';return class_string;}).direction('south_custom').offset([tmp_y_offset,tmp_x_offset]).style('display','none').style('opacity',0).html(function(d){var full_string;var tmp_string=params.network_data.row_nodes[0][d];if(tmp_string.indexOf('<p>')>-1){var start_string=tmp_string.split(': ')[0];var end_string=tmp_string.split('<p>')[1];full_string=start_string+'<p>'+end_string;}else{full_string=get_cat_title(viz,d,'row');}return full_string;});var unit_length=extra_y_room*viz.cat_room.symbol_width;var bar_width=unit_length*0.9;// show row label categories even if viewing a simmilarity matrix
d3.select(params.root+' .row_cat_label_container').selectAll().data(viz.all_cats.row).enter().append('text').style('width','100px').style('height',bar_width+'px').classed('row_cat_super',true).style('font-size',cat_text_size+'px').style('opacity',cat_super_opacity).style('cursor','default').attr('transform',function(d){var inst_y=extra_y_room*viz.cat_room.symbol_width*parseInt(d.split('-')[1],10);return'translate(0,'+inst_y+')';}).text(function(d){return get_cat_title(viz,d,'row');});// selection bar
///////////////////////////////
d3.select(params.root+' .row_cat_label_container').selectAll().data(viz.all_cats.row).enter().append('rect').classed('row_cat_super',true).classed('row_cat_selection_bar',true).style('height',bar_width+'px').style('fill','green').style('width','120px').style('opacity',0).attr('transform',function(d){var inst_y=unit_length*(parseInt(d.split('-')[1],10)-0.75);return'translate(0,'+inst_y+')';}).on('mouseover',function(d){d3.selectAll(params.viz.root_tips+'_row_cat_super').style('display','block').style('opacity',1);cat_tip.show(d);}).on('mouseout',function(){cat_tip.hide(this);// might not need
d3.selectAll('.d3-tip').style('display','none');d3.selectAll(params.viz.root_tips+'_row_cat_super').style('display','none').style('opacity',0);});// row category super-label mouseover
//////////////////////////////////////
if(d3.select(params.root+' .row_cat_selection_bar').empty()===false){d3.selectAll(params.root+' .row_cat_selection_bar').call(cat_tip);}if(_.has(params.network_data,'row_cat_bars')){// Enrichrgram title
/////////////////////
d3.select(params.root+' .enr_title').remove();var enr_title=d3.select(params.root+' .viz_svg').append('g').classed('enr_title',true).attr('transform',function(){var trans=d3.select(params.root+' .row_cat_label_container').attr('transform').split('(')[1].split(')')[0];var x_offset=Number(trans.split(',')[0])-10;return'translate('+String(x_offset)+', 0)';});enr_title.append('rect').attr('width',params.viz.cat_room.row).attr('height',25).attr('fill','white');var library_string=params.network_data.enrichrgram_lib.substring(0,40);enr_title.append('text').attr('transform','translate(0, 17)').text(library_string.replace(/_/g,' ')).style('font-size','15px').attr('font-family','"Helvetica Neue", Helvetica, Arial, sans-serif');// Enrichr bars
////////////////////
d3.selectAll(params.root+' .enrichr_bars').remove();var bar_height=params.viz.clust.margin.top-35;var max_score=params.network_data.row_cat_bars[0];var bar_scale=d3.scale.linear().domain([0,max_score]).range([0,bar_height]);d3.select(params.root+' .row_cat_label_bar_container').selectAll().data(params.network_data.row_cat_bars).enter().append('rect').classed('enrichr_bars',true).attr('height',bar_width+'px').attr('fill','red').attr('width',function(d){var bar_length=bar_scale(d);return bar_length+'px';}).attr('opacity',0.4).attr('transform',function(d,i){var inst_y=unit_length*(i-0.75);return'translate(0, '+inst_y+')';});}};/***/},/* 151 *//***/function(module,exports,__webpack_require__){var resize_viz=__webpack_require__(152);module.exports=function initialize_resizing(cgm){var params=cgm.params;var exp_button;// d3.select(window).on('resize', null);
// // resize window
// if (params.viz.resize) {
//   d3.select(window).on('resize', function () {
//     d3.select(params.viz.viz_svg).style('opacity', 0.5);
//     var wait_time = 500;
//     if (params.viz.run_trans === true) {
//       wait_time = 2500;
//     }
//     setTimeout(resize_viz, wait_time, params);
//   });
// }
// if (params.viz.expand_button) {
d3.select(params.root+' .expand_button').on('click',null);var expand_opacity=0.4;if(d3.select(params.root+' .expand_button').empty()){exp_button=d3.select(params.viz.viz_svg).append('text').attr('class','expand_button');}else{exp_button=d3.select(params.root+' .expand_button');}exp_button.attr('text-anchor','middle').attr('dominant-baseline','central').attr('font-family','FontAwesome').attr('font-size','30px').text(function(){if(params.viz.is_expand===false){// expand button
return'\uF0B2';}else{// menu button
return'\uF0C9';}}).attr('y','25px').attr('x','25px').style('cursor','pointer').style('opacity',expand_opacity).on('mouseover',function(){d3.select(this).style('opacity',0.75);}).on('mouseout',function(){d3.select(this).style('opacity',expand_opacity);}).on('click',function(){// expand view
if(params.viz.is_expand===false){d3.select(this).text(function(){// menu button
return'\uF0C9';});params.viz.is_expand=true;d3.selectAll(params.root+' .borders').style('fill','white');// d3.select(params.root+' .footer_section').style('display', 'none');
d3.select(params.root+' .sidebar_wrapper').style('display','none');// contract view
}else{d3.select(this).text(function(){// expand button
return'\uF0B2';});params.viz.is_expand=false;d3.selectAll(params.root+' .borders').style('fill','#eee');// d3.select(params.root+' .footer_section').style('display', 'block');
d3.select(params.root+' .viz_wrapper').style('width','100px');d3.select(params.root+' .sidebar_wrapper').style('display','block');}// // resize parent div
// set_viz_wrapper_size(params);
d3.select(params.viz.viz_svg).style('opacity',0.5);var wait_time=500;if(params.viz.run_trans==true){wait_time=2500;}setTimeout(resize_viz,wait_time,cgm);});// }
};/***/},/* 152 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);var run_zoom=__webpack_require__(153);var ini_doubleclick=__webpack_require__(161);var reset_zoom=__webpack_require__(162);var resize_dendro=__webpack_require__(163);var resize_super_labels=__webpack_require__(164);var resize_spillover=__webpack_require__(165);var resize_borders=__webpack_require__(166);var resize_row_labels=__webpack_require__(167);var resize_highlights=__webpack_require__(168);var resize_row_viz=__webpack_require__(169);var resize_col_labels=__webpack_require__(170);var resize_col_text=__webpack_require__(171);var resize_col_triangle=__webpack_require__(172);var resize_col_hlight=__webpack_require__(173);var recalc_params_for_resize=__webpack_require__(174);var resize_row_tiles=__webpack_require__(175);var resize_label_bars=__webpack_require__(176);var label_constrain_and_trim=__webpack_require__(145);var make_dendro_triangles=__webpack_require__(105);var toggle_dendro_view=__webpack_require__(104);var show_visible_area=__webpack_require__(134);var calc_viz_dimensions=__webpack_require__(68);var position_play_button=__webpack_require__(177);var make_row_cat_super_labels=__webpack_require__(150);var ini_cat_reorder=__webpack_require__(142);var position_dendro_slider=__webpack_require__(178);var position_tree_icon=__webpack_require__(179);var position_filter_icon=__webpack_require__(180);var position_tree_menu=__webpack_require__(181);var ini_zoom_info=__webpack_require__(86);var grid_lines_viz=__webpack_require__(182);var underscore=__webpack_require__(3);module.exports=function resize_viz(cgm){var params=cgm.params;var cont_dim=calc_viz_dimensions(params);d3.select(params.root+' .play_button');// .style('opacity', 0.2);
d3.select(params.root+' .sidebar_wrapper').style('height',cont_dim.height+'px');d3.select(params.viz.viz_wrapper)// .style('float', 'left')
.style('margin-top',cont_dim.top+'px').style('width',cont_dim.width+'px').style('height',cont_dim.height+'px');params=recalc_params_for_resize(params);params.zoom_info=ini_zoom_info();reset_zoom(params);var svg_group=d3.select(params.viz.viz_svg);// redefine x and y positions
underscore.each(params.network_data.links,function(d){d.x=params.viz.x_scale(d.target);d.y=params.viz.y_scale(d.source);});// disable zoom while transitioning
svg_group.on('.zoom',null);params.zoom_behavior.scaleExtent([1,params.viz.square_zoom*params.viz.zoom_ratio.x]).on('zoom',function(){run_zoom(cgm);});// reenable zoom after transition
if(params.viz.do_zoom){svg_group.call(params.zoom_behavior);}// prevent normal double click zoom etc
ini_doubleclick(cgm);svg_group.attr('width',params.viz.svg_dim.width).attr('height',params.viz.svg_dim.height);svg_group.select('.super_background').style('width',params.viz.svg_dim.width).style('height',params.viz.svg_dim.height);svg_group.select('.grey_background').attr('width',params.viz.clust.dim.width).attr('height',params.viz.clust.dim.height);setTimeout(position_play_button,100,params);var row_nodes=params.network_data.row_nodes;var row_nodes_names=utils.pluck(row_nodes,'name');resize_row_tiles(params,svg_group);svg_group.selectAll('.highlighting_rect').attr('width',params.viz.x_scale.rangeBand()*0.80).attr('height',params.viz.y_scale.rangeBand()*0.80);resize_highlights(params);// resize row labels
///////////////////////////
resize_row_labels(params,svg_group);resize_row_viz(params,svg_group);// change the size of the highlighting rects
svg_group.selectAll('.row_label_group').each(function(){var bbox=d3.select(this).select('text')[0][0].getBBox();d3.select(this).select('rect').attr('x',bbox.x).attr('y',0).attr('width',bbox.width).attr('height',params.viz.rect_height).style('fill','yellow').style('opacity',function(d){var inst_opacity=0;// highlight target genes
if(d.target===1){inst_opacity=1;}return inst_opacity;});});// necessary to properly position row labels vertically
svg_group.selectAll('.row_label_group').select('text').attr('y',params.viz.rect_height*0.5+params.labels.default_fs_row*0.35);if(utils.has(params.network_data.row_nodes[0],'value')){resize_label_bars(cgm,svg_group);}svg_group.selectAll('.row_cat_group').attr('transform',function(d){var inst_index=underscore.indexOf(row_nodes_names,d.name);return'translate(0, '+params.viz.y_scale(inst_index)+')';});svg_group.selectAll('.row_cat_group').select('path').attr('d',function(){var origin_x=params.viz.cat_room.symbol_width-1;var origin_y=0;var mid_x=1;var mid_y=params.viz.rect_height/2;var final_x=params.viz.cat_room.symbol_width-1;var final_y=params.viz.rect_height;var output_string='M '+origin_x+','+origin_y+' L '+mid_x+','+mid_y+' L '+final_x+','+final_y+' Z';return output_string;});var is_resize=true;if(params.viz.show_dendrogram){make_dendro_triangles(cgm,'row',is_resize);make_dendro_triangles(cgm,'col',is_resize);resize_dendro(params,svg_group);toggle_dendro_view(cgm,'row',0);toggle_dendro_view(cgm,'col',0);}else{resize_dendro(params,svg_group);}resize_col_labels(params,svg_group);resize_col_text(params,svg_group);resize_col_triangle(params,svg_group);resize_col_hlight(params,svg_group);resize_super_labels(params,svg_group);resize_spillover(params.viz,svg_group);grid_lines_viz(params);resize_borders(params,svg_group);// reset zoom and translate
params.zoom_behavior.scale(1).translate([params.viz.clust.margin.left,params.viz.clust.margin.top]);label_constrain_and_trim(params);// reposition matrix
d3.select(params.root+' .clust_container').attr('transform','translate('+params.viz.clust.margin.left+','+params.viz.clust.margin.top+')');// removed, this was causing bugs
if(cgm.params.viz.ds_level===-1){show_visible_area(cgm);}make_row_cat_super_labels(cgm);d3.select(params.viz.viz_svg).style('opacity',1);ini_cat_reorder(cgm);d3.select(cgm.params.root+' .row_slider_group').style('opacity',0);d3.select(cgm.params.root+' .col_slider_group').style('opacity',0);setTimeout(position_dendro_slider,500,cgm,'row');setTimeout(position_dendro_slider,500,cgm,'col');setTimeout(position_tree_icon,500,cgm);setTimeout(position_tree_menu,500,cgm);setTimeout(position_filter_icon,500,cgm);};/***/},/* 153 *//***/function(module,exports,__webpack_require__){var run_transformation=__webpack_require__(154);var zoom_rules_y=__webpack_require__(159);var zoom_rules_x=__webpack_require__(160);module.exports=function zoomed(cgm){var params=cgm.params;var zoom_info={};zoom_info.zoom_x=d3.event.scale;zoom_info.zoom_y=d3.event.scale;// subtract away the margin to easily calculate pan_room etc.
zoom_info.trans_x=params.zoom_behavior.translate()[0]-params.viz.clust.margin.left;zoom_info.trans_y=params.zoom_behavior.translate()[1]-params.viz.clust.margin.top;d3.selectAll(params.viz.root_tips).style('display','none');// transfer zoom_info to params
params.zoom_info=zoom_rules_y(params,zoom_info);params.zoom_info=zoom_rules_x(params,zoom_info);// do not run transformation if moving slider
if(params.is_slider_drag===false&&params.is_cropping===false){// reset translate vector - add back margins to trans_x and trans_y
var new_x=params.zoom_info.trans_x+params.viz.clust.margin.left;var new_y=params.zoom_info.trans_y+params.viz.clust.margin.top;params.zoom_behavior.translate([new_x,new_y]);cgm.params=params;run_transformation(cgm);}};/***/},/* 154 *//***/function(module,exports,__webpack_require__){var constrain_font_size=__webpack_require__(147);var show_visible_area=__webpack_require__(134);var resize_label_val_bars=__webpack_require__(155);var zoom_crop_triangles=__webpack_require__(112);var get_previous_zoom=__webpack_require__(129);var run_when_zoom_stopped=__webpack_require__(156);var check_zoom_stop_status=__webpack_require__(158);module.exports=function run_transformation(cgm){var params=cgm.params;var zoom_info=params.zoom_info;var prev_zoom=get_previous_zoom(params);d3.select(params.root+' .clust_group').attr('transform','translate('+[zoom_info.trans_x,zoom_info.trans_y]+') scale('+zoom_info.zoom_x+','+zoom_info.zoom_y+')');d3.select(params.root+' .row_label_zoom_container').attr('transform','translate('+[0,zoom_info.trans_y]+') scale('+zoom_info.zoom_y+')');d3.select(params.root+' .col_zoom_container').attr('transform','translate('+[zoom_info.trans_x,0]+') scale('+zoom_info.zoom_x+')');d3.select(params.root+' .row_cat_container').attr('transform','translate('+[0,zoom_info.trans_y]+') scale( 1,'+zoom_info.zoom_y+')');d3.select(params.root+' .row_dendro_container').attr('transform','translate('+[params.viz.uni_margin/2,zoom_info.trans_y]+') '+'scale( 1,'+zoom_info.zoom_y+')');d3.select(params.root+' .row_dendro_icons_group').attr('transform',function(){var inst_y=zoom_info.trans_y;var inst_translate='translate('+[0,inst_y]+') ';var inst_zoom='scale(1, '+zoom_info.zoom_y+')';var transform_string=inst_translate+inst_zoom;return transform_string;});d3.select(params.root+' .col_dendro_icons_group').attr('transform',function(){var inst_x=zoom_info.trans_x;var inst_translate='translate('+[inst_x,0]+')';var inst_zoom='scale('+zoom_info.zoom_x+', 1)';var transform_string=inst_translate+inst_zoom;return transform_string;});zoom_crop_triangles(params,zoom_info,'row');zoom_crop_triangles(params,zoom_info,'col');d3.select(params.root+' .col_cat_container').attr('transform','translate('+[zoom_info.trans_x,0]+') scale('+zoom_info.zoom_x+',1)');d3.select(params.root+' .col_dendro_container').attr('transform','translate('+[zoom_info.trans_x,params.viz.uni_margin/2]+') scale('+zoom_info.zoom_x+',1)');resize_label_val_bars(params,zoom_info);d3.select(params.root+' .viz_svg').attr('is_zoom',function(){var inst_zoom=Number(d3.select(params.root+' .viz_svg').attr('is_zoom'));d3.select(params.root+' .viz_svg').attr('stopped_zoom',1);return inst_zoom+1;});// this function runs with a slight delay and tells the visualization that
// this particular zoom event is over, reducing the total number of zoom
// events that need to finish
var not_zooming=function not_zooming(){d3.select(params.root+' .viz_svg').attr('is_zoom',function(){var inst_zoom=Number(d3.select(params.root+' .viz_svg').attr('is_zoom'));return inst_zoom-1;});};constrain_font_size(params);if(zoom_info.zoom_y<=prev_zoom.zoom_y){var zooming_out=false;if(zoom_info.zoom_y<prev_zoom.zoom_y){zooming_out=true;}// zooming has not stopped and zooming out is true
var zooming_stopped=false;show_visible_area(cgm,zooming_stopped,zooming_out);}setTimeout(not_zooming,50);setTimeout(check_if_zooming_has_stopped,100,cgm);function check_if_zooming_has_stopped(cgm){var params=cgm.params;var stop_attributes=check_zoom_stop_status(params);if(stop_attributes===true){// wait and double check that zooming has stopped
setTimeout(run_when_zoom_stopped,50,cgm);}}};/***/},/* 155 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);module.exports=function resize_label_val_bars(params){var zoom_info=params.zoom_info;// resize label bars if necessary
if(utils.has(params.network_data.row_nodes[0],'value')){d3.selectAll(params.root+' .row_bars').attr('width',function(d){var inst_value=0;inst_value=params.labels.bar_scale_row(Math.abs(d.value))/zoom_info.zoom_y;return inst_value;}).attr('x',function(d){var inst_value=0;inst_value=-params.labels.bar_scale_row(Math.abs(d.value))/zoom_info.zoom_y;return inst_value;});}if(utils.has(params.network_data.col_nodes[0],'value')){d3.selectAll(params.root+' .col_bars').attr('width',function(d){var inst_value=0;if(d.value>0){inst_value=params.labels.bar_scale_col(d.value)/zoom_info.zoom_x;}return inst_value;});}};/***/},/* 156 *//***/function(module,exports,__webpack_require__){var constrain_font_size=__webpack_require__(147);var trim_text=__webpack_require__(146);var num_visible_labels=__webpack_require__(157);var toggle_grid_lines=__webpack_require__(149);var show_visible_area=__webpack_require__(134);var check_zoom_stop_status=__webpack_require__(158);var underscore=__webpack_require__(3);module.exports=function run_when_zoom_stopped(cgm){var params=cgm.params;var stop_attributes=check_zoom_stop_status(params);if(stop_attributes===true){// ///////////////////////////////////////////////
// // zooming has stopped
// ///////////////////////////////////////////////
// console.log('\nZOOMING HAS ACTUALLY STOPPED\n============================');
// console.log(params.zoom_info.zoom_y)
underscore.each(['row','col'],function(inst_rc){d3.selectAll(params.root+' .'+inst_rc+'_label_group').select('text').style('opacity',1);d3.selectAll(params.root+' .'+inst_rc+'_cat_group').select('path').style('display','block');});show_visible_area(cgm,true);d3.selectAll(params.viz.root_tips).style('display','block');d3.selectAll(params.root+' .row_label_group').select('text').style('display','none');d3.selectAll(params.root+' .row_label_group').select('text').style('display','block');d3.select(params.root+' .viz_svg').attr('stopped_zoom',0);d3.selectAll(params.root+' .row_label_group').select('text').style('display','block');d3.selectAll(params.root+' .col_label_group').select('text').style('display','block');toggle_grid_lines(params);// reset x_offset
cgm.params.viz.x_offset=0;var max_labels_to_trim=150;// probably do not need
/////////////////////////
underscore.each(['row','col'],function(inst_rc){var inst_num_visible=num_visible_labels(params,inst_rc);if(inst_num_visible<max_labels_to_trim){d3.selectAll(params.root+' .'+inst_rc+'_label_group').each(function(){trim_text(params,this,inst_rc);});}});constrain_font_size(params);}};/***/},/* 157 *//***/function(module,exports){module.exports=function num_visible_labels(params,inst_rc){// counting the number of visible labels, probably not necessary
var num_visible;if(inst_rc==='row'){// initialize at high number
num_visible=10000;// only count visible rows if no downsampling
if(params.viz.ds_level===-1){num_visible=d3.selectAll(params.root+' .row')[0].length;}}else if(inst_rc==='col'){num_visible=d3.selectAll(params.root+' .'+inst_rc+'_label_text').filter(function(){return d3.select(this).style('display')!='none';})[0].length;}return num_visible;};/***/},/* 158 *//***/function(module,exports){module.exports=function check_zoom_stop_status(params){var inst_zoom=Number(d3.select(params.root+' .viz_svg').attr('is_zoom'));var check_stop=Number(d3.select(params.root+' .viz_svg').attr('stopped_zoom'));var stop_attributes=false;if(inst_zoom===0&&check_stop!=0){stop_attributes=true;}return stop_attributes;};/***/},/* 159 *//***/function(module,exports){module.exports=function zoom_rules_y(params,zoom_info){var viz=params.viz;// zoom in the x direction before zooming in the y direction
if(viz.zoom_ratio.y>1){if(zoom_info.zoom_y<viz.zoom_ratio.y){zoom_info.trans_y=0;zoom_info.zoom_y=1;}else{zoom_info.zoom_y=zoom_info.zoom_y/viz.zoom_ratio.y;}}// calculate panning room available in the y direction
zoom_info.pan_room_y=(zoom_info.zoom_y-1)*viz.clust.dim.height;// console.log( 'pan_room_y: ' +  String(zoom_info.pan_room_y) + ' ' + String(-zoom_info.trans_y))
// no positive panning or panning more than pan_room
if(zoom_info.trans_y>=0){zoom_info.trans_y=0;// console.log('y no positive panning\n\n')
}else if(zoom_info.trans_y<=-zoom_info.pan_room_y){zoom_info.trans_y=-zoom_info.pan_room_y;// console.log('y restrict pan room \n\n')
}return zoom_info;};/***/},/* 160 *//***/function(module,exports){module.exports=function zoom_rules_x(params,zoom_info){var viz=params.viz;// zoom in the y direction before zooming in the x direction
if(viz.zoom_ratio.x>1){if(zoom_info.zoom_x<viz.zoom_ratio.x){// remove this
// zoom_info.trans_x = - params.viz.clust.margin.left;
zoom_info.zoom_x=1;}else{zoom_info.zoom_x=zoom_info.zoom_x/viz.zoom_ratio.x;// console.log('********* zoom_x: ' + String(zoom_info.zoom_x))
// zoom_info.trans_x = zoom_info.trans_x + params.viz.x_offset;
// zoom_info.trans_x = zoom_info.trans_x * (params.zoom_info.zoom_x/params.zoom_info.zoom_y);
}}// calculate panning room available in the x direction
zoom_info.pan_room_x=(zoom_info.zoom_x-1)*viz.clust.dim.width;// console.log( 'pan_room_x: ' +  String(zoom_info.pan_room_x) + ' trans_x: ' + String(-zoom_info.trans_x))
// no positive panning or panning more than pan_room
if(zoom_info.trans_x>0){zoom_info.trans_x=0;// console.log('no positive panning\n\n')
}else if(zoom_info.trans_x<=-zoom_info.pan_room_x){zoom_info.trans_x=-zoom_info.pan_room_x;// console.log('******* restrict pan room\n\n')
}return zoom_info;};/***/},/* 161 *//***/function(module,exports,__webpack_require__){var two_translate_zoom=__webpack_require__(144);module.exports=function ini_doubleclick(cgm){var params=cgm.params;// disable double-click zoom
d3.selectAll(params.viz.zoom_element).on('dblclick.zoom',null);d3.select(params.viz.zoom_element).on('dblclick',function(){two_translate_zoom(cgm,0,0,1);});};/***/},/* 162 *//***/function(module,exports){module.exports=function(params){// reset zoom
//////////////////////////////
var zoom_y=1;// var zoom_x = 1;
var pan_dx=0;var pan_dy=0;var half_height=params.viz.clust.dim.height/2;var center_y=-(zoom_y-1)*half_height;d3.select(params.root+' .clust_group').attr('transform','translate('+[0,0+center_y]+')'+' scale('+1+','+zoom_y+')'+'translate('+[pan_dx,pan_dy]+')');d3.select(params.root+' .row_label_zoom_container').attr('transform','translate('+[0,center_y]+')'+' scale('+zoom_y+','+zoom_y+')'+'translate('+[0,pan_dy]+')');d3.select(params.root+' .row_cat_container').attr('transform','translate('+[0,center_y]+')'+' scale('+1+','+zoom_y+')'+'translate('+[0,pan_dy]+')');d3.select(params.root+' .row_dendro_container').attr('transform','translate('+[0,center_y]+')'+' scale('+zoom_y+','+zoom_y+')'+'translate('+[params.viz.uni_margin/2,pan_dy]+')');d3.select(params.root+' .col_zoom_container').attr('transform',' scale('+1+','+1+')'+'translate('+[pan_dx,0]+')');d3.select(params.root+' .col_cat_container').attr('transform',' scale('+1+','+1+')'+'translate('+[pan_dx,0]+')');d3.select(params.root+' .col_dendro_container').attr('transform',' scale('+1+','+1+')'+'translate('+[pan_dx,params.viz.uni_margin/2]+')');// reset crop button zooming
d3.select(params.root+' .row_dendro_icons_group').attr('transform',function(){return'translate(0,0) scale(1)';});d3.select(params.root+' .row_dendro_icons_group').selectAll('path').attr('transform',function(d){var inst_x=7;var inst_y=d.pos_mid;return'translate('+inst_x+','+inst_y+') '+'scale(1, 1)';});};/***/},/* 163 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function resize_dendro(params,svg_group){var delay_info=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;// resize dendrogram
///////////////////
var delays={};if(delay_info===false){delays.run_transition=false;}else{delays=delay_info;}var duration=params.viz.duration;var col_nodes=params.network_data.col_nodes;var col_nodes_names=params.network_data.col_nodes_names;var dendro_group;if(delays.run_transition){dendro_group=svg_group.transition().delay(delays.update).duration(duration);svg_group.selectAll('.col_cat_group')// data binding needed for loss/gain of columns
.data(col_nodes,function(d){return d.name;}).transition().delay(delays.update).duration(duration).attr('transform',function(d){var inst_index=underscore.indexOf(col_nodes_names,d.name);return'translate('+params.viz.x_scale(inst_index)+',0)';});svg_group.selectAll('.col_dendro_group')// data binding needed for loss/gain of columns
.data(col_nodes,function(d){return d.name;}).transition().delay(delays.update).duration(duration).attr('transform',function(d){var inst_index=underscore.indexOf(col_nodes_names,d.name);return'translate('+params.viz.x_scale(inst_index)+',0)';});}else{dendro_group=svg_group;svg_group.selectAll('.col_cat_group')// data binding needed for loss/gain of columns
.data(col_nodes,function(d){return d.name;}).attr('transform',function(d){var inst_index=underscore.indexOf(col_nodes_names,d.name);return'translate('+params.viz.x_scale(inst_index)+',0)';});d3.select(params.root).selectAll('.col_dendro_group')// data binding needed for loss/gain of columns
.data(col_nodes,function(d){return d.name;}).attr('transform',function(d){var inst_index=underscore.indexOf(col_nodes_names,d.name);return'translate('+params.viz.x_scale(inst_index)+',0)';});}var i;var inst_class;underscore.each(['row','col'],function(inst_rc){var num_cats=params.viz.all_cats[inst_rc].length;for(i=0;i<num_cats;i++){inst_class='.'+inst_rc+'_cat_rect_'+String(i);if(inst_rc==='row'){dendro_group.selectAll(inst_class).attr('height',params.viz.y_scale.rangeBand());}else{dendro_group.selectAll(inst_class).attr('width',params.viz.x_scale.rangeBand());}}});// position row_dendro_outer_container
var x_offset=params.viz.clust.margin.left+params.viz.clust.dim.width;var y_offset=params.viz.clust.margin.top;var spillover_width=params.viz.dendro_room.row+params.viz.uni_margin;d3.select(params.root+' .viz_svg').select('row_dendro_outer_container').attr('transform','translate('+x_offset+','+y_offset+')');d3.select(params.root+' .row_dendro_outer_container').select('.row_dendro_spillover').attr('width',spillover_width+'px').attr('height',params.viz.svg_dim.height);x_offset=params.viz.clust.margin.left;y_offset=params.viz.clust.margin.top+params.viz.clust.dim.height;var spillover_height=params.viz.dendro_room.col+params.viz.uni_margin;d3.select(params.root+' .col_dendro_outer_container').select('.col_dendro_spillover').attr('width',params.viz.svg_dim.width).attr('height',spillover_height+'px');d3.select(params.root+' .col_dendro_outer_container').select('.col_dendro_spillover_top').attr('width',params.viz.svg_dim.width).attr('height',params.viz.svg_dim.height).attr('transform','translate(0,'+params.viz.dendro_room.col+')');x_offset=params.viz.clust.margin.left;y_offset=0;d3.select(params.root+' .col_dendro_icons_container').attr('transform','translate('+x_offset+','+y_offset+')');};/***/},/* 164 *//***/function(module,exports){module.exports=function resize_super_labels(params,ini_svg_group){var delay_info=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var delays={};var duration=params.viz.duration;var svg_group;if(delay_info===false){delays.run_transition=false;}else{delays=delay_info;}if(delays.run_transition){svg_group=ini_svg_group.transition().delay(delays.update).duration(duration);}else{svg_group=ini_svg_group;}svg_group.select('.super_col_bkg').attr('height',params.viz.super_labels.dim.width+'px').attr('transform','translate('+params.viz.clust.margin.left+','+params.viz.grey_border_width+')');// super col title
svg_group.select('.super_col').attr('transform',function(){var inst_x=params.viz.clust.dim.width/2+params.viz.norm_labels.width.row;var inst_y=params.viz.super_labels.dim.width;return'translate('+inst_x+','+inst_y+')';});svg_group.select('.super_row_bkg').attr('width',params.viz.super_labels.dim.width+'px').attr('transform','translate('+params.viz.grey_border_width+',0)');svg_group.select('.super_row').attr('transform',function(){var inst_x=params.viz.super_labels.dim.width;var inst_y=params.viz.clust.dim.height/2+params.viz.norm_labels.width.col;return'translate('+inst_x+','+inst_y+')';});};/***/},/* 165 *//***/function(module,exports){module.exports=function resize_spillover(viz,ini_svg_group){var delay_info=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var delays={};var duration=viz.duration;var svg_group;if(delay_info===false){delays.run_transition=false;}else{delays=delay_info;}if(delays.run_transition){svg_group=ini_svg_group.transition().delay(delays.update).duration(duration);}else{svg_group=ini_svg_group;}svg_group.select(viz.root+' .right_slant_triangle').attr('transform','translate('+viz.clust.dim.width+','+viz.norm_labels.width.col+')');svg_group.select(viz.root+' .left_slant_triangle').attr('transform','translate(-1,'+viz.norm_labels.width.col+')');var rect_height=viz.clust.margin.top+viz.uni_margin/5;svg_group.select(viz.root+' .top_left_white').attr('width',viz.clust.margin.left).attr('height',rect_height);var tmp_left=viz.clust.margin.left+viz.clust.dim.width+viz.uni_margin+viz.dendro_room.row;var tmp_top=viz.norm_labels.margin.top+viz.norm_labels.width.col;svg_group.select(viz.root+' .right_spillover_container').attr('transform',function(){return'translate('+tmp_left+', 0)';});tmp_top=viz.norm_labels.margin.top+viz.norm_labels.width.col;svg_group.select(viz.root+' .right_spillover_container rect').attr('transform',function(){return'translate( 0,'+tmp_top+')';});svg_group.select(viz.root+' .right_spillover').attr('height',viz.svg_dim.height+'px');// resize dendro spillovers
var x_offset=viz.clust.margin.left+viz.clust.dim.width;var y_offset=tmp_top;var tmp_width=viz.dendro_room.row+viz.uni_margin;var tmp_height=viz.cat_room.col+viz.uni_margin;d3.select(viz.root+' .dendro_row_spillover').attr('width',tmp_width).attr('height',tmp_height).attr('transform',function(){return'translate('+x_offset+','+y_offset+')';});// hide spillover left top of col dendrogram
x_offset=0;y_offset=viz.clust.margin.top+viz.clust.dim.height;tmp_width=viz.clust.margin.left;tmp_height=viz.clust.dim.height*10;svg_group.select('.dendro_col_spillover').attr('width',tmp_width).attr('height',tmp_height).attr('transform',function(){return'translate('+x_offset+','+y_offset+')';});x_offset=viz.clust.margin.left+viz.clust.dim.width;y_offset=viz.clust.margin.top+viz.clust.dim.height;tmp_width=viz.cat_room.col+viz.clust.dim.width;tmp_height=viz.cat_room.row+viz.uni_margin;svg_group.select('.dendro_corner_spillover').attr('width',tmp_width).attr('height',tmp_height).attr('transform',function(){return'translate('+x_offset+','+y_offset+')';});x_offset=viz.clust.margin.left+viz.clust.dim.width+viz.uni_margin;y_offset=viz.norm_labels.margin.top+viz.norm_labels.width.col+2.5*viz.uni_margin;var extra_x_room=2.75;var extra_y_room=1.2;// reposition category superlabels
if(viz.show_categories.col){d3.selectAll(viz.root+' .col_cat_super').attr('transform',function(d){var inst_cat=parseInt(d.split('-')[1],10);var inst_y=y_offset+extra_y_room*viz.cat_room.symbol_width*inst_cat;return'translate('+x_offset+','+inst_y+')';});}if(viz.show_categories.row){d3.select(viz.root+' .row_cat_label_container').attr('transform',function(){x_offset=viz.norm_labels.margin.left+viz.norm_labels.width.row+viz.cat_room.symbol_width+extra_x_room*viz.uni_margin;y_offset=viz.clust.margin.top-viz.uni_margin;return'translate('+x_offset+','+y_offset+') rotate(-90)';});}// white border bottom - prevent clustergram from hitting border
if(viz.show_dendrogram){y_offset=viz.clust.margin.top+viz.clust.dim.height+viz.dendro_room.col-2*viz.uni_margin;}else{y_offset=viz.clust.margin.top+viz.clust.dim.height;}d3.select(viz.root+' .bottom_spillover_container').attr('transform',function(){// shift up enough to show the entire border width
return'translate(0,'+y_offset+')';});svg_group.select(viz.root+' .bottom_spillover').attr('width',viz.svg_dim.width).attr('height',2*viz.svg_dim.height);var inst_height=viz.cat_room.col+1.5*viz.uni_margin;// white rect to cover excess labels
d3.select(viz.viz_svg+' .top_right_white').attr('fill',viz.background_color).attr('width',2*viz.clust.dim.width).attr('height',inst_height).attr('transform',function(){var tmp_left=viz.clust.margin.left+viz.clust.dim.width;var tmp_top=viz.norm_labels.width.col+viz.norm_labels.margin.top-viz.uni_margin;return'translate('+tmp_left+', '+tmp_top+')';});};/***/},/* 166 *//***/function(module,exports){module.exports=function resize_borders(params,svg_group){// left border
svg_group.select('.left_border').attr('width',params.viz.grey_border_width).attr('height',params.viz.svg_dim.height).attr('transform','translate(0,0)');// right border
svg_group.select('.right_border').attr('width',params.viz.grey_border_width).attr('height',params.viz.svg_dim.height).attr('transform',function(){var inst_offset=params.viz.svg_dim.width-params.viz.grey_border_width;return'translate('+inst_offset+',0)';});// top border
svg_group.select('.top_border').attr('width',params.viz.svg_dim.width).attr('height',params.viz.grey_border_width).attr('transform',function(){var inst_offset=0;return'translate('+inst_offset+',0)';});// bottom border
svg_group.select('.bottom_border').attr('width',params.viz.svg_dim.width).attr('height',params.viz.grey_border_width).attr('transform',function(){var inst_offset=params.viz.svg_dim.height-params.viz.grey_border_width;return'translate(0,'+inst_offset+')';});};/***/},/* 167 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function resize_row_labels(params,ini_svg_group){var delay_info=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var delays={};var duration=params.viz.duration;var svg_group;var row_nodes=params.network_data.row_nodes;var row_nodes_names=params.network_data.row_nodes_names;if(delay_info===false){delays.run_transition=false;}else{delays=delay_info;}if(delays.run_transition){ini_svg_group.selectAll('.row_label_group')// data bind necessary for loss/gain of rows
.data(row_nodes,function(d){return d.name;}).transition().delay(delays.update).duration(duration).attr('transform',function(d){var inst_index=underscore.indexOf(row_nodes_names,d.name);return'translate(0,'+params.viz.y_scale(inst_index)+')';}).attr('y',params.viz.rect_height*0.5+params.labels.default_fs_row*0.35);svg_group=ini_svg_group.transition().delay(delays.update).duration(duration);}else{ini_svg_group.selectAll('.row_label_group')// data bind necessary for loss/gain of rows
.data(row_nodes,function(d){return d.name;}).attr('transform',function(d){var inst_index=underscore.indexOf(row_nodes_names,d.name);return'translate(0,'+params.viz.y_scale(inst_index)+')';}).attr('y',params.viz.rect_height*0.5+params.labels.default_fs_row*0.35);svg_group=ini_svg_group;}svg_group.select(params.root+' .row_container').attr('transform','translate('+params.viz.norm_labels.margin.left+','+params.viz.clust.margin.top+')');svg_group.select(params.root+' .row_container').select('.white_bars').attr('width',params.viz.label_background.row).attr('height',30*params.viz.clust.dim.height+'px');svg_group.select(params.root+' .row_container').select('.row_label_container').attr('transform','translate('+params.viz.norm_labels.width.row+',0)');};/***/},/* 168 *//***/function(module,exports){module.exports=function resize_highlights(params){// reposition tile highlight
////////////////////////////////
var rel_width_hlight=6;// var opacity_hlight = 0.85;
var hlight_width=rel_width_hlight*params.viz.border_width.x;var hlight_height=rel_width_hlight*params.viz.border_width.y;// top highlight
d3.select(params.root+' .top_hlight').attr('width',params.viz.rect_width).attr('height',hlight_height).attr('transform',function(){return'translate('+params.viz.x_scale(params.matrix.click_hlight_x)+',0)';});// left highlight
d3.select(params.root+' .left_hlight').attr('width',hlight_width).attr('height',params.viz.rect_width-hlight_height*0.99).attr('transform',function(){return'translate('+params.viz.x_scale(params.matrix.click_hlight_x)+','+hlight_height*0.99+')';});// right highlight
d3.select(params.root+' .right_hlight').attr('width',hlight_width).attr('height',params.viz.rect_height-hlight_height*0.99).attr('transform',function(){var tmp_translate=params.viz.x_scale(params.matrix.click_hlight_x)+params.viz.rect_width-hlight_width;return'translate('+tmp_translate+','+hlight_height*0.99+')';});// bottom highlight
d3.select(params.root+' .bottom_hlight').attr('width',function(){return params.viz.rect_width-1.98*hlight_width;}).attr('height',hlight_height).attr('transform',function(){var tmp_translate_x=params.viz.x_scale(params.matrix.click_hlight_x)+hlight_width*0.99;var tmp_translate_y=params.viz.rect_height-hlight_height;return'translate('+tmp_translate_x+','+tmp_translate_y+')';});// resize row highlight
/////////////////////////
d3.select(params.root+' .row_top_hlight').attr('width',params.viz.svg_dim.width).attr('height',hlight_height);d3.select(params.root+' .row_bottom_hlight').attr('width',params.viz.svg_dim.width).attr('height',hlight_height).attr('transform',function(){var tmp_translate_y=params.viz.rect_height-hlight_height;return'translate(0,'+tmp_translate_y+')';});// resize col highlight
/////////////////////////
d3.select(params.root+' .col_top_hlight').attr('width',params.viz.clust.dim.height).attr('height',hlight_width).attr('transform',function(){var tmp_translate_y=0;var tmp_translate_x=-(params.viz.clust.dim.height+params.viz.cat_room.col+params.viz.uni_margin);return'translate('+tmp_translate_x+','+tmp_translate_y+')';});d3.select(params.root+' .col_bottom_hlight').attr('width',params.viz.clust.dim.height).attr('height',hlight_width).attr('transform',function(){var tmp_translate_y=params.viz.rect_width-hlight_width;var tmp_translate_x=-(params.viz.clust.dim.height+params.viz.cat_room.col+params.viz.uni_margin);return'translate('+tmp_translate_x+','+tmp_translate_y+')';});};/***/},/* 169 *//***/function(module,exports){module.exports=function resize_row_viz(params,ini_svg_group){var delay_info=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var delays={};var duration=params.viz.duration;var svg_group;if(delay_info===false){delays.run_transition=false;}else{delays=delay_info;}if(delays.run_transition){svg_group=ini_svg_group.transition().delay(delays.update).duration(duration);}else{svg_group=ini_svg_group;}svg_group.select('.row_cat_outer_container').attr('transform','translate('+params.viz.norm_labels.width.row+',0)').select('white_bars').attr('width',params.viz.cat_room.row+'px').attr('height',function(){var inst_height=params.viz.clust.dim.height;return inst_height;});var x_offset=params.viz.clust.margin.left+params.viz.clust.dim.width;var y_offset=params.viz.clust.margin.top;svg_group.select('.row_dendro_outer_container').attr('transform','translate('+x_offset+','+y_offset+')');// !! tmp resize col dendro
x_offset=params.viz.clust.margin.left;y_offset=params.viz.clust.margin.top+params.viz.clust.dim.height;svg_group.select(' .col_dendro_outer_container').attr('transform',function(){return'translate('+x_offset+','+y_offset+')';});};/***/},/* 170 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function(params,ini_svg_group){var delay_info=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var delays={};var duration=params.viz.duration;var svg_group;var col_nodes=params.network_data.col_nodes;var col_nodes_names=params.network_data.col_nodes_names;if(delay_info===false){delays.run_transition=false;}else{delays=delay_info;}if(delays.run_transition){svg_group=ini_svg_group.transition().delay(delays.update).duration(duration);ini_svg_group.selectAll('.col_label_text').data(col_nodes,function(d){return d.name;}).transition().delay(delays.update).duration(duration).attr('transform',function(d){var inst_index=underscore.indexOf(col_nodes_names,d.name);return'translate('+params.viz.x_scale(inst_index)+', 0) rotate(-90)';});}else{svg_group=ini_svg_group;ini_svg_group.selectAll('.col_label_text').data(col_nodes,function(d){return d.name;}).attr('transform',function(d){var inst_index=underscore.indexOf(col_nodes_names,d.name);return'translate('+params.viz.x_scale(inst_index)+', 0) rotate(-90)';});}// offset click group column label
var x_offset_click=params.viz.x_scale.rangeBand()/2+params.viz.border_width.x;svg_group.select(params.root+' .col_container').attr('transform','translate('+params.viz.clust.margin.left+','+params.viz.norm_labels.margin.top+')');svg_group.select(params.root+' .col_container').select('.white_bars').attr('width',30*params.viz.clust.dim.width+'px').attr('height',params.viz.label_background.col);svg_group.select(params.root+' .col_container').select('.col_label_outer_container').attr('transform','translate(0,'+params.viz.norm_labels.width.col+')');svg_group.selectAll('.col_label_group').attr('transform','translate('+params.viz.x_scale.rangeBand()/2+','+x_offset_click+') rotate(45)');svg_group.selectAll('.col_label_group').select('text').attr('y',params.viz.x_scale.rangeBand()*0.60).attr('dx',2*params.viz.border_width.x);};/***/},/* 171 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);module.exports=function resize_col_text(params,svg_group){svg_group.selectAll('.col_label_group').select('text').style('font-size',params.labels.default_fs_col+'px').text(function(d){return utils.normal_name(d);});svg_group.selectAll('.col_label_group').each(function(){d3.select(this).select('text')[0][0].getBBox();});};/***/},/* 172 *//***/function(module,exports,__webpack_require__){var col_viz_aid_triangle=__webpack_require__(138);module.exports=function resize_col_triangle(params,ini_svg_group){var delay_info=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;// resize column triangle
var ini_triangle_group=ini_svg_group.selectAll('.col_label_group').select('path');var delays={};var duration=params.viz.duration;if(delay_info===false){delays.run_transition=false;}else{delays=delay_info;}var triangle_group;if(delays.run_transition){triangle_group=ini_triangle_group.transition().delay(delays.update).duration(duration);}else{triangle_group=ini_triangle_group;}triangle_group.attr('d',function(){return col_viz_aid_triangle(params);}).attr('fill','#eee');};/***/},/* 173 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);module.exports=function resize_col_hlight(params,svg_group){var delay_info=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var delays={};// var duration = params.viz.duration;
if(delay_info===false){delays.run_transition=false;}else{delays=delay_info;}if(utils.has(params.network_data.col_nodes[0],'value')){svg_group.selectAll('.col_bars').data(params.network_data.col_nodes,function(d){return d.name;}).attr('width',function(d){var inst_value=0;if(d.value>0){inst_value=params.labels.bar_scale_col(d.value);}return inst_value;})// rotate labels - reduce width if rotating
.attr('height',params.viz.rect_width*0.66);}};/***/},/* 174 *//***/function(module,exports,__webpack_require__){var get_svg_dim=__webpack_require__(69);var calc_clust_height=__webpack_require__(72);var calc_clust_width=__webpack_require__(71);var calc_default_fs=__webpack_require__(81);var calc_zoom_switching=__webpack_require__(80);var underscore=__webpack_require__(3);module.exports=function recalc_params_for_resize(params){// Resetting some visualization parameters
params=get_svg_dim(params);params.viz=calc_clust_width(params.viz);params.viz=calc_clust_height(params.viz);if(params.sim_mat){if(params.viz.clust.dim.width<=params.viz.clust.dim.height){params.viz.clust.dim.height=params.viz.clust.dim.width;}else{params.viz.clust.dim.width=params.viz.clust.dim.height;}}params.viz=calc_zoom_switching(params.viz);// redefine x_scale and y_scale rangeBands
params.viz.x_scale.rangeBands([0,params.viz.clust.dim.width]);params.viz.y_scale.rangeBands([0,params.viz.clust.dim.height]);// redefine border width
params.viz.border_width.x=params.viz.x_scale.rangeBand()/params.viz.border_fraction;params.viz.border_width.y=params.viz.y_scale.rangeBand()/params.viz.border_fraction;params.viz.rect_width=params.viz.x_scale.rangeBand()-params.viz.border_width.x;params.viz.rect_height=params.viz.y_scale.rangeBand()-params.viz.border_width.y;// for downsampling
if(params.viz.ds!=null){for(var i;i<params.viz.ds.length;i++){params.viz.ds[i].rect_height=params.viz.ds[i].y_scale.rangeBand()-params.viz.border_width.y;}}// recalc downsampled y_scale if necessary
if(params.viz.ds_num_levels>0){underscore.each(params.viz.ds,function(inst_ds){// y_scale
/////////////////////////
inst_ds.y_scale=d3.scale.ordinal().rangeBands([0,params.viz.clust.dim.height]);inst_ds.y_scale.domain(d3.range(inst_ds.num_rows+1));inst_ds.rect_height=inst_ds.y_scale.rangeBand()-params.viz.border_width.y;});}// redefine zoom extent
params.viz.square_zoom=params.viz.norm_labels.width.col/(params.viz.rect_width/2);// the default font sizes are set here
params=calc_default_fs(params);return params;};/***/},/* 175 *//***/function(module,exports,__webpack_require__){var draw_up_tile=__webpack_require__(93);var draw_dn_tile=__webpack_require__(94);var fine_position_tile=__webpack_require__(97);var underscore=__webpack_require__(3);module.exports=function resize_row_tiles(params,svg_group){var row_nodes_names=params.network_data.row_nodes_names;if(params.viz.ds_level===-1){// no downsampling
///////////////////////
// resize rows
svg_group.selectAll('.row').attr('transform',function(d){var tmp_index=underscore.indexOf(row_nodes_names,d.name);var inst_y=params.viz.y_scale(tmp_index);return'translate(0,'+inst_y+')';});// resize tiles
svg_group.selectAll('.row').selectAll('.tile').attr('transform',function(d){return fine_position_tile(params,d);}).attr('width',params.viz.rect_width).attr('height',params.viz.rect_height);// resize tile_up
svg_group.selectAll('.row').selectAll('.tile_up').attr('d',function(){return draw_up_tile(params);}).attr('transform',function(d){return fine_position_tile(params,d);});// resize tile_dn
svg_group.selectAll('.row').selectAll('.tile_dn').attr('d',function(){return draw_dn_tile(params);}).attr('transform',function(d){return fine_position_tile(params,d);});}else{// downsampling
/////////////////////////
var ds_level=params.viz.ds_level;var row_class='.ds'+String(ds_level)+'_row';var ds_rect_height=params.viz.ds[ds_level].rect_height;svg_group.selectAll(row_class).attr('transform',function(d){var inst_y=params.viz.ds[ds_level].y_scale(d.row_index);return'translate(0,'+inst_y+')';});// reset ds-tiles
svg_group.selectAll(row_class).selectAll('.tile').attr('transform',function(d){return fine_position_tile(params,d);}).attr('width',params.viz.rect_width).attr('height',ds_rect_height);}};/***/},/* 176 *//***/function(module,exports,__webpack_require__){var calc_val_max=__webpack_require__(73);// var underscore = require('underscore');
module.exports=function resize_label_bars(cgm,svg_group){var params=cgm.params;// // set bar scale
// var val_max = Math.abs(underscore.max( params.network_data.row_nodes, function(d) {
//   return Math.abs(d.value);
// } ).value) ;
// params.labels.bar_scale_row = d3.scale
//   .linear()
//   .domain([0, val_max])
//   .range([0, params.viz.norm_labels.width.row ]);
params=calc_val_max(params);svg_group.selectAll('.row_bars')// .transition().delay(delays.update).duration(duration)
.attr('width',function(d){var inst_value=0;inst_value=params.labels.bar_scale_row(Math.abs(d.value));return inst_value;}).attr('x',function(d){var inst_value=0;inst_value=-params.labels.bar_scale_row(Math.abs(d.value));return inst_value;}).attr('height',params.viz.y_scale.rangeBand());};/***/},/* 177 *//***/function(module,exports){module.exports=function position_play_button(params){var clust_transform=d3.select(params.root+' .clust_container').attr('transform');var clust_x=Number(clust_transform.split('(')[1].split(',')[0]);var clust_y=Number(clust_transform.split(',')[1].replace(')',''));var trans_x=clust_x+params.viz.clust.dim.width/2;var trans_y=clust_y+params.viz.clust.dim.height/2;d3.select(params.root+' .play_button').attr('transform',function(){return'translate('+trans_x+','+trans_y+')';});};/***/},/* 178 *//***/function(module,exports){module.exports=function position_dendro_slider(cgm){var inst_rc=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'row';var viz=cgm.params.viz;var tmp_left;var tmp_top;if(inst_rc==='row'){// row dendrogram
///////////////////////
// keep slider near clustergram
var max_room=viz.svg_dim.width-3*viz.uni_margin;// position close to row dendrogram trapezoids
tmp_left=viz.clust.margin.left+viz.clust.dim.width+5.25*viz.dendro_room.row+2;if(tmp_left>max_room){tmp_left=max_room;}// tmp_top =  viz.clust.margin.top + 3 * viz.uni_margin - 50;
// 135 is a magic number that moves the slider down to make room for the
// reordering tree (use 75 when enabling reclustering icon)
tmp_top=viz.clust.margin.top+3*viz.uni_margin+30;}else{// column dendrogram
///////////////////////
tmp_left=2*viz.uni_margin;// tmp_top =  viz.svg_dim.height - 2.5 * viz.uni_margin;
tmp_top=viz.clust.margin.top+viz.clust.dim.height+viz.dendro_room.col-2*viz.uni_margin;}// reposiiton slider
d3.select(cgm.params.root+' .'+inst_rc+'_slider_group').attr('transform',function(){var inst_translation;if(inst_rc==='row'){tmp_left=tmp_left+0.8*viz.dendro_room.row;inst_translation='translate('+tmp_left+','+tmp_top+')';}else{inst_translation='translate('+tmp_left+','+tmp_top+'), rotate(-90)';}return inst_translation;}).style('opacity',1);};/***/},/* 179 *//***/function(module,exports){module.exports=function position_tree_icon(cgm){var viz=cgm.params.viz;var tmp_left;var tmp_top;// keep slider near clustergram
var max_room=viz.svg_dim.width-3*viz.uni_margin;// position close to row dendrogram trapezoids
tmp_left=viz.clust.margin.left+viz.clust.dim.width+5.25*viz.dendro_room.row;if(tmp_left>max_room){tmp_left=max_room;}// tmp_top =  viz.clust.margin.top + 3 * viz.uni_margin - 50;
tmp_top=viz.clust.margin.top+3*viz.uni_margin+90;// reposition tree icon
d3.select(cgm.params.root+' .'+'tree_icon').attr('transform',function(){var inst_translation;tmp_top=tmp_top-75;inst_translation='translate('+tmp_left+','+tmp_top+')';return inst_translation;}).style('opacity',1);};/***/},/* 180 *//***/function(module,exports){module.exports=function position_filter_icon(cgm){var viz=cgm.params.viz;var tmp_left;var tmp_top;// keep slider near clustergram
var max_room=viz.svg_dim.width-3*viz.uni_margin;// position close to row dendrogram trapezoids
tmp_left=viz.clust.margin.left+viz.clust.dim.width+4*viz.dendro_room.row+7;if(tmp_left>max_room){tmp_left=max_room;}// tmp_top =  viz.clust.margin.top + 3 * viz.uni_margin - 50;
tmp_top=viz.clust.margin.top+3*viz.uni_margin+152;// reposition tree icon
d3.select(cgm.params.root+' .'+'filter_icon').attr('transform',function(){var inst_translation;tmp_top=tmp_top-75;inst_translation='translate('+tmp_left+','+tmp_top+')';return inst_translation;}).style('opacity',1);};/***/},/* 181 *//***/function(module,exports){module.exports=function position_tree_menu(cgm){var params=cgm.params;if(d3.select(params.root+' .tree_menu').empty()===false){var menu_width=cgm.params.viz.tree_menu_width;d3.select(params.root+' .tree_menu').attr('transform',function(){var shift={};shift.x=params.viz.clust.dim.width+params.viz.clust.margin.left-menu_width+30;shift.y=params.viz.clust.margin.top+15;return'translate('+shift.x+', '+shift.y+')';});}};/***/},/* 182 *//***/function(module,exports){module.exports=function grid_lines_viz(params){var duration=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var delay=0;if(duration>0){delay=2000;}var horz_lines=d3.selectAll(params.root+' .horz_lines');var vert_lines=d3.selectAll(params.root+' .vert_lines');horz_lines.style('opacity',0).attr('transform',function(d){var inst_index=d.row_index;var inst_trans=params.viz.y_scale(inst_index);return'translate(  0,'+inst_trans+') rotate(0)';}).transition().duration(duration).delay(delay).style('opacity',1);horz_lines.append('line').attr('x1',0).attr('x2',params.viz.clust.dim.width).style('stroke-width',function(){var inst_width=params.viz.border_width.y;return inst_width+'px';});vert_lines.style('opacity',0).attr('transform',function(d){var inst_index=d.col_index;var inst_trans=params.viz.x_scale(inst_index);return'translate('+inst_trans+') rotate(-90)';}).transition().duration(duration).delay(delay).style('opacity',1);vert_lines.append('line').attr('x1',0).attr('x2',-params.viz.clust.dim.height).style('stroke-width',function(){var inst_width=params.viz.border_width.x;return inst_width+'px';});};/***/},/* 183 *//***/function(module,exports,__webpack_require__){var cat_tooltip_text=__webpack_require__(184);var d3_tip_custom=__webpack_require__(98);var reset_cat_opacity=__webpack_require__(185);var ini_cat_opacity=__webpack_require__(186);// var click_filter_cats = require('./click_filter_cats');
var get_cat_names=__webpack_require__(187);var underscore=__webpack_require__(3);module.exports=function make_col_cat(cgm){var params=cgm.params;// make or reuse outer container
if(d3.select(params.root+' .col_cat_outer_container').empty()){d3.select(params.root+' .col_container').append('g').attr('class','col_cat_outer_container').attr('transform',function(){var inst_offset=params.viz.norm_labels.width.col+2;return'translate(0,'+inst_offset+')';}).append('g').attr('class','col_cat_container');}else{d3.select(params.root+' .col_container').select('col_cat_outer_container').attr('transform',function(){var inst_offset=params.viz.norm_labels.width.col+2;return'translate(0,'+inst_offset+')';});}// remove old col_cat_tips
d3.selectAll(params.viz.root_tips+'_col_cat_tip').remove();// d3-tooltip
var cat_tip=d3_tip_custom().attr('class',function(){var root_tip_selector=params.viz.root_tips.replace('.','');var class_string=root_tip_selector+' d3-tip '+root_tip_selector+'_col_cat_tip';return class_string;}).direction('s').offset([5,0]).style('display','none').html(function(d){return cat_tooltip_text(params,d,this,'col');});// append groups - each will hold classification rects
d3.select(params.root+' .col_cat_container').selectAll('g').data(params.network_data.col_nodes,function(d){return d.name;}).enter().append('g').attr('class','col_cat_group').attr('transform',function(d){var inst_index=underscore.indexOf(params.network_data.col_nodes_names,d.name);// return 'translate(' + params.viz.x_scale(d.col_index) + ',0)';
return'translate('+params.viz.x_scale(inst_index)+',0)';});d3.select(params.root+' .col_cat_container').selectAll('.col_cat_group').call(cat_tip);// add category rects
d3.selectAll(params.root+' .col_cat_group').each(function(){var inst_selection=this;var cat_rect;underscore.each(params.viz.all_cats.col,function(inst_cat){var inst_num=parseInt(inst_cat.split('-')[1],10);var cat_rect_class='col_cat_rect_'+String(inst_num);if(d3.select(inst_selection).select('.'+cat_rect_class).empty()){cat_rect=d3.select(inst_selection).append('rect').attr('class',cat_rect_class).attr('cat',inst_cat).attr('transform',function(){var cat_room=params.viz.cat_room.symbol_width+params.viz.cat_room.separation;var inst_shift=inst_num*cat_room;return'translate(0,'+inst_shift+')';}).on('click',function(d){if(d3.select(this).classed('cat_strings')){var found_names=get_cat_names(params,d,this,'col');$(params.root+' .dendro_info').modal('toggle');var group_string=found_names.join(', ');d3.select(params.root+' .dendro_info input').attr('value',group_string);}});}else{cat_rect=d3.select(inst_selection).select('.'+cat_rect_class);}cat_rect.attr('width',params.viz.x_scale.rangeBand()).attr('height',params.viz.cat_room.symbol_width).style('fill',function(d){var cat_name=d[inst_cat];var inst_color=params.viz.cat_colors.col[inst_cat][cat_name];return inst_color;}).on('mouseover',cat_tip.show).on('mouseout',function(){cat_tip.hide(this);reset_cat_opacity(params);d3.select(this).classed('hovering',false);d3.selectAll('.d3-tip').style('display','none');});ini_cat_opacity(params.viz,'col',cat_rect,inst_cat);});});};/***/},/* 184 *//***/function(module,exports,__webpack_require__){var get_cat_title=__webpack_require__(141);var underscore=__webpack_require__(3);module.exports=function cat_tooltip_text(params,inst_data,inst_selection,inst_rc){d3.selectAll(params.viz.root_tips+'_col_cat_tip').style('display','block');d3.selectAll(params.viz.root_tips+'_row_cat_tip').style('display','block');// category index
var inst_cat=d3.select(inst_selection).attr('cat');var cat_title=get_cat_title(params.viz,inst_cat,inst_rc);var cat_name=inst_data[inst_cat];if(typeof cat_name==='string'){if(cat_name.indexOf(': ')>=0){cat_name=cat_name.split(': ')[1];}}/* old category string */// var cat_string = cat_title + ': '+ cat_name;
/* new string with click instructions */var cat_string='<div>'+cat_title+': '+cat_name+'</div> <div> <br>Click for Category Menu </div>';d3.select(inst_selection).classed('hovering',true);setTimeout(highlight_categories,500);return cat_string;function highlight_categories(){var run_highlighting=false;if(d3.select(inst_selection).classed('hovering')){var node_types=[inst_rc];if(params.viz.sim_mat){node_types=['row','col'];}underscore.each(node_types,function(tmp_rc){// only highlight string categories that are not 'false' categories
if(typeof cat_name==='string'){if(cat_name.indexOf('Not ')<0&&cat_name!='false'){run_highlighting=true;}}if(run_highlighting){d3.selectAll(params.root+' .'+tmp_rc+'_cat_group').selectAll('rect').style('opacity',function(d){var inst_opacity=d3.select(this).style('opacity');if(d3.select(this).classed('cat_strings')&&d3.select(this).classed('filtered_cat')===false){var tmp_name;var tmp_cat=d3.select(this).attr('cat');if(d[tmp_cat].indexOf(': ')>=0){tmp_name=d[tmp_cat].split(': ')[1];}else{tmp_name=d[tmp_cat];}if(tmp_cat===inst_cat&&tmp_name===cat_name){inst_opacity=params.viz.cat_colors.active_opacity;}else{inst_opacity=params.viz.cat_colors.opacity/4;}}return inst_opacity;});}});}}};/***/},/* 185 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function reset_cat_opacity(params){underscore.each(['row','col'],function(inst_rc){d3.selectAll(params.root+' .'+inst_rc+'_cat_group').selectAll('rect').style('opacity',function(){var inst_opacity=d3.select(this).style('opacity');if(d3.select(this).classed('cat_strings')&&d3.select(this).classed('filtered_cat')===false){inst_opacity=params.viz.cat_colors.opacity;}return inst_opacity;});});};/***/},/* 186 *//***/function(module,exports){module.exports=function ini_cat_opacity(viz,inst_rc,cat_rect,inst_cat){var updating=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;// debugger;
var super_string=': ';var inst_type=viz.cat_info[inst_rc][inst_cat].type;// set opacity based on string or value cats
if(inst_type==='cat_strings'){// optionally have categories transition in
if(updating){cat_rect.classed('cat_strings',true).style('opacity',0).transition().duration(1000).style('opacity',viz.cat_colors.opacity);}else{// opacity is fixed
cat_rect.classed('cat_strings',true).style('opacity',viz.cat_colors.opacity);}}else{// opacity varies based on value
cat_rect.classed('cat_values',true).style('opacity',function(d){var unprocessed_val=d[inst_cat];var cat_value=get_cat_value(unprocessed_val);return viz.cat_info[inst_rc][inst_cat].cat_scale(Math.abs(cat_value));}).style('fill',function(d){var inst_color;var cat_value=get_cat_value(d[inst_cat]);// get positive and negative colors
if(cat_value>0){inst_color=viz.cat_value_colors[0];}else{inst_color=viz.cat_value_colors[1];}return inst_color;});}function get_cat_value(unprocessed_value){if(typeof unprocessed_value==='string'){if(unprocessed_value.indexOf(super_string)>-1){unprocessed_value=unprocessed_value.split(super_string)[1];}}var cat_value=parseFloat(unprocessed_value);return cat_value;}};/***/},/* 187 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);var underscore=__webpack_require__(3);module.exports=function get_cat_names(params,inst_data,inst_selection,inst_rc){// category index
var inst_cat=d3.select(inst_selection).attr('cat');var cat_name=inst_data[inst_cat];var tmp_nodes=params.network_data[inst_rc+'_nodes'];var found_nodes=underscore.filter(tmp_nodes,function(d){return d[inst_cat]==cat_name;});var found_names=utils.pluck(found_nodes,'name');return found_names;};/***/},/* 188 *//***/function(module,exports,__webpack_require__){var cat_tooltip_text=__webpack_require__(184);var d3_tip_custom=__webpack_require__(98);var reset_cat_opacity=__webpack_require__(185);var ini_cat_opacity=__webpack_require__(186);// var click_filter_cats = require('./click_filter_cats');
var get_cat_names=__webpack_require__(187);var underscore=__webpack_require__(3);module.exports=function make_row_cat(cgm){var updating=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var params=cgm.params;// make or reuse outer container
if(d3.select(params.root+' .row_cat_outer_container').empty()){d3.select(params.root+' .row_container').append('g').attr('class','row_cat_outer_container').attr('transform','translate('+params.viz.norm_labels.width.row+',0)').append('g').attr('class','row_cat_container');}else{d3.select(params.root+' .row_container').select('row_cat_outer_container').attr('transform','translate('+params.viz.norm_labels.width.row+',0)');}// white background
if(d3.select(params.root+' .row_cat_container').select('.white_bars').empty()){d3.select(params.root+' .row_cat_container').append('rect').attr('class','white_bars').attr('fill',params.viz.background_color).attr('width',params.viz.cat_room.row+'px').attr('height',function(){var inst_height=params.viz.clust.dim.height;return inst_height;});}else{d3.select(params.root+' .row_cat_container').select('.white_bars').attr('fill',params.viz.background_color).attr('width',params.viz.cat_room.row+'px').attr('height',function(){var inst_height=params.viz.clust.dim.height;return inst_height;});}// remove old col_cat_tips
d3.selectAll(params.viz.root_tips+'_row_cat_tip').remove();// d3-tooltip
var cat_tip=d3_tip_custom().attr('class',function(){var root_tip_selector=params.viz.root_tips.replace('.','');var class_string=root_tip_selector+' d3-tip '+root_tip_selector+'_row_cat_tip';return class_string;}).direction('e').offset([5,0]).style('display','none').html(function(d){return cat_tooltip_text(params,d,this,'row');});// groups that hold classification triangle and colorbar rect
d3.select(params.root+' .row_cat_container').selectAll('g').data(params.network_data.row_nodes,function(d){return d.name;}).enter().append('g').attr('class','row_cat_group').attr('transform',function(d){var inst_index=underscore.indexOf(params.network_data.row_nodes_names,d.name);return'translate(0, '+params.viz.y_scale(inst_index)+')';});d3.select(params.root+' .row_cat_container').selectAll('.row_cat_group').call(cat_tip);var cat_rect;var inst_selection;d3.selectAll(params.root+' .row_cat_group rect').remove();if(params.viz.show_categories.row){d3.selectAll(params.root+' .row_cat_group').each(function(){inst_selection=this;underscore.each(params.viz.all_cats.row,function(inst_cat){var inst_num=parseInt(inst_cat.split('-')[1],10);var cat_rect_class='row_cat_rect_'+String(inst_num);if(d3.select(inst_selection).select('.'+cat_rect_class).empty()){cat_rect=d3.select(inst_selection).append('rect').attr('class',cat_rect_class).attr('cat',inst_cat);}else{cat_rect=d3.select(inst_selection).select('.'+cat_rect_class);}cat_rect.attr('width',params.viz.cat_room.symbol_width).attr('height',params.viz.y_scale.rangeBand()).style('fill',function(d){var cat_name=d[inst_cat];// if (cat_name.indexOf(': ') >= 0){
//   cat_name = cat_name.split(': ')[1];
// }
// console.log(cat_name)
var inst_color=params.viz.cat_colors.row[inst_cat][cat_name];// console.log('inst_color: ' + String(inst_color));
return inst_color;}).attr('x',function(){var inst_offset=params.viz.cat_room.symbol_width+params.viz.uni_margin/2;return inst_offset+'px';}).attr('transform',function(){var cat_room=params.viz.cat_room.symbol_width+params.viz.cat_room.separation;var inst_shift=inst_num*cat_room;return'translate('+inst_shift+',0)';}).on('click',function(d){if(d3.select(this).classed('cat_strings')){var found_names=get_cat_names(params,d,this,'row');$(params.root+' .dendro_info').modal('toggle');var group_string=found_names.join(', ');d3.select(params.root+' .dendro_info input').attr('value',group_string);}}).on('mouseover',cat_tip.show).on('mouseout',function(){cat_tip.hide(this);reset_cat_opacity(params);d3.select(this).classed('hovering',false);d3.selectAll('.d3-tip').style('display','none');});ini_cat_opacity(params.viz,'row',cat_rect,inst_cat,updating);});});}};/***/},/* 189 *//***/function(module,exports,__webpack_require__){var make_dendro_triangles=__webpack_require__(105);module.exports=function make_row_dendro(cgm){var params=cgm.params;var spillover_width=params.viz.dendro_room.row+params.viz.uni_margin;// position row_dendro_outer_container
var x_offset=params.viz.clust.margin.left+params.viz.clust.dim.width;var y_offset=params.viz.clust.margin.top;// make or reuse outer container
if(d3.select(params.root+' .row_dendro_outer_container').empty()){d3.select(params.root+' .viz_svg').append('g').attr('class','row_dendro_outer_container').attr('transform','translate('+x_offset+','+y_offset+')');d3.select(params.root+' .row_dendro_outer_container').append('rect').classed('row_dendro_spillover',true).attr('fill',params.viz.background_color).attr('width',spillover_width+'px').attr('height',params.viz.svg_dim.height);d3.select(params.root+' .row_dendro_outer_container').append('g').attr('class','row_dendro_container').attr('transform','translate('+params.viz.uni_margin/2+',0)');}else{d3.select(params.root+' .viz_svg').select('row_dendro_outer_container').attr('transform','translate('+x_offset+','+y_offset+')');d3.select(params.root+' .row_dendro_outer_container').select('.row_dendro_spillover').attr('width',spillover_width+'px').attr('height',params.viz.svg_dim.height);}make_dendro_triangles(cgm,'row',false);if(params.viz.inst_order.col!='clust'){d3.selectAll(params.root+' .row_dendro_group').remove();}};/***/},/* 190 *//***/function(module,exports,__webpack_require__){var make_dendro_triangles=__webpack_require__(105);module.exports=function make_col_dendro(cgm){var params=cgm.params;// position col_dendro_outer_container
var x_offset=params.viz.clust.margin.left;var y_offset=params.viz.clust.margin.top+params.viz.clust.dim.height;var spillover_height=params.viz.dendro_room.col+params.viz.uni_margin;// make or reuse outer container
if(d3.select(params.root+' .col_dendro_outer_container').empty()){d3.select(params.root+' .viz_svg').append('g').attr('class','col_dendro_outer_container').attr('transform','translate('+x_offset+','+y_offset+')');d3.select(params.root+' .col_dendro_outer_container').append('rect').classed('col_dendro_spillover',true).attr('fill',params.viz.background_color).attr('width',params.viz.svg_dim.width).attr('height',spillover_height+'px');d3.select(params.root+' .col_dendro_outer_container').append('g').attr('class','col_dendro_container').attr('transform','translate(0,'+params.viz.uni_margin/2+')');d3.select(params.root+' .col_dendro_outer_container').append('rect').classed('col_dendro_spillover_top',true).attr('fill',params.viz.background_color).attr('width',params.viz.svg_dim.width).attr('height',params.viz.svg_dim.height).attr('transform','translate(0,'+params.viz.dendro_room.col+')');}else{d3.select(params.root+' .viz_svg').select('col_dendro_outer_container').attr('transform','translate('+x_offset+','+y_offset+')');d3.select(params.root+' .col_dendro_outer_container').select('.col_dendro_spillover').attr('width',params.viz.svg_dim.width).attr('height',spillover_height+'px');}make_dendro_triangles(cgm,'col',false);if(params.viz.inst_order.row!='clust'){d3.selectAll(params.root+' .col_dendro_group').remove();}};/***/},/* 191 *//***/function(module,exports,__webpack_require__){var build_single_dendro_slider=__webpack_require__(192);module.exports=function build_dendro_sliders(cgm){build_single_dendro_slider(cgm,'row');build_single_dendro_slider(cgm,'col');};/***/},/* 192 *//***/function(module,exports,__webpack_require__){var change_groups=__webpack_require__(193);var position_dendro_slider=__webpack_require__(178);module.exports=function build_single_dendro_slider(cgm,inst_rc){var slider_length=100;var drag=d3.behavior.drag().on("drag",dragging).on('dragend',function(){cgm.params.is_slider_drag=false;});var slider_group=d3.select(cgm.params.root+' .viz_svg').append('g').classed(inst_rc+'_slider_group',true);position_dendro_slider(cgm,inst_rc);var rect_height=slider_length+20;var rect_width=30;slider_group.append('rect').classed(inst_rc+'_slider_background',true).attr('height',rect_height+'px').attr('width',rect_width+'px').attr('fill',cgm.params.viz.background_color).attr('transform',function(){var translate_string='translate(-10, -5)';return translate_string;}).style('opacity',0);slider_group.append("line").style('stroke-width',slider_length/7+'px').style('stroke','black').style('stroke-linecap','round').style('opacity',0.0).attr("y1",0).attr("y2",function(){return slider_length-2;}).on('click',click_dendro_slider);var offset_triangle=-slider_length/40;slider_group.append('path').style('fill','black').attr('transform','translate('+offset_triangle+', 0)').attr('d',function(){// up triangle
var start_x=0;var start_y=0;var mid_x=0;var mid_y=slider_length;var final_x=slider_length/10;var final_y=0;var output_string='M'+start_x+','+start_y+' L'+mid_x+', '+mid_y+' L'+final_x+','+final_y+' Z';return output_string;}).style('opacity',0.35).on('click',click_dendro_slider);var default_opacity=0.35;var high_opacity=0.6;slider_group.append('circle').classed(inst_rc+'_group_circle',true).attr('r',slider_length*0.08).attr('transform',function(){return'translate(0, '+slider_length/2+')';}).style('fill','blue').style('opacity',default_opacity).on('mouseover',function(){d3.select(this).style('opacity',high_opacity);}).on('mouseout',function(){d3.select(this).style('opacity',default_opacity);}).call(drag);function dragging(){cgm.params.is_slider_drag=true;// d[0] = d3.event.x;
var slider_pos=d3.event.y;if(slider_pos<0){slider_pos=0;}if(slider_pos>slider_length){slider_pos=slider_length;}if(this.nextSibling){this.parentNode.appendChild(this);}slider_pos=d3.round(slider_pos,-1);var slider_value=10-slider_pos/10;d3.select(this).attr("transform","translate(0, "+slider_pos+")");change_groups(cgm,inst_rc,slider_value);}function click_dendro_slider(){var clicked_line_position=d3.mouse(this);var rel_pos=d3.round(clicked_line_position[1],-1);d3.select(cgm.params.root+' .'+inst_rc+'_group_circle').attr('transform','translate(0, '+rel_pos+')');var slider_value=10-rel_pos/10;change_groups(cgm,inst_rc,slider_value);}};/***/},/* 193 *//***/function(module,exports,__webpack_require__){var make_dendro_triangles=__webpack_require__(105);/* Changes the groupings (x- and y-axis color bars).
	 */module.exports=function(cgm,inst_rc,inst_index){var params=cgm.params;if(inst_rc==='row'){params.group_level.row=inst_index;}else if(inst_rc==='col'){params.group_level.col=inst_index;}var is_change_group=true;make_dendro_triangles(cgm,inst_rc,is_change_group);};/***/},/* 194 *//***/function(module,exports,__webpack_require__){var make_dendro_crop_buttons=__webpack_require__(110);module.exports=function make_row_dendro_spillover(cgm){var viz=cgm.params.viz;// hide spillover from right
var tmp_left=viz.clust.margin.left+viz.clust.dim.width+viz.uni_margin+viz.dendro_room.row;var r_spill_container=d3.select(viz.viz_svg).append('g').classed('right_spillover_container',true).attr('transform',function(){return'translate('+tmp_left+', 0)';});var tmp_top=viz.norm_labels.margin.top+viz.norm_labels.width.col;r_spill_container.append('rect').attr('fill',viz.background_color)//!! prog_colors
.attr('width',10*viz.clust.dim.width).attr('height',viz.svg_dim.height+'px').attr('class','white_bars').attr('class','right_spillover').attr('transform',function(){return'translate( 0,'+tmp_top+')';});var x_offset=0;var y_offset=viz.clust.margin.top;r_spill_container.append('g').classed('row_dendro_icons_container',true).attr('transform','translate('+x_offset+','+y_offset+')').append('g').classed('row_dendro_icons_group',true);make_dendro_crop_buttons(cgm,'row');// hide spillover from top of row dendrogram
x_offset=viz.clust.margin.left+viz.clust.dim.width;y_offset=tmp_top;var tmp_width=viz.dendro_room.row+viz.uni_margin;var tmp_height=viz.cat_room.col+viz.uni_margin;d3.select(viz.viz_svg).append('rect').attr('fill',viz.background_color).attr('width',tmp_width).attr('height',tmp_height).attr('transform',function(){return'translate('+x_offset+','+y_offset+')';}).classed('white_bars',true).classed('dendro_row_spillover',true);};/***/},/* 195 *//***/function(module,exports,__webpack_require__){/* eslint-disable */var run_segment=__webpack_require__(196);var play_intro=__webpack_require__(197);var play_zoom=__webpack_require__(199);var play_reset_zoom=__webpack_require__(200);var play_reorder_row=__webpack_require__(202);var play_reorder_buttons=__webpack_require__(203);var play_search=__webpack_require__(205);var play_filter=__webpack_require__(206);var quick_cluster=__webpack_require__(229);var play_groups=__webpack_require__(230);var play_categories=__webpack_require__(231);var play_conclusion=__webpack_require__(232);var toggle_play_button=__webpack_require__(233);var play_menu_button=__webpack_require__(234);module.exports=function play_demo(){var cgm=this;var params=cgm.params;if(d3.select(params.root+' .running_demo').empty()){// prevent more than one demo from running at once
d3.select(params.root+' .play_button').classed('running_demo',true);toggle_play_button(params,false);// prevent user interaction while playing
$.blockUI({css:{border:'none',padding:'15px',backgroundColor:'#000','-webkit-border-radius':'10px','-moz-border-radius':'10px',opacity:0,color:'#fff',cursor:'default'}});d3.selectAll('.blockUI').style('opacity',0);// intro text
var inst_time=750;if(cgm.params.viz.is_expand===false){inst_time=run_segment(params,inst_time,quick_cluster);inst_time=inst_time-1500;}// clustergram interaction
///////////////////////////////////
inst_time=run_segment(params,inst_time,play_intro);inst_time=run_segment(params,inst_time,play_zoom);inst_time=run_segment(cgm,inst_time,play_reset_zoom);inst_time=run_segment(params,inst_time,play_categories);inst_time=run_segment(params,inst_time,play_reorder_row);// sidebar interaction
///////////////////////////////////
inst_time=run_segment(params,inst_time,play_menu_button);inst_time=run_segment(params,inst_time,play_groups);inst_time=run_segment(params,inst_time,play_reorder_buttons);inst_time=run_segment(params,inst_time,play_search);inst_time=run_segment(cgm,inst_time,play_filter);// conclusion
///////////////////////////////////
inst_time=run_segment(params,inst_time,quick_cluster);inst_time=run_segment(params,inst_time,play_conclusion);}};/***/},/* 196 *//***/function(module,exports){module.exports=function run_segment(segment_data,inst_time,inst_segment){/* eslint-disable */var timer=setTimeout(inst_segment().run,inst_time,segment_data);// set up kill demo that will stop setTimeouts
//////////////////////////////////////////////////
// if (clear_timer){
//   clearTimeout(timer);
// }
var inst_duration=inst_segment().get_duration();inst_time=inst_time+inst_duration;return inst_time;};/***/},/* 197 *//***/function(module,exports,__webpack_require__){var demo_text=__webpack_require__(198);module.exports=function play_intro(){var speed_up=1;function run(params){var text_1='Clustergrammer allows users to generate\ninteractive and '+'sharable visualizations\nby uploading a matrix';var text_2="This demo will quickly overview some\nof Clustergrammer's "+"interactive features";setTimeout(demo_text,0,params,text_1,4500/speed_up);setTimeout(demo_text,4500/speed_up,params,text_2,4500/speed_up);}function get_duration(){return 10000/speed_up;}return{run:run,get_duration:get_duration};};/***/},/* 198 *//***/function(module,exports){module.exports=function demo_text(params,text,read_duration){var split_text=text.split('\n');if(split_text.length<3){split_text.push('');}d3.select(params.root+' .demo_group').style('opacity',0).transition().duration(250).style('opacity',1).transition().duration(250).delay(read_duration).style('opacity',0);for(var i=0;i<split_text.length;i++){var inst_text_num=i+1;// make text box
//////////////////
var inst_text_obj=d3.select(params.root+' .demo_group').select('#text_'+inst_text_num).text(split_text[i]);var bbox=inst_text_obj[0][0].getBBox();var box_opacity=0.9;var tmp_fs=Number(d3.select('.demo_group').select('text').style('font-size').replace('px',''));var shift_height=tmp_fs*1.3;d3.select(params.root+' .demo_group').select('.rect_'+inst_text_num).style('fill','white').attr('width',bbox.width+20).attr('height',bbox.height).attr('x',-10).attr('y',bbox.y+i*shift_height).style('opacity',box_opacity);}};/***/},/* 199 *//***/function(module,exports,__webpack_require__){var demo_text=__webpack_require__(198);var two_translate_zoom=__webpack_require__(144);module.exports=function play_zoom(){function run(cgm){var params=cgm.params;var text='Zoom and pan by\nscrolling and dragging';demo_text(params,text,4000);setTimeout(two_translate_zoom,1500,cgm,0,0,4);}function get_duration(){return 4000;}return{run:run,get_duration:get_duration};};/***/},/* 200 *//***/function(module,exports,__webpack_require__){var demo_text=__webpack_require__(198);var two_translate_zoom=__webpack_require__(144);var sim_click=__webpack_require__(201);module.exports=function play_reset_zoom(){function run(cgm){var params=cgm.params;var text='Reset zoom by double-clicking\n';demo_text(params,text,4000);setTimeout(sim_click,2000,params,'double',300,300);setTimeout(two_translate_zoom,2400,cgm,0,0,1);}function get_duration(){return 4500;}return{run:run,get_duration:get_duration};};/***/},/* 201 *//***/function(module,exports){module.exports=function sim_click(params,single_double,pos_x,pos_y){var click_duration=200;var click_circle=d3.select(params.root+' .viz_svg').append('circle').attr('cx',pos_x).attr('cy',pos_y).attr('r',25).style('stroke','black').style('stroke-width','3px').style('fill','#007f00').style('opacity',0.5);if(single_double==='double'){click_circle.transition().duration(click_duration).style('opacity',0.0).transition().duration(50).style('opacity',0.5).transition().duration(click_duration).style('opacity',0.0).remove();}else{click_circle.transition().duration(click_duration).style('opacity',0.0).transition().duration(250).remove();}};/***/},/* 202 *//***/function(module,exports,__webpack_require__){var demo_text=__webpack_require__(198);var sim_click=__webpack_require__(201);module.exports=function play_reorder_row(){/* eslint-disable */function run(params){var text='Reorder the matrix based on a single\nrow or column by double-clicking a\nlabel';demo_text(params,text,7000);var inst_element=get_row_element(params,'EGFR');var group_trans=d3.select(inst_element).attr('transform');var container_trans=d3.select(params.root+' .clust_container').attr('transform').split(',')[1].replace(')','');var x_trans=params.viz.norm_labels.width.row*0.9;var row_trans=group_trans.split(',')[1].replace(')','');var y_trans=String(Number(row_trans)+Number(container_trans)+params.viz.rect_height/2);var wait_click=4000;setTimeout(sim_click,wait_click,params,'double',x_trans,y_trans);var wait_reorder=wait_click+300;setTimeout(fire_double_click_row,wait_reorder,params,inst_element);}function get_duration(){return 8000;}function get_row_element(params,inst_row){var inst_element=d3.selectAll(params.root+' .row_label_group').filter(function(){var inst_data=this.__data__;return inst_data.name==inst_row;})[0][0];return inst_element;}function fire_double_click_row(params,inst_element){$(inst_element).d3DblClick();}// allows doubleclicking on d3 element
jQuery.fn.d3DblClick=function(){this.each(function(i,e){var evt=document.createEvent("MouseEvents");evt.initMouseEvent("dblclick",true,true,window,0,0,0,0,0,false,false,false,false,0,null);e.dispatchEvent(evt);});};return{run:run,get_duration:get_duration};};/***/},/* 203 *//***/function(module,exports,__webpack_require__){var demo_text=__webpack_require__(198);var highlight_sidebar_element=__webpack_require__(204);module.exports=function play_reorder_buttons(){/* eslint-disable */function run(params){var text='Reorder all rows and columns\nby clicking the reorder\n buttons';demo_text(params,text,9000);setTimeout(highlight_sidebar_element,3000,params,'toggle_col_order');setTimeout(click_reorder_button,3500,params,'col','rank');setTimeout(highlight_sidebar_element,7000,params,'toggle_row_order');setTimeout(click_reorder_button,7500,params,'row','rank');}function get_duration(){return 11000;}function click_reorder_button(params,inst_rc,inst_order){var inst_button=d3.selectAll('.toggle_'+inst_rc+'_order .btn').filter(function(){return this.__data__==inst_order;})[0];$(inst_button).click();}return{run:run,get_duration:get_duration};};/***/},/* 204 *//***/function(module,exports){module.exports=function highlight_sidebar_element(params,highlight_class){var duration=arguments.length>2&&arguments[2]!==undefined?arguments[2]:4000;if(highlight_class.indexOf('slider')<0){d3.select(params.root+' .'+highlight_class).style('background','#007f00').style('box-shadow','0px 0px 10px 5px #007f00').transition().duration(1).delay(duration).style('background','#FFFFFF').style('box-shadow','none');}else{d3.select(params.root+' .'+highlight_class).style('box-shadow','0px 0px 10px 5px #007f00').transition().duration(1).delay(duration).style('box-shadow','none');}};/***/},/* 205 *//***/function(module,exports,__webpack_require__){var demo_text=__webpack_require__(198);var highlight_sidebar_element=__webpack_require__(204);var two_translate_zoom=__webpack_require__(144);module.exports=function play_search(){function run(cgm){var params=cgm.params;var text='Search for rows using\nthe search box';demo_text(params,text,5000);var ini_delay=2500;setTimeout(highlight_sidebar_element,ini_delay,params,'gene_search_container');// manually mimic typing and autocomplete
setTimeout(type_out_search,ini_delay+1000,params,'E');setTimeout(type_out_search,ini_delay+1500,params,'EG');setTimeout(type_out_search,ini_delay+2000,params,'EGF');setTimeout(type_out_search,ini_delay+2500,params,'EGFR');setTimeout(run_search,5500,params);setTimeout(two_translate_zoom,7500,cgm,0,0,1);}function get_duration(){return 10000;}function type_out_search(params,inst_string){$(params.root+' .gene_search_box').val(inst_string);$(params.root+' .gene_search_box').autocomplete("search",inst_string);}function run_search(params){$(params.root+' .submit_gene_button').click();$(params.root+' .gene_search_box').autocomplete("search",'');}return{run:run,get_duration:get_duration};};/***/},/* 206 *//***/function(module,exports,__webpack_require__){var demo_text=__webpack_require__(198);var highlight_sidebar_element=__webpack_require__(204);var update_viz_with_view=__webpack_require__(207);module.exports=function play_filter(){function run(cgm){var params=cgm.params;var text='Filter rows based on sum or\nvariance using the sliders';demo_text(params,text,4000);var filter_type='N_row_sum';setTimeout(highlight_sidebar_element,5000,params,'slider_'+filter_type,13000);text='Filter: Top 20 rows by sum';setTimeout(demo_text,5000,params,text,4000);setTimeout(run_update,5300,cgm,filter_type,20,1);text='Filter: Top 10 rows by sum';setTimeout(demo_text,10000,params,text,4000);setTimeout(run_update,10300,cgm,filter_type,10,2);text='Filter: All rows';setTimeout(demo_text,15000,params,text,4000);setTimeout(run_update,15300,cgm,filter_type,'all',0);}function get_duration(){return 19500;}function run_update(cgm,filter_type,filter_value,filter_index){var params=cgm.params;var requested_view={};requested_view[filter_type]=filter_value;update_viz_with_view(cgm,requested_view);// quick fix for slider
$(params.root+' .slider_'+filter_type).slider("value",filter_index);var unit_name;if(filter_type==='N_row_sum'){unit_name='sum';}else{unit_name='variance';}d3.select(params.root+' .title_'+filter_type).text('Top rows '+unit_name+': '+filter_value);}return{run:run,get_duration:get_duration};};/***/},/* 207 *//***/function(module,exports,__webpack_require__){var make_network_using_view=__webpack_require__(11);var disable_sidebar=__webpack_require__(208);var update_viz_with_network=__webpack_require__(209);var underscore=__webpack_require__(3);module.exports=function update_viz_with_view(cgm,requested_view){disable_sidebar(cgm.params);// make new_network_data by filtering the original network data
var new_network_data=make_network_using_view(cgm.config,cgm.params,requested_view);// reset crop button
d3.select(cgm.params.root+' .crop_button').style('color','#337ab7').classed('fa-crop',true).classed('fa-undo',false).classed('active_cropping',false);// reset dendrogram filtering when updating with a new view
// e.g. with the row filter sliders
underscore.each(['row','col'],function(inst_rc){// set class to reflect that no filtering was ran
d3.select(cgm.params.root+' .'+inst_rc+'_dendro_icons_group').classed('ran_filter',false);// display all crop buttons when cropping has not been done
d3.select(cgm.params.root+' .'+inst_rc+'_dendro_icons_container').style('display','block');});update_viz_with_network(cgm,new_network_data);};/***/},/* 208 *//***/function(module,exports){module.exports=function disable_sidebar(params){d3.selectAll(params.root+' .btn').attr('disabled',true);d3.select(params.viz.viz_svg).style('opacity',0.70);};/***/},/* 209 *//***/function(module,exports,__webpack_require__){var make_params=__webpack_require__(10);var define_enter_exit_delays=__webpack_require__(210);var enter_exit_update=__webpack_require__(211);var initialize_resizing=__webpack_require__(151);var make_col_cat=__webpack_require__(183);var make_row_cat=__webpack_require__(188);var make_row_dendro=__webpack_require__(189);var make_col_dendro=__webpack_require__(190);var ini_sidebar=__webpack_require__(222);var enable_sidebar=__webpack_require__(224);var ini_doubleclick=__webpack_require__(161);var update_reorder_buttons=__webpack_require__(225);var make_row_cat_super_labels=__webpack_require__(150);var modify_row_node_cats=__webpack_require__(226);var run_zoom=__webpack_require__(153);var ds_enter_exit_update=__webpack_require__(228);var make_cat_params=__webpack_require__(82);module.exports=function update_viz_with_network(cgm,new_network_data){// set runnning_update class, prevents multiple update from running at once
d3.select(cgm.params.viz.viz_svg).classed('running_update',true);// remove downsampled rows always
d3.selectAll(cgm.params.root+' .ds'+String(cgm.params.viz.ds_level)+'_row').remove();// run optional callback function
if(cgm.params.matrix_update_callback!=null){cgm.params.matrix_update_callback();}// copy persistent parameters
var inst_distance_metric=cgm.params.matrix.distance_metric;var inst_linkage_type=cgm.params.matrix.linkage_type;var inst_filter_state=cgm.params.matrix.filter_state;var inst_normalization_state=cgm.params.matrix.normalization_state;var inst_group_level=cgm.params.group_level;var inst_crop_fitler=cgm.params.crop_filter_nodes;// make tmp config to make new params
var tmp_config=jQuery.extend(true,{},cgm.config);var new_row_cats=null;// bring in 'new' category data
if(cgm.params.new_row_cats!=null){modify_row_node_cats(cgm.params.new_row_cats,new_network_data.row_nodes);new_row_cats=cgm.params.new_row_cats;cgm.params.new_row_cats=new_row_cats;// do not preserve the updated (row) cats
var predefined_cat_colors=true;cgm.params.viz=make_cat_params(cgm.params,cgm.params.viz,predefined_cat_colors);}tmp_config.network_data=new_network_data;tmp_config.inst_order=cgm.params.viz.inst_order;tmp_config.input_domain=cgm.params.matrix.opacity_scale.domain()[1];update_reorder_buttons(tmp_config,cgm.params);// tmp_config.ini_expand = false;
tmp_config.ini_view=null;tmp_config.current_col_cat=cgm.params.current_col_cat;// disabled, causing problems when cropping
// always preserve category colors when updating
tmp_config.cat_colors=cgm.params.viz.cat_colors;var new_params=make_params(tmp_config);// this function is sensitive to further updates, so run here
var delays=define_enter_exit_delays(cgm.params,new_params);// pass the newly calcluated params back to the cgm object
cgm.params=new_params;// set up zoom
cgm.params.zoom_behavior=d3.behavior.zoom().scaleExtent([1,cgm.params.viz.square_zoom*cgm.params.viz.zoom_ratio.x]).on('zoom',function(){run_zoom(cgm);});// Persistent Parameters
/////////////////////////
cgm.params.matrix.distance_metric=inst_distance_metric;cgm.params.matrix.linkage_type=inst_linkage_type;cgm.params.matrix.filter_state=inst_filter_state;cgm.params.matrix.normalization_state=inst_normalization_state;// have persistent group levels while updating
cgm.params.group_level=inst_group_level;// have persistent crop_filter_nodes while updating
cgm.params.crop_filter_nodes=inst_crop_fitler;// only run enter-exit-updates if there is no downsampling
if(cgm.params.viz.ds_num_levels===0){// new_network_data is necessary
enter_exit_update(cgm,new_network_data,delays);}else{ds_enter_exit_update(cgm);}// reduce opacity during update
d3.select(cgm.params.viz.viz_svg).style('opacity',0.70);make_row_cat(cgm);make_row_cat_super_labels(cgm);if(cgm.params.viz.show_categories.col){make_col_cat(cgm);}if(cgm.params.viz.show_dendrogram){make_row_dendro(cgm);make_col_dendro(cgm);}initialize_resizing(cgm);d3.select(cgm.params.viz.viz_svg).call(cgm.params.zoom_behavior);ini_doubleclick(cgm);ini_sidebar(cgm);cgm.params.viz.run_trans=true;// d3.selectAll(cgm.params.viz.root_tips)
//   .style('opacity',0);
setTimeout(enable_sidebar,2500,cgm.params);// remove all dendro shadows
setTimeout(remove_shadows,50);setTimeout(remove_shadows,100);setTimeout(remove_shadows,500);setTimeout(remove_shadows,1000);setTimeout(remove_shadows,1500);function remove_shadows(){d3.selectAll('.dendro_shadow').remove();}function finish_update(){d3.select(cgm.params.viz.viz_svg).transition().duration(250).style('opacity',1.0);setTimeout(finish_update_class,1000);}setTimeout(finish_update,delays.enter);function finish_update_class(){d3.select(cgm.params.viz.viz_svg).classed('running_update',false);}};/***/},/* 210 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function(old_params,params){// exit, update, enter
// check if exit or enter or both are required
var old_row_nodes=old_params.network_data.row_nodes;var old_col_nodes=old_params.network_data.col_nodes;var old_row=underscore.map(old_row_nodes,function(d){return d.name;});var old_col=underscore.map(old_col_nodes,function(d){return d.name;});var all_old_nodes=old_row.concat(old_col);var row_nodes=params.network_data.row_nodes;var col_nodes=params.network_data.col_nodes;var row=underscore.map(row_nodes,function(d){return d.name;});var col=underscore.map(col_nodes,function(d){return d.name;});var all_nodes=row.concat(col);var exit_nodes=underscore.difference(all_old_nodes,all_nodes).length;var enter_nodes=underscore.difference(all_nodes,all_old_nodes).length;var delays={};if(exit_nodes>0){delays.update=1000;}else{delays.update=0;}if(enter_nodes>0){delays.enter=1000;}else{delays.enter=0;}delays.enter=delays.enter+delays.update;delays.run_transition=true;var old_num_links=old_params.network_data.links.length;var new_num_links=params.network_data.links.length;var cutoff_num_links=0.5*params.matrix.def_large_matrix;if(old_num_links>cutoff_num_links||new_num_links>cutoff_num_links){delays.run_transition=false;delays.update=0;delays.enter=0;}return delays;};/***/},/* 211 *//***/function(module,exports,__webpack_require__){var reset_size_after_update=__webpack_require__(212);var make_row_label_container=__webpack_require__(99);var make_col_label_container=__webpack_require__(131);var eeu_existing_row=__webpack_require__(213);var exit_components=__webpack_require__(217);var draw_gridlines=__webpack_require__(89);var enter_row_groups=__webpack_require__(218);var resize_containers=__webpack_require__(221);var label_constrain_and_trim=__webpack_require__(145);var d3_tip_custom=__webpack_require__(98);module.exports=function enter_exit_update(cgm,network_data,delays){var params=cgm.params;// remove old tooltips
d3.selectAll(params.viz.root_tips).remove();// d3-tooltip - for tiles
var tip=d3_tip_custom().attr('class',function(){var root_tip_selector=params.viz.root_tips.replace('.','');var class_string=root_tip_selector+' d3-tip '+root_tip_selector+'_tile_tip';return class_string;}).direction('nw').offset([0,0]).style('display','none').html(function(d){var inst_value=String(d.value.toFixed(3));var tooltip_string;if(params.keep_orig){var orig_value=String(d.value_orig.toFixed(3));tooltip_string='<p>'+d.row_name+' and '+d.col_name+'</p>'+'<p> normalized value: '+inst_value+'</p>'+'<div> original value: '+orig_value+'</div>';}else{tooltip_string='<p>'+d.row_name+' and '+d.col_name+'</p>'+'<div> value: '+inst_value+'</div>';}return tooltip_string;});d3.select(params.root+' .clust_group').call(tip);// necessary for repositioning clust, col and col-cat containers
resize_containers(params);var duration=1000;// make global so that names can be accessed
var row_nodes=network_data.row_nodes;var col_nodes=network_data.col_nodes;var links=network_data.links;//
var tile_data=links;// add name to links for object constancy
for(var i=0;i<tile_data.length;i++){var d=tile_data[i];tile_data[i].name=row_nodes[d.source].name+'_'+col_nodes[d.target].name;}// move rows
var move_rows=d3.select(params.root+' .clust_group').selectAll('.row').data(params.matrix.matrix,function(d){return d.name;});if(delays.run_transition){move_rows.transition().delay(delays.update).duration(duration).attr('transform',function(d){var tmp_index=d.row_index;return'translate(0,'+params.viz.y_scale(tmp_index)+')';});}else{move_rows.attr('transform',function(d){var tmp_index=d.row_index;return'translate(0,'+params.viz.y_scale(tmp_index)+')';});}// update existing rows - enter, exit, update tiles in existing row
d3.select(params.root+' .clust_group').selectAll('.row').each(function(d){// TODO add tip back to arguments
var inst_selection=this;eeu_existing_row(params,d,delays,duration,inst_selection,tip);});d3.selectAll(params.root+' .horz_lines').remove();d3.selectAll(params.root+' .vert_lines').remove();// exit
////////////
exit_components(params,delays,duration);// resize clust components using appropriate delays
reset_size_after_update(cgm,duration,delays);// enter new elements
//////////////////////////
enter_row_groups(params,delays,duration,tip);// update existing rows
make_row_label_container(cgm,duration);make_col_label_container(cgm,duration);draw_gridlines(params,delays,duration);setTimeout(label_constrain_and_trim,2000,params);};/***/},/* 212 *//***/function(module,exports,__webpack_require__){var utils=__webpack_require__(2);var calc_clust_height=__webpack_require__(72);var get_svg_dim=__webpack_require__(69);var calc_clust_width=__webpack_require__(71);var reset_zoom=__webpack_require__(162);var resize_dendro=__webpack_require__(163);var resize_super_labels=__webpack_require__(164);var resize_spillover=__webpack_require__(165);var resize_row_labels=__webpack_require__(167);var resize_row_viz=__webpack_require__(169);var resize_col_labels=__webpack_require__(170);var resize_col_text=__webpack_require__(171);var resize_col_triangle=__webpack_require__(172);var resize_col_hlight=__webpack_require__(173);var resize_label_bars=__webpack_require__(176);var calc_default_fs=__webpack_require__(81);var calc_zoom_switching=__webpack_require__(80);// var show_visible_area = require('../zoom/show_visible_area');
var ini_zoom_info=__webpack_require__(86);var underscore=__webpack_require__(3);module.exports=function reset_size_after_update(cgm){var duration=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var delays=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;if(delays===null){delays={};delays.enter=0;delays.update=0;delays.run_transition=false;}var params=cgm.params;var row_nodes=cgm.params.network_data.row_nodes;params.zoom_info=ini_zoom_info();// // not sure if this is necessary
// ////////////////////////////
// show_visible_area(params);
// // quick fix for column filtering
// setTimeout(show_visible_area, 2200, cgm);
var row_nodes_names=params.network_data.row_nodes_names;reset_zoom(params);// Resetting some visualization parameters
params=get_svg_dim(params);params.viz=calc_clust_width(params.viz);params.viz=calc_clust_height(params.viz);if(params.sim_mat){if(params.viz.clust.dim.width<=params.viz.clust.dim.height){params.viz.clust.dim.height=params.viz.clust.dim.width;}else{params.viz.clust.dim.width=params.viz.clust.dim.height;}}params.viz=calc_zoom_switching(params.viz);// redefine x_scale and y_scale rangeBands
params.viz.x_scale.rangeBands([0,params.viz.clust.dim.width]);params.viz.y_scale.rangeBands([0,params.viz.clust.dim.height]);// redefine zoom extent
params.viz.square_zoom=params.viz.norm_labels.width.col/(params.viz.x_scale.rangeBand()/2);params.zoom_behavior.scaleExtent([1,params.viz.square_zoom*params.viz.zoom_ratio.x]);// redefine border width
params.viz.border_width.x=params.viz.x_scale.rangeBand()/params.viz.border_fraction;params.viz.border_width.y=params.viz.y_scale.rangeBand()/params.viz.border_fraction;params=calc_default_fs(params);// resize the svg
///////////////////////
var svg_group=d3.select(params.viz.viz_wrapper).select('svg');svg_group.select(params.root+' .grey_background').transition().delay(delays.update).duration(duration).attr('width',params.viz.clust.dim.width).attr('height',params.viz.clust.dim.height);resize_row_labels(params,svg_group,delays);// do not delay the font size change since this will break the bounding box calc
svg_group.selectAll('.row_label_group').select('text').style('font-size',params.labels.default_fs_row+'px').text(function(d){return utils.normal_name(d);});// change the size of the highlighting rects
svg_group.selectAll('.row_label_group').each(function(){var bbox=d3.select(this).select('text')[0][0].getBBox();d3.select(this).select('rect').attr('x',bbox.x).attr('y',0).attr('width',bbox.width).attr('height',params.viz.y_scale.rangeBand()).style('fill','yellow').style('opacity',function(d){var inst_opacity=0;// highlight target genes
if(d.target===1){inst_opacity=1;}return inst_opacity;});});resize_row_viz(params,svg_group,delays);if(delays.run_transition){// positioning row text after row text size may have been reduced
svg_group.selectAll('.row_label_group').select('text').transition().delay(delays.update).duration(duration).attr('y',params.viz.rect_height*0.5+params.labels.default_fs_row*0.35);svg_group.selectAll('.row_cat_group').data(row_nodes,function(d){return d.name;}).transition().delay(delays.update).duration(duration).attr('transform',function(d){var inst_index=underscore.indexOf(row_nodes_names,d.name);return'translate(0, '+params.viz.y_scale(inst_index)+')';});svg_group.selectAll('.row_cat_group').select('path').transition().delay(delays.update).duration(duration).attr('d',function(){var origin_x=params.viz.cat_room.symbol_width-1;var origin_y=0;var mid_x=1;var mid_y=params.viz.y_scale.rangeBand()/2;var final_x=params.viz.cat_room.symbol_width-1;var final_y=params.viz.y_scale.rangeBand();var output_string='M '+origin_x+','+origin_y+' L '+mid_x+','+mid_y+' L '+final_x+','+final_y+' Z';return output_string;});svg_group.selectAll('.row_dendro_group').data(row_nodes,function(d){return d.name;}).transition().delay(delays.update).duration(duration).attr('transform',function(d){var inst_index=underscore.indexOf(row_nodes_names,d.name);return'translate(0, '+params.viz.y_scale(inst_index)+')';});}else{// positioning row text after row text size may have been reduced
svg_group.selectAll('.row_label_group').select('text').attr('y',params.viz.rect_height*0.5+params.labels.default_fs_row*0.35);svg_group.selectAll('.row_cat_group').data(row_nodes,function(d){return d.name;}).attr('transform',function(d){var inst_index=underscore.indexOf(row_nodes_names,d.name);return'translate(0, '+params.viz.y_scale(inst_index)+')';});svg_group.selectAll('.row_cat_group').select('path').attr('d',function(){var origin_x=params.viz.cat_room.symbol_width-1;var origin_y=0;var mid_x=1;var mid_y=params.viz.y_scale.rangeBand()/2;var final_x=params.viz.cat_room.symbol_width-1;var final_y=params.viz.y_scale.rangeBand();var output_string='M '+origin_x+','+origin_y+' L '+mid_x+','+mid_y+' L '+final_x+','+final_y+' Z';return output_string;});svg_group.selectAll('.row_dendro_group').data(row_nodes,function(d){return d.name;}).attr('transform',function(d){var inst_index=underscore.indexOf(row_nodes_names,d.name);return'translate(0, '+params.viz.y_scale(inst_index)+')';});}if(utils.has(params.network_data.row_nodes[0],'value')){resize_label_bars(cgm,svg_group);}// resize col labels
///////////////////////
// reduce width of rotated rects
resize_col_labels(params,svg_group,delays);resize_col_text(params,svg_group);resize_col_triangle(params,svg_group,delays);resize_col_hlight(params,svg_group,delays);resize_dendro(params,svg_group,delays);resize_super_labels(params,svg_group,delays);resize_spillover(params.viz,svg_group,delays);// reset zoom and translate
params.zoom_behavior.scale(1).translate([params.viz.clust.margin.left,params.viz.clust.margin.top]);};/***/},/* 213 *//***/function(module,exports,__webpack_require__){var exit_existing_row=__webpack_require__(214);var enter_existing_row=__webpack_require__(215);var update_split_tiles=__webpack_require__(216);var mouseover_tile=__webpack_require__(95);var mouseout_tile=__webpack_require__(96);var fine_position_tile=__webpack_require__(97);var underscore=__webpack_require__(3);// TODO add tip back to arguments
module.exports=function eeu_existing_row(params,ini_inp_row_data,delays,duration,row_selection,tip){var inp_row_data=ini_inp_row_data.row_data;// remove zero values from
var row_values=underscore.filter(inp_row_data,function(num){return num.value!=0;});// bind data to tiles
var cur_row_tiles=d3.select(row_selection).selectAll('.tile').data(row_values,function(d){return d.col_name;});exit_existing_row(params,delays,cur_row_tiles,inp_row_data,row_selection);///////////////////////////
// Update
///////////////////////////
// update tiles in x direction
var update_row_tiles=cur_row_tiles.on('mouseover',function(){for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}mouseover_tile(params,this,tip,args);}).on('mouseout',function mouseout(){mouseout_tile(params,this,tip);});var col_nodes_names=params.network_data.col_nodes_names;if(delays.run_transition){update_row_tiles.transition().delay(delays.update).duration(duration).attr('width',params.viz.rect_width).attr('height',params.viz.rect_height).attr('transform',function(d){// if (_.contains(col_nodes_names, d.col_name)){
if(underscore.contains(col_nodes_names,d.col_name)){return fine_position_tile(params,d);}else{return'translate(0,0)';}});}else{update_row_tiles.attr('width',params.viz.rect_width).attr('height',params.viz.rect_height).attr('transform',function(d){if(underscore.contains(col_nodes_names,d.col_name)){return fine_position_tile(params,d);}else{return'translate(0,0)';}});}if(params.matrix.tile_type=='updn'){update_split_tiles(params,inp_row_data,row_selection,delays,duration,cur_row_tiles,tip);}enter_existing_row(params,delays,duration,cur_row_tiles,tip);};/***/},/* 214 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function exit_existing_row(params,delays,cur_row_tiles,inp_row_data,row_selection){if(delays.run_transition){cur_row_tiles.exit().transition().duration(300).attr('fill-opacity',0).remove();}else{cur_row_tiles.exit().attr('fill-opacity',0).remove();}if(params.matrix.tile_type=='updn'){// value split
var row_split_data=underscore.filter(inp_row_data,function(num){return num.value_up!=0||num.value_dn!=0;});// tile_up
var cur_tiles_up=d3.select(row_selection).selectAll('.tile_up').data(row_split_data,function(d){return d.col_name;});if(delays.run_transition){cur_tiles_up.exit().transition().duration(300).attr('fill','0').remove();}else{cur_tiles_up.exit().attr('fill',0).remove();}// tile_dn
var cur_tiles_dn=d3.select(row_selection).selectAll('.tile_dn').data(row_split_data,function(d){return d.col_name;});if(delays.run_transition){cur_tiles_dn.exit().transition().duration(300).attr('fill',0).remove();}else{cur_tiles_dn.exit().attr('fill',0).remove();}}};/***/},/* 215 *//***/function(module,exports,__webpack_require__){var mouseover_tile=__webpack_require__(95);var mouseout_tile=__webpack_require__(96);var fine_position_tile=__webpack_require__(97);module.exports=function enter_existing_row(params,delays,duration,cur_row_tiles,tip){// enter new tiles
var new_tiles=cur_row_tiles.enter().append('rect').attr('class','tile row_tile').attr('width',params.viz.rect_width).attr('height',params.viz.rect_height).on('mouseover',function(){for(var _len4=arguments.length,args=Array(_len4),_key4=0;_key4<_len4;_key4++){args[_key4]=arguments[_key4];}mouseover_tile(params,this,tip,args);}).on('mouseout',function mouseout(){mouseout_tile(params,this,tip);}).attr('fill-opacity',0).attr('transform',function(d){return fine_position_tile(params,d);});if(delays.run_transition){new_tiles.transition().delay(delays.enter).duration(duration).style('fill',function(d){return d.value>0?params.matrix.tile_colors[0]:params.matrix.tile_colors[1];}).attr('fill-opacity',function(d){var output_opacity=params.matrix.opacity_scale(Math.abs(d.value));return output_opacity;});}else{new_tiles.style('fill',function(d){return d.value>0?params.matrix.tile_colors[0]:params.matrix.tile_colors[1];}).attr('fill-opacity',function(d){var output_opacity=params.matrix.opacity_scale(Math.abs(d.value));return output_opacity;});}// remove new tiles if necessary
new_tiles.each(function(d){if(Math.abs(d.value_up)>0&&Math.abs(d.value_dn)>0){d3.select(this).remove();}});};/***/},/* 216 *//***/function(module,exports,__webpack_require__){var draw_up_tile=__webpack_require__(93);var draw_dn_tile=__webpack_require__(94);var mouseover_tile=__webpack_require__(95);var mouseout_tile=__webpack_require__(96);var fine_position_tile=__webpack_require__(97);var underscore=__webpack_require__(3);module.exports=function update_split_tiles(params,inp_row_data,row_selection,delays,duration,cur_row_tiles,tip){// value split
var row_split_data=underscore.filter(inp_row_data,function(num){return num.value_up!=0||num.value_dn!=0;});// tile_up
var cur_tiles_up=d3.select(row_selection).selectAll('.tile_up').data(row_split_data,function(d){return d.col_name;});// update split tiles_up
var update_tiles_up=cur_tiles_up.on('mouseover',function(){for(var _len5=arguments.length,args=Array(_len5),_key5=0;_key5<_len5;_key5++){args[_key5]=arguments[_key5];}mouseover_tile(params,this,tip,args);}).on('mouseout',function mouseout(){mouseout_tile(params,this,tip);});if(delays.run_transition){update_tiles_up.transition().delay(delays.update).duration(duration).attr('d',function(){return draw_up_tile(params);}).attr('transform',function(d){return fine_position_tile(params,d);});}else{update_tiles_up.attr('d',function(){return draw_up_tile(params);}).attr('transform',function(d){return fine_position_tile(params,d);});}// tile_dn
var cur_tiles_dn=d3.select(row_selection).selectAll('.tile_dn').data(row_split_data,function(d){return d.col_name;});// update split tiles_dn
var update_tiles_dn=cur_tiles_dn.on('mouseover',function(){for(var _len6=arguments.length,args=Array(_len6),_key6=0;_key6<_len6;_key6++){args[_key6]=arguments[_key6];}mouseover_tile(params,this,tip,args);}).on('mouseout',function mouseout(){mouseout_tile(params,this,tip);});if(delays.run_transition){update_tiles_dn.transition().delay(delays.update).duration(duration).attr('d',function(){return draw_dn_tile(params);}).attr('transform',function(d){return fine_position_tile(params,d);});}else{update_tiles_dn.attr('d',function(){return draw_dn_tile(params);}).attr('transform',function(d){return fine_position_tile(params,d);});}// remove tiles when splitting is done
cur_row_tiles.selectAll('.tile').each(function(d){if(Math.abs(d.value_up)>0&&Math.abs(d.value_dn)>0){d3.select(this).remove();}});};/***/},/* 217 *//***/function(module,exports){module.exports=function exit_components(params,delays,duration){var row_nodes=params.network_data.row_nodes;var col_nodes=params.network_data.col_nodes;// remove entire rows
var exiting_rows=d3.select(params.root+' .clust_group').selectAll('.row').data(params.matrix.matrix,function(d){return d.name;}).exit();if(delays.run_transition){exiting_rows.transition().duration(duration).style('opacity',0).remove();}else{exiting_rows.style('opacity',0).remove();}// remove row labels
d3.selectAll(params.root+' .row_label_group').data(row_nodes,function(d){return d.name;}).exit().transition().duration(duration).style('opacity',0).remove();// remove column labels
d3.selectAll(params.root+' .col_label_group').data(col_nodes,function(d){return d.name;}).exit().transition().duration(duration).style('opacity',0).remove();// remove row triangles and colorbars
d3.selectAll(params.root+' .row_cat_group').data(row_nodes,function(d){return d.name;}).exit().transition().duration(duration).style('opacity',0).remove();// remove row triangles and colorbars
d3.selectAll(params.root+' .row_dendro_group').data(row_nodes,function(d){return d.name;}).exit().transition().duration(duration).style('opacity',0).remove();d3.selectAll(params.root+' .col_label_text').data(col_nodes,function(d){return d.name;}).exit().transition().duration(duration).style('opacity',0).remove();d3.selectAll(params.root+' .horz_lines').data(row_nodes,function(d){return d.name;}).exit().transition().duration(duration).style('opacity',0).remove();d3.selectAll(params.root+' .vert_lines').data(col_nodes,function(d){return d.name;}).exit().transition().duration(duration).style('opacity',0).remove();// remove dendrogram
d3.selectAll(params.root+' .col_cat_group').data(col_nodes,function(d){return d.name;}).exit().transition().duration(duration).style('opacity',0).remove();d3.selectAll(params.root+' .col_dendro_group').data(col_nodes,function(d){return d.name;}).exit().transition().duration(duration).style('opacity',0).remove();};/***/},/* 218 *//***/function(module,exports,__webpack_require__){var enter_new_rows=__webpack_require__(219);module.exports=function enter_row_groups(params,delays,duration,tip){// enter new rows
var new_row_groups=d3.select(params.root+' .clust_group').selectAll('.row').data(params.matrix.matrix,function(d){return d.name;}).enter().append('g').classed('row',true).attr('transform',function(d){return'translate(0,'+params.viz.y_scale(d.row_index)+')';});new_row_groups.each(function(d){enter_new_rows(params,d,delays,duration,tip,this);});};/***/},/* 219 *//***/function(module,exports,__webpack_require__){var enter_split_tiles=__webpack_require__(220);var mouseover_tile=__webpack_require__(95);var mouseout_tile=__webpack_require__(96);var fine_position_tile=__webpack_require__(97);var underscore=__webpack_require__(3);// make each row in the clustergram
module.exports=function enter_new_rows(params,ini_inp_row_data,delays,duration,tip,row_selection){var inp_row_data=ini_inp_row_data.row_data;// remove zero values to make visualization faster
var row_data=underscore.filter(inp_row_data,function(num){return num.value!==0;});// update tiles
////////////////////////////////////////////
var tile=d3.select(row_selection).selectAll('rect').data(row_data,function(d){return d.col_name;}).enter().append('rect').attr('class','tile row_tile').attr('width',params.viz.rect_width).attr('height',params.viz.rect_height)// switch the color based on up/dn value
.style('fill',function(d){return d.value>0?params.matrix.tile_colors[0]:params.matrix.tile_colors[1];}).on('mouseover',function(){for(var _len7=arguments.length,args=Array(_len7),_key7=0;_key7<_len7;_key7++){args[_key7]=arguments[_key7];}mouseover_tile(params,this,tip,args);}).on('mouseout',function mouseout(){mouseout_tile(params,this,tip);});tile.style('fill-opacity',0).transition().delay(delays.enter).duration(duration).style('fill-opacity',function(d){// calculate output opacity using the opacity scale
var output_opacity=params.matrix.opacity_scale(Math.abs(d.value));return output_opacity;});tile.attr('transform',function(d){return fine_position_tile(params,d);});if(params.matrix.tile_type=='updn'){enter_split_tiles(params,inp_row_data,row_selection,tip,delays,duration,tile);}};/***/},/* 220 *//***/function(module,exports,__webpack_require__){var draw_up_tile=__webpack_require__(93);var draw_dn_tile=__webpack_require__(94);var fine_position_tile=__webpack_require__(97);var underscore=__webpack_require__(3);module.exports=function enter_split_tiles(params,inp_row_data,row_selection,tip,delays,duration,tile){// value split
var row_split_data=underscore.filter(inp_row_data,function(num){return num.value_up!=0||num.value_dn!=0;});// tile_up
var new_tiles_up=d3.select(row_selection).selectAll('.tile_up').data(row_split_data,function(d){return d.col_name;}).enter().append('path').attr('class','tile_up').attr('d',function(){return draw_up_tile(params);}).attr('transform',function(d){return fine_position_tile(params,d);}).style('fill',function(){return params.matrix.tile_colors[0];}).on('mouseover',function(p){// highlight row - set text to active if
d3.selectAll(params.root+' .row_label_group text').classed('active',function(d){return p.row_name===d.name;});d3.selectAll(params.root+' .col_label_text text').classed('active',function(d){return p.col_name===d.name;});if(params.matrix.show_tile_tooltips){tip.show(p);}}).on('mouseout',function(){d3.selectAll(params.root+' text').classed('active',false);if(params.matrix.show_tile_tooltips){tip.hide();}});new_tiles_up.style('fill-opacity',0).transition().delay(delays.enter).duration(duration).style('fill-opacity',function(d){var inst_opacity=0;if(Math.abs(d.value_dn)>0){inst_opacity=params.matrix.opacity_scale(Math.abs(d.value_up));}return inst_opacity;});// tile_dn
var new_tiles_dn=d3.select(row_selection).selectAll('.tile_dn').data(row_split_data,function(d){return d.col_name;}).enter().append('path').attr('class','tile_dn').attr('d',function(){return draw_dn_tile(params);}).attr('transform',function(d){return fine_position_tile(params,d);}).style('fill',function(){return params.matrix.tile_colors[1];}).on('mouseover',function(p){// highlight row - set text to active if
d3.selectAll(params.root+' .row_label_group text').classed('active',function(d){return p.row_name===d.name;});d3.selectAll(params.root+' .col_label_text text').classed('active',function(d){return p.col_name===d.name;});if(params.matrix.show_tile_tooltips){tip.show(p);}}).on('mouseout',function(){d3.selectAll(params.root+' text').classed('active',false);if(params.matrix.show_tile_tooltips){tip.hide();}});new_tiles_dn.style('fill-opacity',0).transition().delay(delays.enter).duration(duration).style('fill-opacity',function(d){var inst_opacity=0;if(Math.abs(d.value_up)>0){inst_opacity=params.matrix.opacity_scale(Math.abs(d.value_dn));}return inst_opacity;});// remove tiles when splitting is done
tile.each(function(d){if(Math.abs(d.value_up)>0&&Math.abs(d.value_dn)>0){d3.select(this).remove();}});};/***/},/* 221 *//***/function(module,exports){module.exports=function resize_containers(params){// reposition matrix
d3.select(params.root+' .clust_container').attr('transform','translate('+params.viz.clust.margin.left+','+params.viz.clust.margin.top+')');// reposition col container
d3.select(params.root+' .col_label_outer_container').attr('transform','translate(0,'+params.viz.norm_labels.width.col+')');// reposition col_viz container
d3.select(params.root+' .col_cat_outer_container').attr('transform',function(){var inst_offset=params.viz.norm_labels.width.col+2;return'translate(0,'+inst_offset+')';});};/***/},/* 222 *//***/function(module,exports,__webpack_require__){/* eslint-disable */var change_groups=__webpack_require__(193);var all_reorder=__webpack_require__(143);var ini_cat_reorder=__webpack_require__(142);var run_row_search=__webpack_require__(223);var underscore=__webpack_require__(3);module.exports=function ini_sidebar(cgm){var params=cgm.params;var input=d3.select(params.root+' .gene_search_box')[0][0];var awesomplete=new Awesomplete(input,{minChars:1,maxItems:15});var entities=cgm.params.network_data.row_nodes_names;awesomplete.list=entities;// position awesomplete list elements above other elements in the page
d3.selectAll('.awesomplete ul').style('z-index',99);// submit genes button
$(params.root+' .gene_search_box').keyup(function(e){if(e.keyCode===13){var search_gene=$(params.root+' .gene_search_box').val();run_row_search(cgm,search_gene,entities);}});$(params.root+' .submit_gene_button').off().click(function(){var search_gene=$(params.root+' .gene_search_box').val();run_row_search(cgm,search_gene,entities);});var reorder_types;if(params.sim_mat){reorder_types=['both'];}else{reorder_types=['row','col'];}underscore.each(reorder_types,function(inst_rc){// reorder buttons
$(params.root+' .toggle_'+inst_rc+'_order .btn').off().click(function(evt){var order_id=$(evt.target).attr('name').replace('_row','').replace('_col','');d3.selectAll(params.root+' .toggle_'+inst_rc+'_order .btn').classed('active',false);d3.select(this).classed('active',true);if(inst_rc!='both'){all_reorder(cgm,order_id,inst_rc);}else{all_reorder(cgm,order_id,'row');all_reorder(cgm,order_id,'col');}});});ini_cat_reorder(cgm);// Opacity Slider
//////////////////////////////////////////////////////////////////////
if(d3.select(cgm.params.root+' .opacity_slider').select('#handle-one').empty()){var slider_fun=d3.slider().snap(true).value(1).min(0.1).max(1.9).step(0.1).on('slide',function(evt,value){run_on_opacity_slide(evt,value);});d3.select(cgm.params.root+' .opacity_slider').call(slider_fun);}function run_on_opacity_slide(evt,value){var inst_index=2-value;var scaled_max=cgm.params.matrix.abs_max_val*inst_index;cgm.params.matrix.opacity_scale.domain([0,scaled_max]);d3.selectAll(cgm.params.root+' .tile').style('fill-opacity',function(d){// calculate output opacity using the opacity scale
var output_opacity=cgm.params.matrix.opacity_scale(Math.abs(d.value));return output_opacity;});}};/***/},/* 223 *//***/function(module,exports,__webpack_require__){var two_translate_zoom=__webpack_require__(144);var underscore=__webpack_require__(3);module.exports=function run_row_search(cgm,search_term,entities){var prop='name';if(entities.indexOf(search_term)!==-1){// unhighlight
d3.selectAll(cgm.params.root+' .row_label_group').select('rect').style('opacity',0);// calc pan_dy
var idx=underscore.indexOf(entities,search_term);var inst_y_pos=cgm.params.viz.y_scale(idx);var pan_dy=cgm.params.viz.clust.dim.height/2-inst_y_pos;var inst_zoom=cgm.params.viz.zoom_ratio.x;// working on improving zoom behavior
///////////////////////////////////////////////////
///////////////////////////////////////////////////
// // increase zoom
// inst_zoom = 3 * inst_zoom;
// // move visualization down less
// pan_dy = pan_dy - 5;
two_translate_zoom(cgm,0,pan_dy,inst_zoom);// set y zoom to zoom_switch
cgm.params.zoom_info.zoom_y=inst_zoom;// highlight
d3.selectAll(cgm.params.root+' .row_label_group').filter(function(d){return d[prop]===search_term;}).select('rect').style('opacity',1);}};/***/},/* 224 *//***/function(module,exports){module.exports=function enable_sidebar(params){/* only enable dendrogram sliders if there has been no dendro_filtering */// only enable reordering if params.dendro_filter.row === false
if(params.dendro_filter.row===false){// orders are switched!
if(params.viz.inst_order.col==='clust'){d3.select(params.root+' .row_slider_group').style('opacity',1).style('pointer-events','all');}}d3.selectAll(params.root+' .toggle_row_order .btn').attr('disabled',null);if(params.dendro_filter.col===false){// orders are switched!
if(params.viz.inst_order.row==='clust'){d3.select(params.root+' .col_slider_group').style('opacity',1).style('pointer-events','all');}}d3.selectAll(params.root+' .toggle_col_order .btn').attr('disabled',null);d3.selectAll(params.root+' .gene_search_button .btn').attr('disabled',null);params.viz.run_trans=false;};/***/},/* 225 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function update_reorder_buttons(tmp_config,params){underscore.each(['row','col'],function(inst_rc){var other_rc;if(inst_rc==='row'){other_rc='col';}else{other_rc='row';}d3.selectAll(params.root+' .toggle_'+other_rc+'_order .btn').filter(function(){return d3.select(this).attr('name')===tmp_config.inst_order[inst_rc];}).classed('active',true);});};/***/},/* 226 *//***/function(module,exports,__webpack_require__){var remove_node_cats=__webpack_require__(227);var utils=__webpack_require__(2);var underscore=__webpack_require__(3);module.exports=function modify_row_node_cats(cat_data,inst_nodes){var strip_names=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;// console.log('MODIFY ROW NODE CATS')
// console.log('CAT_DATA')
// console.log(cat_data)
var cat_type_num=0;var inst_index=0;var inst_cat_title;var inst_cats;var inst_members;var inst_name;var inst_category;var inst_cat_name;var inst_full_cat;var inst_cat_num;// loop through row nodes
//////////////////////////
underscore.each(inst_nodes,function(inst_node){inst_name=inst_node.name;// not sure if this is needed
// inst_name = inst_name.toUpperCase();
if(strip_names===true){// only consider first part of inst_name
////////////////////////////////////////////
// may improve this
if(inst_name.indexOf(' ')){inst_name=inst_name.split(' ')[0];}else if(inst_name.indexOf('_')){inst_name=inst_name.split('_')[0];}}cat_type_num=0;remove_node_cats(inst_node);// loop through each category type
underscore.each(cat_data,function(inst_cat_data){inst_cat_title=inst_cat_data.cat_title;inst_cats=inst_cat_data.cats;// initialize with no category
inst_category='false';inst_index=-1;inst_cat_num=0;// loop through each category in the category-type
underscore.each(inst_cats,function(inst_cat){inst_cat_name=inst_cat.cat_name;inst_members=inst_cat.members;// add category if node is a member
if(underscore.contains(inst_members,inst_name)){inst_category=inst_cat_name;inst_index=inst_cat_num;}inst_cat_num=inst_cat_num+1;});if(utils.has(inst_cat_data,'pval')){var inst_pval=inst_cat_data.pval.toExponential();inst_full_cat=inst_cat_title+': '+inst_category+'<p> Pval '+String(inst_pval)+'</p>';}else{if(inst_cat_title.indexOf('cat-')===-1){inst_full_cat=inst_cat_title+': '+inst_category;}else{inst_full_cat=inst_category;}}inst_node['cat-'+String(cat_type_num)]=inst_full_cat;inst_node['cat_'+String(cat_type_num)+'_index']=inst_index;cat_type_num=cat_type_num+1;});});};/***/},/* 227 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function remove_node_cats(inst_node){var all_props=underscore.keys(inst_node);underscore.each(all_props,function(inst_prop){if(inst_prop.indexOf('cat-')>-1){delete inst_node[inst_prop];}if(inst_prop.indexOf('cat_')>-1){delete inst_node[inst_prop];}});};/***/},/* 228 *//***/function(module,exports,__webpack_require__){var reset_size_after_update=__webpack_require__(212);var make_col_label_container=__webpack_require__(131);var show_visible_area=__webpack_require__(134);var resize_containers=__webpack_require__(221);module.exports=function ds_enter_exit_update(cgm){// console.log('======== ds_enter_exit_update ===============');
// remove row labels, remove non-downsampled rows, and add downsampled rows
d3.selectAll(cgm.params.root+' .row_cat_group').remove();d3.selectAll(cgm.params.root+' .row_label_group').remove();d3.selectAll(cgm.params.root+' .row').remove();// no need to re-calculate the downsampled layers
// calc_downsampled_levels(params);
var zooming_stopped=true;var zooming_out=true;var make_all_rows=true;// show_visible_area is also run with two_translate_zoom, but at that point
// the parameters were not updated and two_translate_zoom if only run
// if needed to reset zoom
show_visible_area(cgm,zooming_stopped,zooming_out,make_all_rows);make_col_label_container(cgm);var col_nodes=cgm.params.network_data.col_nodes;// remove column labels
d3.selectAll(cgm.params.root+' .col_label_group').data(col_nodes,function(d){return d.name;}).exit().style('opacity',0).remove();d3.selectAll(cgm.params.root+' .col_label_text').data(col_nodes,function(d){return d.name;}).exit().style('opacity',0).remove();d3.selectAll(cgm.params.root+' .col_cat_group').data(col_nodes,function(d){return d.name;}).exit().style('opacity',0).remove();d3.selectAll(cgm.params.root+' .col_dendro_group').data(col_nodes,function(d){return d.name;}).exit().style('opacity',0).remove();// necessary for repositioning clust, col and col-cat containers
resize_containers(cgm.params);// seeing if this fixes resizing issue
var delays={};delays.enter=0;delays.update=0;delays.run_transition=false;var duration=0;reset_size_after_update(cgm,duration,delays);};/***/},/* 229 *//***/function(module,exports,__webpack_require__){var sim_click=__webpack_require__(201);module.exports=function quick_cluster(){/* eslint-disable */function run(params){var x_trans=Number(d3.select(params.root+' .expand_button').attr('x').replace('px',''));var y_trans=Number(d3.select(params.root+' .expand_button').attr('y').replace('px',''));var wait_click=0;var wait_real_click=400;setTimeout(sim_click,wait_click,params,'single',x_trans,y_trans);setTimeout(click_menu_button,wait_real_click,params);setTimeout(reset_cluster_order,1500,params);}function get_duration(){return 3500;}function click_menu_button(params){$(params.root+' .expand_button').d3Click();}function reset_cluster_order(params){click_reorder_button(params,'row','clust');click_reorder_button(params,'col','clust');}function click_reorder_button(params,inst_rc,inst_order){var inst_button=d3.selectAll('.toggle_'+inst_rc+'_order .btn').filter(function(){return this.__data__==inst_order;})[0];$(inst_button).click();}// allows doubleclicking on d3 element
jQuery.fn.d3Click=function(){this.each(function(i,e){var evt=document.createEvent("MouseEvents");evt.initMouseEvent("click",true,true,window,0,0,0,0,0,false,false,false,false,0,null);e.dispatchEvent(evt);});};return{run:run,get_duration:get_duration};};/***/},/* 230 *//***/function(module,exports,__webpack_require__){var demo_text=__webpack_require__(198);var highlight_sidebar_element=__webpack_require__(204);var change_groups=__webpack_require__(193);module.exports=function play_groups(){/* eslint-disable */function run(params){var text='Identify row and column groups\nof varying sizes using '+' the\nsliders and dendrogram';demo_text(params,text,10000);setTimeout(highlight_sidebar_element,3000,params,'slider_col',7000);setTimeout(change_group_slider,4000,params,'row',3);setTimeout(change_group_slider,5000,params,'row',4);setTimeout(change_group_slider,6000,params,'row',5);setTimeout(change_group_slider,7000,params,'row',6);setTimeout(change_group_slider,8000,params,'row',7);setTimeout(change_group_slider,9000,params,'row',5);}function get_duration(){return 11000;}function change_group_slider(params,inst_rc,inst_value){$(cgm.params.root+' .slider_col').slider("value",inst_value/10);change_groups(cgm,inst_rc,inst_value);}return{run:run,get_duration:get_duration};};/***/},/* 231 *//***/function(module,exports,__webpack_require__){var demo_text=__webpack_require__(198);var sim_click=__webpack_require__(201);module.exports=function play_category(){/* eslint-disable */function run(params){var text='Row and column categories\ncan be use to reorder\nby double-clicking';demo_text(params,text,7000);var inst_element=d3.selectAll(params.root+' .col_cat_super').filter(function(){return this.__data__==='cat-1';})[0];var tmp_pos=d3.select('.col_cat_super').attr('transform');var x_trans=Number(tmp_pos.split('(')[1].split(',')[0].replace(')',''))+20;var y_trans=Number(tmp_pos.split(',')[1].replace(')',''));var wait_click=4000;setTimeout(sim_click,wait_click,params,'double',x_trans,y_trans);var wait_reorder=wait_click+300;setTimeout(fire_double_click_row,wait_reorder,params,inst_element);}function get_duration(){return 8000;}function fire_double_click_row(params,inst_element){$(inst_element).d3DblClick();}// allows doubleclicking on d3 element
jQuery.fn.d3DblClick=function(){this.each(function(i,e){var evt=document.createEvent("MouseEvents");evt.initMouseEvent("dblclick",true,true,window,0,0,0,0,0,false,false,false,false,0,null);e.dispatchEvent(evt);});};return{run:run,get_duration:get_duration};};/***/},/* 232 *//***/function(module,exports,__webpack_require__){var demo_text=__webpack_require__(198);var toggle_play_button=__webpack_require__(233);module.exports=function play_conclusion(){function run(params){var text_1="Clustergrammer is built with gene\nexpression data in mind"+" and interfaces\nwith several Ma'ayan lab web tools";var text_2="The example data being visualized is\ngene expression data"+" obtained from the\nCancer Cell Line Encyclopedia";var text_3="For more information please view\nthe help documentation";setTimeout(demo_text,0,params,text_1,4500);setTimeout(demo_text,4500,params,text_2,4500);setTimeout(demo_text,9000,params,text_3,4500);setTimeout(reset_demo,14000,params);}function reset_demo(params){// prevent more than one demo from running at once
d3.select(params.root+' .play_button').classed('running_demo',false);toggle_play_button(params,true);}function get_duration(){return 12000;}return{run:run,get_duration:get_duration};};/***/},/* 233 *//***/function(module,exports){module.exports=function toggle_play_button(params,show){if(show===false){d3.select(params.root+' .play_button').transition().duration(500).style('opacity',0);}else{d3.select(params.root+' .play_button').transition().duration(500).style('opacity',1);$.unblockUI();}};/***/},/* 234 *//***/function(module,exports,__webpack_require__){var demo_text=__webpack_require__(198);var sim_click=__webpack_require__(201);module.exports=function play_menu_button(){/* eslint-disable */function run(params){var text='View additional controls\nby clicking the menu button';demo_text(params,text,4000);// var inst_element = get_row_element(params, 'EGFR');
// var group_trans = d3.select(inst_element).attr('transform');
// var container_trans = d3.select(params.root+' .clust_container')
//   .attr('transform')
//   .split(',')[1].replace(')','');
// var x_trans = params.viz.norm_labels.width.row * 0.9;
// var row_trans = group_trans.split(',')[1].replace(')','');
// var y_trans = String(Number(row_trans) + Number(container_trans) +
//   params.viz.rect_height/2);
var x_trans=Number(d3.select(params.root+' .expand_button').attr('x').replace('px',''));var y_trans=Number(d3.select(params.root+' .expand_button').attr('y').replace('px',''));var wait_click=3000;var wait_real_click=3400;setTimeout(sim_click,wait_click,params,'single',x_trans,y_trans);setTimeout(click_menu_button,wait_real_click,params);}function get_duration(){return 5000;}function click_menu_button(params){$(params.root+' .expand_button').d3Click();}jQuery.fn.d3Click=function(){this.each(function(i,e){var evt=document.createEvent("MouseEvents");evt.initMouseEvent("click",true,true,window,0,0,0,0,0,false,false,false,false,0,null);e.dispatchEvent(evt);});};// allows doubleclicking on d3 element
jQuery.fn.d3DblClick=function(){this.each(function(i,e){var evt=document.createEvent("MouseEvents");evt.initMouseEvent("dblclick",true,true,window,0,0,0,0,0,false,false,false,false,0,null);e.dispatchEvent(evt);});};return{run:run,get_duration:get_duration};};/***/},/* 235 *//***/function(module,exports,__webpack_require__){var make_play_button=__webpack_require__(236);var make_demo_text_containers=__webpack_require__(237);module.exports=function ini_demo(){var cgm=this;var params=cgm.params;make_play_button(cgm);var demo_text_size=30;make_demo_text_containers(params,demo_text_size);};/***/},/* 236 *//***/function(module,exports,__webpack_require__){var position_play_button=__webpack_require__(177);module.exports=function make_play_button(cgm){var params=cgm.params;if(d3.select(params.root+' .play_button').empty()){var play_button=d3.select(params.root+' .viz_svg').append('g').classed('play_button',true).classed('running_demo',false);position_play_button(params);play_button.append('circle').style('r',45).style('fill','white').style('stroke','black').style('stroke-width','3px').style('opacity',0.5);play_button.append('path').attr('d',function(){var tri_w=40;var tri_h=22;var tri_offset=15;return'M-'+tri_offset+',-'+tri_h+' l '+tri_w+','+tri_h+' l -'+tri_w+','+tri_h+' z ';}).style('fill','black').style('opacity',0.5);// mouseover behavior
play_button.on('mouseover',function(){d3.select(this).select('path').style('fill','red').style('opacity',1);d3.select(this).select('circle').style('opacity',1);}).on('mouseout',function(){d3.select(this).select('path').style('fill','black').style('opacity',0.5);d3.select(this).select('circle').style('opacity',0.5);}).on('click',function(){// running from anonymous function to keep this defined correctly
cgm.play_demo();});}};/***/},/* 237 *//***/function(module,exports){module.exports=function make_demo_text_containers(params,demo_text_size){if(d3.select(params.root+' .demo_group').empty()){var clust_transform=d3.select(params.root+' .clust_container').attr('transform');var clust_x=Number(clust_transform.split('(')[1].split(',')[0]);var clust_y=Number(clust_transform.split(',')[1].replace(')',''));// demo text container
var demo_group=d3.select(params.root+' .viz_svg').append('g').classed('demo_group',true).attr('transform',function(){var pos_x=clust_x+20;var pos_y=clust_y+40;return'translate('+pos_x+','+pos_y+')';});demo_group.append('rect').classed('rect_1',true);demo_group.append('rect').classed('rect_2',true);demo_group.append('rect').classed('rect_3',true);var shift_height=1.3*demo_text_size;demo_group.append('text').attr('id','text_1').attr('font-size',demo_text_size+'px').attr('font-weight',1000).attr('font-family','"Helvetica Neue", Helvetica, Arial, sans-serif');demo_group.append('text').attr('id','text_2').attr('font-size',demo_text_size+'px').attr('font-weight',1000).attr('font-family','"Helvetica Neue", Helvetica, Arial, sans-serif').attr('transform',function(){return'translate(0,'+String(shift_height)+')';});demo_group.append('text').attr('id','text_3').attr('font-size',demo_text_size+'px').attr('font-weight',1000).attr('font-family','"Helvetica Neue", Helvetica, Arial, sans-serif').attr('transform',function(){return'translate(0,'+String(2*shift_height)+')';});}};/***/},/* 238 *//***/function(module,exports,__webpack_require__){var filter_network_using_new_nodes=__webpack_require__(12);var update_viz_with_network=__webpack_require__(209);module.exports=function filter_viz_using_nodes(new_nodes){var new_network_data=filter_network_using_new_nodes(this.config,new_nodes);update_viz_with_network(this,new_network_data);};/***/},/* 239 *//***/function(module,exports,__webpack_require__){var filter_network_using_new_nodes=__webpack_require__(12);var update_viz_with_network=__webpack_require__(209);var underscore=__webpack_require__(3);module.exports=function filter_viz_using_names(names){var external_cgm=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;// names is an object with row and column names that will be used to filter
// the matrix
var cgm;if(external_cgm===false){cgm=this;}else{cgm=external_cgm;}var params=cgm.params;var new_nodes={};var found_nodes;underscore.each(['row','col'],function(inst_rc){var orig_nodes=params.inst_nodes[inst_rc+'_nodes'];if(_.has(names,inst_rc)){if(names[inst_rc].length>0){var inst_names=names[inst_rc];found_nodes=$.grep(orig_nodes,function(d){return $.inArray(d.name,inst_names)>-1;});}else{found_nodes=orig_nodes;}}else{found_nodes=orig_nodes;}new_nodes[inst_rc+'_nodes']=found_nodes;});// keep backup of the nodes for resetting filtering
var inst_row_nodes=cgm.params.network_data.row_nodes;var inst_col_nodes=cgm.params.network_data.col_nodes;var new_network_data=filter_network_using_new_nodes(cgm.config,new_nodes);// takes entire cgm object
// last argument tells it to not preserve categoty colors
update_viz_with_network(cgm,new_network_data);// only keep backup if previous number of nodes were larger than current number
// of nodes
if(inst_row_nodes.length>cgm.params.inst_nodes.row_nodes.length){cgm.params.inst_nodes.row_nodes=inst_row_nodes;}if(inst_col_nodes.length>cgm.params.inst_nodes.col_nodes.length){cgm.params.inst_nodes.col_nodes=inst_col_nodes;}};/***/},/* 240 *//***/function(module,exports,__webpack_require__){var make_row_cat=__webpack_require__(188);var calc_viz_params=__webpack_require__(65);var resize_viz=__webpack_require__(152);var modify_row_node_cats=__webpack_require__(226);module.exports=function update_cats(cgm,cat_data){// Only accessible from the cgm API, cat_data is provided by externally
///////////////////////////////////////////////////////////////////////////
if(cgm.params.cat_update_callback!=null){cgm.params.cat_update_callback(this);}// do not change column category info
var col_cat_colors=cgm.params.viz.cat_colors.col;modify_row_node_cats(cat_data,cgm.params.network_data.row_nodes,true);// modify the current inst copy of nodes
modify_row_node_cats(cat_data,cgm.params.inst_nodes.row_nodes,true);// recalculate the visualization parameters using the updated network_data
cgm.params=calc_viz_params(cgm.params,false);make_row_cat(cgm,true);resize_viz(cgm);cgm.params.new_row_cats=cat_data;cgm.params.viz.cat_colors.col=col_cat_colors;};/***/},/* 241 *//***/function(module,exports,__webpack_require__){var make_row_cat=__webpack_require__(188);var calc_viz_params=__webpack_require__(65);var resize_viz=__webpack_require__(152);var modify_row_node_cats=__webpack_require__(226);var generate_cat_data=__webpack_require__(242);module.exports=function reset_cats(){var run_resize_viz=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;// console.log('RESET CATS')
var cgm=this;var cat_data=generate_cat_data(cgm);// do not change column category info
var col_cat_colors=cgm.params.viz.cat_colors.col;modify_row_node_cats(cat_data,cgm.params.network_data.row_nodes);// modify the current inst copy of nodes
modify_row_node_cats(cat_data,cgm.params.inst_nodes.row_nodes);cgm.params.new_row_cats=cat_data;cgm.params.viz.cat_colors.col=col_cat_colors;if(run_resize_viz){// resize visualizatino
////////////////////////////
// recalculate the visualization parameters using the updated network_data
var predefine_cat_colors=true;cgm.params=calc_viz_params(cgm.params,predefine_cat_colors);make_row_cat(cgm,true);resize_viz(cgm);}};/***/},/* 242 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function generate_cat_data(cgm){// only row category resetting is supported currently
// get row_nodes from config, since this is has the original network
var row_nodes=cgm.config.network_data.row_nodes;var title_sep=': ';// contains all the category information stored as an array of
// cat_type
var cat_data=[];var cat_type;var cat_info;var found_cat_name;var cat_name;// console.log('generate_cat_data')
// console.log(cgm.params.viz.cat_names.row)
// get current list of cateories
var check_node=row_nodes[0];var node_keys=underscore.keys(check_node);var current_cats={};var tmp_cat;var tmp_title;var cat_index;underscore.each(node_keys,function(inst_prop){if(inst_prop.indexOf('cat-')>=0){// generate titles from cat info
tmp_cat=check_node[inst_prop];cat_index=parseInt(inst_prop.split('cat-')[1],10);// use given title
if(tmp_cat.indexOf(title_sep)>=0){tmp_title=tmp_cat.split(title_sep)[0];}else{tmp_title=inst_prop;}// current_cats.push(tmp_title);
current_cats[cat_index]=tmp_title;}});// console.log('current_cats')
// console.log(current_cats)
// initialize cat_data with categories in the correct order
var all_index=underscore.keys(current_cats).sort();var inst_data;underscore.each(all_index,function(inst_index){inst_data={};inst_data.cat_title=current_cats[inst_index];inst_data.cats=[];cat_data.push(inst_data);});// // initialize cat_data (keep original order)
// var found_title;
// underscore.each(cgm.params.viz.cat_names.row, function(inst_title){
//   found_title = false;
//   console.log('inst_title -> ' + String(inst_title))
//   if (current_cats.indexOf(inst_title) >= 0){
//     found_title = true;
//   }
//   // only track cats that are found in the incoming nodes
//   if (found_title){
//     var inst_data = {};
//     inst_data.cat_title = inst_title;
//     inst_data.cats = [];
//     cat_data.push(inst_data);
//   }
// });
// console.log('cat_data after cross checking with current cats')
// console.log(cat_data)
// console.log('-------------------------\n')
underscore.each(row_nodes,function(inst_node){var all_props=underscore.keys(inst_node);underscore.each(all_props,function(inst_prop){if(inst_prop.indexOf('cat-')>-1){cat_name=inst_node[inst_prop];cat_index=parseInt(inst_prop.split('cat-')[1],10);// default title and name
var cat_title=inst_prop;cat_name=inst_node[inst_prop];var cat_string=inst_node[inst_prop];var cat_row_name=inst_node.name;// console.log('cat_string: '+String(cat_string))
// found actual title
if(cat_string.indexOf(title_sep)>-1){cat_title=cat_string.split(title_sep)[0];cat_name=cat_string.split(title_sep)[1];}else{// cat_title = 'Category-'+String(parseInt(inst_prop.split('-')[1]) + 1)
cat_title=inst_prop;cat_name=cat_string;}// console.log('cat_index -> ' + String(cat_index))
// console.log('cat_name '+cat_name)
// console.log('cat_title ' + cat_title)
// console.log('--------')
// cat_data is empty
if(cat_data.length===0){add_new_cat_type(cat_title,cat_name,cat_row_name);// cat_data is not empty
}else{// look for cat_title in cat_data
underscore.each(cat_data,function(inst_cat_type){// console.log('inst_cat_data title ' + inst_cat_type.cat_title)
// check each cat_type object for a matching title
if(cat_title===inst_cat_type.cat_title){found_cat_name=false;underscore.each(inst_cat_type.cats,function(inst_cat_obj){// found category name, add cat_row_name to members
if(cat_name===inst_cat_obj.cat_name){found_cat_name=true;// add cat_row_name to members
inst_cat_obj.members.push(cat_row_name);}});// did not find cat name in cat_type - add cat_info for new
// category
if(found_cat_name===false){cat_info={};cat_info.cat_name=cat_name;cat_info.members=[];cat_info.members.push(cat_row_name);inst_cat_type.cats.push(cat_info);}}});// did not find category type, initialize category type object
}}});});function add_new_cat_type(cat_title,cat_name,cat_row_name){// initialize cat_type object to push to cat_data
cat_type={};cat_type.cat_title=cat_title;cat_type.cats=[];// initialize cat_info (e.g. 'true' category has members [...])
cat_info={};cat_info.cat_name=cat_name;cat_info.members=[];cat_info.members.push(cat_row_name);cat_type.cats.push(cat_info);cat_data.push(cat_type);}// console.log('RETURNING CAT DATA')
// console.log(cat_data)
return cat_data;};/***/},/* 243 *//***/function(module,exports,__webpack_require__){var update_viz_with_view=__webpack_require__(207);var reset_other_filter_sliders=__webpack_require__(244);module.exports=function update_view(cgm,filter_type,inst_state){// add something to control slider position
/////////////////////////////////////////////
var requested_view={};requested_view[filter_type]=inst_state;update_viz_with_view(cgm,requested_view);reset_other_filter_sliders(cgm,filter_type,inst_state);};/***/},/* 244 *//***/function(module,exports,__webpack_require__){var make_filter_title=__webpack_require__(245);var underscore=__webpack_require__(3);module.exports=function reset_other_filter_sliders(cgm,filter_type,inst_state){var params=cgm.params;var inst_rc;var reset_rc;d3.select(params.root+' .slider_'+filter_type).attr('current_state',inst_state);underscore.each(underscore.keys(params.viz.possible_filters),function(reset_filter){if(filter_type.indexOf('row')>-1){inst_rc='row';}else if(filter_type.indexOf('col')>-1){inst_rc='col';}else{inst_rc='neither';}if(reset_filter.indexOf('row')>-1){reset_rc='row';}else if(reset_filter.indexOf('col')>-1){reset_rc='col';}else{reset_rc='neither';}if(filter_type!=reset_filter&&inst_rc!='neither'){if(inst_rc==reset_rc){var tmp_title=make_filter_title(params,reset_filter);cgm.slider_functions[reset_filter].value(0);d3.select(params.root+' .title_'+reset_filter).text(tmp_title.text+tmp_title.state);d3.select(params.root+' .slider_'+reset_filter).attr('current_state',tmp_title.state);}}});var filter_title=make_filter_title(params,filter_type);d3.select(params.root+' .title_'+filter_type).text(filter_title.text+inst_state+filter_title.suffix);};/***/},/* 245 *//***/function(module,exports,__webpack_require__){var get_filter_default_state=__webpack_require__(6);var underscore=__webpack_require__(3);module.exports=function make_filter_title(params,filter_type){var filter_title={};var title={};var type={};filter_title.state=get_filter_default_state(params.viz.filter_data,filter_type);type.top=filter_type.split('_')[0];type.node=filter_type.split('_')[1];type.measure=filter_type.split('_')[2];if(type.node==='row'){title.node='rows';}else{title.node='columns';}if(type.top==='N'){// filter_title.suffix = ' '+title.node;
filter_title.suffix='';}if(type.top==='pct'){filter_title.suffix='%';}if(type.measure=='sum'){title.measure='sum';}else if(type.measure=='var'){title.measure='variance';}if(type.measure==='sum'){filter_title.text='Top '+title.node+' '+title.measure+': ';}if(type.measure==='var'){filter_title.text='Top '+title.node+' '+title.measure+': ';}// Enrichr specific rules
if(underscore.keys(params.viz.possible_filters).indexOf('enr_score_type')>-1){if(type.node==='col'){filter_title.text='Top Enriched Terms: ';filter_title.suffix='';}}return filter_title;};/***/},/* 246 *//***/function(module,exports,__webpack_require__){var file_saver=__webpack_require__(247);var make_matrix_string=__webpack_require__(248);module.exports=function save_matrix(){var saveAs=file_saver();var params=this.params;var matrix_string=make_matrix_string(params);var blob=new Blob([matrix_string],{type:'text/plain;charset=utf-8'});saveAs(blob,'clustergrammer.txt');};/***/},/* 247 *//***/function(module,exports){module.exports=function file_saver(){/* eslint-disable *//* FileSaver.js
	   * A saveAs() FileSaver implementation.
	   * 2013-01-23
	   *
	   * By Eli Grey, http://eligrey.com
	   * License: X11/MIT
	   *   See LICENSE.md
	   *//*global self *//*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
	    plusplus: true *//*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */var saveAs=saveAs||navigator.msSaveBlob&&navigator.msSaveBlob.bind(navigator)||function(view){var doc=view.document// only get URL when necessary in case BlobBuilder.js hasn't overridden it yet
,get_URL=function get_URL(){return view.URL||view.webkitURL||view;},URL=view.URL||view.webkitURL||view,save_link=doc.createElementNS("http://www.w3.org/1999/xhtml","a"),can_use_save_link="download"in save_link,click=function click(node){var event=doc.createEvent("MouseEvents");event.initMouseEvent("click",true,false,view,0,0,0,0,0,false,false,false,false,0,null);node.dispatchEvent(event);},webkit_req_fs=view.webkitRequestFileSystem,req_fs=view.requestFileSystem||webkit_req_fs||view.mozRequestFileSystem,throw_outside=function throw_outside(ex){(view.setImmediate||view.setTimeout)(function(){throw ex;},0);},force_saveable_type="application/octet-stream",fs_min_size=0,deletion_queue=[],process_deletion_queue=function process_deletion_queue(){var i=deletion_queue.length;while(i--){var file=deletion_queue[i];if(typeof file==="string"){// file is an object URL
URL.revokeObjectURL(file);}else{// file is a File
file.remove();}}deletion_queue.length=0;// clear queue
},dispatch=function dispatch(filesaver,event_types,event){event_types=[].concat(event_types);var i=event_types.length;while(i--){var listener=filesaver["on"+event_types[i]];if(typeof listener==="function"){try{listener.call(filesaver,event||filesaver);}catch(ex){throw_outside(ex);}}}},FileSaver=function FileSaver(blob,name){// First try a.download, then web filesystem, then object URLs
var filesaver=this,type=blob.type,blob_changed=false,object_url,target_view,get_object_url=function get_object_url(){var object_url=get_URL().createObjectURL(blob);deletion_queue.push(object_url);return object_url;},dispatch_all=function dispatch_all(){dispatch(filesaver,"writestart progress write writeend".split(" "));}// on any filesys errors revert to saving with object URLs
,fs_error=function fs_error(){// don't create more object URLs than needed
if(blob_changed||!object_url){object_url=get_object_url(blob);}if(target_view){target_view.location.href=object_url;}filesaver.readyState=filesaver.DONE;dispatch_all();},abortable=function abortable(func){return function(){if(filesaver.readyState!==filesaver.DONE){return func.apply(this,arguments);}};},create_if_not_found={create:true,exclusive:false},slice;filesaver.readyState=filesaver.INIT;if(!name){name="download";}if(can_use_save_link){object_url=get_object_url(blob);save_link.href=object_url;save_link.download=name;click(save_link);filesaver.readyState=filesaver.DONE;dispatch_all();return;}// Object and web filesystem URLs have a problem saving in Google Chrome when
// viewed in a tab, so I force save with application/octet-stream
// http://code.google.com/p/chromium/issues/detail?id=91158
if(view.chrome&&type&&type!==force_saveable_type){slice=blob.slice||blob.webkitSlice;blob=slice.call(blob,0,blob.size,force_saveable_type);blob_changed=true;}// Since I can't be sure that the guessed media type will trigger a download
// in WebKit, I append .download to the filename.
// https://bugs.webkit.org/show_bug.cgi?id=65440
if(webkit_req_fs&&name!=="download"){name+=".download";}if(type===force_saveable_type||webkit_req_fs){target_view=view;}else{target_view=view.open();}if(!req_fs){fs_error();return;}fs_min_size+=blob.size;req_fs(view.TEMPORARY,fs_min_size,abortable(function(fs){fs.root.getDirectory("saved",create_if_not_found,abortable(function(dir){var save=function save(){dir.getFile(name,create_if_not_found,abortable(function(file){file.createWriter(abortable(function(writer){writer.onwriteend=function(event){target_view.location.href=file.toURL();deletion_queue.push(file);filesaver.readyState=filesaver.DONE;dispatch(filesaver,"writeend",event);};writer.onerror=function(){var error=writer.error;if(error.code!==error.ABORT_ERR){fs_error();}};"writestart progress write abort".split(" ").forEach(function(event){writer["on"+event]=filesaver["on"+event];});writer.write(blob);filesaver.abort=function(){writer.abort();filesaver.readyState=filesaver.DONE;};filesaver.readyState=filesaver.WRITING;}),fs_error);}),fs_error);};dir.getFile(name,{create:false},abortable(function(file){// delete file if it already exists
file.remove();save();}),abortable(function(ex){if(ex.code===ex.NOT_FOUND_ERR){save();}else{fs_error();}}));}),fs_error);}),fs_error);},FS_proto=FileSaver.prototype,saveAs=function saveAs(blob,name){return new FileSaver(blob,name);};FS_proto.abort=function(){var filesaver=this;filesaver.readyState=filesaver.DONE;dispatch(filesaver,"abort");};FS_proto.readyState=FS_proto.INIT=0;FS_proto.WRITING=1;FS_proto.DONE=2;FS_proto.error=FS_proto.onwritestart=FS_proto.onprogress=FS_proto.onwrite=FS_proto.onabort=FS_proto.onerror=FS_proto.onwriteend=null;view.addEventListener("unload",process_deletion_queue,false);return saveAs;}(self);return saveAs;};/***/},/* 248 *//***/function(module,exports,__webpack_require__){var make_full_name=__webpack_require__(249);var underscore=__webpack_require__(3);module.exports=function make_matrix_string(params){var inst_matrix=params.matrix;// get order indexes
var order_indexes={};var inst_name;underscore.each(['row','col'],function(tmp_rc){var inst_rc;// row/col names are reversed in saved orders
if(tmp_rc==='row'){inst_rc='col';}else{inst_rc='row';}// use tmp_rc
inst_name=params.inst_order[tmp_rc];// use tmp_rc
order_indexes[inst_rc]=inst_matrix.orders[inst_name+'_'+tmp_rc];});var matrix_string='\t';var row_nodes=params.network_data.row_nodes;var col_nodes=params.network_data.col_nodes;// alternate column entry
for(var c_i=0;c_i<order_indexes.col.length;c_i++){var inst_index=order_indexes.col[c_i];var inst_col=col_nodes[inst_index];var col_name=make_full_name(params,inst_col,'col');if(c_i<order_indexes.col.length-1){matrix_string=matrix_string+col_name+'\t';}else{matrix_string=matrix_string+col_name;}}var row_data;matrix_string=matrix_string+'\n';underscore.each(order_indexes.row,function(inst_index){// row names
row_data=inst_matrix.matrix[inst_index].row_data;// var row_name = inst_matrix.matrix[inst_index].name;
var inst_row=row_nodes[inst_index];// var row_name = inst_row.name;
var row_name=make_full_name(params,inst_row,'row');matrix_string=matrix_string+row_name+'\t';// alternate data entry
for(var r_i=0;r_i<order_indexes.col.length;r_i++){// get the order
var col_index=order_indexes.col[r_i];if(r_i<order_indexes.col.length-1){matrix_string=matrix_string+String(row_data[col_index].value)+'\t';}else{matrix_string=matrix_string+String(row_data[col_index].value);}}matrix_string=matrix_string+'\n';});return matrix_string;};/***/},/* 249 *//***/function(module,exports){module.exports=function make_full_name(params,inst_node,inst_rc){var cat_name;var inst_name=inst_node.name;var num_cats=params.viz.all_cats[inst_rc].length;// make tuple if necessary
if(num_cats>0){inst_name="('"+inst_name+"'";for(var cat_index=0;cat_index<num_cats;cat_index++){cat_name='cat-'+String(cat_index);inst_name=inst_name+", '"+String(inst_node[cat_name])+"'";}inst_name=inst_name+')';}else{// always make names strings
inst_name=String(inst_name);}return inst_name;};/***/},/* 250 *//***/function(module,exports,__webpack_require__){var deactivate_cropping=__webpack_require__(251);var underscore=__webpack_require__(3);module.exports=function brush_crop_matrix(){// get rows/cols from brush-extent
// works for differnt brushing directions (e.g. start end sites)
var cgm=this;var params=cgm.params;var clust_width=params.viz.clust.dim.width;var clust_height=params.viz.clust.dim.height;var x=d3.scale.linear().domain([0,clust_width]).range([0,clust_width]);var y=d3.scale.linear().domain([0,clust_height]).range([0,clust_height]);// make brush group
d3.select(params.root+' .clust_container').append('g').classed('brush_group',true);cgm.params.is_cropping=true;var brush=d3.svg.brush().x(x).y(y).on("brushend",brushend);d3.select(params.root+' .brush_group').call(brush);function brushend(){// do not display dendro crop buttons when cropping with brushing
d3.select(cgm.params.root+' .col_dendro_icons_container').style('display','none');d3.select(cgm.params.root+' .row_dendro_icons_container').style('display','none');var brushing_extent=brush.extent();var brush_start=brushing_extent[0];var brush_end=brushing_extent[1];var x_start=brush_start[0];var x_end=brush_end[0];var y_start=brush_start[1];var y_end=brush_end[1];if(x_start!=x_end&&y_start!=y_end){setTimeout(deactivate_cropping,500,cgm);// find cropped nodes
var found_nodes=find_cropped_nodes(x_start,x_end,y_start,y_end,brush_start,brush_end);cgm.filter_viz_using_names(found_nodes);d3.select(params.root+' .crop_button').style('color','#337ab7').classed('fa-crop',false).classed('fa-undo',true);}}function find_cropped_nodes(x_start,x_end,y_start,y_end,brush_start,brush_end){// reverse if necessary (depending on how brushing was done)
if(x_start>x_end){x_start=brush_end[0];x_end=brush_start[0];}if(y_start>y_end){y_start=brush_end[1];y_end=brush_start[1];}// add room to brushing
y_start=y_start-params.viz.rect_height;x_start=x_start-params.viz.rect_width;var found_nodes={};found_nodes.row=[];found_nodes.col=[];// d3.selectAll(params.root+' .row_label_group')
//   .each(function(inst_row){
//     // there is already bound data on the rows
//     var inst_trans = d3.select(this)
//       .attr('transform');
//     var y_trans = Number(inst_trans.split(',')[1].split(')')[0]);
//     if (y_trans > y_start && y_trans < y_end){
//       found_nodes.row.push(inst_row.name);
//     }
//   });
underscore.each(params.matrix.matrix,function(row_data){var y_trans=params.viz.y_scale(row_data.row_index);if(y_trans>y_start&&y_trans<y_end){found_nodes.row.push(row_data.name);}});d3.selectAll(params.root+' .col_label_text').each(function(inst_col){// there is already bound data on the cols
var inst_trans=d3.select(this).attr('transform');var x_trans=Number(inst_trans.split(',')[0].split('(')[1]);if(x_trans>x_start&&x_trans<x_end){found_nodes.col.push(inst_col.name);}});return found_nodes;}d3.selectAll(params.root+' .extent').style('opacity',0.2).style('fill','black');};/***/},/* 251 *//***/function(module,exports){module.exports=function deactivate_cropping(cgm){d3.select(cgm.params.root+' .brush_group').transition().style('opacity',0).remove();cgm.params.is_cropping=false;};/***/},/* 252 *//***/function(module,exports,__webpack_require__){var __WEBPACK_AMD_DEFINE_FACTORY__,__WEBPACK_AMD_DEFINE_ARRAY__,__WEBPACK_AMD_DEFINE_RESULT__;/*
	    D3.js Slider
	    Inspired by jQuery UI Slider
	    Copyright (c) 2013, Bjorn Sandvik - http://blog.thematicmapping.org
	    BSD license: http://opensource.org/licenses/BSD-3-Clause
	*/(function(root,factory){{// AMD. Register as an anonymous module.
!(__WEBPACK_AMD_DEFINE_ARRAY__=[__webpack_require__(253)], __WEBPACK_AMD_DEFINE_FACTORY__=factory, __WEBPACK_AMD_DEFINE_RESULT__=typeof __WEBPACK_AMD_DEFINE_FACTORY__==='function'?__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports,__WEBPACK_AMD_DEFINE_ARRAY__):__WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__!==undefined&&(module.exports=__WEBPACK_AMD_DEFINE_RESULT__));}})(this,function(d3){return function module(){var min=0,max=100,step=0.01,animate=false,orientation="horizontal",axis=false,margin=50,value,active=1,snap=false,scale;// Private variables
var axisScale,dispatch=d3.dispatch("slide","slideend"),formatPercent=d3.format(".2%"),tickFormat=d3.format(".0"),handle1,handle2=null,divRange,sliderLength;function slider(selection){selection.each(function(){// Create scale if not defined by user
if(!scale){scale=d3.scale.linear().domain([min,max]);}// Start value
value=value||scale.domain()[0];// DIV container
var div=d3.select(this).classed("d3-slider d3-slider-"+orientation,true);var drag=d3.behavior.drag();drag.on('dragend',function(){dispatch.slideend(d3.event,value);});// Slider handle
//if range slider, create two
// var divRange;
if(toType(value)=="array"&&value.length==2){handle1=div.append("a").classed("d3-slider-handle",true).attr("xlink:href","#").attr('id',"handle-one").on("click",stopPropagation).call(drag);handle2=div.append("a").classed("d3-slider-handle",true).attr('id',"handle-two").attr("xlink:href","#").on("click",stopPropagation).call(drag);}else{handle1=div.append("a").classed("d3-slider-handle",true).attr("xlink:href","#").attr('id',"handle-one").on("click",stopPropagation).call(drag);}// Horizontal slider
if(orientation==="horizontal"){div.on("click",onClickHorizontal);if(toType(value)=="array"&&value.length==2){divRange=d3.select(this).append('div').classed("d3-slider-range",true);handle1.style("left",formatPercent(scale(value[0])));divRange.style("left",formatPercent(scale(value[0])));drag.on("drag",onDragHorizontal);var width=100-parseFloat(formatPercent(scale(value[1])));handle2.style("left",formatPercent(scale(value[1])));divRange.style("right",width+"%");drag.on("drag",onDragHorizontal);}else{handle1.style("left",formatPercent(scale(value)));drag.on("drag",onDragHorizontal);}sliderLength=parseInt(div.style("width"),10);}else{// Vertical
div.on("click",onClickVertical);drag.on("drag",onDragVertical);if(toType(value)=="array"&&value.length==2){divRange=d3.select(this).append('div').classed("d3-slider-range-vertical",true);handle1.style("bottom",formatPercent(scale(value[0])));divRange.style("bottom",formatPercent(scale(value[0])));drag.on("drag",onDragVertical);var top=100-parseFloat(formatPercent(scale(value[1])));handle2.style("bottom",formatPercent(scale(value[1])));divRange.style("top",top+"%");drag.on("drag",onDragVertical);}else{handle1.style("bottom",formatPercent(scale(value)));drag.on("drag",onDragVertical);}sliderLength=parseInt(div.style("height"),10);}if(axis){createAxis(div);}function createAxis(dom){// Create axis if not defined by user
if(typeof axis==="boolean"){axis=d3.svg.axis().ticks(Math.round(sliderLength/100)).tickFormat(tickFormat).orient(orientation==="horizontal"?"bottom":"right");}// Copy slider scale to move from percentages to pixels
axisScale=scale.ticks?scale.copy().range([0,sliderLength]):scale.copy().rangePoints([0,sliderLength],0.5);axis.scale(axisScale);// Create SVG axis container
var svg=dom.append("svg").classed("d3-slider-axis d3-slider-axis-"+axis.orient(),true).on("click",stopPropagation);var g=svg.append("g");// Horizontal axis
if(orientation==="horizontal"){svg.style("margin-left",-margin+"px");svg.attr({width:sliderLength+margin*2,height:margin});if(axis.orient()==="top"){svg.style("top",-margin+"px");g.attr("transform","translate("+margin+","+margin+")");}else{// bottom
g.attr("transform","translate("+margin+",0)");}}else{// Vertical
svg.style("top",-margin+"px");svg.attr({width:margin,height:sliderLength+margin*2});if(axis.orient()==="left"){svg.style("left",-margin+"px");g.attr("transform","translate("+margin+","+margin+")");}else{// right
g.attr("transform","translate("+0+","+margin+")");}}g.call(axis);}function onClickHorizontal(){if(toType(value)!="array"){var pos=Math.max(0,Math.min(sliderLength,d3.event.offsetX||d3.event.layerX));moveHandle(scale.invert?stepValue(scale.invert(pos/sliderLength)):nearestTick(pos/sliderLength));}}function onClickVertical(){if(toType(value)!="array"){var pos=sliderLength-Math.max(0,Math.min(sliderLength,d3.event.offsetY||d3.event.layerY));moveHandle(scale.invert?stepValue(scale.invert(pos/sliderLength)):nearestTick(pos/sliderLength));}}function onDragHorizontal(){if(d3.event.sourceEvent.target.id==="handle-one"){active=1;}else if(d3.event.sourceEvent.target.id=="handle-two"){active=2;}var pos=Math.max(0,Math.min(sliderLength,d3.event.x));moveHandle(scale.invert?stepValue(scale.invert(pos/sliderLength)):nearestTick(pos/sliderLength));}function onDragVertical(){if(d3.event.sourceEvent.target.id==="handle-one"){active=1;}else if(d3.event.sourceEvent.target.id=="handle-two"){active=2;}var pos=sliderLength-Math.max(0,Math.min(sliderLength,d3.event.y));moveHandle(scale.invert?stepValue(scale.invert(pos/sliderLength)):nearestTick(pos/sliderLength));}function stopPropagation(){d3.event.stopPropagation();}});}// Move slider handle on click/drag
function moveHandle(newValue){var currentValue=toType(value)=="array"&&value.length==2?value[active-1]:value,oldPos=formatPercent(scale(stepValue(currentValue))),newPos=formatPercent(scale(stepValue(newValue))),position=orientation==="horizontal"?"left":"bottom";if(oldPos!==newPos){if(toType(value)=="array"&&value.length==2){value[active-1]=newValue;if(d3.event){dispatch.slide(d3.event,value);}}else{if(d3.event){dispatch.slide(d3.event.sourceEvent||d3.event,value=newValue);}}if(value[0]>=value[1])return;if(active===1){if(toType(value)=="array"&&value.length==2){position==="left"?divRange.style("left",newPos):divRange.style("bottom",newPos);}if(animate){handle1.transition().styleTween(position,function(){return d3.interpolate(oldPos,newPos);}).duration(typeof animate==="number"?animate:250);}else{handle1.style(position,newPos);}}else{var width=100-parseFloat(newPos);var top=100-parseFloat(newPos);position==="left"?divRange.style("right",width+"%"):divRange.style("top",top+"%");if(animate){handle2.transition().styleTween(position,function(){return d3.interpolate(oldPos,newPos);}).duration(typeof animate==="number"?animate:250);}else{handle2.style(position,newPos);}}}}// Calculate nearest step value
function stepValue(val){if(val===scale.domain()[0]||val===scale.domain()[1]){return val;}var alignValue=val;if(snap){alignValue=nearestTick(scale(val));}else{var valModStep=(val-scale.domain()[0])%step;alignValue=val-valModStep;if(Math.abs(valModStep)*2>=step){alignValue+=valModStep>0?step:-step;}}return alignValue;}// Find the nearest tick
function nearestTick(pos){var ticks=scale.ticks?scale.ticks():scale.domain();var dist=ticks.map(function(d){return pos-scale(d);});var i=-1,index=0,r=scale.ticks?scale.range()[1]:scale.rangeExtent()[1];do{i++;if(Math.abs(dist[i])<r){r=Math.abs(dist[i]);index=i;}}while(dist[i]>0&&i<dist.length-1);return ticks[index];}// Return the type of an object
function toType(v){return{}.toString.call(v).match(/\s([a-zA-Z]+)/)[1].toLowerCase();}// Getter/setter functions
slider.min=function(_){if(!arguments.length)return min;min=_;return slider;};slider.max=function(_){if(!arguments.length)return max;max=_;return slider;};slider.step=function(_){if(!arguments.length)return step;step=_;return slider;};slider.animate=function(_){if(!arguments.length)return animate;animate=_;return slider;};slider.orientation=function(_){if(!arguments.length)return orientation;orientation=_;return slider;};slider.axis=function(_){if(!arguments.length)return axis;axis=_;return slider;};slider.margin=function(_){if(!arguments.length)return margin;margin=_;return slider;};slider.value=function(_){if(!arguments.length)return value;if(value){moveHandle(stepValue(_));}value=_;return slider;};slider.snap=function(_){if(!arguments.length)return snap;snap=_;return slider;};slider.scale=function(_){if(!arguments.length)return scale;scale=_;return slider;};d3.rebind(slider,dispatch,"on");return slider;};});/***/},/* 253 *//***/function(module,exports){module.exports=d3;/***/},/* 254 *//***/function(module,exports){/**
	 * Simple, lightweight, usable local autocomplete library for modern browsers
	 * Because there weren’t enough autocomplete scripts in the world? Because I’m completely insane and have NIH syndrome? Probably both. :P
	 * @author Lea Verou http://leaverou.github.io/awesomplete
	 * MIT license
	 */(function(){var _=function _(input,o){var me=this;// Setup
this.input=$(input);this.input.setAttribute("autocomplete","off");this.input.setAttribute("aria-autocomplete","list");o=o||{};configure(this,{minChars:2,maxItems:10,autoFirst:false,data:_.DATA,filter:_.FILTER_CONTAINS,sort:_.SORT_BYLENGTH,item:_.ITEM,replace:_.REPLACE},o);this.index=-1;// Create necessary elements
this.container=$.create("div",{className:"awesomplete",around:input});this.ul=$.create("ul",{hidden:"hidden",inside:this.container});this.status=$.create("span",{className:"visually-hidden",role:"status","aria-live":"assertive","aria-relevant":"additions",inside:this.container});// Bind events
$.bind(this.input,{"input":this.evaluate.bind(this),"blur":this.close.bind(this,{reason:"blur"}),"keydown":function keydown(evt){var c=evt.keyCode;// If the dropdown `ul` is in view, then act on keydown for the following keys:
// Enter / Esc / Up / Down
if(me.opened){if(c===13&&me.selected){// Enter
evt.preventDefault();me.select();}else if(c===27){// Esc
me.close({reason:"esc"});}else if(c===38||c===40){// Down/Up arrow
evt.preventDefault();me[c===38?"previous":"next"]();}}}});$.bind(this.input.form,{"submit":this.close.bind(this,{reason:"submit"})});$.bind(this.ul,{"mousedown":function mousedown(evt){var li=evt.target;if(li!==this){while(li&&!/li/i.test(li.nodeName)){li=li.parentNode;}if(li&&evt.button===0){// Only select on left click
evt.preventDefault();me.select(li,evt.target);}}}});if(this.input.hasAttribute("list")){this.list="#"+this.input.getAttribute("list");this.input.removeAttribute("list");}else{this.list=this.input.getAttribute("data-list")||o.list||[];}_.all.push(this);};_.prototype={set list(list){if(Array.isArray(list)){this._list=list;}else if(typeof list==="string"&&list.indexOf(",")>-1){this._list=list.split(/\s*,\s*/);}else{// Element or CSS selector
list=$(list);if(list&&list.children){var items=[];slice.apply(list.children).forEach(function(el){if(!el.disabled){var text=el.textContent.trim();var value=el.value||text;var label=el.label||text;if(value!==""){items.push({label:label,value:value});}}});this._list=items;}}if(document.activeElement===this.input){this.evaluate();}},get selected(){return this.index>-1;},get opened(){return!this.ul.hasAttribute("hidden");},close:function close(o){if(!this.opened){return;}this.ul.setAttribute("hidden","");this.index=-1;$.fire(this.input,"awesomplete-close",o||{});},open:function open(){this.ul.removeAttribute("hidden");if(this.autoFirst&&this.index===-1){this.goto(0);}$.fire(this.input,"awesomplete-open");},next:function next(){var count=this.ul.children.length;this.goto(this.index<count-1?this.index+1:-1);},previous:function previous(){var count=this.ul.children.length;this.goto(this.selected?this.index-1:count-1);},// Should not be used, highlights specific item without any checks!
goto:function goto(i){var lis=this.ul.children;if(this.selected){lis[this.index].setAttribute("aria-selected","false");}this.index=i;if(i>-1&&lis.length>0){lis[i].setAttribute("aria-selected","true");this.status.textContent=lis[i].textContent;$.fire(this.input,"awesomplete-highlight",{text:this.suggestions[this.index]});}},select:function select(selected,origin){if(selected){this.index=$.siblingIndex(selected);}else{selected=this.ul.children[this.index];}if(selected){var suggestion=this.suggestions[this.index];var allowed=$.fire(this.input,"awesomplete-select",{text:suggestion,origin:origin||selected});if(allowed){this.replace(suggestion);this.close({reason:"select"});$.fire(this.input,"awesomplete-selectcomplete",{text:suggestion});}}},evaluate:function evaluate(){var me=this;var value=this.input.value;if(value.length>=this.minChars&&this._list.length>0){this.index=-1;// Populate list with options that match
this.ul.innerHTML="";this.suggestions=this._list.map(function(item){return new Suggestion(me.data(item,value));}).filter(function(item){return me.filter(item,value);}).sort(this.sort).slice(0,this.maxItems);this.suggestions.forEach(function(text){me.ul.appendChild(me.item(text,value));});if(this.ul.children.length===0){this.close({reason:"nomatches"});}else{this.open();}}else{this.close({reason:"nomatches"});}}};// Static methods/properties
_.all=[];_.FILTER_CONTAINS=function(text,input){return RegExp($.regExpEscape(input.trim()),"i").test(text);};_.FILTER_STARTSWITH=function(text,input){return RegExp("^"+$.regExpEscape(input.trim()),"i").test(text);};_.SORT_BYLENGTH=function(a,b){if(a.length!==b.length){return a.length-b.length;}return a<b?-1:1;};_.ITEM=function(text,input){var html=input===''?text:text.replace(RegExp($.regExpEscape(input.trim()),"gi"),"<mark>$&</mark>");return $.create("li",{innerHTML:html,"aria-selected":"false"});};_.REPLACE=function(text){this.input.value=text.value;};_.DATA=function(item/*, input*/){return item;};// Private functions
function Suggestion(data){var o=Array.isArray(data)?{label:data[0],value:data[1]}:(typeof data==='undefined'?'undefined':_typeof(data))==="object"&&"label"in data&&"value"in data?data:{label:data,value:data};this.label=o.label||o.value;this.value=o.value;}Object.defineProperty(Suggestion.prototype=Object.create(String.prototype),"length",{get:function get$$1(){return this.label.length;}});Suggestion.prototype.toString=Suggestion.prototype.valueOf=function(){return""+this.label;};function configure(instance,properties,o){for(var i in properties){var initial=properties[i],attrValue=instance.input.getAttribute("data-"+i.toLowerCase());if(typeof initial==="number"){instance[i]=parseInt(attrValue);}else if(initial===false){// Boolean options must be false by default anyway
instance[i]=attrValue!==null;}else if(initial instanceof Function){instance[i]=null;}else{instance[i]=attrValue;}if(!instance[i]&&instance[i]!==0){instance[i]=i in o?o[i]:initial;}}}// Helpers
var slice=Array.prototype.slice;function $(expr,con){return typeof expr==="string"?(con||document).querySelector(expr):expr||null;}function $$(expr,con){return slice.call((con||document).querySelectorAll(expr));}$.create=function(tag,o){var element=document.createElement(tag);for(var i in o){var val=o[i];if(i==="inside"){$(val).appendChild(element);}else if(i==="around"){var ref=$(val);ref.parentNode.insertBefore(element,ref);element.appendChild(ref);}else if(i in element){element[i]=val;}else{element.setAttribute(i,val);}}return element;};$.bind=function(element,o){if(element){for(var event in o){var callback=o[event];event.split(/\s+/).forEach(function(event){element.addEventListener(event,callback);});}}};$.fire=function(target,type,properties){var evt=document.createEvent("HTMLEvents");evt.initEvent(type,true,true);for(var j in properties){evt[j]=properties[j];}return target.dispatchEvent(evt);};$.regExpEscape=function(s){return s.replace(/[-\\^$*+?.()|[\]{}]/g,"\\$&");};$.siblingIndex=function(el){/* eslint-disable no-cond-assign */for(var i=0;el=el.previousElementSibling;i++){}return i;};// Initialization
function init(){$$("input.awesomplete").forEach(function(input){new _(input);});}// Are we in a browser? Check for Document constructor
if(typeof Document!=="undefined"){// DOM already loaded?
if(document.readyState!=="loading"){init();}else{// Wait for it
document.addEventListener("DOMContentLoaded",init);}}_.$=$;_.$$=$$;// Make sure to export Awesomplete on self when in a browser
if(typeof self!=="undefined"){self.Awesomplete=_;}// Expose Awesomplete as a CJS module
if((typeof module==='undefined'?'undefined':_typeof(module))==="object"&&module.exports){module.exports=_;}return _;})();/***/},/* 255 *//***/function(module,exports,__webpack_require__){// style-loader: Adds some css to the DOM by adding a <style> tag
// load the styles
var content=__webpack_require__(256);if(typeof content==='string')content=[[module.id,content,'']];// add the styles to the DOM
var update=__webpack_require__(258)(content,{});if(content.locals)module.exports=content.locals;// Hot Module Replacement
/***/},/* 256 *//***/function(module,exports,__webpack_require__){exports=module.exports=__webpack_require__(257)();// imports
// module
exports.push([module.id,".d3-slider {\n    position: relative;\n    font-family: Verdana,Arial,sans-serif;\n    font-size: 1.1em;\n    border: 1px solid #aaaaaa;\n    z-index: 2;\n}\n\n.d3-slider-horizontal {\n    height: .8em;\n}  \n\n.d3-slider-range {\n  background:#2980b9;\n  left:0px;\n  right:0px;\n  height: 0.8em;\n  position: absolute;\n}\n\n.d3-slider-range-vertical {\n  background:#2980b9;\n  left:0px;\n  right:0px;\n  position: absolute;\n  top:0;\n}\n\n.d3-slider-vertical {\n    width: .8em;\n    height: 100px;\n}      \n\n.d3-slider-handle {\n    position: absolute;\n    width: 1.2em;\n    height: 1.2em;\n    border: 1px solid #d3d3d3;\n    border-radius: 4px;\n    background: #eee;\n    background: linear-gradient(to bottom, #eee 0%, #ddd 100%);\n    z-index: 3;\n}\n\n.d3-slider-handle:hover {\n    border: 1px solid #999999;\n}\n\n.d3-slider-horizontal .d3-slider-handle {\n    top: -.3em;\n    margin-left: -.6em;\n}\n\n.d3-slider-axis {\n    position: relative;\n    z-index: 1;    \n}\n\n.d3-slider-axis-bottom {\n    top: .8em;\n}\n\n.d3-slider-axis-right {\n    left: .8em;\n}\n\n.d3-slider-axis path {\n    stroke-width: 0;\n    fill: none;\n}\n\n.d3-slider-axis line {\n    fill: none;\n    stroke: #aaa;\n    shape-rendering: crispEdges;\n}\n\n.d3-slider-axis text {\n    font-size: 11px;\n}\n\n.d3-slider-vertical .d3-slider-handle {\n    left: -.25em;\n    margin-left: 0;\n    margin-bottom: -.6em;      \n}",""]);// exports
/***/},/* 257 *//***/function(module,exports){/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/// css base code, injected by the css-loader
module.exports=function(){var list=[];// return the list of modules as css string
list.toString=function toString(){var result=[];for(var i=0;i<this.length;i++){var item=this[i];if(item[2]){result.push("@media "+item[2]+"{"+item[1]+"}");}else{result.push(item[1]);}}return result.join("");};// import a list of modules into the list
list.i=function(modules,mediaQuery){if(typeof modules==="string")modules=[[null,modules,""]];var alreadyImportedModules={};for(var i=0;i<this.length;i++){var id=this[i][0];if(typeof id==="number")alreadyImportedModules[id]=true;}for(i=0;i<modules.length;i++){var item=modules[i];// skip already imported module
// this implementation is not 100% perfect for weird media query combinations
//  when a module is imported multiple times with different media queries.
//  I hope this will never occur (Hey this way we have smaller bundles)
if(typeof item[0]!=="number"||!alreadyImportedModules[item[0]]){if(mediaQuery&&!item[2]){item[2]=mediaQuery;}else if(mediaQuery){item[2]="("+item[2]+") and ("+mediaQuery+")";}list.push(item);}}};return list;};/***/},/* 258 *//***/function(module,exports,__webpack_require__){/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/var stylesInDom={},memoize=function memoize(fn){var memo;return function(){if(typeof memo==="undefined")memo=fn.apply(this,arguments);return memo;};},isOldIE=memoize(function(){return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());}),getHeadElement=memoize(function(){return document.head||document.getElementsByTagName("head")[0];}),singletonElement=null,singletonCounter=0,styleElementsInsertedAtTop=[];module.exports=function(list,options){options=options||{};// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
if(typeof options.singleton==="undefined")options.singleton=isOldIE();// By default, add <style> tags to the bottom of <head>.
if(typeof options.insertAt==="undefined")options.insertAt="bottom";var styles=listToStyles(list);addStylesToDom(styles,options);return function update(newList){var mayRemove=[];for(var i=0;i<styles.length;i++){var item=styles[i];var domStyle=stylesInDom[item.id];domStyle.refs--;mayRemove.push(domStyle);}if(newList){var newStyles=listToStyles(newList);addStylesToDom(newStyles,options);}for(var i=0;i<mayRemove.length;i++){var domStyle=mayRemove[i];if(domStyle.refs===0){for(var j=0;j<domStyle.parts.length;j++){domStyle.parts[j]();}delete stylesInDom[domStyle.id];}}};};function addStylesToDom(styles,options){for(var i=0;i<styles.length;i++){var item=styles[i];var domStyle=stylesInDom[item.id];if(domStyle){domStyle.refs++;for(var j=0;j<domStyle.parts.length;j++){domStyle.parts[j](item.parts[j]);}for(;j<item.parts.length;j++){domStyle.parts.push(addStyle(item.parts[j],options));}}else{var parts=[];for(var j=0;j<item.parts.length;j++){parts.push(addStyle(item.parts[j],options));}stylesInDom[item.id]={id:item.id,refs:1,parts:parts};}}}function listToStyles(list){var styles=[];var newStyles={};for(var i=0;i<list.length;i++){var item=list[i];var id=item[0];var css=item[1];var media=item[2];var sourceMap=item[3];var part={css:css,media:media,sourceMap:sourceMap};if(!newStyles[id])styles.push(newStyles[id]={id:id,parts:[part]});else newStyles[id].parts.push(part);}return styles;}function insertStyleElement(options,styleElement){var head=getHeadElement();var lastStyleElementInsertedAtTop=styleElementsInsertedAtTop[styleElementsInsertedAtTop.length-1];if(options.insertAt==="top"){if(!lastStyleElementInsertedAtTop){head.insertBefore(styleElement,head.firstChild);}else if(lastStyleElementInsertedAtTop.nextSibling){head.insertBefore(styleElement,lastStyleElementInsertedAtTop.nextSibling);}else{head.appendChild(styleElement);}styleElementsInsertedAtTop.push(styleElement);}else if(options.insertAt==="bottom"){head.appendChild(styleElement);}else{throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");}}function removeStyleElement(styleElement){styleElement.parentNode.removeChild(styleElement);var idx=styleElementsInsertedAtTop.indexOf(styleElement);if(idx>=0){styleElementsInsertedAtTop.splice(idx,1);}}function createStyleElement(options){var styleElement=document.createElement("style");styleElement.type="text/css";insertStyleElement(options,styleElement);return styleElement;}function createLinkElement(options){var linkElement=document.createElement("link");linkElement.rel="stylesheet";insertStyleElement(options,linkElement);return linkElement;}function addStyle(obj,options){var styleElement,update,remove;if(options.singleton){var styleIndex=singletonCounter++;styleElement=singletonElement||(singletonElement=createStyleElement(options));update=applyToSingletonTag.bind(null,styleElement,styleIndex,false);remove=applyToSingletonTag.bind(null,styleElement,styleIndex,true);}else if(obj.sourceMap&&typeof URL==="function"&&typeof URL.createObjectURL==="function"&&typeof URL.revokeObjectURL==="function"&&typeof Blob==="function"&&typeof btoa==="function"){styleElement=createLinkElement(options);update=updateLink.bind(null,styleElement);remove=function remove(){removeStyleElement(styleElement);if(styleElement.href)URL.revokeObjectURL(styleElement.href);};}else{styleElement=createStyleElement(options);update=applyToTag.bind(null,styleElement);remove=function remove(){removeStyleElement(styleElement);};}update(obj);return function updateStyle(newObj){if(newObj){if(newObj.css===obj.css&&newObj.media===obj.media&&newObj.sourceMap===obj.sourceMap)return;update(obj=newObj);}else{remove();}};}var replaceText=function(){var textStore=[];return function(index,replacement){textStore[index]=replacement;return textStore.filter(Boolean).join('\n');};}();function applyToSingletonTag(styleElement,index,remove,obj){var css=remove?"":obj.css;if(styleElement.styleSheet){styleElement.styleSheet.cssText=replaceText(index,css);}else{var cssNode=document.createTextNode(css);var childNodes=styleElement.childNodes;if(childNodes[index])styleElement.removeChild(childNodes[index]);if(childNodes.length){styleElement.insertBefore(cssNode,childNodes[index]);}else{styleElement.appendChild(cssNode);}}}function applyToTag(styleElement,obj){var css=obj.css;var media=obj.media;if(media){styleElement.setAttribute("media",media);}if(styleElement.styleSheet){styleElement.styleSheet.cssText=css;}else{while(styleElement.firstChild){styleElement.removeChild(styleElement.firstChild);}styleElement.appendChild(document.createTextNode(css));}}function updateLink(linkElement,obj){var css=obj.css;var sourceMap=obj.sourceMap;if(sourceMap){// http://stackoverflow.com/a/26603875
css+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))))+" */";}var blob=new Blob([css],{type:"text/css"});var oldSrc=linkElement.href;linkElement.href=URL.createObjectURL(blob);if(oldSrc)URL.revokeObjectURL(oldSrc);}/***/},/* 259 *//***/function(module,exports,__webpack_require__){// style-loader: Adds some css to the DOM by adding a <style> tag
// load the styles
var content=__webpack_require__(260);if(typeof content==='string')content=[[module.id,content,'']];// add the styles to the DOM
var update=__webpack_require__(258)(content,{});if(content.locals)module.exports=content.locals;// Hot Module Replacement
/***/},/* 260 *//***/function(module,exports,__webpack_require__){exports=module.exports=__webpack_require__(257)();// imports
// module
exports.push([module.id,"[hidden] { display: none; }\n\n.visually-hidden {\n\tposition: absolute;\n\tclip: rect(0, 0, 0, 0);\n}\n\ndiv.awesomplete {\n\tdisplay: inline-block;\n\tposition: relative;\n}\n\ndiv.awesomplete > input {\n\tdisplay: block;\n}\n\ndiv.awesomplete > ul {\n\tposition: absolute;\n\tleft: 0;\n\tz-index: 1;\n\tmin-width: 100%;\n\tbox-sizing: border-box;\n\tlist-style: none;\n\tpadding: 0;\n\tborder-radius: .3em;\n\tmargin: .2em 0 0;\n\tbackground: hsla(0,0%,100%,.9);\n\tbackground: linear-gradient(to bottom right, white, hsla(0,0%,100%,.8));\n\tborder: 1px solid rgba(0,0,0,.3);\n\tbox-shadow: .05em .2em .6em rgba(0,0,0,.2);\n\ttext-shadow: none;\n}\n\ndiv.awesomplete > ul[hidden],\ndiv.awesomplete > ul:empty {\n\tdisplay: none;\n}\n\n@supports (transform: scale(0)) {\n\tdiv.awesomplete > ul {\n\t\ttransition: .3s cubic-bezier(.4,.2,.5,1.4);\n\t\ttransform-origin: 1.43em -.43em;\n\t}\n\t\n\tdiv.awesomplete > ul[hidden],\n\tdiv.awesomplete > ul:empty {\n\t\topacity: 0;\n\t\ttransform: scale(0);\n\t\tdisplay: block;\n\t\ttransition-timing-function: ease;\n\t}\n}\n\n\t/* Pointer */\n\tdiv.awesomplete > ul:before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\ttop: -.43em;\n\t\tleft: 1em;\n\t\twidth: 0; height: 0;\n\t\tpadding: .4em;\n\t\tbackground: white;\n\t\tborder: inherit;\n\t\tborder-right: 0;\n\t\tborder-bottom: 0;\n\t\t-webkit-transform: rotate(45deg);\n\t\ttransform: rotate(45deg);\n\t}\n\n\tdiv.awesomplete > ul > li {\n\t\tposition: relative;\n\t\tpadding: .2em .5em;\n\t\tcursor: pointer;\n\t}\n\t\n\tdiv.awesomplete > ul > li:hover {\n\t\tbackground: hsl(200, 40%, 80%);\n\t\tcolor: black;\n\t}\n\t\n\tdiv.awesomplete > ul > li[aria-selected=\"true\"] {\n\t\tbackground: hsl(205, 40%, 40%);\n\t\tcolor: white;\n\t}\n\t\n\t\tdiv.awesomplete mark {\n\t\t\tbackground: hsl(65, 100%, 50%);\n\t\t}\n\t\t\n\t\tdiv.awesomplete li:hover mark {\n\t\t\tbackground: hsl(68, 100%, 41%);\n\t\t}\n\t\t\n\t\tdiv.awesomplete li[aria-selected=\"true\"] mark {\n\t\t\tbackground: hsl(86, 100%, 21%);\n\t\t\tcolor: inherit;\n\t\t}",""]);// exports
/***/},/* 261 *//***/function(module,exports,__webpack_require__){var ini_sidebar=__webpack_require__(222);var set_up_filters=__webpack_require__(262);var set_up_search=__webpack_require__(267);var set_up_reorder=__webpack_require__(268);var set_sidebar_ini_view=__webpack_require__(269);var make_icons=__webpack_require__(270);var make_modals=__webpack_require__(272);var set_up_opacity_slider=__webpack_require__(274);var make_colorbar=__webpack_require__(275);var underscore=__webpack_require__(3);/* Represents sidebar with controls.
	 */module.exports=function sidebar(cgm){var params=cgm.params;var sidebar=d3.select(params.root+' .sidebar_wrapper');// console.log('is_expand ',params.viz.is_expand)
if(params.viz.is_expand){sidebar.style('display','none');}sidebar.append('div').classed('title_section',true);if(params.sidebar.title!=null){sidebar.select('.title_section').append('h4')// .style('margin-left', params.sidebar.title_margin_left+'px')
.style('margin-left','20px').style('margin-top','5px').style('margin-bottom','0px').text(params.sidebar.title);}sidebar.append('div').style('padding-right','2px').classed('about_section',true);if(params.sidebar.about!=null){sidebar.select('.about_section').append('h5').classed('sidebar_text',true).style('margin-left','7px').style('margin-top','5px').style('margin-bottom','2px').style('text-align','justify').html(params.sidebar.about);}sidebar.append('div').classed('icons_section',true).style('text-align','center');if(cgm.params.make_modals){make_modals(params);}if(params.sidebar.icons){make_icons(cgm,sidebar);}set_up_reorder(params,sidebar);set_up_search(sidebar,params);set_up_opacity_slider(sidebar);var possible_filter_names=underscore.keys(params.viz.possible_filters);if(possible_filter_names.indexOf('enr_score_type')>-1){possible_filter_names.sort(function(a,b){return a.toLowerCase().localeCompare(b.toLowerCase());});}cgm.slider_functions={};underscore.each(possible_filter_names,function(inst_filter){set_up_filters(cgm,inst_filter);});ini_sidebar(cgm);// when initializing the visualization using a view
if(params.ini_view!==null){set_sidebar_ini_view(params);params.ini_view=null;}make_colorbar(cgm);};/***/},/* 262 *//***/function(module,exports,__webpack_require__){var make_slider_filter=__webpack_require__(263);var make_button_filter=__webpack_require__(266);module.exports=function set_up_filters(cgm,filter_type){var params=cgm.params;var div_filters=d3.select(params.root+' .sidebar_wrapper').append('div').classed('div_filters',true).style('padding-left','10px').style('padding-right','10px');if(params.viz.possible_filters[filter_type]=='numerical'){make_slider_filter(cgm,filter_type,div_filters);}else if(params.viz.possible_filters[filter_type]=='categorical'){make_button_filter(cgm,filter_type,div_filters);}};/***/},/* 263 *//***/function(module,exports,__webpack_require__){var make_filter_title=__webpack_require__(245);var run_filter_slider=__webpack_require__(264);var get_filter_default_state=__webpack_require__(6);var get_subset_views=__webpack_require__(62);d3.slider=__webpack_require__(252);var underscore=__webpack_require__(3);module.exports=function make_slider_filter(cgm,filter_type,div_filters){var params=cgm.params;var inst_view={};var possible_filters=underscore.keys(params.viz.possible_filters);underscore.each(possible_filters,function(tmp_filter){if(tmp_filter!=filter_type){var default_state=get_filter_default_state(params.viz.filter_data,tmp_filter);inst_view[tmp_filter]=default_state;}});var filter_title=make_filter_title(params,filter_type);div_filters.append('div').classed('title_'+filter_type,true).classed('sidebar_text',true).classed('slider_description',true).style('margin-top','5px').style('margin-bottom','3px').text(filter_title.text+filter_title.state+filter_title.suffix);div_filters.append('div').classed('slider_'+filter_type,true).classed('slider',true).attr('current_state',filter_title.state);var views=params.network_data.views;var available_views=get_subset_views(params,views,inst_view);// sort available views by filter_type value
available_views=available_views.sort(function(a,b){return b[filter_type]-a[filter_type];});var inst_max=available_views.length-1;var ini_value=0;// change the starting position of the slider if necessary
if(params.requested_view!==null&&filter_type in params.requested_view){var inst_filter_value=params.requested_view[filter_type];if(inst_filter_value!='all'){var found_value=available_views.map(function(e){return e[filter_type];}).indexOf(inst_filter_value);if(found_value>0){ini_value=found_value;}}}// Filter Slider
//////////////////////////////////////////////////////////////////////
var slide_filter_fun=d3.slider().value(ini_value).min(0).max(inst_max).step(1).on('slide',function(evt,value){run_filter_slider_db(cgm,filter_type,available_views,value);}).on('slideend',function(evt,value){run_filter_slider_db(cgm,filter_type,available_views,value);});// save slider function in order to reset value later
cgm.slider_functions[filter_type]=slide_filter_fun;d3.select(cgm.params.root+' .slider_'+filter_type).call(slide_filter_fun);//////////////////////////////////////////////////////////////////////
var run_filter_slider_db=underscore.debounce(run_filter_slider,800);};/***/},/* 264 *//***/function(module,exports,__webpack_require__){var update_viz_with_view=__webpack_require__(207);var reset_other_filter_sliders=__webpack_require__(244);var get_current_orders=__webpack_require__(265);var make_requested_view=__webpack_require__(64);var underscore=__webpack_require__(3);module.exports=function run_filter_slider(cgm,filter_type,available_views,inst_index){// only update if not running update
if(d3.select(cgm.params.viz.viz_svg).classed('running_update')===false){var params=cgm.params;// get value
var inst_state=available_views[inst_index][filter_type];reset_other_filter_sliders(cgm,filter_type,inst_state);params=get_current_orders(params);var requested_view={};requested_view[filter_type]=inst_state;requested_view=make_requested_view(params,requested_view);if(underscore.has(available_views[0],'enr_score_type')){var enr_state=d3.select(params.root+' .toggle_enr_score_type').attr('current_state');requested_view.enr_score_type=enr_state;}update_viz_with_view(cgm,requested_view);}};/***/},/* 265 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function get_current_orders(params){// get current orders
var other_rc;underscore.each(['row','col'],function(inst_rc){if(inst_rc==='row'){other_rc='col';}else{other_rc='row';}if(d3.select(params.root+' .toggle_'+other_rc+'_order .active').empty()===false){params.viz.inst_order[inst_rc]=d3.select(params.root+' .toggle_'+other_rc+'_order').select('.active').attr('name');}else{// default to cluster ordering
params.viz.inst_order[inst_rc]='clust';}});return params;};/***/},/* 266 *//***/function(module,exports,__webpack_require__){// var update_network = require('../network/update_network');
var make_requested_view=__webpack_require__(64);module.exports=function make_button_filter(config,params,filter_type,div_filters){/*
	  Enrichr specific code
	  */var buttons=div_filters.append('div').classed('categorical_filter',true).classed('toggle_'+filter_type,true).classed('btn-group-vertical',true).style('width','100%').style('margin-top','10px').attr('current_state','combined_score');var filter_options=params.viz.filter_data[filter_type];var button_dict={'combined_score':'Combined Score','pval':'P-Value','zscore':'Z-score'};buttons.selectAll('button').data(filter_options).enter().append('button').attr('type','button').classed('btn',true).classed('btn-primary',true).classed('.filter_button',true).classed('active',function(d){var is_active=false;if(d=='combined_score'){is_active=true;}return is_active;}).attr('name',function(d){return d;}).html(function(d){return button_dict[d];});$(params.root+' .categorical_filter .btn').off().click(function(){d3.selectAll(params.root+' .categorical_filter .btn').classed('active',false);d3.select(this).classed('active',true);var inst_state=d3.select(this).attr('name');var requested_view={'enr_score_type':inst_state};make_requested_view(params,requested_view);d3.select(params.root+' .toggle_enr_score_type').attr('current_state',inst_state);});};/***/},/* 267 *//***/function(module,exports){module.exports=function set_up_search(sidebar,params){var search_container=sidebar.append('div')// .classed('row',true)
.classed('gene_search_container',true).style('padding-left','10px').style('padding-right','10px').style('margin-top','10px');search_container.append('input').classed('form-control',true).classed('gene_search_box',true).classed('sidebar_text',true).attr('type','text').attr('placeholder',params.sidebar.row_search.placeholder).style('height',params.sidebar.row_search.box.height+'px').style('margin-top','10px');search_container.append('div').classed('gene_search_button',true).style('margin-top','5px').attr('data-toggle','buttons').append('button').classed('sidebar_text',true).html('Search').attr('type','button').classed('btn',true).classed('btn-primary',true).classed('submit_gene_button',true).style('width','100%').style('font-size','14px');};/***/},/* 268 *//***/function(module,exports,__webpack_require__){// var get_cat_title = require('../categories/get_cat_title');
var underscore=__webpack_require__(3);module.exports=function set_up_reorder(params,sidebar){var button_dict;var tmp_orders;var rc_dict={'row':'Row','col':'Column','both':''};var is_active;var inst_reorder;// var all_cats;
// var inst_order_label;
var reorder_section=sidebar.append('div').style('padding-left','10px').style('padding-right','10px').classed('reorder_section',true);var reorder_types;if(params.sim_mat){reorder_types=['both'];}else{reorder_types=['row','col'];}underscore.each(reorder_types,function(inst_rc){button_dict={'clust':'Cluster','rank':'Rank by Sum','rankvar':'Rank by Variance','ini':'Initial Order','alpha':'Alphabetically'};var other_rc;if(inst_rc==='row'){other_rc='col';}else{other_rc='row';}tmp_orders=Object.keys(params.matrix.orders);var possible_orders=[];underscore.each(tmp_orders,function(inst_name){if(inst_name.indexOf(other_rc)>-1){inst_name=inst_name.replace('_row','').replace('_col','');if(inst_name.indexOf('cat_')<0){possible_orders.push(inst_name);}}});// specific to Enrichr
if(underscore.keys(params.viz.filter_data).indexOf('enr_score_type')>-1){possible_orders=['clust','rank'];}possible_orders=underscore.uniq(possible_orders);possible_orders=possible_orders.sort();var reorder_text;if(inst_rc!='both'){reorder_text=' Order';}else{reorder_text='Reorder Matrix';}reorder_section.append('div').classed('sidebar_button_text',true).style('clear','both').style('margin-top','10px').html(rc_dict[inst_rc]+reorder_text);inst_reorder=reorder_section.append('div').classed('btn-group-vertical',true).style('width','100%').classed('toggle_'+inst_rc+'_order',true).attr('role','group');inst_reorder.selectAll('.button').data(possible_orders).enter().append('button').attr('type','button').classed('btn',true).classed('btn-primary',true).classed('sidebar_button_text',true).classed('active',function(d){is_active=false;if(d==params.viz.inst_order[other_rc]){is_active=true;}return is_active;}).attr('name',function(d){return d;}).html(function(d){return button_dict[d];});});};/***/},/* 269 *//***/function(module,exports,__webpack_require__){var make_filter_title=__webpack_require__(245);var underscore=__webpack_require__(3);module.exports=function set_sidebar_ini_view(params){underscore.each(underscore.keys(params.ini_view),function(inst_filter){// initialize filter slider using ini_view
var inst_value=params.ini_view[inst_filter];var filter_type=params.viz.possible_filters[inst_filter];if(filter_type==='numerical'){if(inst_value!='all'){inst_value=parseInt(inst_value,10);}if(params.viz.filter_data[inst_filter].indexOf(inst_value)<=-1){inst_value='all';}var filter_title=make_filter_title(params,inst_filter);d3.select(params.root+' .title_'+inst_filter).text(filter_title.text+inst_value+filter_title.suffix);d3.select(params.root+' .slider_'+inst_filter).attr('current_state',inst_value);}else{// set up button initialization
}});};/***/},/* 270 *//***/function(module,exports,__webpack_require__){var file_saver=__webpack_require__(247);var two_translate_zoom=__webpack_require__(144);var deactivate_cropping=__webpack_require__(251);var save_svg_png=__webpack_require__(271);module.exports=function make_icons(cgm,sidebar){var params=cgm.params;// var saveSvgAsPng = save_svg_png();
var saveAs=file_saver();var row=sidebar.select('.icons_section').style('margin-top','7px').style('margin-left','5%');var width_pct='22%';var padding_left='0px';var padding_right='0px';row.append('div').classed('clust_icon',true).style('float','left').style('width',width_pct).style('padding-left',padding_left).style('padding-right',padding_right).append('i').classed('fa',true).classed('fa-share-alt',true).classed('icon_buttons',true).style('font-size','25px').on('click',function(){$(params.root+' .share_info').modal('toggle');$('.share_url').val(window.location.href);}).classed('sidebar_tooltip',true).append('span').classed('sidebar_tooltip_text',true).html('Share').style('left','0%');row.append('div').classed('clust_icon',true).style('float','left').style('width',width_pct).style('padding-left',padding_left).style('padding-right',padding_right).append('i').classed('fa',true).classed('fa-camera',true).classed('icon_buttons',true).style('font-size','25px').on('click',function(){$(params.root+' .picture_info').modal('toggle');}).classed('sidebar_tooltip',true).append('span').classed('sidebar_tooltip_text',true).html('Take snapshot').style('left','-100%');row.append('div').classed('clust_icon',true).style('float','left').style('width',width_pct).style('padding-left',padding_left).style('padding-right',padding_right).append('i').classed('fa',true).classed('fa fa-cloud-download',true).classed('icon_buttons',true).style('font-size','25px').on('click',function(){cgm.save_matrix();}).classed('sidebar_tooltip',true).append('span').classed('sidebar_tooltip_text',true).html('Download matrix').style('left','-200%');row.append('div').classed('clust_icon',true).style('float','left').style('width',width_pct).style('padding-left',padding_left).style('padding-right','-5px').append('i').classed('fa',true).classed('fa-crop',true).classed('crop_button',true).classed('icon_buttons',true).style('font-size','25px').on('click',function(){// do nothing if dendro filtering has been done
if(cgm.params.dendro_filter.row===false&&cgm.params.dendro_filter.col===false){var is_crop=d3.select(this).classed('fa-crop');var is_undo=d3.select(this).classed('fa-undo');// press crop button (can be active/incative)
if(is_crop){// keep list of names to return to state
cgm.params.crop_filter_nodes={};cgm.params.crop_filter_nodes.row_nodes=cgm.params.network_data.row_nodes;cgm.params.crop_filter_nodes.col_nodes=cgm.params.network_data.col_nodes;cgm.brush_crop_matrix();if(d3.select(this).classed('active_cropping')===false){// set active_cropping (button turns red)
d3.select(this).classed('active_cropping',true).style('color','red');}else{// deactivate cropping (button turns blue)
d3.select(this).classed('active_cropping',false).style('color','#337ab7');deactivate_cropping(cgm);}}// press undo button
if(is_undo){d3.select(params.root+' .crop_button').style('color','#337ab7').classed('fa-crop',true).classed('fa-undo',false);// cgm.filter_viz_using_names(cgm.params.crop_filter_nodes);
cgm.filter_viz_using_nodes(cgm.params.crop_filter_nodes);// show dendro crop buttons after brush-cropping has been undone
d3.select(cgm.params.root+' .col_dendro_icons_container').style('display','block');d3.select(cgm.params.root+' .row_dendro_icons_container').style('display','block');}two_translate_zoom(cgm,0,0,1);}}).classed('sidebar_tooltip',true).append('span').classed('sidebar_tooltip_text',true).html('Crop matrix').style('left','-400%');// save svg: example from: http://bl.ocks.org/pgiraud/8955139#profile.json
////////////////////////////////////////////////////////////////////////////
function save_clust_svg(){d3.select(params.root+' .expand_button').style('opacity',0);var html=d3.select(params.root+" .viz_svg").attr("title","test2").attr("version",1.1).attr("xmlns","http://www.w3.org/2000/svg").node().parentNode.innerHTML;var blob=new Blob([html],{type:"image/svg+xml"});saveAs(blob,"clustergrammer.svg");d3.select(params.root+' .expand_button').style('opacity',0.4);}d3.select(params.root+' .download_buttons').append('p').append('a').html('Download SVG').on('click',function(){save_clust_svg();});var svg_id='svg_'+params.root.replace('#','');// save as PNG
/////////////////////////////////////////
d3.select(params.root+' .download_buttons').append('p').append('a').html('Download PNG').on('click',function(){d3.select(params.root+' .expand_button').style('opacity',0);// saveSvgAsPng(document.getElementById(svg_id), "clustergrammer.png");
save_svg_png.saveSvgAsPng(document.getElementById(svg_id),"clustergrammer.png");d3.select(params.root+' .expand_button').style('opacity',0.4);});};/***/},/* 271 *//***/function(module,exports,__webpack_require__){var __WEBPACK_AMD_DEFINE_RESULT__;(function(){var out$=typeof exports!='undefined'&&exports||"function"!='undefined'&&{}||this;var doctype='<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" [<!ENTITY nbsp "&#160;">]>';function isElement(obj){return obj instanceof HTMLElement||obj instanceof SVGElement;}function requireDomNode(el){if(!isElement(el)){throw new Error('an HTMLElement or SVGElement is required; got '+el);}}function isExternal(url){return url&&url.lastIndexOf('http',0)==0&&url.lastIndexOf(window.location.host)==-1;}function inlineImages(el,callback){requireDomNode(el);var images=el.querySelectorAll('image'),left=images.length,checkDone=function checkDone(){if(left===0){callback();}};checkDone();for(var i=0;i<images.length;i++){(function(image){var href=image.getAttributeNS("http://www.w3.org/1999/xlink","href");if(href){if(isExternal(href.value)){console.warn("Cannot render embedded images linking to external hosts: "+href.value);return;}}var canvas=document.createElement('canvas');var ctx=canvas.getContext('2d');var img=new Image();img.crossOrigin="anonymous";href=href||image.getAttribute('href');if(href){img.src=href;img.onload=function(){canvas.width=img.width;canvas.height=img.height;ctx.drawImage(img,0,0);image.setAttributeNS("http://www.w3.org/1999/xlink","href",canvas.toDataURL('image/png'));left--;checkDone();};img.onerror=function(){console.log("Could not load "+href);left--;checkDone();};}else{left--;checkDone();}})(images[i]);}}function styles(el,options,cssLoadedCallback){var selectorRemap=options.selectorRemap;var modifyStyle=options.modifyStyle;var css="";// each font that has extranl link is saved into queue, and processed
// asynchronously
var fontsQueue=[];var sheets=document.styleSheets;for(var i=0;i<sheets.length;i++){try{var rules=sheets[i].cssRules;}catch(e){console.warn("Stylesheet could not be loaded: "+sheets[i].href);continue;}if(rules!=null){for(var j=0,match;j<rules.length;j++, match=null){var rule=rules[j];if(typeof rule.style!="undefined"){var selectorText;try{selectorText=rule.selectorText;}catch(err){console.warn('The following CSS rule has an invalid selector: "'+rule+'"',err);}try{if(selectorText){match=el.querySelector(selectorText)||el.parentNode.querySelector(selectorText);}}catch(err){console.warn('Invalid CSS selector "'+selectorText+'"',err);}if(match){var selector=selectorRemap?selectorRemap(rule.selectorText):rule.selectorText;var cssText=modifyStyle?modifyStyle(rule.style.cssText):rule.style.cssText;css+=selector+" { "+cssText+" }\n";}else if(rule.cssText.match(/^@font-face/)){// below we are trying to find matches to external link. E.g.
// @font-face {
//   // ...
//   src: local('Abel'), url(https://fonts.gstatic.com/s/abel/v6/UzN-iejR1VoXU2Oc-7LsbvesZW2xOQ-xsNqO47m55DA.woff2);
// }
//
// This regex will save extrnal link into first capture group
var fontUrlRegexp=/url\(["']?(.+?)["']?\)/;// TODO: This needs to be changed to support multiple url declarations per font.
var fontUrlMatch=rule.cssText.match(fontUrlRegexp);var externalFontUrl=fontUrlMatch&&fontUrlMatch[1]||'';var fontUrlIsDataURI=externalFontUrl.match(/^data:/);if(fontUrlIsDataURI){// We should ignore data uri - they are already embedded
externalFontUrl='';}if(externalFontUrl){// okay, we are lucky. We can fetch this font later
//handle url if relative
if(externalFontUrl.startsWith('../')){externalFontUrl=sheets[i].href+'/../'+externalFontUrl;}else if(externalFontUrl.startsWith('./')){externalFontUrl=sheets[i].href+'/.'+externalFontUrl;}fontsQueue.push({text:rule.cssText,// Pass url regex, so that once font is downladed, we can run `replace()` on it
fontUrlRegexp:fontUrlRegexp,format:getFontMimeTypeFromUrl(externalFontUrl),url:externalFontUrl});}else{// otherwise, use previous logic
css+=rule.cssText+'\n';}}}}}}// Now all css is processed, it's time to handle scheduled fonts
processFontQueue(fontsQueue);function getFontMimeTypeFromUrl(fontUrl){var supportedFormats={'woff2':'font/woff2','woff':'font/woff','otf':'application/x-font-opentype','ttf':'application/x-font-ttf','eot':'application/vnd.ms-fontobject','sfnt':'application/font-sfnt','svg':'image/svg+xml'};var extensions=Object.keys(supportedFormats);for(var i=0;i<extensions.length;++i){var extension=extensions[i];// TODO: This is not bullet proof, it needs to handle edge cases...
if(fontUrl.indexOf('.'+extension)>0){return supportedFormats[extension];}}// If you see this error message, you probably need to update code above.
console.error('Unknown font format for '+fontUrl+'; Fonts may not be working correctly');return'application/octet-stream';}function processFontQueue(queue){if(queue.length>0){// load fonts one by one until we have anything in the queue:
var font=queue.pop();processNext(font);}else{// no more fonts to load.
cssLoadedCallback(css);}function processNext(font){// TODO: This could benefit from caching.
var oReq=new XMLHttpRequest();oReq.addEventListener('load',fontLoaded);oReq.addEventListener('error',transferFailed);oReq.addEventListener('abort',transferFailed);oReq.open('GET',font.url);oReq.responseType='arraybuffer';oReq.send();function fontLoaded(){// TODO: it may be also worth to wait until fonts are fully loaded before
// attempting to rasterize them. (e.g. use https://developer.mozilla.org/en-US/docs/Web/API/FontFaceSet )
var fontBits=oReq.response;var fontInBase64=arrayBufferToBase64(fontBits);updateFontStyle(font,fontInBase64);}function transferFailed(e){console.warn('Failed to load font from: '+font.url);console.warn(e);css+=font.text+'\n';processFontQueue();}function updateFontStyle(font,fontInBase64){var dataUrl='url("data:'+font.format+';base64,'+fontInBase64+'")';css+=font.text.replace(font.fontUrlRegexp,dataUrl)+'\n';// schedule next font download on next tick.
setTimeout(function(){processFontQueue(queue);},0);}}}function arrayBufferToBase64(buffer){var binary='';var bytes=new Uint8Array(buffer);var len=bytes.byteLength;for(var i=0;i<len;i++){binary+=String.fromCharCode(bytes[i]);}return window.btoa(binary);}}function getDimension(el,clone,dim){var v=el.viewBox&&el.viewBox.baseVal&&el.viewBox.baseVal[dim]||clone.getAttribute(dim)!==null&&!clone.getAttribute(dim).match(/%$/)&&parseInt(clone.getAttribute(dim))||el.getBoundingClientRect()[dim]||parseInt(clone.style[dim])||parseInt(window.getComputedStyle(el).getPropertyValue(dim));return typeof v==='undefined'||v===null||isNaN(parseFloat(v))?0:v;}function reEncode(data){data=encodeURIComponent(data);data=data.replace(/%([0-9A-F]{2})/g,function(match,p1){var c=String.fromCharCode('0x'+p1);return c==='%'?'%25':c;});return decodeURIComponent(data);}out$.prepareSvg=function(el,options,cb){requireDomNode(el);options=options||{};options.scale=options.scale||1;options.responsive=options.responsive||false;var xmlns="http://www.w3.org/2000/xmlns/";inlineImages(el,function(){var outer=document.createElement("div");var clone=el.cloneNode(true);var width,height;if(el.tagName=='svg'){width=options.width||getDimension(el,clone,'width');height=options.height||getDimension(el,clone,'height');}else if(el.getBBox){var box=el.getBBox();width=box.x+box.width;height=box.y+box.height;clone.setAttribute('transform',clone.getAttribute('transform').replace(/translate\(.*?\)/,''));var svg=document.createElementNS('http://www.w3.org/2000/svg','svg');svg.appendChild(clone);clone=svg;}else{console.error('Attempted to render non-SVG element',el);return;}clone.setAttribute("version","1.1");if(!clone.getAttribute('xmlns')){clone.setAttributeNS(xmlns,"xmlns","http://www.w3.org/2000/svg");}if(!clone.getAttribute('xmlns:xlink')){clone.setAttributeNS(xmlns,"xmlns:xlink","http://www.w3.org/1999/xlink");}if(options.responsive){clone.removeAttribute('width');clone.removeAttribute('height');clone.setAttribute('preserveAspectRatio','xMinYMin meet');}else{clone.setAttribute("width",width*options.scale);clone.setAttribute("height",height*options.scale);}clone.setAttribute("viewBox",[options.left||0,options.top||0,width,height].join(" "));var fos=clone.querySelectorAll('foreignObject > *');for(var i=0;i<fos.length;i++){if(!fos[i].getAttribute('xmlns')){fos[i].setAttributeNS(xmlns,"xmlns","http://www.w3.org/1999/xhtml");}}outer.appendChild(clone);// In case of custom fonts we need to fetch font first, and then inline
// its url into data-uri format (encode as base64). That's why style
// processing is done asynchonously. Once all inlining is finshed
// cssLoadedCallback() is called.
styles(el,options,cssLoadedCallback);function cssLoadedCallback(css){// here all fonts are inlined, so that we can render them properly.
var s=document.createElement('style');s.setAttribute('type','text/css');s.innerHTML="<![CDATA[\n"+css+"\n]]>";var defs=document.createElement('defs');defs.appendChild(s);clone.insertBefore(defs,clone.firstChild);if(cb){var outHtml=outer.innerHTML;outHtml=outHtml.replace(/NS\d+:href/gi,'xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href');cb(outHtml,width,height);}}});};out$.svgAsDataUri=function(el,options,cb){out$.prepareSvg(el,options,function(svg){var uri='data:image/svg+xml;base64,'+window.btoa(reEncode(doctype+svg));if(cb){cb(uri);}});};out$.svgAsPngUri=function(el,options,cb){requireDomNode(el);options=options||{};options.encoderType=options.encoderType||'image/png';options.encoderOptions=options.encoderOptions||0.8;var convertToPng=function convertToPng(src,w,h){var canvas=document.createElement('canvas');var context=canvas.getContext('2d');canvas.width=w;canvas.height=h;if(options.canvg){options.canvg(canvas,src);}else{context.drawImage(src,0,0);}if(options.backgroundColor){context.globalCompositeOperation='destination-over';context.fillStyle=options.backgroundColor;context.fillRect(0,0,canvas.width,canvas.height);}var png;try{png=canvas.toDataURL(options.encoderType,options.encoderOptions);}catch(e){if(typeof SecurityError!=='undefined'&&e instanceof SecurityError||e.name=="SecurityError"){console.error("Rendered SVG images cannot be downloaded in this browser.");return;}else{throw e;}}cb(png);};if(options.canvg){out$.prepareSvg(el,options,convertToPng);}else{out$.svgAsDataUri(el,options,function(uri){var image=new Image();image.onload=function(){convertToPng(image,image.width,image.height);};image.onerror=function(){console.error('There was an error loading the data URI as an image on the following SVG\n',window.atob(uri.slice(26)),'\n',"Open the following link to see browser's diagnosis\n",uri);};image.src=uri;});}};out$.download=function(name,uri){if(navigator.msSaveOrOpenBlob){navigator.msSaveOrOpenBlob(uriToBlob(uri),name);}else{var saveLink=document.createElement('a');var downloadSupported='download'in saveLink;if(downloadSupported){saveLink.download=name;saveLink.style.display='none';document.body.appendChild(saveLink);try{var blob=uriToBlob(uri);var url=URL.createObjectURL(blob);saveLink.href=url;saveLink.onclick=function(){requestAnimationFrame(function(){URL.revokeObjectURL(url);});};}catch(e){console.warn('This browser does not support object URLs. Falling back to string URL.');saveLink.href=uri;}saveLink.click();document.body.removeChild(saveLink);}else{window.open(uri,'_temp','menubar=no,toolbar=no,status=no');}}};function uriToBlob(uri){var byteString=window.atob(uri.split(',')[1]);var mimeString=uri.split(',')[0].split(':')[1].split(';')[0];var buffer=new ArrayBuffer(byteString.length);var intArray=new Uint8Array(buffer);for(var i=0;i<byteString.length;i++){intArray[i]=byteString.charCodeAt(i);}return new Blob([buffer],{type:mimeString});}out$.saveSvg=function(el,name,options){requireDomNode(el);options=options||{};out$.svgAsDataUri(el,options,function(uri){out$.download(name,uri);});};out$.saveSvgAsPng=function(el,name,options){requireDomNode(el);options=options||{};out$.svgAsPngUri(el,options,function(uri){out$.download(name,uri);});};// if define is defined create as an AMD module
{!(__WEBPACK_AMD_DEFINE_RESULT__=function(){return out$;}.call(exports,__webpack_require__,exports,module), __WEBPACK_AMD_DEFINE_RESULT__!==undefined&&(module.exports=__WEBPACK_AMD_DEFINE_RESULT__));}})();/***/},/* 272 *//***/function(module,exports,__webpack_require__){var make_modal_skeleton=__webpack_require__(273);module.exports=function ini_modals(params){// share modal
///////////////////////////////////////
var share_modal=make_modal_skeleton(params,'share_info');share_modal.header.append('a').attr('target','_blank').attr('href','/clustergrammer/');share_modal.header.append('h4').classed('modal-title',true).html('Share the visualization using the current URL:');share_modal.body.append('input').classed('bootstrap_highlight',true).classed('share_url',true);// picture modal
///////////////////////////////////////
var screenshot_modal=make_modal_skeleton(params,'picture_info');screenshot_modal.header.append('h4').classed('modal-title',true).html('Save a snapshot of the visualization');screenshot_modal.body.append('div').classed('download_buttons',true);// dendro modal
///////////////////////////////////////
var dendro_modal=make_modal_skeleton(params,'dendro_info');dendro_modal.header.append('h4').classed('modal-title',true).html('Cluster Information');dendro_modal.body.append('g').classed('cluster_info_container',true);dendro_modal.body.append('div').classed('dendro_text',true).append('input').classed('bootstrap_highlight',true).classed('current_names',true).style('width','100%');};/***/},/* 273 *//***/function(module,exports){module.exports=function make_modal_skeleton(params,modal_class){var modal_skeleton={};var modal=d3.select(params.root).append('div').classed('modal',true).classed('fade',true).classed(modal_class,true).attr('role','dialog');var modal_dialog=modal.append('div').classed('modal-dialog',true);var modal_content=modal_dialog.append('div').classed('modal-content',true);modal_skeleton.header=modal_content.append('div').classed('modal-header',true);modal_skeleton.header.append('button').attr('type','button').classed('close',true).attr('data-dismiss','modal').html('&times;');modal_skeleton.body=modal_content.append('div').classed('modal-body',true);return modal_skeleton;};/***/},/* 274 *//***/function(module,exports){module.exports=function set_up_opacity_slider(sidebar){var slider_container=sidebar.append('div').classed('opacity_slider_container',true).style('margin-top','5px').style('padding-left','10px').style('padding-right','10px');slider_container.append('div').classed('sidebar_text',true).classed('opacity_slider_text',true).style('margin-bottom','3px').text('Opacity Slider');slider_container.append('div').classed('slider',true).classed('opacity_slider',true);};/***/},/* 275 *//***/function(module,exports,__webpack_require__){var underscore=__webpack_require__(3);module.exports=function make_colorbar(cgm){var params=cgm.params;d3.select(params.root+' .sidebar_wrapper').append('div').classed('sidebar_text',true).style('padding-left','10px').style('padding-top','5px').text('Matrix Values');var colorbar_width=params.sidebar.width-20;var colorbar_height=13;var svg_height=3*colorbar_height;var svg_width=1.2*colorbar_width;var low_left_margin=10;var top_margin=33;var high_left_margin=colorbar_width+10;var bar_margin_left=10;var bar_margin_top=3;var network_data=params.network_data;var max_link=underscore.max(network_data.links,function(d){return d.value;}).value;var min_link=underscore.min(network_data.links,function(d){return d.value;}).value;var main_svg=d3.select(params.root+' .sidebar_wrapper').append('svg').attr('height',svg_height+'px').attr('width',svg_width+'px');//Append a defs (for definition) element to your SVG
var defs=main_svg.append("defs");//Append a linearGradient element to the defs and give it a unique id
var linearGradient=defs.append("linearGradient").attr("id","linear-gradient");var special_case='none';// no negative numbers
if(min_link>=0){//Set the color for the start (0%)
linearGradient.append("stop").attr("offset","0%").attr("stop-color","white");//Set the color for the end (100%)
linearGradient.append("stop").attr("offset","100%").attr("stop-color","red");special_case='all_postiive';// no positive numbers
}else if(max_link<=0){//Set the color for the start (0%)
linearGradient.append("stop").attr("offset","0%").attr("stop-color","blue");//Set the color for the end (100%)
linearGradient.append("stop").attr("offset","100%").attr("stop-color","white");special_case='all_negative';}// both postive and negative numbers
else{//Set the color for the start (0%)
linearGradient.append("stop").attr("offset","0%").attr("stop-color","blue");//Set the color for the end (100%)
linearGradient.append("stop").attr("offset","50%").attr("stop-color","white");//Set the color for the end (100%)
linearGradient.append("stop").attr("offset","100%").attr("stop-color","red");}// make colorbar
main_svg.append('rect').classed('background',true).attr('height',colorbar_height+'px').attr('width',colorbar_width+'px').attr('fill','url(#linear-gradient)').attr('transform','translate('+bar_margin_left+', '+bar_margin_top+')').attr('stroke','grey').attr('stroke-width','0.25px');// make title
///////////////
var max_abs_val=Math.abs(Math.round(params.matrix.max_link*10)/10);var font_size=13;main_svg.append('text').text(function(){var inst_string;if(special_case==='all_postiive'){inst_string=0;}else{inst_string='-'+max_abs_val.toLocaleString();}return inst_string;}).style('font-family','"Helvetica Neue", Helvetica, Arial, sans-serif').style('font-weight',300).style('font-size',font_size).attr('transform','translate('+low_left_margin+','+top_margin+')').attr('text-anchor','start');main_svg.append('text').text(max_abs_val.toLocaleString()).text(function(){var inst_string;if(special_case==='all_negative'){inst_string=0;}else{inst_string=max_abs_val.toLocaleString();}return inst_string;}).style('font-family','"Helvetica Neue", Helvetica, Arial, sans-serif').style('font-weight',300).style('font-size',font_size).attr('transform','translate('+high_left_margin+','+top_margin+')').attr('text-anchor','end');};/***/}]/******/);

/**
 * @class Clustergrammer
 */

var Clustergrammer$1 = function (_Component) {
  inherits(Clustergrammer$$1, _Component);

  function Clustergrammer$$1() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Clustergrammer$$1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Clustergrammer$$1.__proto__ || Object.getPrototypeOf(Clustergrammer$$1)).call.apply(_ref, [this].concat(args))), _this), _this.draw = function () {
      var _this$props = _this.props,
          width = _this$props.width,
          height = _this$props.height,
          clustergrammerProps = objectWithoutProperties(_this$props, ['width', 'height']);

      Clustergrammer(_extends({}, clustergrammerProps, {
        root: '#react-clustergrammer-box'
      }));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Clustergrammer$$1, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.draw();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          width = _props.width,
          height = _props.height;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        id: 'react-clustergrammer-box',
        style: { width: width + 'px', height: height + 'px' }
      });
    }
  }]);
  return Clustergrammer$$1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Clustergrammer$1.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
Clustergrammer$1.defaultProps = {
  width: 800,
  height: 500
};

/* harmony default export */ __webpack_exports__["a"] = (Clustergrammer$1);


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(29);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(30),n=__webpack_require__(7),p=__webpack_require__(31),q=__webpack_require__(8),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
function M(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a)}
function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++)}
function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b)}
var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b)},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(33)();
}


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(8);
var invariant = __webpack_require__(7);
var ReactPropTypesSecret = __webpack_require__(34);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
  var d3 = {
    version: "3.5.17"
  };
  var d3_arraySlice = [].slice, d3_array = function(list) {
    return d3_arraySlice.call(list);
  };
  var d3_document = this.document;
  function d3_documentElement(node) {
    return node && (node.ownerDocument || node.document || node).documentElement;
  }
  function d3_window(node) {
    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
  }
  if (d3_document) {
    try {
      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
    } catch (e) {
      d3_array = function(list) {
        var i = list.length, array = new Array(i);
        while (i--) array[i] = list[i];
        return array;
      };
    }
  }
  if (!Date.now) Date.now = function() {
    return +new Date();
  };
  if (d3_document) {
    try {
      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
    } catch (error) {
      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
      d3_element_prototype.setAttribute = function(name, value) {
        d3_element_setAttribute.call(this, name, value + "");
      };
      d3_element_prototype.setAttributeNS = function(space, local, value) {
        d3_element_setAttributeNS.call(this, space, local, value + "");
      };
      d3_style_prototype.setProperty = function(name, value, priority) {
        d3_style_setProperty.call(this, name, value + "", priority);
      };
    }
  }
  d3.ascending = d3_ascending;
  function d3_ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
  }
  d3.descending = function(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
  };
  d3.min = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
    }
    return a;
  };
  d3.max = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
    }
    return a;
  };
  d3.extent = function(array, f) {
    var i = -1, n = array.length, a, b, c;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    }
    return [ a, c ];
  };
  function d3_number(x) {
    return x === null ? NaN : +x;
  }
  function d3_numeric(x) {
    return !isNaN(x);
  }
  d3.sum = function(array, f) {
    var s = 0, n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
    } else {
      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
    }
    return s;
  };
  d3.mean = function(array, f) {
    var s = 0, n = array.length, a, i = -1, j = n;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
    }
    if (j) return s / j;
  };
  d3.quantile = function(values, p) {
    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
    return e ? v + e * (values[h] - v) : v;
  };
  d3.median = function(array, f) {
    var numbers = [], n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
    }
    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
  };
  d3.variance = function(array, f) {
    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
    if (arguments.length === 1) {
      while (++i < n) {
        if (d3_numeric(a = d3_number(array[i]))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    } else {
      while (++i < n) {
        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    }
    if (j > 1) return s / (j - 1);
  };
  d3.deviation = function() {
    var v = d3.variance.apply(this, arguments);
    return v ? Math.sqrt(v) : v;
  };
  function d3_bisector(compare) {
    return {
      left: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
        }
        return lo;
      },
      right: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
        }
        return lo;
      }
    };
  }
  var d3_bisect = d3_bisector(d3_ascending);
  d3.bisectLeft = d3_bisect.left;
  d3.bisect = d3.bisectRight = d3_bisect.right;
  d3.bisector = function(f) {
    return d3_bisector(f.length === 1 ? function(d, x) {
      return d3_ascending(f(d), x);
    } : f);
  };
  d3.shuffle = function(array, i0, i1) {
    if ((m = arguments.length) < 3) {
      i1 = array.length;
      if (m < 2) i0 = 0;
    }
    var m = i1 - i0, t, i;
    while (m) {
      i = Math.random() * m-- | 0;
      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
    }
    return array;
  };
  d3.permute = function(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while (i--) permutes[i] = array[indexes[i]];
    return permutes;
  };
  d3.pairs = function(array) {
    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
    return pairs;
  };
  d3.transpose = function(matrix) {
    if (!(n = matrix.length)) return [];
    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
        row[j] = matrix[j][i];
      }
    }
    return transpose;
  };
  function d3_transposeLength(d) {
    return d.length;
  }
  d3.zip = function() {
    return d3.transpose(arguments);
  };
  d3.keys = function(map) {
    var keys = [];
    for (var key in map) keys.push(key);
    return keys;
  };
  d3.values = function(map) {
    var values = [];
    for (var key in map) values.push(map[key]);
    return values;
  };
  d3.entries = function(map) {
    var entries = [];
    for (var key in map) entries.push({
      key: key,
      value: map[key]
    });
    return entries;
  };
  d3.merge = function(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while (++i < n) j += arrays[i].length;
    merged = new Array(j);
    while (--n >= 0) {
      array = arrays[n];
      m = array.length;
      while (--m >= 0) {
        merged[--j] = array[m];
      }
    }
    return merged;
  };
  var abs = Math.abs;
  d3.range = function(start, stop, step) {
    if (arguments.length < 3) {
      step = 1;
      if (arguments.length < 2) {
        stop = start;
        start = 0;
      }
    }
    if ((stop - start) / step === Infinity) throw new Error("infinite range");
    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
    start *= k, stop *= k, step *= k;
    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
    return range;
  };
  function d3_range_integerScale(x) {
    var k = 1;
    while (x * k % 1) k *= 10;
    return k;
  }
  function d3_class(ctor, properties) {
    for (var key in properties) {
      Object.defineProperty(ctor.prototype, key, {
        value: properties[key],
        enumerable: false
      });
    }
  }
  d3.map = function(object, f) {
    var map = new d3_Map();
    if (object instanceof d3_Map) {
      object.forEach(function(key, value) {
        map.set(key, value);
      });
    } else if (Array.isArray(object)) {
      var i = -1, n = object.length, o;
      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
    } else {
      for (var key in object) map.set(key, object[key]);
    }
    return map;
  };
  function d3_Map() {
    this._ = Object.create(null);
  }
  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
  d3_class(d3_Map, {
    has: d3_map_has,
    get: function(key) {
      return this._[d3_map_escape(key)];
    },
    set: function(key, value) {
      return this._[d3_map_escape(key)] = value;
    },
    remove: d3_map_remove,
    keys: d3_map_keys,
    values: function() {
      var values = [];
      for (var key in this._) values.push(this._[key]);
      return values;
    },
    entries: function() {
      var entries = [];
      for (var key in this._) entries.push({
        key: d3_map_unescape(key),
        value: this._[key]
      });
      return entries;
    },
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
    }
  });
  function d3_map_escape(key) {
    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
  }
  function d3_map_unescape(key) {
    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
  }
  function d3_map_has(key) {
    return d3_map_escape(key) in this._;
  }
  function d3_map_remove(key) {
    return (key = d3_map_escape(key)) in this._ && delete this._[key];
  }
  function d3_map_keys() {
    var keys = [];
    for (var key in this._) keys.push(d3_map_unescape(key));
    return keys;
  }
  function d3_map_size() {
    var size = 0;
    for (var key in this._) ++size;
    return size;
  }
  function d3_map_empty() {
    for (var key in this._) return false;
    return true;
  }
  d3.nest = function() {
    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
    function map(mapType, array, depth) {
      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
      while (++i < n) {
        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
          values.push(object);
        } else {
          valuesByKey.set(keyValue, [ object ]);
        }
      }
      if (mapType) {
        object = mapType();
        setter = function(keyValue, values) {
          object.set(keyValue, map(mapType, values, depth));
        };
      } else {
        object = {};
        setter = function(keyValue, values) {
          object[keyValue] = map(mapType, values, depth);
        };
      }
      valuesByKey.forEach(setter);
      return object;
    }
    function entries(map, depth) {
      if (depth >= keys.length) return map;
      var array = [], sortKey = sortKeys[depth++];
      map.forEach(function(key, keyMap) {
        array.push({
          key: key,
          values: entries(keyMap, depth)
        });
      });
      return sortKey ? array.sort(function(a, b) {
        return sortKey(a.key, b.key);
      }) : array;
    }
    nest.map = function(array, mapType) {
      return map(mapType, array, 0);
    };
    nest.entries = function(array) {
      return entries(map(d3.map, array, 0), 0);
    };
    nest.key = function(d) {
      keys.push(d);
      return nest;
    };
    nest.sortKeys = function(order) {
      sortKeys[keys.length - 1] = order;
      return nest;
    };
    nest.sortValues = function(order) {
      sortValues = order;
      return nest;
    };
    nest.rollup = function(f) {
      rollup = f;
      return nest;
    };
    return nest;
  };
  d3.set = function(array) {
    var set = new d3_Set();
    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
    return set;
  };
  function d3_Set() {
    this._ = Object.create(null);
  }
  d3_class(d3_Set, {
    has: d3_map_has,
    add: function(key) {
      this._[d3_map_escape(key += "")] = true;
      return key;
    },
    remove: d3_map_remove,
    values: d3_map_keys,
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key));
    }
  });
  d3.behavior = {};
  function d3_identity(d) {
    return d;
  }
  d3.rebind = function(target, source) {
    var i = 1, n = arguments.length, method;
    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
    return target;
  };
  function d3_rebind(target, source, method) {
    return function() {
      var value = method.apply(source, arguments);
      return value === source ? target : value;
    };
  }
  function d3_vendorSymbol(object, name) {
    if (name in object) return name;
    name = name.charAt(0).toUpperCase() + name.slice(1);
    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
      var prefixName = d3_vendorPrefixes[i] + name;
      if (prefixName in object) return prefixName;
    }
  }
  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
  function d3_noop() {}
  d3.dispatch = function() {
    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    return dispatch;
  };
  function d3_dispatch() {}
  d3_dispatch.prototype.on = function(type, listener) {
    var i = type.indexOf("."), name = "";
    if (i >= 0) {
      name = type.slice(i + 1);
      type = type.slice(0, i);
    }
    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
    if (arguments.length === 2) {
      if (listener == null) for (type in this) {
        if (this.hasOwnProperty(type)) this[type].on(name, null);
      }
      return this;
    }
  };
  function d3_dispatch_event(dispatch) {
    var listeners = [], listenerByName = new d3_Map();
    function event() {
      var z = listeners, i = -1, n = z.length, l;
      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
      return dispatch;
    }
    event.on = function(name, listener) {
      var l = listenerByName.get(name), i;
      if (arguments.length < 2) return l && l.on;
      if (l) {
        l.on = null;
        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
        listenerByName.remove(name);
      }
      if (listener) listeners.push(listenerByName.set(name, {
        on: listener
      }));
      return dispatch;
    };
    return event;
  }
  d3.event = null;
  function d3_eventPreventDefault() {
    d3.event.preventDefault();
  }
  function d3_eventSource() {
    var e = d3.event, s;
    while (s = e.sourceEvent) e = s;
    return e;
  }
  function d3_eventDispatch(target) {
    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    dispatch.of = function(thiz, argumentz) {
      return function(e1) {
        try {
          var e0 = e1.sourceEvent = d3.event;
          e1.target = target;
          d3.event = e1;
          dispatch[e1.type].apply(thiz, argumentz);
        } finally {
          d3.event = e0;
        }
      };
    };
    return dispatch;
  }
  d3.requote = function(s) {
    return s.replace(d3_requote_re, "\\$&");
  };
  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
  var d3_subclass = {}.__proto__ ? function(object, prototype) {
    object.__proto__ = prototype;
  } : function(object, prototype) {
    for (var property in prototype) object[property] = prototype[property];
  };
  function d3_selection(groups) {
    d3_subclass(groups, d3_selectionPrototype);
    return groups;
  }
  var d3_select = function(s, n) {
    return n.querySelector(s);
  }, d3_selectAll = function(s, n) {
    return n.querySelectorAll(s);
  }, d3_selectMatches = function(n, s) {
    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
    d3_selectMatches = function(n, s) {
      return d3_selectMatcher.call(n, s);
    };
    return d3_selectMatches(n, s);
  };
  if (typeof Sizzle === "function") {
    d3_select = function(s, n) {
      return Sizzle(s, n)[0] || null;
    };
    d3_selectAll = Sizzle;
    d3_selectMatches = Sizzle.matchesSelector;
  }
  d3.selection = function() {
    return d3.select(d3_document.documentElement);
  };
  var d3_selectionPrototype = d3.selection.prototype = [];
  d3_selectionPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, group, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selector(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_select(selector, this);
    };
  }
  d3_selectionPrototype.selectAll = function(selector) {
    var subgroups = [], subgroup, node;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
          subgroup.parentNode = node;
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selectorAll(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_selectAll(selector, this);
    };
  }
  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
  var d3_nsPrefix = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: d3_nsXhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
  };
  d3.ns = {
    prefix: d3_nsPrefix,
    qualify: function(name) {
      var i = name.indexOf(":"), prefix = name;
      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
      return d3_nsPrefix.hasOwnProperty(prefix) ? {
        space: d3_nsPrefix[prefix],
        local: name
      } : name;
    }
  };
  d3_selectionPrototype.attr = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node();
        name = d3.ns.qualify(name);
        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
      }
      for (value in name) this.each(d3_selection_attr(value, name[value]));
      return this;
    }
    return this.each(d3_selection_attr(name, value));
  };
  function d3_selection_attr(name, value) {
    name = d3.ns.qualify(name);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrConstant() {
      this.setAttribute(name, value);
    }
    function attrConstantNS() {
      this.setAttributeNS(name.space, name.local, value);
    }
    function attrFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
    }
    function attrFunctionNS() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
    }
    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
  }
  function d3_collapse(s) {
    return s.trim().replace(/\s+/g, " ");
  }
  d3_selectionPrototype.classed = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
        if (value = node.classList) {
          while (++i < n) if (!value.contains(name[i])) return false;
        } else {
          value = node.getAttribute("class");
          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
        }
        return true;
      }
      for (value in name) this.each(d3_selection_classed(value, name[value]));
      return this;
    }
    return this.each(d3_selection_classed(name, value));
  };
  function d3_selection_classedRe(name) {
    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
  }
  function d3_selection_classes(name) {
    return (name + "").trim().split(/^|\s+/);
  }
  function d3_selection_classed(name, value) {
    name = d3_selection_classes(name).map(d3_selection_classedName);
    var n = name.length;
    function classedConstant() {
      var i = -1;
      while (++i < n) name[i](this, value);
    }
    function classedFunction() {
      var i = -1, x = value.apply(this, arguments);
      while (++i < n) name[i](this, x);
    }
    return typeof value === "function" ? classedFunction : classedConstant;
  }
  function d3_selection_classedName(name) {
    var re = d3_selection_classedRe(name);
    return function(node, value) {
      if (c = node.classList) return value ? c.add(name) : c.remove(name);
      var c = node.getAttribute("class") || "";
      if (value) {
        re.lastIndex = 0;
        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
      } else {
        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
      }
    };
  }
  d3_selectionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
        return this;
      }
      if (n < 2) {
        var node = this.node();
        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
      }
      priority = "";
    }
    return this.each(d3_selection_style(name, value, priority));
  };
  function d3_selection_style(name, value, priority) {
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleConstant() {
      this.style.setProperty(name, value, priority);
    }
    function styleFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
    }
    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
  }
  d3_selectionPrototype.property = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") return this.node()[name];
      for (value in name) this.each(d3_selection_property(value, name[value]));
      return this;
    }
    return this.each(d3_selection_property(name, value));
  };
  function d3_selection_property(name, value) {
    function propertyNull() {
      delete this[name];
    }
    function propertyConstant() {
      this[name] = value;
    }
    function propertyFunction() {
      var x = value.apply(this, arguments);
      if (x == null) delete this[name]; else this[name] = x;
    }
    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
  }
  d3_selectionPrototype.text = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.textContent = v == null ? "" : v;
    } : value == null ? function() {
      this.textContent = "";
    } : function() {
      this.textContent = value;
    }) : this.node().textContent;
  };
  d3_selectionPrototype.html = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.innerHTML = v == null ? "" : v;
    } : value == null ? function() {
      this.innerHTML = "";
    } : function() {
      this.innerHTML = value;
    }) : this.node().innerHTML;
  };
  d3_selectionPrototype.append = function(name) {
    name = d3_selection_creator(name);
    return this.select(function() {
      return this.appendChild(name.apply(this, arguments));
    });
  };
  function d3_selection_creator(name) {
    function create() {
      var document = this.ownerDocument, namespace = this.namespaceURI;
      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
    }
    function createNS() {
      return this.ownerDocument.createElementNS(name.space, name.local);
    }
    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
  }
  d3_selectionPrototype.insert = function(name, before) {
    name = d3_selection_creator(name);
    before = d3_selection_selector(before);
    return this.select(function() {
      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
    });
  };
  d3_selectionPrototype.remove = function() {
    return this.each(d3_selectionRemove);
  };
  function d3_selectionRemove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
  }
  d3_selectionPrototype.data = function(value, key) {
    var i = -1, n = this.length, group, node;
    if (!arguments.length) {
      value = new Array(n = (group = this[0]).length);
      while (++i < n) {
        if (node = group[i]) {
          value[i] = node.__data__;
        }
      }
      return value;
    }
    function bind(group, groupData) {
      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
      if (key) {
        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
        for (i = -1; ++i < n; ) {
          if (node = group[i]) {
            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
              exitNodes[i] = node;
            } else {
              nodeByKeyValue.set(keyValue, node);
            }
            keyValues[i] = keyValue;
          }
        }
        for (i = -1; ++i < m; ) {
          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          } else if (node !== true) {
            updateNodes[i] = node;
            node.__data__ = nodeData;
          }
          nodeByKeyValue.set(keyValue, true);
        }
        for (i = -1; ++i < n; ) {
          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
            exitNodes[i] = group[i];
          }
        }
      } else {
        for (i = -1; ++i < n0; ) {
          node = group[i];
          nodeData = groupData[i];
          if (node) {
            node.__data__ = nodeData;
            updateNodes[i] = node;
          } else {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          }
        }
        for (;i < m; ++i) {
          enterNodes[i] = d3_selection_dataNode(groupData[i]);
        }
        for (;i < n; ++i) {
          exitNodes[i] = group[i];
        }
      }
      enterNodes.update = updateNodes;
      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
      enter.push(enterNodes);
      update.push(updateNodes);
      exit.push(exitNodes);
    }
    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
    if (typeof value === "function") {
      while (++i < n) {
        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
      }
    } else {
      while (++i < n) {
        bind(group = this[i], value);
      }
    }
    update.enter = function() {
      return enter;
    };
    update.exit = function() {
      return exit;
    };
    return update;
  };
  function d3_selection_dataNode(data) {
    return {
      __data__: data
    };
  }
  d3_selectionPrototype.datum = function(value) {
    return arguments.length ? this.property("__data__", value) : this.property("__data__");
  };
  d3_selectionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_filter(selector) {
    return function() {
      return d3_selectMatches(this, selector);
    };
  }
  d3_selectionPrototype.order = function() {
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
        if (node = group[i]) {
          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
          next = node;
        }
      }
    }
    return this;
  };
  d3_selectionPrototype.sort = function(comparator) {
    comparator = d3_selection_sortComparator.apply(this, arguments);
    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
    return this.order();
  };
  function d3_selection_sortComparator(comparator) {
    if (!arguments.length) comparator = d3_ascending;
    return function(a, b) {
      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
    };
  }
  d3_selectionPrototype.each = function(callback) {
    return d3_selection_each(this, function(node, i, j) {
      callback.call(node, node.__data__, i, j);
    });
  };
  function d3_selection_each(groups, callback) {
    for (var j = 0, m = groups.length; j < m; j++) {
      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
        if (node = group[i]) callback(node, i, j);
      }
    }
    return groups;
  }
  d3_selectionPrototype.call = function(callback) {
    var args = d3_array(arguments);
    callback.apply(args[0] = this, args);
    return this;
  };
  d3_selectionPrototype.empty = function() {
    return !this.node();
  };
  d3_selectionPrototype.node = function() {
    for (var j = 0, m = this.length; j < m; j++) {
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        var node = group[i];
        if (node) return node;
      }
    }
    return null;
  };
  d3_selectionPrototype.size = function() {
    var n = 0;
    d3_selection_each(this, function() {
      ++n;
    });
    return n;
  };
  function d3_selection_enter(selection) {
    d3_subclass(selection, d3_selection_enterPrototype);
    return selection;
  }
  var d3_selection_enterPrototype = [];
  d3.selection.enter = d3_selection_enter;
  d3.selection.enter.prototype = d3_selection_enterPrototype;
  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
  d3_selection_enterPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, upgroup, group, node;
    for (var j = -1, m = this.length; ++j < m; ) {
      upgroup = (group = this[j]).update;
      subgroups.push(subgroup = []);
      subgroup.parentNode = group.parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
          subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  d3_selection_enterPrototype.insert = function(name, before) {
    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
    return d3_selectionPrototype.insert.call(this, name, before);
  };
  function d3_selection_enterInsertBefore(enter) {
    var i0, j0;
    return function(d, i, j) {
      var group = enter[j].update, n = group.length, node;
      if (j != j0) j0 = j, i0 = 0;
      if (i >= i0) i0 = i + 1;
      while (!(node = group[i0]) && ++i0 < n) ;
      return node;
    };
  }
  d3.select = function(node) {
    var group;
    if (typeof node === "string") {
      group = [ d3_select(node, d3_document) ];
      group.parentNode = d3_document.documentElement;
    } else {
      group = [ node ];
      group.parentNode = d3_documentElement(node);
    }
    return d3_selection([ group ]);
  };
  d3.selectAll = function(nodes) {
    var group;
    if (typeof nodes === "string") {
      group = d3_array(d3_selectAll(nodes, d3_document));
      group.parentNode = d3_document.documentElement;
    } else {
      group = d3_array(nodes);
      group.parentNode = null;
    }
    return d3_selection([ group ]);
  };
  d3_selectionPrototype.on = function(type, listener, capture) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof type !== "string") {
        if (n < 2) listener = false;
        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
        return this;
      }
      if (n < 2) return (n = this.node()["__on" + type]) && n._;
      capture = false;
    }
    return this.each(d3_selection_on(type, listener, capture));
  };
  function d3_selection_on(type, listener, capture) {
    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
    if (i > 0) type = type.slice(0, i);
    var filter = d3_selection_onFilters.get(type);
    if (filter) type = filter, wrap = d3_selection_onFilter;
    function onRemove() {
      var l = this[name];
      if (l) {
        this.removeEventListener(type, l, l.$);
        delete this[name];
      }
    }
    function onAdd() {
      var l = wrap(listener, d3_array(arguments));
      onRemove.call(this);
      this.addEventListener(type, this[name] = l, l.$ = capture);
      l._ = listener;
    }
    function removeAll() {
      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
      for (var name in this) {
        if (match = name.match(re)) {
          var l = this[name];
          this.removeEventListener(match[1], l, l.$);
          delete this[name];
        }
      }
    }
    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
  }
  var d3_selection_onFilters = d3.map({
    mouseenter: "mouseover",
    mouseleave: "mouseout"
  });
  if (d3_document) {
    d3_selection_onFilters.forEach(function(k) {
      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
    });
  }
  function d3_selection_onListener(listener, argumentz) {
    return function(e) {
      var o = d3.event;
      d3.event = e;
      argumentz[0] = this.__data__;
      try {
        listener.apply(this, argumentz);
      } finally {
        d3.event = o;
      }
    };
  }
  function d3_selection_onFilter(listener, argumentz) {
    var l = d3_selection_onListener(listener, argumentz);
    return function(e) {
      var target = this, related = e.relatedTarget;
      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
        l.call(target, e);
      }
    };
  }
  var d3_event_dragSelect, d3_event_dragId = 0;
  function d3_event_dragSuppress(node) {
    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
    if (d3_event_dragSelect == null) {
      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
    }
    if (d3_event_dragSelect) {
      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
      style[d3_event_dragSelect] = "none";
    }
    return function(suppressClick) {
      w.on(name, null);
      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
      if (suppressClick) {
        var off = function() {
          w.on(click, null);
        };
        w.on(click, function() {
          d3_eventPreventDefault();
          off();
        }, true);
        setTimeout(off, 0);
      }
    };
  }
  d3.mouse = function(container) {
    return d3_mousePoint(container, d3_eventSource());
  };
  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
  function d3_mousePoint(container, e) {
    if (e.changedTouches) e = e.changedTouches[0];
    var svg = container.ownerSVGElement || container;
    if (svg.createSVGPoint) {
      var point = svg.createSVGPoint();
      if (d3_mouse_bug44083 < 0) {
        var window = d3_window(container);
        if (window.scrollX || window.scrollY) {
          svg = d3.select("body").append("svg").style({
            position: "absolute",
            top: 0,
            left: 0,
            margin: 0,
            padding: 0,
            border: "none"
          }, "important");
          var ctm = svg[0][0].getScreenCTM();
          d3_mouse_bug44083 = !(ctm.f || ctm.e);
          svg.remove();
        }
      }
      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
      point.y = e.clientY;
      point = point.matrixTransform(container.getScreenCTM().inverse());
      return [ point.x, point.y ];
    }
    var rect = container.getBoundingClientRect();
    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
  }
  d3.touch = function(container, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
      if ((touch = touches[i]).identifier === identifier) {
        return d3_mousePoint(container, touch);
      }
    }
  };
  d3.behavior.drag = function() {
    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
    function drag() {
      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
    }
    function dragstart(id, position, subject, move, end) {
      return function() {
        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
        if (origin) {
          dragOffset = origin.apply(that, arguments);
          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
        } else {
          dragOffset = [ 0, 0 ];
        }
        dispatch({
          type: "dragstart"
        });
        function moved() {
          var position1 = position(parent, dragId), dx, dy;
          if (!position1) return;
          dx = position1[0] - position0[0];
          dy = position1[1] - position0[1];
          dragged |= dx | dy;
          position0 = position1;
          dispatch({
            type: "drag",
            x: position1[0] + dragOffset[0],
            y: position1[1] + dragOffset[1],
            dx: dx,
            dy: dy
          });
        }
        function ended() {
          if (!position(parent, dragId)) return;
          dragSubject.on(move + dragName, null).on(end + dragName, null);
          dragRestore(dragged);
          dispatch({
            type: "dragend"
          });
        }
      };
    }
    drag.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return drag;
    };
    return d3.rebind(drag, event, "on");
  };
  function d3_behavior_dragTouchId() {
    return d3.event.changedTouches[0].identifier;
  }
  d3.touches = function(container, touches) {
    if (arguments.length < 2) touches = d3_eventSource().touches;
    return touches ? d3_array(touches).map(function(touch) {
      var point = d3_mousePoint(container, touch);
      point.identifier = touch.identifier;
      return point;
    }) : [];
  };
  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
  function d3_sgn(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
  }
  function d3_cross2d(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
  }
  function d3_acos(x) {
    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
  }
  function d3_asin(x) {
    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
  }
  function d3_sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
  }
  function d3_cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
  }
  function d3_tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
  }
  function d3_haversin(x) {
    return (x = Math.sin(x / 2)) * x;
  }
  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
  d3.interpolateZoom = function(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    if (d2 < ε2) {
      S = Math.log(w1 / w0) / ρ;
      i = function(t) {
        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
      };
    } else {
      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / ρ;
      i = function(t) {
        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
      };
    }
    i.duration = S * 1e3;
    return i;
  };
  d3.behavior.zoom = function() {
    var view = {
      x: 0,
      y: 0,
      k: 1
    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
    if (!d3_behavior_zoomWheel) {
      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return d3.event.wheelDelta;
      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
        return -d3.event.detail;
      }, "MozMousePixelScroll");
    }
    function zoom(g) {
      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
    }
    zoom.event = function(g) {
      g.each(function() {
        var dispatch = event.of(this, arguments), view1 = view;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.zoom", function() {
            view = this.__chart__ || {
              x: 0,
              y: 0,
              k: 1
            };
            zoomstarted(dispatch);
          }).tween("zoom:zoom", function() {
            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
            return function(t) {
              var l = i(t), k = dx / l[2];
              this.__chart__ = view = {
                x: cx - l[0] * k,
                y: cy - l[1] * k,
                k: k
              };
              zoomed(dispatch);
            };
          }).each("interrupt.zoom", function() {
            zoomended(dispatch);
          }).each("end.zoom", function() {
            zoomended(dispatch);
          });
        } else {
          this.__chart__ = view;
          zoomstarted(dispatch);
          zoomed(dispatch);
          zoomended(dispatch);
        }
      });
    };
    zoom.translate = function(_) {
      if (!arguments.length) return [ view.x, view.y ];
      view = {
        x: +_[0],
        y: +_[1],
        k: view.k
      };
      rescale();
      return zoom;
    };
    zoom.scale = function(_) {
      if (!arguments.length) return view.k;
      view = {
        x: view.x,
        y: view.y,
        k: null
      };
      scaleTo(+_);
      rescale();
      return zoom;
    };
    zoom.scaleExtent = function(_) {
      if (!arguments.length) return scaleExtent;
      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.center = function(_) {
      if (!arguments.length) return center;
      center = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.size = function(_) {
      if (!arguments.length) return size;
      size = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.duration = function(_) {
      if (!arguments.length) return duration;
      duration = +_;
      return zoom;
    };
    zoom.x = function(z) {
      if (!arguments.length) return x1;
      x1 = z;
      x0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    zoom.y = function(z) {
      if (!arguments.length) return y1;
      y1 = z;
      y0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    function location(p) {
      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
    }
    function point(l) {
      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
    }
    function scaleTo(s) {
      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
    }
    function translateTo(p, l) {
      l = point(l);
      view.x += p[0] - l[0];
      view.y += p[1] - l[1];
    }
    function zoomTo(that, p, l, k) {
      that.__chart__ = {
        x: view.x,
        y: view.y,
        k: view.k
      };
      scaleTo(Math.pow(2, k));
      translateTo(center0 = p, l);
      that = d3.select(that);
      if (duration > 0) that = that.transition().duration(duration);
      that.call(zoom.event);
    }
    function rescale() {
      if (x1) x1.domain(x0.range().map(function(x) {
        return (x - view.x) / view.k;
      }).map(x0.invert));
      if (y1) y1.domain(y0.range().map(function(y) {
        return (y - view.y) / view.k;
      }).map(y0.invert));
    }
    function zoomstarted(dispatch) {
      if (!zooming++) dispatch({
        type: "zoomstart"
      });
    }
    function zoomed(dispatch) {
      rescale();
      dispatch({
        type: "zoom",
        scale: view.k,
        translate: [ view.x, view.y ]
      });
    }
    function zoomended(dispatch) {
      if (!--zooming) dispatch({
        type: "zoomend"
      }), center0 = null;
    }
    function mousedowned() {
      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
      d3_selection_interrupt.call(that);
      zoomstarted(dispatch);
      function moved() {
        dragged = 1;
        translateTo(d3.mouse(that), location0);
        zoomed(dispatch);
      }
      function ended() {
        subject.on(mousemove, null).on(mouseup, null);
        dragRestore(dragged);
        zoomended(dispatch);
      }
    }
    function touchstarted() {
      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
      started();
      zoomstarted(dispatch);
      subject.on(mousedown, null).on(touchstart, started);
      function relocate() {
        var touches = d3.touches(that);
        scale0 = view.k;
        touches.forEach(function(t) {
          if (t.identifier in locations0) locations0[t.identifier] = location(t);
        });
        return touches;
      }
      function started() {
        var target = d3.event.target;
        d3.select(target).on(touchmove, moved).on(touchend, ended);
        targets.push(target);
        var changed = d3.event.changedTouches;
        for (var i = 0, n = changed.length; i < n; ++i) {
          locations0[changed[i].identifier] = null;
        }
        var touches = relocate(), now = Date.now();
        if (touches.length === 1) {
          if (now - touchtime < 500) {
            var p = touches[0];
            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
            d3_eventPreventDefault();
          }
          touchtime = now;
        } else if (touches.length > 1) {
          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
          distance0 = dx * dx + dy * dy;
        }
      }
      function moved() {
        var touches = d3.touches(that), p0, l0, p1, l1;
        d3_selection_interrupt.call(that);
        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
          p1 = touches[i];
          if (l1 = locations0[p1.identifier]) {
            if (l0) break;
            p0 = p1, l0 = l1;
          }
        }
        if (l1) {
          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
          scaleTo(scale1 * scale0);
        }
        touchtime = null;
        translateTo(p0, l0);
        zoomed(dispatch);
      }
      function ended() {
        if (d3.event.touches.length) {
          var changed = d3.event.changedTouches;
          for (var i = 0, n = changed.length; i < n; ++i) {
            delete locations0[changed[i].identifier];
          }
          for (var identifier in locations0) {
            return void relocate();
          }
        }
        d3.selectAll(targets).on(zoomName, null);
        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
        dragRestore();
        zoomended(dispatch);
      }
    }
    function mousewheeled() {
      var dispatch = event.of(this, arguments);
      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
      mousewheelTimer = setTimeout(function() {
        mousewheelTimer = null;
        zoomended(dispatch);
      }, 50);
      d3_eventPreventDefault();
      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
      translateTo(center0, translate0);
      zoomed(dispatch);
    }
    function dblclicked() {
      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
    }
    return d3.rebind(zoom, event, "on");
  };
  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
  d3.color = d3_color;
  function d3_color() {}
  d3_color.prototype.toString = function() {
    return this.rgb() + "";
  };
  d3.hsl = d3_hsl;
  function d3_hsl(h, s, l) {
    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
  }
  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
  d3_hslPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, this.l / k);
  };
  d3_hslPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, k * this.l);
  };
  d3_hslPrototype.rgb = function() {
    return d3_hsl_rgb(this.h, this.s, this.l);
  };
  function d3_hsl_rgb(h, s, l) {
    var m1, m2;
    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
    l = l < 0 ? 0 : l > 1 ? 1 : l;
    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
    m1 = 2 * l - m2;
    function v(h) {
      if (h > 360) h -= 360; else if (h < 0) h += 360;
      if (h < 60) return m1 + (m2 - m1) * h / 60;
      if (h < 180) return m2;
      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
      return m1;
    }
    function vv(h) {
      return Math.round(v(h) * 255);
    }
    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
  }
  d3.hcl = d3_hcl;
  function d3_hcl(h, c, l) {
    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
  }
  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
  d3_hclPrototype.brighter = function(k) {
    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.darker = function(k) {
    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.rgb = function() {
    return d3_hcl_lab(this.h, this.c, this.l).rgb();
  };
  function d3_hcl_lab(h, c, l) {
    if (isNaN(h)) h = 0;
    if (isNaN(c)) c = 0;
    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
  }
  d3.lab = d3_lab;
  function d3_lab(l, a, b) {
    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
  }
  var d3_lab_K = 18;
  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
  var d3_labPrototype = d3_lab.prototype = new d3_color();
  d3_labPrototype.brighter = function(k) {
    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.darker = function(k) {
    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.rgb = function() {
    return d3_lab_rgb(this.l, this.a, this.b);
  };
  function d3_lab_rgb(l, a, b) {
    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
    x = d3_lab_xyz(x) * d3_lab_X;
    y = d3_lab_xyz(y) * d3_lab_Y;
    z = d3_lab_xyz(z) * d3_lab_Z;
    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
  }
  function d3_lab_hcl(l, a, b) {
    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
  }
  function d3_lab_xyz(x) {
    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
  }
  function d3_xyz_lab(x) {
    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
  }
  function d3_xyz_rgb(r) {
    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
  }
  d3.rgb = d3_rgb;
  function d3_rgb(r, g, b) {
    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
  }
  function d3_rgbNumber(value) {
    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
  }
  function d3_rgbString(value) {
    return d3_rgbNumber(value) + "";
  }
  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
  d3_rgbPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    var r = this.r, g = this.g, b = this.b, i = 30;
    if (!r && !g && !b) return new d3_rgb(i, i, i);
    if (r && r < i) r = i;
    if (g && g < i) g = i;
    if (b && b < i) b = i;
    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
  };
  d3_rgbPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_rgb(k * this.r, k * this.g, k * this.b);
  };
  d3_rgbPrototype.hsl = function() {
    return d3_rgb_hsl(this.r, this.g, this.b);
  };
  d3_rgbPrototype.toString = function() {
    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
  };
  function d3_rgb_hex(v) {
    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
  }
  function d3_rgb_parse(format, rgb, hsl) {
    var r = 0, g = 0, b = 0, m1, m2, color;
    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
    if (m1) {
      m2 = m1[2].split(",");
      switch (m1[1]) {
       case "hsl":
        {
          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
        }

       case "rgb":
        {
          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
        }
      }
    }
    if (color = d3_rgb_names.get(format)) {
      return rgb(color.r, color.g, color.b);
    }
    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
      if (format.length === 4) {
        r = (color & 3840) >> 4;
        r = r >> 4 | r;
        g = color & 240;
        g = g >> 4 | g;
        b = color & 15;
        b = b << 4 | b;
      } else if (format.length === 7) {
        r = (color & 16711680) >> 16;
        g = (color & 65280) >> 8;
        b = color & 255;
      }
    }
    return rgb(r, g, b);
  }
  function d3_rgb_hsl(r, g, b) {
    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
    if (d) {
      s = l < .5 ? d / (max + min) : d / (2 - max - min);
      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
      h *= 60;
    } else {
      h = NaN;
      s = l > 0 && l < 1 ? 0 : h;
    }
    return new d3_hsl(h, s, l);
  }
  function d3_rgb_lab(r, g, b) {
    r = d3_rgb_xyz(r);
    g = d3_rgb_xyz(g);
    b = d3_rgb_xyz(b);
    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
  }
  function d3_rgb_xyz(r) {
    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
  }
  function d3_rgb_parseNumber(c) {
    var f = parseFloat(c);
    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
  }
  var d3_rgb_names = d3.map({
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  });
  d3_rgb_names.forEach(function(key, value) {
    d3_rgb_names.set(key, d3_rgbNumber(value));
  });
  function d3_functor(v) {
    return typeof v === "function" ? v : function() {
      return v;
    };
  }
  d3.functor = d3_functor;
  d3.xhr = d3_xhrType(d3_identity);
  function d3_xhrType(response) {
    return function(url, mimeType, callback) {
      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
      mimeType = null;
      return d3_xhr(url, mimeType, response, callback);
    };
  }
  function d3_xhr(url, mimeType, response, callback) {
    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
      request.readyState > 3 && respond();
    };
    function respond() {
      var status = request.status, result;
      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
        try {
          result = response.call(xhr, request);
        } catch (e) {
          dispatch.error.call(xhr, e);
          return;
        }
        dispatch.load.call(xhr, result);
      } else {
        dispatch.error.call(xhr, request);
      }
    }
    request.onprogress = function(event) {
      var o = d3.event;
      d3.event = event;
      try {
        dispatch.progress.call(xhr, request);
      } finally {
        d3.event = o;
      }
    };
    xhr.header = function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers[name];
      if (value == null) delete headers[name]; else headers[name] = value + "";
      return xhr;
    };
    xhr.mimeType = function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return xhr;
    };
    xhr.responseType = function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return xhr;
    };
    xhr.response = function(value) {
      response = value;
      return xhr;
    };
    [ "get", "post" ].forEach(function(method) {
      xhr[method] = function() {
        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
      };
    });
    xhr.send = function(method, data, callback) {
      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
      request.open(method, url, true);
      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
      if (responseType != null) request.responseType = responseType;
      if (callback != null) xhr.on("error", callback).on("load", function(request) {
        callback(null, request);
      });
      dispatch.beforesend.call(xhr, request);
      request.send(data == null ? null : data);
      return xhr;
    };
    xhr.abort = function() {
      request.abort();
      return xhr;
    };
    d3.rebind(xhr, dispatch, "on");
    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
  }
  function d3_xhr_fixCallback(callback) {
    return callback.length === 1 ? function(error, request) {
      callback(error == null ? request : null);
    } : callback;
  }
  function d3_xhrHasResponse(request) {
    var type = request.responseType;
    return type && type !== "text" ? request.response : request.responseText;
  }
  d3.dsv = function(delimiter, mimeType) {
    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
    function dsv(url, row, callback) {
      if (arguments.length < 3) callback = row, row = null;
      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
      xhr.row = function(_) {
        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
      };
      return xhr;
    }
    function response(request) {
      return dsv.parse(request.responseText);
    }
    function typedResponse(f) {
      return function(request) {
        return dsv.parse(request.responseText, f);
      };
    }
    dsv.parse = function(text, f) {
      var o;
      return dsv.parseRows(text, function(row, i) {
        if (o) return o(row, i - 1);
        var a = new Function("d", "return {" + row.map(function(name, i) {
          return JSON.stringify(name) + ": d[" + i + "]";
        }).join(",") + "}");
        o = f ? function(row, i) {
          return f(a(row), i);
        } : a;
      });
    };
    dsv.parseRows = function(text, f) {
      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
      function token() {
        if (I >= N) return EOF;
        if (eol) return eol = false, EOL;
        var j = I;
        if (text.charCodeAt(j) === 34) {
          var i = j;
          while (i++ < N) {
            if (text.charCodeAt(i) === 34) {
              if (text.charCodeAt(i + 1) !== 34) break;
              ++i;
            }
          }
          I = i + 2;
          var c = text.charCodeAt(i + 1);
          if (c === 13) {
            eol = true;
            if (text.charCodeAt(i + 2) === 10) ++I;
          } else if (c === 10) {
            eol = true;
          }
          return text.slice(j + 1, i).replace(/""/g, '"');
        }
        while (I < N) {
          var c = text.charCodeAt(I++), k = 1;
          if (c === 10) eol = true; else if (c === 13) {
            eol = true;
            if (text.charCodeAt(I) === 10) ++I, ++k;
          } else if (c !== delimiterCode) continue;
          return text.slice(j, I - k);
        }
        return text.slice(j);
      }
      while ((t = token()) !== EOF) {
        var a = [];
        while (t !== EOL && t !== EOF) {
          a.push(t);
          t = token();
        }
        if (f && (a = f(a, n++)) == null) continue;
        rows.push(a);
      }
      return rows;
    };
    dsv.format = function(rows) {
      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
      var fieldSet = new d3_Set(), fields = [];
      rows.forEach(function(row) {
        for (var field in row) {
          if (!fieldSet.has(field)) {
            fields.push(fieldSet.add(field));
          }
        }
      });
      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
        return fields.map(function(field) {
          return formatValue(row[field]);
        }).join(delimiter);
      })).join("\n");
    };
    dsv.formatRows = function(rows) {
      return rows.map(formatRow).join("\n");
    };
    function formatRow(row) {
      return row.map(formatValue).join(delimiter);
    }
    function formatValue(text) {
      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
    }
    return dsv;
  };
  d3.csv = d3.dsv(",", "text/csv");
  d3.tsv = d3.dsv("	", "text/tab-separated-values");
  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
    setTimeout(callback, 17);
  };
  d3.timer = function() {
    d3_timer.apply(this, arguments);
  };
  function d3_timer(callback, delay, then) {
    var n = arguments.length;
    if (n < 2) delay = 0;
    if (n < 3) then = Date.now();
    var time = then + delay, timer = {
      c: callback,
      t: time,
      n: null
    };
    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
    d3_timer_queueTail = timer;
    if (!d3_timer_interval) {
      d3_timer_timeout = clearTimeout(d3_timer_timeout);
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
    return timer;
  }
  function d3_timer_step() {
    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
    if (delay > 24) {
      if (isFinite(delay)) {
        clearTimeout(d3_timer_timeout);
        d3_timer_timeout = setTimeout(d3_timer_step, delay);
      }
      d3_timer_interval = 0;
    } else {
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
  }
  d3.timer.flush = function() {
    d3_timer_mark();
    d3_timer_sweep();
  };
  function d3_timer_mark() {
    var now = Date.now(), timer = d3_timer_queueHead;
    while (timer) {
      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
      timer = timer.n;
    }
    return now;
  }
  function d3_timer_sweep() {
    var t0, t1 = d3_timer_queueHead, time = Infinity;
    while (t1) {
      if (t1.c) {
        if (t1.t < time) time = t1.t;
        t1 = (t0 = t1).n;
      } else {
        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
      }
    }
    d3_timer_queueTail = t0;
    return time;
  }
  function d3_format_precision(x, p) {
    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
  }
  d3.round = function(x, n) {
    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
  };
  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
  d3.formatPrefix = function(value, precision) {
    var i = 0;
    if (value = +value) {
      if (value < 0) value *= -1;
      if (precision) value = d3.round(value, d3_format_precision(value, precision));
      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
    }
    return d3_formatPrefixes[8 + i / 3];
  };
  function d3_formatPrefix(d, i) {
    var k = Math.pow(10, abs(8 - i) * 3);
    return {
      scale: i > 8 ? function(d) {
        return d / k;
      } : function(d) {
        return d * k;
      },
      symbol: d
    };
  }
  function d3_locale_numberFormat(locale) {
    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
      while (i > 0 && g > 0) {
        if (length + g + 1 > width) g = Math.max(1, width - length);
        t.push(value.substring(i -= g, i + g));
        if ((length += g + 1) > width) break;
        g = locale_grouping[j = (j + 1) % locale_grouping.length];
      }
      return t.reverse().join(locale_thousands);
    } : d3_identity;
    return function(specifier) {
      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
      if (precision) precision = +precision.substring(1);
      if (zfill || fill === "0" && align === "=") {
        zfill = fill = "0";
        align = "=";
      }
      switch (type) {
       case "n":
        comma = true;
        type = "g";
        break;

       case "%":
        scale = 100;
        suffix = "%";
        type = "f";
        break;

       case "p":
        scale = 100;
        suffix = "%";
        type = "r";
        break;

       case "b":
       case "o":
       case "x":
       case "X":
        if (symbol === "#") prefix = "0" + type.toLowerCase();

       case "c":
        exponent = false;

       case "d":
        integer = true;
        precision = 0;
        break;

       case "s":
        scale = -1;
        type = "r";
        break;
      }
      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
      if (type == "r" && !precision) type = "g";
      if (precision != null) {
        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
      }
      type = d3_format_types.get(type) || d3_format_typeDefault;
      var zcomma = zfill && comma;
      return function(value) {
        var fullSuffix = suffix;
        if (integer && value % 1) return "";
        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
        if (scale < 0) {
          var unit = d3.formatPrefix(value, precision);
          value = unit.scale(value);
          fullSuffix = unit.symbol + suffix;
        } else {
          value *= scale;
        }
        value = type(value, precision);
        var i = value.lastIndexOf("."), before, after;
        if (i < 0) {
          var j = exponent ? value.lastIndexOf("e") : -1;
          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
        } else {
          before = value.substring(0, i);
          after = locale_decimal + value.substring(i + 1);
        }
        if (!zfill && comma) before = formatGroup(before, Infinity);
        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
        negative += prefix;
        value = before + after;
        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
      };
    };
  }
  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
  var d3_format_types = d3.map({
    b: function(x) {
      return x.toString(2);
    },
    c: function(x) {
      return String.fromCharCode(x);
    },
    o: function(x) {
      return x.toString(8);
    },
    x: function(x) {
      return x.toString(16);
    },
    X: function(x) {
      return x.toString(16).toUpperCase();
    },
    g: function(x, p) {
      return x.toPrecision(p);
    },
    e: function(x, p) {
      return x.toExponential(p);
    },
    f: function(x, p) {
      return x.toFixed(p);
    },
    r: function(x, p) {
      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
    }
  });
  function d3_format_typeDefault(x) {
    return x + "";
  }
  var d3_time = d3.time = {}, d3_date = Date;
  function d3_date_utc() {
    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
  }
  d3_date_utc.prototype = {
    getDate: function() {
      return this._.getUTCDate();
    },
    getDay: function() {
      return this._.getUTCDay();
    },
    getFullYear: function() {
      return this._.getUTCFullYear();
    },
    getHours: function() {
      return this._.getUTCHours();
    },
    getMilliseconds: function() {
      return this._.getUTCMilliseconds();
    },
    getMinutes: function() {
      return this._.getUTCMinutes();
    },
    getMonth: function() {
      return this._.getUTCMonth();
    },
    getSeconds: function() {
      return this._.getUTCSeconds();
    },
    getTime: function() {
      return this._.getTime();
    },
    getTimezoneOffset: function() {
      return 0;
    },
    valueOf: function() {
      return this._.valueOf();
    },
    setDate: function() {
      d3_time_prototype.setUTCDate.apply(this._, arguments);
    },
    setDay: function() {
      d3_time_prototype.setUTCDay.apply(this._, arguments);
    },
    setFullYear: function() {
      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
    },
    setHours: function() {
      d3_time_prototype.setUTCHours.apply(this._, arguments);
    },
    setMilliseconds: function() {
      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
    },
    setMinutes: function() {
      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
    },
    setMonth: function() {
      d3_time_prototype.setUTCMonth.apply(this._, arguments);
    },
    setSeconds: function() {
      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
    },
    setTime: function() {
      d3_time_prototype.setTime.apply(this._, arguments);
    }
  };
  var d3_time_prototype = Date.prototype;
  function d3_time_interval(local, step, number) {
    function round(date) {
      var d0 = local(date), d1 = offset(d0, 1);
      return date - d0 < d1 - date ? d0 : d1;
    }
    function ceil(date) {
      step(date = local(new d3_date(date - 1)), 1);
      return date;
    }
    function offset(date, k) {
      step(date = new d3_date(+date), k);
      return date;
    }
    function range(t0, t1, dt) {
      var time = ceil(t0), times = [];
      if (dt > 1) {
        while (time < t1) {
          if (!(number(time) % dt)) times.push(new Date(+time));
          step(time, 1);
        }
      } else {
        while (time < t1) times.push(new Date(+time)), step(time, 1);
      }
      return times;
    }
    function range_utc(t0, t1, dt) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = t0;
        return range(utc, t1, dt);
      } finally {
        d3_date = Date;
      }
    }
    local.floor = local;
    local.round = round;
    local.ceil = ceil;
    local.offset = offset;
    local.range = range;
    var utc = local.utc = d3_time_interval_utc(local);
    utc.floor = utc;
    utc.round = d3_time_interval_utc(round);
    utc.ceil = d3_time_interval_utc(ceil);
    utc.offset = d3_time_interval_utc(offset);
    utc.range = range_utc;
    return local;
  }
  function d3_time_interval_utc(method) {
    return function(date, k) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = date;
        return method(utc, k)._;
      } finally {
        d3_date = Date;
      }
    };
  }
  d3_time.year = d3_time_interval(function(date) {
    date = d3_time.day(date);
    date.setMonth(0, 1);
    return date;
  }, function(date, offset) {
    date.setFullYear(date.getFullYear() + offset);
  }, function(date) {
    return date.getFullYear();
  });
  d3_time.years = d3_time.year.range;
  d3_time.years.utc = d3_time.year.utc.range;
  d3_time.day = d3_time_interval(function(date) {
    var day = new d3_date(2e3, 0);
    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    return day;
  }, function(date, offset) {
    date.setDate(date.getDate() + offset);
  }, function(date) {
    return date.getDate() - 1;
  });
  d3_time.days = d3_time.day.range;
  d3_time.days.utc = d3_time.day.utc.range;
  d3_time.dayOfYear = function(date) {
    var year = d3_time.year(date);
    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
  };
  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
    i = 7 - i;
    var interval = d3_time[day] = d3_time_interval(function(date) {
      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
      return date;
    }, function(date, offset) {
      date.setDate(date.getDate() + Math.floor(offset) * 7);
    }, function(date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
    });
    d3_time[day + "s"] = interval.range;
    d3_time[day + "s"].utc = interval.utc.range;
    d3_time[day + "OfYear"] = function(date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
    };
  });
  d3_time.week = d3_time.sunday;
  d3_time.weeks = d3_time.sunday.range;
  d3_time.weeks.utc = d3_time.sunday.utc.range;
  d3_time.weekOfYear = d3_time.sundayOfYear;
  function d3_locale_timeFormat(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    function d3_time_format(template) {
      var n = template.length;
      function format(date) {
        var string = [], i = -1, j = 0, c, p, f;
        while (++i < n) {
          if (template.charCodeAt(i) === 37) {
            string.push(template.slice(j, i));
            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
            string.push(c);
            j = i + 1;
          }
        }
        string.push(template.slice(j, i));
        return string.join("");
      }
      format.parse = function(string) {
        var d = {
          y: 1900,
          m: 0,
          d: 1,
          H: 0,
          M: 0,
          S: 0,
          L: 0,
          Z: null
        }, i = d3_time_parse(d, template, string, 0);
        if (i != string.length) return null;
        if ("p" in d) d.H = d.H % 12 + d.p * 12;
        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
          date.setFullYear(d.y, 0, 1);
          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
        } else date.setFullYear(d.y, d.m, d.d);
        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
        return localZ ? date._ : date;
      };
      format.toString = function() {
        return template;
      };
      return format;
    }
    function d3_time_parse(date, template, string, j) {
      var c, p, t, i = 0, n = template.length, m = string.length;
      while (i < n) {
        if (j >= m) return -1;
        c = template.charCodeAt(i++);
        if (c === 37) {
          t = template.charAt(i++);
          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
          if (!p || (j = p(date, string, j)) < 0) return -1;
        } else if (c != string.charCodeAt(j++)) {
          return -1;
        }
      }
      return j;
    }
    d3_time_format.utc = function(template) {
      var local = d3_time_format(template);
      function format(date) {
        try {
          d3_date = d3_date_utc;
          var utc = new d3_date();
          utc._ = date;
          return local(utc);
        } finally {
          d3_date = Date;
        }
      }
      format.parse = function(string) {
        try {
          d3_date = d3_date_utc;
          var date = local.parse(string);
          return date && date._;
        } finally {
          d3_date = Date;
        }
      };
      format.toString = local.toString;
      return format;
    };
    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
    locale_periods.forEach(function(p, i) {
      d3_time_periodLookup.set(p.toLowerCase(), i);
    });
    var d3_time_formats = {
      a: function(d) {
        return locale_shortDays[d.getDay()];
      },
      A: function(d) {
        return locale_days[d.getDay()];
      },
      b: function(d) {
        return locale_shortMonths[d.getMonth()];
      },
      B: function(d) {
        return locale_months[d.getMonth()];
      },
      c: d3_time_format(locale_dateTime),
      d: function(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      e: function(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      H: function(d, p) {
        return d3_time_formatPad(d.getHours(), p, 2);
      },
      I: function(d, p) {
        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
      },
      j: function(d, p) {
        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
      },
      L: function(d, p) {
        return d3_time_formatPad(d.getMilliseconds(), p, 3);
      },
      m: function(d, p) {
        return d3_time_formatPad(d.getMonth() + 1, p, 2);
      },
      M: function(d, p) {
        return d3_time_formatPad(d.getMinutes(), p, 2);
      },
      p: function(d) {
        return locale_periods[+(d.getHours() >= 12)];
      },
      S: function(d, p) {
        return d3_time_formatPad(d.getSeconds(), p, 2);
      },
      U: function(d, p) {
        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
      },
      w: function(d) {
        return d.getDay();
      },
      W: function(d, p) {
        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
      },
      x: d3_time_format(locale_date),
      X: d3_time_format(locale_time),
      y: function(d, p) {
        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
      },
      Y: function(d, p) {
        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
      },
      Z: d3_time_zone,
      "%": function() {
        return "%";
      }
    };
    var d3_time_parsers = {
      a: d3_time_parseWeekdayAbbrev,
      A: d3_time_parseWeekday,
      b: d3_time_parseMonthAbbrev,
      B: d3_time_parseMonth,
      c: d3_time_parseLocaleFull,
      d: d3_time_parseDay,
      e: d3_time_parseDay,
      H: d3_time_parseHour24,
      I: d3_time_parseHour24,
      j: d3_time_parseDayOfYear,
      L: d3_time_parseMilliseconds,
      m: d3_time_parseMonthNumber,
      M: d3_time_parseMinutes,
      p: d3_time_parseAmPm,
      S: d3_time_parseSeconds,
      U: d3_time_parseWeekNumberSunday,
      w: d3_time_parseWeekdayNumber,
      W: d3_time_parseWeekNumberMonday,
      x: d3_time_parseLocaleDate,
      X: d3_time_parseLocaleTime,
      y: d3_time_parseYear,
      Y: d3_time_parseFullYear,
      Z: d3_time_parseZone,
      "%": d3_time_parseLiteralPercent
    };
    function d3_time_parseWeekdayAbbrev(date, string, i) {
      d3_time_dayAbbrevRe.lastIndex = 0;
      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseWeekday(date, string, i) {
      d3_time_dayRe.lastIndex = 0;
      var n = d3_time_dayRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonthAbbrev(date, string, i) {
      d3_time_monthAbbrevRe.lastIndex = 0;
      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonth(date, string, i) {
      d3_time_monthRe.lastIndex = 0;
      var n = d3_time_monthRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseLocaleFull(date, string, i) {
      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
    }
    function d3_time_parseLocaleDate(date, string, i) {
      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
    }
    function d3_time_parseLocaleTime(date, string, i) {
      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
    }
    function d3_time_parseAmPm(date, string, i) {
      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
      return n == null ? -1 : (date.p = n, i);
    }
    return d3_time_format;
  }
  var d3_time_formatPads = {
    "-": "",
    _: " ",
    "0": "0"
  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
  function d3_time_formatPad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
  }
  function d3_time_formatRe(names) {
    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
  }
  function d3_time_formatLookup(names) {
    var map = new d3_Map(), i = -1, n = names.length;
    while (++i < n) map.set(names[i].toLowerCase(), i);
    return map;
  }
  function d3_time_parseWeekdayNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
    return n ? (date.w = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberSunday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.U = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberMonday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.W = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseFullYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
    return n ? (date.y = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
  }
  function d3_time_parseZone(date, string, i) {
    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
    i + 5) : -1;
  }
  function d3_time_expandYear(d) {
    return d + (d > 68 ? 1900 : 2e3);
  }
  function d3_time_parseMonthNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
  }
  function d3_time_parseDay(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.d = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseDayOfYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.j = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseHour24(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.H = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMinutes(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.M = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseSeconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.S = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMilliseconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.L = +n[0], i + n[0].length) : -1;
  }
  function d3_time_zone(d) {
    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
  }
  function d3_time_parseLiteralPercent(date, string, i) {
    d3_time_percentRe.lastIndex = 0;
    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
  }
  function d3_time_formatMulti(formats) {
    var n = formats.length, i = -1;
    while (++i < n) formats[i][0] = this(formats[i][0]);
    return function(date) {
      var i = 0, f = formats[i];
      while (!f[1](date)) f = formats[++i];
      return f[0](date);
    };
  }
  d3.locale = function(locale) {
    return {
      numberFormat: d3_locale_numberFormat(locale),
      timeFormat: d3_locale_timeFormat(locale)
    };
  };
  var d3_locale_enUS = d3.locale({
    decimal: ".",
    thousands: ",",
    grouping: [ 3 ],
    currency: [ "$", "" ],
    dateTime: "%a %b %e %X %Y",
    date: "%m/%d/%Y",
    time: "%H:%M:%S",
    periods: [ "AM", "PM" ],
    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
  });
  d3.format = d3_locale_enUS.numberFormat;
  d3.geo = {};
  function d3_adder() {}
  d3_adder.prototype = {
    s: 0,
    t: 0,
    add: function(y) {
      d3_adderSum(y, this.t, d3_adderTemp);
      d3_adderSum(d3_adderTemp.s, this.s, this);
      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
    },
    reset: function() {
      this.s = this.t = 0;
    },
    valueOf: function() {
      return this.s;
    }
  };
  var d3_adderTemp = new d3_adder();
  function d3_adderSum(a, b, o) {
    var x = o.s = a + b, bv = x - a, av = x - bv;
    o.t = a - av + (b - bv);
  }
  d3.geo.stream = function(object, listener) {
    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
      d3_geo_streamObjectType[object.type](object, listener);
    } else {
      d3_geo_streamGeometry(object, listener);
    }
  };
  function d3_geo_streamGeometry(geometry, listener) {
    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
      d3_geo_streamGeometryType[geometry.type](geometry, listener);
    }
  }
  var d3_geo_streamObjectType = {
    Feature: function(feature, listener) {
      d3_geo_streamGeometry(feature.geometry, listener);
    },
    FeatureCollection: function(object, listener) {
      var features = object.features, i = -1, n = features.length;
      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
    }
  };
  var d3_geo_streamGeometryType = {
    Sphere: function(object, listener) {
      listener.sphere();
    },
    Point: function(object, listener) {
      object = object.coordinates;
      listener.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
    },
    LineString: function(object, listener) {
      d3_geo_streamLine(object.coordinates, listener, 0);
    },
    MultiLineString: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
    },
    Polygon: function(object, listener) {
      d3_geo_streamPolygon(object.coordinates, listener);
    },
    MultiPolygon: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
    },
    GeometryCollection: function(object, listener) {
      var geometries = object.geometries, i = -1, n = geometries.length;
      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
    }
  };
  function d3_geo_streamLine(coordinates, listener, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    listener.lineStart();
    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
    listener.lineEnd();
  }
  function d3_geo_streamPolygon(coordinates, listener) {
    var i = -1, n = coordinates.length;
    listener.polygonStart();
    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
    listener.polygonEnd();
  }
  d3.geo.area = function(object) {
    d3_geo_areaSum = 0;
    d3.geo.stream(object, d3_geo_area);
    return d3_geo_areaSum;
  };
  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
  var d3_geo_area = {
    sphere: function() {
      d3_geo_areaSum += 4 * π;
    },
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function() {
      d3_geo_areaRingSum.reset();
      d3_geo_area.lineStart = d3_geo_areaRingStart;
    },
    polygonEnd: function() {
      var area = 2 * d3_geo_areaRingSum;
      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
    }
  };
  function d3_geo_areaRingStart() {
    var λ00, φ00, λ0, cosφ0, sinφ0;
    d3_geo_area.point = function(λ, φ) {
      d3_geo_area.point = nextPoint;
      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
      sinφ0 = Math.sin(φ);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      φ = φ * d3_radians / 2 + π / 4;
      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
      d3_geo_areaRingSum.add(Math.atan2(v, u));
      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
    }
    d3_geo_area.lineEnd = function() {
      nextPoint(λ00, φ00);
    };
  }
  function d3_geo_cartesian(spherical) {
    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
  }
  function d3_geo_cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
  }
  function d3_geo_cartesianCross(a, b) {
    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
  }
  function d3_geo_cartesianAdd(a, b) {
    a[0] += b[0];
    a[1] += b[1];
    a[2] += b[2];
  }
  function d3_geo_cartesianScale(vector, k) {
    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
  }
  function d3_geo_cartesianNormalize(d) {
    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l;
    d[1] /= l;
    d[2] /= l;
  }
  function d3_geo_spherical(cartesian) {
    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
  }
  function d3_geo_sphericalEqual(a, b) {
    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
  }
  d3.geo.bounds = function() {
    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
    var bound = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        bound.point = ringPoint;
        bound.lineStart = ringStart;
        bound.lineEnd = ringEnd;
        dλSum = 0;
        d3_geo_area.polygonStart();
      },
      polygonEnd: function() {
        d3_geo_area.polygonEnd();
        bound.point = point;
        bound.lineStart = lineStart;
        bound.lineEnd = lineEnd;
        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
        range[0] = λ0, range[1] = λ1;
      }
    };
    function point(λ, φ) {
      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
      if (φ < φ0) φ0 = φ;
      if (φ > φ1) φ1 = φ;
    }
    function linePoint(λ, φ) {
      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
      if (p0) {
        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
        d3_geo_cartesianNormalize(inflection);
        inflection = d3_geo_spherical(inflection);
        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = inflection[1] * d3_degrees;
          if (φi > φ1) φ1 = φi;
        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = -inflection[1] * d3_degrees;
          if (φi < φ0) φ0 = φi;
        } else {
          if (φ < φ0) φ0 = φ;
          if (φ > φ1) φ1 = φ;
        }
        if (antimeridian) {
          if (λ < λ_) {
            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
          } else {
            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
          }
        } else {
          if (λ1 >= λ0) {
            if (λ < λ0) λ0 = λ;
            if (λ > λ1) λ1 = λ;
          } else {
            if (λ > λ_) {
              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
            } else {
              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
            }
          }
        }
      } else {
        point(λ, φ);
      }
      p0 = p, λ_ = λ;
    }
    function lineStart() {
      bound.point = linePoint;
    }
    function lineEnd() {
      range[0] = λ0, range[1] = λ1;
      bound.point = point;
      p0 = null;
    }
    function ringPoint(λ, φ) {
      if (p0) {
        var dλ = λ - λ_;
        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
      } else λ__ = λ, φ__ = φ;
      d3_geo_area.point(λ, φ);
      linePoint(λ, φ);
    }
    function ringStart() {
      d3_geo_area.lineStart();
    }
    function ringEnd() {
      ringPoint(λ__, φ__);
      d3_geo_area.lineEnd();
      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
      range[0] = λ0, range[1] = λ1;
      p0 = null;
    }
    function angle(λ0, λ1) {
      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
    }
    function compareRanges(a, b) {
      return a[0] - b[0];
    }
    function withinRange(x, range) {
      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
    }
    return function(feature) {
      φ1 = λ1 = -(λ0 = φ0 = Infinity);
      ranges = [];
      d3.geo.stream(feature, bound);
      var n = ranges.length;
      if (n) {
        ranges.sort(compareRanges);
        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
          b = ranges[i];
          if (withinRange(b[0], a) || withinRange(b[1], a)) {
            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
          } else {
            merged.push(a = b);
          }
        }
        var best = -Infinity, dλ;
        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
          b = merged[i];
          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
        }
      }
      ranges = range = null;
      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
    };
  }();
  d3.geo.centroid = function(object) {
    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
    d3.geo.stream(object, d3_geo_centroid);
    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
    if (m < ε2) {
      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
      m = x * x + y * y + z * z;
      if (m < ε2) return [ NaN, NaN ];
    }
    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
  };
  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
  var d3_geo_centroid = {
    sphere: d3_noop,
    point: d3_geo_centroidPoint,
    lineStart: d3_geo_centroidLineStart,
    lineEnd: d3_geo_centroidLineEnd,
    polygonStart: function() {
      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
    },
    polygonEnd: function() {
      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
    }
  };
  function d3_geo_centroidPoint(λ, φ) {
    λ *= d3_radians;
    var cosφ = Math.cos(φ *= d3_radians);
    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
  }
  function d3_geo_centroidPointXYZ(x, y, z) {
    ++d3_geo_centroidW0;
    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
  }
  function d3_geo_centroidLineStart() {
    var x0, y0, z0;
    d3_geo_centroid.point = function(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroid.point = nextPoint;
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_centroidLineEnd() {
    d3_geo_centroid.point = d3_geo_centroidPoint;
  }
  function d3_geo_centroidRingStart() {
    var λ00, φ00, x0, y0, z0;
    d3_geo_centroid.point = function(λ, φ) {
      λ00 = λ, φ00 = φ;
      d3_geo_centroid.point = nextPoint;
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    d3_geo_centroid.lineEnd = function() {
      nextPoint(λ00, φ00);
      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
      d3_geo_centroid.point = d3_geo_centroidPoint;
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
      d3_geo_centroidX2 += v * cx;
      d3_geo_centroidY2 += v * cy;
      d3_geo_centroidZ2 += v * cz;
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_compose(a, b) {
    function compose(x, y) {
      return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
  }
  function d3_true() {
    return true;
  }
  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
    var subject = [], clip = [];
    segments.forEach(function(segment) {
      if ((n = segment.length - 1) <= 0) return;
      var n, p0 = segment[0], p1 = segment[n];
      if (d3_geo_sphericalEqual(p0, p1)) {
        listener.lineStart();
        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
        listener.lineEnd();
        return;
      }
      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
      a.o = b;
      subject.push(a);
      clip.push(b);
      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
      a.o = b;
      subject.push(a);
      clip.push(b);
    });
    clip.sort(compare);
    d3_geo_clipPolygonLinkCircular(subject);
    d3_geo_clipPolygonLinkCircular(clip);
    if (!subject.length) return;
    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
      clip[i].e = entry = !entry;
    }
    var start = subject[0], points, point;
    while (1) {
      var current = start, isSubject = true;
      while (current.v) if ((current = current.n) === start) return;
      points = current.z;
      listener.lineStart();
      do {
        current.v = current.o.v = true;
        if (current.e) {
          if (isSubject) {
            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.n.x, 1, listener);
          }
          current = current.n;
        } else {
          if (isSubject) {
            points = current.p.z;
            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.p.x, -1, listener);
          }
          current = current.p;
        }
        current = current.o;
        points = current.z;
        isSubject = !isSubject;
      } while (!current.v);
      listener.lineEnd();
    }
  }
  function d3_geo_clipPolygonLinkCircular(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while (++i < n) {
      a.n = b = array[i];
      b.p = a;
      a = b;
    }
    a.n = b = array[0];
    b.p = a;
  }
  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other;
    this.e = entry;
    this.v = false;
    this.n = this.p = null;
  }
  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
    return function(rotate, listener) {
      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          clip.point = pointRing;
          clip.lineStart = ringStart;
          clip.lineEnd = ringEnd;
          segments = [];
          polygon = [];
        },
        polygonEnd: function() {
          clip.point = point;
          clip.lineStart = lineStart;
          clip.lineEnd = lineEnd;
          segments = d3.merge(segments);
          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
          if (segments.length) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
          } else if (clipStartInside) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            interpolate(null, null, 1, listener);
            listener.lineEnd();
          }
          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
          segments = polygon = null;
        },
        sphere: function() {
          listener.polygonStart();
          listener.lineStart();
          interpolate(null, null, 1, listener);
          listener.lineEnd();
          listener.polygonEnd();
        }
      };
      function point(λ, φ) {
        var point = rotate(λ, φ);
        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
      }
      function pointLine(λ, φ) {
        var point = rotate(λ, φ);
        line.point(point[0], point[1]);
      }
      function lineStart() {
        clip.point = pointLine;
        line.lineStart();
      }
      function lineEnd() {
        clip.point = point;
        line.lineEnd();
      }
      var segments;
      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
      function pointRing(λ, φ) {
        ring.push([ λ, φ ]);
        var point = rotate(λ, φ);
        ringListener.point(point[0], point[1]);
      }
      function ringStart() {
        ringListener.lineStart();
        ring = [];
      }
      function ringEnd() {
        pointRing(ring[0][0], ring[0][1]);
        ringListener.lineEnd();
        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
        ring.pop();
        polygon.push(ring);
        ring = null;
        if (!n) return;
        if (clean & 1) {
          segment = ringSegments[0];
          var n = segment.length - 1, i = -1, point;
          if (n > 0) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            while (++i < n) listener.point((point = segment[i])[0], point[1]);
            listener.lineEnd();
          }
          return;
        }
        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
      }
      return clip;
    };
  }
  function d3_geo_clipSegmentLength1(segment) {
    return segment.length > 1;
  }
  function d3_geo_clipBufferListener() {
    var lines = [], line;
    return {
      lineStart: function() {
        lines.push(line = []);
      },
      point: function(λ, φ) {
        line.push([ λ, φ ]);
      },
      lineEnd: d3_noop,
      buffer: function() {
        var buffer = lines;
        lines = [];
        line = null;
        return buffer;
      },
      rejoin: function() {
        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
      }
    };
  }
  function d3_geo_clipSort(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
  }
  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
  function d3_geo_clipAntimeridianLine(listener) {
    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
    return {
      lineStart: function() {
        listener.lineStart();
        clean = 1;
      },
      point: function(λ1, φ1) {
        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
        if (abs(dλ - π) < ε) {
          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          listener.point(λ1, φ0);
          clean = 0;
        } else if (sλ0 !== sλ1 && dλ >= π) {
          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          clean = 0;
        }
        listener.point(λ0 = λ1, φ0 = φ1);
        sλ0 = sλ1;
      },
      lineEnd: function() {
        listener.lineEnd();
        λ0 = φ0 = NaN;
      },
      clean: function() {
        return 2 - clean;
      }
    };
  }
  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
  }
  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
    var φ;
    if (from == null) {
      φ = direction * halfπ;
      listener.point(-π, φ);
      listener.point(0, φ);
      listener.point(π, φ);
      listener.point(π, 0);
      listener.point(π, -φ);
      listener.point(0, -φ);
      listener.point(-π, -φ);
      listener.point(-π, 0);
      listener.point(-π, φ);
    } else if (abs(from[0] - to[0]) > ε) {
      var s = from[0] < to[0] ? π : -π;
      φ = direction * s / 2;
      listener.point(-s, φ);
      listener.point(0, φ);
      listener.point(s, φ);
    } else {
      listener.point(to[0], to[1]);
    }
  }
  function d3_geo_pointInPolygon(point, polygon) {
    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
    d3_geo_areaRingSum.reset();
    for (var i = 0, n = polygon.length; i < n; ++i) {
      var ring = polygon[i], m = ring.length;
      if (!m) continue;
      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
      while (true) {
        if (j === m) j = 0;
        point = ring[j];
        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
          d3_geo_cartesianNormalize(arc);
          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
          d3_geo_cartesianNormalize(intersection);
          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
          }
        }
        if (!j++) break;
        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
      }
    }
    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
  }
  function d3_geo_clipCircle(radius) {
    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
    function visible(λ, φ) {
      return Math.cos(λ) * Math.cos(φ) > cr;
    }
    function clipLine(listener) {
      var point0, c0, v0, v00, clean;
      return {
        lineStart: function() {
          v00 = v0 = false;
          clean = 1;
        },
        point: function(λ, φ) {
          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
          if (!point0 && (v00 = v0 = v)) listener.lineStart();
          if (v !== v0) {
            point2 = intersect(point0, point1);
            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
              point1[0] += ε;
              point1[1] += ε;
              v = visible(point1[0], point1[1]);
            }
          }
          if (v !== v0) {
            clean = 0;
            if (v) {
              listener.lineStart();
              point2 = intersect(point1, point0);
              listener.point(point2[0], point2[1]);
            } else {
              point2 = intersect(point0, point1);
              listener.point(point2[0], point2[1]);
              listener.lineEnd();
            }
            point0 = point2;
          } else if (notHemisphere && point0 && smallRadius ^ v) {
            var t;
            if (!(c & c0) && (t = intersect(point1, point0, true))) {
              clean = 0;
              if (smallRadius) {
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
              } else {
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
              }
            }
          }
          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
            listener.point(point1[0], point1[1]);
          }
          point0 = point1, v0 = v, c0 = c;
        },
        lineEnd: function() {
          if (v0) listener.lineEnd();
          point0 = null;
        },
        clean: function() {
          return clean | (v00 && v0) << 1;
        }
      };
    }
    function intersect(a, b, two) {
      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
      if (!determinant) return !two && a;
      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
      d3_geo_cartesianAdd(A, B);
      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
      if (t2 < 0) return;
      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
      d3_geo_cartesianAdd(q, A);
      q = d3_geo_spherical(q);
      if (!two) return q;
      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
        d3_geo_cartesianAdd(q1, A);
        return [ q, d3_geo_spherical(q1) ];
      }
    }
    function code(λ, φ) {
      var r = smallRadius ? radius : π - radius, code = 0;
      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
      return code;
    }
  }
  function d3_geom_clipLine(x0, y0, x1, y1) {
    return function(line) {
      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
      r = x0 - ax;
      if (!dx && r > 0) return;
      r /= dx;
      if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = x1 - ax;
      if (!dx && r < 0) return;
      r /= dx;
      if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      r = y0 - ay;
      if (!dy && r > 0) return;
      r /= dy;
      if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = y1 - ay;
      if (!dy && r < 0) return;
      r /= dy;
      if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      if (t0 > 0) line.a = {
        x: ax + t0 * dx,
        y: ay + t0 * dy
      };
      if (t1 < 1) line.b = {
        x: ax + t1 * dx,
        y: ay + t1 * dy
      };
      return line;
    };
  }
  var d3_geo_clipExtentMAX = 1e9;
  d3.geo.clipExtent = function() {
    var x0, y0, x1, y1, stream, clip, clipExtent = {
      stream: function(output) {
        if (stream) stream.valid = false;
        stream = clip(output);
        stream.valid = true;
        return stream;
      },
      extent: function(_) {
        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
        if (stream) stream.valid = false, stream = null;
        return clipExtent;
      }
    };
    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
  };
  function d3_geo_clipExtent(x0, y0, x1, y1) {
    return function(listener) {
      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          listener = bufferListener;
          segments = [];
          polygon = [];
          clean = true;
        },
        polygonEnd: function() {
          listener = listener_;
          segments = d3.merge(segments);
          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
          if (inside || visible) {
            listener.polygonStart();
            if (inside) {
              listener.lineStart();
              interpolate(null, null, 1, listener);
              listener.lineEnd();
            }
            if (visible) {
              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
            }
            listener.polygonEnd();
          }
          segments = polygon = ring = null;
        }
      };
      function insidePolygon(p) {
        var wn = 0, n = polygon.length, y = p[1];
        for (var i = 0; i < n; ++i) {
          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
            b = v[j];
            if (a[1] <= y) {
              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
            } else {
              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
            }
            a = b;
          }
        }
        return wn !== 0;
      }
      function interpolate(from, to, direction, listener) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
          do {
            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
          } while ((a = (a + direction + 4) % 4) !== a1);
        } else {
          listener.point(to[0], to[1]);
        }
      }
      function pointVisible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
      }
      function point(x, y) {
        if (pointVisible(x, y)) listener.point(x, y);
      }
      var x__, y__, v__, x_, y_, v_, first, clean;
      function lineStart() {
        clip.point = linePoint;
        if (polygon) polygon.push(ring = []);
        first = true;
        v_ = false;
        x_ = y_ = NaN;
      }
      function lineEnd() {
        if (segments) {
          linePoint(x__, y__);
          if (v__ && v_) bufferListener.rejoin();
          segments.push(bufferListener.buffer());
        }
        clip.point = point;
        if (v_) listener.lineEnd();
      }
      function linePoint(x, y) {
        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
        var v = pointVisible(x, y);
        if (polygon) ring.push([ x, y ]);
        if (first) {
          x__ = x, y__ = y, v__ = v;
          first = false;
          if (v) {
            listener.lineStart();
            listener.point(x, y);
          }
        } else {
          if (v && v_) listener.point(x, y); else {
            var l = {
              a: {
                x: x_,
                y: y_
              },
              b: {
                x: x,
                y: y
              }
            };
            if (clipLine(l)) {
              if (!v_) {
                listener.lineStart();
                listener.point(l.a.x, l.a.y);
              }
              listener.point(l.b.x, l.b.y);
              if (!v) listener.lineEnd();
              clean = false;
            } else if (v) {
              listener.lineStart();
              listener.point(x, y);
              clean = false;
            }
          }
        }
        x_ = x, y_ = y, v_ = v;
      }
      return clip;
    };
    function corner(p, direction) {
      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
    }
    function compare(a, b) {
      return comparePoints(a.x, b.x);
    }
    function comparePoints(a, b) {
      var ca = corner(a, 1), cb = corner(b, 1);
      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
  }
  function d3_geo_conic(projectAt) {
    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
    p.parallels = function(_) {
      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
    };
    return p;
  }
  function d3_geo_conicEqualArea(φ0, φ1) {
    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
    function forward(λ, φ) {
      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = ρ0 - y;
      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
    };
    return forward;
  }
  (d3.geo.conicEqualArea = function() {
    return d3_geo_conic(d3_geo_conicEqualArea);
  }).raw = d3_geo_conicEqualArea;
  d3.geo.albers = function() {
    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
  };
  d3.geo.albersUsa = function() {
    var lower48 = d3.geo.albers();
    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
    var point, pointStream = {
      point: function(x, y) {
        point = [ x, y ];
      }
    }, lower48Point, alaskaPoint, hawaiiPoint;
    function albersUsa(coordinates) {
      var x = coordinates[0], y = coordinates[1];
      point = null;
      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
      return point;
    }
    albersUsa.invert = function(coordinates) {
      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
      return {
        point: function(x, y) {
          lower48Stream.point(x, y);
          alaskaStream.point(x, y);
          hawaiiStream.point(x, y);
        },
        sphere: function() {
          lower48Stream.sphere();
          alaskaStream.sphere();
          hawaiiStream.sphere();
        },
        lineStart: function() {
          lower48Stream.lineStart();
          alaskaStream.lineStart();
          hawaiiStream.lineStart();
        },
        lineEnd: function() {
          lower48Stream.lineEnd();
          alaskaStream.lineEnd();
          hawaiiStream.lineEnd();
        },
        polygonStart: function() {
          lower48Stream.polygonStart();
          alaskaStream.polygonStart();
          hawaiiStream.polygonStart();
        },
        polygonEnd: function() {
          lower48Stream.polygonEnd();
          alaskaStream.polygonEnd();
          hawaiiStream.polygonEnd();
        }
      };
    };
    albersUsa.precision = function(_) {
      if (!arguments.length) return lower48.precision();
      lower48.precision(_);
      alaska.precision(_);
      hawaii.precision(_);
      return albersUsa;
    };
    albersUsa.scale = function(_) {
      if (!arguments.length) return lower48.scale();
      lower48.scale(_);
      alaska.scale(_ * .35);
      hawaii.scale(_);
      return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
      if (!arguments.length) return lower48.translate();
      var k = lower48.scale(), x = +_[0], y = +_[1];
      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
      return albersUsa;
    };
    return albersUsa.scale(1070);
  };
  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function() {
      d3_geo_pathAreaPolygon = 0;
      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
    },
    polygonEnd: function() {
      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
    }
  };
  function d3_geo_pathAreaRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathArea.point = function(x, y) {
      d3_geo_pathArea.point = nextPoint;
      x00 = x0 = x, y00 = y0 = y;
    };
    function nextPoint(x, y) {
      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
      x0 = x, y0 = y;
    }
    d3_geo_pathArea.lineEnd = function() {
      nextPoint(x00, y00);
    };
  }
  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
  var d3_geo_pathBounds = {
    point: d3_geo_pathBoundsPoint,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_pathBoundsPoint(x, y) {
    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
  }
  function d3_geo_pathBuffer() {
    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
    var stream = {
      point: point,
      lineStart: function() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function(_) {
        pointCircle = d3_geo_pathBufferCircle(_);
        return stream;
      },
      result: function() {
        if (buffer.length) {
          var result = buffer.join("");
          buffer = [];
          return result;
        }
      }
    };
    function point(x, y) {
      buffer.push("M", x, ",", y, pointCircle);
    }
    function pointLineStart(x, y) {
      buffer.push("M", x, ",", y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      buffer.push("L", x, ",", y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      buffer.push("Z");
    }
    return stream;
  }
  function d3_geo_pathBufferCircle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
  }
  var d3_geo_pathCentroid = {
    point: d3_geo_pathCentroidPoint,
    lineStart: d3_geo_pathCentroidLineStart,
    lineEnd: d3_geo_pathCentroidLineEnd,
    polygonStart: function() {
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
    },
    polygonEnd: function() {
      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
    }
  };
  function d3_geo_pathCentroidPoint(x, y) {
    d3_geo_centroidX0 += x;
    d3_geo_centroidY0 += y;
    ++d3_geo_centroidZ0;
  }
  function d3_geo_pathCentroidLineStart() {
    var x0, y0;
    d3_geo_pathCentroid.point = function(x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
  }
  function d3_geo_pathCentroidLineEnd() {
    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
  }
  function d3_geo_pathCentroidRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathCentroid.point = function(x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      z = y0 * x - x0 * y;
      d3_geo_centroidX2 += z * (x0 + x);
      d3_geo_centroidY2 += z * (y0 + y);
      d3_geo_centroidZ2 += z * 3;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
    d3_geo_pathCentroid.lineEnd = function() {
      nextPoint(x00, y00);
    };
  }
  function d3_geo_pathContext(context) {
    var pointRadius = 4.5;
    var stream = {
      point: point,
      lineStart: function() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function(_) {
        pointRadius = _;
        return stream;
      },
      result: d3_noop
    };
    function point(x, y) {
      context.moveTo(x + pointRadius, y);
      context.arc(x, y, pointRadius, 0, τ);
    }
    function pointLineStart(x, y) {
      context.moveTo(x, y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      context.lineTo(x, y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      context.closePath();
    }
    return stream;
  }
  function d3_geo_resample(project) {
    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
    function resample(stream) {
      return (maxDepth ? resampleRecursive : resampleNone)(stream);
    }
    function resampleNone(stream) {
      return d3_geo_transformPoint(stream, function(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      });
    }
    function resampleRecursive(stream) {
      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
      var resample = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          stream.polygonStart();
          resample.lineStart = ringStart;
        },
        polygonEnd: function() {
          stream.polygonEnd();
          resample.lineStart = lineStart;
        }
      };
      function point(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      }
      function lineStart() {
        x0 = NaN;
        resample.point = linePoint;
        stream.lineStart();
      }
      function linePoint(λ, φ) {
        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
        stream.point(x0, y0);
      }
      function lineEnd() {
        resample.point = point;
        stream.lineEnd();
      }
      function ringStart() {
        lineStart();
        resample.point = ringPoint;
        resample.lineEnd = ringEnd;
      }
      function ringPoint(λ, φ) {
        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
        resample.point = linePoint;
      }
      function ringEnd() {
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
        resample.lineEnd = lineEnd;
        lineEnd();
      }
      return resample;
    }
    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
      if (d2 > 4 * δ2 && depth--) {
        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
          stream.point(x2, y2);
          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
        }
      }
    }
    resample.precision = function(_) {
      if (!arguments.length) return Math.sqrt(δ2);
      maxDepth = (δ2 = _ * _) > 0 && 16;
      return resample;
    };
    return resample;
  }
  d3.geo.path = function() {
    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
    function path(object) {
      if (object) {
        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
        d3.geo.stream(object, cacheStream);
      }
      return contextStream.result();
    }
    path.area = function(object) {
      d3_geo_pathAreaSum = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathArea));
      return d3_geo_pathAreaSum;
    };
    path.centroid = function(object) {
      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
    };
    path.bounds = function(object) {
      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
    };
    path.projection = function(_) {
      if (!arguments.length) return projection;
      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
      return reset();
    };
    path.context = function(_) {
      if (!arguments.length) return context;
      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
      return reset();
    };
    path.pointRadius = function(_) {
      if (!arguments.length) return pointRadius;
      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
      return path;
    };
    function reset() {
      cacheStream = null;
      return path;
    }
    return path.projection(d3.geo.albersUsa()).context(null);
  };
  function d3_geo_pathProjectStream(project) {
    var resample = d3_geo_resample(function(x, y) {
      return project([ x * d3_degrees, y * d3_degrees ]);
    });
    return function(stream) {
      return d3_geo_projectionRadians(resample(stream));
    };
  }
  d3.geo.transform = function(methods) {
    return {
      stream: function(stream) {
        var transform = new d3_geo_transform(stream);
        for (var k in methods) transform[k] = methods[k];
        return transform;
      }
    };
  };
  function d3_geo_transform(stream) {
    this.stream = stream;
  }
  d3_geo_transform.prototype = {
    point: function(x, y) {
      this.stream.point(x, y);
    },
    sphere: function() {
      this.stream.sphere();
    },
    lineStart: function() {
      this.stream.lineStart();
    },
    lineEnd: function() {
      this.stream.lineEnd();
    },
    polygonStart: function() {
      this.stream.polygonStart();
    },
    polygonEnd: function() {
      this.stream.polygonEnd();
    }
  };
  function d3_geo_transformPoint(stream, point) {
    return {
      point: point,
      sphere: function() {
        stream.sphere();
      },
      lineStart: function() {
        stream.lineStart();
      },
      lineEnd: function() {
        stream.lineEnd();
      },
      polygonStart: function() {
        stream.polygonStart();
      },
      polygonEnd: function() {
        stream.polygonEnd();
      }
    };
  }
  d3.geo.projection = d3_geo_projection;
  d3.geo.projectionMutator = d3_geo_projectionMutator;
  function d3_geo_projection(project) {
    return d3_geo_projectionMutator(function() {
      return project;
    })();
  }
  function d3_geo_projectionMutator(projectAt) {
    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
      x = project(x, y);
      return [ x[0] * k + δx, δy - x[1] * k ];
    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
    function projection(point) {
      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
      return [ point[0] * k + δx, δy - point[1] * k ];
    }
    function invert(point) {
      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
    }
    projection.stream = function(output) {
      if (stream) stream.valid = false;
      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
      stream.valid = true;
      return stream;
    };
    projection.clipAngle = function(_) {
      if (!arguments.length) return clipAngle;
      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
      return invalidate();
    };
    projection.clipExtent = function(_) {
      if (!arguments.length) return clipExtent;
      clipExtent = _;
      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
      return invalidate();
    };
    projection.scale = function(_) {
      if (!arguments.length) return k;
      k = +_;
      return reset();
    };
    projection.translate = function(_) {
      if (!arguments.length) return [ x, y ];
      x = +_[0];
      y = +_[1];
      return reset();
    };
    projection.center = function(_) {
      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
      λ = _[0] % 360 * d3_radians;
      φ = _[1] % 360 * d3_radians;
      return reset();
    };
    projection.rotate = function(_) {
      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
      δλ = _[0] % 360 * d3_radians;
      δφ = _[1] % 360 * d3_radians;
      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
      return reset();
    };
    d3.rebind(projection, projectResample, "precision");
    function reset() {
      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
      var center = project(λ, φ);
      δx = x - center[0] * k;
      δy = y + center[1] * k;
      return invalidate();
    }
    function invalidate() {
      if (stream) stream.valid = false, stream = null;
      return projection;
    }
    return function() {
      project = projectAt.apply(this, arguments);
      projection.invert = project.invert && invert;
      return reset();
    };
  }
  function d3_geo_projectionRadians(stream) {
    return d3_geo_transformPoint(stream, function(x, y) {
      stream.point(x * d3_radians, y * d3_radians);
    });
  }
  function d3_geo_equirectangular(λ, φ) {
    return [ λ, φ ];
  }
  (d3.geo.equirectangular = function() {
    return d3_geo_projection(d3_geo_equirectangular);
  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
  d3.geo.rotation = function(rotate) {
    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
    function forward(coordinates) {
      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    }
    forward.invert = function(coordinates) {
      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    };
    return forward;
  };
  function d3_geo_identityRotation(λ, φ) {
    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
  }
  d3_geo_identityRotation.invert = d3_geo_equirectangular;
  function d3_geo_rotation(δλ, δφ, δγ) {
    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
  }
  function d3_geo_forwardRotationλ(δλ) {
    return function(λ, φ) {
      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
    };
  }
  function d3_geo_rotationλ(δλ) {
    var rotation = d3_geo_forwardRotationλ(δλ);
    rotation.invert = d3_geo_forwardRotationλ(-δλ);
    return rotation;
  }
  function d3_geo_rotationφγ(δφ, δγ) {
    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
    function rotation(λ, φ) {
      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
    }
    rotation.invert = function(λ, φ) {
      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
    };
    return rotation;
  }
  d3.geo.circle = function() {
    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
    function circle() {
      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
      interpolate(null, null, 1, {
        point: function(x, y) {
          ring.push(x = rotate(x, y));
          x[0] *= d3_degrees, x[1] *= d3_degrees;
        }
      });
      return {
        type: "Polygon",
        coordinates: [ ring ]
      };
    }
    circle.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return circle;
    };
    circle.angle = function(x) {
      if (!arguments.length) return angle;
      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
      return circle;
    };
    circle.precision = function(_) {
      if (!arguments.length) return precision;
      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
      return circle;
    };
    return circle.angle(90);
  };
  function d3_geo_circleInterpolate(radius, precision) {
    var cr = Math.cos(radius), sr = Math.sin(radius);
    return function(from, to, direction, listener) {
      var step = direction * precision;
      if (from != null) {
        from = d3_geo_circleAngle(cr, from);
        to = d3_geo_circleAngle(cr, to);
        if (direction > 0 ? from < to : from > to) from += direction * τ;
      } else {
        from = radius + direction * τ;
        to = radius - .5 * step;
      }
      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
      }
    };
  }
  function d3_geo_circleAngle(cr, point) {
    var a = d3_geo_cartesian(point);
    a[0] -= cr;
    d3_geo_cartesianNormalize(a);
    var angle = d3_acos(-a[1]);
    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
  }
  d3.geo.distance = function(a, b) {
    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
  };
  d3.geo.graticule = function() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
      return {
        type: "MultiLineString",
        coordinates: lines()
      };
    }
    function lines() {
      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
        return abs(x % DX) > ε;
      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
        return abs(y % DY) > ε;
      }).map(y));
    }
    graticule.lines = function() {
      return lines().map(function(coordinates) {
        return {
          type: "LineString",
          coordinates: coordinates
        };
      });
    };
    graticule.outline = function() {
      return {
        type: "Polygon",
        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
      };
    };
    graticule.extent = function(_) {
      if (!arguments.length) return graticule.minorExtent();
      return graticule.majorExtent(_).minorExtent(_);
    };
    graticule.majorExtent = function(_) {
      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
      X0 = +_[0][0], X1 = +_[1][0];
      Y0 = +_[0][1], Y1 = +_[1][1];
      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
      return graticule.precision(precision);
    };
    graticule.minorExtent = function(_) {
      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
      x0 = +_[0][0], x1 = +_[1][0];
      y0 = +_[0][1], y1 = +_[1][1];
      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
      return graticule.precision(precision);
    };
    graticule.step = function(_) {
      if (!arguments.length) return graticule.minorStep();
      return graticule.majorStep(_).minorStep(_);
    };
    graticule.majorStep = function(_) {
      if (!arguments.length) return [ DX, DY ];
      DX = +_[0], DY = +_[1];
      return graticule;
    };
    graticule.minorStep = function(_) {
      if (!arguments.length) return [ dx, dy ];
      dx = +_[0], dy = +_[1];
      return graticule;
    };
    graticule.precision = function(_) {
      if (!arguments.length) return precision;
      precision = +_;
      x = d3_geo_graticuleX(y0, y1, 90);
      y = d3_geo_graticuleY(x0, x1, precision);
      X = d3_geo_graticuleX(Y0, Y1, 90);
      Y = d3_geo_graticuleY(X0, X1, precision);
      return graticule;
    };
    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
  };
  function d3_geo_graticuleX(y0, y1, dy) {
    var y = d3.range(y0, y1 - ε, dy).concat(y1);
    return function(x) {
      return y.map(function(y) {
        return [ x, y ];
      });
    };
  }
  function d3_geo_graticuleY(x0, x1, dx) {
    var x = d3.range(x0, x1 - ε, dx).concat(x1);
    return function(y) {
      return x.map(function(x) {
        return [ x, y ];
      });
    };
  }
  function d3_source(d) {
    return d.source;
  }
  function d3_target(d) {
    return d.target;
  }
  d3.geo.greatArc = function() {
    var source = d3_source, source_, target = d3_target, target_;
    function greatArc() {
      return {
        type: "LineString",
        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
      };
    }
    greatArc.distance = function() {
      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
    };
    greatArc.source = function(_) {
      if (!arguments.length) return source;
      source = _, source_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.target = function(_) {
      if (!arguments.length) return target;
      target = _, target_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.precision = function() {
      return arguments.length ? greatArc : 0;
    };
    return greatArc;
  };
  d3.geo.interpolate = function(source, target) {
    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
  };
  function d3_geo_interpolate(x0, y0, x1, y1) {
    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
    var interpolate = d ? function(t) {
      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
    } : function() {
      return [ x0 * d3_degrees, y0 * d3_degrees ];
    };
    interpolate.distance = d;
    return interpolate;
  }
  d3.geo.length = function(object) {
    d3_geo_lengthSum = 0;
    d3.geo.stream(object, d3_geo_length);
    return d3_geo_lengthSum;
  };
  var d3_geo_lengthSum;
  var d3_geo_length = {
    sphere: d3_noop,
    point: d3_noop,
    lineStart: d3_geo_lengthLineStart,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_lengthLineStart() {
    var λ0, sinφ0, cosφ0;
    d3_geo_length.point = function(λ, φ) {
      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
      d3_geo_length.point = nextPoint;
    };
    d3_geo_length.lineEnd = function() {
      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
    };
    function nextPoint(λ, φ) {
      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
    }
  }
  function d3_geo_azimuthal(scale, angle) {
    function azimuthal(λ, φ) {
      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
    }
    azimuthal.invert = function(x, y) {
      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
    };
    return azimuthal;
  }
  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
    return Math.sqrt(2 / (1 + cosλcosφ));
  }, function(ρ) {
    return 2 * Math.asin(ρ / 2);
  });
  (d3.geo.azimuthalEqualArea = function() {
    return d3_geo_projection(d3_geo_azimuthalEqualArea);
  }).raw = d3_geo_azimuthalEqualArea;
  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
    var c = Math.acos(cosλcosφ);
    return c && c / Math.sin(c);
  }, d3_identity);
  (d3.geo.azimuthalEquidistant = function() {
    return d3_geo_projection(d3_geo_azimuthalEquidistant);
  }).raw = d3_geo_azimuthalEquidistant;
  function d3_geo_conicConformal(φ0, φ1) {
    var cosφ0 = Math.cos(φ0), t = function(φ) {
      return Math.tan(π / 4 + φ / 2);
    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
    if (!n) return d3_geo_mercator;
    function forward(λ, φ) {
      if (F > 0) {
        if (φ < -halfπ + ε) φ = -halfπ + ε;
      } else {
        if (φ > halfπ - ε) φ = halfπ - ε;
      }
      var ρ = F / Math.pow(t(φ), n);
      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
    };
    return forward;
  }
  (d3.geo.conicConformal = function() {
    return d3_geo_conic(d3_geo_conicConformal);
  }).raw = d3_geo_conicConformal;
  function d3_geo_conicEquidistant(φ0, φ1) {
    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
    if (abs(n) < ε) return d3_geo_equirectangular;
    function forward(λ, φ) {
      var ρ = G - φ;
      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = G - y;
      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
    };
    return forward;
  }
  (d3.geo.conicEquidistant = function() {
    return d3_geo_conic(d3_geo_conicEquidistant);
  }).raw = d3_geo_conicEquidistant;
  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
    return 1 / cosλcosφ;
  }, Math.atan);
  (d3.geo.gnomonic = function() {
    return d3_geo_projection(d3_geo_gnomonic);
  }).raw = d3_geo_gnomonic;
  function d3_geo_mercator(λ, φ) {
    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
  }
  d3_geo_mercator.invert = function(x, y) {
    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
  };
  function d3_geo_mercatorProjection(project) {
    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
    m.scale = function() {
      var v = scale.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.translate = function() {
      var v = translate.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.clipExtent = function(_) {
      var v = clipExtent.apply(m, arguments);
      if (v === m) {
        if (clipAuto = _ == null) {
          var k = π * scale(), t = translate();
          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
        }
      } else if (clipAuto) {
        v = null;
      }
      return v;
    };
    return m.clipExtent(null);
  }
  (d3.geo.mercator = function() {
    return d3_geo_mercatorProjection(d3_geo_mercator);
  }).raw = d3_geo_mercator;
  var d3_geo_orthographic = d3_geo_azimuthal(function() {
    return 1;
  }, Math.asin);
  (d3.geo.orthographic = function() {
    return d3_geo_projection(d3_geo_orthographic);
  }).raw = d3_geo_orthographic;
  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
    return 1 / (1 + cosλcosφ);
  }, function(ρ) {
    return 2 * Math.atan(ρ);
  });
  (d3.geo.stereographic = function() {
    return d3_geo_projection(d3_geo_stereographic);
  }).raw = d3_geo_stereographic;
  function d3_geo_transverseMercator(λ, φ) {
    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
  }
  d3_geo_transverseMercator.invert = function(x, y) {
    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
  };
  (d3.geo.transverseMercator = function() {
    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
    projection.center = function(_) {
      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
    };
    projection.rotate = function(_) {
      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
      [ _[0], _[1], _[2] - 90 ]);
    };
    return rotate([ 0, 0, 90 ]);
  }).raw = d3_geo_transverseMercator;
  d3.geom = {};
  function d3_geom_pointX(d) {
    return d[0];
  }
  function d3_geom_pointY(d) {
    return d[1];
  }
  d3.geom.hull = function(vertices) {
    var x = d3_geom_pointX, y = d3_geom_pointY;
    if (arguments.length) return hull(vertices);
    function hull(data) {
      if (data.length < 3) return [];
      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
      for (i = 0; i < n; i++) {
        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
      }
      points.sort(d3_geom_hullOrder);
      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
      return polygon;
    }
    hull.x = function(_) {
      return arguments.length ? (x = _, hull) : x;
    };
    hull.y = function(_) {
      return arguments.length ? (y = _, hull) : y;
    };
    return hull;
  };
  function d3_geom_hullUpper(points) {
    var n = points.length, hull = [ 0, 1 ], hs = 2;
    for (var i = 2; i < n; i++) {
      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
      hull[hs++] = i;
    }
    return hull.slice(0, hs);
  }
  function d3_geom_hullOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
  }
  d3.geom.polygon = function(coordinates) {
    d3_subclass(coordinates, d3_geom_polygonPrototype);
    return coordinates;
  };
  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
  d3_geom_polygonPrototype.area = function() {
    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
    while (++i < n) {
      a = b;
      b = this[i];
      area += a[1] * b[0] - a[0] * b[1];
    }
    return area * .5;
  };
  d3_geom_polygonPrototype.centroid = function(k) {
    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
    if (!arguments.length) k = -1 / (6 * this.area());
    while (++i < n) {
      a = b;
      b = this[i];
      c = a[0] * b[1] - b[0] * a[1];
      x += (a[0] + b[0]) * c;
      y += (a[1] + b[1]) * c;
    }
    return [ x * k, y * k ];
  };
  d3_geom_polygonPrototype.clip = function(subject) {
    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
    while (++i < n) {
      input = subject.slice();
      subject.length = 0;
      b = this[i];
      c = input[(m = input.length - closed) - 1];
      j = -1;
      while (++j < m) {
        d = input[j];
        if (d3_geom_polygonInside(d, a, b)) {
          if (!d3_geom_polygonInside(c, a, b)) {
            subject.push(d3_geom_polygonIntersect(c, d, a, b));
          }
          subject.push(d);
        } else if (d3_geom_polygonInside(c, a, b)) {
          subject.push(d3_geom_polygonIntersect(c, d, a, b));
        }
        c = d;
      }
      if (closed) subject.push(subject[0]);
      a = b;
    }
    return subject;
  };
  function d3_geom_polygonInside(p, a, b) {
    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
  }
  function d3_geom_polygonIntersect(c, d, a, b) {
    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
    return [ x1 + ua * x21, y1 + ua * y21 ];
  }
  function d3_geom_polygonClosed(coordinates) {
    var a = coordinates[0], b = coordinates[coordinates.length - 1];
    return !(a[0] - b[0] || a[1] - b[1]);
  }
  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
  function d3_geom_voronoiBeach() {
    d3_geom_voronoiRedBlackNode(this);
    this.edge = this.site = this.circle = null;
  }
  function d3_geom_voronoiCreateBeach(site) {
    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
    beach.site = site;
    return beach;
  }
  function d3_geom_voronoiDetachBeach(beach) {
    d3_geom_voronoiDetachCircle(beach);
    d3_geom_voronoiBeaches.remove(beach);
    d3_geom_voronoiBeachPool.push(beach);
    d3_geom_voronoiRedBlackNode(beach);
  }
  function d3_geom_voronoiRemoveBeach(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
      x: x,
      y: y
    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
    d3_geom_voronoiDetachBeach(beach);
    var lArc = previous;
    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
      previous = lArc.P;
      disappearing.unshift(lArc);
      d3_geom_voronoiDetachBeach(lArc);
      lArc = previous;
    }
    disappearing.unshift(lArc);
    d3_geom_voronoiDetachCircle(lArc);
    var rArc = next;
    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
      next = rArc.N;
      disappearing.push(rArc);
      d3_geom_voronoiDetachBeach(rArc);
      rArc = next;
    }
    disappearing.push(rArc);
    d3_geom_voronoiDetachCircle(rArc);
    var nArcs = disappearing.length, iArc;
    for (iArc = 1; iArc < nArcs; ++iArc) {
      rArc = disappearing[iArc];
      lArc = disappearing[iArc - 1];
      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiAddBeach(site) {
    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
    while (node) {
      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
      if (dxl > ε) node = node.L; else {
        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
        if (dxr > ε) {
          if (!node.R) {
            lArc = node;
            break;
          }
          node = node.R;
        } else {
          if (dxl > -ε) {
            lArc = node.P;
            rArc = node;
          } else if (dxr > -ε) {
            lArc = node;
            rArc = node.N;
          } else {
            lArc = rArc = node;
          }
          break;
        }
      }
    }
    var newArc = d3_geom_voronoiCreateBeach(site);
    d3_geom_voronoiBeaches.insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
      d3_geom_voronoiDetachCircle(lArc);
      rArc = d3_geom_voronoiCreateBeach(lArc.site);
      d3_geom_voronoiBeaches.insert(newArc, rArc);
      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      d3_geom_voronoiAttachCircle(lArc);
      d3_geom_voronoiAttachCircle(rArc);
      return;
    }
    if (!rArc) {
      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      return;
    }
    d3_geom_voronoiDetachCircle(lArc);
    d3_geom_voronoiDetachCircle(rArc);
    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
      x: (cy * hb - by * hc) / d + ax,
      y: (bx * hc - cx * hb) / d + ay
    };
    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
  }
  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site.y === directrix ? site.x : Infinity;
  }
  function d3_geom_voronoiCell(site) {
    this.site = site;
    this.edges = [];
  }
  d3_geom_voronoiCell.prototype.prepare = function() {
    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
    while (iHalfEdge--) {
      edge = halfEdges[iHalfEdge].edge;
      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
    }
    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
    return halfEdges.length;
  };
  function d3_geom_voronoiCloseCells(extent) {
    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
    while (iCell--) {
      cell = cells[iCell];
      if (!cell || !cell.prepare()) continue;
      halfEdges = cell.edges;
      nHalfEdges = halfEdges.length;
      iHalfEdge = 0;
      while (iHalfEdge < nHalfEdges) {
        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
            x: x0,
            y: abs(x2 - x0) < ε ? y2 : y1
          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
            x: abs(y2 - y1) < ε ? x2 : x1,
            y: y1
          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
            x: x1,
            y: abs(x2 - x1) < ε ? y2 : y0
          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
            x: abs(y2 - y0) < ε ? x2 : x0,
            y: y0
          } : null), cell.site, null));
          ++nHalfEdges;
        }
      }
    }
  }
  function d3_geom_voronoiHalfEdgeOrder(a, b) {
    return b.angle - a.angle;
  }
  function d3_geom_voronoiCircle() {
    d3_geom_voronoiRedBlackNode(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
  }
  function d3_geom_voronoiAttachCircle(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -ε2) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = cy + Math.sqrt(x * x + y * y);
    circle.cy = cy;
    arc.circle = circle;
    var before = null, node = d3_geom_voronoiCircles._;
    while (node) {
      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
        if (node.L) node = node.L; else {
          before = node.P;
          break;
        }
      } else {
        if (node.R) node = node.R; else {
          before = node;
          break;
        }
      }
    }
    d3_geom_voronoiCircles.insert(before, circle);
    if (!before) d3_geom_voronoiFirstCircle = circle;
  }
  function d3_geom_voronoiDetachCircle(arc) {
    var circle = arc.circle;
    if (circle) {
      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
      d3_geom_voronoiCircles.remove(circle);
      d3_geom_voronoiCirclePool.push(circle);
      d3_geom_voronoiRedBlackNode(circle);
      arc.circle = null;
    }
  }
  function d3_geom_voronoiClipEdges(extent) {
    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
    while (i--) {
      e = edges[i];
      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
        e.a = e.b = null;
        edges.splice(i, 1);
      }
    }
  }
  function d3_geom_voronoiConnectEdge(edge, extent) {
    var vb = edge.b;
    if (vb) return true;
    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
      if (fx < x0 || fx >= x1) return;
      if (lx > rx) {
        if (!va) va = {
          x: fx,
          y: y0
        }; else if (va.y >= y1) return;
        vb = {
          x: fx,
          y: y1
        };
      } else {
        if (!va) va = {
          x: fx,
          y: y1
        }; else if (va.y < y0) return;
        vb = {
          x: fx,
          y: y0
        };
      }
    } else {
      fm = (lx - rx) / (ry - ly);
      fb = fy - fm * fx;
      if (fm < -1 || fm > 1) {
        if (lx > rx) {
          if (!va) va = {
            x: (y0 - fb) / fm,
            y: y0
          }; else if (va.y >= y1) return;
          vb = {
            x: (y1 - fb) / fm,
            y: y1
          };
        } else {
          if (!va) va = {
            x: (y1 - fb) / fm,
            y: y1
          }; else if (va.y < y0) return;
          vb = {
            x: (y0 - fb) / fm,
            y: y0
          };
        }
      } else {
        if (ly < ry) {
          if (!va) va = {
            x: x0,
            y: fm * x0 + fb
          }; else if (va.x >= x1) return;
          vb = {
            x: x1,
            y: fm * x1 + fb
          };
        } else {
          if (!va) va = {
            x: x1,
            y: fm * x1 + fb
          }; else if (va.x < x0) return;
          vb = {
            x: x0,
            y: fm * x0 + fb
          };
        }
      }
    }
    edge.a = va;
    edge.b = vb;
    return true;
  }
  function d3_geom_voronoiEdge(lSite, rSite) {
    this.l = lSite;
    this.r = rSite;
    this.a = this.b = null;
  }
  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, rSite);
    d3_geom_voronoiEdges.push(edge);
    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
    return edge;
  }
  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, null);
    edge.a = va;
    edge.b = vb;
    d3_geom_voronoiEdges.push(edge);
    return edge;
  }
  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
    if (!edge.a && !edge.b) {
      edge.a = vertex;
      edge.l = lSite;
      edge.r = rSite;
    } else if (edge.l === rSite) {
      edge.b = vertex;
    } else {
      edge.a = vertex;
    }
  }
  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
    var va = edge.a, vb = edge.b;
    this.edge = edge;
    this.site = lSite;
    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
  }
  d3_geom_voronoiHalfEdge.prototype = {
    start: function() {
      return this.edge.l === this.site ? this.edge.a : this.edge.b;
    },
    end: function() {
      return this.edge.l === this.site ? this.edge.b : this.edge.a;
    }
  };
  function d3_geom_voronoiRedBlackTree() {
    this._ = null;
  }
  function d3_geom_voronoiRedBlackNode(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null;
  }
  d3_geom_voronoiRedBlackTree.prototype = {
    insert: function(after, node) {
      var parent, grandpa, uncle;
      if (after) {
        node.P = after;
        node.N = after.N;
        if (after.N) after.N.P = node;
        after.N = node;
        if (after.R) {
          after = after.R;
          while (after.L) after = after.L;
          after.L = node;
        } else {
          after.R = node;
        }
        parent = after;
      } else if (this._) {
        after = d3_geom_voronoiRedBlackFirst(this._);
        node.P = null;
        node.N = after;
        after.P = after.L = node;
        parent = after;
      } else {
        node.P = node.N = null;
        this._ = node;
        parent = null;
      }
      node.L = node.R = null;
      node.U = parent;
      node.C = true;
      after = node;
      while (parent && parent.C) {
        grandpa = parent.U;
        if (parent === grandpa.L) {
          uncle = grandpa.R;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.R) {
              d3_geom_voronoiRedBlackRotateLeft(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
          }
        } else {
          uncle = grandpa.L;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.L) {
              d3_geom_voronoiRedBlackRotateRight(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
          }
        }
        parent = after.U;
      }
      this._.C = false;
    },
    remove: function(node) {
      if (node.N) node.N.P = node.P;
      if (node.P) node.P.N = node.N;
      node.N = node.P = null;
      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
      if (parent) {
        if (parent.L === node) parent.L = next; else parent.R = next;
      } else {
        this._ = next;
      }
      if (left && right) {
        red = next.C;
        next.C = node.C;
        next.L = left;
        left.U = next;
        if (next !== right) {
          parent = next.U;
          next.U = node.U;
          node = next.R;
          parent.L = node;
          next.R = right;
          right.U = next;
        } else {
          next.U = parent;
          parent = next;
          node = next.R;
        }
      } else {
        red = node.C;
        node = next;
      }
      if (node) node.U = parent;
      if (red) return;
      if (node && node.C) {
        node.C = false;
        return;
      }
      do {
        if (node === this._) break;
        if (node === parent.L) {
          sibling = parent.R;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            sibling = parent.R;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.R || !sibling.R.C) {
              sibling.L.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateRight(this, sibling);
              sibling = parent.R;
            }
            sibling.C = parent.C;
            parent.C = sibling.R.C = false;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            node = this._;
            break;
          }
        } else {
          sibling = parent.L;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            sibling = parent.L;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.L || !sibling.L.C) {
              sibling.R.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
              sibling = parent.L;
            }
            sibling.C = parent.C;
            parent.C = sibling.L.C = false;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            node = this._;
            break;
          }
        }
        sibling.C = true;
        node = parent;
        parent = parent.U;
      } while (!node.C);
      if (node) node.C = false;
    }
  };
  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
  }
  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
  }
  function d3_geom_voronoiRedBlackFirst(node) {
    while (node.L) node = node.L;
    return node;
  }
  function d3_geom_voronoi(sites, bbox) {
    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
    d3_geom_voronoiEdges = [];
    d3_geom_voronoiCells = new Array(sites.length);
    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
    while (true) {
      circle = d3_geom_voronoiFirstCircle;
      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
        if (site.x !== x0 || site.y !== y0) {
          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
          d3_geom_voronoiAddBeach(site);
          x0 = site.x, y0 = site.y;
        }
        site = sites.pop();
      } else if (circle) {
        d3_geom_voronoiRemoveBeach(circle.arc);
      } else {
        break;
      }
    }
    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
    var diagram = {
      cells: d3_geom_voronoiCells,
      edges: d3_geom_voronoiEdges
    };
    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
    return diagram;
  }
  function d3_geom_voronoiVertexOrder(a, b) {
    return b.y - a.y || b.x - a.x;
  }
  d3.geom.voronoi = function(points) {
    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
    if (points) return voronoi(points);
    function voronoi(data) {
      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
          var s = e.start();
          return [ s.x, s.y ];
        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
        polygon.point = data[i];
      });
      return polygons;
    }
    function sites(data) {
      return data.map(function(d, i) {
        return {
          x: Math.round(fx(d, i) / ε) * ε,
          y: Math.round(fy(d, i) / ε) * ε,
          i: i
        };
      });
    }
    voronoi.links = function(data) {
      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
        return edge.l && edge.r;
      }).map(function(edge) {
        return {
          source: data[edge.l.i],
          target: data[edge.r.i]
        };
      });
    };
    voronoi.triangles = function(data) {
      var triangles = [];
      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
        while (++j < m) {
          e0 = e1;
          s0 = s1;
          e1 = edges[j].edge;
          s1 = e1.l === site ? e1.r : e1.l;
          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
          }
        }
      });
      return triangles;
    };
    voronoi.x = function(_) {
      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
    };
    voronoi.y = function(_) {
      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
    };
    voronoi.clipExtent = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
      return voronoi;
    };
    voronoi.size = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
    };
    return voronoi;
  };
  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
  function d3_geom_voronoiTriangleArea(a, b, c) {
    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
  }
  d3.geom.delaunay = function(vertices) {
    return d3.geom.voronoi().triangles(vertices);
  };
  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
    if (compat = arguments.length) {
      x = d3_geom_quadtreeCompatX;
      y = d3_geom_quadtreeCompatY;
      if (compat === 3) {
        y2 = y1;
        x2 = x1;
        y1 = x1 = 0;
      }
      return quadtree(points);
    }
    function quadtree(data) {
      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
      if (x1 != null) {
        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
      } else {
        x2_ = y2_ = -(x1_ = y1_ = Infinity);
        xs = [], ys = [];
        n = data.length;
        if (compat) for (i = 0; i < n; ++i) {
          d = data[i];
          if (d.x < x1_) x1_ = d.x;
          if (d.y < y1_) y1_ = d.y;
          if (d.x > x2_) x2_ = d.x;
          if (d.y > y2_) y2_ = d.y;
          xs.push(d.x);
          ys.push(d.y);
        } else for (i = 0; i < n; ++i) {
          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
          if (x_ < x1_) x1_ = x_;
          if (y_ < y1_) y1_ = y_;
          if (x_ > x2_) x2_ = x_;
          if (y_ > y2_) y2_ = y_;
          xs.push(x_);
          ys.push(y_);
        }
      }
      var dx = x2_ - x1_, dy = y2_ - y1_;
      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
      function insert(n, d, x, y, x1, y1, x2, y2) {
        if (isNaN(x) || isNaN(y)) return;
        if (n.leaf) {
          var nx = n.x, ny = n.y;
          if (nx != null) {
            if (abs(nx - x) + abs(ny - y) < .01) {
              insertChild(n, d, x, y, x1, y1, x2, y2);
            } else {
              var nPoint = n.point;
              n.x = n.y = n.point = null;
              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
              insertChild(n, d, x, y, x1, y1, x2, y2);
            }
          } else {
            n.x = x, n.y = y, n.point = d;
          }
        } else {
          insertChild(n, d, x, y, x1, y1, x2, y2);
        }
      }
      function insertChild(n, d, x, y, x1, y1, x2, y2) {
        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
        n.leaf = false;
        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
        if (right) x1 = xm; else x2 = xm;
        if (below) y1 = ym; else y2 = ym;
        insert(n, d, x, y, x1, y1, x2, y2);
      }
      var root = d3_geom_quadtreeNode();
      root.add = function(d) {
        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
      };
      root.visit = function(f) {
        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
      };
      root.find = function(point) {
        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
      };
      i = -1;
      if (x1 == null) {
        while (++i < n) {
          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
        }
        --i;
      } else data.forEach(root.add);
      xs = ys = data = d = null;
      return root;
    }
    quadtree.x = function(_) {
      return arguments.length ? (x = _, quadtree) : x;
    };
    quadtree.y = function(_) {
      return arguments.length ? (y = _, quadtree) : y;
    };
    quadtree.extent = function(_) {
      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
      y2 = +_[1][1];
      return quadtree;
    };
    quadtree.size = function(_) {
      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
      return quadtree;
    };
    return quadtree;
  };
  function d3_geom_quadtreeCompatX(d) {
    return d.x;
  }
  function d3_geom_quadtreeCompatY(d) {
    return d.y;
  }
  function d3_geom_quadtreeNode() {
    return {
      leaf: true,
      nodes: [],
      point: null,
      x: null,
      y: null
    };
  }
  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
    if (!f(node, x1, y1, x2, y2)) {
      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
    }
  }
  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
    var minDistance2 = Infinity, closestPoint;
    (function find(node, x1, y1, x2, y2) {
      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
      if (point = node.point) {
        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
        if (distance2 < minDistance2) {
          var distance = Math.sqrt(minDistance2 = distance2);
          x0 = x - distance, y0 = y - distance;
          x3 = x + distance, y3 = y + distance;
          closestPoint = point;
        }
      }
      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
        if (node = children[i & 3]) switch (i & 3) {
         case 0:
          find(node, x1, y1, xm, ym);
          break;

         case 1:
          find(node, xm, y1, x2, ym);
          break;

         case 2:
          find(node, x1, ym, xm, y2);
          break;

         case 3:
          find(node, xm, ym, x2, y2);
          break;
        }
      }
    })(root, x0, y0, x3, y3);
    return closestPoint;
  }
  d3.interpolateRgb = d3_interpolateRgb;
  function d3_interpolateRgb(a, b) {
    a = d3.rgb(a);
    b = d3.rgb(b);
    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
    return function(t) {
      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
    };
  }
  d3.interpolateObject = d3_interpolateObject;
  function d3_interpolateObject(a, b) {
    var i = {}, c = {}, k;
    for (k in a) {
      if (k in b) {
        i[k] = d3_interpolate(a[k], b[k]);
      } else {
        c[k] = a[k];
      }
    }
    for (k in b) {
      if (!(k in a)) {
        c[k] = b[k];
      }
    }
    return function(t) {
      for (k in i) c[k] = i[k](t);
      return c;
    };
  }
  d3.interpolateNumber = d3_interpolateNumber;
  function d3_interpolateNumber(a, b) {
    a = +a, b = +b;
    return function(t) {
      return a * (1 - t) + b * t;
    };
  }
  d3.interpolateString = d3_interpolateString;
  function d3_interpolateString(a, b) {
    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
    a = a + "", b = b + "";
    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
      if ((bs = bm.index) > bi) {
        bs = b.slice(bi, bs);
        if (s[i]) s[i] += bs; else s[++i] = bs;
      }
      if ((am = am[0]) === (bm = bm[0])) {
        if (s[i]) s[i] += bm; else s[++i] = bm;
      } else {
        s[++i] = null;
        q.push({
          i: i,
          x: d3_interpolateNumber(am, bm)
        });
      }
      bi = d3_interpolate_numberB.lastIndex;
    }
    if (bi < b.length) {
      bs = b.slice(bi);
      if (s[i]) s[i] += bs; else s[++i] = bs;
    }
    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
      return b(t) + "";
    }) : function() {
      return b;
    } : (b = q.length, function(t) {
      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    });
  }
  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
  d3.interpolate = d3_interpolate;
  function d3_interpolate(a, b) {
    var i = d3.interpolators.length, f;
    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
    return f;
  }
  d3.interpolators = [ function(a, b) {
    var t = typeof b;
    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
  } ];
  d3.interpolateArray = d3_interpolateArray;
  function d3_interpolateArray(a, b) {
    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
    for (;i < na; ++i) c[i] = a[i];
    for (;i < nb; ++i) c[i] = b[i];
    return function(t) {
      for (i = 0; i < n0; ++i) c[i] = x[i](t);
      return c;
    };
  }
  var d3_ease_default = function() {
    return d3_identity;
  };
  var d3_ease = d3.map({
    linear: d3_ease_default,
    poly: d3_ease_poly,
    quad: function() {
      return d3_ease_quad;
    },
    cubic: function() {
      return d3_ease_cubic;
    },
    sin: function() {
      return d3_ease_sin;
    },
    exp: function() {
      return d3_ease_exp;
    },
    circle: function() {
      return d3_ease_circle;
    },
    elastic: d3_ease_elastic,
    back: d3_ease_back,
    bounce: function() {
      return d3_ease_bounce;
    }
  });
  var d3_ease_mode = d3.map({
    "in": d3_identity,
    out: d3_ease_reverse,
    "in-out": d3_ease_reflect,
    "out-in": function(f) {
      return d3_ease_reflect(d3_ease_reverse(f));
    }
  });
  d3.ease = function(name) {
    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
    t = d3_ease.get(t) || d3_ease_default;
    m = d3_ease_mode.get(m) || d3_identity;
    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
  };
  function d3_ease_clamp(f) {
    return function(t) {
      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
    };
  }
  function d3_ease_reverse(f) {
    return function(t) {
      return 1 - f(1 - t);
    };
  }
  function d3_ease_reflect(f) {
    return function(t) {
      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
    };
  }
  function d3_ease_quad(t) {
    return t * t;
  }
  function d3_ease_cubic(t) {
    return t * t * t;
  }
  function d3_ease_cubicInOut(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    var t2 = t * t, t3 = t2 * t;
    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
  }
  function d3_ease_poly(e) {
    return function(t) {
      return Math.pow(t, e);
    };
  }
  function d3_ease_sin(t) {
    return 1 - Math.cos(t * halfπ);
  }
  function d3_ease_exp(t) {
    return Math.pow(2, 10 * (t - 1));
  }
  function d3_ease_circle(t) {
    return 1 - Math.sqrt(1 - t * t);
  }
  function d3_ease_elastic(a, p) {
    var s;
    if (arguments.length < 2) p = .45;
    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
    return function(t) {
      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
    };
  }
  function d3_ease_back(s) {
    if (!s) s = 1.70158;
    return function(t) {
      return t * t * ((s + 1) * t - s);
    };
  }
  function d3_ease_bounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
  }
  d3.interpolateHcl = d3_interpolateHcl;
  function d3_interpolateHcl(a, b) {
    a = d3.hcl(a);
    b = d3.hcl(b);
    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
    };
  }
  d3.interpolateHsl = d3_interpolateHsl;
  function d3_interpolateHsl(a, b) {
    a = d3.hsl(a);
    b = d3.hsl(b);
    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
    };
  }
  d3.interpolateLab = d3_interpolateLab;
  function d3_interpolateLab(a, b) {
    a = d3.lab(a);
    b = d3.lab(b);
    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
    return function(t) {
      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
    };
  }
  d3.interpolateRound = d3_interpolateRound;
  function d3_interpolateRound(a, b) {
    b -= a;
    return function(t) {
      return Math.round(a + b * t);
    };
  }
  d3.transform = function(string) {
    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
    return (d3.transform = function(string) {
      if (string != null) {
        g.setAttribute("transform", string);
        var t = g.transform.baseVal.consolidate();
      }
      return new d3_transform(t ? t.matrix : d3_transformIdentity);
    })(string);
  };
  function d3_transform(m) {
    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
    if (r0[0] * r1[1] < r1[0] * r0[1]) {
      r0[0] *= -1;
      r0[1] *= -1;
      kx *= -1;
      kz *= -1;
    }
    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
    this.translate = [ m.e, m.f ];
    this.scale = [ kx, ky ];
    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
  }
  d3_transform.prototype.toString = function() {
    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
  };
  function d3_transformDot(a, b) {
    return a[0] * b[0] + a[1] * b[1];
  }
  function d3_transformNormalize(a) {
    var k = Math.sqrt(d3_transformDot(a, a));
    if (k) {
      a[0] /= k;
      a[1] /= k;
    }
    return k;
  }
  function d3_transformCombine(a, b, k) {
    a[0] += k * b[0];
    a[1] += k * b[1];
    return a;
  }
  var d3_transformIdentity = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
  };
  d3.interpolateTransform = d3_interpolateTransform;
  function d3_interpolateTransformPop(s) {
    return s.length ? s.pop() + "," : "";
  }
  function d3_interpolateTranslate(ta, tb, s, q) {
    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
      var i = s.push("translate(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ta[0], tb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ta[1], tb[1])
      });
    } else if (tb[0] || tb[1]) {
      s.push("translate(" + tb + ")");
    }
  }
  function d3_interpolateRotate(ra, rb, s, q) {
    if (ra !== rb) {
      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
        x: d3_interpolateNumber(ra, rb)
      });
    } else if (rb) {
      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
    }
  }
  function d3_interpolateSkew(wa, wb, s, q) {
    if (wa !== wb) {
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
        x: d3_interpolateNumber(wa, wb)
      });
    } else if (wb) {
      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
    }
  }
  function d3_interpolateScale(ka, kb, s, q) {
    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ka[0], kb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ka[1], kb[1])
      });
    } else if (kb[0] !== 1 || kb[1] !== 1) {
      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
    }
  }
  function d3_interpolateTransform(a, b) {
    var s = [], q = [];
    a = d3.transform(a), b = d3.transform(b);
    d3_interpolateTranslate(a.translate, b.translate, s, q);
    d3_interpolateRotate(a.rotate, b.rotate, s, q);
    d3_interpolateSkew(a.skew, b.skew, s, q);
    d3_interpolateScale(a.scale, b.scale, s, q);
    a = b = null;
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  }
  function d3_uninterpolateNumber(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return (x - a) / b;
    };
  }
  function d3_uninterpolateClamp(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return Math.max(0, Math.min(1, (x - a) / b));
    };
  }
  d3.layout = {};
  d3.layout.bundle = function() {
    return function(links) {
      var paths = [], i = -1, n = links.length;
      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
      return paths;
    };
  };
  function d3_layout_bundlePath(link) {
    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
    while (start !== lca) {
      start = start.parent;
      points.push(start);
    }
    var k = points.length;
    while (end !== lca) {
      points.splice(k, 0, end);
      end = end.parent;
    }
    return points;
  }
  function d3_layout_bundleAncestors(node) {
    var ancestors = [], parent = node.parent;
    while (parent != null) {
      ancestors.push(node);
      node = parent;
      parent = parent.parent;
    }
    ancestors.push(node);
    return ancestors;
  }
  function d3_layout_bundleLeastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
    while (aNode === bNode) {
      sharedNode = aNode;
      aNode = aNodes.pop();
      bNode = bNodes.pop();
    }
    return sharedNode;
  }
  d3.layout.chord = function() {
    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
    function relayout() {
      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
      chords = [];
      groups = [];
      k = 0, i = -1;
      while (++i < n) {
        x = 0, j = -1;
        while (++j < n) {
          x += matrix[i][j];
        }
        groupSums.push(x);
        subgroupIndex.push(d3.range(n));
        k += x;
      }
      if (sortGroups) {
        groupIndex.sort(function(a, b) {
          return sortGroups(groupSums[a], groupSums[b]);
        });
      }
      if (sortSubgroups) {
        subgroupIndex.forEach(function(d, i) {
          d.sort(function(a, b) {
            return sortSubgroups(matrix[i][a], matrix[i][b]);
          });
        });
      }
      k = (τ - padding * n) / k;
      x = 0, i = -1;
      while (++i < n) {
        x0 = x, j = -1;
        while (++j < n) {
          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
          subgroups[di + "-" + dj] = {
            index: di,
            subindex: dj,
            startAngle: a0,
            endAngle: a1,
            value: v
          };
        }
        groups[di] = {
          index: di,
          startAngle: x0,
          endAngle: x,
          value: groupSums[di]
        };
        x += padding;
      }
      i = -1;
      while (++i < n) {
        j = i - 1;
        while (++j < n) {
          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
          if (source.value || target.value) {
            chords.push(source.value < target.value ? {
              source: target,
              target: source
            } : {
              source: source,
              target: target
            });
          }
        }
      }
      if (sortChords) resort();
    }
    function resort() {
      chords.sort(function(a, b) {
        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
      });
    }
    chord.matrix = function(x) {
      if (!arguments.length) return matrix;
      n = (matrix = x) && matrix.length;
      chords = groups = null;
      return chord;
    };
    chord.padding = function(x) {
      if (!arguments.length) return padding;
      padding = x;
      chords = groups = null;
      return chord;
    };
    chord.sortGroups = function(x) {
      if (!arguments.length) return sortGroups;
      sortGroups = x;
      chords = groups = null;
      return chord;
    };
    chord.sortSubgroups = function(x) {
      if (!arguments.length) return sortSubgroups;
      sortSubgroups = x;
      chords = null;
      return chord;
    };
    chord.sortChords = function(x) {
      if (!arguments.length) return sortChords;
      sortChords = x;
      if (chords) resort();
      return chord;
    };
    chord.chords = function() {
      if (!chords) relayout();
      return chords;
    };
    chord.groups = function() {
      if (!groups) relayout();
      return groups;
    };
    return chord;
  };
  d3.layout.force = function() {
    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
    function repulse(node) {
      return function(quad, x1, _, x2) {
        if (quad.point !== node) {
          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
          if (dw * dw / theta2 < dn) {
            if (dn < chargeDistance2) {
              var k = quad.charge / dn;
              node.px -= dx * k;
              node.py -= dy * k;
            }
            return true;
          }
          if (quad.point && dn && dn < chargeDistance2) {
            var k = quad.pointCharge / dn;
            node.px -= dx * k;
            node.py -= dy * k;
          }
        }
        return !quad.charge;
      };
    }
    force.tick = function() {
      if ((alpha *= .99) < .005) {
        timer = null;
        event.end({
          type: "end",
          alpha: alpha = 0
        });
        return true;
      }
      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
      for (i = 0; i < m; ++i) {
        o = links[i];
        s = o.source;
        t = o.target;
        x = t.x - s.x;
        y = t.y - s.y;
        if (l = x * x + y * y) {
          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
          x *= l;
          y *= l;
          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
          t.y -= y * k;
          s.x += x * (k = 1 - k);
          s.y += y * k;
        }
      }
      if (k = alpha * gravity) {
        x = size[0] / 2;
        y = size[1] / 2;
        i = -1;
        if (k) while (++i < n) {
          o = nodes[i];
          o.x += (x - o.x) * k;
          o.y += (y - o.y) * k;
        }
      }
      if (charge) {
        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
        i = -1;
        while (++i < n) {
          if (!(o = nodes[i]).fixed) {
            q.visit(repulse(o));
          }
        }
      }
      i = -1;
      while (++i < n) {
        o = nodes[i];
        if (o.fixed) {
          o.x = o.px;
          o.y = o.py;
        } else {
          o.x -= (o.px - (o.px = o.x)) * friction;
          o.y -= (o.py - (o.py = o.y)) * friction;
        }
      }
      event.tick({
        type: "tick",
        alpha: alpha
      });
    };
    force.nodes = function(x) {
      if (!arguments.length) return nodes;
      nodes = x;
      return force;
    };
    force.links = function(x) {
      if (!arguments.length) return links;
      links = x;
      return force;
    };
    force.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return force;
    };
    force.linkDistance = function(x) {
      if (!arguments.length) return linkDistance;
      linkDistance = typeof x === "function" ? x : +x;
      return force;
    };
    force.distance = force.linkDistance;
    force.linkStrength = function(x) {
      if (!arguments.length) return linkStrength;
      linkStrength = typeof x === "function" ? x : +x;
      return force;
    };
    force.friction = function(x) {
      if (!arguments.length) return friction;
      friction = +x;
      return force;
    };
    force.charge = function(x) {
      if (!arguments.length) return charge;
      charge = typeof x === "function" ? x : +x;
      return force;
    };
    force.chargeDistance = function(x) {
      if (!arguments.length) return Math.sqrt(chargeDistance2);
      chargeDistance2 = x * x;
      return force;
    };
    force.gravity = function(x) {
      if (!arguments.length) return gravity;
      gravity = +x;
      return force;
    };
    force.theta = function(x) {
      if (!arguments.length) return Math.sqrt(theta2);
      theta2 = x * x;
      return force;
    };
    force.alpha = function(x) {
      if (!arguments.length) return alpha;
      x = +x;
      if (alpha) {
        if (x > 0) {
          alpha = x;
        } else {
          timer.c = null, timer.t = NaN, timer = null;
          event.end({
            type: "end",
            alpha: alpha = 0
          });
        }
      } else if (x > 0) {
        event.start({
          type: "start",
          alpha: alpha = x
        });
        timer = d3_timer(force.tick);
      }
      return force;
    };
    force.start = function() {
      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
      for (i = 0; i < n; ++i) {
        (o = nodes[i]).index = i;
        o.weight = 0;
      }
      for (i = 0; i < m; ++i) {
        o = links[i];
        if (typeof o.source == "number") o.source = nodes[o.source];
        if (typeof o.target == "number") o.target = nodes[o.target];
        ++o.source.weight;
        ++o.target.weight;
      }
      for (i = 0; i < n; ++i) {
        o = nodes[i];
        if (isNaN(o.x)) o.x = position("x", w);
        if (isNaN(o.y)) o.y = position("y", h);
        if (isNaN(o.px)) o.px = o.x;
        if (isNaN(o.py)) o.py = o.y;
      }
      distances = [];
      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
      strengths = [];
      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
      charges = [];
      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
      function position(dimension, size) {
        if (!neighbors) {
          neighbors = new Array(n);
          for (j = 0; j < n; ++j) {
            neighbors[j] = [];
          }
          for (j = 0; j < m; ++j) {
            var o = links[j];
            neighbors[o.source.index].push(o.target);
            neighbors[o.target.index].push(o.source);
          }
        }
        var candidates = neighbors[i], j = -1, l = candidates.length, x;
        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
        return Math.random() * size;
      }
      return force.resume();
    };
    force.resume = function() {
      return force.alpha(.1);
    };
    force.stop = function() {
      return force.alpha(0);
    };
    force.drag = function() {
      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
      if (!arguments.length) return drag;
      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
    };
    function dragmove(d) {
      d.px = d3.event.x, d.py = d3.event.y;
      force.resume();
    }
    return d3.rebind(force, event, "on");
  };
  function d3_layout_forceDragstart(d) {
    d.fixed |= 2;
  }
  function d3_layout_forceDragend(d) {
    d.fixed &= ~6;
  }
  function d3_layout_forceMouseover(d) {
    d.fixed |= 4;
    d.px = d.x, d.py = d.y;
  }
  function d3_layout_forceMouseout(d) {
    d.fixed &= ~4;
  }
  function d3_layout_forceAccumulate(quad, alpha, charges) {
    var cx = 0, cy = 0;
    quad.charge = 0;
    if (!quad.leaf) {
      var nodes = quad.nodes, n = nodes.length, i = -1, c;
      while (++i < n) {
        c = nodes[i];
        if (c == null) continue;
        d3_layout_forceAccumulate(c, alpha, charges);
        quad.charge += c.charge;
        cx += c.charge * c.cx;
        cy += c.charge * c.cy;
      }
    }
    if (quad.point) {
      if (!quad.leaf) {
        quad.point.x += Math.random() - .5;
        quad.point.y += Math.random() - .5;
      }
      var k = alpha * charges[quad.point.index];
      quad.charge += quad.pointCharge = k;
      cx += k * quad.point.x;
      cy += k * quad.point.y;
    }
    quad.cx = cx / quad.charge;
    quad.cy = cy / quad.charge;
  }
  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
  d3.layout.hierarchy = function() {
    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
    function hierarchy(root) {
      var stack = [ root ], nodes = [], node;
      root.depth = 0;
      while ((node = stack.pop()) != null) {
        nodes.push(node);
        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
          var n, childs, child;
          while (--n >= 0) {
            stack.push(child = childs[n]);
            child.parent = node;
            child.depth = node.depth + 1;
          }
          if (value) node.value = 0;
          node.children = childs;
        } else {
          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
          delete node.children;
        }
      }
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var childs, parent;
        if (sort && (childs = node.children)) childs.sort(sort);
        if (value && (parent = node.parent)) parent.value += node.value;
      });
      return nodes;
    }
    hierarchy.sort = function(x) {
      if (!arguments.length) return sort;
      sort = x;
      return hierarchy;
    };
    hierarchy.children = function(x) {
      if (!arguments.length) return children;
      children = x;
      return hierarchy;
    };
    hierarchy.value = function(x) {
      if (!arguments.length) return value;
      value = x;
      return hierarchy;
    };
    hierarchy.revalue = function(root) {
      if (value) {
        d3_layout_hierarchyVisitBefore(root, function(node) {
          if (node.children) node.value = 0;
        });
        d3_layout_hierarchyVisitAfter(root, function(node) {
          var parent;
          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
          if (parent = node.parent) parent.value += node.value;
        });
      }
      return root;
    };
    return hierarchy;
  };
  function d3_layout_hierarchyRebind(object, hierarchy) {
    d3.rebind(object, hierarchy, "sort", "children", "value");
    object.nodes = object;
    object.links = d3_layout_hierarchyLinks;
    return object;
  }
  function d3_layout_hierarchyVisitBefore(node, callback) {
    var nodes = [ node ];
    while ((node = nodes.pop()) != null) {
      callback(node);
      if ((children = node.children) && (n = children.length)) {
        var n, children;
        while (--n >= 0) nodes.push(children[n]);
      }
    }
  }
  function d3_layout_hierarchyVisitAfter(node, callback) {
    var nodes = [ node ], nodes2 = [];
    while ((node = nodes.pop()) != null) {
      nodes2.push(node);
      if ((children = node.children) && (n = children.length)) {
        var i = -1, n, children;
        while (++i < n) nodes.push(children[i]);
      }
    }
    while ((node = nodes2.pop()) != null) {
      callback(node);
    }
  }
  function d3_layout_hierarchyChildren(d) {
    return d.children;
  }
  function d3_layout_hierarchyValue(d) {
    return d.value;
  }
  function d3_layout_hierarchySort(a, b) {
    return b.value - a.value;
  }
  function d3_layout_hierarchyLinks(nodes) {
    return d3.merge(nodes.map(function(parent) {
      return (parent.children || []).map(function(child) {
        return {
          source: parent,
          target: child
        };
      });
    }));
  }
  d3.layout.partition = function() {
    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
    function position(node, x, dx, dy) {
      var children = node.children;
      node.x = x;
      node.y = node.depth * dy;
      node.dx = dx;
      node.dy = dy;
      if (children && (n = children.length)) {
        var i = -1, n, c, d;
        dx = node.value ? dx / node.value : 0;
        while (++i < n) {
          position(c = children[i], x, d = c.value * dx, dy);
          x += d;
        }
      }
    }
    function depth(node) {
      var children = node.children, d = 0;
      if (children && (n = children.length)) {
        var i = -1, n;
        while (++i < n) d = Math.max(d, depth(children[i]));
      }
      return 1 + d;
    }
    function partition(d, i) {
      var nodes = hierarchy.call(this, d, i);
      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
      return nodes;
    }
    partition.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return partition;
    };
    return d3_layout_hierarchyRebind(partition, hierarchy);
  };
  d3.layout.pie = function() {
    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
    function pie(data) {
      var n = data.length, values = data.map(function(d, i) {
        return +value.call(pie, d, i);
      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
        return values[j] - values[i];
      } : function(i, j) {
        return sort(data[i], data[j]);
      });
      index.forEach(function(i) {
        arcs[i] = {
          data: data[i],
          value: v = values[i],
          startAngle: a,
          endAngle: a += v * k + pa,
          padAngle: p
        };
      });
      return arcs;
    }
    pie.value = function(_) {
      if (!arguments.length) return value;
      value = _;
      return pie;
    };
    pie.sort = function(_) {
      if (!arguments.length) return sort;
      sort = _;
      return pie;
    };
    pie.startAngle = function(_) {
      if (!arguments.length) return startAngle;
      startAngle = _;
      return pie;
    };
    pie.endAngle = function(_) {
      if (!arguments.length) return endAngle;
      endAngle = _;
      return pie;
    };
    pie.padAngle = function(_) {
      if (!arguments.length) return padAngle;
      padAngle = _;
      return pie;
    };
    return pie;
  };
  var d3_layout_pieSortByValue = {};
  d3.layout.stack = function() {
    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
    function stack(data, index) {
      if (!(n = data.length)) return data;
      var series = data.map(function(d, i) {
        return values.call(stack, d, i);
      });
      var points = series.map(function(d) {
        return d.map(function(v, i) {
          return [ x.call(stack, v, i), y.call(stack, v, i) ];
        });
      });
      var orders = order.call(stack, points, index);
      series = d3.permute(series, orders);
      points = d3.permute(points, orders);
      var offsets = offset.call(stack, points, index);
      var m = series[0].length, n, i, j, o;
      for (j = 0; j < m; ++j) {
        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
        for (i = 1; i < n; ++i) {
          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
        }
      }
      return data;
    }
    stack.values = function(x) {
      if (!arguments.length) return values;
      values = x;
      return stack;
    };
    stack.order = function(x) {
      if (!arguments.length) return order;
      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
      return stack;
    };
    stack.offset = function(x) {
      if (!arguments.length) return offset;
      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
      return stack;
    };
    stack.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      return stack;
    };
    stack.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      return stack;
    };
    stack.out = function(z) {
      if (!arguments.length) return out;
      out = z;
      return stack;
    };
    return stack;
  };
  function d3_layout_stackX(d) {
    return d.x;
  }
  function d3_layout_stackY(d) {
    return d.y;
  }
  function d3_layout_stackOut(d, y0, y) {
    d.y0 = y0;
    d.y = y;
  }
  var d3_layout_stackOrders = d3.map({
    "inside-out": function(data) {
      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
        return max[a] - max[b];
      }), top = 0, bottom = 0, tops = [], bottoms = [];
      for (i = 0; i < n; ++i) {
        j = index[i];
        if (top < bottom) {
          top += sums[j];
          tops.push(j);
        } else {
          bottom += sums[j];
          bottoms.push(j);
        }
      }
      return bottoms.reverse().concat(tops);
    },
    reverse: function(data) {
      return d3.range(data.length).reverse();
    },
    "default": d3_layout_stackOrderDefault
  });
  var d3_layout_stackOffsets = d3.map({
    silhouette: function(data) {
      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o > max) max = o;
        sums.push(o);
      }
      for (j = 0; j < m; ++j) {
        y0[j] = (max - sums[j]) / 2;
      }
      return y0;
    },
    wiggle: function(data) {
      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
      y0[0] = o = o0 = 0;
      for (j = 1; j < m; ++j) {
        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
          }
          s2 += s3 * data[i][j][1];
        }
        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
        if (o < o0) o0 = o;
      }
      for (j = 0; j < m; ++j) y0[j] -= o0;
      return y0;
    },
    expand: function(data) {
      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
      }
      for (j = 0; j < m; ++j) y0[j] = 0;
      return y0;
    },
    zero: d3_layout_stackOffsetZero
  });
  function d3_layout_stackOrderDefault(data) {
    return d3.range(data.length);
  }
  function d3_layout_stackOffsetZero(data) {
    var j = -1, m = data[0].length, y0 = [];
    while (++j < m) y0[j] = 0;
    return y0;
  }
  function d3_layout_stackMaxIndex(array) {
    var i = 1, j = 0, v = array[0][1], k, n = array.length;
    for (;i < n; ++i) {
      if ((k = array[i][1]) > v) {
        j = i;
        v = k;
      }
    }
    return j;
  }
  function d3_layout_stackReduceSum(d) {
    return d.reduce(d3_layout_stackSum, 0);
  }
  function d3_layout_stackSum(p, d) {
    return p + d[1];
  }
  d3.layout.histogram = function() {
    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
    function histogram(data, i) {
      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
      while (++i < m) {
        bin = bins[i] = [];
        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
        bin.y = 0;
      }
      if (m > 0) {
        i = -1;
        while (++i < n) {
          x = values[i];
          if (x >= range[0] && x <= range[1]) {
            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
            bin.y += k;
            bin.push(data[i]);
          }
        }
      }
      return bins;
    }
    histogram.value = function(x) {
      if (!arguments.length) return valuer;
      valuer = x;
      return histogram;
    };
    histogram.range = function(x) {
      if (!arguments.length) return ranger;
      ranger = d3_functor(x);
      return histogram;
    };
    histogram.bins = function(x) {
      if (!arguments.length) return binner;
      binner = typeof x === "number" ? function(range) {
        return d3_layout_histogramBinFixed(range, x);
      } : d3_functor(x);
      return histogram;
    };
    histogram.frequency = function(x) {
      if (!arguments.length) return frequency;
      frequency = !!x;
      return histogram;
    };
    return histogram;
  };
  function d3_layout_histogramBinSturges(range, values) {
    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
  }
  function d3_layout_histogramBinFixed(range, n) {
    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
    while (++x <= n) f[x] = m * x + b;
    return f;
  }
  function d3_layout_histogramRange(values) {
    return [ d3.min(values), d3.max(values) ];
  }
  d3.layout.pack = function() {
    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
    function pack(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
        return radius;
      };
      root.x = root.y = 0;
      d3_layout_hierarchyVisitAfter(root, function(d) {
        d.r = +r(d.value);
      });
      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
      if (padding) {
        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r += dr;
        });
        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r -= dr;
        });
      }
      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
      return nodes;
    }
    pack.size = function(_) {
      if (!arguments.length) return size;
      size = _;
      return pack;
    };
    pack.radius = function(_) {
      if (!arguments.length) return radius;
      radius = _ == null || typeof _ === "function" ? _ : +_;
      return pack;
    };
    pack.padding = function(_) {
      if (!arguments.length) return padding;
      padding = +_;
      return pack;
    };
    return d3_layout_hierarchyRebind(pack, hierarchy);
  };
  function d3_layout_packSort(a, b) {
    return a.value - b.value;
  }
  function d3_layout_packInsert(a, b) {
    var c = a._pack_next;
    a._pack_next = b;
    b._pack_prev = a;
    b._pack_next = c;
    c._pack_prev = b;
  }
  function d3_layout_packSplice(a, b) {
    a._pack_next = b;
    b._pack_prev = a;
  }
  function d3_layout_packIntersects(a, b) {
    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
    return .999 * dr * dr > dx * dx + dy * dy;
  }
  function d3_layout_packSiblings(node) {
    if (!(nodes = node.children) || !(n = nodes.length)) return;
    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
    function bound(node) {
      xMin = Math.min(node.x - node.r, xMin);
      xMax = Math.max(node.x + node.r, xMax);
      yMin = Math.min(node.y - node.r, yMin);
      yMax = Math.max(node.y + node.r, yMax);
    }
    nodes.forEach(d3_layout_packLink);
    a = nodes[0];
    a.x = -a.r;
    a.y = 0;
    bound(a);
    if (n > 1) {
      b = nodes[1];
      b.x = b.r;
      b.y = 0;
      bound(b);
      if (n > 2) {
        c = nodes[2];
        d3_layout_packPlace(a, b, c);
        bound(c);
        d3_layout_packInsert(a, c);
        a._pack_prev = c;
        d3_layout_packInsert(c, b);
        b = a._pack_next;
        for (i = 3; i < n; i++) {
          d3_layout_packPlace(a, b, c = nodes[i]);
          var isect = 0, s1 = 1, s2 = 1;
          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
            if (d3_layout_packIntersects(j, c)) {
              isect = 1;
              break;
            }
          }
          if (isect == 1) {
            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
              if (d3_layout_packIntersects(k, c)) {
                break;
              }
            }
          }
          if (isect) {
            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
            i--;
          } else {
            d3_layout_packInsert(a, c);
            b = c;
            bound(c);
          }
        }
      }
    }
    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
    for (i = 0; i < n; i++) {
      c = nodes[i];
      c.x -= cx;
      c.y -= cy;
      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
    }
    node.r = cr;
    nodes.forEach(d3_layout_packUnlink);
  }
  function d3_layout_packLink(node) {
    node._pack_next = node._pack_prev = node;
  }
  function d3_layout_packUnlink(node) {
    delete node._pack_next;
    delete node._pack_prev;
  }
  function d3_layout_packTransform(node, x, y, k) {
    var children = node.children;
    node.x = x += k * node.x;
    node.y = y += k * node.y;
    node.r *= k;
    if (children) {
      var i = -1, n = children.length;
      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
    }
  }
  function d3_layout_packPlace(a, b, c) {
    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
    if (db && (dx || dy)) {
      var da = b.r + c.r, dc = dx * dx + dy * dy;
      da *= da;
      db *= db;
      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
      c.x = a.x + x * dx + y * dy;
      c.y = a.y + x * dy - y * dx;
    } else {
      c.x = a.x + db;
      c.y = a.y;
    }
  }
  d3.layout.tree = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
    function tree(d, i) {
      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
      d3_layout_hierarchyVisitBefore(root1, secondWalk);
      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
        var left = root0, right = root0, bottom = root0;
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          if (node.x < left.x) left = node;
          if (node.x > right.x) right = node;
          if (node.depth > bottom.depth) bottom = node;
        });
        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          node.x = (node.x + tx) * kx;
          node.y = node.depth * ky;
        });
      }
      return nodes;
    }
    function wrapTree(root0) {
      var root1 = {
        A: null,
        children: [ root0 ]
      }, queue = [ root1 ], node1;
      while ((node1 = queue.pop()) != null) {
        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
          queue.push((children[i] = child = {
            _: children[i],
            parent: node1,
            children: (child = children[i].children) && child.slice() || [],
            A: null,
            a: null,
            z: 0,
            m: 0,
            c: 0,
            s: 0,
            t: null,
            i: i
          }).a = child);
        }
      }
      return root1.children[0];
    }
    function firstWalk(v) {
      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
      if (children.length) {
        d3_layout_treeShift(v);
        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
        if (w) {
          v.z = w.z + separation(v._, w._);
          v.m = v.z - midpoint;
        } else {
          v.z = midpoint;
        }
      } else if (w) {
        v.z = w.z + separation(v._, w._);
      }
      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    function secondWalk(v) {
      v._.x = v.z + v.parent.m;
      v.m += v.parent.m;
    }
    function apportion(v, w, ancestor) {
      if (w) {
        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
          vom = d3_layout_treeLeft(vom);
          vop = d3_layout_treeRight(vop);
          vop.a = v;
          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
          if (shift > 0) {
            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
            sip += shift;
            sop += shift;
          }
          sim += vim.m;
          sip += vip.m;
          som += vom.m;
          sop += vop.m;
        }
        if (vim && !d3_layout_treeRight(vop)) {
          vop.t = vim;
          vop.m += sim - sop;
        }
        if (vip && !d3_layout_treeLeft(vom)) {
          vom.t = vip;
          vom.m += sip - som;
          ancestor = v;
        }
      }
      return ancestor;
    }
    function sizeNode(node) {
      node.x *= size[0];
      node.y = node.depth * size[1];
    }
    tree.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return tree;
    };
    tree.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null ? sizeNode : null;
      return tree;
    };
    tree.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) == null ? null : sizeNode;
      return tree;
    };
    return d3_layout_hierarchyRebind(tree, hierarchy);
  };
  function d3_layout_treeSeparation(a, b) {
    return a.parent == b.parent ? 1 : 2;
  }
  function d3_layout_treeLeft(v) {
    var children = v.children;
    return children.length ? children[0] : v.t;
  }
  function d3_layout_treeRight(v) {
    var children = v.children, n;
    return (n = children.length) ? children[n - 1] : v.t;
  }
  function d3_layout_treeMove(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
  }
  function d3_layout_treeShift(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while (--i >= 0) {
      w = children[i];
      w.z += shift;
      w.m += shift;
      shift += w.s + (change += w.c);
    }
  }
  function d3_layout_treeAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
  }
  d3.layout.cluster = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
    function cluster(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var children = node.children;
        if (children && children.length) {
          node.x = d3_layout_clusterX(children);
          node.y = d3_layout_clusterY(children);
        } else {
          node.x = previousNode ? x += separation(node, previousNode) : 0;
          node.y = 0;
          previousNode = node;
        }
      });
      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
        node.x = (node.x - root.x) * size[0];
        node.y = (root.y - node.y) * size[1];
      } : function(node) {
        node.x = (node.x - x0) / (x1 - x0) * size[0];
        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
      });
      return nodes;
    }
    cluster.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return cluster;
    };
    cluster.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null;
      return cluster;
    };
    cluster.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) != null;
      return cluster;
    };
    return d3_layout_hierarchyRebind(cluster, hierarchy);
  };
  function d3_layout_clusterY(children) {
    return 1 + d3.max(children, function(child) {
      return child.y;
    });
  }
  function d3_layout_clusterX(children) {
    return children.reduce(function(x, child) {
      return x + child.x;
    }, 0) / children.length;
  }
  function d3_layout_clusterLeft(node) {
    var children = node.children;
    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
  }
  function d3_layout_clusterRight(node) {
    var children = node.children, n;
    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
  }
  d3.layout.treemap = function() {
    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
    function scale(children, k) {
      var i = -1, n = children.length, child, area;
      while (++i < n) {
        area = (child = children[i]).value * (k < 0 ? 0 : k);
        child.area = isNaN(area) || area <= 0 ? 0 : area;
      }
    }
    function squarify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while ((n = remaining.length) > 0) {
          row.push(child = remaining[n - 1]);
          row.area += child.area;
          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
            remaining.pop();
            best = score;
          } else {
            row.area -= row.pop().area;
            position(row, u, rect, false);
            u = Math.min(rect.dx, rect.dy);
            row.length = row.area = 0;
            best = Infinity;
          }
        }
        if (row.length) {
          position(row, u, rect, true);
          row.length = row.area = 0;
        }
        children.forEach(squarify);
      }
    }
    function stickify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), remaining = children.slice(), child, row = [];
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while (child = remaining.pop()) {
          row.push(child);
          row.area += child.area;
          if (child.z != null) {
            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
            row.length = row.area = 0;
          }
        }
        children.forEach(stickify);
      }
    }
    function worst(row, u) {
      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
      while (++i < n) {
        if (!(r = row[i].area)) continue;
        if (r < rmin) rmin = r;
        if (r > rmax) rmax = r;
      }
      s *= s;
      u *= u;
      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
    }
    function position(row, u, rect, flush) {
      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
      if (u == rect.dx) {
        if (flush || v > rect.dy) v = rect.dy;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dy = v;
          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
        }
        o.z = true;
        o.dx += rect.x + rect.dx - x;
        rect.y += v;
        rect.dy -= v;
      } else {
        if (flush || v > rect.dx) v = rect.dx;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dx = v;
          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
        }
        o.z = false;
        o.dy += rect.y + rect.dy - y;
        rect.x += v;
        rect.dx -= v;
      }
    }
    function treemap(d) {
      var nodes = stickies || hierarchy(d), root = nodes[0];
      root.x = root.y = 0;
      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
      if (stickies) hierarchy.revalue(root);
      scale([ root ], root.dx * root.dy / root.value);
      (stickies ? stickify : squarify)(root);
      if (sticky) stickies = nodes;
      return nodes;
    }
    treemap.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return treemap;
    };
    treemap.padding = function(x) {
      if (!arguments.length) return padding;
      function padFunction(node) {
        var p = x.call(treemap, node, node.depth);
        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
      }
      function padConstant(node) {
        return d3_layout_treemapPad(node, x);
      }
      var type;
      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
      padConstant) : padConstant;
      return treemap;
    };
    treemap.round = function(x) {
      if (!arguments.length) return round != Number;
      round = x ? Math.round : Number;
      return treemap;
    };
    treemap.sticky = function(x) {
      if (!arguments.length) return sticky;
      sticky = x;
      stickies = null;
      return treemap;
    };
    treemap.ratio = function(x) {
      if (!arguments.length) return ratio;
      ratio = x;
      return treemap;
    };
    treemap.mode = function(x) {
      if (!arguments.length) return mode;
      mode = x + "";
      return treemap;
    };
    return d3_layout_hierarchyRebind(treemap, hierarchy);
  };
  function d3_layout_treemapPadNull(node) {
    return {
      x: node.x,
      y: node.y,
      dx: node.dx,
      dy: node.dy
    };
  }
  function d3_layout_treemapPad(node, padding) {
    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
    if (dx < 0) {
      x += dx / 2;
      dx = 0;
    }
    if (dy < 0) {
      y += dy / 2;
      dy = 0;
    }
    return {
      x: x,
      y: y,
      dx: dx,
      dy: dy
    };
  }
  d3.random = {
    normal: function(µ, σ) {
      var n = arguments.length;
      if (n < 2) σ = 1;
      if (n < 1) µ = 0;
      return function() {
        var x, y, r;
        do {
          x = Math.random() * 2 - 1;
          y = Math.random() * 2 - 1;
          r = x * x + y * y;
        } while (!r || r > 1);
        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
      };
    },
    logNormal: function() {
      var random = d3.random.normal.apply(d3, arguments);
      return function() {
        return Math.exp(random());
      };
    },
    bates: function(m) {
      var random = d3.random.irwinHall(m);
      return function() {
        return random() / m;
      };
    },
    irwinHall: function(m) {
      return function() {
        for (var s = 0, j = 0; j < m; j++) s += Math.random();
        return s;
      };
    }
  };
  d3.scale = {};
  function d3_scaleExtent(domain) {
    var start = domain[0], stop = domain[domain.length - 1];
    return start < stop ? [ start, stop ] : [ stop, start ];
  }
  function d3_scaleRange(scale) {
    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
  }
  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
    return function(x) {
      return i(u(x));
    };
  }
  function d3_scale_nice(domain, nice) {
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
    if (x1 < x0) {
      dx = i0, i0 = i1, i1 = dx;
      dx = x0, x0 = x1, x1 = dx;
    }
    domain[i0] = nice.floor(x0);
    domain[i1] = nice.ceil(x1);
    return domain;
  }
  function d3_scale_niceStep(step) {
    return step ? {
      floor: function(x) {
        return Math.floor(x / step) * step;
      },
      ceil: function(x) {
        return Math.ceil(x / step) * step;
      }
    } : d3_scale_niceIdentity;
  }
  var d3_scale_niceIdentity = {
    floor: d3_identity,
    ceil: d3_identity
  };
  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
    if (domain[k] < domain[0]) {
      domain = domain.slice().reverse();
      range = range.slice().reverse();
    }
    while (++j <= k) {
      u.push(uninterpolate(domain[j - 1], domain[j]));
      i.push(interpolate(range[j - 1], range[j]));
    }
    return function(x) {
      var j = d3.bisect(domain, x, 1, k) - 1;
      return i[j](u[j](x));
    };
  }
  d3.scale.linear = function() {
    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
  };
  function d3_scale_linear(domain, range, interpolate, clamp) {
    var output, input;
    function rescale() {
      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
      output = linear(domain, range, uninterpolate, interpolate);
      input = linear(range, domain, uninterpolate, d3_interpolate);
      return scale;
    }
    function scale(x) {
      return output(x);
    }
    scale.invert = function(y) {
      return input(y);
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(Number);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.rangeRound = function(x) {
      return scale.range(x).interpolate(d3_interpolateRound);
    };
    scale.clamp = function(x) {
      if (!arguments.length) return clamp;
      clamp = x;
      return rescale();
    };
    scale.interpolate = function(x) {
      if (!arguments.length) return interpolate;
      interpolate = x;
      return rescale();
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      d3_scale_linearNice(domain, m);
      return rescale();
    };
    scale.copy = function() {
      return d3_scale_linear(domain, range, interpolate, clamp);
    };
    return rescale();
  }
  function d3_scale_linearRebind(scale, linear) {
    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
  }
  function d3_scale_linearNice(domain, m) {
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    return domain;
  }
  function d3_scale_linearTickRange(domain, m) {
    if (m == null) m = 10;
    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
    extent[0] = Math.ceil(extent[0] / step) * step;
    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
    extent[2] = step;
    return extent;
  }
  function d3_scale_linearTicks(domain, m) {
    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
  }
  function d3_scale_linearTickFormat(domain, m, format) {
    var range = d3_scale_linearTickRange(domain, m);
    if (format) {
      var match = d3_format_re.exec(format);
      match.shift();
      if (match[8] === "s") {
        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
        match[8] = "f";
        format = d3.format(match.join(""));
        return function(d) {
          return format(prefix.scale(d)) + prefix.symbol;
        };
      }
      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
      format = match.join("");
    } else {
      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
    }
    return d3.format(format);
  }
  var d3_scale_linearFormatSignificant = {
    s: 1,
    g: 1,
    p: 1,
    r: 1,
    e: 1
  };
  function d3_scale_linearPrecision(value) {
    return -Math.floor(Math.log(value) / Math.LN10 + .01);
  }
  function d3_scale_linearFormatPrecision(type, range) {
    var p = d3_scale_linearPrecision(range[2]);
    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
  }
  d3.scale.log = function() {
    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
  };
  function d3_scale_log(linear, base, positive, domain) {
    function log(x) {
      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
    }
    function pow(x) {
      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
    }
    function scale(x) {
      return linear(log(x));
    }
    scale.invert = function(x) {
      return pow(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      positive = x[0] >= 0;
      linear.domain((domain = x.map(Number)).map(log));
      return scale;
    };
    scale.base = function(_) {
      if (!arguments.length) return base;
      base = +_;
      linear.domain(domain.map(log));
      return scale;
    };
    scale.nice = function() {
      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
      linear.domain(niced);
      domain = niced.map(pow);
      return scale;
    };
    scale.ticks = function() {
      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
      if (isFinite(j - i)) {
        if (positive) {
          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
          ticks.push(pow(i));
        } else {
          ticks.push(pow(i));
          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
        }
        for (i = 0; ticks[i] < u; i++) {}
        for (j = ticks.length; ticks[j - 1] > v; j--) {}
        ticks = ticks.slice(i, j);
      }
      return ticks;
    };
    scale.tickFormat = function(n, format) {
      if (!arguments.length) return d3_scale_logFormat;
      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
      var k = Math.max(1, base * n / scale.ticks().length);
      return function(d) {
        var i = d / pow(Math.round(log(d)));
        if (i * base < base - .5) i *= base;
        return i <= k ? format(d) : "";
      };
    };
    scale.copy = function() {
      return d3_scale_log(linear.copy(), base, positive, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
    floor: function(x) {
      return -Math.ceil(-x);
    },
    ceil: function(x) {
      return -Math.floor(-x);
    }
  };
  d3.scale.pow = function() {
    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
  };
  function d3_scale_pow(linear, exponent, domain) {
    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
    function scale(x) {
      return linear(powp(x));
    }
    scale.invert = function(x) {
      return powb(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      linear.domain((domain = x.map(Number)).map(powp));
      return scale;
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      return scale.domain(d3_scale_linearNice(domain, m));
    };
    scale.exponent = function(x) {
      if (!arguments.length) return exponent;
      powp = d3_scale_powPow(exponent = x);
      powb = d3_scale_powPow(1 / exponent);
      linear.domain(domain.map(powp));
      return scale;
    };
    scale.copy = function() {
      return d3_scale_pow(linear.copy(), exponent, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_scale_powPow(e) {
    return function(x) {
      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
    };
  }
  d3.scale.sqrt = function() {
    return d3.scale.pow().exponent(.5);
  };
  d3.scale.ordinal = function() {
    return d3_scale_ordinal([], {
      t: "range",
      a: [ [] ]
    });
  };
  function d3_scale_ordinal(domain, ranger) {
    var index, range, rangeBand;
    function scale(x) {
      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
    }
    function steps(start, step) {
      return d3.range(domain.length).map(function(i) {
        return start + step * i;
      });
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = [];
      index = new d3_Map();
      var i = -1, n = x.length, xi;
      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
      return scale[ranger.t].apply(scale, ranger.a);
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      rangeBand = 0;
      ranger = {
        t: "range",
        a: arguments
      };
      return scale;
    };
    scale.rangePoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
      0) : (stop - start) / (domain.length - 1 + padding);
      range = steps(start + step * padding / 2, step);
      rangeBand = 0;
      ranger = {
        t: "rangePoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundPoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
      0) : (stop - start) / (domain.length - 1 + padding) | 0;
      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
      rangeBand = 0;
      ranger = {
        t: "rangeRoundPoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
      range = steps(start + step * outerPadding, step);
      if (reverse) range.reverse();
      rangeBand = step * (1 - padding);
      ranger = {
        t: "rangeBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
      if (reverse) range.reverse();
      rangeBand = Math.round(step * (1 - padding));
      ranger = {
        t: "rangeRoundBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeBand = function() {
      return rangeBand;
    };
    scale.rangeExtent = function() {
      return d3_scaleExtent(ranger.a[0]);
    };
    scale.copy = function() {
      return d3_scale_ordinal(domain, ranger);
    };
    return scale.domain(domain);
  }
  d3.scale.category10 = function() {
    return d3.scale.ordinal().range(d3_category10);
  };
  d3.scale.category20 = function() {
    return d3.scale.ordinal().range(d3_category20);
  };
  d3.scale.category20b = function() {
    return d3.scale.ordinal().range(d3_category20b);
  };
  d3.scale.category20c = function() {
    return d3.scale.ordinal().range(d3_category20c);
  };
  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
  d3.scale.quantile = function() {
    return d3_scale_quantile([], []);
  };
  function d3_scale_quantile(domain, range) {
    var thresholds;
    function rescale() {
      var k = 0, q = range.length;
      thresholds = [];
      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
      return scale;
    }
    function scale(x) {
      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.quantiles = function() {
      return thresholds;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
    };
    scale.copy = function() {
      return d3_scale_quantile(domain, range);
    };
    return rescale();
  }
  d3.scale.quantize = function() {
    return d3_scale_quantize(0, 1, [ 0, 1 ]);
  };
  function d3_scale_quantize(x0, x1, range) {
    var kx, i;
    function scale(x) {
      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
    }
    function rescale() {
      kx = range.length / (x1 - x0);
      i = range.length - 1;
      return scale;
    }
    scale.domain = function(x) {
      if (!arguments.length) return [ x0, x1 ];
      x0 = +x[0];
      x1 = +x[x.length - 1];
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      y = y < 0 ? NaN : y / kx + x0;
      return [ y, y + 1 / kx ];
    };
    scale.copy = function() {
      return d3_scale_quantize(x0, x1, range);
    };
    return rescale();
  }
  d3.scale.threshold = function() {
    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
  };
  function d3_scale_threshold(domain, range) {
    function scale(x) {
      if (x <= x) return range[d3.bisect(domain, x)];
    }
    scale.domain = function(_) {
      if (!arguments.length) return domain;
      domain = _;
      return scale;
    };
    scale.range = function(_) {
      if (!arguments.length) return range;
      range = _;
      return scale;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return [ domain[y - 1], domain[y] ];
    };
    scale.copy = function() {
      return d3_scale_threshold(domain, range);
    };
    return scale;
  }
  d3.scale.identity = function() {
    return d3_scale_identity([ 0, 1 ]);
  };
  function d3_scale_identity(domain) {
    function identity(x) {
      return +x;
    }
    identity.invert = identity;
    identity.domain = identity.range = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(identity);
      return identity;
    };
    identity.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    identity.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    identity.copy = function() {
      return d3_scale_identity(domain);
    };
    return identity;
  }
  d3.svg = {};
  function d3_zero() {
    return 0;
  }
  d3.svg.arc = function() {
    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
    function arc() {
      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
        if (!cw) p1 *= -1;
        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
      }
      if (r1) {
        x0 = r1 * Math.cos(a0 + p1);
        y0 = r1 * Math.sin(a0 + p1);
        x1 = r1 * Math.cos(a1 - p1);
        y1 = r1 * Math.sin(a1 - p1);
        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
          var h1 = (a0 + a1) / 2;
          x0 = r1 * Math.cos(h1);
          y0 = r1 * Math.sin(h1);
          x1 = y1 = null;
        }
      } else {
        x0 = y0 = 0;
      }
      if (r0) {
        x2 = r0 * Math.cos(a1 - p0);
        y2 = r0 * Math.sin(a1 - p0);
        x3 = r0 * Math.cos(a0 + p0);
        y3 = r0 * Math.sin(a0 + p0);
        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
          var h0 = (a0 + a1) / 2;
          x2 = r0 * Math.cos(h0);
          y2 = r0 * Math.sin(h0);
          x3 = y3 = null;
        }
      } else {
        x2 = y2 = 0;
      }
      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
        cr = r0 < r1 ^ cw ? 0 : 1;
        var rc1 = rc, rc0 = rc;
        if (da < π) {
          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
        }
        if (x1 != null) {
          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
          if (rc === rc1) {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
          } else {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
          }
        } else {
          path.push("M", x0, ",", y0);
        }
        if (x3 != null) {
          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
          if (rc === rc0) {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          } else {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          }
        } else {
          path.push("L", x2, ",", y2);
        }
      } else {
        path.push("M", x0, ",", y0);
        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
        path.push("L", x2, ",", y2);
        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
      }
      path.push("Z");
      return path.join("");
    }
    function circleSegment(r1, cw) {
      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
    }
    arc.innerRadius = function(v) {
      if (!arguments.length) return innerRadius;
      innerRadius = d3_functor(v);
      return arc;
    };
    arc.outerRadius = function(v) {
      if (!arguments.length) return outerRadius;
      outerRadius = d3_functor(v);
      return arc;
    };
    arc.cornerRadius = function(v) {
      if (!arguments.length) return cornerRadius;
      cornerRadius = d3_functor(v);
      return arc;
    };
    arc.padRadius = function(v) {
      if (!arguments.length) return padRadius;
      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
      return arc;
    };
    arc.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return arc;
    };
    arc.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return arc;
    };
    arc.padAngle = function(v) {
      if (!arguments.length) return padAngle;
      padAngle = d3_functor(v);
      return arc;
    };
    arc.centroid = function() {
      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
      return [ Math.cos(a) * r, Math.sin(a) * r ];
    };
    return arc;
  };
  var d3_svg_arcAuto = "auto";
  function d3_svg_arcInnerRadius(d) {
    return d.innerRadius;
  }
  function d3_svg_arcOuterRadius(d) {
    return d.outerRadius;
  }
  function d3_svg_arcStartAngle(d) {
    return d.startAngle;
  }
  function d3_svg_arcEndAngle(d) {
    return d.endAngle;
  }
  function d3_svg_arcPadAngle(d) {
    return d && d.padAngle;
  }
  function d3_svg_arcSweep(x0, y0, x1, y1) {
    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
  }
  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
  }
  function d3_svg_line(projection) {
    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
    function line(data) {
      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
      function segment() {
        segments.push("M", interpolate(projection(points), tension));
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
        } else if (points.length) {
          segment();
          points = [];
        }
      }
      if (points.length) segment();
      return segments.length ? segments.join("") : null;
    }
    line.x = function(_) {
      if (!arguments.length) return x;
      x = _;
      return line;
    };
    line.y = function(_) {
      if (!arguments.length) return y;
      y = _;
      return line;
    };
    line.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return line;
    };
    line.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      return line;
    };
    line.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return line;
    };
    return line;
  }
  d3.svg.line = function() {
    return d3_svg_line(d3_identity);
  };
  var d3_svg_lineInterpolators = d3.map({
    linear: d3_svg_lineLinear,
    "linear-closed": d3_svg_lineLinearClosed,
    step: d3_svg_lineStep,
    "step-before": d3_svg_lineStepBefore,
    "step-after": d3_svg_lineStepAfter,
    basis: d3_svg_lineBasis,
    "basis-open": d3_svg_lineBasisOpen,
    "basis-closed": d3_svg_lineBasisClosed,
    bundle: d3_svg_lineBundle,
    cardinal: d3_svg_lineCardinal,
    "cardinal-open": d3_svg_lineCardinalOpen,
    "cardinal-closed": d3_svg_lineCardinalClosed,
    monotone: d3_svg_lineMonotone
  });
  d3_svg_lineInterpolators.forEach(function(key, value) {
    value.key = key;
    value.closed = /-closed$/.test(key);
  });
  function d3_svg_lineLinear(points) {
    return points.length > 1 ? points.join("L") : points + "Z";
  }
  function d3_svg_lineLinearClosed(points) {
    return points.join("L") + "Z";
  }
  function d3_svg_lineStep(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
    if (n > 1) path.push("H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepBefore(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepAfter(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
    return path.join("");
  }
  function d3_svg_lineCardinalOpen(points, tension) {
    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineCardinalClosed(points, tension) {
    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
  }
  function d3_svg_lineCardinal(points, tension) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineHermite(points, tangents) {
    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
      return d3_svg_lineLinear(points);
    }
    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
    if (quad) {
      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
      p0 = points[1];
      pi = 2;
    }
    if (tangents.length > 1) {
      t = tangents[1];
      p = points[pi];
      pi++;
      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      for (var i = 2; i < tangents.length; i++, pi++) {
        p = points[pi];
        t = tangents[i];
        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      }
    }
    if (quad) {
      var lp = points[pi];
      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
    }
    return path;
  }
  function d3_svg_lineCardinalTangents(points, tension) {
    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
    while (++i < n) {
      p0 = p1;
      p1 = p2;
      p2 = points[i];
      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
    }
    return tangents;
  }
  function d3_svg_lineBasis(points) {
    if (points.length < 3) return d3_svg_lineLinear(points);
    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    points.push(points[n - 1]);
    while (++i <= n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    points.pop();
    path.push("L", pi);
    return path.join("");
  }
  function d3_svg_lineBasisOpen(points) {
    if (points.length < 4) return d3_svg_lineLinear(points);
    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
    while (++i < 3) {
      pi = points[i];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
    --i;
    while (++i < n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBasisClosed(points) {
    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
    while (++i < 4) {
      pi = points[i % n];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    --i;
    while (++i < m) {
      pi = points[i % n];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBundle(points, tension) {
    var n = points.length - 1;
    if (n) {
      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
      while (++i <= n) {
        p = points[i];
        t = i / n;
        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
      }
    }
    return d3_svg_lineBasis(points);
  }
  function d3_svg_lineDot4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
  }
  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
  function d3_svg_lineBasisBezier(path, x, y) {
    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
  }
  function d3_svg_lineSlope(p0, p1) {
    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
  }
  function d3_svg_lineFiniteDifferences(points) {
    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
    while (++i < j) {
      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
    }
    m[i] = d;
    return m;
  }
  function d3_svg_lineMonotoneTangents(points) {
    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
    while (++i < j) {
      d = d3_svg_lineSlope(points[i], points[i + 1]);
      if (abs(d) < ε) {
        m[i] = m[i + 1] = 0;
      } else {
        a = m[i] / d;
        b = m[i + 1] / d;
        s = a * a + b * b;
        if (s > 9) {
          s = d * 3 / Math.sqrt(s);
          m[i] = s * a;
          m[i + 1] = s * b;
        }
      }
    }
    i = -1;
    while (++i <= j) {
      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
      tangents.push([ s || 0, m[i] * s || 0 ]);
    }
    return tangents;
  }
  function d3_svg_lineMonotone(points) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
  }
  d3.svg.line.radial = function() {
    var line = d3_svg_line(d3_svg_lineRadial);
    line.radius = line.x, delete line.x;
    line.angle = line.y, delete line.y;
    return line;
  };
  function d3_svg_lineRadial(points) {
    var point, i = -1, n = points.length, r, a;
    while (++i < n) {
      point = points[i];
      r = point[0];
      a = point[1] - halfπ;
      point[0] = r * Math.cos(a);
      point[1] = r * Math.sin(a);
    }
    return points;
  }
  function d3_svg_area(projection) {
    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
    function area(data) {
      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
        return x;
      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
        return y;
      } : d3_functor(y1), x, y;
      function segment() {
        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
        } else if (points0.length) {
          segment();
          points0 = [];
          points1 = [];
        }
      }
      if (points0.length) segment();
      return segments.length ? segments.join("") : null;
    }
    area.x = function(_) {
      if (!arguments.length) return x1;
      x0 = x1 = _;
      return area;
    };
    area.x0 = function(_) {
      if (!arguments.length) return x0;
      x0 = _;
      return area;
    };
    area.x1 = function(_) {
      if (!arguments.length) return x1;
      x1 = _;
      return area;
    };
    area.y = function(_) {
      if (!arguments.length) return y1;
      y0 = y1 = _;
      return area;
    };
    area.y0 = function(_) {
      if (!arguments.length) return y0;
      y0 = _;
      return area;
    };
    area.y1 = function(_) {
      if (!arguments.length) return y1;
      y1 = _;
      return area;
    };
    area.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return area;
    };
    area.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      interpolateReverse = interpolate.reverse || interpolate;
      L = interpolate.closed ? "M" : "L";
      return area;
    };
    area.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return area;
    };
    return area;
  }
  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
  d3.svg.area = function() {
    return d3_svg_area(d3_identity);
  };
  d3.svg.area.radial = function() {
    var area = d3_svg_area(d3_svg_lineRadial);
    area.radius = area.x, delete area.x;
    area.innerRadius = area.x0, delete area.x0;
    area.outerRadius = area.x1, delete area.x1;
    area.angle = area.y, delete area.y;
    area.startAngle = area.y0, delete area.y0;
    area.endAngle = area.y1, delete area.y1;
    return area;
  };
  d3.svg.chord = function() {
    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
    function chord(d, i) {
      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
    }
    function subgroup(self, f, d, i) {
      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
      return {
        r: r,
        a0: a0,
        a1: a1,
        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
      };
    }
    function equals(a, b) {
      return a.a0 == b.a0 && a.a1 == b.a1;
    }
    function arc(r, p, a) {
      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
    }
    function curve(r0, p0, r1, p1) {
      return "Q 0,0 " + p1;
    }
    chord.radius = function(v) {
      if (!arguments.length) return radius;
      radius = d3_functor(v);
      return chord;
    };
    chord.source = function(v) {
      if (!arguments.length) return source;
      source = d3_functor(v);
      return chord;
    };
    chord.target = function(v) {
      if (!arguments.length) return target;
      target = d3_functor(v);
      return chord;
    };
    chord.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return chord;
    };
    chord.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return chord;
    };
    return chord;
  };
  function d3_svg_chordRadius(d) {
    return d.radius;
  }
  d3.svg.diagonal = function() {
    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
    function diagonal(d, i) {
      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
        x: p0.x,
        y: m
      }, {
        x: p3.x,
        y: m
      }, p3 ];
      p = p.map(projection);
      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
    }
    diagonal.source = function(x) {
      if (!arguments.length) return source;
      source = d3_functor(x);
      return diagonal;
    };
    diagonal.target = function(x) {
      if (!arguments.length) return target;
      target = d3_functor(x);
      return diagonal;
    };
    diagonal.projection = function(x) {
      if (!arguments.length) return projection;
      projection = x;
      return diagonal;
    };
    return diagonal;
  };
  function d3_svg_diagonalProjection(d) {
    return [ d.x, d.y ];
  }
  d3.svg.diagonal.radial = function() {
    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
    diagonal.projection = function(x) {
      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
    };
    return diagonal;
  };
  function d3_svg_diagonalRadialProjection(projection) {
    return function() {
      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
      return [ r * Math.cos(a), r * Math.sin(a) ];
    };
  }
  d3.svg.symbol = function() {
    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
    function symbol(d, i) {
      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
    }
    symbol.type = function(x) {
      if (!arguments.length) return type;
      type = d3_functor(x);
      return symbol;
    };
    symbol.size = function(x) {
      if (!arguments.length) return size;
      size = d3_functor(x);
      return symbol;
    };
    return symbol;
  };
  function d3_svg_symbolSize() {
    return 64;
  }
  function d3_svg_symbolType() {
    return "circle";
  }
  function d3_svg_symbolCircle(size) {
    var r = Math.sqrt(size / π);
    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
  }
  var d3_svg_symbols = d3.map({
    circle: d3_svg_symbolCircle,
    cross: function(size) {
      var r = Math.sqrt(size / 5) / 2;
      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
    },
    diamond: function(size) {
      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
    },
    square: function(size) {
      var r = Math.sqrt(size) / 2;
      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
    },
    "triangle-down": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
    },
    "triangle-up": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
    }
  });
  d3.svg.symbolTypes = d3_svg_symbols.keys();
  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
  d3_selectionPrototype.transition = function(name) {
    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
      time: Date.now(),
      ease: d3_ease_cubicInOut,
      delay: 0,
      duration: 250
    };
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_selectionPrototype.interrupt = function(name) {
    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
  };
  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
  function d3_selection_interruptNS(ns) {
    return function() {
      var lock, activeId, active;
      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
        active.timer.c = null;
        active.timer.t = NaN;
        if (--lock.count) delete lock[activeId]; else delete this[ns];
        lock.active += .5;
        active.event && active.event.interrupt.call(this, this.__data__, active.index);
      }
    };
  }
  function d3_transition(groups, ns, id) {
    d3_subclass(groups, d3_transitionPrototype);
    groups.namespace = ns;
    groups.id = id;
    return groups;
  }
  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
  d3_transitionPrototype.call = d3_selectionPrototype.call;
  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
  d3_transitionPrototype.node = d3_selectionPrototype.node;
  d3_transitionPrototype.size = d3_selectionPrototype.size;
  d3.transition = function(selection, name) {
    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
  };
  d3.transition.prototype = d3_transitionPrototype;
  d3_transitionPrototype.select = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
          if ("__data__" in node) subnode.__data__ = node.__data__;
          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
          subgroup.push(subnode);
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.selectAll = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          transition = node[ns][id];
          subnodes = selector.call(node, node.__data__, i, j);
          subgroups.push(subgroup = []);
          for (var k = -1, o = subnodes.length; ++k < o; ) {
            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
            subgroup.push(subnode);
          }
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_transition(subgroups, this.namespace, this.id);
  };
  d3_transitionPrototype.tween = function(name, tween) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
    return d3_selection_each(this, tween == null ? function(node) {
      node[ns][id].tween.remove(name);
    } : function(node) {
      node[ns][id].tween.set(name, tween);
    });
  };
  function d3_transition_tween(groups, name, value, tween) {
    var id = groups.id, ns = groups.namespace;
    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
    } : (value = tween(value), function(node) {
      node[ns][id].tween.set(name, value);
    }));
  }
  d3_transitionPrototype.attr = function(nameNS, value) {
    if (arguments.length < 2) {
      for (value in nameNS) this.attr(value, nameNS[value]);
      return this;
    }
    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrTween(b) {
      return b == null ? attrNull : (b += "", function() {
        var a = this.getAttribute(name), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttribute(name, i(t));
        });
      });
    }
    function attrTweenNS(b) {
      return b == null ? attrNullNS : (b += "", function() {
        var a = this.getAttributeNS(name.space, name.local), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttributeNS(name.space, name.local, i(t));
        });
      });
    }
    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.attrTween = function(nameNS, tween) {
    var name = d3.ns.qualify(nameNS);
    function attrTween(d, i) {
      var f = tween.call(this, d, i, this.getAttribute(name));
      return f && function(t) {
        this.setAttribute(name, f(t));
      };
    }
    function attrTweenNS(d, i) {
      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
      return f && function(t) {
        this.setAttributeNS(name.space, name.local, f(t));
      };
    }
    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.style(priority, name[priority], value);
        return this;
      }
      priority = "";
    }
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleString(b) {
      return b == null ? styleNull : (b += "", function() {
        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
        return a !== b && (i = d3_interpolate(a, b), function(t) {
          this.style.setProperty(name, i(t), priority);
        });
      });
    }
    return d3_transition_tween(this, "style." + name, value, styleString);
  };
  d3_transitionPrototype.styleTween = function(name, tween, priority) {
    if (arguments.length < 3) priority = "";
    function styleTween(d, i) {
      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
      return f && function(t) {
        this.style.setProperty(name, f(t), priority);
      };
    }
    return this.tween("style." + name, styleTween);
  };
  d3_transitionPrototype.text = function(value) {
    return d3_transition_tween(this, "text", value, d3_transition_text);
  };
  function d3_transition_text(b) {
    if (b == null) b = "";
    return function() {
      this.textContent = b;
    };
  }
  d3_transitionPrototype.remove = function() {
    var ns = this.namespace;
    return this.each("end.transition", function() {
      var p;
      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
    });
  };
  d3_transitionPrototype.ease = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].ease;
    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
    return d3_selection_each(this, function(node) {
      node[ns][id].ease = value;
    });
  };
  d3_transitionPrototype.delay = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].delay;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].delay = +value.call(node, node.__data__, i, j);
    } : (value = +value, function(node) {
      node[ns][id].delay = value;
    }));
  };
  d3_transitionPrototype.duration = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].duration;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
    } : (value = Math.max(1, value), function(node) {
      node[ns][id].duration = value;
    }));
  };
  d3_transitionPrototype.each = function(type, listener) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) {
      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
      try {
        d3_transitionInheritId = id;
        d3_selection_each(this, function(node, i, j) {
          d3_transitionInherit = node[ns][id];
          type.call(node, node.__data__, i, j);
        });
      } finally {
        d3_transitionInherit = inherit;
        d3_transitionInheritId = inheritId;
      }
    } else {
      d3_selection_each(this, function(node) {
        var transition = node[ns][id];
        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
      });
    }
    return this;
  };
  d3_transitionPrototype.transition = function() {
    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if (node = group[i]) {
          transition = node[ns][id0];
          d3_transitionNode(node, i, ns, id1, {
            time: transition.time,
            ease: transition.ease,
            delay: transition.delay + transition.duration,
            duration: transition.duration
          });
        }
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id1);
  };
  function d3_transitionNamespace(name) {
    return name == null ? "__transition__" : "__transition_" + name + "__";
  }
  function d3_transitionNode(node, i, ns, id, inherit) {
    var lock = node[ns] || (node[ns] = {
      active: 0,
      count: 0
    }), transition = lock[id], time, timer, duration, ease, tweens;
    function schedule(elapsed) {
      var delay = transition.delay;
      timer.t = delay + time;
      if (delay <= elapsed) return start(elapsed - delay);
      timer.c = start;
    }
    function start(elapsed) {
      var activeId = lock.active, active = lock[activeId];
      if (active) {
        active.timer.c = null;
        active.timer.t = NaN;
        --lock.count;
        delete lock[activeId];
        active.event && active.event.interrupt.call(node, node.__data__, active.index);
      }
      for (var cancelId in lock) {
        if (+cancelId < id) {
          var cancel = lock[cancelId];
          cancel.timer.c = null;
          cancel.timer.t = NaN;
          --lock.count;
          delete lock[cancelId];
        }
      }
      timer.c = tick;
      d3_timer(function() {
        if (timer.c && tick(elapsed || 1)) {
          timer.c = null;
          timer.t = NaN;
        }
        return 1;
      }, 0, time);
      lock.active = id;
      transition.event && transition.event.start.call(node, node.__data__, i);
      tweens = [];
      transition.tween.forEach(function(key, value) {
        if (value = value.call(node, node.__data__, i)) {
          tweens.push(value);
        }
      });
      ease = transition.ease;
      duration = transition.duration;
    }
    function tick(elapsed) {
      var t = elapsed / duration, e = ease(t), n = tweens.length;
      while (n > 0) {
        tweens[--n].call(node, e);
      }
      if (t >= 1) {
        transition.event && transition.event.end.call(node, node.__data__, i);
        if (--lock.count) delete lock[id]; else delete node[ns];
        return 1;
      }
    }
    if (!transition) {
      time = inherit.time;
      timer = d3_timer(schedule, 0, time);
      transition = lock[id] = {
        tween: new d3_Map(),
        time: time,
        timer: timer,
        delay: inherit.delay,
        duration: inherit.duration,
        ease: inherit.ease,
        index: i
      };
      inherit = null;
      ++lock.count;
    }
  }
  d3.svg.axis = function() {
    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
    function axis(g) {
      g.each(function() {
        var g = d3.select(this);
        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
        d3.transition(path));
        tickEnter.append("line");
        tickEnter.append("text");
        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
        if (orient === "bottom" || orient === "top") {
          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
        } else {
          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
        }
        lineEnter.attr(y2, sign * innerTickSize);
        textEnter.attr(y1, sign * tickSpacing);
        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
        if (scale1.rangeBand) {
          var x = scale1, dx = x.rangeBand() / 2;
          scale0 = scale1 = function(d) {
            return x(d) + dx;
          };
        } else if (scale0.rangeBand) {
          scale0 = scale1;
        } else {
          tickExit.call(tickTransform, scale1, scale0);
        }
        tickEnter.call(tickTransform, scale0, scale1);
        tickUpdate.call(tickTransform, scale1, scale1);
      });
    }
    axis.scale = function(x) {
      if (!arguments.length) return scale;
      scale = x;
      return axis;
    };
    axis.orient = function(x) {
      if (!arguments.length) return orient;
      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
      return axis;
    };
    axis.ticks = function() {
      if (!arguments.length) return tickArguments_;
      tickArguments_ = d3_array(arguments);
      return axis;
    };
    axis.tickValues = function(x) {
      if (!arguments.length) return tickValues;
      tickValues = x;
      return axis;
    };
    axis.tickFormat = function(x) {
      if (!arguments.length) return tickFormat_;
      tickFormat_ = x;
      return axis;
    };
    axis.tickSize = function(x) {
      var n = arguments.length;
      if (!n) return innerTickSize;
      innerTickSize = +x;
      outerTickSize = +arguments[n - 1];
      return axis;
    };
    axis.innerTickSize = function(x) {
      if (!arguments.length) return innerTickSize;
      innerTickSize = +x;
      return axis;
    };
    axis.outerTickSize = function(x) {
      if (!arguments.length) return outerTickSize;
      outerTickSize = +x;
      return axis;
    };
    axis.tickPadding = function(x) {
      if (!arguments.length) return tickPadding;
      tickPadding = +x;
      return axis;
    };
    axis.tickSubdivide = function() {
      return arguments.length && axis;
    };
    return axis;
  };
  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  };
  function d3_svg_axisX(selection, x0, x1) {
    selection.attr("transform", function(d) {
      var v0 = x0(d);
      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
    });
  }
  function d3_svg_axisY(selection, y0, y1) {
    selection.attr("transform", function(d) {
      var v0 = y0(d);
      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
    });
  }
  d3.svg.brush = function() {
    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
    function brush(g) {
      g.each(function() {
        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
        var background = g.selectAll(".background").data([ 0 ]);
        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
        var resize = g.selectAll(".resize").data(resizes, d3_identity);
        resize.exit().remove();
        resize.enter().append("g").attr("class", function(d) {
          return "resize " + d;
        }).style("cursor", function(d) {
          return d3_svg_brushCursor[d];
        }).append("rect").attr("x", function(d) {
          return /[ew]$/.test(d) ? -3 : null;
        }).attr("y", function(d) {
          return /^[ns]/.test(d) ? -3 : null;
        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
        resize.style("display", brush.empty() ? "none" : null);
        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
        if (x) {
          range = d3_scaleRange(x);
          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
          redrawX(gUpdate);
        }
        if (y) {
          range = d3_scaleRange(y);
          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
          redrawY(gUpdate);
        }
        redraw(gUpdate);
      });
    }
    brush.event = function(g) {
      g.each(function() {
        var event_ = event.of(this, arguments), extent1 = {
          x: xExtent,
          y: yExtent,
          i: xExtentDomain,
          j: yExtentDomain
        }, extent0 = this.__chart__ || extent1;
        this.__chart__ = extent1;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.brush", function() {
            xExtentDomain = extent0.i;
            yExtentDomain = extent0.j;
            xExtent = extent0.x;
            yExtent = extent0.y;
            event_({
              type: "brushstart"
            });
          }).tween("brush:brush", function() {
            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
            xExtentDomain = yExtentDomain = null;
            return function(t) {
              xExtent = extent1.x = xi(t);
              yExtent = extent1.y = yi(t);
              event_({
                type: "brush",
                mode: "resize"
              });
            };
          }).each("end.brush", function() {
            xExtentDomain = extent1.i;
            yExtentDomain = extent1.j;
            event_({
              type: "brush",
              mode: "resize"
            });
            event_({
              type: "brushend"
            });
          });
        } else {
          event_({
            type: "brushstart"
          });
          event_({
            type: "brush",
            mode: "resize"
          });
          event_({
            type: "brushend"
          });
        }
      });
    };
    function redraw(g) {
      g.selectAll(".resize").attr("transform", function(d) {
        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
      });
    }
    function redrawX(g) {
      g.select(".extent").attr("x", xExtent[0]);
      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
    }
    function redrawY(g) {
      g.select(".extent").attr("y", yExtent[0]);
      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
    }
    function brushstart() {
      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
      if (d3.event.changedTouches) {
        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
      } else {
        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
      }
      g.interrupt().selectAll("*").interrupt();
      if (dragging) {
        origin[0] = xExtent[0] - origin[0];
        origin[1] = yExtent[0] - origin[1];
      } else if (resizing) {
        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
        origin[0] = xExtent[ex];
        origin[1] = yExtent[ey];
      } else if (d3.event.altKey) center = origin.slice();
      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
      d3.select("body").style("cursor", eventTarget.style("cursor"));
      event_({
        type: "brushstart"
      });
      brushmove();
      function keydown() {
        if (d3.event.keyCode == 32) {
          if (!dragging) {
            center = null;
            origin[0] -= xExtent[1];
            origin[1] -= yExtent[1];
            dragging = 2;
          }
          d3_eventPreventDefault();
        }
      }
      function keyup() {
        if (d3.event.keyCode == 32 && dragging == 2) {
          origin[0] += xExtent[1];
          origin[1] += yExtent[1];
          dragging = 0;
          d3_eventPreventDefault();
        }
      }
      function brushmove() {
        var point = d3.mouse(target), moved = false;
        if (offset) {
          point[0] += offset[0];
          point[1] += offset[1];
        }
        if (!dragging) {
          if (d3.event.altKey) {
            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
            origin[0] = xExtent[+(point[0] < center[0])];
            origin[1] = yExtent[+(point[1] < center[1])];
          } else center = null;
        }
        if (resizingX && move1(point, x, 0)) {
          redrawX(g);
          moved = true;
        }
        if (resizingY && move1(point, y, 1)) {
          redrawY(g);
          moved = true;
        }
        if (moved) {
          redraw(g);
          event_({
            type: "brush",
            mode: dragging ? "move" : "resize"
          });
        }
      }
      function move1(point, scale, i) {
        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
        if (dragging) {
          r0 -= position;
          r1 -= size + position;
        }
        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
        if (dragging) {
          max = (min += position) + size;
        } else {
          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
          if (position < min) {
            max = min;
            min = position;
          } else {
            max = position;
          }
        }
        if (extent[0] != min || extent[1] != max) {
          if (i) yExtentDomain = null; else xExtentDomain = null;
          extent[0] = min;
          extent[1] = max;
          return true;
        }
      }
      function brushend() {
        brushmove();
        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
        d3.select("body").style("cursor", null);
        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
        dragRestore();
        event_({
          type: "brushend"
        });
      }
    }
    brush.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.clamp = function(z) {
      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
      return brush;
    };
    brush.extent = function(z) {
      var x0, x1, y0, y1, t;
      if (!arguments.length) {
        if (x) {
          if (xExtentDomain) {
            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
          } else {
            x0 = xExtent[0], x1 = xExtent[1];
            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
            if (x1 < x0) t = x0, x0 = x1, x1 = t;
          }
        }
        if (y) {
          if (yExtentDomain) {
            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
          } else {
            y0 = yExtent[0], y1 = yExtent[1];
            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
            if (y1 < y0) t = y0, y0 = y1, y1 = t;
          }
        }
        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
      }
      if (x) {
        x0 = z[0], x1 = z[1];
        if (y) x0 = x0[0], x1 = x1[0];
        xExtentDomain = [ x0, x1 ];
        if (x.invert) x0 = x(x0), x1 = x(x1);
        if (x1 < x0) t = x0, x0 = x1, x1 = t;
        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
      }
      if (y) {
        y0 = z[0], y1 = z[1];
        if (x) y0 = y0[1], y1 = y1[1];
        yExtentDomain = [ y0, y1 ];
        if (y.invert) y0 = y(y0), y1 = y(y1);
        if (y1 < y0) t = y0, y0 = y1, y1 = t;
        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
      }
      return brush;
    };
    brush.clear = function() {
      if (!brush.empty()) {
        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
        xExtentDomain = yExtentDomain = null;
      }
      return brush;
    };
    brush.empty = function() {
      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
    };
    return d3.rebind(brush, event, "on");
  };
  var d3_svg_brushCursor = {
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
  };
  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
  var d3_time_formatUtc = d3_time_format.utc;
  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
  function d3_time_formatIsoNative(date) {
    return date.toISOString();
  }
  d3_time_formatIsoNative.parse = function(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
  };
  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
  d3_time.second = d3_time_interval(function(date) {
    return new d3_date(Math.floor(date / 1e3) * 1e3);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
  }, function(date) {
    return date.getSeconds();
  });
  d3_time.seconds = d3_time.second.range;
  d3_time.seconds.utc = d3_time.second.utc.range;
  d3_time.minute = d3_time_interval(function(date) {
    return new d3_date(Math.floor(date / 6e4) * 6e4);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
  }, function(date) {
    return date.getMinutes();
  });
  d3_time.minutes = d3_time.minute.range;
  d3_time.minutes.utc = d3_time.minute.utc.range;
  d3_time.hour = d3_time_interval(function(date) {
    var timezone = date.getTimezoneOffset() / 60;
    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
  }, function(date) {
    return date.getHours();
  });
  d3_time.hours = d3_time.hour.range;
  d3_time.hours.utc = d3_time.hour.utc.range;
  d3_time.month = d3_time_interval(function(date) {
    date = d3_time.day(date);
    date.setDate(1);
    return date;
  }, function(date, offset) {
    date.setMonth(date.getMonth() + offset);
  }, function(date) {
    return date.getMonth();
  });
  d3_time.months = d3_time.month.range;
  d3_time.months.utc = d3_time.month.utc.range;
  function d3_time_scale(linear, methods, format) {
    function scale(x) {
      return linear(x);
    }
    scale.invert = function(x) {
      return d3_time_scaleDate(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
      linear.domain(x);
      return scale;
    };
    function tickMethod(extent, count) {
      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
        return d / 31536e6;
      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
    }
    scale.nice = function(interval, skip) {
      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
      if (method) interval = method[0], skip = method[1];
      function skipped(date) {
        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
      }
      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
        floor: function(date) {
          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
          return date;
        },
        ceil: function(date) {
          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
          return date;
        }
      } : interval));
    };
    scale.ticks = function(interval, skip) {
      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
        range: interval
      }, skip ];
      if (method) interval = method[0], skip = method[1];
      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
    };
    scale.tickFormat = function() {
      return format;
    };
    scale.copy = function() {
      return d3_time_scale(linear.copy(), methods, format);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_time_scaleDate(t) {
    return new Date(t);
  }
  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
    return d.getMilliseconds();
  } ], [ ":%S", function(d) {
    return d.getSeconds();
  } ], [ "%I:%M", function(d) {
    return d.getMinutes();
  } ], [ "%I %p", function(d) {
    return d.getHours();
  } ], [ "%a %d", function(d) {
    return d.getDay() && d.getDate() != 1;
  } ], [ "%b %d", function(d) {
    return d.getDate() != 1;
  } ], [ "%B", function(d) {
    return d.getMonth();
  } ], [ "%Y", d3_true ] ]);
  var d3_time_scaleMilliseconds = {
    range: function(start, stop, step) {
      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
    },
    floor: d3_identity,
    ceil: d3_identity
  };
  d3_time_scaleLocalMethods.year = d3_time.year;
  d3_time.scale = function() {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
  };
  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
    return [ m[0].utc, m[1] ];
  });
  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
    return d.getUTCMilliseconds();
  } ], [ ":%S", function(d) {
    return d.getUTCSeconds();
  } ], [ "%I:%M", function(d) {
    return d.getUTCMinutes();
  } ], [ "%I %p", function(d) {
    return d.getUTCHours();
  } ], [ "%a %d", function(d) {
    return d.getUTCDay() && d.getUTCDate() != 1;
  } ], [ "%b %d", function(d) {
    return d.getUTCDate() != 1;
  } ], [ "%B", function(d) {
    return d.getUTCMonth();
  } ], [ "%Y", d3_true ] ]);
  d3_time_scaleUtcMethods.year = d3_time.year.utc;
  d3_time.scale.utc = function() {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
  };
  d3.text = d3_xhrType(function(request) {
    return request.responseText;
  });
  d3.json = function(url, callback) {
    return d3_xhr(url, "application/json", d3_json, callback);
  };
  function d3_json(request) {
    return JSON.parse(request.responseText);
  }
  d3.html = function(url, callback) {
    return d3_xhr(url, "text/html", d3_html, callback);
  };
  function d3_html(request) {
    var range = d3_document.createRange();
    range.selectNode(d3_document.body);
    return range.createContextualFragment(request.responseText);
  }
  d3.xml = d3_xhrType(function(request) {
    return request.responseXML;
  });
  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
}();

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.9.0
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            this ||
            {};

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  // (`nodeType` is checked to ensure that `module`
  // and `exports` are not HTML elements.)
  if (typeof exports != 'undefined' && !exports.nodeType) {
    if (typeof module != 'undefined' && !module.nodeType && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.9.0';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  var builtinIteratee;

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
    return _.property(value);
  };

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only argCount argument.
  _.iteratee = builtinIteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  var restArguments = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var shallowProperty = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  var deepGet = function(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = shallowProperty('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (_.isFunction(path)) {
      func = path;
    } else if (_.isArray(path)) {
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return _.map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null || array.length < 1) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null || array.length < 1) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, Boolean);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        // Flatten current level of array or arguments object.
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArguments(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArguments(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArguments(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of _.pairs.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions.
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test.
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions.
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments.
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArguments(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArguments(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = _.delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArguments = restArguments;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object.
  // In contrast to _.map it returns an object.
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of _.object.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`.
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test.
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, path) {
    if (!_.isArray(path)) {
      return obj != null && hasOwnProperty.call(obj, path);
    }
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (obj == null || !hasOwnProperty.call(obj, key)) {
        return false;
      }
      obj = obj[key];
    }
    return !!length;
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indexes.
  _.property = function(path) {
    if (!_.isArray(path)) {
      return shallowProperty(path);
    }
    return function(obj) {
      return deepGet(obj, path);
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    if (obj == null) {
      return function(){};
    }
    return function(path) {
      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  _.result = function(obj, path, fallback) {
    if (!_.isArray(path)) path = [path];
    var length = path.length;
    if (!length) {
      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = _.isFunction(prop) ? prop.call(obj) : prop;
    }
    return obj;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(37)(module)))

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

/*!
 * Bootstrap v3.3.6 (http://getbootstrap.com)
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>2)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 3")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){return a(b.target).is(this)?b.handleObj.handler.apply(this,arguments):void 0}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.6",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a(f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.6",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target);d.hasClass("btn")||(d=d.closest(".btn")),b.call(d,"toggle"),a(c.target).is('input[type="radio"]')||a(c.target).is('input[type="checkbox"]')||c.preventDefault()}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.6",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));return a>this.$items.length-1||0>a?void 0:this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){return this.sliding?void 0:this.slide("next")},c.prototype.prev=function(){return this.sliding?void 0:this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.6",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.6",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.6",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;(e||!/destroy|hide/.test(b))&&(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.6",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),c.isInStateTrue()?void 0:(clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide())},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);return this.$element.trigger(g),g.isDefaultPrevented()?void 0:(f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this)},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=d?{top:0,left:0}:b.offset(),g={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},h=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,g,h,f)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;(e||!/destroy|hide/.test(b))&&(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.6",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.6",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");
d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.6",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.6",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return c>e?"top":!1;if("bottom"==this.affixed)return null!=c?e+this.unpin<=f.top?!1:"bottom":a-d>=e+g?!1:"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&c>=e?"top":null!=d&&i+j>=a-d?"bottom":!1},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.2bb6bc3b.js